// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/hkgrotesk-light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/hkgrotesk-light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/hkgrotesk-regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/hkgrotesk-regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/hkgrotesk-medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/hkgrotesk-medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/hkgrotesk-semibold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/hkgrotesk-semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/hkgrotesk-bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23adb5bd%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 version=%271.1%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 xmlns:svgjs=%27http://svgjs.com/svgjs%27 width=%271440%27 height=%27560%27 preserveAspectRatio=%27none%27 viewBox=%270 0 1440 560%27%3e%3cg mask=%27url%28%26quot%3b%23SvgjsMask1016%26quot%3b%29%27 fill=%27none%27%3e%3crect width=%271440%27 height=%27560%27 x=%270%27 y=%270%27 fill=%27rgba%2864%2c 81%2c 137%2c 1%29%27%3e%3c/rect%3e%3cpath d=%27M0%2c650.704C122.328%2c648.746%2c159.175%2c473.043%2c255.674%2c397.837C339.724%2c332.333%2c461.529%2c324.924%2c526.449%2c240.421C598.428%2c146.73%2c655.546%2c24.847%2c631.015%2c-90.726C606.666%2c-205.444%2c482.926%2c-263.497%2c401.565%2c-347.958C325.215%2c-427.217%2c275.543%2c-549.012%2c167.826%2c-571.563C60.344%2c-594.065%2c-27.703%2c-482.932%2c-135.163%2c-460.325C-256.336%2c-434.833%2c-401.929%2c-509.651%2c-497.972%2c-431.495C-592.807%2c-354.321%2c-579.865%2c-206.886%2c-595.603%2c-85.635C-611.133%2c34.016%2c-656.761%2c169.183%2c-588.884%2c268.934C-520.854%2c368.909%2c-362.458%2c340.324%2c-260.989%2c406.106C-158.875%2c472.306%2c-121.679%2c652.651%2c0%2c650.704%27 fill=%27%2333416e%27%3e%3c/path%3e%3cpath d=%27M1440 995.672C1519.728 984.741 1563.12 899.779 1626.466 850.1469999999999 1682.6390000000001 806.135 1756.261 782.602 1791.2939999999999 720.431 1827.571 656.052 1835.537 577.6610000000001 1820.814 505.247 1806.518 434.933 1753.2640000000001 383.16999999999996 1710.941 325.228 1664.475 261.614 1634.992 175.16000000000003 1560.657 149.07999999999998 1485.96 122.87299999999999 1402.146 155.543 1332.03 192.289 1269.541 225.038 1232.754 287.251 1189.969 343.347 1149.925 395.849 1115.781 448.9 1089.96 509.672 1056 589.599 988.9680000000001 671.1659999999999 1015.557 753.837 1041.91 835.774 1142.714 863.61 1217.498 906.22 1288.388 946.611 1359.167 1006.755 1440 995.672%27 fill=%27%234d61a4%27%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id=%27SvgjsMask1016%27%3e%3crect width=%271440%27 height=%27560%27 fill=%27white%27%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23ced4da%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23ced4da%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5bsGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5bsGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: hkgrotesk;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: local("hkgrotesk light"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: 300;
}

@font-face {
  font-family: hkgrotesk;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  src: local("hkgrotesk regular"),
    url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: 400;
}

@font-face {
  font-family: hkgrotesk;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  src: local("hkgrotesk medium"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
  font-weight: 500;
}

@font-face {
  font-family: hkgrotesk;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  src: local("hkgrotesk semibold"),
    url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
  font-weight: 600;
}

@font-face {
  font-family: hkgrotesk;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  src: local("hkgrotesk bold"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff");
  font-weight: 700;
}

:root {
  --bs-vertical-menu-bg: #fff;
  --bs-vertical-menu-item-color: #6d7080;
  --bs-vertical-menu-item-hover-color: #4b38b3;
  --bs-vertical-menu-item-active-color: #4b38b3;
  --bs-vertical-menu-sub-item-color: #7c7f90;
  --bs-vertical-menu-sub-item-hover-color: #4b38b3;
  --bs-vertical-menu-sub-item-active-color: #4b38b3;
  --bs-vertical-menu-title-color: #919da9;
  --bs-vertical-menu-bg-dark: #f3f3f9;
  --bs-vertical-menu-item-color-dark: #a3a6b7;
  --bs-vertical-menu-item-hover-color-dark: #fff;
  --bs-vertical-menu-item-active-color-dark: #fff;
  --bs-vertical-menu-sub-item-color-dark: #a3a6b7;
  --bs-vertical-menu-sub-item-hover-color-dark: #fff;
  --bs-vertical-menu-sub-item-active-color-dark: #fff;
  --bs-vertical-menu-title-color-dark: #6d7080;
  --bs-header-bg: #fff;
  --bs-header-item-color: #e9ecef;
  --bs-header-bg-dark: #1c1c36;
  --bs-header-item-color-dark: var(--bs-vertical-menu-item-color-dark);
  --bs-topbar-search-bg: #f3f3f9;
  --bs-topbar-user-bg: #f3f3f9;
  --bs-topbar-user-bg-dark: #2a2a50;
  --bs-footer-bg: #fff;
  --bs-footer-color: #98a6ad;
  --bs-topnav-bg: #fff;
  --bs-topnav-item-color: #6d7080;
  --bs-topnav-item-color-active: #4b38b3;
  --bs-twocolumn-menu-iconview-bg: #fff;
  --bs-twocolumn-menu-bg: #fff;
  --bs-twocolumn-menu-iconview-bg-dark: var(--bs-vertical-menu-bg-dark);
  --bs-twocolumn-menu-bg-dark: #1c1c36;
  --bs-twocolumn-menu-item-color-dark: var(--bs-vertical-menu-item-color-dark);
  --bs-twocolumn-menu-item-active-color-dark: #fff;
  --bs-twocolumn-menu-item-active-bg-dark: rgba(255, 255, 255, 0.15);
  --bs-boxed-body-bg: #e5e5ef;
  --bs-heading-color: #495057;
  --bs-box-shadow: 0 3px 3px rgba(56, 65, 74, 0.1);
  --bs-link-color: #4b38b3;
  --bs-link-hover-color: #4b38b3;
  --bs-border-color: #e9ebec;
  --bs-card-bg-custom: #fff;
  --bs-card-logo-dark: block;
  --bs-card-logo-light: none;
  --bs-list-group-hover-bg: #f3f6f9;
  --bs-input-bg: #fff;
  --bs-input-border: #ced4da;
  --bs-input-focus-border: #a59cd9;
  --bs-input-disabled-bg: #eff2f7;
  --bs-input-group-addon-bg: #eff2f7;
  --bs-input-check-border: var(--bs-input-border);
  --bs-body-font-size: 0.8125rem !important;
  --bs-dropdown-font-size: 0.8125rem !important;
}

.h2,
h2 {
  font-size: calc(1.2875rem + 0.45vw) !important;
}

.btn-group-sm > .btn,
.btn-sm {
  --bs-btn-font-size: 0.7109375rem;
  --bs-btn-border-radius: 0.2rem;
}

.h6,
h6 {
  font-size: 0.8125rem;
}

.h5,
h5 {
  font-size: 1.015625rem;
}

.h4,
h4 {
  font-size: 1.21875rem;
}

.dropdown-menu {
  font-size: var(--bs-body-font-size);
}

.form-select,
.input-group-text,
.form-control {
  font-size: 0.8125rem !important;
}

:root .nav-tabs {
  --bs-nav-tabs-link-active-bg: #f2f2f7;
}

:root .choices,
:root .ck,
:root .flatpickr-calendar,
:root .menu-dropdown,
:root .ql-toolbar,
:root .select2-container {
  --bs-choices-bg: #fff;
  --bs-choices-link-color: #212529;
  --bs-choices-link-hover-bg: #f3f6f9;
  --bs-choices-link-active-color: #1e2125;
}

[data-layout-mode="dark"] {
  --bs-gray-100: #1a1d21;
  --bs-gray-200: #212529;
  --bs-gray-300: #2a2f34;
  --bs-gray-400: #878a99;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #bfc8e2;
  --bs-gray-700: #ced4da;
  --bs-gray-800: #eff2f7;
  --bs-gray-900: #f3f6f9;
  --bs-body-bg: #1a1d21;
  --bs-body-bg-rgb: 26, 29, 33;
  --bs-body-color: #ced4da;
  --bs-body-color-rgb: 206, 212, 218;
  --bs-vertical-menu-bg: #fff;
  --bs-vertical-menu-item-color: #5f6270;
  --bs-vertical-menu-item-hover-color: #4b38b3;
  --bs-vertical-menu-item-active-color: #4b38b3;
  --bs-vertical-menu-sub-item-color: #686b7b;
  --bs-vertical-menu-sub-item-hover-color: #4b38b3;
  --bs-vertical-menu-sub-item-active-color: #4b38b3;
  --bs-vertical-menu-title-color: #878a99;
  --bs-vertical-menu-bg-dark: #212529;
  --bs-vertical-menu-item-color-dark: #878a99;
  --bs-vertical-menu-item-hover-color-dark: #fff;
  --bs-vertical-menu-item-active-color-dark: #fff;
  --bs-vertical-menu-sub-item-color-dark: #7c7f90;
  --bs-vertical-menu-sub-item-hover-color-dark: #fff;
  --bs-vertical-menu-sub-item-active-color-dark: #fff;
  --bs-vertical-menu-title-color-dark: #5f6270;
  --bs-header-bg: #262a2f;
  --bs-header-item-color: #e9ecef;
  --bs-header-bg-dark: var(--bs-header-bg);
  --bs-header-item-color-dark: var(--bs-header-item-color);
  --bs-topbar-search-bg: #1a1d21;
  --bs-topbar-user-bg: #2f343a;
  --bs-topbar-user-bg-dark: #2f343a;
  --bs-footer-bg: #23282c;
  --bs-footer-color: #878a99;
  --bs-topnav-bg: #272b30;
  --bs-topnav-item-color: #878a99;
  --bs-topnav-item-color-active: #fff;
  --bs-twocolumn-menu-iconview-bg: #fff;
  --bs-twocolumn-menu-bg: #fff;
  --bs-twocolumn-menu-iconview-bg-dark: #1b1f22;
  --bs-twocolumn-menu-bg-dark: var(--bs-vertical-menu-bg-dark);
  --bs-twocolumn-menu-item-color-dark: var(--bs-vertical-menu-item-color-dark);
  --bs-twocolumn-menu-item-active-color-dark: #fff;
  --bs-twocolumn-menu-item-active-bg-dark: rgba(255, 255, 255, 0.15);
  --bs-boxed-body-bg: #111316;
  --bs-heading-color: #ced4da;
  --bs-box-shadow: 0 3px 5px rgba(29, 35, 40, 0.15);
  --bs-light: #2a2f34;
  --bs-light-rgb: 42, 47, 52;
  --bs-dark: #eff2f7;
  --bs-dark-rgb: 239, 242, 247;
  --bs-link-color: #ced4da;
  --bs-link-hover-color: #ced4da;
  --bs-border-color: #32383e;
  --bs-card-bg-custom: #212529;
  --bs-card-logo-dark: none;
  --bs-card-logo-light: block;
  --bs-list-group-hover-bg: #272b30;
  --bs-input-bg: #262a2f;
  --bs-input-border: #2a2f34;
  --bs-input-focus-border: #33393f;
  --bs-input-disabled-bg: #212529;
  --bs-input-group-addon-bg: #2a2f34;
  --bs-input-check-border: #33393f;
  --bs-body-bg: #1a1d21;
  --bs-card-list-hover: blue;
}

[data-layout-mode="dark"] .list-group {
  --bs-list-group-color: #ced4da;
  --bs-list-group-bg: #212529;
  --bs-list-group-border-color: var(--bs-border-color);
}

[data-layout-mode="dark"] .form-check-input {
  background-color: var(--bs-input-bg);
  border: 1px solid var(--bs-input-check-border);
}

[data-layout-mode="dark"] .dropdown-menu {
  --bs-dropdown-bg: #272b30;
  --bs-dropdown-link-color: #eff2f7;
  --bs-dropdown-link-hover-color: #d7dade;
  --bs-dropdown-link-hover-bg: #2f343a;
  --bs-dropdown-border-width: 1px;
  --bs-dropdown-link-active-bg: #2f343a;
  --bs-dropdown-link-active-color: #adb5bd;
}

[data-layout-mode="dark"] .choices,
[data-layout-mode="dark"] .ck,
[data-layout-mode="dark"] .flatpickr-calendar,
[data-layout-mode="dark"] .menu-dropdown,
[data-layout-mode="dark"] .ql-toolbar,
[data-layout-mode="dark"] .select2-container {
  --bs-choices-bg: #292e33;
  --bs-choices-link-color: #adb5bd;
  --bs-choices-link-hover-bg: #2f343a;
  --bs-choices-link-active-color: #dbdde0;
}

[data-layout-mode="dark"] .btn-light {
  --bs-btn-color: var(--bs-dark);
  --bs-btn-bg: var(--bs-light);
  --bs-btn-border-color: var(--bs-light);
}

[data-layout-mode="dark"] .btn-outline-light {
  --bs-btn-color: var(--bs-dark);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: var(--bs-light);
}

[data-layout-mode="dark"] .btn-light,
[data-layout-mode="dark"] .btn-outline-light {
  --bs-btn-hover-color: var(--bs-dark);
  --bs-btn-hover-bg: rgba(var(--bs-light-rgb), 0.75);
  --bs-btn-hover-border-color: rgba(var(--bs-light-rgb), 0.75);
}

[data-layout-mode="dark"] .btn-dark {
  --bs-btn-color: var(--bs-light);
  --bs-btn-bg: var(--bs-dark);
  --bs-btn-border-color: var(--bs-dark);
}

[data-layout-mode="dark"] .btn-outline-dark {
  --bs-btn-color: var(--bs-dark);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: var(--bs-dark);
}

[data-layout-mode="dark"] .btn-dark,
[data-layout-mode="dark"] .btn-outline-dark {
  --bs-btn-hover-color: var(--bs-light);
  --bs-btn-hover-bg: rgba(var(--bs-dark-rgb), 0.75);
  --bs-btn-hover-border-color: rgba(var(--bs-dark-rgb), 0.75);
}

[data-layout-mode="dark"] .card {
  --bs-card-bg: #212529;
  --bs-card-cap-bg: #212529;
  color: var(--bs-heading-color);
}

[data-layout-mode="dark"] .modal {
  --bs-modal-bg: #212529;
}

[data-layout-mode="dark"] .nav-tabs {
  --bs-nav-tabs-link-active-color: #f3f6f9;
  --bs-nav-tabs-link-active-bg: #2a2f34;
}

[data-layout-mode="dark"] .accordion {
  --bs-accordion-button-active-color: #fff;
  --bs-accordion-bg: #212529;
  --bs-accordion-btn-bg: #212529;
}

[data-layout-mode="dark"] .offcanvas,
[data-layout-mode="dark"] .offcanvas-lg,
[data-layout-mode="dark"] .offcanvas-md,
[data-layout-mode="dark"] .offcanvas-sm,
[data-layout-mode="dark"] .offcanvas-xl,
[data-layout-mode="dark"] .offcanvas-xxl {
  --bs-offcanvas-bg: #212529;
}

[data-layout-mode="dark"] .progress {
  --bs-progress-bg: #2a2f34;
}

.table {
  font-family: "Inter", sans-serif !important;
  font-size: 12px !important;
  line-height: 1.5 !important;
}

[data-layout-mode="dark"] .table {
  --bs-table-striped-bg: rgba(255, 255, 255, 0.03);
  --bs-table-active-bg: rgba(255, 255, 255, 0.07);
  --bs-table-hover-bg: rgba(255, 255, 255, 0.07);
  --bs-table-color: #ced4da;
}

[data-layout-mode="dark"] .table-light {
  --bs-table-color: #fff;
  --bs-table-bg: rgba(255, 255, 255, 0.05);
  --bs-table-border-color: var(--bs-border-color);
  --bs-table-striped-bg: rgba(255, 255, 255, 0.07);
  --bs-table-striped-color: #fff;
}

[data-layout-mode="dark"] .toast {
  --bs-toast-bg: rgba(42, 47, 52, 0.85);
  --bs-toast-header-bg: rgba(42, 47, 52, 0.85);
  --bs-toast-border-color: rgba(255, 255, 255, 0.1);
  --bs-toast-header-border-color: rgba(255, 255, 255, 0.05);
}

[data-layout-mode="dark"] .popover {
  --bs-popover-bg: #23282c;
}

[data-layout-mode="dark"] .pagination {
  --bs-pagination-hover-bg: #2a2f34;
  --bs-pagination-focus-bg: #2a2f34;
  --bs-pagination-color: var(--bs-link-color);
  --bs-pagination-bg: var(--bs-card-bg-custom);
}

[data-layout-mode="dark"] .page-link {
  border: none;
}

[data-layout-mode="dark"] .css-1g0ym13-control {
  background-color: transparent;
}

[data-layout-mode="dark"]
  .flatpickr-calendar.inline
  .flatpickr-rContainer
  .flatpickr-days
  .dayContainer {
  background-color: #292e33;
}

/* [data-layout-mode=dark] .list-group-item-action:focus, .list-group-item-action:hover {
    background-color: var(--bs-card-list-hover);
}
[data-layout-mode=light] .list-group-item-action:focus, .list-group-item-action:hover {
    background-color: #eef2f5;
} */

[data-sidebar="gradient"] {
  --bs-vertical-menu-bg-gradient: linear-gradient(
    to right,
    var(--bs-primary),
    var(--bs-success)
  );
  --bs-vertical-menu-border-gradient: var(--bs-success);
  --bs-twocolumn-menu-bg-dark: var(--bs-success);
}

[data-sidebar="gradient-2"] {
  --bs-vertical-menu-bg-gradient: linear-gradient(
    to right,
    var(--bs-info),
    var(--bs-secondary)
  );
  --bs-vertical-menu-border-gradient: var(--bs-secondary);
  --bs-twocolumn-menu-bg-dark: var(--bs-secondary);
}

[data-sidebar="gradient-3"] {
  --bs-vertical-menu-bg-gradient: linear-gradient(
    to right,
    var(--bs-info),
    var(--bs-success)
  );
  --bs-vertical-menu-border-gradient: var(--bs-success);
  --bs-twocolumn-menu-bg-dark: var(--bs-success);
}

[data-sidebar="gradient-4"] {
  --bs-vertical-menu-bg-gradient: linear-gradient(
    to right,
    #212529,
    var(--bs-primary)
  );
  --bs-vertical-menu-border-gradient: var(--bs-primary);
  --bs-twocolumn-menu-bg-dark: var(--bs-primary);
}

#page-topbar {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1002;
  background-color: var(--bs-header-bg);
  transition: all 0.1s ease-out;
}

#page-topbar.topbar-shadow {
  box-shadow: var(--bs-box-shadow);
}

@media (min-width: 768px) {
  #page-topbar {
    left: 250px;
  }
}

@media (max-width: 767px) {
  .navbar-menu {
    margin-top: 70px !important;
  }
}

.navbar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  height: 70px;
  padding: 0 1.5rem 0 calc(1.5rem / 2);
}

@media (max-width: 767.98px) {
  .navbar-header {
    padding: 0 calc(1.5rem / 2) 0 calc(1.5rem / 2);
  }
}

.navbar-header .topbar-head-dropdown .dropdown-menu.show {
  top: 13px !important;
}

.navbar-header .btn-topbar {
  height: 42px;
  width: 42px;
}

@media (max-width: 360px) {
  .navbar-header .btn-topbar {
    height: 36px;
    width: 36px;
  }
}

.navbar-header .user-name-text {
  color: var(--bs-gray-700);
}

.app-search {
  padding: calc(32px / 2) 0;
}

.app-search .form-control {
  border: none;
  height: 38px;
  padding-left: 40px;
  padding-right: 30px;
  background-color: var(--bs-topbar-search-bg);
  box-shadow: none;
}

.app-search .form-control::placeholder {
  color: #878a99;
  font-size: 15px;
  font-weight: 400;
}

.app-search span.search-widget-icon {
  position: absolute;
  z-index: 10;
  font-size: 18px;
  line-height: 38px;
  left: 13px;
  top: 0;
  color: #878a99;
}

.app-search .search-widget-icon-close {
  right: 7px;
  left: auto !important;
}

@media (max-width: 1023.99px) {
  .app-search {
    padding-left: calc(1.5rem / 2);
  }
}

.megamenu-list li {
  position: relative;
  padding: 5px 0;
}

.megamenu-list li a {
  color: var(--bs-body-color);
}

@media (max-width: 767.98px) {
  .logo span.logo-lg {
    display: none;
  }

  .logo span.logo-sm {
    display: inline-block;
  }
}

.header-item {
  height: 70px;
  display: flex;
  align-items: center;
}

.header-profile-user {
  height: 32px;
  width: 32px;
}

.topbar-badge-sm {
  right: 0;
  top: 7px !important;
}

.topbar-badge {
  right: -9px;
  top: 4px !important;
}

.topbar-user .dropdown-menu {
  top: 6px !important;
}

.notification-item {
  padding: 0.75rem 1rem;
  white-space: inherit;
  position: relative;
}

.notification-item .form-check-input {
  position: relative;
  z-index: 2;
}

.dropdown-icon-item {
  display: block;
  border-radius: 3px;
  line-height: 34px;
  text-align: center;
  padding: 15px 0 9px;
  border: 1px solid transparent;
  color: var(--bs-dropdown-link-color);
}

.dropdown-icon-item img {
  height: 24px;
}

.dropdown-icon-item span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dropdown-icon-item:hover {
  background-color: var(--bs-dropdown-link-hover-bg);
}

.fullscreen-enable [data-toggle="fullscreen"] .bx-fullscreen::before {
  content: "\\eacb";
}

[data-layout-mode="dark"] .light-dark-mode .bx-moon::before {
  content: "\\ec34";
}

[data-topbar="dark"] #page-topbar {
  background-color: var(--bs-header-bg-dark);
  border-color: var(--bs-header-bg-dark);
}

[data-topbar="dark"] .navbar-header .btn-topbar {
  color: var(--bs-header-item-color-dark);
}

[data-topbar="dark"] .navbar-header .btn-topbar:focus,
[data-topbar="dark"] .navbar-header .btn-topbar:hover {
  background-color: rgba(255, 255, 255, 0.07);
  color: #fff;
}

[data-topbar="dark"] .logo-dark {
  display: none;
}

[data-topbar="dark"] .logo-light {
  display: inline-block;
}

[data-topbar="dark"] .app-search .form-control {
  background-color: rgba(255, 255, 255, 0.05);
  color: #fff;
}

[data-topbar="dark"] .app-search input.form-control::-webkit-input-placeholder,
[data-topbar="dark"] .app-search span.search-widget-icon {
  color: rgba(255, 255, 255, 0.5);
}

[data-topbar="dark"] .hamburger-icon span {
  background-color: #e9ebec;
}

@media (max-width: 600px) {
  .navbar-header .dropdown {
    position: static;
  }

  .navbar-header .dropdown .dropdown-menu {
    width: 100%;
  }
}

@media (max-width: 767.98px) {
  #search-dropdown-reponsive {
    top: 54px !important;
  }
}

@media (min-width: 1024.1px) {
  [data-layout="vertical"][data-layout-style="detached"] #page-topbar {
    left: 0 !important;
    box-shadow: var(--bs-box-shadow);
  }

  [data-layout="vertical"][data-layout-style="detached"] .horizontal-logo {
    display: inline-block;
    padding-left: 0;
  }

  [data-layout="vertical"][data-layout-style="detached"] .topnav-hamburger {
    visibility: hidden;
  }

  [data-layout="vertical"][data-layout-style="detached"] .layout-width {
    max-width: 95%;
    margin: 0 auto;
  }

  [data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm-hover"]
    .navbar-brand-box,
  [data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm"]
    .navbar-brand-box {
    background-color: transparent !important;
    position: relative;
    width: auto;
    text-align: left;
  }

  [data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm-hover"]
    .navbar-brand-box
    .logo-sm,
  [data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm"]
    .navbar-brand-box
    .logo-sm {
    display: none;
  }

  [data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm-hover"]
    .navbar-brand-box
    .logo-lg,
  [data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm"]
    .navbar-brand-box
    .logo-lg {
    display: block;
  }
}

[data-layout="vertical"][data-layout-style="detached"][data-topbar="dark"]
  .horizontal-logo
  .logo-dark {
  display: none;
}

[data-layout="vertical"][data-layout-style="detached"][data-topbar="dark"]
  .horizontal-logo
  .logo-light {
  display: block;
}

[data-layout="horizontal"] #page-topbar {
  left: 0;
  border-bottom: 1px solid var(--bs-gray-300);
}

@media (min-width: 1024.1px) {
  [data-layout="horizontal"] #page-topbar.topbar-shadow {
    box-shadow: none;
  }
}

[data-layout="horizontal"] .page-content {
  padding: calc(45px + 1.5rem) calc(1.5rem / 2) 60px calc(1.5rem / 2);
}

@media (min-width: 1024.1px) {
  [data-layout="horizontal"] .page-content {
    margin-top: 70px;
  }
}

@media (min-width: 1024.1px) {
  [data-layout="horizontal"][data-layout-width="boxed"] .page-content {
    min-height: calc(100vh - 130px);
  }
}

@media (min-width: 768px) {
  [data-layout="vertical"][data-sidebar-size="sm-hover"] #page-topbar,
  [data-layout="vertical"][data-sidebar-size="sm"] #page-topbar {
    left: 70px;
  }
}

@media (min-width: 768px) {
  [data-layout="vertical"][data-sidebar-size="md"] #page-topbar {
    left: 180px;
  }
}

@media (min-width: 768px) {
  [data-layout="twocolumn"] #page-topbar {
    left: calc(70px + 220px);
  }
}

[data-layout="twocolumn"] .horizontal-logo {
  display: none;
}

.page-title-box {
  padding: 10px 1.5rem;
  background-color: var(--bs-card-bg-custom);
  box-shadow: var(--bs-box-shadow);
  border-bottom: 1px solid none;
  border-top: 1px solid none;
  margin: -23px -1.5rem 1.5rem -1.5rem;
}

.page-title-box .breadcrumb {
  background-color: transparent;
  padding: 0;
}

.page-title-box h4 {
  font-weight: 700;
  font-size: 15px !important;
  text-transform: uppercase;
}

[data-layout="horizontal"] .page-title-box {
  padding: 1.2rem 0;
  background-color: transparent !important;
  border-bottom: none;
  border-top: none;
  box-shadow: none;
  margin: 0;
}

@media (min-width: 1024.1px) {
  [data-layout="horizontal"] .page-title-box {
    margin: -19px 0 0 0;
  }
}

[data-layout="vertical"][data-layout-style="detached"] .page-title-box {
  padding: 1.2rem 0;
  background-color: transparent !important;
  border-bottom: none;
  border-top: none;
  box-shadow: none;
  margin: 0;
}

@media (min-width: 1024.1px) {
  [data-layout="vertical"][data-layout-style="detached"] .page-title-box {
    margin: -19px 0 0 0;
  }
}

.footer {
  /* bottom: 0; */
  padding: 20px calc(1.5rem * 0.5);
  /* position: absolute; */
  /* right: 0; */
  color: var(--bs-footer-color);
  /* left: 250px; */
  height: 60px;
  background-color: var(--bs-footer-bg);
}

@media (max-width: 991.98px) {
  .footer {
    left: 0;
  }
}

[data-layout="vertical"][data-sidebar-size="sm-hover"] .footer,
[data-layout="vertical"][data-sidebar-size="sm"] .footer {
  left: 70px;
}

@media (max-width: 767.98px) {
  [data-layout="vertical"][data-sidebar-size="sm-hover"] .footer,
  [data-layout="vertical"][data-sidebar-size="sm"] .footer {
    left: 0;
  }
}

[data-layout="vertical"][data-sidebar-size="md"] .footer {
  left: 180px;
}

@media (max-width: 991.98px) {
  [data-layout="vertical"][data-sidebar-size="md"] .footer {
    left: 0;
  }
}

[data-layout="horizontal"] .footer {
  left: 0 !important;
}

@media (min-width: 1024.1px) {
  [data-layout="vertical"][data-layout-style="detached"] .footer {
    left: 0 !important;
    background-color: transparent;
  }
}

@media (min-width: 768.1px) {
  [data-layout="twocolumn"] .footer {
    left: calc(70px + 220px);
  }
}

.app-content {
  margin-left: 250px;
  overflow: hidden;
}

.app-content .content {
  padding: 0 15px 10px 15px;
  margin-top: 70px;
}

.main-content {
  transition: all 0.1s ease-out;
  /* background-color: #f3f3f9 !important; */
}

@media (min-width: 768px) {
  .main-content {
    margin-left: 250px;
  }
}

.page-content {
  padding: calc(70px + 1.5rem) calc(1.5rem * 0.5) 60px calc(1.5rem * 0.5);
}

.navbar-menu {
  width: 250px;
  z-index: 1002;
  /* background: var(--bs-vertical-menu-bg); */
  /* border-right: 1px solid #fff; */
  bottom: 0;
  margin-top: 0;
  position: fixed;
  top: 0;
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  padding: 0 0 calc(70px + 25px) 0;
  transition: all 0.1s ease-out;
}

.navbar-menu .navbar-nav .nav-link {
  display: flex;
  align-items: center;
  padding: 6px 1.5rem;
  color: var(--bs-vertical-menu-item-color);
  font-size: 0.925rem;
  font-family: Inter, sans-serif;
}

.navbar-menu .navbar-nav .nav-link.active {
  color: var(--bs-vertical-menu-item-active-color);
}

.navbar-menu .navbar-nav .nav-link:hover {
  color: var(--bs-vertical-menu-item-hover-color);
}

.navbar-menu .navbar-nav .nav-link i {
  display: inline-block;
  min-width: 1.75rem;
  font-size: 18px;
  line-height: inherit;
}

.navbar-menu .navbar-nav .nav-link svg {
  width: 18px;
  margin-right: 0.665rem;
  color: var(--bs-vertical-menu-item-color);
}

.navbar-menu .navbar-nav .nav-link .badge {
  margin-left: auto;
  margin-right: -2px;
  z-index: 1;
}

.navbar-menu .navbar-nav .nav-link:hover {
  color: var(--bs-vertical-menu-item-hover-color);
}

.navbar-menu .navbar-nav .nav-link:hover .icon-dual {
  color: var(--bs-vertical-menu-item-hover-color);
  fill: rgba(75, 56, 179, 0.16);
}

.navbar-menu .navbar-nav .nav-link[data-bs-toggle="collapse"]:after {
  display: block;
  content: "\\f0142";
  font-family: "Material Design Icons";
  margin-left: auto;
  transition: transform 0.2s;
  font-size: 1.05rem;
  position: absolute;
  right: 18px;
  color: var(--bs-vertical-menu-title-color);
}

.navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"] {
  color: var(--bs-vertical-menu-item-active-color);
}

.navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]
  .icon-dual {
  color: var(--bs-vertical-menu-item-hover-color);
  fill: rgba(75, 56, 179, 0.16);
}

.navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:after {
  transform: rotate(90deg);
  color: var(--bs-vertical-menu-item-active-color);
}

.navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:before {
  opacity: 1;
  background-color: var(--bs-vertical-menu-item-active-color);
}

.navbar-menu .navbar-nav .nav-link.collapsed.active::after {
  transform: rotate(90deg);
}

.navbar-menu .navbar-nav .nav-sm {
  padding-left: 1.75rem;
}

.navbar-menu .navbar-nav .nav-sm .nav-link {
  padding: 0.55rem 1.5rem !important;
  color: var(--bs-vertical-menu-sub-item-color);
  white-space: none;
  position: relative;
  font-size: 0.8125rem;
  font-family: Inter, sans-serif;
}

.navbar-menu .navbar-nav .nav-sm .nav-link:before {
  content: "";
  width: 6px;
  height: 1.5px;
  background-color: var(--bs-vertical-menu-sub-item-color);
  position: absolute;
  left: 2px;
  top: 16.5px;
  transition: all 0.4s ease-in-out;
  opacity: 0.5;
}

.navbar-menu .navbar-nav .nav-sm .nav-link:hover {
  color: var(--bs-vertical-menu-sub-item-hover-color);
}

.navbar-menu .navbar-nav .nav-sm .nav-link:hover:before {
  background-color: var(--bs-vertical-menu-sub-item-hover-color) !important;
  opacity: 1;
}

.navbar-menu .navbar-nav .nav-sm .nav-link.active {
  color: var(--bs-vertical-menu-item-active-color);
}

.navbar-menu .navbar-nav .nav-sm .nav-link.active:before {
  background-color: var(--bs-vertical-menu-item-active-color);
}

.navbar-menu .navbar-nav .nav-sm .nav-sm {
  padding-left: 15px;
}

.navbar-menu .navbar-nav .nav-sm .nav-sm .nav-link:before {
  height: 5px;
  width: 5px;
  left: 5px;
  border-radius: 50%;
  background-color: transparent;
  border: 1px solid;
  top: 16px;
}

.navbar-menu .btn-vertical-sm-hover {
  color: #878a99;
  display: none;
}

.navbar-brand-box {
  padding: 0 1.3rem;
  text-align: center;
  transition: all 0.1s ease-out;
}

@media (max-width: 767.98px) {
  .navbar-brand-box {
    display: none;
  }
}

.hamburger-icon {
  width: 20px;
  height: 14px;
  position: relative;
  cursor: pointer;
  display: inline-block;
}

.hamburger-icon span {
  background-color: #878a99;
  position: absolute;
  border-radius: 2px;
  transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);
  width: 100%;
  height: 2px;
  display: block;
  left: 0;
}

.hamburger-icon span:nth-child(1) {
  top: 0;
  width: 80%;
}

.hamburger-icon span:nth-child(2) {
  top: 6px;
}

.hamburger-icon span:nth-child(3) {
  bottom: 0;
  width: 60%;
}

.vertical-menu-btn:hover .hamburger-icon:not(.open) span:nth-child(1) {
  top: -1px;
}

.vertical-menu-btn:hover .hamburger-icon:not(.open) span:nth-child(3) {
  bottom: -1px;
}

.hamburger-icon.open {
  transform: rotate(-90deg);
}

.hamburger-icon.open span:nth-child(1) {
  left: 1px;
  top: 5px;
  width: 20px;
  transform: rotate(90deg);
  transition-delay: 150ms;
}

.hamburger-icon.open span:nth-child(2) {
  left: 3px;
  top: 13px;
  width: 10px;
  transform: rotate(45deg);
  transition-delay: 50ms;
}

.hamburger-icon.open span:nth-child(3) {
  left: 9px;
  top: 13px;
  width: 10px;
  transform: rotate(-45deg);
  transition-delay: 0.1s;
}

.logo {
  line-height: 70px;
}

.logo .logo-sm {
  display: none;
}

.logo-light {
  display: none;
}

[data-layout="vertical"] .app-menu .row {
  margin: 0;
}

[data-layout="vertical"] .app-menu .row > * {
  width: 100%;
  padding: 0;
}

@media (max-width: 767.98px) {
  [data-layout="vertical"] .app-menu {
    margin-left: -100%;
    padding: 10px 0 20px 0;
  }
}

[data-layout="vertical"] .navbar-menu .container-fluid {
  padding: 0;
}

@media (max-width: 767.98px) {
  [data-layout="vertical"] .navbar-brand-box {
    display: none;
  }
}

[data-layout="vertical"] .horizontal-logo {
  display: none;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"] .main-content {
  margin-left: 70px;
}

@media (max-width: 767.98px) {
  [data-layout="vertical"][data-sidebar-size="sm-hover"] .main-content {
    margin-left: 0;
  }
}

[data-layout="vertical"][data-sidebar-size="sm-hover"] .logo span.logo-lg {
  display: none;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"] .logo span.logo-sm {
  display: inline-block;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"] .btn-vertical-sm-hover {
  display: inline-block;
}

@media (min-width: 768px) {
  [data-layout="vertical"][data-sidebar-size="sm-hover"] .topnav-hamburger {
    display: none;
  }
}

[data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu {
  width: 70px;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu
  .btn-vertical-sm-hover {
  display: none;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu
  .btn-vertical-sm-hover
  i.ri-record-circle-line:before {
  content: "\\eb7d";
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu
  .navbar-nav
  .badge {
  display: none;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu
  .navbar-nav
  .menu-title {
  text-align: center;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu
  .navbar-nav
  .menu-title
  span {
  display: none;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu
  .navbar-nav
  .menu-title
  i {
  display: block;
  line-height: 36px;
  font-size: 1rem;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu
  .navbar-nav
  .nav-link
  span {
  display: none;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu
  .navbar-nav
  .nav-link
  i {
  font-size: 22px;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu
  .navbar-nav
  .nav-link
  i.lab,
[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu
  .navbar-nav
  .nav-link
  i.lar,
[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu
  .navbar-nav
  .nav-link
  i.las {
  font-size: 24px;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu
  .navbar-nav
  .nav-link
  svg {
  margin-right: 0;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu
  .navbar-nav
  .nav-link:after,
[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu
  .navbar-nav
  .nav-link:before {
  display: none;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu
  .navbar-nav
  .menu-dropdown {
  display: none;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu:hover {
  width: 250px !important;
}

@media (min-width: 1024.99px) {
  [data-layout="vertical"][data-sidebar-size="sm-hover"]
    .navbar-menu:hover
    .btn-vertical-sm-hover {
    display: inline-block;
  }

  [data-layout="vertical"][data-sidebar-size="sm-hover"]
    .navbar-menu:hover
    .navbar-brand-box {
    text-align: left;
  }
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu:hover
  .navbar-nav
  .menu-dropdown.show {
  display: block;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu:hover
  .nav-link
  i {
  font-size: 18px;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu:hover
  .nav-link
  i.lab,
[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu:hover
  .nav-link
  i.lar,
[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu:hover
  .nav-link
  i.las {
  font-size: 20px;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu:hover
  .nav-link
  svg {
  margin-right: 0.665rem;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu:hover
  .nav-link
  span,
[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu:hover
  .nav-link:after,
[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu:hover
  .nav-link:before {
  display: inline-block;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu:hover
  .logo
  span.logo-lg {
  display: inline-block;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu:hover
  .logo
  span.logo-sm {
  display: none;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu:hover
  .menu-title {
  text-align: left;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu:hover
  .menu-title
  span {
  display: inline-block;
}

[data-layout="vertical"][data-sidebar-size="sm-hover"]
  .navbar-menu:hover
  .menu-title
  i {
  display: none;
}

@media (min-width: 1025px) {
  [data-layout="vertical"][data-sidebar-size="sm-hover-active"] .navbar-header,
  [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-header {
    padding-left: 1.5rem;
  }
}

[data-layout="vertical"][data-sidebar-size="sm-hover-active"]
  .navbar-brand-box {
  text-align: left;
}

[data-layout="vertical"][data-sidebar-size="sm-hover-active"]
  .topnav-hamburger {
  display: none;
}

[data-layout="vertical"][data-sidebar-size="sm-hover-active"]
  .btn-vertical-sm-hover {
  display: inline-block;
}

@media (min-width: 768px) {
  [data-layout="vertical"][data-sidebar-size="sm"] {
    min-height: 1400px;
  }

  [data-layout="vertical"][data-sidebar-size="sm"] .main-content {
    margin-left: 70px;
  }
}

[data-layout="vertical"][data-sidebar-size="sm"] #page-topbar {
  z-index: calc(1002 + 1);
}

[data-layout="vertical"][data-sidebar-size="sm"] .navbar-brand-box {
  position: fixed;
  padding: 0;
  width: 70px;
  z-index: 1;
  top: 0;
  /* background: var(--bs-vertical-menu-bg) */
}

[data-layout="vertical"][data-sidebar-size="sm"] .logo span.logo-lg {
  display: none;
}

[data-layout="vertical"][data-sidebar-size="sm"] .logo span.logo-sm {
  display: inline-block;
}

[data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu {
  position: fixed;
  width: 70px !important;
  padding-top: 70px;
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .simplebar-content-wrapper,
[data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .simplebar-mask {
  overflow: visible !important;
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .simplebar-scrollbar,
[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .vertical-menu-btn {
  display: none !important;
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .simplebar-offset {
  bottom: 0 !important;
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .badge {
  display: none !important;
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .menu-title {
  text-align: center;
  font-size: 1rem;
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .menu-title
  span {
  display: none;
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .menu-title
  i {
  display: block;
  line-height: 36px;
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-link
  span {
  display: none;
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-link
  i {
  font-size: 22px;
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-link
  svg {
  margin-right: 0;
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-link:after,
[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-link:before {
  display: none;
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .menu-dropdown {
  display: none;
  height: auto !important;
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-item {
  position: relative;
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-item:hover
  > a.menu-link {
  position: relative;
  width: calc(200px + 70px);
  color: #6d7080;
  background-color: var(--bs-vertical-menu-bg-dark);
  transition: none;
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-item:hover
  > a.menu-link
  .icon-dual {
  color: var(--bs-vertical-menu-item-hover-color-dark);
  fill: rgba(255, 255, 255, 0.16);
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-item:hover
  > a.menu-link
  span {
  display: inline-block;
  padding-left: 25px;
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-item:hover
  > a.menu-link:after {
  display: block;
  transform: rotate(90deg);
  color: var(--bs-body-color);
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-item:hover
  > .menu-dropdown {
  display: block;
  left: 70px;
  position: absolute;
  width: 200px;
  /* background: var(--bs-vertical-menu-bg); */
  height: auto !important;
  padding: 0.5rem 0;
  border-radius: 0 0 3px 3px;
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
}

[data-layout-mode="light"]
  .navbar-menu
  .navbar-nav
  .nav-item:hover
  > .menu-dropdown {
  background-color: #fff !important;
}

[data-layout-mode="dark"]
  .navbar-menu
  .navbar-nav
  .nav-item:hover
  > .menu-dropdown {
  background-color: #262a2f !important;
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm {
  padding: 0;
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-item:hover
  > .nav-link {
  color: var(--bs-vertical-menu-item-hover-color);
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-item:hover
  > .nav-link:after {
  color: inherit;
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link:after {
  display: block !important;
  transform: rotate(0) !important;
}

[data-layout="vertical"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .menu-dropdown {
  left: 100% !important;
  top: 0;
  border-radius: 3px !important;
}

@media (min-width: 768px) {
  [data-layout="vertical"][data-sidebar-size="md"] .main-content {
    margin-left: 180px;
  }
}

[data-layout="vertical"][data-sidebar-size="md"] .navbar-brand-box {
  width: 180px;
}

[data-layout="vertical"][data-sidebar-size="md"] .navbar-menu {
  width: 180px !important;
}

[data-layout="vertical"][data-sidebar-size="md"]
  .navbar-menu
  .navbar-nav
  .nav-link {
  display: block;
  text-align: center;
  padding: 0.55rem 0.525rem;
}

[data-layout="vertical"][data-sidebar-size="md"]
  .navbar-menu
  .navbar-nav
  .nav-link
  i {
  display: block;
}

[data-layout="vertical"][data-sidebar-size="md"]
  .navbar-menu
  .navbar-nav
  .nav-link
  svg {
  display: block;
  margin-left: auto;
  margin-right: auto;
}

[data-layout="vertical"][data-sidebar-size="md"]
  .navbar-menu
  .navbar-nav
  .nav-link:before {
  display: none !important;
}

[data-layout="vertical"][data-sidebar-size="md"]
  .navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"]:after {
  position: relative;
  display: inline-block;
  right: 0;
  top: 3px;
}

[data-layout="vertical"][data-sidebar-size="md"]
  .navbar-menu
  .navbar-nav
  .nav-link.menu-link[data-bs-toggle="collapse"]:after {
  display: none;
}

[data-layout="vertical"][data-sidebar-size="md"]
  .navbar-menu
  .navbar-nav
  .badge {
  display: none !important;
}

[data-layout="vertical"][data-sidebar-size="md"]
  .navbar-menu
  .navbar-nav
  .nav-sm {
  padding-left: 0;
}

[data-layout="vertical"][data-sidebar-size="md"] .navbar-menu .menu-title {
  text-align: center;
}

[data-layout="vertical"][data-sidebar-size="md"] .navbar-menu .menu-title span {
  text-decoration: underline;
}

[data-layout="vertical"][data-sidebar="dark"] .navbar-menu {
  background: var(--bs-vertical-menu-bg-dark);
  border-right: 1px solid var(--bs-vertical-menu-bg-dark);
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-menu
  .hamburger-icon
  span {
  background-color: var(--bs-vertical-menu-item-color-dark);
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-menu
  .btn-vertical-sm-hover {
  color: var(--bs-vertical-menu-item-color-dark);
}

[data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-link {
  color: var(--bs-vertical-menu-item-color-dark);
}

[data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-link.active {
  color: var(--bs-vertical-menu-item-active-color-dark);
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"]:after {
  color: inherit;
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"] {
  color: var(--bs-vertical-menu-item-active-color-dark);
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:after {
  color: inherit;
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]
  .icon-dual {
  color: var(--bs-vertical-menu-item-active-color-dark);
  fill: rgba(255, 255, 255, 0.1);
}

[data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-link svg {
  color: var(--bs-vertical-menu-item-color-dark);
  fill: rgba(255, 255, 255, 0.1);
}

[data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-link:hover {
  color: var(--bs-vertical-menu-item-hover-color-dark);
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-nav
  .nav-link:hover
  .icon-dual {
  color: var(--bs-vertical-menu-item-hover-color-dark);
  fill: rgba(255, 255, 255, 0.16);
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-nav
  > .nav-item
  .nav-link.active {
  color: var(--bs-vertical-menu-item-active-color-dark);
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-nav
  > .nav-item
  .nav-link.active
  .icon-dual {
  color: var(--bs-vertical-menu-item-hover-color-dark);
  fill: rgba(255, 255, 255, 0.16);
}

[data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-sm .nav-link {
  color: var(--bs-vertical-menu-sub-item-color-dark);
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-nav
  .nav-sm
  .nav-link:before {
  background-color: var(--bs-vertical-menu-sub-item-color-dark) !important;
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-nav
  .nav-sm
  .nav-link:hover {
  color: var(--bs-vertical-menu-item-hover-color-dark);
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-nav
  .nav-sm
  .nav-link:hover:before {
  background-color: var(--bs-vertical-menu-item-hover-color-dark) !important;
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-nav
  .nav-sm
  .nav-link.active {
  color: var(--bs-vertical-menu-item-active-color-dark);
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-nav
  .nav-sm
  .nav-sm
  .nav-link:before {
  background-color: transparent !important;
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-nav
  .nav-sm
  .nav-sm
  .nav-link:hover:before {
  background-color: var(--bs-vertical-menu-item-hover-color-dark) !important;
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-nav
  .nav-sm
  .nav-sm
  .nav-link.active {
  color: var(--bs-vertical-menu-item-active-color-dark);
}

[data-layout="vertical"][data-sidebar="dark"]
  .navbar-nav
  .nav-sm
  .nav-sm
  .nav-link.active:before {
  background-color: var(--bs-vertical-menu-item-active-color-dark) !important;
}

[data-layout="vertical"][data-sidebar="dark"][data-sidebar-size="sm"]
  .navbar-brand-box {
  background: var(--bs-vertical-menu-bg-dark);
}

[data-layout="vertical"][data-sidebar="dark"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-item:hover
  > .menu-dropdown {
  background: var(--bs-vertical-menu-bg-dark);
}

[data-layout="vertical"][data-sidebar="dark"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm {
  padding: 0;
}

[data-layout="vertical"][data-sidebar="dark"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link:after {
  display: block !important;
  transform: rotate(0) !important;
}

[data-layout="vertical"][data-sidebar="dark"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-item:hover
  > .nav-link {
  color: var(--bs-vertical-menu-item-active-color-dark);
}

[data-layout="vertical"][data-sidebar="dark"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-item:hover
  > .nav-link:after {
  color: inherit;
}

[data-layout="vertical"][data-sidebar="dark"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .menu-dropdown {
  left: 100% !important;
  top: 0;
  border-radius: 3px !important;
}

[data-layout="vertical"][data-sidebar="dark"] .menu-title {
  color: var(--bs-vertical-menu-title-color-dark);
}

[data-layout="vertical"][data-sidebar="dark"] .logo-dark {
  display: none;
}

[data-layout="vertical"][data-sidebar="dark"] .logo-light {
  display: inline-block;
}

[data-layout="vertical"][data-sidebar="light"] .logo-dark {
  display: inline-block;
}

[data-layout="vertical"][data-sidebar="light"] .logo-light {
  display: none;
}

[data-layout="vertical"][data-layout-style="detached"] #layout-wrapper,
[data-layout="vertical"][data-layout-style="detached"] .main-content {
  min-height: 100vh;
}

@media (min-width: 1024.1px) {
  [data-layout="vertical"][data-layout-style="detached"] .main-content {
    position: relative;
  }

  [data-layout="vertical"][data-layout-style="detached"] #layout-wrapper {
    max-width: 95%;
    margin: 0 auto;
    padding-left: 1.5rem;
  }

  [data-layout="vertical"][data-layout-style="detached"] .navbar-header {
    padding-left: 1.5rem;
  }

  [data-layout="vertical"][data-layout-style="detached"] .navbar-menu {
    top: calc(70px + 1.5rem);
    bottom: 1.5rem;
    padding: 0;
    border-right: var(--bs-vertical-menu-bg);
    border-radius: 5px;
    padding: 10px 0;
    z-index: 1;
  }

  [data-layout="vertical"][data-layout-style="detached"]
    .navbar-menu
    .navbar-brand-box {
    display: none;
  }

  [data-layout="vertical"][data-layout-style="detached"][data-sidebar="dark"]
    .logo-dark,
  [data-layout="vertical"][data-layout-style="detached"][data-sidebar="gradient-2"]
    .logo-dark,
  [data-layout="vertical"][data-layout-style="detached"][data-sidebar="gradient-3"]
    .logo-dark,
  [data-layout="vertical"][data-layout-style="detached"][data-sidebar="gradient-4"]
    .logo-dark,
  [data-layout="vertical"][data-layout-style="detached"][data-sidebar="gradient"]
    .logo-dark {
    display: inline-block;
  }

  [data-layout="vertical"][data-layout-style="detached"][data-sidebar="dark"]
    .logo-light,
  [data-layout="vertical"][data-layout-style="detached"][data-sidebar="gradient-2"]
    .logo-light,
  [data-layout="vertical"][data-layout-style="detached"][data-sidebar="gradient-3"]
    .logo-light,
  [data-layout="vertical"][data-layout-style="detached"][data-sidebar="gradient-4"]
    .logo-light,
  [data-layout="vertical"][data-layout-style="detached"][data-sidebar="gradient"]
    .logo-light {
    display: none;
  }
}

[data-layout="vertical"][data-layout-style="detached"] .footer {
  border-top: 1px dashed var(--bs-border-color);
}

[data-layout="vertical"][data-layout-style="detached"]
  .auth-page-wrapper
  .footer {
  border-top: none;
}

@media (min-width: 768px) {
  [data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm"]
    #layout-wrapper,
  [data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm"]
    .main-content {
    min-height: 1400px;
  }
}

[data-layout="vertical"][data-sidebar="gradient-2"] .logo-dark,
[data-layout="vertical"][data-sidebar="gradient-3"] .logo-dark,
[data-layout="vertical"][data-sidebar="gradient-4"] .logo-dark,
[data-layout="vertical"][data-sidebar="gradient"] .logo-dark {
  display: none;
}

[data-layout="vertical"][data-sidebar="gradient-2"] .logo-light,
[data-layout="vertical"][data-sidebar="gradient-3"] .logo-light,
[data-layout="vertical"][data-sidebar="gradient-4"] .logo-light,
[data-layout="vertical"][data-sidebar="gradient"] .logo-light {
  display: inline-block;
}

.menu-title {
  letter-spacing: 0.05em;
  cursor: default;
  font-size: 11px;
  text-transform: uppercase;
  color: var(--bs-vertical-menu-title-color);
  font-weight: 600;
}

.menu-title span {
  padding: 12px 20px;
  display: inline-block;
}

.menu-title i {
  display: none;
}

.vertical-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(33, 37, 41, 0.35);
  z-index: 1003;
  display: none;
}

.vertical-sidebar-enable .vertical-overlay {
  display: block;
}

.vertical-sidebar-enable .app-menu {
  margin-left: 0 !important;
  z-index: 1004;
}

[dir="rtl"]
  .navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"]:after {
  transform: rotate(180deg);
}

[dir="rtl"]
  .navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:after {
  transform: rotate(270deg);
}

[data-sidebar="gradient-2"] .navbar-menu,
[data-sidebar="gradient-3"] .navbar-menu,
[data-sidebar="gradient-4"] .navbar-menu,
[data-sidebar="gradient"] .navbar-menu {
  background: var(--bs-vertical-menu-bg-gradient);
  border-right: 1px solid var(--bs-vertical-menu-border-gradient);
}

[data-sidebar="gradient-2"] .navbar-menu .hamburger-icon span,
[data-sidebar="gradient-3"] .navbar-menu .hamburger-icon span,
[data-sidebar="gradient-4"] .navbar-menu .hamburger-icon span,
[data-sidebar="gradient"] .navbar-menu .hamburger-icon span {
  background-color: rgba(255, 255, 255, 0.5);
}

[data-sidebar="gradient-2"] .navbar-menu .btn-vertical-sm-hover,
[data-sidebar="gradient-3"] .navbar-menu .btn-vertical-sm-hover,
[data-sidebar="gradient-4"] .navbar-menu .btn-vertical-sm-hover,
[data-sidebar="gradient"] .navbar-menu .btn-vertical-sm-hover {
  color: rgba(255, 255, 255, 0.5);
}

[data-sidebar="gradient-2"] .navbar-nav .nav-link,
[data-sidebar="gradient-3"] .navbar-nav .nav-link,
[data-sidebar="gradient-4"] .navbar-nav .nav-link,
[data-sidebar="gradient"] .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5);
}

[data-sidebar="gradient-2"] .navbar-nav .nav-link.active,
[data-sidebar="gradient-3"] .navbar-nav .nav-link.active,
[data-sidebar="gradient-4"] .navbar-nav .nav-link.active,
[data-sidebar="gradient"] .navbar-nav .nav-link.active {
  color: var(--bs-vertical-menu-item-active-color-dark);
}

[data-sidebar="gradient-2"]
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"]:after,
[data-sidebar="gradient-3"]
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"]:after,
[data-sidebar="gradient-4"]
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"]:after,
[data-sidebar="gradient"]
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"]:after {
  color: inherit;
}

[data-sidebar="gradient-2"]
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"],
[data-sidebar="gradient-3"]
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"],
[data-sidebar="gradient-4"]
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"],
[data-sidebar="gradient"]
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"] {
  color: var(--bs-vertical-menu-item-active-color-dark);
}

[data-sidebar="gradient-2"]
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:after,
[data-sidebar="gradient-3"]
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:after,
[data-sidebar="gradient-4"]
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:after,
[data-sidebar="gradient"]
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:after {
  color: inherit;
}

[data-sidebar="gradient-2"]
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]
  .icon-dual,
[data-sidebar="gradient-3"]
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]
  .icon-dual,
[data-sidebar="gradient-4"]
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]
  .icon-dual,
[data-sidebar="gradient"]
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]
  .icon-dual {
  color: var(--bs-vertical-menu-item-active-color-dark);
  fill: rgba(255, 255, 255, 0.1);
}

[data-sidebar="gradient-2"] .navbar-nav .nav-link svg,
[data-sidebar="gradient-3"] .navbar-nav .nav-link svg,
[data-sidebar="gradient-4"] .navbar-nav .nav-link svg,
[data-sidebar="gradient"] .navbar-nav .nav-link svg {
  color: rgba(255, 255, 255, 0.5);
  fill: rgba(255, 255, 255, 0.1);
}

[data-sidebar="gradient-2"] .navbar-nav .nav-link:hover,
[data-sidebar="gradient-3"] .navbar-nav .nav-link:hover,
[data-sidebar="gradient-4"] .navbar-nav .nav-link:hover,
[data-sidebar="gradient"] .navbar-nav .nav-link:hover {
  color: var(--bs-vertical-menu-item-hover-color-dark);
}

[data-sidebar="gradient-2"] .navbar-nav .nav-link:hover .icon-dual,
[data-sidebar="gradient-3"] .navbar-nav .nav-link:hover .icon-dual,
[data-sidebar="gradient-4"] .navbar-nav .nav-link:hover .icon-dual,
[data-sidebar="gradient"] .navbar-nav .nav-link:hover .icon-dual {
  color: var(--bs-vertical-menu-item-hover-color-dark);
  fill: rgba(255, 255, 255, 0.16);
}

[data-sidebar="gradient-2"] .navbar-nav > .nav-item .nav-link.active,
[data-sidebar="gradient-3"] .navbar-nav > .nav-item .nav-link.active,
[data-sidebar="gradient-4"] .navbar-nav > .nav-item .nav-link.active,
[data-sidebar="gradient"] .navbar-nav > .nav-item .nav-link.active {
  color: var(--bs-vertical-menu-item-active-color-dark);
}

[data-sidebar="gradient-2"] .navbar-nav > .nav-item .nav-link.active .icon-dual,
[data-sidebar="gradient-3"] .navbar-nav > .nav-item .nav-link.active .icon-dual,
[data-sidebar="gradient-4"] .navbar-nav > .nav-item .nav-link.active .icon-dual,
[data-sidebar="gradient"] .navbar-nav > .nav-item .nav-link.active .icon-dual {
  color: var(--bs-vertical-menu-item-hover-color-dark);
  fill: rgba(255, 255, 255, 0.16);
}

[data-sidebar="gradient-2"] .navbar-nav .nav-sm .nav-link,
[data-sidebar="gradient-3"] .navbar-nav .nav-sm .nav-link,
[data-sidebar="gradient-4"] .navbar-nav .nav-sm .nav-link,
[data-sidebar="gradient"] .navbar-nav .nav-sm .nav-link {
  color: rgba(255, 255, 255, 0.5);
}

[data-sidebar="gradient-2"] .navbar-nav .nav-sm .nav-link:before,
[data-sidebar="gradient-3"] .navbar-nav .nav-sm .nav-link:before,
[data-sidebar="gradient-4"] .navbar-nav .nav-sm .nav-link:before,
[data-sidebar="gradient"] .navbar-nav .nav-sm .nav-link:before {
  background-color: rgba(255, 255, 255, 0.5) !important;
}

[data-sidebar="gradient-2"] .navbar-nav .nav-sm .nav-link:hover,
[data-sidebar="gradient-3"] .navbar-nav .nav-sm .nav-link:hover,
[data-sidebar="gradient-4"] .navbar-nav .nav-sm .nav-link:hover,
[data-sidebar="gradient"] .navbar-nav .nav-sm .nav-link:hover {
  color: var(--bs-vertical-menu-item-hover-color-dark);
}

[data-sidebar="gradient-2"] .navbar-nav .nav-sm .nav-link:hover:before,
[data-sidebar="gradient-3"] .navbar-nav .nav-sm .nav-link:hover:before,
[data-sidebar="gradient-4"] .navbar-nav .nav-sm .nav-link:hover:before,
[data-sidebar="gradient"] .navbar-nav .nav-sm .nav-link:hover:before {
  background-color: var(--bs-vertical-menu-item-hover-color-dark) !important;
}

[data-sidebar="gradient-2"] .navbar-nav .nav-sm .nav-link.active,
[data-sidebar="gradient-3"] .navbar-nav .nav-sm .nav-link.active,
[data-sidebar="gradient-4"] .navbar-nav .nav-sm .nav-link.active,
[data-sidebar="gradient"] .navbar-nav .nav-sm .nav-link.active {
  color: var(--bs-vertical-menu-item-active-color-dark);
}

[data-sidebar="gradient-2"] .navbar-nav .nav-sm .nav-sm .nav-link:before,
[data-sidebar="gradient-3"] .navbar-nav .nav-sm .nav-sm .nav-link:before,
[data-sidebar="gradient-4"] .navbar-nav .nav-sm .nav-sm .nav-link:before,
[data-sidebar="gradient"] .navbar-nav .nav-sm .nav-sm .nav-link:before {
  background-color: transparent !important;
}

[data-sidebar="gradient-2"] .navbar-nav .nav-sm .nav-sm .nav-link:hover:before,
[data-sidebar="gradient-3"] .navbar-nav .nav-sm .nav-sm .nav-link:hover:before,
[data-sidebar="gradient-4"] .navbar-nav .nav-sm .nav-sm .nav-link:hover:before,
[data-sidebar="gradient"] .navbar-nav .nav-sm .nav-sm .nav-link:hover:before {
  background-color: var(--bs-vertical-menu-item-hover-color-dark) !important;
}

[data-sidebar="gradient-2"] .navbar-nav .nav-sm .nav-sm .nav-link.active,
[data-sidebar="gradient-3"] .navbar-nav .nav-sm .nav-sm .nav-link.active,
[data-sidebar="gradient-4"] .navbar-nav .nav-sm .nav-sm .nav-link.active,
[data-sidebar="gradient"] .navbar-nav .nav-sm .nav-sm .nav-link.active {
  color: var(--bs-vertical-menu-item-active-color-dark);
}

[data-sidebar="gradient-2"] .navbar-nav .nav-sm .nav-sm .nav-link.active:before,
[data-sidebar="gradient-3"] .navbar-nav .nav-sm .nav-sm .nav-link.active:before,
[data-sidebar="gradient-4"] .navbar-nav .nav-sm .nav-sm .nav-link.active:before,
[data-sidebar="gradient"] .navbar-nav .nav-sm .nav-sm .nav-link.active:before {
  background-color: var(--bs-vertical-menu-item-active-color-dark) !important;
}

[data-sidebar="gradient-2"][data-sidebar-size="sm"] .navbar-brand-box,
[data-sidebar="gradient-3"][data-sidebar-size="sm"] .navbar-brand-box,
[data-sidebar="gradient-4"][data-sidebar-size="sm"] .navbar-brand-box,
[data-sidebar="gradient"][data-sidebar-size="sm"] .navbar-brand-box {
  background: var(--bs-vertical-menu-bg-gradient);
}

[data-sidebar="gradient-2"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-item:hover
  > .menu-dropdown,
[data-sidebar="gradient-3"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-item:hover
  > .menu-dropdown,
[data-sidebar="gradient-4"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-item:hover
  > .menu-dropdown,
[data-sidebar="gradient"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-item:hover
  > .menu-dropdown {
  background: var(--bs-vertical-menu-bg-dark);
}

[data-sidebar="gradient-2"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm,
[data-sidebar="gradient-3"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm,
[data-sidebar="gradient-4"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm,
[data-sidebar="gradient"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm {
  padding: 0;
}

[data-sidebar="gradient-2"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link:after,
[data-sidebar="gradient-3"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link:after,
[data-sidebar="gradient-4"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link:after,
[data-sidebar="gradient"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link:after {
  display: block !important;
  transform: rotate(0) !important;
}

[data-sidebar="gradient-2"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-item:hover
  > .nav-link,
[data-sidebar="gradient-3"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-item:hover
  > .nav-link,
[data-sidebar="gradient-4"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-item:hover
  > .nav-link,
[data-sidebar="gradient"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-item:hover
  > .nav-link {
  color: var(--bs-vertical-menu-item-active-color-dark);
}

[data-sidebar="gradient-2"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-item:hover
  > .nav-link:after,
[data-sidebar="gradient-3"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-item:hover
  > .nav-link:after,
[data-sidebar="gradient-4"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-item:hover
  > .nav-link:after,
[data-sidebar="gradient"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-item:hover
  > .nav-link:after {
  color: inherit;
}

[data-sidebar="gradient-2"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .menu-dropdown,
[data-sidebar="gradient-3"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .menu-dropdown,
[data-sidebar="gradient-4"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .menu-dropdown,
[data-sidebar="gradient"][data-sidebar-size="sm"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .menu-dropdown {
  left: 100% !important;
  top: 0;
  border-radius: 3px !important;
}

[data-sidebar="gradient-2"][data-sidebar-size="sm"][data-layout="vertical"]
  .navbar-menu
  .navbar-nav
  .nav-item:hover
  > a.menu-link,
[data-sidebar="gradient-3"][data-sidebar-size="sm"][data-layout="vertical"]
  .navbar-menu
  .navbar-nav
  .nav-item:hover
  > a.menu-link,
[data-sidebar="gradient-4"][data-sidebar-size="sm"][data-layout="vertical"]
  .navbar-menu
  .navbar-nav
  .nav-item:hover
  > a.menu-link,
[data-sidebar="gradient"][data-sidebar-size="sm"][data-layout="vertical"]
  .navbar-menu
  .navbar-nav
  .nav-item:hover
  > a.menu-link {
  background: var(--bs-vertical-menu-bg-gradient);
}

[data-sidebar="gradient-2"] .menu-title,
[data-sidebar="gradient-3"] .menu-title,
[data-sidebar="gradient-4"] .menu-title,
[data-sidebar="gradient"] .menu-title {
  color: rgba(255, 255, 255, 0.5);
}

.bg-vertical-gradient {
  background: linear-gradient(to right, var(--bs-primary), var(--bs-success));
}

.bg-vertical-gradient-2 {
  background: linear-gradient(to right, var(--bs-info), var(--bs-secondary));
}

.bg-vertical-gradient-3 {
  background: linear-gradient(to right, var(--bs-info), var(--bs-success));
}

.bg-vertical-gradient-4 {
  background: linear-gradient(to right, var(--bs-dark), var(--bs-primary));
}

.sidebar-background {
  position: absolute;
  z-index: -1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: 50%;
  opacity: 0.07;
}

[data-layout="horizontal"] .main-content {
  margin-left: 0;
}

@media (min-width: 1024.1px) {
  [data-layout="horizontal"] .container-fluid,
  [data-layout="horizontal"] .layout-width {
    max-width: 90%;
    margin: 0 auto;
  }

  [data-layout="horizontal"] .topnav-hamburger {
    visibility: hidden;
  }
}

[data-layout="horizontal"] .horizontal-logo {
  padding-left: calc(1.5rem / 2);
}

@media (max-width: 1024.98px) {
  [data-layout="horizontal"] .horizontal-logo {
    padding-left: 1.5rem;
  }
}

[data-layout="horizontal"] .navbar-menu {
  background: var(--bs-topnav-bg);
  border-right-color: transparent;
  padding: 0 calc(1.5rem / 2);
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  margin-top: 70px;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 100;
  width: 100%;
  bottom: auto;
}

@media (max-width: 575.98px) {
  [data-layout="horizontal"] .navbar-menu .container-fluid {
    padding: 0;
  }
}

[data-layout="horizontal"] .navbar-menu .navbar-nav {
  flex-direction: row;
}

[data-layout="horizontal"] .navbar-menu .navbar-nav .nav-sm {
  padding-left: 0;
}

[data-layout="horizontal"] .navbar-menu .navbar-nav .nav-sm .nav-link:before {
  opacity: 0 !important;
}

[data-layout="horizontal"] .navbar-menu .navbar-nav .nav-sm .nav-link.active,
[data-layout="horizontal"] .navbar-menu .navbar-nav .nav-sm .nav-link:hover {
  color: var(--bs-topnav-item-color-active);
}

[data-layout="horizontal"] .navbar-menu .navbar-nav .nav-link {
  color: var(--bs-topnav-item-color);
  padding: 0.75rem 1.5rem;
}

[data-layout="horizontal"] .navbar-menu .navbar-nav .nav-link i {
  line-height: 1;
}

[data-layout="horizontal"] .navbar-menu .navbar-nav .nav-link.active {
  color: var(--bs-topnav-item-color-active);
}

[data-layout="horizontal"] .navbar-menu .navbar-nav .nav-link.active:after {
  color: var(--bs-topnav-item-color-active);
}

[data-layout="horizontal"]
  .navbar-menu
  .navbar-nav
  .nav-link.active
  .icon-dual {
  color: var(--bs-topnav-item-color-active);
  fill: rgba(75, 56, 179, 0.1);
}

[data-layout="horizontal"]
  .navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"] {
  color: var(--bs-topnav-item-color-active);
}

[data-layout="horizontal"]
  .navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]
  .icon-dual {
  color: var(--bs-topnav-item-color-active);
  fill: rgba(75, 56, 179, 0.1);
}

[data-layout="horizontal"]
  .navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:after {
  color: var(--bs-topnav-item-color-active);
}

[data-layout="horizontal"] .navbar-menu .navbar-nav .nav-link:hover .icon-dual {
  color: var(--bs-topnav-item-color-active);
  fill: rgba(75, 56, 179, 0.1);
}

[data-layout="horizontal"]
  .navbar-menu
  .navbar-nav
  > .nav-item
  > .nav-link[data-bs-toggle="collapse"]:after {
  right: 0;
  transform: rotate(90deg) !important;
}

[data-layout="horizontal"]
  .navbar-menu
  .navbar-nav
  > li:nth-of-type(2)
  > .nav-link.menu-link {
  padding-left: 0;
}

[data-layout="horizontal"] .navbar-menu .navbar-brand-box {
  display: none;
}

[data-layout="horizontal"] .navbar-nav .nav-item {
  position: relative;
}

[data-layout="horizontal"]
  .navbar-nav
  .nav-item
  .nav-link[data-bs-toggle="collapse"]:after {
  right: 10px;
  transform: rotate(0) !important;
}

[data-layout="horizontal"] .navbar-nav .nav-item > .nav-link > .badge {
  display: none;
}

[data-layout="horizontal"] .navbar-nav .nav-item:hover > .nav-link {
  color: var(--bs-topnav-item-color-active);
}

[data-layout="horizontal"] .navbar-nav .nav-item:hover > .nav-link .icon-dual {
  color: var(--bs-topnav-item-color-active);
  fill: rgba(75, 56, 179, 0.1);
}

[data-layout="horizontal"] .navbar-nav .nav-item:hover > .nav-link:after {
  color: var(--bs-topnav-item-color-active);
}

@media (min-width: 1024.1px) {
  [data-layout="horizontal"] .navbar-nav .nav-item:hover > .menu-dropdown {
    display: block;
    height: auto !important;
  }
}

[data-layout="horizontal"] .navbar-nav .nav-item.active {
  color: var(--bs-topnav-item-color-active);
}

[data-layout="horizontal"] .menu-dropdown {
  position: absolute;
  min-width: 12rem;
  padding: 0.5rem 0;
  box-shadow: 0 0 5px rgba(15, 34, 58, 0.15);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  margin: 0;
  z-index: 1000;
  background-color: var(--bs-choices-bg);
  background-clip: padding-box;
  border: 0 solid var(--bs-border-color);
  border-radius: 0.3rem;
  display: none;
}

[data-layout="horizontal"] .menu-dropdown .menu-dropdown {
  top: 0;
  left: 100%;
}

[data-layout="horizontal"] .mega-dropdown-menu {
  width: 40rem;
}

[data-layout="horizontal"] .menu-title {
  display: none;
}

[data-layout="horizontal"] .dropdown-custom-right {
  left: -100% !important;
  right: 100%;
}

@media (max-width: 1024px) {
  [data-layout="horizontal"] .navbar-menu {
    display: none;
  }
}

@media (max-width: 1024px) {
  [data-layout="horizontal"] .menu .navbar-menu {
    display: block;
    max-height: 360px;
    overflow-y: auto;
    padding-left: 0;
  }

  [data-layout="horizontal"] .menu .navbar-menu .navbar-nav {
    flex-direction: column;
  }

  [data-layout="horizontal"]
    .menu
    .navbar-menu
    .navbar-nav
    > li:nth-of-type(2)
    > .nav-link.menu-link {
    padding-left: 1.5rem;
  }

  [data-layout="horizontal"]
    .menu
    .navbar-menu
    .navbar-nav
    .nav-sm
    .nav-link:before {
    opacity: 1 !important;
  }

  [data-layout="horizontal"] .menu .menu-dropdown {
    position: relative;
    min-width: 100%;
    box-shadow: none;
    padding-left: 28px;
    left: 0;
    animation: none;
    padding-top: 0;
  }

  [data-layout="horizontal"] .menu .menu-dropdown.show {
    display: block;
  }

  [data-layout="horizontal"] .menu .dropdown-custom-right {
    left: 0 !important;
  }

  [data-layout="horizontal"]
    .menu
    .nav-item
    .nav-link[data-bs-toggle="collapse"]:after {
    right: 0;
  }

  [data-layout="horizontal"] .menu .mega-dropdown-menu {
    width: 100%;
  }
}

[data-layout-mode="dark"][data-topbar="light"]
  .navbar-header
  .horizontal-logo
  .logo-dark {
  display: none;
}

[data-layout-mode="dark"][data-topbar="light"]
  .navbar-header
  .horizontal-logo
  .logo-light {
  display: block;
}

[dir="rtl"][data-layout="horizontal"]
  .navbar-menu
  .navbar-nav
  > .nav-item
  > .nav-link[data-bs-toggle="collapse"]:after {
  transform: rotate(-90deg) !important;
}

[dir="rtl"][data-layout="horizontal"]
  .navbar-nav
  .nav-item
  .nav-link[data-bs-toggle="collapse"]:after {
  transform: rotate(-180deg) !important;
}

[data-layout="twocolumn"] .app-menu {
  padding-bottom: 0;
  width: 220px;
  left: 70px;
}

[data-layout="twocolumn"] .app-menu .menu-link {
  letter-spacing: 0.05em;
  cursor: default;
  font-size: 11px;
  text-transform: uppercase;
  color: var(--bs-vertical-menu-title-color) !important;
  font-weight: 600;
}

[data-layout="twocolumn"] .app-menu .menu-link:after {
  display: none !important;
}

[data-layout="twocolumn"] .app-menu .menu-link i {
  display: none;
}

[data-layout="twocolumn"] .app-menu .navbar-nav {
  height: calc(100vh - 70px);
}

@media (max-width: 767.98px) {
  [data-layout="twocolumn"] .app-menu .navbar-nav {
    padding-top: 16px;
  }
}

[data-layout="twocolumn"] .app-menu .navbar-nav > li:not(.twocolumn-item-show) {
  display: none;
}

[data-layout="twocolumn"] .app-menu .navbar-nav .twocolumn-item-show > div {
  display: block !important;
  height: auto !important;
}

[data-layout="twocolumn"] .app-menu .navbar-nav > .nav-item > .menu-dropdown {
  display: block !important;
  height: auto !important;
}

[data-layout="twocolumn"] .app-menu .navbar-nav .nav-item .menu-dropdown .row {
  margin: 0;
}

[data-layout="twocolumn"]
  .app-menu
  .navbar-nav
  .nav-item
  .menu-dropdown
  .row
  .col-lg-4 {
  width: 100%;
  padding: 0;
}

[data-layout="twocolumn"] .app-menu .navbar-nav .nav-sm .nav-link {
  color: var(--bs-vertical-menu-item-color);
}

[data-layout="twocolumn"] .app-menu .navbar-nav .nav-sm .nav-link.active {
  color: var(--bs-vertical-menu-item-active-color);
}

[data-layout="twocolumn"] .app-menu .container-fluid {
  padding: 0;
}

[data-layout="twocolumn"] .main-content {
  margin-left: calc(220px + 70px);
}

@media (max-width: 767.98px) {
  [data-layout="twocolumn"] .main-content {
    margin-left: 70px;
  }
}

[data-layout="twocolumn"] .twocolumn-iconview {
  width: 70px;
  background-color: var(--bs-twocolumn-menu-iconview-bg);
  height: 100%;
  left: -70px;
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  top: 0;
  position: absolute;
  padding: 0;
  text-align: center;
}

[data-layout="twocolumn"] .twocolumn-iconview li {
  position: relative;
}

[data-layout="twocolumn"] .twocolumn-iconview li .nav-icon::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

[data-layout="twocolumn"] .twocolumn-iconview .nav-icon {
  width: 42px;
  height: 42px;
  line-height: 42px;
  color: var(--bs-vertical-menu-item-color);
  z-index: 1;
  font-size: 22px;
  text-align: center;
  border-radius: 3px;
  margin: 5px 0;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

[data-layout="twocolumn"] .twocolumn-iconview .nav-icon .icon-dual {
  width: 18px;
  color: var(--bs-vertical-menu-item-color);
}

[data-layout="twocolumn"] .twocolumn-iconview .nav-icon.active {
  background-color: rgba(75, 56, 179, 0.15);
  color: #4b38b3;
}

[data-layout="twocolumn"] .twocolumn-iconview .nav-icon.active .icon-dual {
  color: #4b38b3;
  fill: rgba(75, 56, 179, 0.1);
}

[data-layout="twocolumn"] .menu-title {
  display: none;
}

@media (max-width: 991.98px) {
  [data-layout="twocolumn"] .logo span.logo-lg {
    display: block;
  }

  [data-layout="twocolumn"] .logo span.logo-sm {
    display: none;
  }
}

[data-layout="twocolumn"][data-sidebar="light"]
  .app-menu
  .navbar-brand-box
  .logo-light {
  display: none;
}

[data-layout="twocolumn"][data-sidebar="light"]
  .app-menu
  .navbar-brand-box
  .logo-dark {
  display: block;
}

[data-layout="twocolumn"][data-sidebar="dark"] .twocolumn-iconview {
  background-color: var(--bs-twocolumn-menu-iconview-bg-dark);
}

[data-layout="twocolumn"][data-sidebar="dark"] .twocolumn-iconview .nav-icon {
  color: var(--bs-twocolumn-menu-item-color-dark);
}

[data-layout="twocolumn"][data-sidebar="dark"]
  .twocolumn-iconview
  .nav-icon.active {
  color: var(--bs-twocolumn-menu-item-active-color-dark);
  background-color: var(--bs-twocolumn-menu-item-active-bg-dark);
}

[data-layout="twocolumn"][data-sidebar="dark"] .app-menu {
  background-color: var(--bs-twocolumn-menu-bg-dark);
  border-right-color: var(--bs-twocolumn-menu-bg-dark);
}

[data-layout="twocolumn"][data-sidebar="dark"]
  .app-menu
  .navbar-brand-box
  .logo-light {
  display: block;
}

[data-layout="twocolumn"][data-sidebar="dark"]
  .app-menu
  .navbar-brand-box
  .logo-dark {
  display: none;
}

[data-layout="twocolumn"][data-sidebar="dark"]
  .app-menu
  .navbar-nav
  .nav-sm
  .nav-link {
  color: var(--bs-twocolumn-menu-item-color-dark);
}

[data-layout="twocolumn"][data-sidebar="dark"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link.active,
[data-layout="twocolumn"][data-sidebar="dark"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link:hover {
  color: var(--bs-twocolumn-menu-item-active-color-dark);
}

[data-layout="twocolumn"][data-sidebar="dark"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link.active::before,
[data-layout="twocolumn"][data-sidebar="dark"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link:hover::before {
  background-color: var(--bs-twocolumn-menu-item-active-color-dark) !important;
}

[data-layout="twocolumn"][data-sidebar="dark"]
  .navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"] {
  color: var(--bs-twocolumn-menu-item-active-color-dark);
}

[data-layout="twocolumn"][data-sidebar="dark"]
  .navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:before {
  background-color: var(--bs-twocolumn-menu-item-active-color-dark);
}

[data-layout="twocolumn"][data-sidebar="dark"]
  .navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]::after {
  color: var(--bs-twocolumn-menu-item-active-color-dark) !important;
}

[data-layout="twocolumn"][data-sidebar="gradient-2"] .twocolumn-iconview,
[data-layout="twocolumn"][data-sidebar="gradient-3"] .twocolumn-iconview,
[data-layout="twocolumn"][data-sidebar="gradient-4"] .twocolumn-iconview,
[data-layout="twocolumn"][data-sidebar="gradient"] .twocolumn-iconview {
  background-color: var(--bs-twocolumn-menu-iconview-bg-dark);
}

[data-layout="twocolumn"][data-sidebar="gradient-2"]
  .twocolumn-iconview
  .nav-icon,
[data-layout="twocolumn"][data-sidebar="gradient-3"]
  .twocolumn-iconview
  .nav-icon,
[data-layout="twocolumn"][data-sidebar="gradient-4"]
  .twocolumn-iconview
  .nav-icon,
[data-layout="twocolumn"][data-sidebar="gradient"]
  .twocolumn-iconview
  .nav-icon {
  color: rgba(255, 255, 255, 0.6);
}

[data-layout="twocolumn"][data-sidebar="gradient-2"]
  .twocolumn-iconview
  .nav-icon.active,
[data-layout="twocolumn"][data-sidebar="gradient-3"]
  .twocolumn-iconview
  .nav-icon.active,
[data-layout="twocolumn"][data-sidebar="gradient-4"]
  .twocolumn-iconview
  .nav-icon.active,
[data-layout="twocolumn"][data-sidebar="gradient"]
  .twocolumn-iconview
  .nav-icon.active {
  color: var(--bs-twocolumn-menu-item-active-color-dark);
  background-color: var(--bs-twocolumn-menu-item-active-bg-dark);
}

[data-layout="twocolumn"][data-sidebar="gradient-2"] .app-menu,
[data-layout="twocolumn"][data-sidebar="gradient-3"] .app-menu,
[data-layout="twocolumn"][data-sidebar="gradient-4"] .app-menu,
[data-layout="twocolumn"][data-sidebar="gradient"] .app-menu {
  background-color: var(--bs-twocolumn-menu-bg-dark);
  border-right-color: var(--bs-twocolumn-menu-bg-dark);
}

[data-layout="twocolumn"][data-sidebar="gradient-2"]
  .app-menu
  .navbar-brand-box
  .logo-light,
[data-layout="twocolumn"][data-sidebar="gradient-3"]
  .app-menu
  .navbar-brand-box
  .logo-light,
[data-layout="twocolumn"][data-sidebar="gradient-4"]
  .app-menu
  .navbar-brand-box
  .logo-light,
[data-layout="twocolumn"][data-sidebar="gradient"]
  .app-menu
  .navbar-brand-box
  .logo-light {
  display: block;
}

[data-layout="twocolumn"][data-sidebar="gradient-2"]
  .app-menu
  .navbar-brand-box
  .logo-dark,
[data-layout="twocolumn"][data-sidebar="gradient-3"]
  .app-menu
  .navbar-brand-box
  .logo-dark,
[data-layout="twocolumn"][data-sidebar="gradient-4"]
  .app-menu
  .navbar-brand-box
  .logo-dark,
[data-layout="twocolumn"][data-sidebar="gradient"]
  .app-menu
  .navbar-brand-box
  .logo-dark {
  display: none;
}

[data-layout="twocolumn"][data-sidebar="gradient-2"]
  .app-menu
  .navbar-nav
  .nav-sm
  .nav-link,
[data-layout="twocolumn"][data-sidebar="gradient-3"]
  .app-menu
  .navbar-nav
  .nav-sm
  .nav-link,
[data-layout="twocolumn"][data-sidebar="gradient-4"]
  .app-menu
  .navbar-nav
  .nav-sm
  .nav-link,
[data-layout="twocolumn"][data-sidebar="gradient"]
  .app-menu
  .navbar-nav
  .nav-sm
  .nav-link {
  color: rgba(255, 255, 255, 0.6);
}

[data-layout="twocolumn"][data-sidebar="gradient-2"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link.active,
[data-layout="twocolumn"][data-sidebar="gradient-2"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link:hover,
[data-layout="twocolumn"][data-sidebar="gradient-3"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link.active,
[data-layout="twocolumn"][data-sidebar="gradient-3"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link:hover,
[data-layout="twocolumn"][data-sidebar="gradient-4"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link.active,
[data-layout="twocolumn"][data-sidebar="gradient-4"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link:hover,
[data-layout="twocolumn"][data-sidebar="gradient"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link.active,
[data-layout="twocolumn"][data-sidebar="gradient"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link:hover {
  color: var(--bs-twocolumn-menu-item-active-color-dark);
}

[data-layout="twocolumn"][data-sidebar="gradient-2"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link.active::before,
[data-layout="twocolumn"][data-sidebar="gradient-2"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link:hover::before,
[data-layout="twocolumn"][data-sidebar="gradient-3"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link.active::before,
[data-layout="twocolumn"][data-sidebar="gradient-3"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link:hover::before,
[data-layout="twocolumn"][data-sidebar="gradient-4"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link.active::before,
[data-layout="twocolumn"][data-sidebar="gradient-4"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link:hover::before,
[data-layout="twocolumn"][data-sidebar="gradient"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link.active::before,
[data-layout="twocolumn"][data-sidebar="gradient"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-link:hover::before {
  background-color: var(--bs-twocolumn-menu-item-active-color-dark) !important;
}

[data-layout="twocolumn"][data-sidebar="gradient-2"]
  .navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"],
[data-layout="twocolumn"][data-sidebar="gradient-3"]
  .navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"],
[data-layout="twocolumn"][data-sidebar="gradient-4"]
  .navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"],
[data-layout="twocolumn"][data-sidebar="gradient"]
  .navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"] {
  color: var(--bs-twocolumn-menu-item-active-color-dark);
}

[data-layout="twocolumn"][data-sidebar="gradient-2"]
  .navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:before,
[data-layout="twocolumn"][data-sidebar="gradient-3"]
  .navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:before,
[data-layout="twocolumn"][data-sidebar="gradient-4"]
  .navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:before,
[data-layout="twocolumn"][data-sidebar="gradient"]
  .navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:before {
  background-color: var(--bs-twocolumn-menu-item-active-color-dark);
}

[data-layout="twocolumn"][data-sidebar="gradient-2"]
  .navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]::after,
[data-layout="twocolumn"][data-sidebar="gradient-3"]
  .navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]::after,
[data-layout="twocolumn"][data-sidebar="gradient-4"]
  .navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]::after,
[data-layout="twocolumn"][data-sidebar="gradient"]
  .navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]::after {
  color: var(--bs-twocolumn-menu-item-active-color-dark) !important;
}

[data-layout="twocolumn"][data-sidebar="gradient-2"][data-layout-mode="dark"]
  .app-menu,
[data-layout="twocolumn"][data-sidebar="gradient-3"][data-layout-mode="dark"]
  .app-menu,
[data-layout="twocolumn"][data-sidebar="gradient-4"][data-layout-mode="dark"]
  .app-menu,
[data-layout="twocolumn"][data-sidebar="gradient"][data-layout-mode="dark"]
  .app-menu {
  border-right-color: #495057;
}

[data-layout="twocolumn"] .twocolumn-panel .app-menu {
  width: 0;
  border-right: 0;
}

@media (max-width: 575.98px) {
  [data-layout="twocolumn"] .twocolumn-panel .app-menu {
    display: none;
  }
}

[data-layout="twocolumn"] .twocolumn-panel .navbar-brand-box,
[data-layout="twocolumn"] .twocolumn-panel .navbar-nav {
  display: none;
}

[data-layout="twocolumn"] .twocolumn-panel .main-content {
  margin-left: 70px;
}

[data-layout="twocolumn"] .twocolumn-panel #page-topbar,
[data-layout="twocolumn"] .twocolumn-panel .footer {
  left: 70px;
}

@media (max-width: 575.98px) {
  [data-layout="twocolumn"] .twocolumn-panel .main-content {
    margin-left: 0;
  }

  [data-layout="twocolumn"] .twocolumn-panel #page-topbar,
  [data-layout="twocolumn"] .twocolumn-panel .footer {
    left: 0;
  }
}

@media (max-width: 767.98px) {
  [data-layout="twocolumn"] #page-topbar,
  [data-layout="twocolumn"] .footer {
    left: 70px;
  }
}

@media (max-width: 575.98px) {
  [data-layout="twocolumn"] .main-content {
    margin-left: 0;
  }

  [data-layout="twocolumn"] #page-topbar,
  [data-layout="twocolumn"] .footer {
    left: 0;
  }
}

[data-layout-width="boxed"] body {
  background-color: var(--bs-boxed-body-bg);
}

[data-layout-width="boxed"] #layout-wrapper {
  max-width: 1300px;
  margin: 0 auto;
  box-shadow: var(--bs-box-shadow);
  background-color: var(--bs-body-bg);
}

[data-layout-width="boxed"][data-layout="vertical"] #layout-wrapper {
  min-height: 100vh;
}

[data-layout-width="boxed"] #page-topbar,
[data-layout-width="boxed"] .footer {
  max-width: 1300px;
  margin: 0 auto;
  left: 0 !important;
}

@media (min-width: 768px) {
  [data-layout-width="boxed"][data-sidebar-size="sm-hover"][data-layout="vertical"]
    #layout-wrapper,
  [data-layout-width="boxed"][data-sidebar-size="sm"][data-layout="vertical"]
    #layout-wrapper {
    min-height: 1400px;
  }
}

@media (max-width: 767.98px) {
  [data-layout-width="boxed"][data-sidebar-size="sm-hover"][data-layout="vertical"]
    .main-content,
  [data-layout-width="boxed"][data-sidebar-size="sm"][data-layout="vertical"]
    .main-content {
    margin-left: 0;
  }
}

[data-layout-width="boxed"][data-sidebar-size="sm-hover"] #page-topbar,
[data-layout-width="boxed"][data-sidebar-size="sm-hover"] .footer,
[data-layout-width="boxed"][data-sidebar-size="sm"] #page-topbar,
[data-layout-width="boxed"][data-sidebar-size="sm"] .footer {
  left: 0 !important;
  max-width: calc(1300px - 70px);
}

@media (min-width: 768px) {
  [data-layout-width="boxed"][data-sidebar-size="sm-hover"] #page-topbar,
  [data-layout-width="boxed"][data-sidebar-size="sm-hover"] .footer,
  [data-layout-width="boxed"][data-sidebar-size="sm"] #page-topbar,
  [data-layout-width="boxed"][data-sidebar-size="sm"] .footer {
    left: 70px !important;
  }
}

[data-layout-width="boxed"][data-sidebar-size="lg"] #page-topbar,
[data-layout-width="boxed"][data-sidebar-size="lg"] .footer,
[data-layout-width="boxed"][data-sidebar-size="sm-hover-active"] #page-topbar,
[data-layout-width="boxed"][data-sidebar-size="sm-hover-active"] .footer {
  max-width: calc(1300px - 250px);
}

@media (min-width: 768px) {
  [data-layout-width="boxed"][data-sidebar-size="lg"] #page-topbar,
  [data-layout-width="boxed"][data-sidebar-size="lg"] .footer,
  [data-layout-width="boxed"][data-sidebar-size="sm-hover-active"] #page-topbar,
  [data-layout-width="boxed"][data-sidebar-size="sm-hover-active"] .footer {
    left: 250px !important;
  }
}

[data-layout-width="boxed"][data-sidebar-size="md"] #page-topbar,
[data-layout-width="boxed"][data-sidebar-size="md"] .footer {
  max-width: calc(1300px - 180px);
}

@media (min-width: 768px) {
  [data-layout-width="boxed"][data-sidebar-size="md"] #page-topbar,
  [data-layout-width="boxed"][data-sidebar-size="md"] .footer {
    left: 180px !important;
  }
}

[data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"]
  body {
  background-color: var(--bs-body-bg);
}

@media (min-width: 1024.1px) {
  [data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"]
    #layout-wrapper {
    max-width: 1300px;
    box-shadow: none;
  }

  [data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"]
    .layout-width {
    max-width: 1300px;
  }
}

[data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="lg"]
  #page-topbar,
[data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="lg"]
  .footer,
[data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="md"]
  #page-topbar,
[data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="md"]
  .footer,
[data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm-hover"]
  #page-topbar,
[data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm-hover"]
  .footer,
[data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm"]
  #page-topbar,
[data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm"]
  .footer {
  max-width: 100%;
  left: 0 !important;
}

[data-layout="horizontal"][data-layout-width="boxed"] #layout-wrapper,
[data-layout="horizontal"][data-layout-width="boxed"] #page-topbar,
[data-layout="horizontal"][data-layout-width="boxed"] .footer {
  max-width: 100%;
}

[data-layout="horizontal"][data-layout-width="boxed"] .container-fluid,
[data-layout="horizontal"][data-layout-width="boxed"] .navbar-header {
  max-width: 1300px;
}

[data-layout="horizontal"][data-layout-width="boxed"] .navbar-header {
  padding: 0 calc(1.5rem / 2) 0 0;
}

[data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="lg"]
  #page-topbar,
[data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="lg"]
  .footer,
[data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="sm-hover"]
  #page-topbar,
[data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="sm-hover"]
  .footer,
[data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="sm"]
  [data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="sm-hover-active"]
  #page-topbar,
[data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="sm"]
  [data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="sm-hover-active"]
  .footer {
  left: 0 !important;
}

@media (min-width: 992px) {
  [data-layout-position="scrollable"] #page-topbar,
  [data-layout-position="scrollable"] .navbar-menu {
    position: absolute;
  }
}

@media (min-width: 992px) {
  [data-layout-position="scrollable"][data-layout="horizontal"] #page-topbar,
  [data-layout-position="scrollable"][data-layout="horizontal"] .topnav {
    position: absolute;
  }
}

/*!
 * Waves v0.7.6
 * http://fian.my.id/Waves 
 * 
 * Copyright 2014-2018 Alfiana E. Sibuea and other contributors 
 * Released under the MIT license 
 * https://github.com/fians/Waves/blob/master/LICENSE */

.waves-effect {
  position: relative;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  -webkit-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.waves-effect .waves-ripple {
  position: absolute;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin-top: -50px;
  margin-left: -50px;
  opacity: 0;
  background: rgba(0, 0, 0, 0.2);
  background: radial-gradient(
    rgba(0, 0, 0, 0.2) 0,
    rgba(0, 0, 0, 0.3) 40%,
    rgba(0, 0, 0, 0.4) 50%,
    rgba(0, 0, 0, 0.5) 60%,
    rgba(255, 255, 255, 0) 70%
  );
  transition: all 0.5s ease-out;
  transition-property: transform, opacity;
  transform: scale(0) translate(0, 0);
  pointer-events: none;
}

.waves-effect.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
  background: radial-gradient(
    rgba(255, 255, 255, 0.2) 0,
    rgba(255, 255, 255, 0.3) 40%,
    rgba(255, 255, 255, 0.4) 50%,
    rgba(255, 255, 255, 0.5) 60%,
    rgba(255, 255, 255, 0) 70%
  );
}

.waves-effect.waves-classic .waves-ripple {
  background: rgba(0, 0, 0, 0.2);
}

.waves-effect.waves-classic.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
}

.waves-notransition {
  transition: none !important;
}

.waves-button,
.waves-circle {
  transform: translateZ(0);
  -webkit-mask-image: -webkit-radial-gradient(circle, #fff 100%, #000 100%);
}

.waves-button,
.waves-button-input,
.waves-button:hover,
.waves-button:visited {
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  border: none;
  outline: 0;
  color: inherit;
  background-color: rgba(0, 0, 0, 0);
  font-size: 1em;
  line-height: 1em;
  text-align: center;
  text-decoration: none;
  z-index: 1;
}

.waves-button {
  padding: 0.85em 1.1em;
  border-radius: 0.2em;
}

.waves-button-input {
  margin: 0;
  padding: 0.85em 1.1em;
}

.waves-input-wrapper {
  border-radius: 0.2em;
  vertical-align: bottom;
}

.waves-input-wrapper.waves-button {
  padding: 0;
}

.waves-input-wrapper .waves-button-input {
  position: relative;
  top: 0;
  left: 0;
  z-index: 1;
}

.waves-circle {
  text-align: center;
  width: 2.5em;
  height: 2.5em;
  line-height: 2.5em;
  border-radius: 50%;
}

.waves-float {
  -webkit-mask-image: none;
  box-shadow: 0 1px 1.5px 1px rgba(0, 0, 0, 0.12);
  transition: all 0.3s;
}

.waves-float:active {
  box-shadow: 0 8px 20px 1px rgba(0, 0, 0, 0.3);
}

.waves-block {
  display: block;
}

.waves-effect.waves-light .waves-ripple {
  background-color: rgba(255, 255, 255, 0.4);
}

.waves-effect.waves-primary .waves-ripple {
  background-color: rgba(75, 56, 179, 0.4);
}

.waves-effect.waves-success .waves-ripple {
  background-color: rgba(69, 203, 133, 0.4);
}

.waves-effect.waves-info .waves-ripple {
  background-color: rgba(41, 156, 219, 0.4);
}

.waves-effect.waves-warning .waves-ripple {
  background-color: rgba(255, 190, 11, 0.4);
}

.waves-effect.waves-danger .waves-ripple {
  background-color: rgba(240, 101, 72, 0.4);
}

.avatar-xxs {
  height: 1.5rem;
  width: 1.5rem;
}

.avatar-xs {
  height: 2rem;
  width: 2rem;
}

.avatar-sm {
  height: 3rem;
  width: 3rem;
}

.avatar-md {
  height: 4.5rem;
  width: 4.5rem;
}

.avatar-lg {
  height: 6rem;
  width: 6rem;
}

.avatar-xl {
  height: 9.5rem;
  width: 9.5rem;
  border-radius: 0.375rem !important;
  box-shadow: none !important;
}

.profile-img {
  height: 50px;
  width: 50px;
}

.avatar-title {
  align-items: center;
  background-color: #4b38b3;
  color: #fff;
  display: flex;
  font-weight: 500;
  height: 100%;
  justify-content: center;
  width: 100%;
}

.avatar-group {
  padding-left: 12px;
  display: flex;
  flex-wrap: wrap;
}

.avatar-group .avatar-group-item {
  margin-left: -12px;
  border: 2px solid var(--bs-card-bg-custom);
  border-radius: 50%;
  transition: all 0.2s;
}

.avatar-group .avatar-group-item:hover {
  position: relative;
  transform: translateY(-2px);
  z-index: 1;
}

.accordion .accordion-button {
  font-weight: 500;
}

.accordion .accordion-body {
  color: #878a99;
}

.accordion.accordion-icon-none .accordion-button::after {
  content: "";
  background-image: none !important;
}

.accordion.accordion-icon-none .accordion-button:not(.collapsed)::after {
  content: "";
}

.custom-accordionwithicon .accordion-button::after {
  background-image: none !important;
  font-family: "Material Design Icons";
  content: "\\f0142";
  font-size: 1.1rem;
  vertical-align: middle;
  line-height: 0.8;
}

.custom-accordionwithicon .accordion-button:not(.collapsed)::after {
  background-image: none !important;
  content: "\\f0140";
  margin-right: -3px;
}

.custom-accordionwithicon-plus .accordion-button::after {
  background-image: none !important;
  font-family: "Material Design Icons";
  content: "\\f0415";
  font-size: 1.1rem;
  vertical-align: middle;
  line-height: 0.8;
}

.custom-accordionwithicon-plus .accordion-button:not(.collapsed)::after {
  background-image: none !important;
  content: "\\f0374";
  margin-right: -3px;
}

.lefticon-accordion .accordion-button {
  padding-left: 2.75rem;
}

.lefticon-accordion .accordion-button::after {
  position: absolute;
  left: 1.25rem;
  top: 14px;
}

.lefticon-accordion .accordion-button:not(.collapsed)::after {
  top: 20px;
}

.accordion-border-box .accordion-item {
  border-top: 1px solid var(--bs-border-color);
  border-radius: 0.25rem;
}

.accordion-border-box .accordion-item:not(:first-of-type) {
  margin-top: 8px;
}

.accordion-border-box .accordion-item .accordion-button {
  border-radius: 0.25rem;
}

.accordion-border-box .accordion-item .accordion-button:not(.collapsed) {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.custom-accordion-border .accordion-item {
  border-left: 3px solid var(--bs-border-color);
}

.accordion-primary .accordion-item {
  border-color: rgba(75, 56, 179, 0.6);
}

.accordion-primary .accordion-item .accordion-button {
  box-shadow: none;
}

.accordion-primary .accordion-item .accordion-button:not(.collapsed) {
  color: #4b38b3;
  background-color: rgba(75, 56, 179, 0.1) !important;
}

.accordion-primary .accordion-item .accordion-button::after {
  color: #4b38b3;
}

.accordion-fill-primary .accordion-item .accordion-button {
  box-shadow: none;
}

.accordion-fill-primary .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #4b38b3 !important;
}

.accordion-secondary .accordion-item {
  border-color: rgba(53, 119, 241, 0.6);
}

.accordion-secondary .accordion-item .accordion-button {
  box-shadow: none;
}

.accordion-secondary .accordion-item .accordion-button:not(.collapsed) {
  color: #3577f1;
  background-color: rgba(53, 119, 241, 0.1) !important;
}

.accordion-secondary .accordion-item .accordion-button::after {
  color: #3577f1;
}

.accordion-fill-secondary .accordion-item .accordion-button {
  box-shadow: none;
}

.accordion-fill-secondary .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #3577f1 !important;
}

.accordion-success .accordion-item {
  border-color: rgba(69, 203, 133, 0.6);
}

.accordion-success .accordion-item .accordion-button {
  box-shadow: none;
}

.accordion-success .accordion-item .accordion-button:not(.collapsed) {
  color: #45cb85;
  background-color: rgba(69, 203, 133, 0.1) !important;
}

.accordion-success .accordion-item .accordion-button::after {
  color: #45cb85;
}

.accordion-fill-success .accordion-item .accordion-button {
  box-shadow: none;
}

.accordion-fill-success .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #45cb85 !important;
}

.accordion-info .accordion-item {
  border-color: rgba(41, 156, 219, 0.6);
}

.accordion-info .accordion-item .accordion-button {
  box-shadow: none;
}

.accordion-info .accordion-item .accordion-button:not(.collapsed) {
  color: #299cdb;
  background-color: rgba(41, 156, 219, 0.1) !important;
}

.accordion-info .accordion-item .accordion-button::after {
  color: #299cdb;
}

.accordion-fill-info .accordion-item .accordion-button {
  box-shadow: none;
}

.accordion-fill-info .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #299cdb !important;
}

.accordion-warning .accordion-item {
  border-color: rgba(255, 190, 11, 0.6);
}

.accordion-warning .accordion-item .accordion-button {
  box-shadow: none;
}

.accordion-warning .accordion-item .accordion-button:not(.collapsed) {
  color: #ffbe0b;
  background-color: rgba(255, 190, 11, 0.1) !important;
}

.accordion-warning .accordion-item .accordion-button::after {
  color: #ffbe0b;
}

.accordion-fill-warning .accordion-item .accordion-button {
  box-shadow: none;
}

.accordion-fill-warning .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #ffbe0b !important;
}

.accordion-danger .accordion-item {
  border-color: rgba(240, 101, 72, 0.6);
}

.accordion-danger .accordion-item .accordion-button {
  box-shadow: none;
}

.accordion-danger .accordion-item .accordion-button:not(.collapsed) {
  color: #f06548;
  background-color: rgba(240, 101, 72, 0.1) !important;
}

.accordion-danger .accordion-item .accordion-button::after {
  color: #f06548;
}

.accordion-fill-danger .accordion-item .accordion-button {
  box-shadow: none;
}

.accordion-fill-danger .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #f06548 !important;
}

.accordion-light .accordion-item {
  border-color: rgba(243, 246, 249, 0.6);
}

.accordion-light .accordion-item .accordion-button {
  box-shadow: none;
}

.accordion-light .accordion-item .accordion-button:not(.collapsed) {
  color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.1) !important;
}

.accordion-light .accordion-item .accordion-button::after {
  color: #f3f6f9;
}

.accordion-fill-light .accordion-item .accordion-button {
  box-shadow: none;
}

.accordion-fill-light .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #f3f6f9 !important;
}

.accordion-dark .accordion-item {
  border-color: rgba(33, 37, 41, 0.6);
}

.accordion-dark .accordion-item .accordion-button {
  box-shadow: none;
}

.accordion-dark .accordion-item .accordion-button:not(.collapsed) {
  color: #212529;
  background-color: rgba(33, 37, 41, 0.1) !important;
}

.accordion-dark .accordion-item .accordion-button::after {
  color: #212529;
}

.accordion-fill-dark .accordion-item .accordion-button {
  box-shadow: none;
}

.accordion-fill-dark .accordion-item .accordion-button:not(.collapsed) {
  color: #fff;
  background-color: #212529 !important;
}

[data-layout-mode="dark"] .accordion-button:not(.collapsed) {
  color: var(--bs-accordion-button-active-color);
}

[data-layout-mode="dark"] .accordion-button:not(.collapsed):after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

[data-layout-mode="dark"] .accordion-button:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
}

[dir="rtl"] .custom-accordionwithicon .accordion-button::after {
  transform: rotate(180deg);
}

.fs-10 {
  font-size: 10px !important;
}

.fs-11 {
  font-size: 11px !important;
}

.fs-12 {
  font-size: 12px !important;
}

.fs-13 {
  font-size: 13px !important;
}

.fs-14 {
  font-size: 14px !important;
}

.fs-15 {
  font-size: 15px !important;
}

.fs-16 {
  font-size: 16px !important;
}

.fs-17 {
  font-size: 17px !important;
}

.fs-18 {
  font-size: 18px !important;
}

.fs-19 {
  font-size: 19px !important;
}

.fs-20 {
  font-size: 20px !important;
}

.fs-21 {
  font-size: 21px !important;
}

.fs-22 {
  font-size: 22px !important;
}

.fs-23 {
  font-size: 23px !important;
}

.fs-24 {
  font-size: 24px !important;
}

.fs-36 {
  font-size: 36px !important;
}

.fs-48 {
  font-size: 48px !important;
}

.border-dark {
  border-color: var(--bs-dark) !important;
}

.border-light {
  border-color: var(--bs-light) !important;
}

.border-double {
  border-style: double !important;
}

.border-top-double {
  border-top-style: double !important;
}

.border-bottom-double {
  border-bottom-style: double !important;
}

.border-end-double {
  border-right-style: double !important;
}

.border-start-double {
  border-left-style: double !important;
}

.list-group-flush.border-double {
  border: none !important;
}

.list-group-flush.border-double .list-group-item {
  border-style: double !important;
}

.border-dashed {
  border-style: dashed !important;
}

.border-top-dashed {
  border-top-style: dashed !important;
}

.border-bottom-dashed {
  border-bottom-style: dashed !important;
}

.border-end-dashed {
  border-right-style: dashed !important;
}

.border-start-dashed {
  border-left-style: dashed !important;
}

.list-group-flush.border-dashed {
  border: none !important;
}

.list-group-flush.border-dashed .list-group-item {
  border-style: dashed !important;
}

.border-groove {
  border-style: groove !important;
}

.border-top-groove {
  border-top-style: groove !important;
}

.border-bottom-groove {
  border-bottom-style: groove !important;
}

.border-end-groove {
  border-right-style: groove !important;
}

.border-start-groove {
  border-left-style: groove !important;
}

.list-group-flush.border-groove {
  border: none !important;
}

.list-group-flush.border-groove .list-group-item {
  border-style: groove !important;
}

.border-outset {
  border-style: outset !important;
}

.border-top-outset {
  border-top-style: outset !important;
}

.border-bottom-outset {
  border-bottom-style: outset !important;
}

.border-end-outset {
  border-right-style: outset !important;
}

.border-start-outset {
  border-left-style: outset !important;
}

.list-group-flush.border-outset {
  border: none !important;
}

.list-group-flush.border-outset .list-group-item {
  border-style: outset !important;
}

.border-ridge {
  border-style: ridge !important;
}

.border-top-ridge {
  border-top-style: ridge !important;
}

.border-bottom-ridge {
  border-bottom-style: ridge !important;
}

.border-end-ridge {
  border-right-style: ridge !important;
}

.border-start-ridge {
  border-left-style: ridge !important;
}

.list-group-flush.border-ridge {
  border: none !important;
}

.list-group-flush.border-ridge .list-group-item {
  border-style: ridge !important;
}

.border-dotted {
  border-style: dotted !important;
}

.border-top-dotted {
  border-top-style: dotted !important;
}

.border-bottom-dotted {
  border-bottom-style: dotted !important;
}

.border-end-dotted {
  border-right-style: dotted !important;
}

.border-start-dotted {
  border-left-style: dotted !important;
}

.list-group-flush.border-dotted {
  border: none !important;
}

.list-group-flush.border-dotted .list-group-item {
  border-style: dotted !important;
}

.border-inset {
  border-style: inset !important;
}

.border-top-inset {
  border-top-style: inset !important;
}

.border-bottom-inset {
  border-bottom-style: inset !important;
}

.border-end-inset {
  border-right-style: inset !important;
}

.border-start-inset {
  border-left-style: inset !important;
}

.list-group-flush.border-inset {
  border: none !important;
}

.list-group-flush.border-inset .list-group-item {
  border-style: inset !important;
}

[data-layout-mode="dark"] .link-dark,
[data-layout-mode="dark"] .link-light {
  color: var(--bs-dark) !important;
}

[data-layout-mode="dark"] .link-dark:focus,
[data-layout-mode="dark"] .link-dark:hover,
[data-layout-mode="dark"] .link-light:focus,
[data-layout-mode="dark"] .link-light:hover {
  color: rgba(var(--bs-dark-rgb), 0.75) !important;
}

.ff-base {
  font-family: var(--bs-font-sans-serif);
}

.ff-secondary {
  font-family: Inter, sans-serif;
}

.fw-medium {
  font-weight: 500;
}

.flex-1 {
  flex: 1 1;
}

.social-list-item {
  height: 2rem;
  width: 2rem;
  line-height: calc(2rem - 4px);
  display: block;
  border: 2px solid #adb5bd;
  border-radius: 50%;
  color: #adb5bd;
  text-align: center;
  transition: all 0.4s;
}

.social-list-item:hover {
  color: #878a99;
  background-color: #eff2f7;
}

/* .bg-pattern {
    background: url(../images/modal-bg.png) #fff
} */

.w-xs {
  min-width: 80px;
}

.w-sm {
  min-width: 95px;
}

.w-md {
  min-width: 110px;
}

.w-lg {
  min-width: 140px;
}

.w-xl {
  min-width: 160px;
}

.icon-xs {
  height: 16px;
  width: 16px;
}

.icon-sm {
  height: 18px;
  width: 18px;
}

.icon-md {
  height: 22px;
  width: 22px;
}

.icon-lg {
  height: 24px;
  width: 24px;
}

.icon-xl {
  height: 28px;
  width: 28px;
}

.icon-xxl {
  height: 32px;
  width: 32px;
}

.icon-dual {
  color: #adb5bd;
  fill: rgba(173, 181, 189, 0.16);
}

.icon-dual-primary {
  color: #4b38b3;
  fill: rgba(75, 56, 179, 0.16);
}

.icon-dual-secondary {
  color: #3577f1;
  fill: rgba(53, 119, 241, 0.16);
}

.icon-dual-success {
  color: #45cb85;
  fill: rgba(69, 203, 133, 0.16);
}

.icon-dual-info {
  color: #299cdb;
  fill: rgba(41, 156, 219, 0.16);
}

.icon-dual-warning {
  color: #ffbe0b;
  fill: rgba(255, 190, 11, 0.16);
}

.icon-dual-danger {
  color: #f06548;
  fill: rgba(240, 101, 72, 0.16);
}

.icon-dual-light {
  color: #f3f6f9;
  fill: rgba(243, 246, 249, 0.16);
}

.icon-dual-dark {
  color: #212529;
  fill: rgba(33, 37, 41, 0.16);
}

.search-box {
  position: relative;
}

.search-box .form-control {
  padding-left: 40px;
}

.search-box .search-icon {
  font-size: 14px;
  position: absolute;
  left: 13px;
  top: 0;
  height: 100%;
  display: flex;
  align-items: center;
  color: #878a99;
}

.bg-overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
  opacity: 0.7;
  background-color: #000;
}

.customizer-setting {
  position: fixed;
  bottom: 40px;
  right: 20px;
  z-index: 1000;
}

code {
  -webkit-user-select: all;
  user-select: all;
}

.layout-rightside {
  width: 280px;
  margin-right: -1.5rem;
  margin-top: calc(1px - 1.5rem * 1.1);
  height: calc(100% + 1.5rem * 1.1);
}

@media (max-width: 1699.98px) {
  .layout-rightside-col {
    display: none;
    position: fixed !important;
    height: 100vh;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1004;
  }

  .layout-rightside-col .overlay {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(33, 37, 41, 0.2);
  }

  .layout-rightside-col .layout-rightside {
    margin-top: 0;
    height: 100%;
    margin-left: auto;
  }

  .layout-rightside-col .card-body {
    overflow-y: auto;
    padding-bottom: 1rem !important;
  }
}

@media (min-width: 1700px) {
  [data-layout-style="detached"] .layout-rightside,
  [data-layout="horizontal"] .layout-rightside {
    margin-top: calc(28px - 1.5rem);
    margin-right: 0;
    height: calc(100% - (1.5rem / 5));
  }
}

.object-cover {
  object-fit: cover;
}

.text-truncate-two-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  white-space: normal;
}

.favourite-btn {
  border-color: transparent;
}

.favourite-btn .ri-star-fill {
  color: #878a99;
}

.favourite-btn.active {
  border-color: transparent;
}

.favourite-btn.active .ri-star-fill {
  color: #ffbe0b;
}

.favourite-btn.active .ri-star-fill:before {
  content: "\\f186";
}

.card-logo-light {
  display: var(--bs-card-logo-light);
}

.card-logo-dark {
  display: var(--bs-card-logo-dark);
}

[data-layout-mode="dark"] .btn-close {
  filter: invert(1) grayscale(100%) brightness(200%);
}

#back-to-top {
  position: fixed;
  bottom: 100px;
  right: 28px;
  transition: all 0.5s ease;
  display: none;
  z-index: 1000;
}

#back-to-top:hover {
  animation: fade-up 1.5s infinite linear;
}

@keyframes fade-up {
  0% {
    transform: translateY(0);
    opacity: 1;
  }

  75% {
    transform: translateY(-20px);
    opacity: 0;
  }
}

.cursor-pointer {
  cursor: pointer;
}

#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--bs-card-bg-custom);
  z-index: 9999;
}

[data-preloader="disable"] #preloader {
  opacity: 0;
  visibility: hidden;
}

#status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}

[type="email"]::placeholder,
[type="number"]::placeholder,
[type="tel"]::placeholder,
[type="url"]::placeholder {
  text-align: left;
}

.main-chart .chart-border-left {
  border-left: 1.4px solid var(--bs-border-color);
  padding: 2px 20px;
}

.main-chart .chart-border-left:last-child {
  margin-right: 0;
}

.activity-feed {
  list-style: none;
}

.activity-feed .feed-item {
  position: relative;
  padding-bottom: 27px;
  padding-left: 16px;
  border-left: 2px solid #f3f6f9;
}

.activity-feed .feed-item:after {
  content: "";
  display: block;
  position: absolute;
  top: 4px;
  left: -6px;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  border: 2px solid #4b38b3;
  background-color: #fff;
}

.activity-feed .feed-item:last-child {
  border-color: transparent;
}

.mini-stats-wid {
  position: relative;
}

.mini-stats-wid .mini-stat-icon {
  overflow: hidden;
  position: relative;
}

.mini-stats-wid .mini-stat-icon:after,
.mini-stats-wid .mini-stat-icon:before {
  content: "";
  position: absolute;
  width: 8px;
  height: 69px;
  background-color: rgba(69, 203, 133, 0.1);
  left: 3px;
  transform: rotate(32deg);
  top: -8px;
  transition: all 0.4s;
}

.mini-stats-wid .mini-stat-icon::after {
  left: 27px;
  width: 8px;
  transition: all 0.2s;
}

.mini-stats-wid:hover .mini-stat-icon::after {
  left: 60px;
}

.mini-stats-wid:hover .mini-stat-icon::before {
  left: 50px;
}

.button-items {
  margin-left: -8px;
  margin-bottom: -12px;
}

.button-items .btn {
  margin-bottom: 12px;
  margin-left: 8px;
}

.bs-example-modal {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  z-index: 1;
  display: block;
}

[dir="rtl"] .modal-open {
  padding-left: 0 !important;
}

.icon-demo-content {
  color: var(--bs-gray-500);
}

.icon-demo-content i {
  font-size: 24px;
  margin-right: 10px;
  color: var(--bs-gray-600);
  transition: all 0.4s;
  vertical-align: middle;
}

.icon-demo-content svg {
  margin-right: 10px;
  transition: all 0.4s;
  height: 20px;
}

.icon-demo-content .col-lg-4 {
  margin-top: 24px;
}

.icon-demo-content .col-lg-4:hover i,
.icon-demo-content .col-lg-4:hover svg {
  color: #4b38b3;
  transform: scale(1.5);
}

.grid-structure .grid-container {
  background-color: #f3f6f9;
  margin-top: 10px;
  font-size: 0.8rem;
  font-weight: 500;
  padding: 10px 20px;
}

.img-switch .card-radio .form-check-input {
  display: none;
}

.img-switch .card-radio .form-check-input:checked + .form-check-label::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(75, 56, 179, 0.5);
}

.img-switch .card-radio .form-check-input:checked + .form-check-label::after {
  content: "\\eb80";
  font-family: remixicon;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  font-size: 18px;
  color: #fff;
}

[data-bs-target="#collapseBgGradient"].active {
  border-color: #4b38b3 !important;
}

[data-bs-target="#collapseBgGradient"].active::before {
  content: "\\eb80";
  font-family: remixicon;
  position: absolute;
  top: 2px;
  right: 6px;
  font-size: 16px;
  color: #4b38b3;
}

[data-layout-mode="dark"] .colorscheme-cardradio .form-check-label {
  background-color: var(--bs-dark);
}

[data-layout-mode="dark"] .colorscheme-cardradio .bg-light {
  background-color: rgb(120 123 137) !important;
}

[data-layout-mode="dark"] .colorscheme-cardradio .bg-soft-light {
  background-color: rgba(var(--bs-dark-rgb), 0.1) !important;
}

[data-layout-mode="dark"] .colorscheme-cardradio .dark .bg-dark {
  background-color: var(--bs-card-bg-custom) !important;
}

@media print {
  #back-to-top,
  .app-menu,
  .footer,
  .navbar-header,
  .page-title-box,
  .right-bar,
  .vertical-menu {
    display: none !important;
  }

  .card-body,
  .main-content,
  .page-content,
  .right-bar,
  body {
    padding: 0;
    margin: 0;
  }

  .card {
    border: 0;
    box-shadow: none !important;
  }

  .invoice-details .d-sm-flex {
    display: flex !important;
  }

  .address.col-sm-6 {
    flex: 0 0 auto !important;
    width: 50% !important;
    max-width: 100% !important;
  }
}

.ribbon-box {
  position: relative;
}

.ribbon-box .ribbon {
  padding: 5px 12px;
  box-shadow: 2px 5px 10px rgba(33, 37, 41, 0.15);
  color: #fff;
  font-size: 0.8125rem;
  font-weight: 600;
  position: absolute;
  left: -1px;
  top: 5px;
}

.ribbon-box .ribbon.round-shape {
  border-radius: 0 30px 30px 0;
}

.ribbon-box .ribbon.ribbon-shape {
  display: inline-block;
}

.ribbon-box .ribbon.ribbon-shape::before {
  content: "";
  position: absolute;
  right: -17px;
  top: 0;
  border: 14px solid transparent;
}

.ribbon-box .ribbon.ribbon-shape::after {
  content: "";
  position: absolute;
  right: -17px;
  bottom: 0;
  border: 14px solid transparent;
}

.ribbon-box.ribbon-circle .ribbon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 20px;
  top: 20px;
}

.ribbon-box.ribbon-fill {
  overflow: hidden;
}

.ribbon-box.ribbon-fill .ribbon {
  transform: rotate(-45deg);
  width: 93px;
  height: 52px;
  left: -36px;
  top: -16px;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}

.ribbon-box.ribbon-fill.ribbon-sm .ribbon {
  padding: 2px 12px;
  width: 78px;
  height: 42px;
  font-size: 12px;
  box-shadow: none;
}

.ribbon-box.right .ribbon {
  position: absolute;
  left: auto;
  right: 0;
}

.ribbon-box.right .ribbon.round-shape {
  border-radius: 30px 0 0 30px;
}

.ribbon-box.right .ribbon.ribbon-shape {
  text-align: right;
}

.ribbon-box.right .ribbon.ribbon-shape::after,
.ribbon-box.right .ribbon.ribbon-shape::before {
  right: auto;
  left: -17px;
  border-left-color: transparent;
}

.ribbon-box.right.ribbon-circle .ribbon {
  left: auto;
  right: 20px;
}

.ribbon-box.right .icon-ribbon {
  right: 24px;
  left: auto;
}

.ribbon-box.right.ribbon-fill .ribbon {
  transform: rotate(45deg);
  right: -38px;
  left: auto;
}

.ribbon-box.right.ribbon-box .ribbon-two {
  left: auto;
  right: -5px;
}

.ribbon-box.right.ribbon-box .ribbon-two span {
  left: auto;
  right: -21px;
  transform: rotate(45deg);
}

.ribbon-box .ribbon-content {
  clear: both;
}

.ribbon-box .ribbon-primary {
  background: #4b38b3;
}

.ribbon-box .ribbon-primary:before {
  border-color: #3b2c8c transparent transparent;
}

.ribbon-box .ribbon-primary.ribbon-shape::before {
  border-left-color: #4b38b3;
  border-top-color: #4b38b3;
}

.ribbon-box .ribbon-primary.ribbon-shape::after {
  border-left-color: #4b38b3;
  border-bottom-color: #4b38b3;
}

.ribbon-box.right .ribbon-primary {
  background: #4b38b3;
}

.ribbon-box.right .ribbon-primary.ribbon-shape::before {
  border-right-color: #4b38b3;
  border-top-color: #4b38b3;
}

.ribbon-box.right .ribbon-primary.ribbon-shape::after {
  border-right-color: #4b38b3;
  border-bottom-color: #4b38b3;
}

.ribbon-box .ribbon-secondary {
  background: #3577f1;
}

.ribbon-box .ribbon-secondary:before {
  border-color: #105ae3 transparent transparent;
}

.ribbon-box .ribbon-secondary.ribbon-shape::before {
  border-left-color: #3577f1;
  border-top-color: #3577f1;
}

.ribbon-box .ribbon-secondary.ribbon-shape::after {
  border-left-color: #3577f1;
  border-bottom-color: #3577f1;
}

.ribbon-box.right .ribbon-secondary {
  background: #3577f1;
}

.ribbon-box.right .ribbon-secondary.ribbon-shape::before {
  border-right-color: #3577f1;
  border-top-color: #3577f1;
}

.ribbon-box.right .ribbon-secondary.ribbon-shape::after {
  border-right-color: #3577f1;
  border-bottom-color: #3577f1;
}

.ribbon-box .ribbon-success {
  background: #45cb85;
}

.ribbon-box .ribbon-success:before {
  border-color: #30ad6c transparent transparent;
}

.ribbon-box .ribbon-success.ribbon-shape::before {
  border-left-color: #45cb85;
  border-top-color: #45cb85;
}

.ribbon-box .ribbon-success.ribbon-shape::after {
  border-left-color: #45cb85;
  border-bottom-color: #45cb85;
}

.ribbon-box.right .ribbon-success {
  background: #45cb85;
}

.ribbon-box.right .ribbon-success.ribbon-shape::before {
  border-right-color: #45cb85;
  border-top-color: #45cb85;
}

.ribbon-box.right .ribbon-success.ribbon-shape::after {
  border-right-color: #45cb85;
  border-bottom-color: #45cb85;
}

.ribbon-box .ribbon-info {
  background: #299cdb;
}

.ribbon-box .ribbon-info:before {
  border-color: #1e7eb3 transparent transparent;
}

.ribbon-box .ribbon-info.ribbon-shape::before {
  border-left-color: #299cdb;
  border-top-color: #299cdb;
}

.ribbon-box .ribbon-info.ribbon-shape::after {
  border-left-color: #299cdb;
  border-bottom-color: #299cdb;
}

.ribbon-box.right .ribbon-info {
  background: #299cdb;
}

.ribbon-box.right .ribbon-info.ribbon-shape::before {
  border-right-color: #299cdb;
  border-top-color: #299cdb;
}

.ribbon-box.right .ribbon-info.ribbon-shape::after {
  border-right-color: #299cdb;
  border-bottom-color: #299cdb;
}

.ribbon-box .ribbon-warning {
  background: #ffbe0b;
}

.ribbon-box .ribbon-warning:before {
  border-color: #d79e00 transparent transparent;
}

.ribbon-box .ribbon-warning.ribbon-shape::before {
  border-left-color: #ffbe0b;
  border-top-color: #ffbe0b;
}

.ribbon-box .ribbon-warning.ribbon-shape::after {
  border-left-color: #ffbe0b;
  border-bottom-color: #ffbe0b;
}

.ribbon-box.right .ribbon-warning {
  background: #ffbe0b;
}

.ribbon-box.right .ribbon-warning.ribbon-shape::before {
  border-right-color: #ffbe0b;
  border-top-color: #ffbe0b;
}

.ribbon-box.right .ribbon-warning.ribbon-shape::after {
  border-right-color: #ffbe0b;
  border-bottom-color: #ffbe0b;
}

.ribbon-box .ribbon-danger {
  background: #f06548;
}

.ribbon-box .ribbon-danger:before {
  border-color: #ec3d19 transparent transparent;
}

.ribbon-box .ribbon-danger.ribbon-shape::before {
  border-left-color: #f06548;
  border-top-color: #f06548;
}

.ribbon-box .ribbon-danger.ribbon-shape::after {
  border-left-color: #f06548;
  border-bottom-color: #f06548;
}

.ribbon-box.right .ribbon-danger {
  background: #f06548;
}

.ribbon-box.right .ribbon-danger.ribbon-shape::before {
  border-right-color: #f06548;
  border-top-color: #f06548;
}

.ribbon-box.right .ribbon-danger.ribbon-shape::after {
  border-right-color: #f06548;
  border-bottom-color: #f06548;
}

.ribbon-box .ribbon-light {
  background: #f3f6f9;
}

.ribbon-box .ribbon-light:before {
  border-color: #d1dde8 transparent transparent;
}

.ribbon-box .ribbon-light.ribbon-shape::before {
  border-left-color: #f3f6f9;
  border-top-color: #f3f6f9;
}

.ribbon-box .ribbon-light.ribbon-shape::after {
  border-left-color: #f3f6f9;
  border-bottom-color: #f3f6f9;
}

.ribbon-box.right .ribbon-light {
  background: #f3f6f9;
}

.ribbon-box.right .ribbon-light.ribbon-shape::before {
  border-right-color: #f3f6f9;
  border-top-color: #f3f6f9;
}

.ribbon-box.right .ribbon-light.ribbon-shape::after {
  border-right-color: #f3f6f9;
  border-bottom-color: #f3f6f9;
}

.ribbon-box .ribbon-dark {
  background: #212529;
}

.ribbon-box .ribbon-dark:before {
  border-color: #0a0c0d transparent transparent;
}

.ribbon-box .ribbon-dark.ribbon-shape::before {
  border-left-color: #212529;
  border-top-color: #212529;
}

.ribbon-box .ribbon-dark.ribbon-shape::after {
  border-left-color: #212529;
  border-bottom-color: #212529;
}

.ribbon-box.right .ribbon-dark {
  background: #212529;
}

.ribbon-box.right .ribbon-dark.ribbon-shape::before {
  border-right-color: #212529;
  border-top-color: #212529;
}

.ribbon-box.right .ribbon-dark.ribbon-shape::after {
  border-right-color: #212529;
  border-bottom-color: #212529;
}

.ribbon-box .icon-ribbon {
  box-shadow: none;
  left: 24px;
  top: -12px;
  font-size: 40px;
  padding: 0;
}

.ribbon-box .ribbon-two {
  position: absolute;
  left: -5px;
  top: -5px;
  z-index: 1;
  overflow: hidden;
  width: 75px;
  height: 75px;
  text-align: right;
}

.ribbon-box .ribbon-two span {
  font-size: 13px;
  color: #fff;
  text-align: center;
  line-height: 20px;
  transform: rotate(-45deg);
  width: 100px;
  display: block;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);
  position: absolute;
  top: 19px;
  left: -21px;
  font-weight: 600;
}

.ribbon-box .ribbon-two span:before {
  content: "";
  position: absolute;
  left: 0;
  top: 100%;
  z-index: -1;
  border-right: 3px solid transparent;
  border-bottom: 3px solid transparent;
}

.ribbon-box .ribbon-two span:after {
  content: "";
  position: absolute;
  right: 0;
  top: 100%;
  z-index: -1;
  border-left: 3px solid transparent;
  border-bottom: 3px solid transparent;
}

.ribbon-box .ribbon-two-primary span {
  background: #4b38b3;
}

.ribbon-box .ribbon-two-primary span:before {
  border-left: 3px solid #332679;
  border-top: 3px solid #332679;
}

.ribbon-box .ribbon-two-primary span:after {
  border-right: 3px solid #332679;
  border-top: 3px solid #332679;
}

.ribbon-box .ribbon-two-secondary span {
  background: #3577f1;
}

.ribbon-box .ribbon-two-secondary span:before {
  border-left: 3px solid #0e51cb;
  border-top: 3px solid #0e51cb;
}

.ribbon-box .ribbon-two-secondary span:after {
  border-right: 3px solid #0e51cb;
  border-top: 3px solid #0e51cb;
}

.ribbon-box .ribbon-two-success span {
  background: #45cb85;
}

.ribbon-box .ribbon-two-success span:before {
  border-left: 3px solid #2b995f;
  border-top: 3px solid #2b995f;
}

.ribbon-box .ribbon-two-success span:after {
  border-right: 3px solid #2b995f;
  border-top: 3px solid #2b995f;
}

.ribbon-box .ribbon-two-info span {
  background: #299cdb;
}

.ribbon-box .ribbon-two-info span:before {
  border-left: 3px solid #1a6f9d;
  border-top: 3px solid #1a6f9d;
}

.ribbon-box .ribbon-two-info span:after {
  border-right: 3px solid #1a6f9d;
  border-top: 3px solid #1a6f9d;
}

.ribbon-box .ribbon-two-warning span {
  background: #ffbe0b;
}

.ribbon-box .ribbon-two-warning span:before {
  border-left: 3px solid #be8b00;
  border-top: 3px solid #be8b00;
}

.ribbon-box .ribbon-two-warning span:after {
  border-right: 3px solid #be8b00;
  border-top: 3px solid #be8b00;
}

.ribbon-box .ribbon-two-danger span {
  background: #f06548;
}

.ribbon-box .ribbon-two-danger span:before {
  border-left: 3px solid #da3412;
  border-top: 3px solid #da3412;
}

.ribbon-box .ribbon-two-danger span:after {
  border-right: 3px solid #da3412;
  border-top: 3px solid #da3412;
}

.ribbon-box .ribbon-two-light span {
  background: #f3f6f9;
}

.ribbon-box .ribbon-two-light span:before {
  border-left: 3px solid #c0d0e0;
  border-top: 3px solid #c0d0e0;
}

.ribbon-box .ribbon-two-light span:after {
  border-right: 3px solid #c0d0e0;
  border-top: 3px solid #c0d0e0;
}

.ribbon-box .ribbon-two-dark span {
  background: #212529;
}

.ribbon-box .ribbon-two-dark span:before {
  border-left: 3px solid #000;
  border-top: 3px solid #000;
}

.ribbon-box .ribbon-two-dark span:after {
  border-right: 3px solid #000;
  border-top: 3px solid #000;
}

.ribbon-box.right .ribbon-three {
  position: absolute;
  top: -6.1px;
  right: 10px;
  left: auto;
}

.ribbon-three {
  position: absolute;
  top: -6.1px;
  left: 10px;
}

.ribbon-three span {
  position: relative;
  display: block;
  text-align: center;
  color: #fff;
  font-size: 14px;
  line-height: 1;
  padding: 12px 8px 10px;
  border-top-right-radius: 8px;
  width: 90px;
}

.ribbon-three span::after,
.ribbon-three span::before {
  position: absolute;
  content: "";
}

.ribbon-three span::before {
  height: 6px;
  width: 6px;
  left: -6px;
  top: 0;
}

.ribbon-three span::after {
  height: 6px;
  width: 8px;
  left: -8px;
  top: 0;
  border-radius: 8px 8px 0 0;
}

.ribbon-three::after {
  position: absolute;
  content: "";
  width: 0;
  height: 0;
  border-left: 44px solid transparent;
  border-right: 44px solid transparent;
  border-top: 10px solid;
}

.ribbon-three-primary span {
  background: #4b38b3;
}

.ribbon-three-primary span:before {
  background: #4b38b3;
}

.ribbon-three-primary span:after {
  background: #3b2c8c;
}

.ribbon-three-primary::after {
  border-top-color: #4b38b3;
}

.ribbon-three-secondary span {
  background: #3577f1;
}

.ribbon-three-secondary span:before {
  background: #3577f1;
}

.ribbon-three-secondary span:after {
  background: #105ae3;
}

.ribbon-three-secondary::after {
  border-top-color: #3577f1;
}

.ribbon-three-success span {
  background: #45cb85;
}

.ribbon-three-success span:before {
  background: #45cb85;
}

.ribbon-three-success span:after {
  background: #30ad6c;
}

.ribbon-three-success::after {
  border-top-color: #45cb85;
}

.ribbon-three-info span {
  background: #299cdb;
}

.ribbon-three-info span:before {
  background: #299cdb;
}

.ribbon-three-info span:after {
  background: #1e7eb3;
}

.ribbon-three-info::after {
  border-top-color: #299cdb;
}

.ribbon-three-warning span {
  background: #ffbe0b;
}

.ribbon-three-warning span:before {
  background: #ffbe0b;
}

.ribbon-three-warning span:after {
  background: #d79e00;
}

.ribbon-three-warning::after {
  border-top-color: #ffbe0b;
}

.ribbon-three-danger span {
  background: #f06548;
}

.ribbon-three-danger span:before {
  background: #f06548;
}

.ribbon-three-danger span:after {
  background: #ec3d19;
}

.ribbon-three-danger::after {
  border-top-color: #f06548;
}

.ribbon-three-light span {
  background: #f3f6f9;
}

.ribbon-three-light span:before {
  background: #f3f6f9;
}

.ribbon-three-light span:after {
  background: #d1dde8;
}

.ribbon-three-light::after {
  border-top-color: #f3f6f9;
}

.ribbon-three-dark span {
  background: #212529;
}

.ribbon-three-dark span:before {
  background: #212529;
}

.ribbon-three-dark span:after {
  background: #0a0c0d;
}

.ribbon-three-dark::after {
  border-top-color: #212529;
}

.ribbon-box .trending-ribbon {
  transform: translateX(-50px);
  transition: all 0.5s ease;
}

.ribbon-box .trending-ribbon .trending-ribbon-text {
  transition: all 0.5s ease;
  opacity: 0;
}

.ribbon-box:hover .trending-ribbon {
  transform: translateX(0);
}

.ribbon-box:hover .trending-ribbon .trending-ribbon-text {
  opacity: 1;
}

.ribbon-box.right .trending-ribbon {
  transform: translateX(50px);
  transition: all 0.5s ease;
}

.ribbon-box.right .trending-ribbon .trending-ribbon-text {
  transition: all 0.5s ease;
  opacity: 0;
}

.ribbon-box.right:hover .trending-ribbon {
  transform: translateX(0);
}

.ribbon-box.right:hover .trending-ribbon .trending-ribbon-text {
  opacity: 1;
}

.toast:not(:last-child) {
  margin-bottom: 0.75rem;
}

.toast-border-primary .toast-body {
  color: #4b38b3;
  border-bottom: 3px solid #4b38b3;
}

.toast-border-secondary .toast-body {
  color: #3577f1;
  border-bottom: 3px solid #3577f1;
}

.toast-border-success .toast-body {
  color: #45cb85;
  border-bottom: 3px solid #45cb85;
}

.toast-border-info .toast-body {
  color: #299cdb;
  border-bottom: 3px solid #299cdb;
}

.toast-border-warning .toast-body {
  color: #ffbe0b;
  border-bottom: 3px solid #ffbe0b;
}

.toast-border-danger .toast-body {
  color: #f06548;
  border-bottom: 3px solid #f06548;
}

.toast-border-light .toast-body {
  color: #f3f6f9;
  border-bottom: 3px solid #f3f6f9;
}

.toast-border-dark .toast-body {
  color: #212529;
  border-bottom: 3px solid #212529;
}

.scrollspy-example {
  position: relative;
  height: 200px;
  margin-top: 0.5rem;
  overflow: auto;
}

.scrollspy-example-2 {
  position: relative;
  height: 370px;
  overflow: auto;
}

html {
  position: relative;
  min-height: 100%;
}

.h1,
.h2,
.h3,
.h4,
.h5,
.h6,
h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--bs-heading-color);
  font-family: Inter, sans-serif;
}

a {
  text-decoration: none !important;
}

label {
  font-weight: 500;
  margin-bottom: 0.5rem;
}

b,
strong {
  font-weight: 600;
}

.blockquote {
  padding: 10px 20px;
  border-left: 4px solid var(--bs-gray-300);
}

.blockquote-reverse {
  border-left: 0;
  border-right: 4px solid var(--bs-gray-300);
  text-align: right;
}

@media (min-width: 1200px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl {
    max-width: 1140px;
  }
}

.row > * {
  position: relative;
}

.alert-solid .alert-link {
  color: #fff;
}

.alert-outline {
  background-color: var(--bs-card-bg-custom);
  border-width: 2px;
}

.alert-borderless {
  border-width: 0;
}

.alert-label-icon {
  position: relative;
  padding-left: 60px;
  border: 0;
}

.alert-label-icon .label-icon {
  position: absolute;
  width: 45px;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(255, 255, 255, 0.15);
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.alert-label-icon.label-arrow {
  overflow: hidden;
}

.alert-label-icon.label-arrow .label-icon:after {
  content: "";
  position: absolute;
  border: 6px solid transparent;
  border-left-color: #4b38b3;
  right: -12px;
}

.alert-border-left {
  border-left: 3px solid;
}

.alert-top-border {
  background-color: var(--bs-card-bg-custom);
  border-color: var(--bs-border-color);
  border-top: 2px solid;
  color: var(--bs-body-color);
}

.alert-additional {
  padding: 0;
}

.alert-additional .alert-body {
  padding: 0.8rem 1rem;
}

.alert-additional .alert-content {
  padding: 0.8rem 1rem;
  border-bottom-left-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
  margin: 0 -1px -1px -1px;
}

.rounded-label .label-icon {
  width: 45px;
  height: 26px;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 0 30px 30px 0;
}

.alert-solid.alert-primary {
  background-color: #4b38b3;
  border-color: #4b38b3;
  color: #fff;
}

.alert-outline.alert-primary {
  color: #4b38b3;
}

.alert-border-left.alert-primary {
  border-left-color: #4b38b3;
}

.alert-top-border.alert-primary {
  border-top-color: #4b38b3;
}

.rounded-label.alert-primary .label-icon {
  background-color: #4b38b3;
  color: #fff;
}

.label-arrow.alert-primary .label-icon {
  color: #fff;
  background-color: #4b38b3;
}

.label-arrow.alert-primary .label-icon:after {
  border-left-color: #4b38b3 !important;
}

.alert.alert-primary .btn-close::after {
  color: #4b38b3;
}

.alert-additional.alert-primary .alert-content {
  background-color: #4b38b3;
  color: #fff;
}

.alert-solid.alert-secondary {
  background-color: #3577f1;
  border-color: #3577f1;
  color: #fff;
}

.alert-outline.alert-secondary {
  color: #3577f1;
}

.alert-border-left.alert-secondary {
  border-left-color: #3577f1;
}

.alert-top-border.alert-secondary {
  border-top-color: #3577f1;
}

.rounded-label.alert-secondary .label-icon {
  background-color: #3577f1;
  color: #fff;
}

.label-arrow.alert-secondary .label-icon {
  color: #fff;
  background-color: #3577f1;
}

.label-arrow.alert-secondary .label-icon:after {
  border-left-color: #3577f1 !important;
}

.alert.alert-secondary .btn-close::after {
  color: #3577f1;
}

.alert-additional.alert-secondary .alert-content {
  background-color: #3577f1;
  color: #fff;
}

.alert-solid.alert-success {
  background-color: #45cb85;
  border-color: #45cb85;
  color: #fff;
}

.alert-outline.alert-success {
  color: #45cb85;
}

.alert-border-left.alert-success {
  border-left-color: #45cb85;
}

.alert-top-border.alert-success {
  border-top-color: #45cb85;
}

.rounded-label.alert-success .label-icon {
  background-color: #45cb85;
  color: #fff;
}

.label-arrow.alert-success .label-icon {
  color: #fff;
  background-color: #45cb85;
}

.label-arrow.alert-success .label-icon:after {
  border-left-color: #45cb85 !important;
}

.alert.alert-success .btn-close::after {
  color: #45cb85;
}

.alert-additional.alert-success .alert-content {
  background-color: #45cb85;
  color: #fff;
}

.alert-solid.alert-info {
  background-color: #299cdb;
  border-color: #299cdb;
  color: #fff;
}

.alert-outline.alert-info {
  color: #299cdb;
}

.alert-border-left.alert-info {
  border-left-color: #299cdb;
}

.alert-top-border.alert-info {
  border-top-color: #299cdb;
}

.rounded-label.alert-info .label-icon {
  background-color: #299cdb;
  color: #fff;
}

.label-arrow.alert-info .label-icon {
  color: #fff;
  background-color: #299cdb;
}

.label-arrow.alert-info .label-icon:after {
  border-left-color: #299cdb !important;
}

.alert.alert-info .btn-close::after {
  color: #299cdb;
}

.alert-additional.alert-info .alert-content {
  background-color: #299cdb;
  color: #fff;
}

.alert-solid.alert-warning {
  background-color: #ffbe0b;
  border-color: #ffbe0b;
  color: #fff;
}

.alert-outline.alert-warning {
  color: #ffbe0b;
}

.alert-border-left.alert-warning {
  border-left-color: #ffbe0b;
}

.alert-top-border.alert-warning {
  border-top-color: #ffbe0b;
}

.rounded-label.alert-warning .label-icon {
  background-color: #ffbe0b;
  color: #fff;
}

.label-arrow.alert-warning .label-icon {
  color: #fff;
  background-color: #ffbe0b;
}

.label-arrow.alert-warning .label-icon:after {
  border-left-color: #ffbe0b !important;
}

.alert.alert-warning .btn-close::after {
  color: #ffbe0b;
}

.alert-additional.alert-warning .alert-content {
  background-color: #ffbe0b;
  color: #fff;
}

.alert-solid.alert-danger {
  background-color: #f06548;
  border-color: #f06548;
  color: #fff;
}

.alert-outline.alert-danger {
  color: #f06548;
}

.alert-border-left.alert-danger {
  border-left-color: #f06548;
}

.alert-top-border.alert-danger {
  border-top-color: #f06548;
}

.rounded-label.alert-danger .label-icon {
  background-color: #f06548;
  color: #fff;
}

.label-arrow.alert-danger .label-icon {
  color: #fff;
  background-color: #f06548;
}

.label-arrow.alert-danger .label-icon:after {
  border-left-color: #f06548 !important;
}

.alert.alert-danger .btn-close::after {
  color: #f06548;
}

.alert-additional.alert-danger .alert-content {
  background-color: #f06548;
  color: #fff;
}

.alert-solid.alert-light {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
  color: #000;
}

.alert-outline.alert-light {
  color: #f3f6f9;
}

.alert-border-left.alert-light {
  border-left-color: #f3f6f9;
}

.alert-top-border.alert-light {
  border-top-color: #f3f6f9;
}

.rounded-label.alert-light .label-icon {
  background-color: #f3f6f9;
  color: #000;
}

.label-arrow.alert-light .label-icon {
  color: #000;
  background-color: #f3f6f9;
}

.label-arrow.alert-light .label-icon:after {
  border-left-color: #f3f6f9 !important;
}

.alert.alert-light .btn-close::after {
  color: #f3f6f9;
}

.alert-additional.alert-light .alert-content {
  background-color: #f3f6f9;
  color: #000;
}

.alert-solid.alert-dark {
  background-color: #212529;
  border-color: #212529;
  color: #fff;
}

.alert-outline.alert-dark {
  color: #212529;
}

.alert-border-left.alert-dark {
  border-left-color: #212529;
}

.alert-top-border.alert-dark {
  border-top-color: #212529;
}

.rounded-label.alert-dark .label-icon {
  background-color: #212529;
  color: #fff;
}

.label-arrow.alert-dark .label-icon {
  color: #fff;
  background-color: #212529;
}

.label-arrow.alert-dark .label-icon:after {
  border-left-color: #212529 !important;
}

.alert.alert-dark .btn-close::after {
  color: #212529;
}

.alert-additional.alert-dark .alert-content {
  background-color: #212529;
  color: #fff;
}

.alert-dismissible .btn-close {
  background: 0 0 !important;
}

.alert-dismissible .btn-close::after {
  background: 0 0 !important;
  content: "\\f0156" !important;
  font-size: 18px;
  line-height: 15px;
  font-family: "Material Design Icons" !important;
}

.alert-outline.alert-dark {
  color: var(--bs-dark);
}

.bg-soft-primary {
  background-color: rgba(75, 56, 179, 0.18) !important;
}

.bg-soft-secondary {
  background-color: rgba(53, 119, 241, 0.18) !important;
}

.bg-soft-success {
  background-color: rgba(69, 203, 133, 0.18) !important;
}

.bg-soft-info {
  background-color: rgba(41, 156, 219, 0.18) !important;
}

.bg-soft-warning {
  background-color: rgba(255, 190, 11, 0.18) !important;
}

.bg-soft-danger {
  background-color: rgba(240, 101, 72, 0.18) !important;
}

.bg-soft-light {
  background-color: rgba(243, 246, 249, 0.18) !important;
}

.bg-soft-dark {
  background-color: rgba(33, 37, 41, 0.18) !important;
}

.bg-soft-dark {
  background-color: rgba(var(--bs-dark-rgb), 0.18) !important;
}

.bg-soft-light {
  background-color: rgba(var(--bs-light-rgb), 0.18) !important;
}

.badge-outline-primary {
  color: #4b38b3;
  border: 1px solid #4b38b3;
  background-color: transparent;
}

.badge-outline-secondary {
  color: #3577f1;
  border: 1px solid #3577f1;
  background-color: transparent;
}

.badge-outline-success {
  color: #45cb85;
  border: 1px solid #45cb85;
  background-color: transparent;
}

.badge-outline-info {
  color: #299cdb;
  border: 1px solid #299cdb;
  background-color: transparent;
}

.badge-outline-warning {
  color: #ffbe0b;
  border: 1px solid #ffbe0b;
  background-color: transparent;
}

.badge-outline-danger {
  color: #f06548;
  border: 1px solid #f06548;
  background-color: transparent;
}

.badge-outline-light {
  color: #f3f6f9;
  border: 1px solid #f3f6f9;
  background-color: transparent;
}

.badge-outline-dark {
  color: #212529;
  border: 1px solid #212529;
  background-color: transparent;
}

.badge-outline {
  background-color: var(--bs-card-bg-custom);
  border: 1px solid;
}

.badge-soft-primary {
  color: #4b38b3;
  background-color: rgba(75, 56, 179, 0.1);
}

.badge-outline.badge-primary {
  color: #4b38b3;
  border: 1px solid #4b38b3;
  background-color: transparent;
}

.badge-label.bg-primary:before {
  border-right-color: #4b38b3;
}

.badge-soft-secondary {
  color: #3577f1;
  background-color: rgba(53, 119, 241, 0.1);
}

.badge-outline.badge-secondary {
  color: #3577f1;
  border: 1px solid #3577f1;
  background-color: transparent;
}

.badge-label.bg-secondary:before {
  border-right-color: #3577f1;
}

.badge-soft-success {
  color: #45cb85;
  background-color: rgba(69, 203, 133, 0.1);
}

.badge-outline.badge-success {
  color: #45cb85;
  border: 1px solid #45cb85;
  background-color: transparent;
}

.badge-label.bg-success:before {
  border-right-color: #45cb85;
}

.badge-soft-info {
  color: #299cdb;
  background-color: rgba(41, 156, 219, 0.1);
}

.badge-outline.badge-info {
  color: #299cdb;
  border: 1px solid #299cdb;
  background-color: transparent;
}

.badge-label.bg-info:before {
  border-right-color: #299cdb;
}

.badge-soft-warning {
  color: #ffbe0b;
  background-color: rgba(255, 190, 11, 0.1);
}

.badge-outline.badge-warning {
  color: #ffbe0b;
  border: 1px solid #ffbe0b;
  background-color: transparent;
}

.badge-label.bg-warning:before {
  border-right-color: #ffbe0b;
}

.badge-soft-danger {
  color: #f06548;
  background-color: rgba(240, 101, 72, 0.1);
}

.badge-outline.badge-danger {
  color: #f06548;
  border: 1px solid #f06548;
  background-color: transparent;
}

.badge-label.bg-danger:before {
  border-right-color: #f06548;
}

.badge-soft-light {
  color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.1);
}

.badge-outline.badge-light {
  color: #f3f6f9;
  border: 1px solid #f3f6f9;
  background-color: transparent;
}

.badge-label.bg-light:before {
  border-right-color: #f3f6f9;
}

.badge-soft-dark {
  color: #212529;
  background-color: rgba(33, 37, 41, 0.1);
}

.badge-outline.badge-dark {
  color: #212529;
  border: 1px solid #212529;
  background-color: transparent;
}

.badge-label.bg-dark:before {
  border-right-color: #212529;
}

.badge-border {
  border-left: 2px solid;
}

.badge-label {
  margin-left: 8px;
  position: relative;
}

.badge-label:before {
  content: "";
  position: absolute;
  border: 8px solid transparent;
  border-right-color: #4b38b3;
  left: -14px;
  top: 0;
}

.badge-gradient-primary {
  background: linear-gradient(135deg, #4b38b3 0, #45cb85 100%);
}

.badge-gradient-secondary {
  background: linear-gradient(135deg, #3577f1 0, #299cdb 100%);
}

.badge-gradient-success {
  background: linear-gradient(135deg, #45cb85 0, #ffbe0b 100%);
}

.badge-gradient-danger {
  background: linear-gradient(135deg, #f06548 0, #3577f1 100%);
}

.badge-gradient-warning {
  background: linear-gradient(135deg, #ffbe0b 0, #be8b00 100%);
}

.badge-gradient-info {
  background: linear-gradient(135deg, #299cdb 0, #45cb85 100%);
}

.badge-gradient-dark {
  background: linear-gradient(135deg, #212529 0, #4b38b3 100%);
}

a,
button {
  outline: 0 !important;
  position: relative;
}

.btn {
  box-shadow: var(--bs-box-shadow);
}

.btn.active,
.btn.show,
.btn:active,
.btn:first-child:active,
.btn:focus,
.btn:hover {
  border-color: transparent;
}

:not(.btn-check) + .btn:active {
  border-color: transparent;
}

.btn-rounded {
  border-radius: 30px;
}

.btn-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: calc(1rem + 1.5em + 2px);
  width: calc(1rem + 1.5em + 2px);
  padding: 0;
}

.btn-icon i,
.btn-icon img,
.btn-icon svg {
  vertical-align: middle;
}

.btn-icon.btn-sm {
  height: calc(0.5rem + 1.5em + 2px);
  width: calc(0.5rem + 1.5em + 2px);
}

.btn-icon.btn-lg {
  height: calc(1.4rem + 1.5em + 2px);
  width: calc(1.4rem + 1.5em + 2px);
}

.btn-soft-primary {
  color: #4b38b3;
  background-color: rgba(75, 56, 179, 0.1);
  border-color: transparent;
}

.btn-soft-primary:active,
.btn-soft-primary:focus,
.btn-soft-primary:hover {
  color: #fff !important;
  background-color: #4b38b3 !important;
  border-color: transparent;
}

.btn-soft-secondary {
  color: #3577f1;
  background-color: rgba(53, 119, 241, 0.1);
  border-color: transparent;
  margin: 3px;
}

.btn-soft-secondary:active,
.btn-soft-secondary:focus,
.btn-soft-secondary:hover {
  color: #fff !important;
  background-color: #3577f1 !important;
  border-color: transparent;
}

.btn-soft-success {
  color: #45cb85;
  background-color: rgba(69, 203, 133, 0.1);
  border-color: transparent;
}

.btn-soft-success:active,
.btn-soft-success:focus,
.btn-soft-success:hover {
  color: #fff !important;
  background-color: #45cb85 !important;
  border-color: transparent;
}

.btn-soft-info {
  color: #299cdb;
  background-color: rgba(41, 156, 219, 0.1);
  border-color: transparent;
  margin: 3px;
}

.btn-soft-info:active,
.btn-soft-info:focus,
.btn-soft-info:hover {
  color: #fff !important;
  background-color: #299cdb !important;
  border-color: transparent;
}

.btn-soft-warning {
  color: #ffbe0b;
  background-color: rgba(255, 190, 11, 0.1);
  border-color: transparent;
}

.btn-soft-warning:active,
.btn-soft-warning:focus,
.btn-soft-warning:hover {
  color: #fff !important;
  background-color: #ffbe0b !important;
  border-color: transparent;
}

.btn-soft-danger {
  color: #f06548;
  background-color: rgba(240, 101, 72, 0.1);
  border-color: transparent;
}

.btn-soft-danger:active,
.btn-soft-danger:focus,
.btn-soft-danger:hover {
  color: #fff !important;
  background-color: #f06548 !important;
  border-color: transparent;
}

.btn-soft-light {
  color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.1);
  border-color: transparent;
}

.btn-soft-light:active,
.btn-soft-light:focus,
.btn-soft-light:hover {
  color: #fff !important;
  background-color: #f3f6f9 !important;
  border-color: transparent;
}

.btn-soft-dark {
  color: #212529;
  background-color: rgba(33, 37, 41, 0.1);
  border-color: transparent;
}

.btn-soft-dark:active,
.btn-soft-dark:focus,
.btn-soft-dark:hover {
  color: #fff !important;
  background-color: #212529 !important;
  border-color: transparent;
}

.btn-ghost-primary {
  color: #4b38b3;
  border-color: transparent;
}

.btn-ghost-primary:active,
.btn-ghost-primary:focus,
.btn-ghost-primary:hover {
  color: #4b38b3 !important;
  background-color: rgba(75, 56, 179, 0.1) !important;
  border-color: transparent !important;
}

.btn-ghost-secondary {
  color: #3577f1;
  border-color: transparent;
}

.btn-ghost-secondary:active,
.btn-ghost-secondary:focus,
.btn-ghost-secondary:hover {
  color: #3577f1 !important;
  background-color: rgba(53, 119, 241, 0.1) !important;
  border-color: transparent !important;
}

.btn-ghost-success {
  color: #45cb85;
  border-color: transparent;
}

.btn-ghost-success:active,
.btn-ghost-success:focus,
.btn-ghost-success:hover {
  color: #45cb85 !important;
  background-color: rgba(69, 203, 133, 0.1) !important;
  border-color: transparent !important;
}

.btn-ghost-info {
  color: #299cdb;
  border-color: transparent;
}

.btn-ghost-info:active,
.btn-ghost-info:focus,
.btn-ghost-info:hover {
  color: #299cdb !important;
  background-color: rgba(41, 156, 219, 0.1) !important;
  border-color: transparent !important;
}

.btn-ghost-warning {
  color: #ffbe0b;
  border-color: transparent;
}

.btn-ghost-warning:active,
.btn-ghost-warning:focus,
.btn-ghost-warning:hover {
  color: #ffbe0b !important;
  background-color: rgba(255, 190, 11, 0.1) !important;
  border-color: transparent !important;
}

.btn-ghost-danger {
  color: #f06548;
  border-color: transparent;
}

.btn-ghost-danger:active,
.btn-ghost-danger:focus,
.btn-ghost-danger:hover {
  color: #f06548 !important;
  background-color: rgba(240, 101, 72, 0.1) !important;
  border-color: transparent !important;
}

.btn-ghost-light {
  color: #f3f6f9;
  border-color: transparent;
}

.btn-ghost-light:active,
.btn-ghost-light:focus,
.btn-ghost-light:hover {
  color: #f3f6f9 !important;
  background-color: rgba(243, 246, 249, 0.1) !important;
  border-color: transparent !important;
}

.btn-ghost-dark {
  color: #212529;
  border-color: transparent;
}

.btn-ghost-dark:active,
.btn-ghost-dark:focus,
.btn-ghost-dark:hover {
  color: #212529 !important;
  background-color: rgba(33, 37, 41, 0.1) !important;
  border-color: transparent !important;
}

.btn-ghost-secondary {
  color: var(--bs-gray-700);
}

.btn-label {
  position: relative;
  padding-left: 44px;
}

.btn-label .label-icon {
  position: absolute;
  width: 35.5px;
  left: -1px;
  top: -1px;
  bottom: -1px;
  background-color: rgba(255, 255, 255, 0.1);
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-label.btn-light .label-icon {
  background-color: rgba(33, 37, 41, 0.05);
}

.btn-label.right {
  padding-left: 0.9rem;
  padding-right: 44px;
}

.btn-label.right .label-icon {
  right: -1px;
  left: auto;
}

.btn-animation {
  overflow: hidden;
  transition: border-color 0.3s, background-color 0.3s;
  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);
}

.btn-animation::after {
  content: attr(data-text);
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  transform: translate3d(0, 25%, 0);
  padding: 0.5rem 0.9rem;
  transition: transform 0.3s, opacity 0.3s;
  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);
}

.btn-animation > span {
  display: block;
  transition: transform 0.3s, opacity 0.3s;
  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);
}

.btn-animation:hover::after {
  opacity: 1;
  transform: translate3d(0, 0, 0);
}

.btn-animation:hover > span {
  opacity: 0;
  transform: translate3d(0, -25%, 0);
}

.btn-primary.btn-animation {
  background-color: #4b38b3;
  border-color: #4b38b3;
}

.btn-primary.btn-animation:active,
.btn-primary.btn-animation:focus,
.btn-primary.btn-animation:hover {
  color: #4b38b3;
  background-color: rgba(75, 56, 179, 0.1);
}

.btn-secondary.btn-animation {
  background-color: #3577f1;
  border-color: #3577f1;
}

.btn-secondary.btn-animation:active,
.btn-secondary.btn-animation:focus,
.btn-secondary.btn-animation:hover {
  color: #3577f1;
  background-color: rgba(53, 119, 241, 0.1);
}

.btn-success.btn-animation {
  background-color: #45cb85;
  border-color: #45cb85;
}

.btn-success.btn-animation:active,
.btn-success.btn-animation:focus,
.btn-success.btn-animation:hover {
  color: #45cb85;
  background-color: rgba(69, 203, 133, 0.1);
}

.btn-info.btn-animation {
  background-color: #299cdb;
  border-color: #299cdb;
}

.btn-info.btn-animation:active,
.btn-info.btn-animation:focus,
.btn-info.btn-animation:hover {
  color: #299cdb;
  background-color: rgba(41, 156, 219, 0.1);
}

.btn-warning.btn-animation {
  background-color: #ffbe0b;
  border-color: #ffbe0b;
}

.btn-warning.btn-animation:active,
.btn-warning.btn-animation:focus,
.btn-warning.btn-animation:hover {
  color: #ffbe0b;
  background-color: rgba(255, 190, 11, 0.1);
}

.btn-danger.btn-animation {
  background-color: #f06548;
  border-color: #f06548;
}

.btn-danger.btn-animation:active,
.btn-danger.btn-animation:focus,
.btn-danger.btn-animation:hover {
  color: #f06548;
  background-color: rgba(240, 101, 72, 0.1);
}

.btn-light.btn-animation {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
}

.btn-light.btn-animation:active,
.btn-light.btn-animation:focus,
.btn-light.btn-animation:hover {
  color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.1);
}

.btn-dark.btn-animation {
  background-color: #212529;
  border-color: #212529;
}

.btn-dark.btn-animation:active,
.btn-dark.btn-animation:focus,
.btn-dark.btn-animation:hover {
  color: #212529;
  background-color: rgba(33, 37, 41, 0.1);
}

.btn-group-vertical label {
  margin-bottom: 0;
}

.btn-group.radio .btn {
  border: none;
}

.btn-group.radio .btn-check:active + .btn-light,
.btn-group.radio .btn-check:checked + .btn-light,
.btn-group.radio .btn-light.active,
.btn-group.radio .btn-light.dropdown-toggle.show,
.btn-group.radio .btn-light:active {
  background-color: rgba(41, 156, 219, 0.2);
  color: #299cdb;
}

[data-layout-mode="dark"] .btn-check:focus + .btn-light,
[data-layout-mode="dark"] .btn-check:focus + .btn-outline-light,
[data-layout-mode="dark"] .btn-check:focus + .btn-soft-light,
[data-layout-mode="dark"] .btn-soft-light:focus {
  color: var(--bs-dark);
  background-color: rgba(var(--bs-light-rgb), 0.75);
  border-color: rgba(var(--bs-light-rgb), 0.75);
}

[data-layout-mode="dark"] .btn-check:active + .btn-light,
[data-layout-mode="dark"] .btn-check:active + .btn-outline-light,
[data-layout-mode="dark"] .btn-check:active + .btn-soft-light,
[data-layout-mode="dark"] .btn-check:checked + .btn-light,
[data-layout-mode="dark"] .btn-check:checked + .btn-outline-light,
[data-layout-mode="dark"] .btn-check:checked + .btn-soft-light,
[data-layout-mode="dark"] .btn-light.active,
[data-layout-mode="dark"] .btn-light:active,
[data-layout-mode="dark"] .btn-outline-light.active,
[data-layout-mode="dark"] .btn-outline-light:active,
[data-layout-mode="dark"] .btn-soft-light.active,
[data-layout-mode="dark"] .btn-soft-light:active,
[data-layout-mode="dark"] .show > .btn-light.dropdown-toggle,
[data-layout-mode="dark"] .show > .btn-outline-light.dropdown-toggle,
[data-layout-mode="dark"] .show > .btn-soft-light.dropdown-toggle {
  color: var(--bs-dark);
  background-color: rgba(var(--bs-light-rgb), 0.75);
  border-color: rgba(var(--bs-light-rgb), 0.75);
}

[data-layout-mode="dark"] .btn-check:focus + .btn-dark,
[data-layout-mode="dark"] .btn-check:focus + .btn-outline-dark,
[data-layout-mode="dark"] .btn-check:focus + .btn-soft-dark,
[data-layout-mode="dark"] .btn-soft-dark:focus {
  color: var(--bs-light);
  background-color: rgba(var(--bs-dark-rgb), 0.75);
  border-color: rgba(var(--bs-dark-rgb), 0.75);
}

[data-layout-mode="dark"] .btn-check:active + .btn-dark,
[data-layout-mode="dark"] .btn-check:active + .btn-outline-dark,
[data-layout-mode="dark"] .btn-check:active + .btn-soft-dark,
[data-layout-mode="dark"] .btn-check:checked + .btn-dark,
[data-layout-mode="dark"] .btn-check:checked + .btn-outline-dark,
[data-layout-mode="dark"] .btn-check:checked + .btn-soft-dark,
[data-layout-mode="dark"] .btn-dark.active,
[data-layout-mode="dark"] .btn-dark:active,
[data-layout-mode="dark"] .btn-outline-dark.active,
[data-layout-mode="dark"] .btn-outline-dark:active,
[data-layout-mode="dark"] .btn-soft-dark.active,
[data-layout-mode="dark"] .btn-soft-dark:active,
[data-layout-mode="dark"] .show > .btn-dark.dropdown-toggle,
[data-layout-mode="dark"] .show > .btn-outline-dark.dropdown-toggle,
[data-layout-mode="dark"] .show > .btn-soft-dark.dropdown-toggle {
  color: var(--bs-light);
  background-color: rgba(var(--bs-dark-rgb), 0.75);
  border-color: rgba(var(--bs-dark-rgb), 0.75);
}

[data-layout-mode="dark"] .btn-soft-light {
  color: var(--bs-dark);
  background-color: rgba(var(--bs-light-rgb), 0.1);
}

[data-layout-mode="dark"] .btn-soft-light:hover {
  color: var(--bs-dark);
  background-color: var(--bs-light);
}

[data-layout-mode="dark"] .btn-soft-dark {
  color: var(--bs-dark);
  background-color: rgba(var(--bs-dark-rgb), 0.1);
}

[data-layout-mode="dark"] .btn-soft-dark:hover {
  color: var(--bs-light);
  background-color: var(--bs-dark);
}

[data-layout-mode="dark"] .btn-ghost-light {
  color: var(--bs-dark);
}

[data-layout-mode="dark"] .btn-ghost-light:active,
[data-layout-mode="dark"] .btn-ghost-light:focus,
[data-layout-mode="dark"] .btn-ghost-light:hover {
  color: var(--bs-dark);
  background-color: rgba(var(--bs-light-rgb), 0.5);
}

[data-layout-mode="dark"] .btn-ghost-dark {
  color: var(--bs-dark);
}

[data-layout-mode="dark"] .btn-ghost-dark:active,
[data-layout-mode="dark"] .btn-ghost-dark:focus,
[data-layout-mode="dark"] .btn-ghost-dark:hover {
  color: var(--bs-dark);
  background-color: rgba(var(--bs-dark-rgb), 0.1);
}

.btn-load .spinner-border,
.btn-load .spinner-grow {
  height: 19px;
  width: 19px;
}

.btn-outline-primary.btn-border,
.btn-primary.btn-border,
.btn-soft-primary.btn-border {
  border-bottom: 2px solid #3e2e94;
}

.btn-outline-secondary.btn-border,
.btn-secondary.btn-border,
.btn-soft-secondary.btn-border {
  border-bottom: 2px solid #105eed;
}

.btn-outline-success.btn-border,
.btn-soft-success.btn-border,
.btn-success.btn-border {
  border-bottom: 2px solid #33b571;
}

.btn-info.btn-border,
.btn-outline-info.btn-border,
.btn-soft-info.btn-border {
  border-bottom: 2px solid #2084bc;
}

.btn-outline-warning.btn-border,
.btn-soft-warning.btn-border,
.btn-warning.btn-border {
  border-bottom: 2px solid #e1a500;
}

.btn-danger.btn-border,
.btn-outline-danger.btn-border,
.btn-soft-danger.btn-border {
  border-bottom: 2px solid #ed4522;
}

.btn-light.btn-border,
.btn-outline-light.btn-border,
.btn-soft-light.btn-border {
  border-bottom: 2px solid #d8e2eb;
}

.btn-dark.btn-border,
.btn-outline-dark.btn-border,
.btn-soft-dark.btn-border {
  border-bottom: 2px solid #0f1112;
}

.custom-toggle .icon-off {
  display: none;
}

.custom-toggle.active .icon-on {
  display: none;
}

.custom-toggle.active .icon-off {
  display: block;
}

.breadcrumb-item > a {
  color: var(--bs-gray-700);
}

.breadcrumb-item + .breadcrumb-item::before {
  font-family: "Material Design Icons";
  font-size: 15px;
  line-height: 20px;
}

.card {
  margin-bottom: 1.5rem;
  box-shadow: var(--bs-box-shadow);
}

.card-header {
  border-bottom: 1px solid var(--bs-border-color);
}

.card-header-dropdown .dropdown-btn {
  padding: 1rem 0;
}

.card-footer {
  border-top: 1px solid var(--bs-border-color);
}

.card-drop {
  color: #212529;
}

.card-title {
  font-size: 16px;
  margin: 0 0 7px 0;
}

.card-title-desc {
  margin-bottom: 24px;
}

.card-height-100 {
  height: calc(100% - 1.5rem);
}

.card-animate {
  transition: all 0.4s;
}

.card-animate:hover {
  transform: translateY(calc(-1.5rem / 5));
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
}

.card-primary {
  color: #fff;
  background-color: #4b38b3;
}

.card-primary .card-footer,
.card-primary .card-header {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}

.card-primary .card-title {
  color: #fff;
}

.card-secondary {
  color: #fff;
  background-color: #3577f1;
}

.card-secondary .card-footer,
.card-secondary .card-header {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}

.card-secondary .card-title {
  color: #fff;
}

.card-success {
  color: #fff;
  background-color: #45cb85;
}

.card-success .card-footer,
.card-success .card-header {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}

.card-success .card-title {
  color: #fff;
}

.card-info {
  color: #fff;
  background-color: #299cdb;
}

.card-info .card-footer,
.card-info .card-header {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}

.card-info .card-title {
  color: #fff;
}

.card-warning {
  color: #fff;
  background-color: #ffbe0b;
}

.card-warning .card-footer,
.card-warning .card-header {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}

.card-warning .card-title {
  color: #fff;
}

.card-danger {
  color: #fff;
  background-color: #f06548;
}

.card-danger .card-footer,
.card-danger .card-header {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}

.card-danger .card-title {
  color: #fff;
}

.card-light {
  color: #fff;
  background-color: #f3f6f9;
}

.card-light .card-footer,
.card-light .card-header {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}

.card-light .card-title {
  color: #fff;
}

.card-dark {
  color: #fff;
  background-color: #212529;
}

.card-dark .card-footer,
.card-dark .card-header {
  background-color: rgba(255, 255, 255, 0.1);
  color: #fff;
  border-color: transparent;
}

.card-dark .card-title {
  color: #fff;
}

.card-border-primary {
  border-color: #4b38b3 !important;
}

.card-border-primary .card-footer,
.card-border-primary .card-header {
  border-color: #4b38b3;
}

.card-border-secondary {
  border-color: #3577f1 !important;
}

.card-border-secondary .card-footer,
.card-border-secondary .card-header {
  border-color: #3577f1;
}

.card-border-success {
  border-color: #45cb85 !important;
}

.card-border-success .card-footer,
.card-border-success .card-header {
  border-color: #45cb85;
}

.card-border-info {
  border-color: #299cdb !important;
}

.card-border-info .card-footer,
.card-border-info .card-header {
  border-color: #299cdb;
}

.card-border-warning {
  border-color: #ffbe0b !important;
}

.card-border-warning .card-footer,
.card-border-warning .card-header {
  border-color: #ffbe0b;
}

.card-border-danger {
  border-color: #f06548 !important;
}

.card-border-danger .card-footer,
.card-border-danger .card-header {
  border-color: #f06548;
}

.card-border-light {
  border-color: #f3f6f9 !important;
}

.card-border-light .card-footer,
.card-border-light .card-header {
  border-color: #f3f6f9;
}

.card-border-dark {
  border-color: #212529 !important;
}

.card-border-dark .card-footer,
.card-border-dark .card-header {
  border-color: #212529;
}

.card-light {
  background-color: var(--bs-light);
}

.card-light .card-footer,
.card-light .card-header {
  color: var(--bs-body-color) !important;
  background-color: rgba(var(--bs-dark-rgb), 0.1);
}

.card-light .card-text,
.card-light .card-title {
  color: var(--bs-body-color) !important;
}

.stretched-link {
  position: static;
}

.card-preloader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(var(--bs-light-rgb), 0.6);
  z-index: 9999;
}

.card-status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) !important;
}

.custom-loader {
  animation: spin 2s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.card-overlay {
  position: relative;
  overflow: hidden;
}

.card-overlay:before {
  content: "";
  background-color: rgba(75, 56, 179, 0.2);
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
}

.card-overlay .card-footer,
.card-overlay .card-header {
  border-color: rgba(255, 255, 255, 0.15) !important;
}

.card-toolbar-menu {
  line-height: 0.8;
}

.card-toolbar-menu a {
  font-size: 17px;
}

.card-toolbar-menu .minimize-card .plus {
  display: none;
}

.card-toolbar-menu .minimize-card .minus {
  display: block;
}

.card-toolbar-menu .minimize-card.collapsed .plus {
  display: block;
}

.card-toolbar-menu .minimize-card.collapsed .minus {
  display: none;
}

.dropdown-toggle::after {
  display: inline-block;
  margin-left: 0.255em;
  font-size: 15px;
  line-height: 15px;
  content: "\\f0140";
  font-family: "Material Design Icons";
}

.dropdown-menu {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  position: absolute;
  z-index: 1000;
}

.dropdown-menu.dropdown-megamenu {
  padding: 20px;
  left: 0 !important;
  right: 0 !important;
}

.dropdown-menu[data-popper-placement="top-start"] {
  animation-name: DropDownSlideDown;
}

@keyframes DropDownSlide {
  100% {
    margin-top: -1px;
  }

  0% {
    margin-top: 8px;
  }
}

@keyframes DropDownSlideDown {
  100% {
    margin-bottom: 0;
  }

  0% {
    margin-bottom: 8px;
  }
}

@media (min-width: 600px) {
  .dropdown-menu-xl {
    width: 420px;
  }

  .dropdown-menu-lg {
    width: 320px;
  }

  .dropdown-menu-md {
    width: 240px;
  }
}

.dropdown-toggle-split {
  border-left: none;
}

.dropdown-toggle-split::after {
  margin-left: 0;
}

.dropdown-toggle-split:before {
  content: "";
  position: absolute;
  background-color: rgba(255, 255, 255, 0.12);
  top: -1px;
  bottom: -1px;
  right: -1px;
  left: 0;
  border-radius: 0 0.25rem 0.25rem 0;
}

.dropdown-mega {
  position: static !important;
}

.dropdown-mega-menu-xl {
  width: 38rem;
}

.dropdown-mega-menu-lg {
  width: 26rem;
}

[dir="ltr"] .dropdown-menu-start {
  --bs-position: end;
}

[dir="ltr"] .dropdown-menu-end {
  --bs-position: start;
}

.dropdown-head .nav-tabs-custom {
  border: 0;
}

.dropdown-head .nav-tabs-custom .nav-link {
  color: rgba(255, 255, 255, 0.6);
}

.dropdown-head .nav-tabs-custom .nav-link.active {
  background-color: var(--bs-dropdown-bg);
}

.dropdown-head .nav-tabs-custom .nav-link:hover {
  color: #fff;
}

.dropdownmenu-primary .dropdown-item.active,
.dropdownmenu-primary .dropdown-item:focus,
.dropdownmenu-primary .dropdown-item:hover {
  background-color: rgba(75, 56, 179, 0.07);
  color: #4b38b3;
}

.dropdownmenu-secondary .dropdown-item.active,
.dropdownmenu-secondary .dropdown-item:focus,
.dropdownmenu-secondary .dropdown-item:hover {
  background-color: rgba(53, 119, 241, 0.07);
  color: #3577f1;
}

.dropdownmenu-success .dropdown-item.active,
.dropdownmenu-success .dropdown-item:focus,
.dropdownmenu-success .dropdown-item:hover {
  background-color: rgba(69, 203, 133, 0.07);
  color: #45cb85;
}

.dropdownmenu-info .dropdown-item.active,
.dropdownmenu-info .dropdown-item:focus,
.dropdownmenu-info .dropdown-item:hover {
  background-color: rgba(41, 156, 219, 0.07);
  color: #299cdb;
}

.dropdownmenu-warning .dropdown-item.active,
.dropdownmenu-warning .dropdown-item:focus,
.dropdownmenu-warning .dropdown-item:hover {
  background-color: rgba(255, 190, 11, 0.07);
  color: #ffbe0b;
}

.dropdownmenu-danger .dropdown-item.active,
.dropdownmenu-danger .dropdown-item:focus,
.dropdownmenu-danger .dropdown-item:hover {
  background-color: rgba(240, 101, 72, 0.07);
  color: #f06548;
}

.dropdownmenu-light .dropdown-item.active,
.dropdownmenu-light .dropdown-item:focus,
.dropdownmenu-light .dropdown-item:hover {
  background-color: rgba(243, 246, 249, 0.07);
  color: #f3f6f9;
}

.dropdownmenu-dark .dropdown-item.active,
.dropdownmenu-dark .dropdown-item:focus,
.dropdownmenu-dark .dropdown-item:hover {
  background-color: rgba(33, 37, 41, 0.07);
  color: #212529;
}

.nav-pills > li > a,
.nav-tabs > li > a {
  color: var(--bs-gray-700);
  font-weight: 500;
}

.nav-pills > a {
  color: var(--bs-gray-700);
  font-weight: 500;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  box-shadow: var(--bs-box-shadow);
}

.nav-tabs-custom {
  border-bottom: 1px solid var(--bs-gray-300);
}

.nav-tabs-custom .nav-item {
  position: relative;
}

.nav-tabs-custom .nav-item .nav-link {
  border: none;
  font-weight: 500;
}

.nav-tabs-custom .nav-item .nav-link::after {
  content: "";
  background: #4b38b3;
  height: 1px;
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  transition: all 250ms ease 0s;
  transform: scale(0);
}

.nav-tabs-custom .nav-item .nav-link.active {
  color: #4b38b3;
}

.nav-tabs-custom .nav-item .nav-link.active:after {
  transform: scale(1);
}

.nav-tabs-custom.card-header-tabs {
  margin-top: -1rem;
}

.nav-tabs-custom.card-header-tabs .nav-link {
  padding: 1rem 1rem;
}

.vertical-nav .nav .nav-link {
  padding: 24px 16px;
  text-align: center;
  margin-bottom: 8px;
}

.vertical-nav .nav .nav-link .nav-icon {
  font-size: 24px;
}

.navtab-bg li > a {
  background-color: #e9ebec;
  margin: 0 5px;
}

.arrow-navtabs .nav-item .nav-link {
  position: relative;
  text-align: center;
}

.arrow-navtabs .nav-item .nav-link:before {
  content: "";
  position: absolute;
  border: 6px solid transparent;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .arrow-navtabs .nav-item .nav-link:before {
    transition: none;
  }
}

.arrow-navtabs .nav-item .nav-link.active:before {
  border-top-color: #4b38b3;
}

.custom-hover-nav-tabs .nav-item {
  text-align: center;
  overflow: hidden;
}

.custom-hover-nav-tabs .nav-item .nav-link {
  width: 120px;
  height: 45px;
  position: relative;
  border-radius: 0;
}

.custom-hover-nav-tabs .nav-item .nav-link .nav-icon {
  font-size: 22px;
}

.custom-hover-nav-tabs .nav-item .nav-link .nav-titl {
  font-size: 14px;
}

.custom-hover-nav-tabs .nav-item .nav-link.active .nav-tab-position {
  color: #fff;
}

.custom-hover-nav-tabs .nav-item .nav-link .nav-tab-position {
  position: absolute;
  left: 0;
  right: 0;
  transition: all 0.4s;
}

.custom-hover-nav-tabs .nav-item .nav-link .nav-tab-position.nav-icon {
  top: 50%;
  transform: translateY(-50%);
}

.custom-hover-nav-tabs .nav-item .nav-link .nav-tab-position.nav-titl {
  bottom: -20px;
}

.custom-hover-nav-tabs .nav-item .nav-link:hover .nav-titl {
  bottom: 50%;
  transform: translateY(50%);
}

.custom-hover-nav-tabs .nav-item .nav-link:hover .nav-icon {
  top: -20px;
}

.custom-verti-nav-pills .nav-link {
  background-color: var(--bs-light);
  margin-top: 7px;
  position: relative;
}

@media (min-width: 992px) {
  .custom-verti-nav-pills .nav-link::before {
    content: "";
    position: absolute;
    right: -20px;
    top: 50%;
    transform: translateY(-50%);
    border: 12px solid transparent;
    border-left-color: transparent;
    transition: border-left-color 0.04 ease;
  }

  .custom-verti-nav-pills .nav-link.active::before {
    border-left-color: #4b38b3;
  }
}

.animation-nav li {
  position: relative;
}

.animation-nav li a {
  color: var(--bs-body-color);
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  transition: all 0.4s;
  z-index: 1;
}

.animation-nav li a span {
  position: relative;
}

.animation-nav li a::before {
  content: "";
  position: absolute;
  top: 0;
  width: 0;
  right: 0;
  height: 100%;
  transition: width 0.4s cubic-bezier(0.51, 0.18, 0, 0.88) 0.1s;
  background-color: #4b38b3;
  z-index: -1;
}

.animation-nav li a.active,
.animation-nav li a:hover {
  color: #fff;
  background-color: transparent !important;
}

.animation-nav li a.active::before,
.animation-nav li a:hover::before {
  width: 100%;
  left: 0;
}

.nav-border-top .nav-link {
  border-top: 3px solid transparent;
}

.nav-border-top .nav-link.active {
  border-top-color: #4b38b3;
}

.nav-border-top-primary .nav-link.active {
  color: #4b38b3;
  border-top-color: #4b38b3;
}

.nav-border-top-secondary .nav-link.active {
  color: #3577f1;
  border-top-color: #3577f1;
}

.nav-border-top-success .nav-link.active {
  color: #45cb85;
  border-top-color: #45cb85;
}

.nav-border-top-info .nav-link.active {
  color: #299cdb;
  border-top-color: #299cdb;
}

.nav-border-top-warning .nav-link.active {
  color: #ffbe0b;
  border-top-color: #ffbe0b;
}

.nav-border-top-danger .nav-link.active {
  color: #f06548;
  border-top-color: #f06548;
}

.nav-border-top-light .nav-link.active {
  color: #f3f6f9;
  border-top-color: #f3f6f9;
}

.nav-border-top-dark .nav-link.active {
  color: #212529;
  border-top-color: #212529;
}

.nav-custom {
  background-color: #4b38b3;
  border-radius: 0.25rem;
}

.nav-custom .nav-item .nav-link {
  color: rgba(255, 255, 255, 0.75);
}

.nav-custom .nav-item .nav-link.active {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
}

.nav-custom.nav-custom-light .nav-item .nav-link {
  color: rgba(var(--bs-dark-rgb), 0.75);
}

.nav-custom.nav-custom-light .nav-item .nav-link.active {
  color: #f3f6f9;
  background-color: #4b38b3;
}

.nav-custom-primary {
  background-color: #4b38b3;
}

.nav-custom-secondary {
  background-color: #3577f1;
}

.nav-custom-success {
  background-color: #45cb85;
}

.nav-custom-info {
  background-color: #299cdb;
}

.nav-custom-warning {
  background-color: #ffbe0b;
}

.nav-custom-danger {
  background-color: #f06548;
}

.nav-custom-light {
  background-color: #f3f6f9;
}

.nav-custom-dark {
  background-color: #212529;
}

.nav-custom-light {
  background-color: var(--bs-light);
}

.nav-primary .nav-link.active {
  color: #fff;
  background-color: #4b38b3;
}

.nav-primary.nav-tabs .nav-link.active {
  color: #4b38b3;
  background-color: var(--bs-card-bg-custom);
}

.nav-primary.nav-tabs-custom .nav-link.active {
  color: #4b38b3;
  background-color: var(--bs-card-bg-custom);
}

.nav-primary.nav-tabs-custom .nav-link.active::after {
  background-color: #4b38b3;
}

.nav-primary.arrow-navtabs .nav-link.active::before {
  border-top-color: #4b38b3;
}

.nav-primary.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #4b38b3;
}

.nav-secondary .nav-link.active {
  color: #fff;
  background-color: #3577f1;
}

.nav-secondary.nav-tabs .nav-link.active {
  color: #3577f1;
  background-color: var(--bs-card-bg-custom);
}

.nav-secondary.nav-tabs-custom .nav-link.active {
  color: #3577f1;
  background-color: var(--bs-card-bg-custom);
}

.nav-secondary.nav-tabs-custom .nav-link.active::after {
  background-color: #3577f1;
}

.nav-secondary.arrow-navtabs .nav-link.active::before {
  border-top-color: #3577f1;
}

.nav-secondary.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #3577f1;
}

.nav-success .nav-link.active {
  color: #fff;
  background-color: #45cb85;
}

.nav-success.nav-tabs .nav-link.active {
  color: #45cb85;
  background-color: var(--bs-card-bg-custom);
}

.nav-success.nav-tabs-custom .nav-link.active {
  color: #45cb85;
  background-color: var(--bs-card-bg-custom);
}

.nav-success.nav-tabs-custom .nav-link.active::after {
  background-color: #45cb85;
}

.nav-success.arrow-navtabs .nav-link.active::before {
  border-top-color: #45cb85;
}

.nav-success.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #45cb85;
}

.nav-info .nav-link.active {
  color: #fff;
  background-color: #299cdb;
}

.nav-info.nav-tabs .nav-link.active {
  color: #299cdb;
  background-color: var(--bs-card-bg-custom);
}

.nav-info.nav-tabs-custom .nav-link.active {
  color: #299cdb;
  background-color: var(--bs-card-bg-custom);
}

.nav-info.nav-tabs-custom .nav-link.active::after {
  background-color: #299cdb;
}

.nav-info.arrow-navtabs .nav-link.active::before {
  border-top-color: #299cdb;
}

.nav-info.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #299cdb;
}

.nav-warning .nav-link.active {
  color: #fff;
  background-color: #ffbe0b;
}

.nav-warning.nav-tabs .nav-link.active {
  color: #ffbe0b;
  background-color: var(--bs-card-bg-custom);
}

.nav-warning.nav-tabs-custom .nav-link.active {
  color: #ffbe0b;
  background-color: var(--bs-card-bg-custom);
}

.nav-warning.nav-tabs-custom .nav-link.active::after {
  background-color: #ffbe0b;
}

.nav-warning.arrow-navtabs .nav-link.active::before {
  border-top-color: #ffbe0b;
}

.nav-warning.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #ffbe0b;
}

.nav-danger .nav-link.active {
  color: #fff;
  background-color: #f06548;
}

.nav-danger.nav-tabs .nav-link.active {
  color: #f06548;
  background-color: var(--bs-card-bg-custom);
}

.nav-danger.nav-tabs-custom .nav-link.active {
  color: #f06548;
  background-color: var(--bs-card-bg-custom);
}

.nav-danger.nav-tabs-custom .nav-link.active::after {
  background-color: #f06548;
}

.nav-danger.arrow-navtabs .nav-link.active::before {
  border-top-color: #f06548;
}

.nav-danger.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #f06548;
}

.nav-light .nav-link.active {
  color: #fff;
  background-color: #f3f6f9;
}

.nav-light.nav-tabs .nav-link.active {
  color: #f3f6f9;
  background-color: var(--bs-card-bg-custom);
}

.nav-light.nav-tabs-custom .nav-link.active {
  color: #f3f6f9;
  background-color: var(--bs-card-bg-custom);
}

.nav-light.nav-tabs-custom .nav-link.active::after {
  background-color: #f3f6f9;
}

.nav-light.arrow-navtabs .nav-link.active::before {
  border-top-color: #f3f6f9;
}

.nav-light.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #f3f6f9;
}

.nav-dark .nav-link.active {
  color: #fff;
  background-color: #212529;
}

.nav-dark.nav-tabs .nav-link.active {
  color: #212529;
  background-color: var(--bs-card-bg-custom);
}

.nav-dark.nav-tabs-custom .nav-link.active {
  color: #212529;
  background-color: var(--bs-card-bg-custom);
}

.nav-dark.nav-tabs-custom .nav-link.active::after {
  background-color: #212529;
}

.nav-dark.arrow-navtabs .nav-link.active::before {
  border-top-color: #212529;
}

.nav-dark.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #212529;
}

.progress-nav {
  position: relative;
  margin-right: 1rem;
  margin-left: 1rem;
}

.progress-nav .progress {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
}

.progress-nav .nav {
  margin-right: -1rem;
  margin-left: -1rem;
  justify-content: space-between;
}

.progress-nav .nav .nav-link {
  width: 2rem;
  height: 2rem;
  background-color: var(--bs-light);
  padding: 0;
  color: var(--bs-dark);
  font-weight: 500;
}

.progress-nav .nav .nav-link.active,
.progress-nav .nav .nav-link.done {
  background-color: #4b38b3;
  color: #fff;
}

.step-arrow-nav .nav {
  background-color: var(--bs-light);
}

.step-arrow-nav .nav .nav-link {
  border-radius: 0;
  position: relative;
  font-weight: 500;
  color: var(--bs-dark);
}

.step-arrow-nav .nav .nav-link::before {
  content: "";
  position: absolute;
  border: 7px solid transparent;
  right: -14px;
  top: 50%;
  transform: translateY(-50%);
}

.step-arrow-nav .nav .nav-link.done {
  background-color: rgba(75, 56, 179, 0.05);
  color: #4b38b3;
}

.step-arrow-nav .nav .nav-link.done::before {
  border-left-color: transparent;
}

.step-arrow-nav .nav .nav-link.active {
  background-color: rgba(75, 56, 179, 0.1);
  color: #4b38b3;
  box-shadow: none;
}

.step-arrow-nav .nav .nav-link.active::before {
  border-left-color: rgba(75, 56, 179, 0.1);
}

.step-arrow-nav .nav .nav-item:last-child .nav-link:before {
  display: none;
}

.vertical-navs-step .nav {
  gap: 16px;
}

.vertical-navs-step .nav .nav-link {
  text-align: left;
  background-color: rgba(var(--bs-light-rgb), 0.4);
  border: 1px solid var(--bs-border-color);
  color: var(--bs-dark);
}

.vertical-navs-step .nav .nav-link .step-title {
  font-weight: 600;
}

.vertical-navs-step .nav .nav-link .step-icon {
  color: #f06548;
  vertical-align: middle;
  font-weight: 500;
  float: left;
}

.vertical-navs-step .nav .nav-link.active .step-icon,
.vertical-navs-step .nav .nav-link.done .step-icon {
  color: #45cb85;
}

.vertical-navs-step .nav .nav-link.active .step-icon:before,
.vertical-navs-step .nav .nav-link.done .step-icon:before {
  content: "\\eb80";
}

.vertical-navs-step .nav .nav-link.active {
  border-color: #4b38b3;
}

.vertical-navs-step .nav .nav-link.done {
  border-color: #45cb85;
}

.nav-custom-outline.nav .nav-link {
  border: 1px solid transparent;
  border-bottom: 2px solid transparent;
}

.nav-custom-outline.nav .nav-link.active {
  border-color: #4b38b3;
  background-color: transparent;
  color: #4b38b3;
}

.nav-primary.nav-custom-outline .nav-link.active {
  color: #4b38b3;
  border-color: #4b38b3;
}

.nav-secondary.nav-custom-outline .nav-link.active {
  color: #3577f1;
  border-color: #3577f1;
}

.nav-success.nav-custom-outline .nav-link.active {
  color: #45cb85;
  border-color: #45cb85;
}

.nav-info.nav-custom-outline .nav-link.active {
  color: #299cdb;
  border-color: #299cdb;
}

.nav-warning.nav-custom-outline .nav-link.active {
  color: #ffbe0b;
  border-color: #ffbe0b;
}

.nav-danger.nav-custom-outline .nav-link.active {
  color: #f06548;
  border-color: #f06548;
}

.nav-light.nav-custom-outline .nav-link.active {
  color: #f3f6f9;
  border-color: #f3f6f9;
}

.nav-dark.nav-custom-outline .nav-link.active {
  color: #212529;
  border-color: #212529;
}

.nav-customs.nav {
  padding-left: 34px;
  overflow: hidden;
}

.nav-customs.nav .nav-link {
  position: relative;
  display: block;
  float: right;
  background-color: var(--bs-body-bg);
  margin-right: 46px;
  transition: all 0.5s ease;
}

.nav-customs.nav .nav-link::after,
.nav-customs.nav .nav-link::before {
  display: block;
  content: " ";
  position: absolute;
  top: -1px;
  bottom: -1px;
  width: 37px;
  background-color: var(--bs-body-bg);
  transition: all 0.5s ease;
}

.nav-customs.nav .nav-link::before {
  border-radius: 0 8px 0 0;
  right: -24px;
  transform: skew(30deg, 0deg);
}

.nav-customs.nav .nav-link::after {
  border-radius: 8px 0 0 0;
  left: -24px;
  transform: skew(-30deg, 0deg);
}

.nav-customs.nav .nav-link.active,
.nav-customs.nav .nav-link.active:after,
.nav-customs.nav .nav-link.active:before {
  background-color: #4b38b3;
  color: #fff;
}

.nav-customs.nav .nav-link.active {
  z-index: 1;
}

.table th {
  font-weight: 600;
}

.table > thead {
  border-color: var(--bs-border-color);
}

.table > :not(:first-child) {
  border-top-width: 1px;
}

.table-nowrap td,
.table-nowrap th {
  white-space: nowrap;
}

.table-card {
  margin: -1rem -1rem;
}

.table-card td:first-child,
.table-card th:first-child {
  padding-left: 16px;
}

.table-card td:last-child,
.table-card th:last-child {
  padding-right: 16px;
}

.table-card .table > :not(:first-child) {
  border-top-width: 1px;
}

.border-primary.table > thead {
  border-color: #4b38b3 !important;
}

.table-primary.table > thead {
  border-bottom-color: #6654ca !important;
}

.border-secondary.table > thead {
  border-color: #3577f1 !important;
}

.table-secondary.table > thead {
  border-bottom-color: #6597f4 !important;
}

.border-success.table > thead {
  border-color: #45cb85 !important;
}

.table-success.table > thead {
  border-bottom-color: #6dd69f !important;
}

.border-info.table > thead {
  border-color: #299cdb !important;
}

.table-info.table > thead {
  border-bottom-color: #55b0e2 !important;
}

.border-warning.table > thead {
  border-color: #ffbe0b !important;
}

.table-warning.table > thead {
  border-bottom-color: #ffcc3e !important;
}

.border-danger.table > thead {
  border-color: #f06548 !important;
}

.table-danger.table > thead {
  border-bottom-color: #f48d77 !important;
}

.border-light.table > thead {
  border-color: #f3f6f9 !important;
}

.table-light.table > thead {
  border-bottom-color: #fff !important;
}

.border-dark.table > thead {
  border-color: #212529 !important;
}

.table-dark.table > thead {
  border-bottom-color: #383f45 !important;
}

.table .form-check {
  padding-left: 0;
  margin-bottom: 0;
}

.table .form-check .form-check-input {
  margin-left: 0;
  margin-top: 0;
  float: none;
  vertical-align: middle;
}

.table .sort {
  position: relative;
}

.table .sort::before {
  content: "\\f035d";
  position: absolute;
  right: 0.5rem;
  top: 18px;
  font-size: 0.8rem;
  font-family: "Material Design Icons";
}

.table .sort::after {
  position: absolute;
  right: 0.5rem;
  content: "\\f0360";
  font-family: "Material Design Icons";
  font-size: 0.8rem;
  top: 12px;
}

.modal-title {
  font-weight: 600;
}

.modal-dialog:not(.modal-dialog-scrollable) .modal-header {
  padding-bottom: 0;
}

.modal-dialog:not(.modal-dialog-scrollable) .modal-header .btn-close {
  margin-top: -1.25rem 1.25rem;
}

.modal-dialog:not(.modal-dialog-scrollable) .modal-footer {
  padding-top: 0;
}

.modal.fadeInRight .modal-dialog {
  opacity: 0;
  transform: translateX(20%);
  transition: all 0.3s ease-in-out;
}

.modal.fadeInRight.show .modal-dialog {
  opacity: 1;
  transform: translateX(0);
}

.modal.fadeInLeft .modal-dialog {
  animation: fadeInLeft 0.3s ease-in-out;
  transform: translate(-50%, 0);
}

.modal.fadeInLeft.show .modal-dialog {
  transform: none;
}

.modal.fadeInUp .modal-dialog {
  animation: fadeInUp 0.3s ease-in-out;
  transform: translate(0, 30%);
}

.modal.fadeInUp.show .modal-dialog {
  transform: none;
}

.modal.flip {
  perspective: 1300px;
}

.modal.flip .modal-dialog {
  opacity: 0;
  transform: rotateY(-70deg);
  transition: all 0.3s;
}

.modal.flip.show .modal-dialog {
  opacity: 1;
  transform: rotateY(0);
}

.modal.zoomIn .modal-dialog {
  opacity: 0;
  transform: scale(0.7);
  transition: all 0.3s ease;
}

.modal.zoomIn.show .modal-dialog {
  opacity: 1;
  transform: scale(1);
}

.modal-dialog-right {
  margin-right: 1.75rem;
}

.modal-dialog-bottom {
  display: flex;
  align-items: flex-end;
  min-height: calc(100% - 1.75rem);
}

@media (min-width: 576px) {
  .modal-dialog-bottom {
    min-height: calc(100% - 3.5rem);
  }
}

.modal-dialog-bottom-right {
  display: flex;
  align-items: flex-end;
  min-height: calc(100% - 1.75rem);
  margin-right: 1.75rem;
}

@media (min-width: 576px) {
  .modal-dialog-bottom-right {
    min-height: calc(100% - 3.5rem);
  }
}

@keyframes fadeInLeft {
  0% {
    opacity: 0;
    transform: translate3d(-30%, 0, 0);
  }

  to {
    opacity: 1;
    transform: translateZ(0);
  }
}

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translate3d(0, 30%, 0);
  }

  to {
    opacity: 1;
    transform: translateZ(0);
  }
}

@keyframes zoomIn {
  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}

.login-modal {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-size: cover;
  background-position: center;
}

.pagination-separated .page-item .page-link {
  margin-left: 0.35rem;
  border-radius: 0.25rem;
}

.pagination-rounded .page-link {
  border-radius: 30px !important;
  margin: 0 3px !important;
  border: none;
  min-width: 32px;
  min-height: 32px;
  text-align: center;
}

.pagination-rounded.pagination-sm .page-link {
  min-width: 25px;
  min-height: 25px;
}

.page-item.active .page-link {
  box-shadow: var(--bs-box-shadow);
}

.progress-sm {
  height: 5px;
}

.progress-lg {
  height: 12px;
}

.progress-xl {
  height: 16px;
}

.custom-progess {
  position: relative;
}

.custom-progess .progress-icon {
  position: absolute;
  top: -12px;
}

.custom-progess .progress-icon .avatar-title {
  background: var(--bs-card-bg-custom);
}

.animated-progress {
  position: relative;
}

.animated-progress .progress-bar {
  position: relative;
  border-radius: 6px;
  animation: animate-positive 2s;
}

@keyframes animate-positive {
  0% {
    width: 0;
  }
}

.custom-progress {
  height: 15px;
  padding: 4px;
  border-radius: 30px;
}

.custom-progress .progress-bar {
  position: relative;
  border-radius: 30px;
}

.custom-progress .progress-bar::before {
  content: "";
  position: absolute;
  width: 4px;
  height: 4px;
  background-color: #fff;
  border-radius: 7px;
  right: 2px;
  top: 50%;
  transform: translateY(-50%);
}

.progress-label {
  overflow: visible;
}

.progress-label .progress-bar {
  position: relative;
  overflow: visible;
}

.progress-label .progress-bar .label {
  position: absolute;
  top: -25px;
  right: -9px;
  background-color: #4b38b3;
  color: #fff;
  display: inline-block;
  line-height: 18px;
  padding: 0 4px;
  border-radius: 4px;
}

.progress-label .progress-bar .label:after {
  content: "";
  position: absolute;
  border: 4px solid transparent;
  border-top-color: #4b38b3;
  bottom: -7px;
  left: 50%;
  transform: translateX(-50%);
}

.progress-step-arrow {
  height: 3.25rem;
}

.progress-step-arrow .progress-bar {
  position: relative;
  overflow: initial;
  font-size: 0.875rem;
  color: #fff;
}

.progress-step-arrow .progress-bar::after {
  content: "";
  position: absolute;
  border: 10px solid transparent;
  bottom: 15px;
  right: -20px;
  z-index: 1;
}

.progress-primary .progress-bar {
  background-color: #4b38b3;
}

.progress-primary .progress-bar::after {
  border-left-color: #4b38b3;
}

.progress-primary .progress-bar:nth-child(2) {
  background-color: rgba(75, 56, 179, 0.1) !important;
  color: #4b38b3 !important;
}

.progress-primary .progress-bar:nth-child(2)::after {
  border-left-color: rgba(75, 56, 179, 0.1);
}

.progress-secondary .progress-bar {
  background-color: #3577f1;
}

.progress-secondary .progress-bar::after {
  border-left-color: #3577f1;
}

.progress-secondary .progress-bar:nth-child(2) {
  background-color: rgba(53, 119, 241, 0.1) !important;
  color: #3577f1 !important;
}

.progress-secondary .progress-bar:nth-child(2)::after {
  border-left-color: rgba(53, 119, 241, 0.1);
}

.progress-success .progress-bar {
  background-color: #45cb85;
}

.progress-success .progress-bar::after {
  border-left-color: #45cb85;
}

.progress-success .progress-bar:nth-child(2) {
  background-color: rgba(69, 203, 133, 0.1) !important;
  color: #45cb85 !important;
}

.progress-success .progress-bar:nth-child(2)::after {
  border-left-color: rgba(69, 203, 133, 0.1);
}

.progress-info .progress-bar {
  background-color: #299cdb;
}

.progress-info .progress-bar::after {
  border-left-color: #299cdb;
}

.progress-info .progress-bar:nth-child(2) {
  background-color: rgba(41, 156, 219, 0.1) !important;
  color: #299cdb !important;
}

.progress-info .progress-bar:nth-child(2)::after {
  border-left-color: rgba(41, 156, 219, 0.1);
}

.progress-warning .progress-bar {
  background-color: #ffbe0b;
}

.progress-warning .progress-bar::after {
  border-left-color: #ffbe0b;
}

.progress-warning .progress-bar:nth-child(2) {
  background-color: rgba(255, 190, 11, 0.1) !important;
  color: #ffbe0b !important;
}

.progress-warning .progress-bar:nth-child(2)::after {
  border-left-color: rgba(255, 190, 11, 0.1);
}

.progress-danger .progress-bar {
  background-color: #f06548;
}

.progress-danger .progress-bar::after {
  border-left-color: #f06548;
}

.progress-danger .progress-bar:nth-child(2) {
  background-color: rgba(240, 101, 72, 0.1) !important;
  color: #f06548 !important;
}

.progress-danger .progress-bar:nth-child(2)::after {
  border-left-color: rgba(240, 101, 72, 0.1);
}

.progress-light .progress-bar {
  background-color: #f3f6f9;
}

.progress-light .progress-bar::after {
  border-left-color: #f3f6f9;
}

.progress-light .progress-bar:nth-child(2) {
  background-color: rgba(243, 246, 249, 0.1) !important;
  color: #f3f6f9 !important;
}

.progress-light .progress-bar:nth-child(2)::after {
  border-left-color: rgba(243, 246, 249, 0.1);
}

.progress-dark .progress-bar {
  background-color: #212529;
}

.progress-dark .progress-bar::after {
  border-left-color: #212529;
}

.progress-dark .progress-bar:nth-child(2) {
  background-color: rgba(33, 37, 41, 0.1) !important;
  color: #212529 !important;
}

.progress-dark .progress-bar:nth-child(2)::after {
  border-left-color: rgba(33, 37, 41, 0.1);
}

.popover {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
}

.text-white-75 {
  color: rgba(255, 255, 255, 0.75) !important;
}

.custom-blockquote.blockquote {
  padding: 16px;
  border-left: 3px solid;
}

.custom-blockquote.blockquote.blockquote-outline {
  background-color: var(--bs-card-bg-custom) !important;
  border: 1px solid;
  border-left: 3px solid;
}

.custom-blockquote.blockquote.blockquote-primary {
  color: #4b38b3;
  border-color: #4b38b3;
  background-color: rgba(75, 56, 179, 0.15);
}

.custom-blockquote.blockquote.blockquote-primary .blockquote-footer {
  color: #4b38b3;
}

.custom-blockquote.blockquote.blockquote-outline.blockquote-primary {
  border-color: #4b38b3;
}

.custom-blockquote.blockquote.blockquote-outline.blockquote-primary
  .blockquote-footer {
  color: #4b38b3;
}

.custom-blockquote.blockquote.blockquote-secondary {
  color: #3577f1;
  border-color: #3577f1;
  background-color: rgba(53, 119, 241, 0.15);
}

.custom-blockquote.blockquote.blockquote-secondary .blockquote-footer {
  color: #3577f1;
}

.custom-blockquote.blockquote.blockquote-outline.blockquote-secondary {
  border-color: #3577f1;
}

.custom-blockquote.blockquote.blockquote-outline.blockquote-secondary
  .blockquote-footer {
  color: #3577f1;
}

.custom-blockquote.blockquote.blockquote-success {
  color: #45cb85;
  border-color: #45cb85;
  background-color: rgba(69, 203, 133, 0.15);
}

.custom-blockquote.blockquote.blockquote-success .blockquote-footer {
  color: #45cb85;
}

.custom-blockquote.blockquote.blockquote-outline.blockquote-success {
  border-color: #45cb85;
}

.custom-blockquote.blockquote.blockquote-outline.blockquote-success
  .blockquote-footer {
  color: #45cb85;
}

.custom-blockquote.blockquote.blockquote-info {
  color: #299cdb;
  border-color: #299cdb;
  background-color: rgba(41, 156, 219, 0.15);
}

.custom-blockquote.blockquote.blockquote-info .blockquote-footer {
  color: #299cdb;
}

.custom-blockquote.blockquote.blockquote-outline.blockquote-info {
  border-color: #299cdb;
}

.custom-blockquote.blockquote.blockquote-outline.blockquote-info
  .blockquote-footer {
  color: #299cdb;
}

.custom-blockquote.blockquote.blockquote-warning {
  color: #ffbe0b;
  border-color: #ffbe0b;
  background-color: rgba(255, 190, 11, 0.15);
}

.custom-blockquote.blockquote.blockquote-warning .blockquote-footer {
  color: #ffbe0b;
}

.custom-blockquote.blockquote.blockquote-outline.blockquote-warning {
  border-color: #ffbe0b;
}

.custom-blockquote.blockquote.blockquote-outline.blockquote-warning
  .blockquote-footer {
  color: #ffbe0b;
}

.custom-blockquote.blockquote.blockquote-danger {
  color: #f06548;
  border-color: #f06548;
  background-color: rgba(240, 101, 72, 0.15);
}

.custom-blockquote.blockquote.blockquote-danger .blockquote-footer {
  color: #f06548;
}

.custom-blockquote.blockquote.blockquote-outline.blockquote-danger {
  border-color: #f06548;
}

.custom-blockquote.blockquote.blockquote-outline.blockquote-danger
  .blockquote-footer {
  color: #f06548;
}

.custom-blockquote.blockquote.blockquote-light {
  color: #f3f6f9;
  border-color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.15);
}

.custom-blockquote.blockquote.blockquote-light .blockquote-footer {
  color: #f3f6f9;
}

.custom-blockquote.blockquote.blockquote-outline.blockquote-light {
  border-color: #f3f6f9;
}

.custom-blockquote.blockquote.blockquote-outline.blockquote-light
  .blockquote-footer {
  color: #f3f6f9;
}

.custom-blockquote.blockquote.blockquote-dark {
  color: #212529;
  border-color: #212529;
  background-color: rgba(33, 37, 41, 0.15);
}

.custom-blockquote.blockquote.blockquote-dark .blockquote-footer {
  color: #212529;
}

.custom-blockquote.blockquote.blockquote-outline.blockquote-dark {
  border-color: #212529;
}

.custom-blockquote.blockquote.blockquote-outline.blockquote-dark
  .blockquote-footer {
  color: #212529;
}

.custom-blockquote.blockquote.blockquote-dark {
  color: var(--bs-dark);
  border-color: var(--bs-dark);
  background-color: rgba(var(--bs-dark-rgb), 0.15);
}

.custom-blockquote.blockquote.blockquote-dark .blockquote-footer {
  color: var(--bs-dark);
}

.custom-blockquote.blockquote.blockquote-outline.blockquote-dark {
  border-color: var(--bs-dark);
}

.custom-blockquote.blockquote.blockquote-outline.blockquote-dark
  .blockquote-footer {
  color: var(--bs-dark);
}

.form-check {
  position: relative;
  text-align: left;
}

.form-check .form-check-input {
  cursor: pointer;
}

.form-check label {
  cursor: pointer;
}

.form-check-primary .form-check-input:checked {
  background-color: #4b38b3;
  border-color: #4b38b3;
}

.form-radio-primary .form-check-input:checked {
  border-color: #4b38b3;
  background-color: #4b38b3;
}

.form-radio-primary .form-check-input:checked:after {
  background-color: #4b38b3;
}

.form-check-secondary .form-check-input:checked {
  background-color: #3577f1;
  border-color: #3577f1;
}

.form-radio-secondary .form-check-input:checked {
  border-color: #3577f1;
  background-color: #3577f1;
}

.form-radio-secondary .form-check-input:checked:after {
  background-color: #3577f1;
}

.form-check-success .form-check-input:checked {
  background-color: #45cb85;
  border-color: #45cb85;
}

.form-radio-success .form-check-input:checked {
  border-color: #45cb85;
  background-color: #45cb85;
}

.form-radio-success .form-check-input:checked:after {
  background-color: #45cb85;
}

.form-check-info .form-check-input:checked {
  background-color: #299cdb;
  border-color: #299cdb;
}

.form-radio-info .form-check-input:checked {
  border-color: #299cdb;
  background-color: #299cdb;
}

.form-radio-info .form-check-input:checked:after {
  background-color: #299cdb;
}

.form-check-warning .form-check-input:checked {
  background-color: #ffbe0b;
  border-color: #ffbe0b;
}

.form-radio-warning .form-check-input:checked {
  border-color: #ffbe0b;
  background-color: #ffbe0b;
}

.form-radio-warning .form-check-input:checked:after {
  background-color: #ffbe0b;
}

.form-check-danger .form-check-input:checked {
  background-color: #f06548;
  border-color: #f06548;
}

.form-radio-danger .form-check-input:checked {
  border-color: #f06548;
  background-color: #f06548;
}

.form-radio-danger .form-check-input:checked:after {
  background-color: #f06548;
}

.form-check-light .form-check-input:checked {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
}

.form-radio-light .form-check-input:checked {
  border-color: #f3f6f9;
  background-color: #f3f6f9;
}

.form-radio-light .form-check-input:checked:after {
  background-color: #f3f6f9;
}

.form-check-dark .form-check-input:checked {
  background-color: #212529;
  border-color: #212529;
}

.form-radio-dark .form-check-input:checked {
  border-color: #212529;
  background-color: #212529;
}

.form-radio-dark .form-check-input:checked:after {
  background-color: #212529;
}

.form-check-label {
  cursor: pointer;
  margin-bottom: 0;
}

.form-check-right {
  padding-left: 0;
  display: inline-block;
}

.form-check-right .form-check-input {
  float: right;
  margin-left: 0;
  margin-right: -1.6em;
}

.form-check-right .form-check-label {
  display: block;
}

.form-check-right.form-switch .form-check-input {
  margin-right: -2.56em;
}

.form-check-outline.form-check-primary
  .form-check-input:checked[type="checkbox"] {
  color: #4b38b3;
  background-color: transparent;
  border-color: #4b38b3;
}

.form-check-outline.form-check-secondary
  .form-check-input:checked[type="checkbox"] {
  color: #3577f1;
  background-color: transparent;
  border-color: #3577f1;
}

.form-check-outline.form-check-success
  .form-check-input:checked[type="checkbox"] {
  color: #45cb85;
  background-color: transparent;
  border-color: #45cb85;
}

.form-check-outline.form-check-info .form-check-input:checked[type="checkbox"] {
  color: #299cdb;
  background-color: transparent;
  border-color: #299cdb;
}

.form-check-outline.form-check-warning
  .form-check-input:checked[type="checkbox"] {
  color: #ffbe0b;
  background-color: transparent;
  border-color: #ffbe0b;
}

.form-check-outline.form-check-danger
  .form-check-input:checked[type="checkbox"] {
  color: #f06548;
  background-color: transparent;
  border-color: #f06548;
}

.form-check-outline.form-check-light
  .form-check-input:checked[type="checkbox"] {
  color: #f3f6f9;
  background-color: transparent;
  border-color: #f3f6f9;
}

.form-check-outline.form-check-dark .form-check-input:checked[type="checkbox"] {
  color: #212529;
  background-color: transparent;
  border-color: #212529;
}

.form-check-outline .form-check-input {
  position: relative;
}

.form-check-outline .form-check-input:checked[type="checkbox"] {
  background-image: none;
}

.form-check-outline .form-check-input:checked[type="checkbox"]::before {
  content: "\\f012c";
  font-family: "Material Design Icons";
  top: -2px;
  position: absolute;
  font-weight: 700;
  font-size: 11px;
  left: 1px;
}

.form-radio-outline.form-radio-primary .form-check-input:checked[type="radio"] {
  color: #4b38b3;
  background-color: transparent;
  border-color: #4b38b3;
}

.form-radio-outline.form-radio-secondary
  .form-check-input:checked[type="radio"] {
  color: #3577f1;
  background-color: transparent;
  border-color: #3577f1;
}

.form-radio-outline.form-radio-success .form-check-input:checked[type="radio"] {
  color: #45cb85;
  background-color: transparent;
  border-color: #45cb85;
}

.form-radio-outline.form-radio-info .form-check-input:checked[type="radio"] {
  color: #299cdb;
  background-color: transparent;
  border-color: #299cdb;
}

.form-radio-outline.form-radio-warning .form-check-input:checked[type="radio"] {
  color: #ffbe0b;
  background-color: transparent;
  border-color: #ffbe0b;
}

.form-radio-outline.form-radio-danger .form-check-input:checked[type="radio"] {
  color: #f06548;
  background-color: transparent;
  border-color: #f06548;
}

.form-radio-outline.form-radio-light .form-check-input:checked[type="radio"] {
  color: #f3f6f9;
  background-color: transparent;
  border-color: #f3f6f9;
}

.form-radio-outline.form-radio-dark .form-check-input:checked[type="radio"] {
  color: #212529;
  background-color: transparent;
  border-color: #212529;
}

.form-radio-outline .form-check-input {
  position: relative;
}

.form-radio-outline .form-check-input:checked[type="radio"] {
  background-image: none;
}

.form-radio-outline .form-check-input:checked[type="radio"]::before {
  content: "\\f0765";
  font-family: "Material Design Icons";
  top: 0;
  position: absolute;
  font-size: 8px;
  left: 2.2px;
}

.form-switch-md {
  padding-left: 2.5rem;
  min-height: 22px;
  line-height: 22px;
}

.form-switch-md .form-check-input {
  width: 40px;
  height: 20px;
  left: -0.5rem;
  position: relative;
}

.form-switch-md .form-check-label {
  vertical-align: middle;
}

.form-switch-lg {
  padding-left: 2.75rem;
  min-height: 28px;
  line-height: 28px;
}

.form-switch-lg .form-check-input {
  width: 48px;
  height: 24px;
  left: -0.75rem;
  position: relative;
}

.input-group-text {
  margin-bottom: 0;
}

.form-switch-primary .form-check-input:checked {
  background-color: #4b38b3;
  border-color: #4b38b3;
}

.form-switch-custom.form-switch-primary .form-check-input:checked::before {
  color: #180f5a;
}

.form-switch-secondary .form-check-input:checked {
  background-color: #3577f1;
  border-color: #3577f1;
}

.form-switch-custom.form-switch-secondary .form-check-input:checked::before {
  color: #3577f1;
}

.form-switch-success .form-check-input:checked {
  background-color: #45cb85;
  border-color: #45cb85;
}

.form-switch-custom.form-switch-success .form-check-input:checked::before {
  color: #45cb85;
}

.form-switch-info .form-check-input:checked {
  background-color: #299cdb;
  border-color: #299cdb;
}

.form-switch-custom.form-switch-info .form-check-input:checked::before {
  color: #299cdb;
}

.form-switch-warning .form-check-input:checked {
  background-color: #ffbe0b;
  border-color: #ffbe0b;
}

.form-switch-custom.form-switch-warning .form-check-input:checked::before {
  color: #ffbe0b;
}

.form-switch-danger .form-check-input:checked {
  background-color: #f06548;
  border-color: #f06548;
}

.form-switch-custom.form-switch-danger .form-check-input:checked::before {
  color: #f06548;
}

.form-switch-light .form-check-input:checked {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
}

.form-switch-custom.form-switch-light .form-check-input:checked::before {
  color: #f3f6f9;
}

.form-switch-dark .form-check-input:checked {
  background-color: #212529;
  border-color: #212529;
}

.form-switch-custom.form-switch-dark .form-check-input:checked::before {
  color: #212529;
}

.form-switch-custom .form-check-input {
  position: relative;
  background-image: none;
}

.form-switch-custom .form-check-input::before {
  content: "\\f0765";
  font-family: "Material Design Icons";
  top: -9px;
  position: absolute;
  font-size: 20px;
  left: -3px;
  color: #878a99;
  transition: background-position 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-switch-custom .form-check-input::before {
    transition: none;
  }
}

.form-switch-custom .form-check-input:checked {
  background-image: none;
  background-color: var(--bs-input-bg);
  transition: background-position 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-switch-custom .form-check-input:checked {
    transition: none;
  }
}

.form-switch-custom .form-check-input:checked::before {
  right: -3px;
  left: auto;
}

.form-switch-custom .form-check-input:focus {
  background-image: none;
}

.form-switch-right {
  display: inline-block;
  padding-right: 0.8em;
  margin-bottom: 0;
  padding-left: 0 !important;
}

.form-switch-right .form-check-input {
  float: right;
  margin-left: 0;
  margin-right: -1.6em;
  margin-top: 0.1em !important;
}

.form-switch-right label {
  margin-bottom: 0;
  margin-right: 1rem;
}

.card-radio {
  padding: 0;
}

.card-radio .form-check-label {
  background-color: var(--bs-card-bg-custom);
  border: 1px solid var(--bs-input-check-border) !important;
  border-radius: 0.25rem;
  padding: 1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  position: relative;
  padding-right: 32px;
}

.card-radio .form-check-label:hover {
  cursor: pointer;
}

.card-radio .form-check-input {
  display: none;
}

.card-radio .form-check-input:checked + .form-check-label {
  border-color: #4b38b3 !important;
}

.card-radio .form-check-input:checked + .form-check-label:before {
  content: "\\eb80";
  font-family: remixicon;
  position: absolute;
  top: 2px;
  right: 6px;
  font-size: 16px;
  color: #4b38b3;
}

.card-radio.dark .form-check-input:checked + .form-check-label:before {
  color: #fff;
}

[data-layout-mode="dark"] .form-switch .form-check-input,
[data-layout-mode="dark"] .form-switch .form-check-input:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
}

.form-icon {
  position: relative;
}

.form-icon .form-control-icon {
  padding-left: 2.7rem;
  position: relative;
}

.form-icon i {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 18px;
  display: flex;
  align-items: center;
}

.form-icon.right .form-control-icon {
  padding-right: 2.7rem;
  padding-left: 0.9rem;
  position: relative;
}

.form-icon.right i {
  left: auto;
  right: 18px;
}

[data-layout-mode="dark"] .form-select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  color: var(--bs-body-color);
  background-color: var(--bs-input-bg);
  border: 1px solid var(--bs-input-border);
}

[data-layout-mode="dark"] .form-control {
  color: white !important;
  background-color: var(--bs-input-bg);
  border: 1px solid var(--bs-input-border);
}

[data-layout-mode="dark"] .input-group-text {
  background-color: var(--bs-input-group-addon-bg);
  border: 1px solid var(--bs-input-border);
  color: var(--bs-body-color);
}

.list-group-fill-primary .list-group-item.active {
  background-color: #4b38b3 !important;
  border-color: #4b38b3;
}

.list-group-fill-secondary .list-group-item.active {
  background-color: #3577f1 !important;
  border-color: #3577f1;
}

.list-group-fill-success .list-group-item.active {
  background-color: #45cb85 !important;
  border-color: #45cb85;
}

.list-group-fill-info .list-group-item.active {
  background-color: #299cdb !important;
  border-color: #299cdb;
}

.list-group-fill-warning .list-group-item.active {
  background-color: #ffbe0b !important;
  border-color: #ffbe0b;
}

.list-group-fill-danger .list-group-item.active {
  background-color: #f06548 !important;
  border-color: #f06548;
}

.list-group-fill-light .list-group-item.active {
  background-color: #f3f6f9 !important;
  border-color: #f3f6f9;
}

.list-group-fill-dark .list-group-item.active {
  background-color: #212529 !important;
  border-color: #212529;
}

.list-group-fill-light {
  color: #212529 !important;
}

.list-group-item {
  margin-bottom: 0;
}

.list-group-item .list-text {
  color: #878a99;
}

.list-group-item.active {
  box-shadow: var(--bs-box-shadow);
}

.list-group-item.active .list-title {
  color: #fff;
}

.list-group-item.active .list-text {
  color: rgba(255, 255, 255, 0.5);
}

[data-simplebar] {
  position: relative;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
}

.simplebar-wrapper {
  overflow: hidden;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit;
}

.simplebar-mask {
  direction: inherit;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto !important;
  height: auto !important;
  z-index: 0;
}

.simplebar-offset {
  direction: inherit !important;
  box-sizing: inherit !important;
  resize: none !important;
  position: absolute;
  top: 0;
  left: 0 !important;
  bottom: 0;
  right: 0 !important;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch;
}

.simplebar-content-wrapper {
  direction: inherit;
  box-sizing: border-box !important;
  position: relative;
  display: block;
  height: 100%;
  width: auto;
  visibility: visible;
  overflow: auto;
  max-width: 100%;
  max-height: 100%;
  scrollbar-width: none;
  padding: 0 !important;
}

.simplebar-content-wrapper::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
  display: none;
}

.simplebar-content:after,
.simplebar-content:before {
  content: " ";
  display: table;
}

.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  pointer-events: none;
}

.simplebar-height-auto-observer-wrapper {
  box-sizing: inherit !important;
  height: 100%;
  width: 100%;
  max-width: 1px;
  position: relative;
  float: left;
  max-height: 1px;
  overflow: hidden;
  z-index: -1;
  padding: 0;
  margin: 0;
  pointer-events: none;
  flex-grow: inherit;
  flex-shrink: 0;
  flex-basis: 0;
}

.simplebar-height-auto-observer {
  box-sizing: inherit;
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 1000%;
  width: 1000%;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  pointer-events: none;
  z-index: -1;
}

.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
}

[data-simplebar].simplebar-dragging .simplebar-content {
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none;
}

[data-simplebar].simplebar-dragging .simplebar-track {
  pointer-events: all;
}

.simplebar-scrollbar {
  position: absolute;
  right: 2px;
  width: 6px;
  min-height: 10px;
}

.simplebar-scrollbar:before {
  position: absolute;
  content: "";
  background: #a2adb7;
  border-radius: 7px;
  left: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.2s linear;
}

.simplebar-scrollbar.simplebar-visible:before {
  opacity: 0.5;
  transition: opacity 0s linear;
}

.simplebar-track.simplebar-vertical {
  top: 0;
  width: 11px;
}

.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  top: 2px;
  bottom: 2px;
}

.simplebar-track.simplebar-horizontal {
  left: 0;
  height: 11px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {
  height: 100%;
  left: 2px;
  right: 2px;
}

.simplebar-track.simplebar-horizontal .simplebar-scrollbar {
  right: auto;
  left: 0;
  top: 2px;
  height: 7px;
  min-height: 0;
  min-width: 10px;
  width: auto;
}

[data-simplebar-direction="rtl"] .simplebar-track.simplebar-vertical {
  right: auto;
  left: 0;
}

.hs-dummy-scrollbar-size {
  direction: rtl;
  position: fixed;
  opacity: 0;
  visibility: hidden;
  height: 500px;
  width: 500px;
  overflow-y: hidden;
  overflow-x: scroll;
}

.simplebar-hide-scrollbar {
  position: fixed;
  left: 0;
  visibility: hidden;
  overflow-y: scroll;
  scrollbar-width: none;
}

.custom-scroll {
  height: 100%;
}

[data-simplebar-track="primary"] .simplebar-scrollbar:before {
  background: #4b38b3;
}

[data-simplebar-track="secondary"] .simplebar-scrollbar:before {
  background: #3577f1;
}

[data-simplebar-track="success"] .simplebar-scrollbar:before {
  background: #45cb85;
}

[data-simplebar-track="info"] .simplebar-scrollbar:before {
  background: #299cdb;
}

[data-simplebar-track="warning"] .simplebar-scrollbar:before {
  background: #ffbe0b;
}

[data-simplebar-track="danger"] .simplebar-scrollbar:before {
  background: #f06548;
}

[data-simplebar-track="light"] .simplebar-scrollbar:before {
  background: #f3f6f9;
}

[data-simplebar-track="dark"] .simplebar-scrollbar:before {
  background: #212529;
}

code[class*="language-"],
pre[class*="language-"] {
  color: #000;
  background: 0 0;
  text-shadow: 0 1px #fff;
  font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
  font-size: 1em;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  line-height: 1.5;
  tab-size: 4;
  hyphens: none;
}

code[class*="language-"] ::selection,
code[class*="language-"]::selection,
pre[class*="language-"] ::selection,
pre[class*="language-"]::selection {
  text-shadow: none;
  background: #b3d4fc;
}

@media print {
  code[class*="language-"],
  pre[class*="language-"] {
    text-shadow: none;
  }
}

pre[class*="language-"] {
  padding: 1em;
  margin: 0;
  overflow: auto;
}

:not(pre) > code[class*="language-"],
pre[class*="language-"] {
  background: var(--bs-light) !important;
}

:not(pre) > code[class*="language-"] {
  padding: 0.1em;
  border-radius: 0.3em;
  white-space: normal;
}

.token.cdata,
.token.comment,
.token.doctype,
.token.prolog {
  color: #708090;
}

.token.punctuation {
  color: #999;
}

.token.namespace {
  opacity: 0.7;
}

.token.boolean,
.token.constant,
.token.deleted,
.token.number,
.token.property,
.token.symbol,
.token.tag {
  color: #f06548;
}

.token.attr-name,
.token.builtin,
.token.char,
.token.inserted,
.token.selector,
.token.string {
  color: #690;
}

.language-css .token.string,
.style .token.string,
.token.entity,
.token.operator,
.token.url {
  color: #9a6e3a;
  background: hsla(0deg, 0%, 100%, 0.5);
}

.token.atrule,
.token.attr-value,
.token.keyword {
  color: #07a;
}

.token.class-name,
.token.function {
  color: #dd4a68;
}

.token.important,
.token.regex,
.token.variable {
  color: #e90;
}

.token.bold,
.token.important {
  font-weight: 700;
}

.token.italic {
  font-style: italic;
}

.token.entity {
  cursor: help;
}

:not(pre) > code[class*="language-"],
pre[class*="language-"] {
  background: #eff2f7;
}

code[class*="language-"],
pre[class*="language-"] {
  color: #878a99;
  text-shadow: none;
}

.language-markup::-webkit-scrollbar {
  -webkit-appearance: none;
}

.language-markup::-webkit-scrollbar:vertical {
  width: 10px;
}

.language-markup::-webkit-scrollbar:horizontal {
  height: 10px;
}

.language-markup::-webkit-scrollbar-thumb {
  background-color: rgba(var(--bs-dark-rgb), 0.1);
  border-radius: 10px;
  border: 2px solid var(--bs-light);
}

.language-markup::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: var(--bs-light);
}

#scroll-top {
  width: 30px;
  height: 30px;
  position: fixed;
  bottom: 65px;
  right: 30px;
  background: #343a40;
  border-color: transparent;
  border-radius: 3px;
  color: #fff;
  transition: all 0.5s ease;
}

.btn-clipboard {
  position: absolute !important;
  right: 15px !important;
  z-index: 1 !important;
}

div.code-toolbar > .toolbar {
  opacity: 1 !important;
}

div.code-toolbar > .toolbar button {
  display: inline-block !important;
  margin: 0.375rem 0.5rem !important;
  padding: 0.25rem 0.75rem !important;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
  border-radius: 0.2rem !important;
  border: 1px solid rgba(75, 56, 179, 0.35) !important;
  background-color: transparent;
  color: #4b38b3 !important;
  box-shadow: none !important;
}

div.code-toolbar > .toolbar button:focus {
  outline: 0 !important;
  box-shadow: none !important;
}

div.code-toolbar > .toolbar button:hover {
  background-color: #4b38b3 !important;
  color: #fff !important;
}

.swal2-container .swal2-title {
  padding: 24px 24px 0;
  font-size: 20px;
  font-weight: 500;
}

.swal2-popup {
  padding-bottom: 24px;
  border-radius: 0.3rem;
  background-color: var(--bs-card-bg-custom);
  color: var(--bs-body-color);
}

.swal2-popup .swal2-title {
  color: var(--bs-heading-color);
}

.swal2-popup .swal2-html-container {
  color: var(--bs-body-color);
}

.swal2-footer {
  border-top: 1px solid var(--bs-border-color);
  color: var(--bs-body-color);
}

.swal2-html-container {
  font-size: 16px;
}

.swal2-icon.swal2-question {
  border-color: #299cdb;
  color: #299cdb;
}

.swal2-icon.swal2-success [class^="swal2-success-line"] {
  background-color: #45cb85;
}

.swal2-icon.swal2-success .swal2-success-ring {
  border-color: rgba(69, 203, 133, 0.3);
}

.swal2-icon.swal2-warning {
  border-color: #ffbe0b;
  color: #ffbe0b;
}

.swal2-styled:focus {
  box-shadow: none;
}

.swal2-loader {
  border-color: #4b38b3 transparent #4b38b3 transparent;
}

.swal2-timer-progress-bar {
  background-color: rgba(69, 203, 133, 0.4);
}

.swal2-progress-steps .swal2-progress-step {
  background: #4b38b3;
}

.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {
  background: #4b38b3;
}

.swal2-progress-steps
  .swal2-progress-step.swal2-active-progress-step
  ~ .swal2-progress-step,
.swal2-progress-steps
  .swal2-progress-step.swal2-active-progress-step
  ~ .swal2-progress-step-line {
  background: rgba(75, 56, 179, 0.3);
}

.swal2-progress-steps .swal2-progress-step-line {
  background: #4b38b3;
}

.swal2-actions.swal2-loading .swal2-styled.swal2-confirm {
  border-left-color: #4b38b3 !important;
  border-right-color: #4b38b3 !important;
}

.swal2-file,
.swal2-input,
.swal2-textarea {
  border: 1px solid var(--bs-input-border);
}

.swal2-file:focus,
.swal2-input:focus,
.swal2-textarea:focus {
  box-shadow: none;
  border-color: var(--bs-input-focus-border);
}

.swal2-input {
  height: auto;
  display: block;
  padding: 0.5rem 0.9rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: var(--bs-input-bg);
  background-clip: padding-box;
  border: 1px solid var(--bs-input-border);
}

.swal2-close {
  font-family: var(--bs-font-sans-serif);
  font-weight: 300;
  font-size: 28px;
}

.swal2-close:focus {
  box-shadow: none;
}

.swal2-close:hover {
  color: #4b38b3;
}

.swal2-validation-message {
  background-color: transparent;
}

.dropzone {
  min-height: 230px;
  border: 2px dashed var(--bs-border-color);
  background: var(--bs-card-bg-custom);
  border-radius: 6px;
}

.dropzone .dz-message {
  font-size: 24px;
  width: 100%;
  margin: 1em 0;
}

.noUi-connect {
  background: #45cb85;
}

.noUi-handle {
  background: #45cb85;
  border: 2px solid var(--bs-card-bg);
  box-shadow: none;
}

.noUi-horizontal {
  height: 4px;
}

.noUi-horizontal .noUi-handle {
  height: 16px;
  width: 16px;
  border-radius: 50%;
  right: -10px !important;
  top: -7px;
}

.noUi-horizontal .noUi-handle::after,
.noUi-horizontal .noUi-handle::before {
  display: none;
}

.noUi-horizontal .noUi-handle:focus {
  outline: 0;
}

.noUi-pips-horizontal {
  height: 50px;
}

.noUi-tooltip {
  padding: 0.4rem 0.7rem;
  border-color: var(--bs-border-color);
  border-radius: 0.2rem;
  background-color: var(--bs-card-bg-custom);
  color: var(--bs-body-color);
}

.noUi-vertical {
  width: 4px;
}

.noUi-vertical .noUi-handle {
  height: 16px;
  width: 16px;
  right: -8px;
  top: -12px;
  left: auto;
  border-radius: 50%;
}

.noUi-vertical .noUi-handle::after,
.noUi-vertical .noUi-handle::before {
  display: none;
}

.noUi-vertical .noUi-handle:focus {
  outline: 0;
}

.noUi-vertical .noUi-origin {
  top: 0;
}

.noUi-value {
  font-size: 12px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 12px;
}

.noUi-value-horizontal {
  padding-top: 4px;
}

.noUi-target {
  box-shadow: none;
  background-color: var(--bs-light);
  border-color: var(--bs-light);
}

.noUi-touch-area:focus {
  outline: 0;
}

#blue,
#green,
#red {
  margin: 10px;
  display: inline-block;
  height: 200px;
}

#colorpicker {
  height: 240px;
  width: 310px;
  margin: 0 auto;
  padding: 10px;
  border: 1px solid var(--bs-border-color);
}

#result {
  margin: 60px 26px;
  height: 100px;
  width: 100px;
  display: inline-block;
  vertical-align: top;
  border: 1px solid var(--bs-border-color);
  box-shadow: 0 0 3px;
  border-radius: 7px;
}

#red .noUi-connect {
  background: #f06548;
}

#green .noUi-connect {
  background: #45cb85;
}

#blue .noUi-connect {
  background: #4b38b3;
}

.form-control.keyboard {
  max-width: 340px !important;
}

.example-val {
  font-size: 12px;
  color: #878a99;
  display: block;
  margin: 15px 0;
}

.example-val:before {
  content: "Value: ";
  font-size: 12px;
  font-weight: 600;
}

.noUi-tooltip {
  display: none;
}

.noUi-active .noUi-tooltip {
  display: block;
}

.c-1-color {
  background: #f06548;
}

.c-2-color {
  background: #ffbe0b;
}

.c-3-color {
  background: #45cb85;
}

.c-4-color {
  background: #4b38b3;
}

.c-5-color {
  background: #6559cc;
}

#slider-toggle {
  height: 50px;
}

#slider-toggle.off .noUi-handle {
  border-color: #f06548;
}

[data-slider-color="primary"] .noUi-connect {
  background: #4b38b3;
}

[data-slider-color="primary"] .noUi-handle {
  background: #4b38b3;
}

[data-slider-color="primary"][data-slider-style="border"] .noUi-handle,
[data-slider-color="primary"][data-slider-style="square"] .noUi-handle {
  border-color: #4b38b3;
}

[data-slider-color="secondary"] .noUi-connect {
  background: #3577f1;
}

[data-slider-color="secondary"] .noUi-handle {
  background: #3577f1;
}

[data-slider-color="secondary"][data-slider-style="border"] .noUi-handle,
[data-slider-color="secondary"][data-slider-style="square"] .noUi-handle {
  border-color: #3577f1;
}

[data-slider-color="success"] .noUi-connect {
  background: #45cb85;
}

[data-slider-color="success"] .noUi-handle {
  background: #45cb85;
}

[data-slider-color="success"][data-slider-style="border"] .noUi-handle,
[data-slider-color="success"][data-slider-style="square"] .noUi-handle {
  border-color: #45cb85;
}

[data-slider-color="info"] .noUi-connect {
  background: #299cdb;
}

[data-slider-color="info"] .noUi-handle {
  background: #299cdb;
}

[data-slider-color="info"][data-slider-style="border"] .noUi-handle,
[data-slider-color="info"][data-slider-style="square"] .noUi-handle {
  border-color: #299cdb;
}

[data-slider-color="warning"] .noUi-connect {
  background: #ffbe0b;
}

[data-slider-color="warning"] .noUi-handle {
  background: #ffbe0b;
}

[data-slider-color="warning"][data-slider-style="border"] .noUi-handle,
[data-slider-color="warning"][data-slider-style="square"] .noUi-handle {
  border-color: #ffbe0b;
}

[data-slider-color="danger"] .noUi-connect {
  background: #f06548;
}

[data-slider-color="danger"] .noUi-handle {
  background: #f06548;
}

[data-slider-color="danger"][data-slider-style="border"] .noUi-handle,
[data-slider-color="danger"][data-slider-style="square"] .noUi-handle {
  border-color: #f06548;
}

[data-slider-color="light"] .noUi-connect {
  background: #f3f6f9;
}

[data-slider-color="light"] .noUi-handle {
  background: #f3f6f9;
}

[data-slider-color="light"][data-slider-style="border"] .noUi-handle,
[data-slider-color="light"][data-slider-style="square"] .noUi-handle {
  border-color: #f3f6f9;
}

[data-slider-color="dark"] .noUi-connect {
  background: #212529;
}

[data-slider-color="dark"] .noUi-handle {
  background: #212529;
}

[data-slider-color="dark"][data-slider-style="border"] .noUi-handle,
[data-slider-color="dark"][data-slider-style="square"] .noUi-handle {
  border-color: #212529;
}

[data-slider-size="lg"].noUi-horizontal {
  height: 12px;
}

[data-slider-size="lg"].noUi-horizontal .noUi-handle {
  width: 24px;
  height: 24px;
}

[data-slider-size="md"].noUi-horizontal {
  height: 8px;
}

[data-slider-size="md"].noUi-horizontal .noUi-handle {
  width: 20px;
  height: 20px;
}

[data-slider-size="sm"].noUi-horizontal {
  height: 4px;
}

[data-slider-size="sm"].noUi-horizontal .noUi-handle {
  width: 16px;
  height: 16px;
}

[data-slider-style="line"].noUi-horizontal .noUi-handle {
  width: 8px;
  border-radius: 4px;
  right: -8px;
}

[data-slider-style="line"].noUi-vertical .noUi-handle {
  height: 8px;
  border-radius: 4px;
  top: -3px;
}

[data-slider-style="border"] .noUi-handle {
  border-color: #45cb85;
  background-color: #fff;
}

[data-slider-style="square"] .noUi-handle {
  border-radius: 0;
  transform: rotate(45deg);
  height: 10px;
  width: 10px;
  top: -4px;
  border-color: #45cb85;
  background-color: #fff;
}

.nested-list .list-group-item {
  background-color: rgba(75, 56, 179, 0.05);
  border-color: rgba(75, 56, 179, 0.05);
}

.nested-1,
.nested-2,
.nested-3,
.nested-list {
  margin-top: 5px;
}

.nested-sortable-handle .handle {
  position: absolute;
  left: 0;
  top: 0;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
}

.nested-sortable-handle .list-group-item {
  padding-left: 42px;
}

.shepherd-element {
  background: var(--bs-card-bg-custom);
  box-shadow: var(--bs-box-shadow);
}

.shepherd-has-title .shepherd-content .shepherd-header {
  background-color: var(--bs-light);
  padding: 0.5rem 0.75rem;
}

.shepherd-has-title .shepherd-content .shepherd-cancel-icon {
  color: rgba(var(--bs-dark-rgb), 0.75);
}

.shepherd-has-title .shepherd-content .shepherd-cancel-icon:hover {
  color: rgba(var(--bs-dark-rgb), 0.75);
}

.shepherd-element.shepherd-has-title[data-popper-placement^="bottom"]
  > .shepherd-arrow:before {
  background-color: var(--bs-light);
}

.shepherd-title {
  font-size: 15px;
  font-weight: 500;
  color: var(--bs-body-color);
}

.shepherd-text {
  padding: 0.75rem;
  font-size: 0.8125rem;
  color: var(--bs-body-color);
}

.shepherd-button.btn-success:not(:disabled):hover {
  background: #3bc87e;
  color: #fff;
}

.shepherd-button.btn-light:not(:disabled):hover {
  background: rgba(var(--bs-light-rgb), 0.75);
  color: var(--bs-dark);
}

.shepherd-button.btn-primary:not(:disabled):hover {
  background: #4735a9;
  color: #fff;
}

.shepherd-footer {
  padding: 0 0.75rem 0.75rem;
}

.shepherd-arrow,
.shepherd-arrow:before {
  content: "\\ea75";
  font-family: remixicon;
  font-size: 24px;
  z-index: 1;
  background-color: transparent !important;
  transform: rotate(0);
  color: #4b38b3;
}

.shepherd-element[data-popper-placement^="bottom"] > .shepherd-arrow {
  top: -18px;
}

.shepherd-button {
  margin-right: 0.5rem;
}

.swiper-button-next,
.swiper-button-prev {
  height: 32px;
  width: 32px;
  background-color: rgba(75, 56, 179, 0.2);
  backdrop-filter: blur(2px);
  border-radius: 8px;
}

.swiper-button-next::after,
.swiper-button-prev::after {
  font-family: remixicon;
  font-size: 28px;
  color: #4b38b3;
  transition: all 0.3s ease;
}

.swiper-button-prev::after {
  content: "\\ea64" !important;
}

.swiper-button-next::after {
  content: "\\ea6e" !important;
}

.swiper-pagination-bullet {
  width: 22px;
  height: 5px;
  background-color: #fff;
  border-radius: 50px;
  box-shadow: var(--bs-box-shadow);
}

.swiper-pagination-bullet .swiper-pagination-bullet-active {
  opacity: 1;
}

.dynamic-pagination .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  background-color: #fff;
  opacity: 0.5;
  transition: all 0.5s ease;
}

.dynamic-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
  opacity: 1;
  width: 20px;
}

.swiper-pagination-fraction {
  color: #fff;
  font-size: 16px;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(2px);
}

.pagination-custom .swiper-pagination-bullet {
  height: 25px;
  width: 25px;
  line-height: 25px;
  border-radius: 8px;
  background-color: #fff;
  opacity: 0.5;
  transition: all 0.5s ease;
}

.pagination-custom .swiper-pagination-bullet.swiper-pagination-bullet-active {
  color: #3577f1;
  opacity: 1;
}

.swiper-pagination-progressbar {
  height: 6px !important;
  background-color: rgba(69, 203, 133, 0.25);
}

.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
  background-color: #45cb85;
}

.swiper-scrollbar {
  background-color: rgba(255, 255, 255, 0.35);
  backdrop-filter: blur(2px);
  padding: 1.2px;
  height: 6px !important;
}

.swiper-scrollbar .swiper-scrollbar-drag {
  background-color: #fff;
}

.swiper-pagination-dark .swiper-pagination-bullet {
  background-color: #3577f1;
}

.swiper-pagination-dark .dynamic-pagination .swiper-pagination-bullet {
  background-color: #3577f1;
}

.swiper-pagination-dark.pagination-custom .swiper-pagination-bullet {
  color: #fff;
}

.swiper-pagination-dark.pagination-custom
  .swiper-pagination-bullet.swiper-pagination-bullet-active {
  opacity: 1;
}

.swiper-pagination-dark.swiper-scrollbar {
  background-color: rgba(33, 37, 41, 0.35);
}

.multi-wrapper {
  border: none;
  position: relative;
}

.multi-wrapper::before {
  content: "\\ea61";
  position: absolute;
  font-family: remixicon;
  left: 50%;
  transform: translateX(-50%);
  bottom: 86px;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  border-radius: 50%;
  color: #878a99;
  background-color: var(--bs-light);
  z-index: 1;
}

.multi-wrapper .non-selected-wrapper {
  border: 1px solid var(--bs-input-border);
  background-color: var(--bs-input-bg);
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.multi-wrapper .non-selected-wrapper::-webkit-scrollbar,
.multi-wrapper .selected-wrapper::-webkit-scrollbar {
  -webkit-appearance: none;
}

.multi-wrapper .non-selected-wrapper::-webkit-scrollbar:vertical,
.multi-wrapper .selected-wrapper::-webkit-scrollbar:vertical {
  width: 10px;
}

.multi-wrapper .non-selected-wrapper::-webkit-scrollbar:horizontal,
.multi-wrapper .selected-wrapper::-webkit-scrollbar:horizontal {
  height: 9px;
}

.multi-wrapper .non-selected-wrapper::-webkit-scrollbar-thumb,
.multi-wrapper .selected-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(var(--bs-dark-rgb), 0.2);
  border-radius: 10px;
  border: 2px solid var(--bs-input-bg);
}

.multi-wrapper .non-selected-wrapper::-webkit-scrollbar-track,
.multi-wrapper .selected-wrapper::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: var(--bs-input-bg);
}

.multi-wrapper .item-group .group-label {
  font-size: 12px;
}

.multi-wrapper .item {
  color: var(--bs-body-color);
}

.multi-wrapper .item:hover {
  background-color: rgba(75, 56, 179, 0.1);
}

.multi-wrapper .selected-wrapper {
  border: 1px solid var(--bs-input-border);
  background: var(--bs-input-bg);
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.multi-wrapper .search-input {
  flex: 0 0 auto;
  padding: 0.5rem 0.9rem;
  font-size: 0.8125rem;
  color: var(--bs-body-color);
  background-color: var(--bs-input-bg);
  border: 1px solid var(--bs-input-border);
  border-radius: 0.25rem;
  margin-bottom: 16px;
}

.multi-wrapper .search-input::placeholder {
  color: #878a99;
}

.multi-wrapper .header {
  font-weight: 600;
  color: var(--bs-gray-600);
}

.pcr-app {
  background: var(--bs-card-bg-custom);
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  border-radius: 4px;
  border: 1px solid var(--bs-border-color);
}

.pickr .pcr-button {
  border: 4px solid var(--bs-card-bg-custom);
  box-shadow: 0 0 0 2px var(--bs-border-color);
  border-radius: 50%;
  box-shadow: var(--bs-box-shadow);
}

.pickr .pcr-button::after,
.pickr .pcr-button::before {
  border-radius: 50%;
}

.pcr-app[data-theme="classic"] .pcr-selection .pcr-color-preview {
  margin-right: 0.75em;
  margin-left: 0;
}

.pcr-app[data-theme="classic"] .pcr-selection .pcr-color-chooser,
.pcr-app[data-theme="classic"] .pcr-selection .pcr-color-opacity {
  margin-left: 0.75em;
  margin-right: 0;
}

.pcr-app[data-theme="monolith"] .pcr-result {
  min-width: 100%;
}

.pcr-app .pcr-interaction .pcr-type.active {
  background: #4b38b3;
}

.pcr-app .pcr-interaction .pcr-result {
  background-color: var(--bs-input-bg);
  color: var(--bs-body-color);
  border: 1px solid var(--bs-input-border);
  border-radius: 0.25rem;
}

.pcr-app .pcr-interaction input {
  border-radius: 0.25rem !important;
}

.pcr-app .pcr-interaction input:focus {
  box-shadow: none;
  background-color: var(--bs-input-bg);
  border-color: var(--bs-input-focus-border);
}

.pcr-app .pcr-interaction .pcr-save {
  background: #45cb85 !important;
}

.pcr-app .pcr-interaction .pcr-cancel,
.pcr-app .pcr-interaction .pcr-clear {
  background: #f06548 !important;
}

.filepond--root {
  margin-bottom: 0;
}

.filepond--root[data-style-panel-layout~="circle"] .filepond--drop-label label {
  font-size: 14px;
}

.filepond--panel-root {
  border: 2px dashed var(--bs-border-color);
  background: var(--bs-card-bg-custom);
}

.filepond--drop-label {
  color: var(--bs-body-color);
}

.filepond--drop-label label {
  font-weight: 500;
}

.filepond--credits {
  display: none;
}

.filepond--item-panel {
  background-color: #4b38b3 !important;
}

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  height: auto;
}

.input-step {
  border: 1px solid var(--bs-input-border);
  display: -ms-inline-flexbox;
  overflow: visible;
  height: 37.5px;
  border-radius: 0.25rem;
  background: var(--bs-input-bg);
  padding: 4px;
  max-width: 115px;
}

.input-step input {
  width: 4em;
  height: 100%;
  text-align: center;
  border: 0;
  background: 0 0;
  color: var(--bs-body-color);
  border-radius: 0.25rem;
}

.input-step input:focus-visible {
  outline: 0;
}

.input-step button {
  width: 1.4em;
  font-weight: 300;
  height: 100%;
  line-height: 0.1em;
  font-size: 1.4em;
  padding: 0.2em !important;
  background: var(--bs-light);
  color: var(--bs-body-color);
  border: none;
  border-radius: 0.25rem;
}

.input-step.light {
  background: var(--bs-light);
}

.input-step.light button {
  background-color: var(--bs-input-bg);
}

.input-step.light-input {
  background: var(--bs-light);
}

.input-step.light-input input {
  background-color: var(--bs-input-bg);
}

.input-step.full-width {
  display: flex;
  width: 100%;
}

.input-step.full-width button {
  flex-shrink: 0;
}

.input-step.full-width input {
  flex-grow: 1;
}

.input-step.step-primary button {
  background-color: #4b38b3;
  color: #fff;
}

.input-step.step-secondary button {
  background-color: #3577f1;
  color: #fff;
}

.input-step.step-success button {
  background-color: #45cb85;
  color: #fff;
}

.input-step.step-info button {
  background-color: #299cdb;
  color: #fff;
}

.input-step.step-warning button {
  background-color: #ffbe0b;
  color: #fff;
}

.input-step.step-danger button {
  background-color: #f06548;
  color: #fff;
}

.input-step.step-light button {
  background-color: #f3f6f9;
  color: #fff;
}

.input-step.step-dark button {
  background-color: #212529;
  color: #fff;
}

.ck {
  font-family: var(--bs-font-sans-serif) !important;
}

.ck.ck-reset_all,
.ck.ck-reset_all * {
  color: var(--bs-body-color) !important;
}

.ck.ck-toolbar {
  background: rgba(var(--bs-light-rgb), 0.75) !important;
}

.ck p {
  margin-bottom: 0;
}

.ck.ck-toolbar {
  border: 1px solid var(--bs-input-border) !important;
}

.ck.ck-toolbar.ck-toolbar_grouping > .ck-toolbar__items {
  flex-wrap: wrap !important;
}

.ck.ck-toolbar .ck.ck-toolbar__separator {
  background: 0 0 !important;
}

.ck.ck-editor__main > .ck-editor__editable {
  border-top: 0 !important;
  background-color: var(--bs-card-bg-custom) !important;
  border-color: var(--bs-input-border) !important;
  box-shadow: none !important;
}

.ck.ck-dropdown__panel {
  background: var(--bs-choices-bg) !important;
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  border-radius: 0.3rem;
}

.ck.ck-list {
  background: var(--bs-choices-bg) !important;
}

.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,
.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se {
  left: 0;
  right: auto !important;
}

.ck.ck-editor__editable_inline[dir="ltr"] {
  text-align: left !important;
}

.ck.ck-dropdown__panel {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12) !important;
  border-radius: 0.3rem !important;
  border: 1px solid var(--bs-border-color) !important;
}

.ck.ck-button:active,
.ck.ck-button:focus,
a.ck.ck-button:active,
a.ck.ck-button:focus {
  box-shadow: none !important;
  border: 1px solid var(--bs-light) !important;
}

.ck.ck-button:not(.ck-disabled):hover,
a.ck.ck-button:not(.ck-disabled):hover {
  background: var(--bs-light) !important;
}

.ck.ck-button.ck-on,
a.ck.ck-button.ck-on {
  background: var(--bs-light) !important;
}

.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.ck-editor__editable {
  min-height: 245px !important;
}

.ck[class*="ck-heading_heading"] {
  font-weight: 500 !important;
}

.ck.ck-button.ck-on:not(.ck-disabled):active,
.ck.ck-button.ck-on:not(.ck-disabled):hover,
a.ck.ck-button.ck-on:not(.ck-disabled):active,
a.ck.ck-button.ck-on:not(.ck-disabled):hover {
  box-shadow: none !important;
}

.ck.ck-tooltip .ck-tooltip__text {
  background: #212529 !important;
  color: #f3f6f9 !important;
}

.ck.ck-input-text {
  background: var(--bs-input-bg) !important;
  border: 1px solid var(--bs-input-border) !important;
}

.ck.ck-input-text:focus {
  border: 1px solid var(--bs-input-focus-border) !important;
  box-shadow: none !important;
}

.ck.ck-balloon-panel {
  background: #fff !important;
  border: 1px solid var(--bs-border-color) !important;
}

.ck.ck-balloon-panel[class*="arrow_n"]:after {
  border-bottom-color: #fff !important;
}

.ck.ck-balloon-panel[class*="arrow_n"]::before {
  border-bottom-color: var(--bs-border-color) !important;
}

.ck.ck-labeled-field-view
  > .ck.ck-labeled-field-view__input-wrapper
  > .ck.ck-label {
  background: #fff !important;
}

.ck-editor-reverse .ck-editor {
  display: flex;
  flex-direction: column-reverse;
}

.ck-editor-reverse .ck.ck-editor__main > .ck-editor__editable {
  border: 1px solid var(--bs-input-border) !important;
  border-bottom: 0 !important;
}

.ck-editor-reverse
  .ck-rounded-corners
  .ck.ck-editor__main
  > .ck-editor__editable,
.ck-editor-reverse
  .ck.ck-editor__main
  > .ck-editor__editable.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.ck-editor-reverse
  .ck-rounded-corners
  .ck.ck-editor__top
  .ck-sticky-panel
  .ck-toolbar,
.ck-editor-reverse
  .ck.ck-editor__top
  .ck-sticky-panel
  .ck-toolbar.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

[dir="rtl"] .ck.ck-toolbar > .ck-toolbar__items {
  flex-direction: row-reverse;
}

.ql-editor {
  text-align: left;
}

.ql-editor ol,
.ql-editor ul {
  padding-left: 1.5em;
  padding-right: 0;
}

.ql-editor li:not(.ql-direction-rtl)::before {
  margin-left: -1.5em;
  margin-right: 0.3em;
  text-align: right;
}

.ql-container {
  font-family: var(--bs-font-sans-serif);
}

.ql-container.ql-snow {
  border-color: var(--bs-input-border);
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.ql-bubble {
  border: 1px solid var(--bs-input-border);
  border-radius: 0.25rem;
}

.ql-toolbar {
  font-family: var(--bs-font-sans-serif) !important;
}

.ql-toolbar span {
  outline: 0 !important;
  color: var(--bs-choices-link-color);
}

.ql-toolbar span:hover {
  color: #4b38b3 !important;
}

.ql-toolbar.ql-snow {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-color: var(--bs-input-border);
}

.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  border-color: transparent;
}

.ql-toolbar.ql-snow .ql-picker-options {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  border-radius: 0.3rem;
}

.ql-snow .ql-script,
.ql-snow .ql-strike svg,
.ql-snow .ql-stroke {
  stroke: var(--bs-choices-link-color);
}

.ql-snow .ql-fill {
  fill: var(--bs-choices-link-color);
}

.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
  right: 0;
  left: auto;
}

.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  color: var(--bs-choices-link-color);
}

.ql-snow .ql-picker-options {
  background-color: var(--bs-choices-bg);
  border-color: var(--bs-border-color) !important;
}

.gridjs-container {
  color: var(--bs-body-color);
  padding: 0;
  display: block;
}

.gridjs-wrapper {
  box-shadow: none;
  border: 1px solid var(--bs-border-color);
  border-radius: 0;
}

.gridjs-wrapper::-webkit-scrollbar {
  -webkit-appearance: none;
}

.gridjs-wrapper::-webkit-scrollbar:vertical {
  width: 12px;
}

.gridjs-wrapper::-webkit-scrollbar:horizontal {
  height: 12px;
}

.gridjs-wrapper::-webkit-scrollbar-thumb {
  background-color: rgba(var(--bs-dark-rgb), 0.075);
  border-radius: 10px;
  border: 2px solid var(--bs-card-bg-custom);
}

.gridjs-wrapper::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: var(--bs-card-bg-custom);
}

.gridjs-footer {
  border: none !important;
  padding: 12px 0 0;
}

.gridjs-table {
  width: 100%;
}

.gridjs-tbody,
td.gridjs-td {
  background-color: transparent;
}

td.gridjs-td,
th.gridjs-th {
  border: 1px solid var(--bs-border-color);
  padding: 0.75rem 0.6rem;
}

th.gridjs-th {
  border-top: 0;
  color: var(--bs-body-color);
  background-color: rgba(var(--bs-light-rgb), 0.75);
}

th.gridjs-th-sort:focus,
th.gridjs-th-sort:hover {
  background-color: rgba(var(--bs-light-rgb), 0.85);
}

.gridjs-head {
  padding-top: 0;
}

.gridjs-footer {
  box-shadow: none;
  border: 1px solid var(--bs-border-color);
  border-top: 0;
  background-color: transparent;
}

.gridjs-summary {
  color: #878a99;
  margin-top: 8px !important;
}

.gridjs-pagination .gridjs-pages button {
  margin-left: 0.3rem;
  border-radius: 0.25rem !important;
  border: 1px solid transparent;
  background-color: var(--bs-card-bg-custom);
  color: var(--bs-link-color);
}

.gridjs-pagination .gridjs-pages button:last-child {
  border-right: 1px solid transparent;
}

.gridjs-pagination .gridjs-pages button:disabled,
.gridjs-pagination .gridjs-pages button:hover:disabled,
.gridjs-pagination .gridjs-pages button[disabled] {
  color: #878a99;
  background-color: var(--bs-card-bg-custom);
}

.gridjs-pagination .gridjs-pages button:hover {
  background-color: #eff2f7;
  color: var(--bs-link-hover-color);
}

.gridjs-pagination .gridjs-pages button:focus {
  box-shadow: none;
}

.gridjs-pagination .gridjs-pages button:first-child:hover,
.gridjs-pagination .gridjs-pages button:last-child:hover {
  background-color: transparent;
}

.gridjs-pagination .gridjs-pages button.gridjs-currentPage {
  background-color: #4b38b3;
  color: #fff;
  border-color: #4b38b3;
  font-weight: 500;
}

.gridjs-search {
  position: relative;
  float: left;
}

.gridjs-search::before {
  content: "\\f0d1";
  font-family: remixicon;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
  font-size: 14px;
  color: #878a99;
}

input.gridjs-input {
  border-color: var(--bs-input-border);
  background-color: var(--bs-input-bg);
  color: var(--bs-body-color);
  line-height: 1.5;
  padding: 0.5rem 0.9rem 0.5rem 2.025rem;
  border-radius: 0.25rem;
  font-size: 0.8125rem;
}

input.gridjs-input:focus {
  box-shadow: none;
  border-color: var(--bs-input-focus-border);
  background-color: var(--bs-input-bg);
}

input.gridjs-input::placeholder {
  color: #878a99;
}

th.gridjs-th .gridjs-th-content {
  float: none;
  display: inline-block;
  vertical-align: middle;
  font-weight: 600;
}

button.gridjs-sort {
  float: none;
  display: inline-block;
  vertical-align: middle;
  width: 10px;
  height: 20px;
}

th.gridjs-th-sort .gridjs-th-content {
  width: calc(100% - 10px);
}

button.gridjs-sort-asc,
button.gridjs-sort-desc {
  background-size: 7px;
}

.table-card .gridjs-head {
  padding: 16px 16px 5px;
}

.table-card .gridjs-wrapper {
  border-top: 0;
  border-radius: 0;
  border-width: 1px 0;
}

.table-card .gridjs-footer {
  padding: 8px 16px;
}

.gridjs-tr-selected td {
  background-color: rgba(var(--bs-light-rgb), 1);
}

.gridjs-tr-selected .gridjs-td .gridjs-checkbox[type="checkbox"] {
  background-color: #4b38b3;
  border-color: #4b38b3;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
}

.gridjs-td .gridjs-checkbox {
  width: 1.1em;
  height: 1.1em;
  vertical-align: top;
  background-color: var(--bs-input-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid var(--bs-input-check-border);
  appearance: none;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.gridjs-td .gridjs-checkbox[type="checkbox"] {
  border-radius: 0.25em;
}

.gridjs-border-none td.gridjs-td,
.gridjs-border-none th.gridjs-th {
  border-right-width: 0;
  border-left-width: 0;
}

.gridjs-loading-bar {
  background-color: var(--bs-card-bg-custom);
}

[data-layout-mode="dark"] button.gridjs-sort-asc,
[data-layout-mode="dark"] button.gridjs-sort-desc,
[data-layout-mode="dark"] button.gridjs-sort-neutral {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.listjs-pagination {
  margin-bottom: 0;
  justify-content: flex-end;
  gap: 8px;
}

.listjs-pagination li .page {
  display: block;
  padding: 0.375rem 0.75rem;
  color: var(--bs-link-color);
  background-color: var(--bs-card-bg-custom);
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.listjs-pagination li.active .page {
  color: #fff;
  background-color: #4b38b3;
  border-color: #4b38b3;
}

.pagination-wrap {
  -webkit-user-select: none;
  user-select: none;
  display: flex;
  align-items: center;
}

.pagination-wrap a {
  text-decoration: none;
  display: inline-block;
}

.pagination-next,
.pagination-prev {
  color: #4b38b3;
  font-weight: 500;
  padding: 0.375rem 0.75rem;
  background-color: var(--bs-card-bg-custom);
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.pagination-next:hover,
.pagination-prev:hover {
  color: #897bd6;
}

.pagination-next.disabled,
.pagination-prev.disabled {
  color: #878a99;
  cursor: default;
}

.pagination-next.disabled:hover,
.pagination-prev.disabled:hover {
  color: #878a99;
}

.apex-charts {
  min-height: 10px !important;
}

.apex-charts text {
  font-family: var(--bs-font-sans-serif) !important;
}

.apex-charts .apexcharts-canvas {
  margin: 0 auto;
}

.apexcharts-tooltip-text,
.apexcharts-tooltip-title {
  font-family: var(--bs-font-sans-serif) !important;
}

.apexcharts-tooltip {
  border: 1px solid var(--bs-border-color) !important;
  background-color: var(--bs-card-bg-custom) !important;
  box-shadow: var(--bs-box-shadow) !important;
}

.apexcharts-tooltip * {
  font-family: var(--bs-font-sans-serif) !important;
  color: #878a99 !important;
}

.apexcharts-tooltip .apexcharts-tooltip-title {
  background-color: rgba(var(--bs-light-rgb), 0.75) !important;
  border-bottom: 1px solid var(--bs-border-color) !important;
}

.apexcharts-tooltip.apexcharts-theme-dark * {
  color: #fff !important;
}

.apexcharts-legend-series {
  font-weight: 500;
}

.apexcharts-gridline {
  pointer-events: none;
  stroke: rgba(var(--bs-light-rgb), 0.75);
}

.apexcharts-legend-text {
  color: #878a99 !important;
  font-family: var(--bs-font-sans-serif) !important;
  font-size: 13px !important;
}

.apexcharts-pie-label {
  fill: #fff !important;
}

.apexcharts-subtitle-text,
.apexcharts-title-text {
  fill: #adb5bd;
}

.apexcharts-xaxis text,
.apexcharts-yaxis text {
  font-family: var(--bs-font-sans-serif) !important;
  fill: #adb5bd;
}

.apexcharts-yaxis-title {
  font-weight: 500;
}

#dynamicloadedchart-wrap {
  margin: 0 auto;
  max-width: 800px;
  position: relative;
}

.chart-box {
  padding-left: 0;
}

#chart-quarter,
#chart-year {
  width: 96%;
  max-width: 48%;
  box-shadow: none;
  padding-left: 0;
  padding-top: 20px;
  background: var(--bs-card-bg-custom);
  border: 1px solid var(--bs-border-color);
}

#chart-year {
  float: left;
  position: relative;
  transition: 1s ease transform;
  z-index: 3;
}

#chart-year.chart-quarter-activated {
  transform: translateX(0);
  transition: 1s ease transform;
}

#chart-quarter {
  float: left;
  position: relative;
  z-index: -2;
  transition: 1s ease transform;
}

#chart-quarter.active {
  transition: 1.1s ease-in-out transform;
  transform: translateX(0);
  z-index: 1;
}

@media screen and (min-width: 480px) {
  #chart-year {
    transform: translateX(50%);
  }

  #chart-quarter {
    transform: translateX(-50%);
  }
}

.apexcharts-radar-series line,
.apexcharts-radar-series polygon {
  stroke: var(--bs-border-color);
}

.apexcharts-pie circle,
.apexcharts-pie line {
  stroke: var(--bs-border-color);
}

.apexcharts-pie text {
  fill: var(--bs-body-color);
}

.apex-charts .apexcharts-xaxis line,
.apex-charts .apexcharts-yaxis line {
  stroke: var(--bs-border-color);
}

.apex-charts .apexcharts-xaxis-tick {
  stroke: var(--bs-border-color);
}

.apex-charts .apexcharts-bar-series path,
.apex-charts .apexcharts-pie-series path {
  stroke: var(--bs-card-bg-custom);
}

.apex-charts .apexcharts-radialbar-track path {
  stroke: var(--bs-light);
}

.apex-charts .apexcharts-marker {
  stroke: var(--bs-card-bg-custom);
}

.apex-charts .apexcharts-boxPlot-series path {
  stroke: var(--bs-border-color);
}

.apex-charts .apexcharts-heatmap-series rect,
.apex-charts .apexcharts-treemap rect {
  stroke: var(--bs-card-bg-custom);
}

.chartjs-chart {
  max-height: 320px;
}

.e-charts {
  height: 350px;
}

.e-charts-height {
  height: 300px;
}

.gmaps,
.gmaps-panaroma {
  height: 300px;
  background: #f3f6f9;
  border-radius: 3px;
}

.gmaps-overlay {
  display: block;
  text-align: center;
  color: #fff;
  font-size: 16px;
  line-height: 40px;
  background: #4b38b3;
  border-radius: 4px;
  padding: 10px 20px;
}

.gmaps-overlay_arrow {
  left: 50%;
  margin-left: -16px;
  width: 0;
  height: 0;
  position: absolute;
}

.gmaps-overlay_arrow.above {
  bottom: -15px;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-top: 16px solid #4b38b3;
}

.gmaps-overlay_arrow.below {
  top: -15px;
  border-left: 16px solid transparent;
  border-right: 16px solid transparent;
  border-bottom: 16px solid #4b38b3;
}

.autoComplete_wrapper {
  display: block;
}

.autoComplete_wrapper > input {
  display: block;
  width: 100%;
  height: auto;
  padding: 0.5rem 0.9rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--bs-body-color);
  background-color: var(--bs-input-bg);
  background-clip: padding-box;
  border: 1px solid var(--bs-input-border);
  border-radius: 0.25rem;
  background-image: none;
}

.autoComplete_wrapper > input::placeholder {
  padding: 0 !important;
  color: #878a99 !important;
  font-size: 0.8125rem !important;
}

.autoComplete_wrapper > input:focus {
  border: 1px solid var(--bs-input-focus-border);
  color: var(--bs-body-color);
}

.autoComplete_wrapper > input:hover {
  color: var(--bs-body-color);
}

.autoComplete_wrapper > ul {
  border-radius: 0.25rem;
  border-color: var(--bs-border-color);
  background-color: #fff;
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  padding: 0;
  overflow: auto;
  max-height: 160px;
  margin: 0;
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
}

.autoComplete_wrapper > ul > li {
  font-size: 0.8125rem;
  margin: 0;
  padding: 0.35rem 1.2rem;
  border-radius: 0;
  background-color: #fff;
  color: var(--bs-body-color);
}

.autoComplete_wrapper > ul > li mark {
  color: #f06548;
  font-weight: 600;
  padding: 1px;
}

.autoComplete_wrapper > ul > li:hover,
.autoComplete_wrapper > ul > li[aria-selected="true"] {
  color: #1e2125;
  background-color: #f3f6f9;
}

.autoComplete_wrapper > ul .no_result {
  padding: 0.7rem 1.2rem;
  font-style: italic;
  font-weight: 500;
}

.jvm-tooltip {
  border-radius: 3px;
  background-color: #4b38b3;
  font-family: var(--bs-font-sans-serif);
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  padding: 5px 9px;
}

.jvm-container text {
  font-family: var(--bs-font-sans-serif);
  font-size: 0.8125rem;
  fill: var(--bs-gray-700);
}

.jvm-zoom-btn {
  background-color: #4b38b3;
}

.leaflet-map {
  height: 300px;
}

.leaflet-map.leaflet-container {
  z-index: 0;
  font-family: Inter, sans-serif;
}

.fc td,
.fc th {
  border: 1px solid var(--bs-border-color);
}

.fc .fc-toolbar h2 {
  font-size: 16px;
  line-height: 30px;
  text-transform: uppercase;
}

@media (max-width: 767.98px) {
  .fc .fc-toolbar .fc-center,
  .fc .fc-toolbar .fc-left,
  .fc .fc-toolbar .fc-right {
    float: none;
    display: block;
    text-align: center;
    clear: both;
    margin: 10px 0;
  }

  .fc .fc-toolbar > * > * {
    float: none;
  }

  .fc .fc-toolbar .fc-today-button {
    display: none;
  }
}

.fc .fc-toolbar .btn {
  text-transform: capitalize;
}

.fc .fc-col-header-cell {
  background-color: var(--bs-light);
}

.fc .fc-col-header-cell-cushion {
  display: block;
  padding: 8px 4px;
}

.fc .fc-daygrid-day-number {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  margin: 2px;
}

.fc .fc-daygrid-day.fc-day-today {
  background-color: rgba(75, 56, 179, 0.1);
}

.fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-number {
  background-color: #4b38b3;
  color: #fff;
}

.fc .fc-daygrid-day.fc-day-today {
  background-color: rgba(75, 56, 179, 0.1);
}

.fc .fc-timegrid-col.fc-day-today {
  background-color: rgba(75, 56, 179, 0.1);
}

.fc .fc-list-event:hover td {
  background: 0 0;
}

.fc .fc-list-event-title a {
  color: #fff !important;
}

.fc .fc-col-header,
.fc .fc-daygrid-body,
.fc .fc-scrollgrid-sync-table {
  width: 100% !important;
}

.fc .fc-scrollgrid-section > * {
  border-left: 1px solid var(--bs-border-color);
  border-top: 1px solid var(--bs-border-color);
}

.fc .fc-scrollgrid-section-liquid > td {
  border-top: 0;
}

.fc-theme-bootstrap a:not([href]) {
  color: var(--bs-body-color);
}

.fc-event {
  color: #fff;
}

.fc th.fc-widget-header {
  background: #e9ebec;
  line-height: 20px;
  padding: 10px 0;
  text-transform: uppercase;
  font-weight: 700;
}

.fc-unthemed .fc-content,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-list-heading td,
.fc-unthemed .fc-list-view,
.fc-unthemed .fc-popover,
.fc-unthemed .fc-row,
.fc-unthemed tbody,
.fc-unthemed td,
.fc-unthemed th,
.fc-unthemed thead {
  border-color: #e9ebec;
}

.fc-unthemed td.fc-today {
  background: #f6f8fa;
}

.fc-button {
  background: var(--bs-card-bg-custom);
  border-color: var(--bs-border-color);
  color: #495057;
  text-transform: capitalize;
  box-shadow: none;
  padding: 6px 12px !important;
  height: auto !important;
}

.fc-state-active,
.fc-state-disabled,
.fc-state-down {
  background-color: #4b38b3;
  color: #fff;
  text-shadow: none;
}

.fc-event {
  border-radius: 2px;
  border: none;
  cursor: move;
  font-size: 0.8125rem;
  margin: 5px 7px;
  padding: 5px 5px;
  text-align: center;
}

.fc-event,
.fc-event-dot {
  background-color: #4b38b3;
}

.fc-daygrid-dot-event.fc-event-mirror,
.fc-daygrid-dot-event:hover {
  background-color: #4b38b3;
}

.fc-event-title,
.fc-sticky {
  font-weight: 600 !important;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fc-daygrid-event-dot {
  border-color: #fff !important;
  display: none;
}

.fc-event-time {
  display: none;
}

.fc-event .fc-content {
  color: #fff;
}

#external-events .external-event {
  text-align: left;
  padding: 8px 16px;
  margin: 6px 0;
}

.fc-day-grid-event.fc-h-event.fc-event.fc-start.fc-end.bg-dark .fc-content {
  color: #f3f6f9;
}

.fc-next-button,
.fc-prev-button {
  position: relative;
  height: 37.5px;
  width: 37.5px;
}

.fc-next-button::before,
.fc-prev-button::before {
  position: absolute;
  font-family: remixicon !important;
  font-size: 20px;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.fc-prev-button::before {
  content: "\\ea64";
}

.fc-next-button::before {
  content: "\\ea6e";
}

.fc-toolbar-chunk .btn-group {
  box-shadow: var(--bs-box-shadow);
}

.fc-toolbar-chunk .btn-group .btn {
  color: #3577f1;
  background-color: rgba(53, 119, 241, 0.15);
  border: none;
  box-shadow: none;
}

.fc-toolbar-chunk .btn-group .btn.active,
.fc-toolbar-chunk .btn-group .btn:hover {
  color: #fff;
  background-color: #3577f1;
}

.fc-toolbar-chunk .fc-today-button {
  background-color: #3577f1 !important;
  border: #3577f1;
}

@media (max-width: 575.98px) {
  .fc-toolbar {
    flex-direction: column;
    gap: 16px;
  }
}

#upcoming-event-list .card:last-child {
  margin-bottom: 6px !important;
}

#event-modal .event-details {
  display: none;
}

#event-modal .view-event .event-form {
  display: none;
}

#event-modal .view-event #event-category-tag {
  display: none;
}

#event-modal .view-event .event-details {
  display: block;
}

.fc-daygrid-event-harness .fc-daygrid-event {
  backdrop-filter: blur(4px);
}

.fc-timegrid-event-harness .fc-timegrid-event {
  backdrop-filter: blur(4px);
}

.fc-timegrid-slots table tr {
  border-color: var(--bs-border-color) !important;
}

.fc-list-table {
  border-color: var(--bs-border-color);
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-primary .fc-event-main,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-primary .fc-event-title {
  color: #4b38b3 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-primary .fc-event-title {
  color: #4b38b3 !important;
}

.fc-list-table .fc-list-event.bg-soft-primary {
  color: #4b38b3 !important;
}

.fc-list-table .fc-list-event.bg-soft-primary .fc-list-event-title > a {
  color: #4b38b3 !important;
}

.fc-list-table .fc-list-event.bg-soft-primary .fc-list-event-dot {
  border-color: #4b38b3;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-secondary .fc-event-main,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-secondary .fc-event-title {
  color: #3577f1 !important;
}

.fc-timegrid-event-harness
  .fc-timegrid-event.bg-soft-secondary
  .fc-event-title {
  color: #3577f1 !important;
}

.fc-list-table .fc-list-event.bg-soft-secondary {
  color: #3577f1 !important;
}

.fc-list-table .fc-list-event.bg-soft-secondary .fc-list-event-title > a {
  color: #3577f1 !important;
}

.fc-list-table .fc-list-event.bg-soft-secondary .fc-list-event-dot {
  border-color: #3577f1;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-success .fc-event-main,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-success .fc-event-title {
  color: #45cb85 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-success .fc-event-title {
  color: #45cb85 !important;
}

.fc-list-table .fc-list-event.bg-soft-success {
  color: #45cb85 !important;
}

.fc-list-table .fc-list-event.bg-soft-success .fc-list-event-title > a {
  color: #45cb85 !important;
}

.fc-list-table .fc-list-event.bg-soft-success .fc-list-event-dot {
  border-color: #45cb85;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-info .fc-event-main,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-info .fc-event-title {
  color: #299cdb !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-info .fc-event-title {
  color: #299cdb !important;
}

.fc-list-table .fc-list-event.bg-soft-info {
  color: #299cdb !important;
}

.fc-list-table .fc-list-event.bg-soft-info .fc-list-event-title > a {
  color: #299cdb !important;
}

.fc-list-table .fc-list-event.bg-soft-info .fc-list-event-dot {
  border-color: #299cdb;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-warning .fc-event-main,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-warning .fc-event-title {
  color: #ffbe0b !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-warning .fc-event-title {
  color: #ffbe0b !important;
}

.fc-list-table .fc-list-event.bg-soft-warning {
  color: #ffbe0b !important;
}

.fc-list-table .fc-list-event.bg-soft-warning .fc-list-event-title > a {
  color: #ffbe0b !important;
}

.fc-list-table .fc-list-event.bg-soft-warning .fc-list-event-dot {
  border-color: #ffbe0b;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-danger .fc-event-main,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-danger .fc-event-title {
  color: #f06548 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-danger .fc-event-title {
  color: #f06548 !important;
}

.fc-list-table .fc-list-event.bg-soft-danger {
  color: #f06548 !important;
}

.fc-list-table .fc-list-event.bg-soft-danger .fc-list-event-title > a {
  color: #f06548 !important;
}

.fc-list-table .fc-list-event.bg-soft-danger .fc-list-event-dot {
  border-color: #f06548;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-light .fc-event-main,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-light .fc-event-title {
  color: #f3f6f9 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-light .fc-event-title {
  color: #f3f6f9 !important;
}

.fc-list-table .fc-list-event.bg-soft-light {
  color: #f3f6f9 !important;
}

.fc-list-table .fc-list-event.bg-soft-light .fc-list-event-title > a {
  color: #f3f6f9 !important;
}

.fc-list-table .fc-list-event.bg-soft-light .fc-list-event-dot {
  border-color: #f3f6f9;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-main,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-title {
  color: #212529 !important;
}

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-dark .fc-event-title {
  color: #212529 !important;
}

.fc-list-table .fc-list-event.bg-soft-dark {
  color: #212529 !important;
}

.fc-list-table .fc-list-event.bg-soft-dark .fc-list-event-title > a {
  color: #212529 !important;
}

.fc-list-table .fc-list-event.bg-soft-dark .fc-list-event-dot {
  border-color: #212529;
}

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-main,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-title {
  color: var(--bs-dark) !important;
}

.fc-direction-ltr {
  direction: ltr;
}

.fc-direction-ltr .fc-toolbar > * > :not(:first-child) {
  margin-left: 0.75em;
}

.fg-emoji-picker {
  width: 250px !important;
  box-shadow: var(--bs-box-shadow) !important;
  top: auto !important;
  bottom: 130px;
}

.fg-emoji-picker * {
  font-family: var(--bs-font-sans-serif) !important;
  color: var(--bs-body-color) !important;
}

@media (max-width: 991.98px) {
  .fg-emoji-picker {
    left: 14px !important;
    top: auto !important;
    bottom: 118px;
  }
}

.fg-emoji-picker .fg-emoji-picker-container-title {
  color: #212529 !important;
}

.fg-emoji-picker .fg-emoji-picker-search {
  height: 40px !important;
}

.fg-emoji-picker .fg-emoji-picker-search input {
  background-color: var(--bs-input-bg) !important;
  color: var(--bs-body-color) !important;
  padding: 0.5rem 0.9rem !important;
  font-size: 0.8125rem !important;
}

.fg-emoji-picker .fg-emoji-picker-search input::placeholder {
  color: #878a99 !important;
}

.fg-emoji-picker .fg-emoji-picker-search svg {
  fill: var(--bs-body-color) !important;
  right: 11px;
  top: 12px;
}

.fg-emoji-picker .fg-emoji-picker-categories {
  background-color: #f3f6f9 !important;
}

.fg-emoji-picker .fg-emoji-picker-categories li.active {
  background-color: rgba(var(--bs-primary-rgb), 0.2);
}

.fg-emoji-picker .fg-emoji-picker-categories a:hover {
  background-color: rgba(var(--bs-primary-rgb), 0.2);
}

.fg-emoji-picker-grid > li:hover {
  background-color: rgba(var(--bs-primary-rgb), 0.2) !important;
}

a.fg-emoji-picker-close-button {
  background-color: #e5ecf2 !important;
}

table.dataTable td.dataTables_empty,
table.dataTable th.dataTables_empty {
  text-align: center;
  padding: 50px;
  font-weight: 600;
  --bs-table-accent-bg: var(--bs-card-bg-custom);
}

table.dataTable > thead .sorting:before,
table.dataTable > thead .sorting_asc:before,
table.dataTable > thead .sorting_asc_disabled:before,
table.dataTable > thead .sorting_desc:before,
table.dataTable > thead .sorting_desc_disabled:before {
  content: "\\f0360";
  position: absolute;
  right: 0.5rem;
  top: 12px;
  font-size: 0.8rem;
  font-family: "Material Design Icons";
}

table.dataTable > thead .sorting:after,
table.dataTable > thead .sorting_asc:after,
table.dataTable > thead .sorting_asc_disabled:after,
table.dataTable > thead .sorting_desc:after,
table.dataTable > thead .sorting_desc_disabled:after {
  content: "\\f035d";
  position: absolute;
  right: 0.5rem;
  top: 18px;
  font-size: 0.8rem;
  font-family: "Material Design Icons";
}

table.dataTable > tbody > tr.child span.dtr-title {
  font-weight: 600;
  min-width: 150px;
}

table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control::before,
table.dataTable.dtr-inline.collapsed > tbody > tr > th.dtr-control::before {
  background-color: #4b38b3;
  border-color: var(--bs-card-bg-custom);
}

table.dataTable.dtr-inline.collapsed
  > tbody
  > tr.parent.parent
  > th.dtr-control::before {
  background-color: #f06548;
}

table.dataTable.dtr-inline.collapsed
  > tbody
  > tr.parent
  > td.dtr-control::before {
  background-color: #f06548;
}

table.dataTable > tbody > tr.child span.dtr-title {
  min-width: 135px;
}

.table-card .dataTables_filter,
.table-card .dataTables_length {
  padding: 1rem 1rem;
  padding-bottom: 0;
}

.table-card .dataTables_info,
.table-card .dataTables_paginate {
  padding: 1rem 1rem;
}

.table-card div.dataTables_wrapper .col-md-6 {
  width: 100%;
}

.table-card div.dataTables_wrapper div.dataTables_filter input {
  width: calc(100% - 52px);
}

.table-card div.dataTables_wrapper div.dataTables_filter label {
  display: block;
}

div.dtr-modal div.dtr-modal-display {
  background-color: #fff;
  border-color: var(--bs-border-color);
  box-shadow: none;
  height: 70%;
}

div.dtr-modal div.dtr-modal-content {
  padding: 1.25rem;
}

div.dtr-modal div.dtr-modal-content h2 {
  font-size: 1.015625rem;
  font-weight: 600;
  margin-bottom: 15px;
}

div.dtr-modal div.dtr-modal-content .dtr-details tr td {
  padding: 0.75rem 0.6rem;
}

div.dtr-modal div.dtr-modal-close {
  font-size: 24px;
  top: 9px;
  right: 11px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  background-color: var(--bs-card-bg-custom);
  border-color: var(--bs-border-color);
}

div.dtr-modal div.dtr-modal-close:hover {
  background-color: var(--bs-light);
}

.dt-buttons a.dt-button,
.dt-buttons button.dt-button,
.dt-buttons div.dt-button,
.dt-buttons input.dt-button {
  border-color: var(--bs-border-color);
  background: var(--bs-light);
  color: var(--bs-gray-800);
}

.select2.select2-container {
  width: 100% !important;
}

.select2-container .select2-selection--single {
  border: 1px solid var(--bs-input-border);
  height: calc(1.5em + 1rem + 2px);
  background-color: var(--bs-input-bg);
  outline: 0;
}

.select2-container .select2-selection--single .select2-selection__rendered {
  line-height: 36px;
  padding-left: 12px;
  color: var(--bs-body-color);
}

.select2-container .select2-selection--single .select2-selection__arrow {
  height: 34px;
  width: 34px;
  right: 3px;
}

.select2-container .select2-selection--single .select2-selection__arrow b {
  border-color: var(--bs-input-border) transparent transparent transparent;
  border-width: 6px 6px 0 6px;
}

.select2-container--open
  .select2-selection--single
  .select2-selection__arrow
  b {
  border-color: transparent transparent var(--bs-input-border) transparent !important;
  border-width: 0 6px 6px 6px !important;
}

.select2-results__option {
  padding: 6px 12px;
}

.select2-dropdown {
  border: 0 solid var(--bs-border-color);
  box-shadow: var(--bs-box-shadow);
  background-color: var(--bs-choices-bg);
  z-index: 1056;
}

.select2-container--default .select2-results__option--selected {
  background-color: var(--bs-input-disabled-bg);
}

.select2-container--default .select2-search--dropdown {
  padding: 10px;
  background-color: var(--bs-choices-bg);
}

.select2-container--default .select2-search--dropdown .select2-search__field {
  outline: 0;
  border: 1px solid var(--bs-input-border);
  background-color: var(--bs-input-bg);
  color: var(--bs-body-color);
  border-radius: 0.25rem;
}

.select2-container--default
  .select2-results__option--highlighted[aria-selected] {
  background-color: #4b38b3;
}

.select2-container--default .select2-results__option[aria-selected="true"] {
  background-color: var(--bs-choices-bg);
  color: var(--bs-choices-link-active-color);
}

.select2-container--default
  .select2-results__option[aria-selected="true"]:hover {
  background-color: #4b38b3;
  color: #fff;
}

.select2-container--default
  .select2-selection--multiple
  .select2-selection__choice__display {
  padding-left: 36px;
  padding-right: 5px;
}

.select2-container--default
  .select2-selection--single
  .select2-selection__arrow {
  right: 1px;
  left: auto;
}

.select2-container .select2-selection--multiple {
  min-height: calc(1.5em + 1rem + 2px);
  border: 1px solid var(--bs-input-border) !important;
  background-color: var(--bs-input-bg);
}

.select2-container .select2-selection--multiple .select2-selection__rendered {
  padding: 1px 4px;
}

.select2-container .select2-selection--multiple .select2-search__field {
  border: 0;
  color: var(--bs-body-color);
}

.select2-container .select2-selection--multiple .select2-selection__choice {
  background-color: #4b38b3;
  border: none;
  color: #fff;
  border-radius: 3px;
  padding: 3px;
  margin-top: 6px;
}

.select2-container
  .select2-selection--multiple
  .select2-selection__choice__remove {
  color: #fff;
  margin-right: 7px;
  border-color: #5d4cbb;
  padding: 0 8px;
  top: 3px;
}

.select2-container
  .select2-selection--multiple
  .select2-selection__choice__remove:hover {
  color: #fff;
  background-color: #4b38b3;
}

.select2-container .select2-search--inline .select2-search__field {
  margin-top: 7px;
  font-family: var(--bs-font-sans-serif);
}

.select2-container .select2-search textarea::placeholder {
  color: #878a99;
}

.select2-container--default.select2-container--disabled
  .select2-selection--multiple,
.select2-container--default.select2-container--disabled
  .select2-selection--single {
  background-color: var(--bs-input-disabled-bg);
  cursor: default;
}

.toastify {
  padding: 12px 16px;
  color: #fff;
  display: inline-block;
  box-shadow: 0 3px 6px -1px rgba(0, 0, 0, 0.12),
    0 10px 36px -4px rgba(77, 96, 232, 0.3);
  background: #45cb85;
  position: fixed;
  opacity: 0;
  transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
  border-radius: 2px;
  cursor: pointer;
  text-decoration: none;
  max-width: calc(50% - 20px);
  z-index: 2147483647;
}

.toastify.on {
  opacity: 1;
}

.toast-close {
  opacity: 0.4;
  padding: 0 5px;
  position: relative;
  left: 4px;
  margin-left: 4px;
  border: none;
  background: 0 0;
}

.toastify-right {
  right: 15px;
}

.toastify-left {
  left: 15px;
}

.toastify-left .toast-close {
  left: -4px;
  margin-left: 0;
  margin-right: 4px;
}

.toastify-top {
  top: -150px;
}

.toastify-bottom {
  bottom: -150px;
}

.toastify-rounded {
  border-radius: 25px;
}

.toastify-avatar {
  width: 1.5em;
  height: 1.5em;
  margin: -7px 5px;
  border-radius: 2px;
}

.toastify-center {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  max-width: fit-content;
  max-width: -moz-fit-content;
}

@media only screen and (max-width: 360px) {
  .toastify-left,
  .toastify-right {
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    max-width: fit-content;
  }
}

.choices {
  position: relative;
  margin-bottom: 24px;
  font-size: 16px;
}

.choices:focus {
  outline: 0;
}

.choices:last-child {
  margin-bottom: 0;
}

.choices.is-disabled .choices__inner,
.choices.is-disabled .choices__input {
  background-color: rgba(var(--bs-light-rgb), 0.75);
  cursor: not-allowed;
  -webkit-user-select: none;
  user-select: none;
}

.choices.is-disabled .choices__item {
  cursor: not-allowed;
}

.choices [hidden] {
  display: none !important;
}

.choices[data-type*="select-one"] {
  cursor: pointer;
}

.choices[data-type*="select-one"] .choices__inner {
  padding-bottom: 0.25rem;
}

.choices[data-type*="select-one"] .choices__input {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem;
  background-color: var(--bs-input-bg);
  border: 1px solid var(--bs-input-border);
  font-size: 0.8125rem;
  border-radius: 0.25rem;
  color: var(--bs-body-color);
  margin-bottom: 10px;
}

.choices[data-type*="select-one"] .choices__button {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  padding: 0;
  background-size: 8px;
  position: absolute;
  top: 50%;
  right: 0;
  left: auto;
  margin-top: -10px;
  margin-right: 25px;
  margin-left: 0;
  height: 20px;
  width: 20px;
  border-radius: 10em;
  opacity: 0.5;
}

.choices[data-type*="select-one"] .choices__button:focus,
.choices[data-type*="select-one"] .choices__button:hover {
  opacity: 1;
}

.choices[data-type*="select-one"] .choices__button:focus {
  box-shadow: 0 0 0 2px #00bcd4;
}

.choices[data-type*="select-one"]
  .choices__item[data-value=""]
  .choices__button {
  display: none;
}

.choices[data-type*="select-one"]:after {
  content: "\\f0140";
  position: absolute;
  border: 0;
  border-color: #212529 transparent transparent;
  right: 11.5px;
  left: auto;
  font-family: "Material Design Icons";
  width: auto;
  height: auto;
  margin-top: 0;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}

.choices[data-type*="select-one"].is-open:after {
  margin-top: 0;
  transform: translateY(-50%) rotate(-180deg);
}

.choices[data-type*="select-multiple"] .choices__inner,
.choices[data-type*="text"] .choices__inner {
  cursor: text;
  padding-right: 0.9rem;
}

.choices[data-type*="select-multiple"] .choices__button,
.choices[data-type*="text"] .choices__button {
  position: relative;
  display: inline-block;
  margin-top: 0;
  margin-right: -4px;
  margin-bottom: 0;
  margin-left: 8px;
  padding-left: 16px;
  border-left: 1px solid rgba(255, 255, 255, 0.5);
  border-right: 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-size: 8px;
  width: 8px;
  line-height: 1;
  opacity: 0.75;
  border-radius: 0;
}

.choices[data-type*="select-multiple"] .choices__button:focus,
.choices[data-type*="select-multiple"] .choices__button:hover,
.choices[data-type*="text"] .choices__button:focus,
.choices[data-type*="text"] .choices__button:hover {
  opacity: 1;
}

.choices[data-type*="select-multiple"] .choices__list--dropdown,
.choices[data-type*="text"] .choices__list--dropdown {
  padding-bottom: 10px;
}

.choices[data-type*="select-multiple"] .choices__list--dropdown .choices__list,
.choices[data-type*="text"] .choices__list--dropdown .choices__list {
  margin-bottom: 0;
}

.choices[data-type*="select-multiple"] .choices__input {
  padding-top: 3px;
}

.input-light .choices__inner {
  background-color: var(--bs-light);
  border: none;
}

.choices__inner {
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  background-color: var(--bs-input-bg);
  padding: 0.25rem 3.6rem 0.1rem 0.5rem;
  border: 1px solid var(--bs-input-border);
  border-radius: 0.25rem !important;
  font-size: 0.8125rem;
  min-height: 37.5px;
  overflow: hidden;
}

.is-focused .choices__inner,
.is-open .choices__inner {
  border-color: var(--bs-input-focus-border);
}

.choices__list {
  margin: 0;
  padding-left: 0;
  list-style: none;
}

.choices__list--single {
  display: inline-block;
  padding: 4px 16px 4px 4px;
  width: 100%;
}

.choices__list--single .choices__item {
  width: 100%;
}

.choices__list--multiple {
  display: inline;
}

.choices__list--multiple .choices__item {
  display: inline-block;
  vertical-align: initial;
  border-radius: 7px;
  padding: 2px 7px;
  font-size: 11px;
  font-weight: 400;
  margin-right: 3.75px;
  margin-bottom: 3.75px;
  margin-top: 2px;
  background-color: #4b38b3;
  border: 1px solid #4b38b3;
  word-break: break-all;
  box-sizing: border-box;
  color: #fff;
  box-shadow: var(--bs-box-shadow);
}

.choices__list--multiple .choices__item[data-deletable] {
  padding-right: 5px;
}

.choices__list--multiple .choices__item.is-highlighted {
  background-color: #4b38b3;
  border: 1px solid #4b38b3;
}

.is-disabled .choices__list--multiple .choices__item {
  background-color: #3577f1;
  border: 1px solid #3577f1;
}

.choices__list--dropdown {
  visibility: hidden;
  z-index: 1;
  position: absolute;
  width: 100%;
  background-color: var(--bs-choices-bg);
  border: 1px solid var(--bs-border-color);
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  top: 100%;
  margin-top: 0;
  padding: 10px 10px 20px 10px;
  border-bottom-left-radius: 2.5px;
  border-bottom-right-radius: 2.5px;
  overflow: hidden;
  word-break: break-all;
  will-change: visibility;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  transform: translateY(1px);
}

.choices__list--dropdown.is-active {
  visibility: visible;
  animation-name: DropDownSlide;
}

.choices__list--dropdown .choices__item--selectable.is-highlighted {
  background-color: var(--bs-choices-link-hover-bg);
}

.choices__list--dropdown .choices__list {
  margin: 0 -16px -16px;
}

.choices__list--dropdown .has-no-results {
  font-style: italic;
  font-weight: 500;
}

.choices__list--dropdown .choices__item--selectable:after {
  display: none;
}

.is-open .choices__list--dropdown {
  border-color: var(--bs-border-color);
}

.is-flipped .choices__list--dropdown {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: -1px;
  border-radius: 0.25rem 0.25rem 0 0;
}

.is-flipped .choices__list--dropdown.is-active {
  animation-name: DropDownSlideDown;
  transform: translateY(-1px);
}

.choices__list--dropdown .choices__list {
  position: relative;
  max-height: 300px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  will-change: scroll-position;
}

.choices__list--dropdown .choices__item {
  position: relative;
  font-size: 0.8125rem;
  padding: 0.35rem 1.2rem 0.35rem 16px;
}

@media (min-width: 640px) {
  .choices__list--dropdown .choices__item--selectable:after {
    content: attr(data-select-text);
    font-size: 12px;
    opacity: 0;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }

  .choices__list--dropdown .choices__item--selectable.is-highlighted:after {
    opacity: 0.5;
  }
}

.choices__item {
  cursor: default;
}

.choices__item--selectable {
  cursor: pointer;
}

.choices__item--disabled {
  cursor: not-allowed;
  -webkit-user-select: none;
  user-select: none;
  opacity: 0.5;
}

.choices__heading {
  font-weight: 600;
  font-size: 12px;
  padding: 10px 16px;
  border-bottom: 1px solid var(--bs-border-color);
  color: #878a99;
}

.choices__button {
  text-indent: -9999px;
  appearance: none;
  border: 0;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
}

.choices__button:focus {
  outline: 0;
}

.choices__input {
  display: inline-block;
  vertical-align: baseline;
  background-color: var(--bs-input-bg);
  color: var(--bs-body-color);
  font-size: 0.8125rem;
  margin-bottom: 0;
  border: 0;
  border-radius: 0;
  max-width: 100%;
  padding: 2px 0 2px 2px;
}

.choices__input:focus {
  outline: 0;
}

.choices__input::placeholder {
  color: #878a99;
}

.choices__placeholder {
  color: #878a99;
  opacity: 1;
}

[data-layout-mode="dark"] .choices[data-type*="select-one"] .choices__button {
  filter: invert(1) grayscale(100%) brightness(200%);
}

.flatpickr-calendar {
  background: 0 0;
  opacity: 0;
  display: none;
  text-align: center;
  visibility: hidden;
  padding: 0;
  animation: none;
  direction: ltr;
  border: 0;
  font-size: 14px;
  line-height: 24px;
  border-radius: 5px;
  position: absolute;
  width: 307.875px;
  box-sizing: border-box;
  touch-action: manipulation;
  background: var(--bs-choices-bg);
  box-shadow: 1px 0 0 var(--bs-border-color), -1px 0 0 var(--bs-border-color),
    0 1px 0 var(--bs-border-color), 0 -1px 0 var(--bs-border-color),
    0 3px 13px rgba(0, 0, 0, 0.08);
}

.flatpickr-calendar.inline,
.flatpickr-calendar.open {
  opacity: 1;
  max-height: 640px;
  visibility: visible;
}

.flatpickr-calendar.open {
  display: inline-block;
  z-index: 1056;
}

.flatpickr-calendar.animate.open {
  animation: fpFadeInDown 0.3s cubic-bezier(0.23, 1, 0.32, 1);
}

.flatpickr-calendar.inline {
  display: block;
  position: relative;
  top: 2px;
  width: 100%;
  box-shadow: none;
}

.flatpickr-calendar.inline .flatpickr-rContainer {
  display: block;
  width: 100%;
}

.flatpickr-calendar.inline .flatpickr-rContainer .flatpickr-days {
  width: 100%;
  border: 1px solid var(--bs-input-border);
  border-top: none;
  border-radius: 0 0 5px 5px;
}

.flatpickr-calendar.inline .flatpickr-rContainer .flatpickr-days .dayContainer {
  width: 100%;
  min-width: 100%;
  max-width: 100%;
}

.flatpickr-calendar.inline
  .flatpickr-rContainer
  .flatpickr-days
  .dayContainer
  .flatpickr-day {
  max-width: 100%;
  border-radius: 4px;
}

.flatpickr-calendar.inline .flatpickr-time {
  border: 1px solid var(--bs-input-border) !important;
  border-radius: 0.25rem;
}

.flatpickr-calendar.static {
  position: absolute;
  top: calc(100% + 2px);
}

.flatpickr-calendar.static.open {
  z-index: 999;
  display: block;
}

.flatpickr-calendar.multiMonth
  .flatpickr-days
  .dayContainer:nth-child(n + 1)
  .flatpickr-day.inRange:nth-child(7n + 7) {
  box-shadow: none !important;
}

.flatpickr-calendar.multiMonth
  .flatpickr-days
  .dayContainer:nth-child(n + 2)
  .flatpickr-day.inRange:nth-child(7n + 1) {
  box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;
}

.flatpickr-calendar .hasTime .dayContainer,
.flatpickr-calendar .hasWeeks .dayContainer {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.flatpickr-calendar .hasWeeks .dayContainer {
  border-left: 0;
}

.flatpickr-calendar.hasTime .flatpickr-time {
  height: 40px;
  border-top: 1px solid var(--bs-border-color);
}

.flatpickr-calendar.noCalendar.hasTime .flatpickr-time {
  height: auto;
}

.flatpickr-calendar::after,
.flatpickr-calendar::before {
  position: absolute;
  display: block;
  pointer-events: none;
  border: solid transparent;
  content: "";
  height: 0;
  width: 0;
  left: 22px;
}

.flatpickr-calendar.arrowRight::after,
.flatpickr-calendar.arrowRight::before,
.flatpickr-calendar.rightMost::after,
.flatpickr-calendar.rightMost::before {
  left: auto;
  right: 22px;
}

.flatpickr-calendar.arrowCenter::after,
.flatpickr-calendar.arrowCenter::before {
  left: 50%;
  right: 50%;
}

.flatpickr-calendar::before {
  border-width: 5px;
  margin: 0 -5px;
}

.flatpickr-calendar::after {
  border-width: 4px;
  margin: 0 -4px;
}

.flatpickr-calendar.arrowTop::after,
.flatpickr-calendar.arrowTop::before {
  bottom: 100%;
}

.flatpickr-calendar.arrowTop::before {
  border-bottom-color: #4b38b3;
}

.flatpickr-calendar.arrowTop::after {
  border-bottom-color: #4b38b3;
}

.flatpickr-calendar.arrowBottom::after,
.flatpickr-calendar.arrowBottom::before {
  top: 100%;
}

.flatpickr-calendar.arrowBottom::before {
  border-top-color: #4b38b3;
}

.flatpickr-calendar.arrowBottom::after {
  border-top-color: #4b38b3;
}

.flatpickr-calendar:focus {
  outline: 0;
}

.flatpickr-wrapper {
  position: relative;
  display: inline-block;
}

.flatpickr-months {
  display: flex;
  background-color: #4b38b3;
  border-radius: 5px 5px 0 0;
}

.flatpickr-months .flatpickr-month {
  background: 0 0;
  color: rgba(255, 255, 255, 0.9);
  fill: rgba(255, 255, 255, 0.9);
  height: 34px;
  line-height: 1;
  text-align: center;
  position: relative;
  -webkit-user-select: none;
  user-select: none;
  overflow: hidden;
  flex: 1 1;
}

.flatpickr-months .flatpickr-next-month,
.flatpickr-months .flatpickr-prev-month {
  text-decoration: none;
  cursor: pointer;
  position: absolute;
  top: 0;
  height: 34px;
  padding: 10px;
  z-index: 3;
  color: rgba(255, 255, 255, 0.9);
  fill: rgba(255, 255, 255, 0.9);
}

.flatpickr-months .flatpickr-next-month.flatpickr-disabled,
.flatpickr-months .flatpickr-prev-month.flatpickr-disabled {
  display: none;
}

.flatpickr-months .flatpickr-next-month i,
.flatpickr-months .flatpickr-prev-month i {
  position: relative;
}

.flatpickr-months .flatpickr-next-month.flatpickr-prev-month,
.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month {
  left: 0;
}

.flatpickr-months .flatpickr-next-month.flatpickr-next-month,
.flatpickr-months .flatpickr-prev-month.flatpickr-next-month {
  right: 0;
}

.flatpickr-months .flatpickr-next-month:hover,
.flatpickr-months .flatpickr-prev-month:hover {
  color: #959ea9;
}

.flatpickr-months .flatpickr-next-month:hover svg,
.flatpickr-months .flatpickr-prev-month:hover svg {
  fill: rgba(255, 255, 255, 0.9);
}

.flatpickr-months .flatpickr-next-month svg,
.flatpickr-months .flatpickr-prev-month svg {
  width: 14px;
  height: 14px;
}

.flatpickr-months .flatpickr-next-month svg path,
.flatpickr-months .flatpickr-prev-month svg path {
  transition: fill 0.1s;
  fill: inherit;
}

.numInputWrapper {
  position: relative;
  height: auto;
}

.numInputWrapper input,
.numInputWrapper span {
  display: inline-block;
}

.numInputWrapper input {
  width: 100%;
}

.numInputWrapper input::-ms-clear {
  display: none;
}

.numInputWrapper input::-webkit-inner-spin-button,
.numInputWrapper input::-webkit-outer-spin-button {
  margin: 0;
  -webkit-appearance: none;
}

.numInputWrapper span {
  position: absolute;
  right: 0;
  width: 14px;
  padding: 0 4px 0 2px;
  height: 50%;
  line-height: 50%;
  opacity: 0;
  cursor: pointer;
  border: 1px solid rgba(var(--bs-dark-rgb), 0.15);
  box-sizing: border-box;
}

.numInputWrapper span:hover {
  background: rgba(0, 0, 0, 0.1);
}

.numInputWrapper span:active {
  background: rgba(0, 0, 0, 0.2);
}

.numInputWrapper span:after {
  display: block;
  content: "";
  position: absolute;
}

.numInputWrapper span.arrowUp {
  top: 0;
  border-bottom: 0;
}

.numInputWrapper span.arrowUp:after {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid rgba(57, 57, 57, 0.6);
  top: 26%;
}

.numInputWrapper span.arrowDown {
  top: 50%;
}

.numInputWrapper span.arrowDown:after {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid rgba(57, 57, 57, 0.6);
  top: 40%;
}

.numInputWrapper span svg {
  width: inherit;
  height: auto;
}

.numInputWrapper span svg path {
  fill: rgba(0, 0, 0, 0.5);
}

.numInputWrapper:hover {
  background: rgba(0, 0, 0, 0.05);
}

.numInputWrapper:hover span {
  opacity: 1;
}

.flatpickr-current-month {
  font-size: 100%;
  line-height: inherit;
  font-weight: 300;
  color: inherit;
  position: absolute;
  width: 75%;
  left: 12.5%;
  padding: 7.48px 0 0 0;
  line-height: 1;
  height: 34px;
  display: inline-block;
  text-align: center;
  transform: translate3d(0, 0, 0);
}

.flatpickr-current-month span.cur-month {
  font-family: inherit;
  font-weight: 700;
  color: inherit;
  display: inline-block;
  margin-left: 0.5ch;
  padding: 0;
}

.flatpickr-current-month span.cur-month:hover {
  background: rgba(0, 0, 0, 0.05);
}

.flatpickr-current-month .numInputWrapper {
  width: 6ch;
  display: inline-block;
}

.flatpickr-current-month span.arrowUp::after {
  border-bottom-color: rgba(0, 0, 0, 0.9);
}

.flatpickr-current-month span.arrowDown:after {
  border-top-color: rgba(0, 0, 0, 0.9);
}

.flatpickr-current-month input.cur-year {
  background: 0 0;
  box-sizing: border-box;
  color: inherit;
  cursor: text;
  padding: 0 0 0 0.5ch;
  margin: 0;
  display: inline-block;
  font-size: inherit;
  font-family: inherit;
  font-weight: 600;
  line-height: inherit;
  height: auto;
  border: 0;
  border-radius: 0;
  vertical-align: initial;
  appearance: textfield;
}

.flatpickr-current-month input.cur-year:focus {
  outline: 0;
}

.flatpickr-current-month input.cur-year[disabled],
.flatpickr-current-month input.cur-year[disabled]:hover {
  font-size: 100%;
  color: rgba(255, 255, 255, 0.9);
  background: 0 0;
  pointer-events: none;
}

.flatpickr-current-month .flatpickr-monthDropdown-months {
  appearance: menulist;
  background: 0 0;
  border: none;
  border-radius: 0;
  box-sizing: border-box;
  color: inherit;
  cursor: pointer;
  font-size: inherit;
  font-family: inherit;
  font-weight: 600;
  height: auto;
  line-height: inherit;
  margin: -1px 0 0 0;
  outline: 0;
  padding: 0 0 0 0.5ch;
  position: relative;
  vertical-align: initial;
  width: auto;
}

.flatpickr-current-month .flatpickr-monthDropdown-months:active,
.flatpickr-current-month .flatpickr-monthDropdown-months:focus {
  outline: 0;
}

.flatpickr-current-month .flatpickr-monthDropdown-months:hover {
  background-color: transparent;
}

.flatpickr-current-month
  .flatpickr-monthDropdown-months
  .flatpickr-monthDropdown-month {
  background-color: transparent;
  outline: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.8);
}

.flatpickr-weekdays {
  background-color: #4b38b3;
  text-align: center;
  overflow: hidden;
  width: 100%;
  display: flex;
  align-items: center;
  height: 36px;
  border-bottom: 1px solid var(--bs-border-color);
}

.flatpickr-weekdays .flatpickr-weekdaycontainer {
  display: flex;
  flex: 1 1;
}

span.flatpickr-weekday {
  cursor: default;
  font-size: 90%;
  background: #4b38b3;
  color: #fff;
  line-height: 1;
  margin: 0;
  text-align: center;
  display: block;
  flex: 1 1;
  font-weight: 500;
}

.dayContainer,
.flatpickr-weeks {
  padding: 1px 0 0 0;
}

.flatpickr-days {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  width: 307.875px;
}

.flatpickr-days:focus {
  outline: 0;
}

.dayContainer {
  padding: 0;
  outline: 0;
  text-align: left;
  width: 307.875px;
  min-width: 307.875px;
  max-width: 307.875px;
  box-sizing: border-box;
  display: inline-block;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  transform: translate3d(0, 0, 0);
  opacity: 1;
}

.dayContainer + .dayContainer {
  box-shadow: -1px 0 0 #e6e6e6;
}

.flatpickr-day {
  background: 0 0;
  border: 1px solid transparent;
  border-radius: 150px;
  box-sizing: border-box;
  color: var(--bs-body-color);
  cursor: pointer;
  font-weight: 400;
  width: 14.2857143%;
  flex-basis: 14.2857143%;
  max-width: 39px;
  height: 39px;
  line-height: 39px;
  margin: 0;
  display: inline-block;
  position: relative;
  justify-content: center;
  text-align: center;
}

.flatpickr-day:focus,
.flatpickr-day:hover {
  background-color: rgba(var(--bs-light-rgb), 0.7);
}

.flatpickr-day.inRange,
.flatpickr-day.nextMonthDay.inRange,
.flatpickr-day.nextMonthDay.today.inRange,
.flatpickr-day.nextMonthDay:focus,
.flatpickr-day.nextMonthDay:hover,
.flatpickr-day.prevMonthDay.inRange,
.flatpickr-day.prevMonthDay.today.inRange,
.flatpickr-day.prevMonthDay:focus,
.flatpickr-day.prevMonthDay:hover,
.flatpickr-day.today.inRange,
.flatpickr-day:focus,
.flatpickr-day:hover {
  cursor: pointer;
  outline: 0;
  background-color: var(--bs-light);
  border-color: var(--bs-light);
}

.flatpickr-day.today {
  border-color: #4b38b3;
  background-color: rgba(75, 56, 179, 0.1);
  box-shadow: var(--bs-box-shadow);
}

.flatpickr-day.today:focus,
.flatpickr-day.today:hover {
  border-color: #4b38b3;
  background-color: rgba(75, 56, 179, 0.15);
  color: var(--bs-dark);
}

.flatpickr-day.endRange,
.flatpickr-day.endRange.inRange,
.flatpickr-day.endRange.nextMonthDay,
.flatpickr-day.endRange.prevMonthDay,
.flatpickr-day.endRange:focus,
.flatpickr-day.endRange:hover,
.flatpickr-day.selected,
.flatpickr-day.selected.inRange,
.flatpickr-day.selected.nextMonthDay,
.flatpickr-day.selected.prevMonthDay,
.flatpickr-day.selected:focus,
.flatpickr-day.selected:hover,
.flatpickr-day.startRange,
.flatpickr-day.startRange.inRange,
.flatpickr-day.startRange.nextMonthDay,
.flatpickr-day.startRange.prevMonthDay,
.flatpickr-day.startRange:focus,
.flatpickr-day.startRange:hover {
  background: #4b38b3;
  box-shadow: var(--bs-box-shadow);
  color: #fff;
  border-color: #4b38b3;
}

.flatpickr-day.endRange.startRange,
.flatpickr-day.selected.startRange,
.flatpickr-day.startRange.startRange {
  border-radius: 50px 0 0 50px;
}

.flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n + 1)),
.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n + 1)),
.flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n + 1)) {
  box-shadow: -10px 0 0 #4b38b3;
}

.flatpickr-day.endRange.startRange .endRange,
.flatpickr-day.selected.startRange .endRange,
.flatpickr-day.startRange.startRange .endRange {
  border-radius: 50px;
}

.flatpickr-day.endRange.endRange,
.flatpickr-day.selected.endRange,
.flatpickr-day.startRange.endRange {
  border-radius: 0 50px 50px 0;
}

.flatpickr-day.inRange {
  border-radius: 0;
  box-shadow: -5px 0 0 var(--bs-light), 5px 0 0 var(--bs-light);
}

.flatpickr-day.flatpickr-disabled,
.flatpickr-day.flatpickr-disabled:hover,
.flatpickr-day.nextMonthDay,
.flatpickr-day.notAllowed,
.flatpickr-day.notAllowed.nextMonthDay,
.flatpickr-day.notAllowed.prevMonthDay,
.flatpickr-day.prevMonthDay {
  color: rgba(var(--bs-body-color-rgb), 0.3);
  background: 0 0;
  border-color: transparent;
  cursor: default;
}

.flatpickr-day.flatpickr-disabled,
.flatpickr-day.flatpickr-disabled:hover {
  cursor: not-allowed;
  color: rgba(var(--bs-body-color-rgb), 0.3);
}

.flatpickr-day.week.selected {
  border-radius: 0;
  box-shadow: -5px 0 0 #4b38b3, 5px 0 0 #4b38b3;
}

.flatpickr-day.hidden {
  visibility: hidden;
}

.rangeMode .flatpickr-day {
  margin-top: 1px;
}

.flatpickr-weekwrapper {
  float: left;
}

.flatpickr-weekwrapper .flatpickr-weeks {
  padding: 0 12px;
  box-shadow: 1px 0 0 #e6e6e6;
}

.flatpickr-weekwrapper .flatpickr-weekday {
  float: none;
  width: 100%;
  line-height: 35px;
}

.flatpickr-weekwrapper span.flatpickr-day,
.flatpickr-weekwrapper span.flatpickr-day:hover {
  display: block;
  width: 100%;
  max-width: none;
  color: rgba(var(--bs-dark-rgb), 0.3);
  background: 0 0;
  cursor: default;
  border: none;
}

.flatpickr-innerContainer {
  display: block;
  display: flex;
  box-sizing: border-box;
  overflow: hidden;
}

.flatpickr-rContainer {
  display: inline-block;
  padding: 0;
  box-sizing: border-box;
}

.flatpickr-time {
  text-align: center;
  outline: 0;
  display: block;
  height: 0;
  line-height: 40px;
  max-height: 40px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
}

.flatpickr-time:after {
  content: "";
  display: table;
  clear: both;
}

.flatpickr-time .numInputWrapper {
  flex: 1 1;
  width: 40%;
  height: 40px;
  float: left;
}

.flatpickr-time .numInputWrapper span.arrowDown:after,
.flatpickr-time .numInputWrapper span.arrowUp:after {
  border-bottom-color: var(--bs-border-color);
}

.flatpickr-time.hasSeconds .numInputWrapper {
  width: 26%;
}

.flatpickr-time.time24hr .numInputWrapper {
  width: 49%;
}

.flatpickr-time input {
  background: 0 0;
  box-shadow: none;
  border: 0;
  border-radius: 0;
  text-align: center;
  margin: 0;
  padding: 0;
  height: inherit;
  line-height: inherit;
  color: var(--bs-body-color);
  font-size: 14px;
  position: relative;
  box-sizing: border-box;
  appearance: textfield;
}

.flatpickr-time input.flatpickr-hour {
  font-weight: 700;
}

.flatpickr-time input.flatpickr-minute,
.flatpickr-time input.flatpickr-second {
  font-weight: 400;
}

.flatpickr-time input:focus {
  outline: 0;
  border: 0;
}

.flatpickr-time .flatpickr-am-pm,
.flatpickr-time .flatpickr-time-separator {
  height: inherit;
  float: left;
  line-height: inherit;
  color: var(--bs-body-color);
  font-weight: 700;
  width: 2%;
  -webkit-user-select: none;
  user-select: none;
  align-self: center;
}

.flatpickr-time .flatpickr-am-pm {
  outline: 0;
  width: 18%;
  cursor: pointer;
  text-align: center;
  font-weight: 400;
}

.flatpickr-time .flatpickr-am-pm:focus,
.flatpickr-time .flatpickr-am-pm:hover,
.flatpickr-time input:focus,
.flatpickr-time input:hover {
  background: rgba(75, 56, 179, 0.04);
}

.flatpickr-am-pm:focus,
.flatpickr-am-pm:hover,
.numInput:focus,
.numInput:hover,
.numInputWrapper:focus,
.numInputWrapper:hover {
  background-color: transparent;
}

.flatpickr-input[readonly] {
  cursor: pointer;
  background-color: var(--bs-input-bg);
}

[data-inline-date="true"],
[data-time-inline] {
  display: none;
}

@keyframes fpFadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -20px, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

[datepicker-inline],
[timepicker-inline] {
  display: none;
}

[data-input-flag] {
  position: relative;
}

[data-input-flag] .dropdown-menu .dropdown-menu-list {
  max-height: 158px;
  overflow-y: auto;
}

[data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar {
  -webkit-appearance: none;
}

[data-input-flag]
  .dropdown-menu
  .dropdown-menu-list::-webkit-scrollbar:vertical {
  width: 8px;
}

[data-input-flag]
  .dropdown-menu
  .dropdown-menu-list::-webkit-scrollbar:horizontal {
  height: 10px;
}

[data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar-thumb {
  background-color: rgba(var(--bs-dark-rgb), 0.075);
  border-radius: 8px;
}

[data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar-track {
  border-radius: 8px;
}

/* [data-option-flag-img-name] .flag-input {
    padding-left: 45px;
    background-image: url(../images/flags/us.svg);
    background-repeat: no-repeat;
    background-position: 14px 8px;
    background-size: 18px
} */

[data-option-flag-img-name]::before,
[data-option-flag-name]::before {
  content: "\\f0140";
  font-family: "Material Design Icons";
  position: absolute;
  right: 0.9rem;
  top: 0.5rem;
  font-size: 16px;
}

[data-option-countrycode="false"] .country-codeno {
  display: none;
}

[data-search-input="false"] .searchlist-input {
  display: none;
}

.auth-page-wrapper .auth-page-content {
  padding-bottom: 60px;
  position: relative;
  z-index: 2;
  width: 100%;
}

.auth-page-wrapper .footer {
  left: 0;
  background-color: transparent;
  color: var(--bs-body-color);
}

.auth-one-bg-position {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 380px;
}

@media (max-width: 575.98px) {
  .auth-one-bg-position {
    height: 280px;
  }
}

.auth-one-bg .shape {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1;
  pointer-events: none;
}

.auth-one-bg .shape > svg {
  width: 100%;
  height: auto;
  fill: var(--bs-body-bg);
}

.auth-pass-inputgroup input[type="text"] + .btn .ri-eye-fill:before {
  content: "\\ecb6";
}

.particles-js-canvas-el {
  position: relative;
}

.signin-other-title {
  position: relative;
}

.signin-other-title:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  right: 0;
  border-top: 1px dashed var(--bs-border-color);
  top: 10px;
}

.signin-other-title .title {
  display: inline-block;
  position: relative;
  z-index: 9;
  background-color: var(--bs-card-bg-custom);
  padding: 2px 16px;
}

.auth-bg-cover {
  background: #f5f5f5;
}

/* .auth-bg-cover>.bg-overlay {
    background-image: url(../images/cover-pattern.png);
    background-position: center;
    background-size: cover;
    opacity: 1;
    background-color: transparent
} */

.auth-bg-cover .footer {
  color: rgba(255, 255, 255, 0.5);
}

#password-contain {
  display: none;
}

#password-contain p {
  padding-left: 13px;
}

#password-contain p.valid {
  color: #45cb85;
}

#password-contain p.valid::before {
  position: relative;
  left: -8px;
  content: "✔";
}

#password-contain p.invalid {
  color: #f06548;
}

#password-contain p.invalid::before {
  position: relative;
  left: -8px;
  content: "✖";
}

.dash-filter-picker {
  min-width: 210px !important;
}

.upcoming-scheduled {
  position: relative;
}

.upcoming-scheduled .flatpickr-months {
  position: absolute !important;
  top: -45px !important;
  left: auto !important;
  right: 0 !important;
  width: 200px;
  background-color: transparent;
}

.upcoming-scheduled .flatpickr-months .flatpickr-month {
  color: #878a99 !important;
  fill: #878a99 !important;
}

.upcoming-scheduled .flatpickr-months .flatpickr-next-month,
.upcoming-scheduled .flatpickr-months .flatpickr-prev-month {
  display: none;
}

.upcoming-scheduled .flatpickr-calendar {
  box-shadow: none !important;
}

.upcoming-scheduled .flatpickr-calendar .flatpickr-current-month {
  font-size: 13px;
  width: 100%;
  left: 0;
}

.upcoming-scheduled .flatpickr-calendar .flatpickr-monthDropdown-months {
  border: 1px solid var(--bs-border-color);
  border-radius: 4px;
  height: 26px;
}

.upcoming-scheduled .flatpickr-calendar .flatpickr-weekdays {
  background-color: var(--bs-light);
  border: none;
}

.upcoming-scheduled
  .flatpickr-calendar
  .flatpickr-weekdays
  span.flatpickr-weekday {
  color: var(--bs-dark);
  background-color: var(--bs-light);
}

.upcoming-scheduled .flatpickr-calendar .flatpickr-day.today {
  color: #fff !important;
  background-color: #45cb85;
  border-color: #45cb85 !important;
}

.upcoming-scheduled .flatpickr-calendar .flatpickr-day.today:hover {
  color: #45cb85 !important;
  background-color: rgba(69, 203, 133, 0.2) !important;
}

.upcoming-scheduled .flatpickr-calendar .flatpickr-day.selected {
  background-color: #45cb85 !important;
  border-color: #45cb85 !important;
  color: #fff;
}

.upcoming-scheduled .flatpickr-calendar .numInputWrapper {
  width: 7.5ch;
  margin-left: 10px;
}

.upcoming-scheduled .flatpickr-days {
  border: none !important;
}

.crm-widget .col {
  border-right: 1px solid var(--bs-border-color);
}

.crm-widget .col:last-child {
  border: 0;
}

@media (min-width: 768px) and (max-width: 1399.98px) {
  .crm-widget .col:nth-child(3) {
    border-right: 0;
  }

  .crm-widget .col:last-child {
    border-right: 1px solid var(--bs-border-color);
  }
}

@media (max-width: 767.98px) {
  .crm-widget .col {
    border-right: 0;
    border-bottom: 1px solid var(--bs-border-color);
  }
}

@media (min-width: 1400px) and (max-width: 1599.98px) {
  .project-wrapper .col-xxl-4,
  .project-wrapper > .col-xxl-8 {
    width: 100%;
  }
}

.crypto-widget {
  max-width: 130px !important;
}

/* .bg-marketplace {
    background-image: url(../images/nft/marketplace.png);
    background-size: cover
} */

.dash-countdown .countdownlist .count-num {
  background-color: var(--bs-card-bg-custom);
  padding: 16px 8px;
  font-size: 22px;
}

@media (max-width: 575.98px) {
  .dash-countdown .countdownlist .count-num {
    font-size: 16px;
    padding: 8px 6px;
  }
}

@media (max-width: 575.98px) {
  .dash-countdown .countdownlist .count-title {
    font-size: 10px;
  }
}

.marketplace-icon {
  position: absolute;
  float: right;
  top: 30px;
  left: 30px;
}

.marketplace-swiper .swiper-button-next,
.marketplace-swiper .swiper-button-prev {
  top: 34px;
  width: 28px;
  height: 28px;
  background-color: rgba(75, 56, 179, 0.1);
  color: #4b38b3;
  border-radius: 0.3rem;
  right: 16px !important;
}

.marketplace-swiper .swiper-button-prev {
  right: 58px !important;
  left: auto !important;
}

.dash-collection .content {
  background-color: rgba(255, 255, 255, 0.25);
  backdrop-filter: blur(5px);
}

@media (max-width: 1441.98px) {
  .dash-nft .col-xxl-3,
  .dash-nft .col-xxl-9 {
    width: 100% !important;
    max-width: 100% !important;
  }
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {
  width: 32px;
  height: 32px;
  display: inline-block;
  vertical-align: middle;
}

.timeline {
  position: relative;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto;
}

.timeline::after {
  content: "";
  position: absolute;
  width: 2px;
  background: var(--bs-card-bg-custom);
  top: 57px;
  bottom: 166px;
  left: 50%;
  margin-left: -1.5px;
}

.timeline-item {
  padding: 30px 60px;
  position: relative;
  background: inherit;
  width: 50%;
}

.timeline-item .icon {
  position: absolute;
  display: inline-flex;
  width: 60px;
  height: 60px;
  align-items: center;
  justify-content: center;
  font-size: 25px;
  top: 30px;
  right: -30px;
  padding: 9px 0;
  background: var(--bs-card-bg-custom);
  border: 1px solid var(--bs-border-color);
  border-radius: 50px;
  color: #45cb85;
  z-index: 1;
}

.timeline-item .date {
  position: absolute;
  display: inline-block;
  width: calc(100% - 48px);
  top: 50px;
  font-size: 14px;
  font-weight: 500;
  font-style: italic;
}

.timeline-item .content {
  padding: 20px;
  background: var(--bs-card-bg-custom);
  position: relative;
  border: 1px solid var(--bs-border-color);
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.timeline-item.left {
  left: 0;
}

.timeline-item.left .date {
  left: calc(100% + 48px);
  text-align: start;
}

.timeline-item.right {
  left: 50%;
}

.timeline-item.right .icon {
  left: -30px;
}

.timeline-item.right .date {
  right: calc(100% + 48px);
  text-align: end;
}

.timeline-item.right::before {
  left: 28px;
  border-color: transparent transparent transparent #fff;
}

@media (max-width: 991.98px) {
  .timeline::after {
    left: 112px;
    bottom: 180px;
  }

  .timeline-item {
    width: 100%;
    padding-left: 165px;
    padding-right: 0;
  }

  .timeline-item.left,
  .timeline-item.right {
    left: 0;
  }

  .timeline-item.left .icon,
  .timeline-item.right .icon {
    width: 45px;
    height: 45px;
    top: 37.5px;
    font-size: 18px;
    left: 90px;
  }

  .timeline-item.left::before,
  .timeline-item.right::before {
    left: 110px;
    border-color: transparent transparent transparent var(--bs-border-color);
  }

  .timeline-item.left .date,
  .timeline-item.right .date {
    right: auto;
    left: 0;
    width: 79px;
  }
}

.timeline-2 {
  position: relative;
}

.timeline-2::after {
  position: absolute;
  content: "";
  width: 2px;
  height: 83%;
  top: 50px;
  left: 40px;
  margin-left: -1px;
  background: var(--bs-card-bg-custom);
}

.timeline-2 .timeline-year {
  position: relative;
  width: 100%;
  text-align: left;
  z-index: 1;
}

.timeline-2 .timeline-year p {
  display: inline-flex;
  width: 80px;
  height: 80px;
  margin: 0;
  padding: 23px 10px;
  background: var(--bs-card-bg-custom);
  border-radius: 50px;
  text-transform: uppercase;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.timeline-2 .timeline-year p span {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.timeline-2 .timeline-date {
  font-size: 14px;
  font-weight: 500;
  margin: 24px 0 0 0;
  margin-left: 55px;
}

.timeline-2 .timeline-date::after {
  content: "";
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  top: 26px;
  left: 45px;
  align-items: left;
  background: #45cb85;
  border: 3px solid var(--bs-card-bg-custom);
  border-radius: 50px;
  z-index: 1;
}

.timeline-2 .timeline-box {
  position: relative;
  display: inline-block;
  margin: 23px 62px;
  padding: 20px;
  border: 1px solid var(--bs-border-color);
  border-radius: 6px;
  background: var(--bs-card-bg-custom);
  max-width: 695px;
}

.timeline-2 .timeline-box::after {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  top: 26px;
  right: 100%;
  border-color: transparent var(--bs-card-bg-custom) transparent transparent;
  border-width: 10px;
}

.timeline-2 .timeline-box::before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  right: 100%;
  top: 24px;
  border-color: transparent var(--bs-border-color) transparent transparent;
  border-width: 12px;
}

.timeline-2 .timeline-box .timeline-text {
  position: relative;
  float: left;
}

.timeline-2 .timeline-launch {
  position: relative;
  display: inline-block;
  border: 1px solid var(--bs-border-color);
  border-radius: 6px;
  background: #fff;
  width: 100%;
  margin-top: 15px;
  padding: 0;
  border: none;
  text-align: left;
  background: 0 0;
}

.timeline-2 .timeline-launch .timeline-box {
  margin-left: 0;
}

.timeline-2 .timeline-launch .timeline-box::after {
  left: 30px;
  margin-left: 0;
  top: -20px;
  border-color: transparent transparent var(--bs-border-color) transparent;
}

.timeline-2 .timeline-launch .timeline-box::before {
  left: 30px;
  margin-left: 0;
  top: -19px;
  border-color: transparent transparent var(--bs-card-bg-custom) transparent;
  border-width: 10px;
  z-index: 1;
}

.horizontal-timeline {
  position: relative;
  width: 100%;
  margin: 0 auto;
}

.horizontal-timeline::before {
  content: "";
  position: absolute;
  width: 100%;
  top: 174px;
  left: 0;
  height: 2px;
  background-color: var(--bs-card-bg-custom);
}

.horizontal-timeline .swiper-slide .item-box {
  margin: 227px 0 0;
  background-color: transparent;
  box-shadow: none;
}

.horizontal-timeline .swiper-slide .item-box::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  background: #4b38b3;
  width: 13px;
  height: 13px;
  top: -59px;
  border-radius: 50px;
  border: 3px solid var(--bs-card-bg-custom);
}

.horizontal-timeline .swiper-slide .timeline-content {
  min-height: 110px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: var(--bs-card-bg-custom);
}

.horizontal-timeline .swiper-slide .timeline-content::before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  border-style: solid;
  left: 0;
  top: -23px;
  border-color: transparent transparent var(--bs-card-bg-custom) transparent;
  border-width: 12px;
  right: 0;
  margin: 0 auto;
}

.horizontal-timeline .swiper-slide .time {
  position: absolute;
  top: -86px;
  right: 0;
  left: 0;
  margin: 0 auto;
}

.horizontal-timeline .swiper-slide:nth-child(even) {
  margin-top: 5px;
  transform: rotate(-180deg);
}

.horizontal-timeline .swiper-slide:nth-child(even) .timeline-content {
  transform: rotate(180deg);
}

.horizontal-timeline .swiper-slide:nth-child(even) .timeline-content::before {
  bottom: -23px;
  top: auto;
  border-color: var(--bs-card-bg-custom) transparent transparent transparent;
}

.horizontal-timeline .swiper-slide:nth-child(even) .time {
  transform: rotate(180deg);
}

.horizontal-timeline .swiper-button-next,
.horizontal-timeline .swiper-button-prev {
  height: 40px;
  width: 40px;
  line-height: 40px;
  border-radius: 50%;
  background-color: #4f3bbd;
}

.horizontal-timeline .swiper-button-next::after,
.horizontal-timeline .swiper-button-prev::after {
  font-size: 24px;
  color: #fff;
}

.horizontal-timeline .swiper-button-next.swiper-button-disabled,
.horizontal-timeline .swiper-button-prev.swiper-button-disabled {
  background-color: rgba(75, 56, 179, 0.5);
  opacity: 1;
  cursor: auto;
  backdrop-filter: blur(25px);
  pointer-events: none;
}

.horizontal-timeline .swiper-button-next {
  right: 0;
}

.horizontal-timeline .swiper-button-next::after {
  content: "\\ea6e";
  font-family: remixicon;
}

.horizontal-timeline .swiper-button-prev {
  left: 0;
}

.horizontal-timeline .swiper-button-prev::after {
  content: "\\ea64";
  font-family: remixicon;
}

.acitivity-timeline {
  position: relative;
  overflow: hidden;
}

.acitivity-timeline .acitivity-item {
  position: relative;
}

.acitivity-timeline .acitivity-item .flex-shrink-0 {
  z-index: 2;
}

.acitivity-timeline .acitivity-item .acitivity-avatar {
  background-color: var(--bs-card-bg-custom);
  border: 3px solid var(--bs-card-bg-custom);
  height: 32px;
  width: 32px;
}

.acitivity-timeline .acitivity-item:before {
  content: "";
  position: absolute;
  border-left: 1px dashed var(--bs-border-color);
  left: 16px;
  height: 100%;
  top: 5px;
  z-index: 0;
}

.acitivity-timeline .acitivity-item:last-child::before {
  border-color: transparent;
}

.categories-filter .list-inline-item {
  position: relative;
  margin-right: 0;
}

.categories-filter .list-inline-item a {
  display: block;
  color: var(--bs-body-color);
  font-weight: 600;
  padding: 8px 15px;
  margin: 5px;
  cursor: pointer;
}

.gallery-box {
  position: relative;
  overflow: hidden;
  border: 1px solid transparent;
  margin-bottom: 10px;
  box-shadow: none;
  background-color: transparent;
  padding: 8px;
}

.gallery-box::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  width: 100%;
  height: 0;
  background-color: var(--bs-card-bg-custom);
  transition: all 0.4s;
}

.gallery-box .gallery-container {
  position: relative;
  overflow: hidden;
  border-radius: 4px;
}

.gallery-box .gallery-container a {
  display: block;
}

.gallery-box .gallery-container .gallery-overlay {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  opacity: 0;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 10%,
    rgba(0, 0, 0, 0) 60%,
    rgba(0, 0, 0, 0.5) 100%
  );
  visibility: hidden;
  overflow: hidden;
  transition: all 0.4s ease-in-out 0s;
  display: flex;
  width: 100%;
  align-items: flex-end;
  padding: 16px;
}

.gallery-box .gallery-container .gallery-overlay .overlay-caption {
  color: #fff;
  margin: 0;
  font-size: 16px;
}

.gallery-box .gallery-img {
  transition: all 0.2s ease-in-out;
}

.gallery-box .box-content {
  position: relative;
}

.gallery-box .box-content .title {
  font-size: 14px;
  margin-bottom: 4px;
  display: none;
}

.gallery-box .box-content .post {
  margin: 0;
  transition: all 0.2s;
  color: #878a99;
}

.gallery-box:hover::before {
  height: 100%;
}

.gallery-box:hover .box-content {
  bottom: 0;
}

.gallery-box:hover .box-content .post {
  opacity: 1;
}

.gallery-box:hover .gallery-overlay {
  opacity: 1;
  visibility: visible;
}

.gallery-light .gallery-box::before {
  background-color: var(--bs-light);
}

.error-basic-img {
  max-width: 450px;
}

.error-500 .title {
  font-size: 250px;
}

.error-500 .error-500-img {
  position: absolute;
  top: 57px;
  left: 0;
  right: 0;
  margin: 0 auto;
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .error-500 .title {
    font-size: 150px;
  }

  .error-500 .error-500-img {
    width: 20% !important;
    top: 43px;
  }
}

@media (max-width: 767.98px) {
  .error-500 .title {
    font-size: 68px;
    margin-top: 35px;
  }

  .error-500 .error-500-img {
    position: relative;
    top: 0;
  }
}

@keyframes errorAnimation {
  0% {
    transform: translateX(0);
  }

  15% {
    transform: translateX(-25%) rotate(-5deg);
  }

  30% {
    transform: translateX(20%) rotate(3deg);
  }

  45% {
    transform: translateX(-15%) rotate(-3deg);
  }

  60% {
    transform: translateX(10%) rotate(2deg);
  }

  75% {
    transform: translateX(-5%) rotate(-1deg);
  }

  100% {
    transform: translateX(0);
  }
}

.error-img {
  animation: errorAnimation 20s infinite;
}

.error-text {
  text-shadow: 4px 4px rgba(69, 203, 133, 0.4);
}

@media (min-width: 1200px) {
  .error-text {
    font-size: 10rem;
  }
}

.profile-wid-bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 320px;
}

@media (max-width: 575.98px) {
  .profile-wid-bg {
    height: 445px;
  }
}

.profile-wid-bg::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  opacity: 0.9;
  background: #4b38b3;
  background: linear-gradient(to top, #221a52, #4b38b3);
}

.profile-wid-bg .profile-wid-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.profile-nav.nav-pills .nav-link {
  color: rgba(255, 255, 255, 0.8);
}

.profile-nav.nav-pills .nav-link::before {
  background-color: rgba(255, 255, 255, 0.1);
}

.profile-project-card {
  border: 1px solid var(--bs-border-color);
  border-left: 3px solid var(--bs-border-color);
}

.profile-project-card.profile-project-primary {
  border-left-color: #4b38b3;
}

.profile-project-card.profile-project-secondary {
  border-left-color: #3577f1;
}

.profile-project-card.profile-project-success {
  border-left-color: #45cb85;
}

.profile-project-card.profile-project-info {
  border-left-color: #299cdb;
}

.profile-project-card.profile-project-warning {
  border-left-color: #ffbe0b;
}

.profile-project-card.profile-project-danger {
  border-left-color: #f06548;
}

.profile-project-card.profile-project-light {
  border-left-color: #f3f6f9;
}

.profile-project-card.profile-project-dark {
  border-left-color: #212529;
}

.user-profile-img {
  position: relative;
}

.user-profile-img .profile-img {
  width: 100%;
  height: 250px;
  object-fit: cover;
}

@media (max-width: 991px) {
  .user-profile-img .profile-img {
    height: 160px;
  }
}

.user-profile-img .profile-foreground-img-file-input {
  display: none;
}

.user-profile-img .profile-photo-edit {
  cursor: pointer;
}

.profile-user {
  position: relative;
  display: inline-block;
}

.profile-user .profile-photo-edit {
  position: absolute;
  right: 0;
  left: auto;
  bottom: 0;
  cursor: pointer;
}

.profile-user .user-profile-image {
  object-fit: cover;
}

.profile-user .profile-img-file-input {
  display: none;
}

.profile-timeline .accordion-item {
  position: relative;
}

.profile-timeline .accordion-item .accordion-button {
  background-color: transparent;
}

.profile-timeline .accordion-item .accordion-button::after {
  background: 0 0;
}

.profile-timeline .accordion-item::before {
  content: "";
  border-left: 2px dashed var(--bs-border-color);
  position: absolute;
  height: 100%;
  left: 23px;
}

.profile-timeline .accordion-item:first-child::before {
  top: 8px;
}

.profile-timeline .accordion-item:last-child::before {
  height: 20px;
  top: 3px;
}

.profile-setting-img {
  position: relative;
  height: 260px;
}

.profile-setting-img .overlay-content {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
}

.profile-setting-img .profile-img {
  width: 100%;
  height: 250px;
  object-fit: cover;
}

@media (max-width: 991.98px) {
  .profile-setting-img .profile-img {
    height: 160px;
  }
}

.profile-setting-img .profile-foreground-img-file-input {
  display: none;
}

.profile-setting-img .profile-photo-edit {
  cursor: pointer;
}

@media (max-width: 575.98px) {
  [data-layout="horizontal"] .profile-foreground {
    margin-top: 0 !important;
  }
}

.sitemap-content {
  width: 100%;
  max-width: 1142px;
  margin: 0 auto;
  padding: 0 20px;
}

.sitemap-content * {
  position: relative;
}

.sitemap-horizontal {
  position: relative;
}

.sitemap-horizontal ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

.sitemap-horizontal ul a {
  display: block;
  background: var(--bs-light);
  border: 2px solid var(--bs-card-bg-custom);
  box-shadow: var(--bs-box-shadow);
  font-size: 0.8125rem;
  height: 60px;
  padding: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.sitemap-horizontal ul a span {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.administration .director > li > a {
  width: 50%;
  margin: 0 auto 0 auto;
  border-radius: 4px;
}

.administration .subdirector {
  position: absolute;
  width: 100%;
}

.administration .subdirector::after {
  content: "";
  display: block;
  width: 0;
  height: 130px;
  border-left: 2px dashed var(--bs-border-color);
  left: 45.45%;
  position: relative;
}

.administration .subdirector > li:first-child {
  width: 18.59%;
  height: 64px;
  margin: 0 auto 92px auto;
  padding-top: 25px;
  border-bottom: 2px dashed var(--bs-border-color);
  z-index: 1;
  float: right;
  right: 27.2%;
  border-left: 2px dashed var(--bs-border-color);
}

.administration .subdirector > li:first-child a {
  width: 100%;
  left: 25px;
}

@media screen and (max-width: 767px) {
  .administration .subdirector > li:first-child {
    width: 40%;
    right: 10%;
    margin-right: 2px;
  }

  .administration .subdirector::after {
    left: 49.8%;
  }
}

.departments {
  width: 100%;
}

.departments > li:first-child {
  width: 18.59%;
  height: 64px;
  margin: 0 auto 92px auto;
  padding-top: 25px;
  border-bottom: 2px dashed var(--bs-border-color);
  z-index: 1;
  float: left;
  left: 27%;
}

.departments > li:first-child a {
  width: 100%;
  right: 25px;
}

.departments > li:nth-child(2) {
  margin-left: 0;
  clear: left;
}

.departments > li:nth-child(2).department:before {
  border: none;
}

.departments::after {
  content: "";
  display: block;
  position: absolute;
  width: 81.1%;
  height: 22px;
  border-top: 2px dashed var(--bs-border-color);
  border-right: 2px dashed var(--bs-border-color);
  border-left: 2px dashed var(--bs-border-color);
  margin: 0 auto;
  top: 130px;
  left: 9.1%;
}

@media screen and (max-width: 767px) {
  .departments > li:first-child {
    width: 40%;
    left: 10%;
    margin-left: 2px;
  }

  .departments::after {
    border-right: none;
    left: 0;
    width: 50%;
  }
}

.department {
  border-left: 2px dashed var(--bs-border-color);
  float: left;
  margin-left: 1.75%;
  margin-bottom: 60px;
  width: 18.25%;
}

.department::before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 22px;
  border-left: 2px dashed var(--bs-border-color);
  z-index: 1;
  top: -22px;
  left: 50%;
  margin-left: -4px;
}

.department > a {
  margin: 0 0 -26px -4px;
  z-index: 1;
}

.department ul {
  margin-top: 0;
  margin-bottom: 0;
}

.department ul li {
  padding-left: 25px;
  border-bottom: 2px dashed var(--bs-border-color);
  height: 80px;
}

.department ul li a {
  background: var(--bs-card-bg-custom);
  margin-top: 48px;
  position: absolute;
  z-index: 1;
  width: 90%;
  height: 60px;
  vertical-align: middle;
  right: -1px;
  text-align: center;
}

.department:first-child {
  margin-left: 0;
  clear: left;
}

@media screen and (min-width: 768px) {
  .department:last-child:before {
    border: none;
  }
}

@media screen and (max-width: 767px) {
  .department {
    float: none;
    width: 100%;
    margin-left: 0;
  }

  .department::before {
    content: "";
    display: block;
    position: absolute;
    width: 0;
    height: 60px;
    border-left: 2px dashed #fff;
    z-index: 1;
    top: -60px;
    left: 0;
    margin-left: -4px;
  }

  .department:nth-child(2)::before {
    display: none;
  }
}

.hori-sitemap ul {
  padding: 0;
  padding-top: 10px;
  text-align: center;
}

.hori-sitemap ul li {
  position: relative;
}

@media (max-width: 575.98px) {
  .hori-sitemap ul {
    text-align: left;
  }

  .hori-sitemap ul .parent-title a {
    padding-left: 0;
  }

  .hori-sitemap ul .parent-title a:after {
    display: none;
  }

  .hori-sitemap ul .parent-title:before {
    display: none;
  }
}

@media (max-width: 575.98px) {
  .hori-sitemap > ul {
    position: relative;
  }

  .hori-sitemap > ul li {
    padding-top: 10px;
  }

  .hori-sitemap > ul li .second-list,
  .hori-sitemap > ul li .sub-list {
    position: relative;
  }

  .hori-sitemap > ul li .second-list:before,
  .hori-sitemap > ul li .sub-list:before {
    content: "";
    height: calc(100% - 14px);
    border-right: 2px dashed var(--bs-border-color);
    position: absolute;
    top: 0;
    left: 0;
  }

  .hori-sitemap > ul li .sub-list:before {
    height: 38%;
  }

  .hori-sitemap > ul li a {
    position: relative;
    padding: 4px 16px 4px 36px;
  }

  .hori-sitemap > ul li a:after {
    content: "";
    width: 24px;
    border-top: 2px dashed var(--bs-border-color);
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
  }

  .hori-sitemap > ul li ul {
    margin-left: 36px;
  }
}

@media (min-width: 576px) {
  .hori-sitemap ul {
    padding-top: 20px;
  }

  .hori-sitemap ul li {
    padding-top: 30px;
  }

  .hori-sitemap ul li:before {
    content: "";
    height: 24px;
    width: 0;
    border-right: 2px dashed var(--bs-border-color);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    margin: 0 auto;
  }

  .hori-sitemap ul li:after {
    content: "";
    width: 100%;
    border-top: 2px dashed var(--bs-border-color);
    position: absolute;
    top: 0;
    left: 50%;
  }

  .hori-sitemap ul li:last-of-type:after {
    display: none;
  }

  .hori-sitemap ul li.parent-title::before {
    content: "";
    height: 23px;
    border-right: 2px dashed var(--bs-border-color);
    position: absolute;
    top: 28px;
    left: 0;
  }

  .hori-sitemap ul li.parent-title::after {
    border: none;
  }

  .hori-sitemap ul li .sub-title {
    position: relative;
  }

  .hori-sitemap ul li .sub-title::before {
    content: "";
    height: 21px;
    border-right: 2px dashed var(--bs-border-color);
    position: absolute;
    top: 27px;
    left: 49%;
    margin: 0 auto;
  }
}

.hori-sitemap a {
  color: var(--bs-body-color);
  padding: 4px 0;
  display: block;
}

.verti-sitemap a {
  color: var(--bs-body-color);
  display: block;
}

.verti-sitemap .parent-title a {
  padding-left: 0;
}

.verti-sitemap .parent-title a:before {
  display: none;
}

.verti-sitemap .parent-title:before {
  display: none;
}

.verti-sitemap .first-list {
  position: relative;
  padding-top: 10px;
}

.verti-sitemap .first-list:before {
  content: "";
  border-left: 2px dashed var(--bs-border-color);
  position: absolute;
  top: 0;
  height: 100%;
  bottom: 0;
  left: 0;
}

.verti-sitemap .first-list .list-wrap a,
.verti-sitemap .first-list li a {
  position: relative;
  padding: 10px 16px 4px 36px;
}

.verti-sitemap .first-list .list-wrap a::before,
.verti-sitemap .first-list li a::before {
  content: "";
  width: 24px;
  border-top: 2px dashed var(--bs-border-color);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
}

.verti-sitemap .first-list .second-list,
.verti-sitemap .first-list .third-list {
  margin-left: 42px;
}

.verti-sitemap .first-list .second-list,
.verti-sitemap .first-list .third-list {
  position: relative;
}

.verti-sitemap .first-list .second-list li,
.verti-sitemap .first-list .third-list li {
  position: relative;
}

.verti-sitemap .first-list .second-list li:before,
.verti-sitemap .first-list .third-list li:before {
  content: "";
  height: 100%;
  border-left: 2px dashed var(--bs-border-color);
  position: absolute;
  top: 0;
  left: 0;
  margin: 0 auto;
}

.verti-sitemap .first-list .second-list li:last-child::before,
.verti-sitemap .first-list .third-list li:last-child::before {
  height: 13px;
}

.verti-sitemap .first-list:last-child::before {
  height: 25px;
}

.modal-team-cover,
.profile-offcanvas .team-cover,
.team-box .team-cover {
  display: none;
  position: relative;
  margin-bottom: -140px;
}

.modal-team-cover img,
.profile-offcanvas .team-cover img,
.team-box .team-cover img {
  height: 140px;
  width: 100%;
  object-fit: cover;
}

.modal-team-cover::before,
.profile-offcanvas .team-cover::before,
.team-box .team-cover::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: linear-gradient(to top, #221a52, #4b38b3);
  opacity: 0.6;
}

.team-list.grid-view-filter {
  flex-flow: row wrap;
}

.team-list.grid-view-filter .col {
  flex: 0 0 auto;
  width: 25%;
}

.team-list.grid-view-filter .team-box {
  overflow: hidden;
}

.team-list.grid-view-filter .team-box .team-row {
  align-items: start;
}

.team-list.grid-view-filter .team-box .team-row .col {
  width: 100%;
}

.team-list.grid-view-filter .team-box .team-cover {
  display: block;
}

.team-list.grid-view-filter .team-box .team-settings .col {
  width: 50% !important;
  flex: 0 0 auto;
}

.team-list.grid-view-filter .team-box .team-settings .btn-star {
  color: #fff;
}

.team-list.grid-view-filter .team-box .team-settings .dropdown > a {
  color: #fff;
}

.team-list.grid-view-filter .team-box .team-profile-img {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 25px;
  margin-top: 36px;
}

.team-list.grid-view-filter .team-box .team-profile-img .avatar-lg {
  font-size: 22px;
}

.team-list.grid-view-filter .team-box .team-profile-img .team-content {
  margin-left: 0;
  margin-top: 25px;
  text-align: center;
}

.team-list.grid-view-filter .team-box .view-btn {
  width: 100%;
  margin-top: 25px;
}

@media (min-width: 1200px) and (max-width: 1399.98px) {
  .team-list.grid-view-filter .col {
    flex: 0 0 auto;
    width: 33.33%;
  }
}

@media (max-width: 1199.98px) {
  .team-list.grid-view-filter .col {
    flex: 0 0 auto;
    width: 50%;
  }
}

@media (max-width: 767.98px) {
  .team-list.grid-view-filter .col {
    flex: 0 0 auto;
    width: 100%;
  }
}

.team-list.list-view-filter {
  flex-direction: column;
}

.team-list.list-view-filter .team-box {
  margin-bottom: 10px;
}

.team-list.list-view-filter .team-box .team-row {
  align-items: center;
  justify-content: space-between;
}

.team-list.list-view-filter .team-box .team-profile-img {
  display: flex;
  align-items: center;
}

.team-list.list-view-filter .team-box .team-profile-img .avatar-lg {
  height: 4rem;
  width: 4rem;
  font-size: 16px;
}

.team-list.list-view-filter .team-box .team-profile-img .team-content {
  margin-left: 15px;
}

.team-list.list-view-filter .team-box .team-settings {
  width: auto;
  flex: 0 0 auto;
  order: 6;
}

.team-list.list-view-filter .team-box .btn-star {
  color: #4b38b3;
}

@media (max-width: 767.98px) {
  .team-list.list-view-filter {
    flex-direction: row;
  }

  .team-list.list-view-filter .col {
    flex: 0 0 auto;
    width: 100%;
  }

  .team-list.list-view-filter .team-box .team-settings {
    width: 100%;
    flex: 0 0 auto;
    order: -1;
    margin-bottom: 10px;
  }

  .team-list.list-view-filter .team-box .team-settings .col {
    width: 50%;
  }

  .team-list.list-view-filter .team-box .team-profile-img {
    margin-bottom: 25px;
  }

  .team-list.list-view-filter .team-box .view-btn {
    width: 100%;
    margin-top: 25px;
  }
}

.modal-team-cover {
  display: block;
}

.list-grid-nav .nav-link.active {
  background-color: #299cdb;
  color: #fff;
}

.profile-offcanvas .team-cover {
  margin-bottom: -132px;
  display: block;
  z-index: -1;
}

.profile-offcanvas .btn-star {
  color: #fff;
}

.profile-offcanvas .dropdown > a {
  color: #fff;
}

.countdownlist {
  text-align: center;
  display: flex;
  gap: 24px;
}

.countdownlist .countdownlist-item {
  width: 25%;
}

.countdownlist .countdownlist-item:last-of-type .count-num::after {
  display: none;
}

.countdownlist .count-title {
  font-size: 13px;
  font-weight: 500;
  display: block;
  margin-bottom: 8px;
  color: rgba(var(--bs-dark-rgb), 0.5);
  text-transform: uppercase;
}

.countdownlist .count-num {
  background-color: var(--bs-card-bg-custom);
  padding: 16px 8px;
  position: relative;
  border-radius: 0.25rem;
  box-shadow: var(--bs-box-shadow);
  font-weight: 600;
  font-size: 32px;
}

@media (max-width: 575.98px) {
  .countdownlist .count-num {
    font-size: 18px;
  }
}

.countdownlist .count-num::after {
  content: ":";
  font-size: 20px;
  position: absolute;
  right: -16px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--bs-dark);
}

.move-animation {
  animation: mover 1s infinite alternate;
}

@keyframes mover {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(-16px);
  }
}

.coming-soon-text {
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  text-shadow: 3px 4px #45cb85;
}

.countdown-input-group {
  max-width: 400px;
}

.search-more-results {
  position: relative;
  overflow: hidden;
}

.search-more-results .nav-icon {
  font-size: 14px;
  color: #fff;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  left: 0;
  right: 0;
}

.search-more-results .nav-icon i {
  font-size: 20px;
}

@media (max-width: 767.98px) {
  .search-more-results .nav-icon {
    font-size: 14px;
  }

  .search-more-results .nav-icon i {
    font-size: 18px;
  }
}

.video-list .list-element {
  display: none;
}

.video-list .list-element:nth-child(1) {
  display: block;
}

.video-list .list-element:nth-child(2) {
  display: block;
}

.video-list .list-element:nth-child(3) {
  display: block;
}

.search-voice {
  height: 120px;
  width: 120px;
  line-height: 120px;
  margin: 0 auto;
  text-align: center;
  border-radius: 50%;
  z-index: 1;
  position: relative;
}

.search-voice i {
  line-height: 56px;
  font-size: 30px;
}

.search-voice .voice-wave {
  position: absolute;
  width: 120px;
  height: 120px;
  z-index: -1;
  left: 0;
  right: 0;
  margin: 0 auto;
  opacity: 0;
  border-radius: 100px;
  animation: voice-wave 1.8s infinite;
  background-color: var(--bs-light);
}

.search-voice .voice-wave:nth-child(2) {
  animation-delay: 0.3s;
}

.search-voice .voice-wave:nth-child(3) {
  animation-delay: 0.6s;
}

@keyframes voice-wave {
  0% {
    opacity: 1;
    transform: scale(0);
  }

  100% {
    opacity: 0;
    transform: scale(1);
  }
}

.images-menu .swiper-slide {
  width: auto;
  display: inline-block;
}

#selection-element {
  display: none;
}

.filter-choices-input .choices__inner {
  padding: 0;
  border: none;
  background-color: var(--bs-card-bg-custom);
}

.filter-choices-input .choices__input {
  background-color: var(--bs-card-bg-custom);
}

@media (min-width: 992px) {
  .sticky-side-div {
    position: sticky;
    top: calc(70px + 1.5rem);
  }
}

.product-img-slider .product-nav-slider .nav-slide-item {
  border: 1px solid var(--bs-border-color);
  border-radius: 0.25rem;
  padding: 0.5rem;
  cursor: pointer;
}

.product-img-slider
  .product-nav-slider
  .swiper-slide-thumb-active
  .nav-slide-item {
  background-color: var(--bs-light);
}

.filter-list a.active .listname {
  color: #45cb85;
}

.invoice-table tbody:last-child {
  border: none;
}

.currency-select .choices__inner {
  padding: 0;
  padding-right: 15px;
  min-height: 0;
}

.currency-select .choices__list--single {
  padding: 0 16px 0 4px;
}

.currency-select .choices[data-type*="select-one"] {
  bottom: 0;
}

.currency-select .choices[data-type*="select-one"] :after {
  top: 4px;
}

.currency-select .choices[data-type*="select-one"] .choices__inner {
  padding-bottom: 0;
}

.chat-wrapper {
  position: relative;
  overflow-x: hidden;
}

.chat-leftsidebar {
  height: calc(100vh - 137px);
  position: relative;
  background-color: var(--bs-card-bg-custom);
}

@media (min-width: 992px) {
  .chat-leftsidebar {
    min-width: 300px;
    max-width: 300px;
    height: calc(100vh - 70px - 60px - 8px);
  }
}

.chat-list {
  margin: 0;
}

.chat-list > li.active a {
  background-color: var(--bs-primary);
  color: var(--bs-white);
}

.chat-list > li.active a .badge {
  background-color: rgba(var(--bs-success-rgb), 0.15) !important;
  color: #45cb85 !important;
}

.chat-list > li a {
  display: block;
  padding: 7px 24px;
  color: var(--bs-body-color);
  transition: all 0.4s;
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 0.8125rem;
}

.chat-list > li .chat-user-message {
  font-size: 14px;
}

.chat-list > li .unread-msg-user {
  font-weight: 600;
}

.chat-list > li .unread-message {
  position: absolute;
  display: inline-block;
  right: 24px;
  left: auto;
  top: 33px;
}

.chat-list > li .unread-message .badge {
  line-height: 16px;
  font-weight: 600;
  font-size: 10px;
}

.chat-user-img {
  position: relative;
}

.chat-user-img .user-status {
  width: 10px;
  height: 10px;
  background-color: #adb5bd;
  border-radius: 50%;
  border: 2px solid var(--bs-card-bg-custom);
  position: absolute;
  right: 0;
  left: auto;
  bottom: 0;
}

.chat-user-img.online .user-status {
  background-color: #45cb85;
}

.chat-user-img.away .user-status {
  background-color: #ffbe0b;
}

.chat-room-list {
  max-height: calc(100vh - 296px);
}

@media (max-width: 991.98px) {
  .chat-room-list {
    height: calc(100vh - 296px);
  }
}

.contact-list li {
  cursor: pointer;
  padding: 8px 24px;
  transition: all 0.4s;
  color: var(--bs-body-color);
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 0.8125rem;
}

.contact-list-title {
  padding: 6px 24px;
  color: #4b38b3;
  font-weight: 500;
  position: relative;
  font-size: 12px;
}

.contact-list-title:after {
  content: "";
  height: 1px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 50px;
  right: 0;
  background-color: #f3f6f9;
}

/* .user-chat {
    background: url(../images/chat-bg-pattern.png);
    -webkit-transition: all .4s;
    transition: all .4s;
    position: relative;
    background-color: var(--bs-body-bg)
} */

@media (max-width: 991.98px) {
  .user-chat {
    position: absolute;
    left: 0;
    top: 3px;
    width: 100%;
    height: calc(100% - 3px);
    visibility: hidden;
    transform: translateX(100%);
    z-index: 99;
    padding-top: 70px;
  }

  .user-chat.user-chat-show {
    visibility: visible;
    transform: translateX(0);
  }
}

.user-chat .chat-content {
  position: relative;
}

.user-chat.user-chat-show .chat-welcome-section {
  display: none;
}

@media (min-width: 992px) {
  .user-chat.user-chat-show .chat-content {
    display: flex !important;
  }
}

.user-chat-topbar {
  border-bottom: 1px solid transparent;
  background-color: var(--bs-card-bg-custom);
}

@media (max-width: 991.98px) {
  .user-chat-topbar {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    z-index: 1;
  }
}

.user-chat-nav .nav-btn {
  height: 40px;
  width: 40px;
  line-height: 40px;
  box-shadow: none;
  padding: 0;
  font-size: 20px;
  color: #343a40;
}

@media (max-width: 575.98px) {
  .user-chat-nav {
    display: flex;
    justify-content: flex-end;
  }
}

.chat-conversation {
  height: calc(100vh - 299px);
}

@media (max-width: 991.98px) {
  .chat-conversation {
    height: calc(100vh - 275px);
  }
}

.chat-conversation .simplebar-content-wrapper {
  display: flex;
  flex-direction: column;
}

.chat-conversation .simplebar-content-wrapper .simplebar-content {
  margin-top: auto;
}

.chat-conversation .chat-conversation-list {
  padding-top: 10px;
  margin-bottom: 0;
}

.chat-conversation .chat-conversation-list > li {
  display: flex;
}

.chat-conversation li:last-of-type .conversation-list {
  margin-bottom: 0;
}

.chat-conversation .chat-list.left .check-message-icon {
  display: none;
}

.chat-conversation .chat-list .message-box-drop {
  visibility: hidden;
}

.chat-conversation .chat-list:hover .message-box-drop {
  visibility: visible;
}

.chat-conversation .chat-avatar {
  margin: 0 16px 0 0;
}

.chat-conversation .chat-avatar img {
  width: 28px;
  height: 28px;
  border-radius: 50%;
}

.chat-conversation .chat-day-title {
  position: relative;
  text-align: center;
  margin-bottom: 24px;
  margin-top: 12px;
  width: 100%;
}

.chat-conversation .chat-day-title .title {
  background-color: #fff;
  position: relative;
  font-size: 13px;
  z-index: 1;
  padding: 6px 12px;
  border-radius: 5px;
}

.chat-conversation .chat-day-title:before {
  content: "";
  position: absolute;
  width: 100%;
  height: 1px;
  left: 0;
  right: 0;
  background-color: rgba(75, 56, 179, 0.2);
  top: 10px;
}

.chat-conversation .chat-day-title .badge {
  font-size: 12px;
}

.chat-conversation .conversation-list {
  margin-bottom: 24px;
  display: inline-flex;
  position: relative;
  align-items: flex-end;
  max-width: 80%;
}

@media (max-width: 575.98px) {
  .chat-conversation .conversation-list {
    max-width: 90%;
  }
}

.chat-conversation .conversation-list .ctext-wrap {
  display: flex;
  margin-bottom: 10px;
}

.chat-conversation .conversation-list .ctext-content {
  word-wrap: break-word;
  word-break: break-word;
}

.chat-conversation .conversation-list .ctext-wrap-content {
  padding: 12px 20px;
  background-color: var(--bs-light);
  position: relative;
  border-radius: 3px;
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
}

@media (max-width: 575.98px) {
  .chat-conversation
    .conversation-list
    .ctext-wrap-content
    .attached-file
    .attached-file-avatar {
    display: none;
  }

  .chat-conversation
    .conversation-list
    .ctext-wrap-content
    .attached-file
    .dropdown
    .dropdown-toggle {
    display: block;
  }
}

.chat-conversation .conversation-list .conversation-name {
  font-weight: 500;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.chat-conversation .conversation-list .dropdown .dropdown-toggle {
  font-size: 18px;
  padding: 4px;
  color: #878a99;
}

.chat-conversation .conversation-list .dropdown .dropdown-toggle::after {
  display: none;
}

@media (max-width: 575.98px) {
  .chat-conversation .conversation-list .dropdown .dropdown-toggle {
    display: none;
  }
}

.chat-conversation .conversation-list .chat-time {
  font-size: 12px;
  margin-top: 4px;
  text-align: right;
}

.chat-conversation .conversation-list .message-img {
  border-radius: 0.2rem;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.chat-conversation .conversation-list .message-img .message-img-list {
  position: relative;
}

.chat-conversation .conversation-list .message-img img {
  max-width: 150px;
}

.chat-conversation .conversation-list .message-img .message-img-link {
  position: absolute;
  right: 10px;
  left: auto;
  bottom: 10px;
}

.chat-conversation .conversation-list .message-img .message-img-link li > a {
  font-size: 18px;
  color: #fff;
  display: inline-block;
  line-height: 20px;
  width: 26px;
  height: 24px;
  border-radius: 3px;
  background-color: rgba(33, 37, 41, 0.7);
  text-align: center;
}

.chat-conversation .right {
  justify-content: flex-end;
}

.chat-conversation .right .chat-avatar {
  order: 3;
  margin-right: 0;
  margin-left: 16px;
}

.chat-conversation .right .chat-time {
  text-align: left;
  color: #878a99;
}

.chat-conversation .right .conversation-list {
  text-align: right;
}

.chat-conversation .right .conversation-list .ctext-wrap {
  justify-content: flex-end;
}

.chat-conversation .right .conversation-list .ctext-wrap .ctext-wrap-content {
  order: 2;
  background-color: var(--bs-primary);
  color: var(--bs-white);
  text-align: right;
  box-shadow: var(--bs-box-shadow);
}

.chat-conversation
  .right
  .conversation-list
  .ctext-wrap
  .ctext-wrap-content
  .replymessage-block {
  background-color: rgba(255, 255, 255, 0.5);
  border-color: rgba(var(--bs-success-rgb), 1);
  color: #212529;
}

.chat-conversation
  .right
  .conversation-list
  .ctext-wrap
  .ctext-wrap-content
  .replymessage-block
  .conversation-name {
  color: rgba(var(--bs-success-rgb), 1);
}

.chat-conversation .right .conversation-list .conversation-name {
  justify-content: flex-end;
}

.chat-conversation
  .right
  .conversation-list
  .conversation-name
  .check-message-icon {
  order: 1;
}

.chat-conversation .right .conversation-list .conversation-name .time {
  order: 2;
}

.chat-conversation .right .conversation-list .conversation-name .name {
  order: 3;
}

.chat-conversation .right .conversation-list .dropdown {
  order: 1;
}

.chat-conversation .right .dot {
  background-color: #212529;
}

.chat-input-section {
  border-top: 1px solid transparent;
  background-color: var(--bs-card-bg-custom);
  position: relative;
  z-index: 1;
}

.chat-input-section .chat-input-feedback {
  display: none;
  position: absolute;
  top: -20px;
  left: 4px;
  font-size: 12px;
  color: #f06548;
}

.chat-input-section .show {
  display: block;
}

.chat-input-links {
  display: flex;
}

.chat-input-links .links-list-item > .btn {
  box-shadow: none;
  padding: 0;
  font-size: 20px;
  width: 37.5px;
  height: 37.5px;
}

.chat-input-links .links-list-item > .btn.btn-link {
  color: #878a99;
}

.copyclipboard-alert {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: none;
}

.replyCard {
  position: absolute;
  left: 0;
  right: 0;
  border-top: 1px solid var(--bs-border-color);
  overflow: hidden;
  opacity: 0;
  bottom: 0;
  border-radius: 0;
  transition: all 0.4s;
}

@media (max-width: 991.98px) {
  .replyCard {
    bottom: -12px;
  }
}

.replyCard.show {
  transform: translateY(-88px);
  opacity: 1;
}

@media (max-width: 991.98px) {
  .replyCard.show {
    transform: translateY(-83px);
  }
}

.replymessage-block {
  padding: 12px 20px;
  margin-bottom: 8px;
  text-align: left;
  border-radius: 4px;
  background-color: rgba(var(--bs-success-rgb), 0.1);
  border-left: 2px solid rgba(var(--bs-success-rgb), 1);
}

.replymessage-block .conversation-name {
  color: rgba(var(--bs-success-rgb), 1);
  font-size: 14px;
}

.chat-sm .ctext-wrap-content {
  box-shadow: none !important;
}

.chat-sm .message-img img {
  max-width: 90px !important;
}

.chat-sm .message-img-link {
  bottom: 0 !important;
  right: 5px !important;
}

@media (min-width: 1025px) {
  [data-layout="horizontal"] .chat-wrapper {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

@media (max-width: 991.98px) {
  [data-layout="horizontal"] .chat-wrapper {
    margin-top: 0 !important;
  }
}

[data-layout="horizontal"] .chat-leftsidebar {
  height: calc(100vh - 70px - 60px - 54px);
}

@media (max-width: 991.98px) {
  [data-layout="horizontal"] .chat-leftsidebar {
    height: calc(100vh - 70px - 60px - 8px);
  }
}

[data-layout="horizontal"] .chat-room-list {
  height: calc(100vh - 352px);
}

@media (max-width: 991.98px) {
  [data-layout="horizontal"] .chat-room-list {
    height: calc(100vh - 265px);
  }
}

[data-layout="horizontal"] .chat-conversation {
  height: calc(100vh - 343px);
}

@media (max-width: 991.98px) {
  [data-layout="horizontal"] .chat-conversation {
    height: calc(100vh - 275px);
  }
}

.email-wrapper {
  position: relative;
  overflow-x: hidden;
}

.email-menu-sidebar {
  height: calc(100vh - 137px);
  position: relative;
  background-color: var(--bs-card-bg-custom);
  transition: all 0.2s;
}

@media (min-width: 992px) {
  .email-menu-sidebar {
    min-width: 250px;
    max-width: 250px;
    height: calc(100vh - 70px - 60px - 8px);
  }
}

@media (max-width: 991.98px) {
  .email-menu-sidebar {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 200px;
    max-width: 100%;
    z-index: 1003;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    transform: translateX(-100%);
    visibility: hidden;
    height: 100vh;
  }

  .email-menu-sidebar.menubar-show {
    visibility: visible;
    transform: none;
  }
}

.email-menu-sidebar .email-menu-sidebar-scroll {
  height: calc(100vh - 295px);
}

@media (max-width: 991.98px) {
  .email-menu-sidebar .email-menu-sidebar-scroll {
    height: calc(100vh - 150px);
  }
}

.mail-list a {
  display: flex;
  align-items: center;
  color: #878a99;
  padding: 5px 0;
  font-weight: 500;
}

.mail-list a:hover {
  color: #4b38b3;
}

.mail-list a i {
  font-size: 14px;
}

.mail-list a.active {
  color: #45cb85;
  font-weight: 600;
}

.mail-list a.active i {
  color: #45cb85;
}

.email-topbar-link .btn-ghost-secondary {
  color: #878a99;
}

.email-topbar-link .btn-ghost-secondary:hover {
  color: #3577f1;
}

.email-content {
  width: 100%;
  background-color: var(--bs-card-bg-custom);
  transition: all 0.2s;
}

.unreadConversations-alert {
  position: fixed;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}

.email-detail-content {
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 68%;
  width: 32%;
  background-color: var(--bs-card-bg-custom);
  transform: translateX(200%);
  transition: all 0.2s;
  visibility: hidden;
  border-left: 2px solid var(--bs-body-bg);
}

.email-detail-show .email-detail-content {
  transform: none;
  visibility: visible;
}

.email-detail-show .email-content {
  margin-right: 32%;
}

@media (max-width: 1349.98px) {
  .email-detail-show .email-content {
    margin-right: 0;
  }
}

.email-detail-content-scroll {
  height: calc(100vh - 390px);
}

@media (max-width: 1349.98px) {
  .email-detail-content-scroll {
    height: calc(100vh - 252px);
  }
}

.message-list-content {
  height: calc(100vh - 242px);
}

@media (max-width: 575.98px) {
  .message-list-content {
    height: calc(100vh - 230px);
  }
}

.message-list {
  display: block;
  padding-left: 0;
  margin: 0;
}

.message-list li {
  position: relative;
  display: block;
  height: 50px;
  line-height: 50px;
  cursor: default;
  transition-duration: 0.3s;
  clear: both;
}

.message-list li a {
  color: var(--bs-gray-700);
}

.message-list li:hover {
  background: var(--bs-light);
  transition-duration: 50ms;
}

.message-list li .col-mail {
  float: left;
  position: relative;
}

.message-list li .col-mail-1 {
  width: 280px;
}

.message-list li .col-mail-1 .checkbox-wrapper-mail,
.message-list li .col-mail-1 .dot,
.message-list li .col-mail-1 .star-toggle {
  display: block;
  float: left;
}

.message-list li .col-mail-1 .dot {
  border: 4px solid transparent;
  border-radius: 100px;
  margin: 22px 26px 0;
  height: 0;
  width: 0;
  line-height: 0;
  font-size: 0;
}

.message-list li .col-mail-1 .checkbox-wrapper-mail {
  margin: 15px 0 0 20px;
  line-height: normal;
}

.message-list li .col-mail-1 .star-toggle {
  margin-top: 18px;
  margin-left: 5px;
}

.message-list li .col-mail-1 .title {
  position: absolute;
  top: 0;
  left: 95px;
  right: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin-bottom: 0;
}

@media (max-width: 575.98px) {
  .message-list li .col-mail-1 .title {
    left: 95px;
  }
}

.message-list li .col-mail-2 {
  position: absolute;
  top: 0;
  left: 280px;
  right: 0;
  bottom: 0;
}

.message-list li .col-mail-2 .date,
.message-list li .col-mail-2 .subject {
  position: absolute;
  top: 0;
}

.message-list li .col-mail-2 .subject {
  left: 0;
  right: 110px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.message-list li .col-mail-2 .subject .teaser {
  color: var(--bs-gray-600);
}

.message-list li .col-mail-2 .date {
  right: 0;
  width: 100px;
  padding-left: 20px;
}

.message-list li.active,
.message-list li.active:hover {
  box-shadow: inset 3px 0 0 #4b38b3;
  background-color: var(--bs-light);
}

.message-list li.unread {
  color: var(--bs-gray-800);
}

.message-list li.unread a {
  color: var(--bs-gray-800);
  font-weight: 600;
}

#email-topbar-actions,
#unreadConversations {
  display: none;
}

#elmLoader {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
}

.email-compose-input {
  padding-right: 80px;
}

@media (max-width: 1349.98px) {
  .email-detail-content {
    position: fixed;
    top: 0;
    bottom: 0;
    left: auto;
    right: 0;
    width: 400px;
    max-width: 100%;
    z-index: 1003;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    transform: translateX(100%);
  }

  .email-detail-show .email-detail-content {
    transform: none;
  }
}

@media (max-width: 575.98px) {
  .message-list li .col-mail-1 {
    width: 180px;
  }
}

.email-editor .ck-editor__editable_inline {
  min-height: 200px !important;
}

.email-chat-detail {
  width: 350px;
  position: fixed;
  max-width: 100%;
  bottom: 60px;
  right: 60px;
  z-index: 9;
  display: none;
}

.email-chat-detail .card {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
}

@media (max-width: 515.98px) {
  .email-chat-detail {
    left: 16px;
    right: 16px;
  }
}

@media (min-width: 1025px) {
  [data-layout="horizontal"] .email-wrapper {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
}

@media (max-width: 991.98px) {
  [data-layout="horizontal"] .email-wrapper {
    margin-top: 0 !important;
  }
}

[data-layout="horizontal"] .email-menu-sidebar {
  height: calc(100vh - 70px - 60px - 54px);
}

@media (max-width: 991.98px) {
  [data-layout="horizontal"] .email-menu-sidebar {
    height: 100vh;
  }
}

[data-layout="horizontal"] .email-menu-sidebar .email-menu-sidebar-scroll {
  height: calc(100vh - 330px);
}

@media (max-width: 991.98px) {
  [data-layout="horizontal"] .email-menu-sidebar .email-menu-sidebar-scroll {
    height: calc(100vh - 150px);
  }
}

[data-layout="horizontal"] .message-list-content {
  height: calc(100vh - 289px);
}

[data-layout="horizontal"] .email-detail-content-scroll {
  height: calc(100vh - 435px);
}

@media (max-width: 1349.98px) {
  [data-layout="horizontal"] .email-detail-content-scroll {
    height: calc(100vh - 252px);
  }
}

.tasks-board {
  display: flex;
  overflow-x: auto;
  align-items: stretch;
}

.tasks-board .tasks-list {
  min-width: 300px;
  margin-right: 24px;
}

.tasks-board::-webkit-scrollbar {
  -webkit-appearance: none;
}

.tasks-board::-webkit-scrollbar:vertical {
  width: 10px;
}

.tasks-board::-webkit-scrollbar:horizontal {
  height: 8px;
}

.tasks-board::-webkit-scrollbar-thumb {
  background-color: rgba(var(--bs-dark-rgb), 0.075);
  border-radius: 8px;
}

.tasks-board::-webkit-scrollbar-track {
  border-radius: 8px;
}

.tasks-box .progress {
  border-radius: 0 0 0.25rem 0.25rem;
}

.tasks-box .tasks-img {
  height: 135px;
  width: 100%;
  object-fit: cover;
  object-position: center;
  margin: 12px 0;
}

.tasks-box:last-child {
  margin-bottom: 0;
}

.tasks-wrapper {
  max-height: calc(100vh - 418px);
}

.tasks {
  min-height: 180px;
  position: relative;
}

/* .tasks.noTask::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 180px;
    width: 270px;
    margin: 0 auto;
    background-image: url(../images/file.png);
    background-size: cover;
    background-position: center
} */

#tasksList tr .tasks-list-menu {
  opacity: 0;
}

#tasksList tr:hover .tasks-list-menu {
  opacity: 1;
}

.layout-wrapper.landing {
  background-color: var(--bs-card-bg-custom);
  font-size: 15px;
}

.section {
  padding: 90px 0;
  position: relative;
}

@media (max-width: 767.98px) {
  .section {
    padding: 50px 0;
  }
}

.icon-effect {
  position: relative;
}

.icon-effect::before {
  content: "";
  position: absolute;
  width: 24px;
  height: 24px;
  background-color: rgba(69, 203, 133, 0.2);
  border-radius: 50%;
  bottom: 0;
  left: 0;
}

.navbar-landing {
  padding: 10px 0;
  transition: all 0.5s ease;
}

@media (max-width: 991.98px) {
  .navbar-landing {
    background-color: var(--bs-card-bg-custom);
    box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);
    padding: 10px 8px;
  }
}

.navbar-landing .navbar-nav .nav-item .nav-link {
  font-size: 16px;
  font-weight: 500;
  transition: all 0.4s;
  font-family: Inter, sans-serif;
  color: var(--bs-dark);
  padding: 14px;
}

@media (max-width: 991.98px) {
  .navbar-landing .navbar-nav .nav-item .nav-link {
    padding: 8px 0;
  }
}

.navbar-landing .navbar-nav .nav-item .nav-link.active,
.navbar-landing .navbar-nav .nav-item .nav-link:focus,
.navbar-landing .navbar-nav .nav-item .nav-link:hover {
  color: #45cb85 !important;
}

.navbar-landing.is-sticky {
  background-color: var(--bs-card-bg-custom);
  box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);
}

.navbar-light .navbar-brand .card-logo-dark {
  display: none;
}

.navbar-light .navbar-brand .card-logo-light {
  display: block;
}

.navbar-light .navbar-nav .nav-item .nav-link {
  color: rgba(var(--bs-white-rgb), 0.75);
}

.navbar-light.is-sticky .navbar-nav .nav-item .nav-link {
  color: var(--bs-dark);
}

.navbar-light.is-sticky .navbar-brand .card-logo-dark {
  display: block;
}

.navbar-light.is-sticky .navbar-brand .card-logo-light {
  display: none;
}

.hero-section {
  background-color: rgba(var(--bs-light-rgb), 0.5);
}

.hero-section .hero-shape-svg svg path {
  fill: var(--bs-card-bg-custom);
}

/* .bg-overlay-pattern {
    background-image: url(../images/landing/bg-pattern.png);
    background-color: transparent;
    background-position: center;
    background-size: cover;
    opacity: .2
} */

.demo-carousel {
  position: relative;
  z-index: 1;
}

.demo-carousel .carousel-item .demo-item {
  background-color: var(--bs-card-bg-custom);
  padding: 8px;
  border-radius: 7px;
}

.demo-carousel .demo-img-patten-top {
  position: absolute;
  right: -50px;
  top: -16px;
  max-width: 230px;
}

.demo-carousel .demo-img-patten-bottom {
  position: absolute;
  left: -70px;
  bottom: -50px;
  max-width: 230px;
}

.client-images img {
  max-height: 45px;
  width: auto;
  margin: 12px auto;
  transition: all 0.4s;
}

.plan-box {
  max-width: 356px;
  margin-left: auto;
  margin-right: auto;
}

.process-card {
  position: relative;
}

.process-card .process-arrow-img {
  position: absolute;
  left: 75%;
  top: 7%;
  width: 50%;
  opacity: 0.1;
}

.custom-footer {
  color: #9ba7b3;
}

.footer-list li a {
  color: #9ba7b3;
  padding: 7px 0;
  display: block;
  transition: all 0.3s ease-in-out;
}

.footer-list li a:hover {
  color: rgba(255, 255, 255, 0.9);
}

.footer-social-link .avatar-title {
  color: #778089;
  background-color: rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease;
}

.footer-social-link .avatar-title:hover {
  color: #fff;
  background-color: #4b38b3;
}

#back-to-top.landing-back-top {
  bottom: 35px;
}

[data-layout-mode="dark"] .layout-wrapper.landing .demo-img-patten-bottom,
[data-layout-mode="dark"] .layout-wrapper.landing .demo-img-patten-top {
  opacity: 0.2;
}

[data-layout-mode="dark"] .layout-wrapper.landing footer.bg-dark {
  background-color: var(--bs-card-bg-custom) !important;
}

[data-layout-mode="dark"]
  .navbar-light.is-sticky
  .navbar-brand
  .card-logo-dark {
  display: none;
}

[data-layout-mode="dark"]
  .navbar-light.is-sticky
  .navbar-brand
  .card-logo-light {
  display: block;
}

.bookmark-icon .btn {
  color: #878a99;
  background-color: var(--bs-light);
  box-shadow: var(--bs-box-shadow);
  font-size: 0.8125rem;
}

.bookmark-icon .btn.active,
.bookmark-icon .btn:hover {
  border-color: transparent;
  color: #f06548;
}

.explore-box {
  border-radius: 9px;
  overflow: hidden;
}

.explore-box .explore-img {
  height: 280px;
  object-fit: cover;
}

.explore-box .explore-place-bid-img {
  position: relative;
  overflow: hidden;
  z-index: 0;
}

.explore-box .explore-place-bid-img .bg-overlay {
  position: absolute;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(33, 37, 41, 0.4);
  opacity: 0;
  transition: all 0.5s ease;
}

.explore-box .explore-place-bid-img .place-bid-btn {
  top: 50%;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
}

.explore-box .explore-place-bid-img .place-bid-btn .btn {
  opacity: 0;
  bottom: -25px;
  transition: 0.5s ease;
}

.explore-box:hover .explore-place-bid-img .place-bid-btn .btn {
  opacity: 1;
  bottom: 0;
}

.explore-box:hover .explore-place-bid-img .bg-overlay {
  opacity: 1;
}

.explore-box .discount-time {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.4);
  backdrop-filter: blur(5px);
  padding: 8px;
}

/* .nft-hero {
    background-image: url(../images/nft/bg-home.jpg);
    background-size: cover;
    background-position: bottom;
    padding: 222px 0 150px 0
} */

.nft-hero .bg-overlay {
  background-color: #05175f;
  opacity: 0.85;
}

#explorecard-list .list-element {
  display: none;
}

#explorecard-list .list-element:nth-child(-n + 10) {
  display: block;
}

.file-manager-menu {
  max-height: calc(100vh - 296px);
}

@media (max-width: 991.98px) {
  .file-manager-menu {
    height: calc(100vh - 296px);
  }
}

.file-manager-menu li {
  padding: 5px 0;
}

.file-manager-menu li a {
  color: var(--bs-dark);
  font-weight: 500;
  transition: all 0.5s ease;
}

.file-manager-menu li a.active,
.file-manager-menu li a:hover,
.file-manager-menu li a[aria-expanded="true"] {
  color: #45cb85;
}

.file-manager-menu li .sub-menu li {
  padding-left: 25px;
  position: relative;
}

.file-manager-menu li .sub-menu li::before {
  content: "\\f0374";
  position: absolute;
  left: 0;
  font-family: Material Design Icons;
  color: rgba(var(--bs-dark-rgb), 0.4);
}

.file-manager-sidebar {
  position: relative;
  background-color: var(--bs-card-bg-custom);
}

@media (min-width: 992px) {
  .file-manager-sidebar {
    min-width: 300px;
    max-width: 300px;
    height: calc(100vh - 70px - 60px - 8px);
  }
}

@media (max-width: 991.98px) {
  .file-manager-sidebar {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 200px;
    max-width: 100%;
    z-index: 1003;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    transform: translateX(-100%);
    visibility: hidden;
    height: 100vh;
  }

  .file-manager-sidebar.menubar-show {
    visibility: visible;
    transform: none;
  }
}

.file-menu-sidebar-scroll {
  height: calc(100vh - 375px);
}

@media (max-width: 991.98px) {
  .file-menu-sidebar-scroll {
    height: calc(100vh - 190px);
  }
}

.file-manager-content {
  background-color: var(--bs-card-bg-custom);
}

.file-manager-content-scroll {
  height: calc(100vh - 185px);
}

@media (max-width: 991.98px) {
  .file-manager-content-scroll {
    height: calc(100vh - 144px);
  }
}

.file-manager-content-scroll .simplebar-content {
  height: 100%;
}

.file-detail-content-scroll {
  height: calc(100vh - 180px);
}

@media (max-width: 991.98px) {
  .file-detail-content-scroll {
    height: 100vh;
  }
}

.file-detail-content-scroll .simplebar-content {
  height: 100%;
}

.file-manager-detail-content {
  width: 32%;
  max-width: 100%;
  background-color: var(--bs-card-bg-custom);
  display: none;
}

.file-detail-show .file-manager-detail-content {
  display: block;
}

#file-overview {
  display: none;
}

@media (max-width: 1399.98px) {
  .file-manager-detail-content {
    position: fixed;
    top: 0;
    bottom: 0;
    left: auto;
    right: 0;
    width: 400px;
    max-width: 100%;
    z-index: 1003;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    transform: translateX(100%);
  }

  .file-detail-show .file-manager-detail-content {
    transform: none;
  }
}

.file-details-box {
  height: 195px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.to-do-menu li .nav-link {
  color: var(--bs-body-color);
  padding-left: 0;
  font-weight: 500;
  background-color: var(--bs-light);
  padding: 10px 12px;
  border-radius: 4px;
  display: block;
  margin-bottom: 8px;
}

.to-do-menu li .nav-link.active,
.to-do-menu li .nav-link:hover {
  color: #45cb85;
}

.todo-content {
  height: calc(100vh - 362px);
  overflow-y: auto;
}

.todo-content::-webkit-scrollbar {
  -webkit-appearance: none;
}

.todo-content::-webkit-scrollbar:vertical {
  width: 8px;
}

.todo-content::-webkit-scrollbar:horizontal {
  height: 10px;
}

.todo-content::-webkit-scrollbar-thumb {
  background-color: rgba(var(--bs-dark-rgb), 0.075);
  border-radius: 8px;
}

.todo-content::-webkit-scrollbar-track {
  border-radius: 8px;
}

.todo-task table .form-check .form-check-input:checked + .form-check-label {
  text-decoration: line-through;
}

.task-handle {
  cursor: move;
}

#task-error-msg {
  display: none;
}


.color-icon-open:before {
  content: "\\eaeb";
}

.color-icon-close::before {
  content: "\\eacb";
}

.flatpickr-monthDropdown-months {
  display: none !important;
}

.remove-child-scroll {
  max-height: 400px;
  overflow-y: auto;
}

.dropdown-item-cart {
  white-space: nowrap;
}

.remove-child-scroll {
  max-height: 270px;
  overflow-y: scroll;
}

.remove-child-scroll::-webkit-scrollbar {
  width: 0;
  background: transparent;
}

.remove-child-scroll::-webkit-scrollbar-thumb {
  background: transparent;
}

.remove-child-scroll h5 {
  font-size: 1.1rem;
}

.dropdown-item-cart {
  white-space: nowrap;
}

.empty-cart {
  display: none;
}

.dropdown-container {
  position: relative;
  display: inline-block;
}

.dropdown-toggle {
  padding: 10px 20px;
  color: #fff;
  border: none;
  cursor: pointer;
}

.unread-msg-scroll {
  overflow-y: auto;
  min-height: 430px;
}

.unread-msg-scroll::-webkit-scrollbar {
  width: 0;
  background: transparent;
}

.unread-msg-scroll::-webkit-scrollbar-thumb {
  background: transparent;
}

.dropdown-item {
  padding: 10px 20px;
  cursor: pointer;
}

.dropdown-item.active {
  background-color: #f1f1f1;
}

.sub-menu {
  padding-left: 20px;
  margin-top: 10px;
  background-color: #f9f9f9;
}

.sub-menu-item {
  padding: 8px 20px;
  cursor: pointer;
}

.sub-menu-item:hover {
  background-color: #ececec;
}

.blurred-background {
  background-color: rgba(0, 0, 0, 0.5);
}

.apexcharts-toolbar {
  display: none !important;
}

.chat-conversation {
  height: 500px !important;
  overflow-y: scroll;
}

.chat-conversation::-webkit-scrollbar {
  width: 0;
  background: transparent;
}

.chat-conversation::-webkit-scrollbar-thumb {
  background: transparent;
}

.myTasksElementStyle {
  height: 219px;
  overflow-y: scroll;
}

.myTasksElementStyle::-webkit-scrollbar {
  width: 0;
  background: transparent;
}

.myTasksElementStyle::-webkit-scrollbar-thumb {
  background: transparent;
}

.table-responsive::-webkit-scrollbar {
  width: 0;
  background: transparent;
}

.table-responsive::-webkit-scrollbar-thumb {
  background: transparent;
}

.fullscreen.fullscreen-enabled {
  background-color: white !important;
}

.text-muted {
  --bs-text-opacity: 1;
  color: #878a99 !important;
  font-size: 14px !important;
}

/* page group page styling */

.table > :not(caption) > * > * {
  padding: 0.75rem 1.6rem !important;
  background-color: var(--bs-table-bg);
  border-bottom-width: 1px;
  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);
}

.manage-page-group {
  font-size: 14px;
  font-weight: 400;
}

.manage-page-group i {
  font-size: 20px;
  padding-right: 5px;
}

.manage-page-group i.ri-delete-bin-6-line {
  color: #dc3545;
}

.manage-page-group i.ri-pencil-fill {
  color: #13096a;
}

.btn.disabled,
.btn:disabled,
fieldset:disabled .btn {
  opacity: 0.1;
}

.card {
  --bs-card-border-color: transparent !important;
}

.card-header {
  background-color: transparent !important;
}

/* .table {
    --bs-table-striped-bg: #fbfbfb !important;
} */

[data-layout-mode="light"] .main-content {
  background-color: #f3f3f9;
}

[data-layout-mode="dark"] .main-content {
  background-color: #1a1d21;
}

[data-layout-mode="light"] .navbar-menu {
  background-color: #ffffff;
}

[data-layout-mode="dark"] .navbar-menu {
  background-color: #262a2f;
}

[data-layout-mode="light"] .manage-page-group-select {
  color: #000;
  border: 1px solid #e5e5e5;
}

[data-layout-mode="dark"] .manage-page-group-select {
  color: #fff;
  border: 1px solid #1a1d21;
}

.manage-page-group-card-body {
  padding: 0px !important;
}

.manage-page-group th:first-child {
  padding-left: 26px !important;
}

.manage-page-group td:first-child {
  padding-left: 26px !important;
}

.manage-page-group-table-values td {
  font-size: 14px;
  font-weight: 400;
}

.manage-page-group-entries-displayed {
  font-size: 14px;
  font-weight: 400;
}

.card-header h5 {
  font-weight: 600;
}

.form-select-entry-count {
  display: flex !important;
  align-items: center !important;
}

ul.dropdown-menu.show {
  min-width: 100px !important;
}

.btn-secondary {
  --bs-btn-bg: #1f156d !important;
}

[data-layout-mode="light"] .manage-page-group-table-header {
  background-color: #f3f6f9;
}

[data-layout-mode="dark"] .manage-page-group-table-header {
  background-color: #262a2f;
}

[data-layout-mode="light"] .manage-page-group-table-header th {
  font-size: 14px;
  color: #000;
  font-weight: 600;
}

[data-layout-mode="dark"] .manage-page-group-table-header th {
  font-size: 14px;
  color: #fff;
  font-weight: 600;
}

[data-layout-mode="light"] .manage-page-group-table-values td {
  color: #000;
}

[data-layout-mode="dark"] .manage-page-group-table-values td {
  color: #fff;
}

[data-layout-mode="light"] .manage-page-group-entries-displayed {
  color: #000;
}

[data-layout-mode="dark"] .manage-page-group-entries-displayed {
  color: #fff;
}

[data-layout-mode="light"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-item.active
  .nav-link {
  color: #4b38b3 !important;
}

[data-layout-mode="dark"]
  .navbar-menu
  .navbar-nav
  .nav-sm
  .nav-item.active
  .nav-link {
  color: #fff !important;
}

.navbar-menu
  .navbar-nav
  .nav-link[data-bs-toggle="collapse"][aria-expanded="true"] {
  color: var(--bs-vertical-menu-sub-item-color) !important;
}

[data-layout-mode="light"] button.btn.btn-sm.manage-page-group-select {
  color: #000;
}

[data-layout-mode="dark"] button.btn.btn-sm.manage-page-group-select {
  color: #fff;
}

button.btn.btn-sm.manage-page-group-select {
  font-size: 2rem;
  background-color: transparent;
  border: none;
  box-shadow: none;
}

/* div#sidebarAdminSettings {
    background-color: var(--bs-vertical-menu-bg-dark);
} */

.border-shadow-login-card {
  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,
    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
}

.text-body i.ri-camera-fill {
  color: black;
}

span.avatar-title.rounded-circle.bg-light.text-body.shadow {
  background-color: #737685 !important;
}

.loading-spinner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f4f4f4;
}

[data-layout-mode="dark"] .loading-spinner-container {
  background-color: #262a2f;
}

.loading-spinner {
  display: flex;
  justify-content: center;
  align-items: center;
}

.spinner-circle {
  border: 6px solid #f3f3f3;
  border-radius: 50%;
  border-top: 6px solid #3498db;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.loading-spinner p {
  margin-top: 15px;
  font-size: 1.2rem;
  color: #333;
}

.select-dropdown-swr-property {
  box-shadow: none;
  background-color: #fff;
  border: 1px solid #ced4da;
  appearance: none;
  border-radius: 0.375rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  height: 34px;
  color: #000;
  padding: 2px;
}

.select-dropdown-swr-property:hover {
  box-shadow: none !important;
  background-color: #fff !important;
  border: 1px solid #ced4da !important;
  appearance: none !important;
  border-radius: 0.375rem !important;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
  height: 34px !important;
  color: #000 !important;
  padding: 2px !important;
}

.dropdown-toggle::after {
  content: none !important;
}

.btn-check:checked + .btn,
.btn.active,
.btn.show,
.btn:first-child:active,
:not(.btn-check) + .btn:active {
  color: #000;
  background-color: #fff;
  border-color: #ced4da;
}

.badge {
  --bs-badge-padding-x: 0.85em !important;
  --bs-badge-padding-y: 0.55em !important;
}

.heading-tab-section {
  font-size: 1.2rem;
  font-weight: 600;
}

span.badge.text-bg-warning.ms-2 {
  color: #fff !important;
}

.tab-dates {
  font-weight: 600;
}

.nav-success.nav-tabs-custom .nav-link.active {
  color: #2913dd;
  background-color: transparent !important;
  font-size: 1rem;
}

.nav-tabs-custom {
  border-bottom: 1px solid transparent !important;
}

.property-detail-tab {
  background-color: #eaf2fd;
}

.nav-success.nav-tabs-custom .nav-link.active::after {
  background-color: #2913dd !important;
}

ul.nav.nav-tabs.nav-tabs-custom.nav-success.nav-justified.mb-3.pt-3 {
  font-size: 1rem;
  color: #fff;
  width: 480px;
}

.tab-property-detail-address {
  white-space: normal;
  word-wrap: break-word;
  word-break: break-word;
}

table.table.table-nowrap {
  font-size: 0.9rem;
}

table.table.table-nowrap td {
  font-weight: 400;
}

.ri-edit-2-fill:before {
  font-size: 1.1rem;
  color: #170b75;
}

.flat-detail-table {
  padding: 0 !important;
}

.image-container {
  position: relative;
  display: inline-block;
  margin: 10px;
  transition: transform 0.3s ease, opacity 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  /* Add slight box-shadow */
  border-radius: 8px;
}

.image-container:hover {
  transform: scale(1.05);
  /* Slight zoom on hover */
}

.uploaded-image {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
}

.remove-image-btn {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: #ff4d4f;
  color: white;
  border: none;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition: background-color 0.2s ease;
}

.remove-image-btn:hover {
  background-color: #ff7875;
}

.image-preview {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 10px;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
}

.image-container.fade-in {
  animation: fadeIn 0.3s ease;
}

.image-container.fade-out {
  animation: fadeOut 0.3s ease;
}

.gallery-modal-heading {
  color: #1f156d;
}

.mt-n4 {
  margin-top: -1.5rem !important;
  /* background-color: #d8edf9 !important; */
}

.mx-n4 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important;
}

.css-s4lgu-MuiFormControl-root {
  margin: 0px !important;
}

.css-w76bbz-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
  padding: 0px !important;
}

.css-lohd6h-MuiSvgIcon-root-MuiSelect-icon {
  display: none !important;
}

.css-w1u3ce > span {
  display: none !important;
}

.css-lohd6h-MuiSvgIcon-root-MuiSelect-icon {
  visibility: hidden !important;
}

.form-select svg {
  display: none !important;
}

button#page-header-user-dropdown {
  color: unset !important;
  background-color: unset !important;
  border-color: transparent !important;
}

.pagination {
  --bs-pagination-active-bg: #211959 !important;
  --bs-pagination-active-border-color: #2b2178 !important;
}

/* blogs page css  */
.profile-user {
  width: 130px;
}

.card-header-wrapper {
  border-bottom: 1px solid var(--bs-border-color);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tox-statusbar__branding {
  display: none !important;
}

.blog-name-wrapper {
  display: flex;
  align-items: center;
  column-gap: 5px;
}

[data-layout-mode="dark"] .tox .tox-statusbar {
  background-color: #1a1d21 !important;
  border-top: 1px solid #20252a !important;
}

[data-layout-mode="dark"] .tox .tox-edit-area__iframe {
  background-color: #1a1d21 !important;
}

[data-layout-mode="dark"] .tox:not(.tox-tinymce-inline) .tox-editor-header {
  background-color: #1a1d21 !important;
}

[data-layout-mode="dark"] .tox .tox-toolbar__primary {
  background-color: #1a1d21 !important;
  background-image: repeating-linear-gradient(
    #20252a 0 1px,
    transparent 1px 39px
  ) !important;
}

[data-layout-mode="dark"] .tox-tinymce {
  border: 2px solid #20252a !important;
}

[data-layout-mode="dark"] .tox .tox-statusbar__path-item {
  color: #fff !important;
}

[data-layout-mode="dark"] .tox .tox-statusbar__wordcount {
  color: #fff !important;
}

[data-layout-mode="dark"] .tox .tox-tbtn svg {
  fill: #ffffff !important;
}

[data-layout-mode="dark"] .tox .tox-tbtn--bespoke {
  background: #262a2f !important;
  color: #fff !important;
}

.mce-content-body {
  color: #000 !important;
}

[data-layout-mode="dark"] .tox.tox-tinymce-aux .tox-toolbar__overflow {
  background-color: #262a2f !important;
}

[data-layout-mode="dark"] .tox .tox-menu {
  background-color: #262a2f !important;
}

[data-layout-mode="dark"] .tox .tox-menu .tox-collection__item-label {
  color: #fff !important;
}

[data-layout-mode="dark"].tox
  .tox-collection--list
  .tox-collection__item--active {
  background-color: #1a1d21 !important;
}

[data-layout-mode="dark"] .tox .tox-tbtn--enabled {
  background: #1a1d21 !important;
}

[data-layout-mode="dark"] .tox .tox-tbtn:hover {
  background: #1a1d21 !important;
}

[data-layout-mode="dark"]
  .tox
  .tox-collection--list
  .tox-collection__item--active {
  background: #1a1d21 !important;
}

body#tinymce {
  color: #fff !important;
}

[data-layout-mode="dark"] .tox .tox-collection__item-icon svg {
  fill: #fff !important;
}

.css-13cymwt-control {
  min-height: 36px !important;
  height: 32px !important;
}

[data-layout-mode="dark"] .css-13cymwt-control {
  background-color: #262a2f !important;
  border-color: hsl(210deg 10.64% 18.43%) !important;
  color: #acb1b8 !important;
}

[data-layout-mode="dark"] .css-t3ipsp-control {
  background-color: #262a2f !important;
  border-color: hsl(210deg 10.64% 18.43%) !important;
  color: #acb1b8 !important;
}

[data-layout-mode="dark"] .css-1nmdiq5-menu {
  background-color: #262a2f !important;
  color: #acb1b8 !important;
}

.modal-dialog:not(.modal-dialog-scrollable) .modal-header {
  padding-bottom: 9px !important;
}

.btn-properties-search {
  margin-top: 18px !important;
  padding: 6px 20px !important;
}

.PhoneInput {
  font-size: 0.8125rem;
  background: transparent;
  border: 1px solid #ced4da;
  border-radius: 5px;
  color: #0e0e46;
  min-height: 34px;
  margin: 0;
  padding: 9px 15px;
  max-height: 37px;
}

.PhoneInput input {
  margin: 0;
  padding: 0;
  border: none;
  height: 30px;
  width: calc(100% - 30px);
  outline: none;
  background-color: transparent !important;
}

.PhoneInput--focus {
  border-color: var(--secondary-theme-color);
}

.verified-details {
  font-size: 17px;
  margin-left: 5px;
  line-height: 0;
  position: relative;
  top: 4px;
}

.ri-mail-fill:before {
  content: "\\eef3";
  line-height: 0;
  position: relative;
  top: 3px;
  color: #13086a;
}

.ri-phone-fill:before {
  line-height: 0;
  position: relative;
  top: 2px;
  color: #13086a;
}

.form-select {
  padding: 0.5rem 0.9rem;
  font-weight: 400;
  line-height: 1.5;
}

.form-control {
  padding: 0.5rem 0.9rem;
  font-weight: 400;
  line-height: 1.5;
}

.form-select {
  padding: 0.5rem 0.9rem;
  font-weight: 400;
  line-height: 1.5;
}

/* --- */
.css-mp9f0v {
  padding: 0px 0px !important;
}

.MuiFormControl-root.MuiFormControl-marginNormal.MuiFormControl-fullWidth {
  margin: 0px !important;
}

.entried-dropdown-style {
  min-width: 80px;
  text-align: justify;
}

.btn-secondary {
  min-width: 100px !important;
}

.no-border {
  border: none !important;
}

.viewhidePassword {
  position: absolute;
  right: 10px;
  top: 70%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
}

.view-hide-password-invalid {
  position: absolute;
  right: 22px;
  top: 48px;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
}

.img-thumbnail {
  background-color: transparent !important;
}

input::placeholder {
  font-family: "Inter", sans-serif !important;
  font-size: 0.8125rem;
  font-weight: 400;
}

[data-sidebar-size="lg"] .navbar-menu div#scrollbar {
  overflow-y: auto;
  height: calc(100dvh - 70px);
}

select.PhoneInputCountrySelect:disabled {
  display: contents !important;
}

.pac-container {
  z-index: 9999 !important;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px !important;
}

.cursor-pointer {
  cursor: pointer;
}

.manage-page-group:hover {
  background-color: #f6f6f6;
}

[data-layout-mode="dark"] .manage-page-group:hover {
  background-color: #1a1d21;
}

.auth-one-bg img {
  filter: grayscale(100) brightness(100);
}

.text-primary {
  font-size: 30px;
}

.aligning-item {
  align-items: center !important;
}

.aligning-sigin-form {
  height: 100%;
}

[data-layout-mode="dark"] .disabled > .page-link,
.page-link.disabled {
  background-color: #333232 !important;
}

.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.form-select.css-quhxjy-MuiInputBase-root-MuiOutlinedInput-root {
  border: 1px !important;
}

.profile-info-fields {
  position: relative;
  z-index: 1;
}

.profile-info-fields:before {
  content: "";
  position: absolute;
  right: 0;
  top: 12px;
  width: 89%;
  height: 1px;
  background: #c7c7c7;
  z-index: -1;
}

.profile-info-fields h5 {
  background: var(--white);
  margin-bottom: 20px;
  display: inline-flex;
  padding-right: 10px;
}

@media (max-width: 1600px) {
  .profile-info-fields:before {
    width: 88%;
  }
}

@media (max-width: 1400px) {
  .profile-info-fields:before {
    width: 86%;
  }
}

@media (max-width: 1200px) {
  .profile-info-fields:before {
    width: 84%;
  }
}

@media (max-width: 992px) {
  .profile-info-fields:before {
    width: 79%;
  }
}

@media (max-width: 768px) {
  .profile-info-fields:before {
    width: 67%;
  }
}

@media (max-width: 576px) {
  .profile-info-fields:before {
    display: none !important;
  }
}

.line-separator {
  font-size: 16px;
  font-weight: 700;
}

.order-info-details {
  display: flex;
  justify-content: space-between;
}

.responsive-filter {
  display: flex;
  justify-content: start;
}

.responsive-filter-type {
  display: flex;
  column-gap: 20px;
}

@media (max-width: 1092px) {
  .responsive-filter {
    display: block !important;
  }

  .responsive-filter-type {
    display: block !important;
  }
}

@media (max-width: 576px) {
  .timeline-item .content {
    background: transparent;
    box-shadow: none;
    border: none;
    padding: 0px;
  }
}

.required-field {
  color: red;
}

.timeline-background {
  background-color: #edf2fa;
}

[data-layout-mode="dark"] .timeline-background {
  background-color: #1b1c1e;
}

.fw-semibold {
  color: #150b6d;
}

[data-layout-mode="dark"] .fw-semibold {
  color: #6c757d;
}

.sub-title-detail {
  font-weight: 600;
  color: #000;
}

[data-layout-mode="dark"] .sub-title-detail {
  color: #fff;
}

.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.form-select.css-iz33ar {
  border: 1px !important;
}

.wrapper-entries-dropdownx {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.css-28116y-MuiAutocomplete-root .MuiOutlinedInput-root {
  padding: 0px !important;
}

.css-28116y-MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {
  padding: 6px 4px 7.5px 5px !important;
}

.css-qjqmwp .MuiOutlinedInput-root .MuiAutocomplete-input {
  padding: 6px 4px 7.5px 5px !important;
}

.css-qjqmwp .MuiOutlinedInput-root {
  padding: 0px !important;
}

.css-28116y-MuiAutocomplete-root {
  width: 270px !important;
}

.css-qjqmwp {
  width: 270px !important;
}

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #c4c4c4 #f3f3f9;
}

.show-hide-sub-table {
  font-size: 25px;
  cursor: pointer;
}

.show-hide-sub-row {
  font-size: 30px;
  cursor: pointer;
}

.pagination-details-responsive {
  display: flex !important;
}

.flat-details-filter {
  margin: 0px 0px;
}

@media (max-width: 520px) {
  .pagination-details-responsive {
    display: contents !important;
  }

  .flat-details-filter {
    margin: 10px 0px;
  }
}

.btn-download {
  border: 2px solid #1f156d !important;
  background-color: #ffffff !important;
  color: #1f156d !important;
}

.btn-download:hover {
  background-color: #1f156d !important;
  color: #ffffff !important;
}

[data-layout-mode="dark"] .table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: #868990 #1a1d21;
}

.set-upload-button {
  margin-top: 10px;
  margin-left: 10px;
}

.set-upload-button-sample {
  margin-top: 10px;
}

[data-layout-mode="dark"] .btn-download {
  background-color: #262a2f !important;
  border: 2px solid #ffffff !important;
  color: #ffffff !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/app.min.css","webpack://./src/components/_waves.scss"],"names":[],"mappings":"AAGA;EACE,sBAAsB;EACtB,4CAAsC;ECGvC;0DDDoD;EACnD,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,4CAAwC;EACxC;0DACqD;EACrD,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,4CAAuC;EACvC;0DACoD;EACpD,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,4CAAyC;EACzC;0DACsD;EACtD,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,4CAAyC;EACzC,oFAA8E;EAC9E,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;EACtC,4CAA4C;EAC5C,6CAA6C;EAC7C,0CAA0C;EAC1C,gDAAgD;EAChD,iDAAiD;EACjD,uCAAuC;EACvC,mCAAmC;EACnC,2CAA2C;EAC3C,8CAA8C;EAC9C,+CAA+C;EAC/C,+CAA+C;EAC/C,kDAAkD;EAClD,mDAAmD;EACnD,4CAA4C;EAC5C,oBAAoB;EACpB,+BAA+B;EAC/B,4BAA4B;EAC5B,oEAAoE;EACpE,8BAA8B;EAC9B,4BAA4B;EAC5B,iCAAiC;EACjC,oBAAoB;EACpB,0BAA0B;EAC1B,oBAAoB;EACpB,+BAA+B;EAC/B,sCAAsC;EACtC,qCAAqC;EACrC,4BAA4B;EAC5B,qEAAqE;EACrE,oCAAoC;EACpC,4EAA4E;EAC5E,gDAAgD;EAChD,kEAAkE;EAClE,2BAA2B;EAC3B,2BAA2B;EAC3B,gDAAgD;EAChD,wBAAwB;EACxB,8BAA8B;EAC9B,0BAA0B;EAC1B,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,iCAAiC;EACjC,mBAAmB;EACnB,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;EAC/B,kCAAkC;EAClC,+CAA+C;EAC/C,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;;EAEE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;;EAGE,+BAA+B;AACjC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;;;;;EAME,qBAAqB;EACrB,gCAAgC;EAChC,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,4BAA4B;EAC5B,wBAAwB;EACxB,kCAAkC;EAClC,2BAA2B;EAC3B,sCAAsC;EACtC,4CAA4C;EAC5C,6CAA6C;EAC7C,0CAA0C;EAC1C,gDAAgD;EAChD,iDAAiD;EACjD,uCAAuC;EACvC,mCAAmC;EACnC,2CAA2C;EAC3C,8CAA8C;EAC9C,+CAA+C;EAC/C,+CAA+C;EAC/C,kDAAkD;EAClD,mDAAmD;EACnD,4CAA4C;EAC5C,uBAAuB;EACvB,+BAA+B;EAC/B,wCAAwC;EACxC,wDAAwD;EACxD,8BAA8B;EAC9B,4BAA4B;EAC5B,iCAAiC;EACjC,uBAAuB;EACvB,0BAA0B;EAC1B,uBAAuB;EACvB,+BAA+B;EAC/B,mCAAmC;EACnC,qCAAqC;EACrC,4BAA4B;EAC5B,6CAA6C;EAC7C,4DAA4D;EAC5D,4EAA4E;EAC5E,gDAAgD;EAChD,kEAAkE;EAClE,2BAA2B;EAC3B,2BAA2B;EAC3B,iDAAiD;EACjD,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,4BAA4B;EAC5B,wBAAwB;EACxB,8BAA8B;EAC9B,0BAA0B;EAC1B,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;EAC3B,iCAAiC;EACjC,sBAAsB;EACtB,0BAA0B;EAC1B,gCAAgC;EAChC,+BAA+B;EAC/B,kCAAkC;EAClC,gCAAgC;EAChC,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,oDAAoD;AACtD;;AAEA;EACE,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,uCAAuC;EACvC,oCAAoC;EACpC,+BAA+B;EAC/B,qCAAqC;EACrC,wCAAwC;AAC1C;;AAEA;;;;;;EAME,wBAAwB;EACxB,gCAAgC;EAChC,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;EAC9B,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;;EAEE,oCAAoC;EACpC,kDAAkD;EAClD,4DAA4D;AAC9D;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,qCAAqC;AACvC;;AAEA;;EAEE,qCAAqC;EACrC,iDAAiD;EACjD,2DAA2D;AAC7D;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,qCAAqC;AACvC;;AAEA;EACE,wCAAwC;EACxC,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;;;;;;EAME,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAC3C,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,gDAAgD;EAChD,+CAA+C;EAC/C,8CAA8C;EAC9C,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,+CAA+C;EAC/C,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;EAC5C,iDAAiD;EACjD,yDAAyD;AAC3D;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;;GAKG;;AAEH;EACE;;;;GAIC;EACD,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE;;;;GAIC;EACD,uDAAuD;EACvD,gDAAgD;AAClD;;AAEA;EACE;;;;GAIC;EACD,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE;;;;GAIC;EACD,qDAAqD;EACrD,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,aAAa;EACb,qCAAqC;EAErC,6BAA6B;AAC/B;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EAGE,aAAa;EAGb,8BAA8B;EAG9B,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE;IACE,8CAA8C;EAChD;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,4CAA4C;EAE5C,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,MAAM;EACN,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE;IACE,8BAA8B;EAChC;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,YAAY;EAGZ,aAAa;EAGb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;;EAEE,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;EAC3C,WAAW;AACb;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE;IACE,kBAAkB;IAElB,gCAAgC;EAClC;;EAEA;IACE,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,cAAc;EAChB;;EAEA;;;;IAIE,wCAAwC;IACxC,kBAAkB;IAClB,WAAW;IACX,gBAAgB;EAClB;;EAEA;;;;;;IAME,aAAa;EACf;;EAEA;;;;;;IAME,cAAc;EAChB;AACF;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,2CAA2C;AAC7C;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,mEAAmE;AACrE;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,0CAA0C;EAE1C,gCAAgC;EAChC,6BAA6B;EAC7B,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAEhB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,iBAAiB;EACjB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAEhB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,wBAAwB;EACxB,cAAc;EACd,6BAA6B;EAC7B,iBAAiB;EACjB,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE;IACE,OAAO;EACT;AACF;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE;;IAEE,OAAO;EACT;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IACE,OAAO;EACT;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EAEE,6BAA6B;EAC7B,0CAA0C;AAC5C;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,uEAAuE;AACzE;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,4CAA4C;EAC5C,kCAAkC;EAClC,SAAS;EACT,aAAa;EACb,eAAe;EACf,MAAM;EAEN,4CAA4C;EAC5C,gCAAgC;EAEhC,6BAA6B;AAC/B;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,+CAA+C;EAC/C,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,oCAAoC;EACpC,iBAAiB;EAGjB,0BAA0B;EAE1B,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;;;EAGE,gDAAgD;AAClD;;AAEA;;;;EAIE,+CAA+C;EAC/C,6BAA6B;AAC/B;;AAEA;;;EAIE,wBAAwB;EACxB,gDAAgD;AAClD;;AAEA;;;EAGE,UAAU;EACV,2DAA2D;AAC7D;;AAEA;EAEE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;EAC7C,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,UAAU;EACV,aAAa;EACb,wDAAwD;EACxD,kBAAkB;EAClB,SAAS;EACT,WAAW;EAEX,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,yEAAyE;EACzE,UAAU;AACZ;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAElB,6BAA6B;AAC/B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAElB,iDAAiD;EACjD,WAAW;EACX,WAAW;EACX,cAAc;EACd,OAAO;AACT;;AAEA;EACE,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,WAAW;EAEX,wBAAwB;EAExB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,WAAW;EAEX,wBAAwB;EAExB,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,SAAS;EACT,WAAW;EAEX,yBAAyB;EAEzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE;IACE,kBAAkB;IAClB,sBAAsB;EACxB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,aAAa;AACf;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;;;;EAKE,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;EAeE,eAAe;AACjB;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;;;;;;EAQE,aAAa;AACf;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;;;IAGE,qBAAqB;EACvB;;EAEA;;;IAGE,gBAAgB;EAClB;AACF;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;;;;;;;;;EAYE,eAAe;AACjB;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;;;;;;;;;;EAUE,qBAAqB;AACvB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE;;IAEE,oBAAoB;EACtB;AACF;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,UAAU;EACV,MAAM;EACN,2CAA2C;AAC7C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;;;EAIE,4BAA4B;AAC9B;;AAEA;;;;;;EAME,wBAAwB;AAC1B;;AAEA;;;EAGE,oBAAoB;AACtB;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;;;;EAIE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;;;;EAKE,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;;;;;;;;EAQE,aAAa;AACf;;AAEA;;;;EAIE,aAAa;EACb,uBAAuB;AACzB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;;;;;EAKE,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,iDAAiD;EAEjD,gBAAgB;AAClB;;AAEA;;;;;;EAME,oDAAoD;EACpD,+BAA+B;AACjC;;AAEA;;;;;;EAME,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;;;;EAKE,cAAc;EAEd,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;;;;;EAKE,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,YAAY;EACZ,4CAA4C;EAC5C,uBAAuB;EACvB,iBAAiB;EACjB,0BAA0B;EAE1B,4CAA4C;AAC9C;;AAEA;;;;;EAKE,iCAAiC;AACnC;;AAEA;;;;;EAKE,oCAAoC;AACtC;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;;;;;EAME,+CAA+C;AACjD;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;;EAKE,yBAAyB;EAEzB,+BAA+B;AACjC;;AAEA;;;;;EAKE,qBAAqB;EACrB,MAAM;EACN,6BAA6B;AAC/B;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;;;EAIE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;;;;;EAKE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;;;;EAIE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,QAAQ;AACV;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;EAC3C,uDAAuD;AACzD;;AAEA;;;;EAIE,yDAAyD;AAC3D;;AAEA;;;EAGE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,qDAAqD;AACvD;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;;EAIE,qDAAqD;EACrD,8BAA8B;AAChC;;AAEA;EACE,8CAA8C;EAC9C,8BAA8B;AAChC;;AAEA;EACE,oDAAoD;AACtD;;AAEA;;;;EAIE,oDAAoD;EACpD,+BAA+B;AACjC;;AAEA;;;;EAIE,qDAAqD;AACvD;;AAEA;;;;;EAKE,oDAAoD;EACpD,+BAA+B;AACjC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;;;;EAIE,wEAAwE;AAC1E;;AAEA;;;;EAIE,oDAAoD;AACtD;;AAEA;;;;EAIE,0EAA0E;AAC5E;;AAEA;;;;EAIE,qDAAqD;AACvD;;AAEA;;;;;EAKE,wCAAwC;AAC1C;;AAEA;;;;;EAKE,0EAA0E;AAC5E;;AAEA;;;;;EAKE,qDAAqD;AACvD;;AAEA;;;;;EAKE,2EAA2E;AAC7E;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;;;;;EAKE,2CAA2C;AAC7C;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;;;;EAKE,yBAAyB;EAEzB,+BAA+B;AACjC;;AAEA;;;;;;EAME,qDAAqD;AACvD;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;;EAKE,qBAAqB;EACrB,MAAM;EACN,6BAA6B;AAC/B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,wBAAwB;IACxB,cAAc;IACd,UAAU;IACV,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,UAAU;EACZ;;EAEA;;;IAGE,aAAa;EACf;;EAEA;;;;;;;;;;IAUE,qBAAqB;EACvB;;EAEA;;;;;;;;;;IAUE,aAAa;EACf;AACF;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;EACE;;;;IAIE,kBAAkB;EACpB;AACF;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,wCAAwC;EACxC,aAAa;EACb,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;EAKE,yBAAyB;AAC3B;;AAEA;;;;EAIE,+CAA+C;EAC/C,+DAA+D;AACjE;;AAEA;;;;EAIE,0CAA0C;AAC5C;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;;;;EAIE,qDAAqD;AACvD;;AAEA;;;;;;;;;;;;EAYE,cAAc;AAChB;;AAEA;;;;;;;;;;;;EAYE,qDAAqD;AACvD;;AAEA;;;;;;;;;;;;EAYE,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;EAgBE,qDAAqD;EACrD,8BAA8B;AAChC;;AAEA;;;;EAIE,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;;;;EAIE,oDAAoD;AACtD;;AAEA;;;;EAIE,oDAAoD;EACpD,+BAA+B;AACjC;;AAEA;;;;EAIE,qDAAqD;AACvD;;AAEA;;;;EAIE,oDAAoD;EACpD,+BAA+B;AACjC;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;;;;EAIE,qDAAqD;AACvD;;AAEA;;;;EAIE,oDAAoD;AACtD;;AAEA;;;;EAIE,0EAA0E;AAC5E;;AAEA;;;;EAIE,qDAAqD;AACvD;;AAEA;;;;EAIE,wCAAwC;AAC1C;;AAEA;;;;EAIE,0EAA0E;AAC5E;;AAEA;;;;EAIE,qDAAqD;AACvD;;AAEA;;;;EAIE,2EAA2E;AAC7E;;AAEA;;;;EAIE,+CAA+C;AACjD;;AAEA;;;;;;;;;;;;;;;;;;;;EAoBE,2CAA2C;AAC7C;;AAEA;;;;;;;;;;;;;;;;EAgBE,UAAU;AACZ;;AAEA;;;;;;;;;;;;;;;;;;;;EAoBE,yBAAyB;EAEzB,+BAA+B;AACjC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,qDAAqD;AACvD;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;EAwBE,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;EAoBE,qBAAqB;EACrB,MAAM;EACN,6BAA6B;AAC/B;;AAEA;;;;;;;;;;;;;;;;;;;;EAoBE,+CAA+C;AACjD;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;EAQE,2EAA2E;AAC7E;;AAEA;EAQE,0EAA0E;AAC5E;;AAEA;EAQE,wEAAwE;AAC1E;;AAEA;EAQE,wEAAwE;AAC1E;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,cAAc;EACd,MAAM;EACN,OAAO;EACP,sBAAsB;EACtB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;;IAEE,cAAc;IACd,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,2BAA2B;EAE3B,4CAA4C;EAC5C,gBAAgB;EAChB,eAAe;EACf,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EAIE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,yCAAyC;AAC3C;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;;;;EAKE,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;;;;EAIE,yCAAyC;AAC3C;;AAEA;;;;;EAKE,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;;;;EAIE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;;;;;EAKE,QAAQ;EAER,mCAAmC;AACrC;;AAEA;;;;;EAKE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;EAIE,WAAW;EAEX,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,4BAA4B;AAC9B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE;IACE,cAAc;IACd,uBAAuB;EACzB;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EAEjB,0CAA0C;EAE1C,6BAA6B;EAE7B,wBAAwB;EAExB,yBAAyB;EACzB,SAAS;EACT,aAAa;EACb,sCAAsC;EACtC,4BAA4B;EAC5B,sCAAsC;EACtC,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IAIE,sBAAsB;EACxB;;EAEA;;;;;;IAME,oBAAoB;EACtB;;EAEA;;;;;;IAME,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IAEf,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IAEP,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;;IAIE,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;;EAME,oCAAoC;AACtC;;AAEA;;;;EAKE,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,qDAAqD;EACrD,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;;;;;;;EAOE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,sDAAsD;EACtD,YAAY;EACZ,WAAW;EAEX,4CAA4C;EAC5C,MAAM;EACN,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;EACzC,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EAGb,oBAAoB;EAGpB,uBAAuB;EAGvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;;EAGE,sDAAsD;EACtD,8DAA8D;AAChE;;AAEA;EACE,kDAAkD;EAClD,oDAAoD;AACtD;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;;EAKE,+CAA+C;AACjD;;AAEA;;;;;;;;;;EAUE,sDAAsD;AACxD;;AAEA;;;;;;;;;;EAUE,4EAA4E;AAC9E;;AAEA;;;;EAIE,sDAAsD;AACxD;;AAEA;;;;EAIE,iEAAiE;AACnE;;AAEA;;;;EAIE,iEAAiE;AACnE;;AAEA;;;;EAIE,2DAA2D;AAC7D;;AAEA;;;;;;;;;;;;EAYE,+BAA+B;AACjC;;AAEA;;;;;;;;;;;;EAYE,sDAAsD;EACtD,8DAA8D;AAChE;;AAEA;;;;EAIE,kDAAkD;EAClD,oDAAoD;AACtD;;AAEA;;;;;;;;;;;;;;;;EAgBE,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;EAgBE,aAAa;AACf;;AAEA;;;;;;;;;;;;;;;;;;;;EAoBE,+BAA+B;AACjC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwCE,sDAAsD;AACxD;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAwCE,4EAA4E;AAC9E;;AAEA;;;;;;;;;;;;;;;;EAgBE,sDAAsD;AACxD;;AAEA;;;;;;;;;;;;;;;;EAgBE,iEAAiE;AACnE;;AAEA;;;;;;;;;;;;;;;;EAgBE,iEAAiE;AACnE;;AAEA;;;;;;;;EAQE,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;;IAEE,OAAO;EACT;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;;IAEE,OAAO;EACT;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,cAAc;EAEd,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;;;;IAIE,kBAAkB;EACpB;AACF;;AAEA;EACE;;;;IAIE,cAAc;EAChB;AACF;;AAEA;;;;EAIE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE;;;;IAIE,qBAAqB;EACvB;AACF;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;EACE;;;;IAIE,sBAAsB;EACxB;AACF;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE;;IAEE,sBAAsB;EACxB;AACF;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE;;IAEE,iBAAiB;IAEjB,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA;;;;;;;;;;;;;;;;EAgBE,eAAe;EACf,kBAAkB;AACpB;;AAEA;;;EAGE,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;;;;;;;;;;;;;EAcE,kBAAkB;AACpB;;AAEA;EACE;;IAEE,kBAAkB;EACpB;AACF;;AAEA;EACE;;IAEE,kBAAkB;EACpB;AACF;;AAEA;;;;;;uDAMuD;;AAEvD;EACE,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EAGzB,iBAAiB;EACjB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,8BAA8B;EAC9B;;;;;;GAMC;EAED,6BAA6B;EAI7B,uCAAuC;EAGvC,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,oCAAoC;EACpC;;;;;;GAMC;AACH;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;;EAGE,wBAAwB;EACxB,yEAAyE;AAC3E;;AAEA;;;;EAIE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,UAAU;EACV,cAAc;EACd,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EAExB,+CAA+C;EAE/C,oBAAoB;AACtB;;AAEA;EAEE,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EAGE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EAGX,aAAa;EACb,gBAAgB;EAChB,YAAY;EAGZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAGlB,aAAa;EAEb,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAElB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAElB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oDAAoD;AACtD;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qDAAqD;AACvD;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kDAAkD;AACpD;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,yDAA8R;AAChS;;AAEA;EACE,0DAAiS;AACnS;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;;;EAIE,gDAAgD;AAClD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAGE,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAElB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,YAAY;EAGZ,aAAa;EAGb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,SAAS;EACT,OAAO;EACP,MAAM;EACN,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa;AACf;;AAEA;EACE,wBAAwB;EAExB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE;IACE,aAAa;IACb,0BAA0B;IAC1B,aAAa;IACb,QAAQ;IACR,MAAM;IACN,SAAS;IACT,aAAa;EACf;;EAEA;IACE,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,uCAAuC;EACzC;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,+BAA+B;EACjC;AACF;;AAEA;EACE;;IAEE,+BAA+B;IAC/B,eAAe;IACf,iCAAiC;EACnC;AACF;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EAEE,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,aAAa;EACb,WAAW;EAEX,yBAAyB;EACzB,aAAa;EACb,aAAa;AACf;;AAEA;EAEE,uCAAuC;AACzC;;AAgBA;EACE;IAEE,wBAAwB;IACxB,UAAU;EACZ;;EAEA;IAEE,4BAA4B;IAC5B,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,uBAAuB;AACzB;;AA8BA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,+CAA+C;EAC/C,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,yCAAyC;EACzC,SAAS;EAET,wBAAwB;EACxB,SAAS;EAET,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,UAAU;EAEV,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EAEzB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAElB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EAEd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,SAAS;EAET,4CAA4C;EAC5C,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE;;;;;;;IAOE,wBAAwB;EAC1B;;EAEA;;;;;IAKE,UAAU;IACV,SAAS;EACX;;EAEA;IACE,SAAS;IAET,2BAA2B;EAC7B;;EAEA;IAGE,wBAAwB;EAC1B;;EAEA;IAGE,yBAAyB;IACzB,qBAAqB;IACrB,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EAEjB,+CAA+C;EAC/C,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,MAAM;EACN,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EAGV,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,UAAU;EAGV,aAAa;EAGb,uBAAuB;EAGvB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,eAAe;EAEf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EAEE,wBAAwB;EACxB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,UAAU;EACV,YAAY;EAEZ,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EAEE,gBAAgB;EAChB,UAAU;EACV,UAAU;EACV,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EAEjB,yBAAyB;EACzB,YAAY;EACZ,cAAc;EAGd,wEAAwE;EACxE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,mCAAmC;EACnC,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,UAAU;EACV,UAAU;EACV,MAAM;AACR;;AAEA;EACE,WAAW;EACX,UAAU;EACV,UAAU;EACV,MAAM;EACN,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAEE,4BAA4B;EAE5B,yBAAyB;AAC3B;;AAEA;EAEE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EAEE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EAEE,2BAA2B;EAE3B,yBAAyB;AAC3B;;AAEA;EAEE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EAEE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;EAYE,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE;;;;;;IAME,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,2CAA2C;EAC3C,eAAe;EAGf,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;EAC1C,oCAAoC;EACpC,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,OAAO;EACP,QAAQ;EAER,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,eAAe;EACf,iBAAiB;EACjB,+CAA+C;AACjD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,2BAA2B;EAC3B,WAAW;EACX,MAAM;AACR;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;;EAEE,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EAGE,oBAAoB;EAGpB,uBAAuB;EAGvB,mBAAmB;EACnB,gCAAgC;EAChC,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;;;EAGE,sBAAsB;EACtB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;EAGE,sBAAsB;EACtB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;;;EAGE,sBAAsB;EACtB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;EAGE,sBAAsB;EACtB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;;;EAGE,sBAAsB;EACtB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;;;EAGE,sBAAsB;EACtB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;;;EAGE,sBAAsB;EACtB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;;;EAGE,sBAAsB;EACtB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,mDAAmD;EACnD,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,oDAAoD;EACpD,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,oDAAoD;EACpD,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,oDAAoD;EACpD,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,oDAAoD;EACpD,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,oDAAoD;EACpD,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,qDAAqD;EACrD,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;EACzB,kDAAkD;EAClD,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,SAAS;EACT,YAAY;EACZ,0CAA0C;EAC1C,eAAe;EAGf,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;AACzB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAEhB,oDAAoD;EAEpD,wDAAwD;AAC1D;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,UAAU;EAEV,iCAAiC;EACjC,sBAAsB;EAGtB,wCAAwC;EAGxC,wDAAwD;AAC1D;;AAEA;EACE,cAAc;EAGd,wCAAwC;EAGxC,wDAAwD;AAC1D;;AAEA;EACE,UAAU;EAEV,+BAA+B;AACjC;;AAEA;EACE,UAAU;EAEV,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;EAKE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;;;;EAIE,qBAAqB;EACrB,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA;;;;;;;;;;;;;;;EAeE,qBAAqB;EACrB,iDAAiD;EACjD,6CAA6C;AAC/C;;AAEA;;;;EAIE,sBAAsB;EACtB,gDAAgD;EAChD,4CAA4C;AAC9C;;AAEA;;;;;;;;;;;;;;;EAeE,sBAAsB;EACtB,gDAAgD;EAChD,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;EAGE,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;;EAEE,YAAY;EACZ,WAAW;AACb;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;;;EAGE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EAErB,gCAAgC;AAClC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAEE,oBAAoB;AACtB;;AAEA;EAEE,wCAAwC;EAExC,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,0CAA0C;EAC1C,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,0CAA0C;EAC1C,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,0CAA0C;EAC1C,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,0CAA0C;EAC1C,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,0CAA0C;EAC1C,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,0CAA0C;EAC1C,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,0CAA0C;EAC1C,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,0CAA0C;EAC1C,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,sCAAsC;EACtC,+CAA+C;AACjD;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gDAAgD;EAChD,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EAER,2CAA2C;AAC7C;;AAEA;EAEE,kCAAkC;AACpC;;AASA;EACE;IAEE,yBAAyB;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,SAAS;AACX;;AAEA;;EAEE,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EAEE,6CAA6C;EAE7C,6BAA6B;EAE7B,wBAAwB;EAExB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EAEE,iCAAiC;AACnC;;AAYA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAYA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,SAAS;EACT,YAAY;EACZ,WAAW;EACX,OAAO;EACP,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,WAAW;AACb;;AAEA;;;EAGE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;;;EAGE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;;;EAGE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;;;EAGE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;;;EAGE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;;;EAGE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;;;EAGE,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;;;EAGE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAGE,gCAAgC;AAClC;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,SAAS;EAET,6BAA6B;EAE7B,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,SAAS;EAET,2BAA2B;EAG3B;kCACgC;AAClC;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EAER,oBAAoB;AACtB;;AAEA;EACE,QAAQ;EAER,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EAEX,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,QAAQ;IAER,2BAA2B;IAC3B,8BAA8B;IAC9B,8BAA8B;IAE9B,uCAAuC;EACzC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAEhB,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,QAAQ;EACR,YAAY;EAEZ,6DAA6D;EAC7D,yBAAyB;EACzB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,wCAAwC;AAC1C;;AAEA;;EAEE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EAER,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAGlB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,UAAU;EACV,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;EACZ,QAAQ;EAER,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wCAAwC;EACxC,cAAc;EAEd,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gDAAgD;EAChD,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAElB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,WAAW;EACX,mCAAmC;EAEnC,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,YAAY;EAEZ,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,WAAW;EAEX,6BAA6B;AAC/B;;AAEA;;;EAGE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,oCAAoC;EACpC,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EAEV,0BAA0B;EAE1B,gCAAgC;AAClC;;AAEA;EACE,UAAU;EAEV,wBAAwB;AAC1B;;AAEA;EAEE,sCAAsC;EAEtC,6BAA6B;AAC/B;;AAEA;EAEE,eAAe;AACjB;;AAEA;EAEE,oCAAoC;EAEpC,4BAA4B;AAC9B;;AAEA;EAEE,eAAe;AACjB;;AAEA;EAEE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EAEV,0BAA0B;EAE1B,oBAAoB;AACtB;;AAEA;EACE,UAAU;EAEV,qBAAqB;AACvB;;AAEA;EACE,UAAU;EAEV,qBAAqB;EAErB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EAEV,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EAGE,aAAa;EAGb,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE;IACE,+BAA+B;EACjC;AACF;;AAEA;EAGE,aAAa;EAGb,qBAAqB;EACrB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE;IACE,+BAA+B;EACjC;AACF;;AAgBA;EACE;IACE,UAAU;IAEV,kCAAkC;EACpC;;EAEA;IACE,UAAU;IAEV,wBAAwB;EAC1B;AACF;;AAgBA;EACE;IACE,UAAU;IAEV,iCAAiC;EACnC;;EAEA;IACE,UAAU;IAEV,wBAAwB;EAC1B;AACF;;AAcA;EACE;IACE,UAAU;IAEV,iCAAiC;EACnC;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,0DAAg8D;EACh8D,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAElB,8BAA8B;AAChC;;AAQA;EACE;IACE,QAAQ;EACV;AACF;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,QAAQ;EAER,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,yBAAyB;EACzB,YAAY;EACZ,SAAS;EAET,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oDAAoD;EACpD,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kDAAkD;EAClD,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EAEE,6CAA6C;AAC/C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qDAAqD;EACrD,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,4BAA4B;EAC5B,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,MAAM;EACN,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,cAAc;EAEd,iDAAiD;AACnD;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EAEpC,iDAAiD;AACnD;;AAEA;EACE;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0CAA0C;EAC1C,yDAAyD;EACzD,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,0DAA0J;AAC5J;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EAGV,aAAa;EAGb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,0DAAiP;EACjP,2BAA2B;EAC3B,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,gDAAgD;EAChD,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAIlB,sBAAsB;EAEtB,eAAe;EAGf,2BAA2B;EAE3B,yBAAyB;EAGzB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,OAAO;EACP,MAAM;EACN,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,6BAA6B;EAE7B,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAElB,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,oBAAoB;AACtB;;AAEA;EAEE,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,SAAS;EACT,oBAAoB;EAGpB,kBAAkB;EAElB,cAAc;EAEd,aAAa;AACf;;AAEA;EAEE,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EAGpB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,UAAU;EAEV,+BAA+B;AACjC;;AAEA;EACE,YAAY;EAEZ,6BAA6B;AAC/B;;AAEA;EACE,MAAM;EACN,WAAW;AACb;;AAEA;EACE,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,uBAAuB;EACvB,sEAAsE;EACtE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAGhB,WAAW;EAGX,aAAa;AACf;;AAkBA;;;;EAIE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;;IAEE,iBAAiB;EACnB;AACF;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,cAAc;AAChB;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;;;;;;EAME,WAAW;AACb;;AAEA;;;;;EAKE,cAAc;EACd,qCAAqC;AACvC;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EAEX,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,mCAAmC;EAMnC;2EACyE;EAIzE,gCAAgC;EAChC,oDAAoD;EACpD,6BAA6B;EAC7B,yBAAyB;EAEzB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EAErB,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;EAME,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;;;EAIE,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,oCAAoC;EACpC,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;EACzC,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;EAEnC,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;AACX;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,qBAAqB;EACrB,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;EACX,UAAU;EACV,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,gBAAgB;EAChB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;;;EAGE,YAAY;EACZ,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,wCAAwC;EAExC,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAEhB,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EAGZ,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EAEvB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EAEpC,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,UAAU;EACV,wCAAwC;EAExC,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,wCAAwC;EAExC,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;EACf,cAAc;EAEd,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EAEnB,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,sBAAsB;EACtB,YAAY;EAEZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,oCAAoC;EAEpC,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EAEZ,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2CAA2C;EAE3C,0BAA0B;EAC1B,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EAET,2BAA2B;EAC3B,YAAY;EACZ,WAAW;EACX,YAAY;EAGZ,aAAa;EAGb,uBAAuB;EAGvB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,+CAA+C;EAC/C,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;;EAEE,mBAAmB;EACnB,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;EACxC,8BAA8B;EAC9B,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EAGE,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,oCAAoC;EACpC,wCAAwC;EACxC,sBAAsB;EACtB,mBAAmB;AACrB;;AAkBA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EAEpC,6CAA6C;EAC7C,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAE1C,4CAA4C;EAC5C,kBAAkB;EAElB,gCAAgC;AAClC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EAEE,gBAAgB;EAChB,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yCAAyC;EACzC,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,wCAAwC;EAExC,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,2BAA2B;EAC3B,2BAA2B;EAC3B,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EAGE,aAAa;EACb,WAAW;AACb;;AAEA;EAEE,cAAc;AAChB;;AAEA;EAGE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,iDAAiD;AACnD;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EAEE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,qDAAqD;EACrD,+CAA+C;EAE/C,2BAA2B;AAC7B;;AAEA;EACE,2CAA2C;EAE3C,6CAA6C;EAE7C,6BAA6B;EAE7B,wBAAwB;EAExB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;;EAEE,OAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EAEE,wDAAwD;EACxD,gCAAgC;EAChC,mDAAmD;AACrD;;AAEA;;;;EAKE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;;EAEE,sCAAsC;AACxC;;AAEA;;EAEE,iCAAiC;EACjC,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;;EAEE,iCAAiC;EACjC,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;;EAKE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,mDAAmD;AACrD;;AAEA;EACE,yDAAyD;EAEzD,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,mDAAmD;AACrD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sDAAsD;AACxD;;AAEA;;;EAGE,2BAA2B;AAC7B;;AAEA;EAGE,aAAa;EAIb,8BAA8B;AAChC;;AAEA;EACE,mDAAmD;EACnD,2BAA2B;AAC7B;;AAEA;;;;;;;EAOE,iCAAiC;EACjC,uCAAuC;EACvC,wCAAwC;AAC1C;;AAEA;;;;;;;;;EASE,iCAAiC;EACjC,oCAAoC;EACpC,qCAAqC;AACvC;;AAEA;EAIE,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,oCAAoC;EACpC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAEE,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;EACtC,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,cAAc;AAChB;;AAEA;EAEE,gBAAgB;EAChB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iDAAiD;EACjD,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,wCAAwC;EACxC,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,iDAAiD;AACnD;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,6BAA6B;EAC7B,0CAA0C;EAC1C,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;;EAGE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EAER,2BAA2B;EAC3B,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,2BAA2B;EAC3B,gBAAgB;EAChB,sCAAsC;EACtC,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EAEE,gBAAgB;EAChB,0CAA0C;EAC1C,oCAAoC;AACtC;;AAkBA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,0DAA+O;AACjP;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,8CAA8C;EAG9C,gBAAgB;EAChB,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;;EAIE,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAGhB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,2BAA2B;EAC3B,0CAA0C;EAC1C,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EAGzB,iBAAiB;EAGjB,aAAa;EAGb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,0CAA0C;EAC1C,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,mDAAmD;EACnD,qDAAqD;EAErD,2CAA2C;AAC7C;;AAEA;EACE,iDAAiD;EACjD,yBAAyB;AAC3B;;AAEA;EACE,4DAA4D;EAC5D,0DAA0D;AAC5D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,iDAAiD;EACjD,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,iDAAiD;EACjD,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,UAAU;EACV,cAAc;EAEd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAElB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EAEE,wBAAwB;EAExB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EAEX,6BAA6B;AAC/B;;AAEA;EAEE,sCAAsC;EAEtC,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE;IAEE,0BAA0B;EAC5B;;EAEA;IAEE,2BAA2B;EAC7B;AACF;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,mCAAmC;EACnC,oCAAoC;EACpC,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;EAC3B,oCAAoC;EACpC,4BAA4B;EAC5B,wCAAwC;EACxC,sBAAsB;EACtB,sBAAsB;AACxB;;AA0BA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,sBAAsB;EAEtB,6CAA6C;EAC7C,UAAU;EACV,cAAc;EACd,iBAAiB;EACjB,SAAS;EAET,6BAA6B;EAE7B,wBAAwB;EAExB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,sCAAsC;EAEtC,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,8BAA8B;AAChC;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE;;;IAGE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EAGV,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;EAC7C,4CAA4C;AAC9C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;;;;;;;;;EAUE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,cAAc;EACd,0BAA0B;EAE1B,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;;;EAGE,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;EAC3B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EAGR,aAAa;EAGb,mBAAmB;EAGnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,YAAY;EAEZ,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE;IAIE,sBAAsB;IACtB,SAAS;EACX;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,0BAA0B;AAC5B;;AAEA;EAEE,0BAA0B;AAC5B;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EAEvB,2CAA2C;EAC3C,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,iDAAiD;EACjD,sCAAsC;AACxC;;AAEA;EACE;IACE,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;EACf;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+CAA+C;EAC/C,sCAAsC;EACtC,iCAAiC;EACjC,+BAA+B;AACjC;;AAkBA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,SAAS;AACX;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;;;;;EAKE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;;;;;EAKE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EAEpC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;;;EAIE,oCAAoC;EACpC,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;EAChC,oCAAoC;EACpC,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,wEAAwE;EACxE,2BAA2B;AAC7B;;AAEA;;;;EAIE,mFAAmF;EACnF,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EAEtC,gCAAgC;EAChC,sCAAsC;EACtC,aAAa;AACf;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,wCAAwC;EACxC,oCAAoC;EACpC,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;;EAEE,yBAAyB;EACzB,WAAW;AACb;;AAEA;;;EAGE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;EAGE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,mDAAmD;EACnD,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;;;EAGE,WAAW;EACX,iBAAiB;EACjB,qBAAqB;EACrB,cAAc;EACd,QAAQ;AACV;;AAEA;;;EAGE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,sCAAsC;AACxC;;AAkBA;EACE,cAAc;AAChB;;AAEA;;;;EAIE,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EAGrB;2CACyC;EACzC,mBAAmB;EACnB,eAAe;EACf,UAAU;EAEV,wDAAwD;EACxD,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EAER,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE;;IAEE,iBAAiB;IACjB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IAGR,sBAAsB;EACxB;AACF;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,iDAAiD;EACjD,mBAAmB;EACnB,yBAAyB;EAGzB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,sBAAsB;EACtB,oCAAoC;EACpC,wCAAwC;EACxC,oBAAoB;EACpB,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,0DAAyX;EACzX,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EAEE,6BAA6B;AAC/B;;AAEA;;;EAGE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,SAAS;EACT,6CAA6C;EAC7C,aAAa;EACb,UAAU;EACV,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,QAAQ;EAER,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EAEb,2CAA2C;AAC7C;;AAEA;;EAEE,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;EAEE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,+CAA+C;EAC/C,eAAe;EACf,0DAAyX;EACzX,oBAAoB;EACpB,UAAU;EACV,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,oCAAoC;EACpC,qCAAqC;EACrC,wCAAwC;EACxC,iCAAiC;EACjC,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EAErB,sBAAsB;EACtB,WAAW;EAEX,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,sCAAsC;EACtC,wCAAwC;EAExC,6CAA6C;EAC7C,SAAS;EACT,aAAa;EACb,4BAA4B;EAC5B,gCAAgC;EAChC,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EAEvB,wBAAwB;EAExB,yBAAyB;EAEzB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EAEnB,6BAA6B;AAC/B;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EAEE,iCAAiC;EAEjC,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE;IACE,+BAA+B;IAC/B,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,QAAQ;IAER,2BAA2B;EAC7B;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EAGzB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,oBAAoB;EAGpB,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,oCAAoC;EACpC,2BAA2B;EAC3B,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAkBA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EAEE,kDAAkD;AACpD;;AAEA;EACE,eAAe;EACf,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EAEV,eAAe;EACf,cAAc;EACd,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAEhB,sBAAsB;EAEtB,0BAA0B;EAC1B,gCAAgC;EAIhC;;kCAEgC;AAClC;;AAEA;;EAEE,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EAEE,2DAA2D;AAC7D;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,WAAW;EAEX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,wCAAwC;EACxC,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,eAAe;AACjB;;AAEA;;;;;EAKE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mDAAmD;EACnD,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;;;;EAKE,2BAA2B;AAC7B;;AAEA;;;;EAKE,6CAA6C;AAC/C;;AAEA;;EAEE,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,yBAAyB;EACzB,WAAW;EACX,SAAS;EACT,QAAQ;EACR,UAAU;AACZ;;AAEA;;;;EAIE,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EAGE,aAAa;EACb,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,8BAA8B;EAC9B,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EAGzB,iBAAiB;EACjB,gBAAgB;EAGhB,SAAO;AACT;;AAEA;;EAEE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,aAAa;EACb,UAAU;EACV,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,OAAO;AACT;;AAEA;;EAEE,QAAQ;AACV;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;EAGE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,SAAS;EACT,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,gDAAgD;EAEhD,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,MAAM;EACN,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,8CAA8C;EAC9C,QAAQ;AACV;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;EACnC,2CAA2C;EAC3C,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAElB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EAEf,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EAGvB,qBAAqB;AACvB;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EAGE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAEhB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;AACb;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;;EAGE,6BAA6B;EAC7B,UAAU;EACV,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EAGX,aAAa;EAGb,mBAAmB;EACnB,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EAGE,aAAa;EAGb,SAAO;AACT;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,cAAc;EAGd,SAAO;EACP,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAGhB,aAAa;EAGb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EAEpB,sBAAsB;EACtB,qBAAqB;EAGrB,aAAa;EAEb,eAAe;EAEf,6BAA6B;EAE7B,+BAA+B;EAC/B,UAAU;AACZ;;AAEA;EAEE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,oBAAoB;EAEpB,sBAAsB;EACtB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAElB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAGlB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;;;;;;;;;;;;EAYE,eAAe;EACf,UAAU;EACV,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,wCAAwC;EAExC,gCAAgC;AAClC;;AAEA;;EAEE,qBAAqB;EACrB,yCAAyC;EACzC,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;;;;;;EAkBE,mBAAmB;EAEnB,gCAAgC;EAChC,WAAW;EACX,qBAAqB;AACvB;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;;;EAIE,6BAA6B;AAC/B;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAEhB,6DAA6D;AAC/D;;AAEA;;;;;;;EAOE,0CAA0C;EAC1C,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAEhB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EAEf,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,eAAe;EACf,oCAAoC;EACpC,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EAGd,aAAa;EAEb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EAEV,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAEhB,sBAAsB;EACtB,gBAAgB;EAGhB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;;AAEA;EAGE,SAAO;EACP,UAAU;EACV,YAAY;EACZ,WAAW;AACb;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EAEf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAElB,sBAAsB;EAGtB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,2BAA2B;EAC3B,gBAAgB;EAChB,SAAS;EACT,yBAAyB;EAGzB,iBAAiB;EAEjB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;;;EAIE,mCAAmC;AACrC;;AAEA;;;;;;EAME,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,oCAAoC;AACtC;;AAEA;;EAEE,aAAa;AACf;;AAgBA;EACE;IACE,UAAU;IAEV,mCAAmC;EACrC;;EAEA;IACE,UAAU;IAEV,+BAA+B;EACjC;AACF;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;GAMG;;AAEH;;EAEE,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,OAAO;EACP,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,OAAO;EACP,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,OAAO;EACP,QAAQ;EACR,6CAA6C;EAC7C,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,0CAA0C;EAC1C,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;;;;GAMG;;AAEH;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,OAAO;AACT;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;;AAEA;;;;EAIE,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,oDAAoD;AACtD;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,8CAA8C;EAChD;AACF;;AAEA;EACE;IACE,eAAe;IACf,+CAA+C;EACjD;AACF;;AAEA;EACE;;IAEE,WAAW;EACb;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;;GAGG;;AAEH;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;;AAEA;;EAEE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;EAE3C,0BAA0B;AAC5B;;AAEA;EACE;;IAEE,sBAAsB;IACtB,0BAA0B;EAC5B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,oCAAoC;EACpC,SAAS;EACT,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAGlB,oBAAoB;EACpB,WAAW;EACX,YAAY;EAGZ,mBAAmB;EAGnB,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,wCAAwC;EACxC,mBAAmB;EACnB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;EACxB,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,kBAAkB;EAClB,wCAAwC;EACxC,sBAAsB;EAEtB,mDAAmD;AACrD;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,sDAAsD;AACxD;;AAEA;EACE;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;;IAEE,OAAO;EACT;;EAEA;;IAEE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,eAAe;IACf,UAAU;EACZ;;EAEA;;IAEE,WAAW;IACX,wEAAwE;EAC1E;;EAEA;;IAEE,WAAW;IACX,OAAO;IACP,WAAW;EACb;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EAGE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,yBAAyB;EAGzB,mBAAmB;EAGnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EAGV,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,aAAa;EACb,wCAAwC;EACxC,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,0EAA0E;EAC1E,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,wEAAwE;EACxE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,wCAAwC;EACxC,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,UAAU;EACV,wEAAwE;AAC1E;;AAEA;EACE,UAAU;EACV,cAAc;EACd,UAAU;EACV,0EAA0E;EAC1E,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,OAAO;EACP,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAE7B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EAGjB,aAAa;EAGb,uBAAuB;EAGvB,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,OAAO;EACP,UAAU;EACV,0EAA0E;EAC1E,kBAAkB;EAClB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,OAAO;EACP,cAAc;AAChB;;AAEA;EACE,eAAe;EAEf,0BAA0B;AAC5B;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,0EAA0E;AAC5E;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,wCAAwC;EACxC,UAAU;EACV,YAAY;EAEZ,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0CAA0C;EAC1C,0CAA0C;EAC1C,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,8CAA8C;EAC9C,UAAU;EACV,YAAY;EACZ,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EAEnB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,WAAW;EACX,SAAS;EACT,0CAA0C;EAE1C,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,SAAS;EACT,QAAQ;EACR,UAAU;EASV;;;;;GAKC;EACD,kBAAkB;EAClB,gBAAgB;EAEhB,mCAAmC;EAGnC,aAAa;EACb,WAAW;EAGX,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA;EAEE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,SAAS;EAET,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,SAAS;EACX;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,MAAM;EACR;AACF;;AAuCA;EACE;IAEE,wBAAwB;EAC1B;;EAEA;IAEE,yCAAyC;EAC3C;;EAEA;IAEE,uCAAuC;EACzC;;EAEA;IAEE,yCAAyC;EAC3C;;EAEA;IAEE,uCAAuC;EACzC;;EAEA;IAEE,wCAAwC;EAC1C;;EAEA;IAEE,wBAAwB;EAC1B;AACF;;AAEA;EAEE,sCAAsC;AACxC;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,SAAS;EACT,YAAY;EACZ,mBAAmB;EAQnB,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,YAAY;EAEZ,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;EACxC,6CAA6C;AAC/C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EAEb,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,SAAS;EACT,eAAe;AACjB;;AAEA;EAEE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,8CAA8C;EAC9C,kBAAkB;EAClB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EAEb,iBAAiB;AACnB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,0CAA0C;EAE1C,gCAAgC;EAChC,oBAAoB;EACpB,YAAY;EACZ,YAAY;EAGZ,aAAa;EAGb,uBAAuB;EAGvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;EACd,QAAQ;EACR,aAAa;EACb,8CAA8C;EAC9C,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,gDAAgD;EAChD,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,wBAAwB;EACxB,iBAAiB;EACjB,gDAAgD;EAChD,UAAU;EACV,WAAW;EACX,SAAS;AACX;;AAEA;EACE,WAAW;EACX,WAAW;AACb;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,6CAA6C;EAC7C,+CAA+C;EAC/C,8CAA8C;EAC9C,cAAc;EACd,UAAU;EACV,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,OAAO;IACP,UAAU;EACZ;AACF;;AAEA;EACE,8CAA8C;EAC9C,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,8CAA8C;EAC9C,UAAU;EACV,UAAU;EACV,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,WAAW;IACX,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,4BAA4B;IAC5B,UAAU;IACV,UAAU;IACV,OAAO;IACP,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;IACX,yBAAyB;IACzB,+CAA+C;IAC/C,kBAAkB;IAClB,MAAM;IACN,OAAO;EACT;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,WAAW;IACX,6CAA6C;IAC7C,kBAAkB;IAClB,QAAQ;IAER,2BAA2B;IAC3B,OAAO;EACT;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,QAAQ;IACR,+CAA+C;IAC/C,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,6CAA6C;IAC7C,kBAAkB;IAClB,MAAM;IACN,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,+CAA+C;IAC/C,kBAAkB;IAClB,SAAS;IACT,OAAO;EACT;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,+CAA+C;IAC/C,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,cAAc;EAChB;AACF;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,8CAA8C;EAC9C,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,SAAS;EACT,OAAO;AACT;;AAEA;;EAEE,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;;EAEE,WAAW;EACX,WAAW;EACX,6CAA6C;EAC7C,kBAAkB;EAClB,QAAQ;EAER,2BAA2B;EAC3B,OAAO;AACT;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,8CAA8C;EAC9C,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;AAChB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,aAAa;EACb,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;;EAGE,aAAa;EACb,WAAW;EAEX,iBAAiB;AACnB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EAQZ,qDAAqD;EACrD,YAAY;AACd;;AAEA;EAIE,mBAAmB;AACrB;;AAEA;EAGE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAGE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EAGrB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EAGE,aAAa;EAIb,sBAAsB;EAGtB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IAGE,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE;IAGE,cAAc;IACd,UAAU;EACZ;AACF;;AAEA;EACE;IAGE,cAAc;IACd,WAAW;EACb;AACF;;AAEA;EAIE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EAGE,mBAAmB;EAGnB,8BAA8B;AAChC;;AAEA;EAGE,aAAa;EAGb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EAGX,cAAc;EAGd,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IAIE,mBAAmB;EACrB;;EAEA;IAGE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,WAAW;IAGX,cAAc;IAGd,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAGlB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EAEtB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EAER,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA;EAEE,sCAAsC;AACxC;;AAcA;EACE;IAEE,wBAAwB;EAC1B;;EAEA;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,QAAQ;EAER,2BAA2B;EAC3B,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,OAAO;EACP,QAAQ;EACR,cAAc;EACd,UAAU;EACV,oBAAoB;EAEpB,mCAAmC;EACnC,iCAAiC;AACnC;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EAEE,qBAAqB;AACvB;;AAgBA;EACE;IACE,UAAU;IAEV,mBAAmB;EACrB;;EAEA;IACE,UAAU;IAEV,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE;IACE,gBAAgB;IAChB,wBAAwB;EAC1B;AACF;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;AAEA;;;;EAIE,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,uCAAuC;EACzC;AACF;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,8DAA8D;EAC9D,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,2BAA2B;EAE3B,oBAAoB;EACpB,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,UAAU;EACV,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,eAAe;EACf,iBAAiB;EAEjB,oBAAoB;EACpB,2BAA2B;EAC3B,8BAA8B;EAC9B,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,QAAQ;EAER,2BAA2B;EAC3B,UAAU;EACV,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;;;;;;GAMG;;AAEH;EACE;IACE,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,WAAW;IACX,wBAAwB;IACxB,kBAAkB;IAElB,2BAA2B;IAC3B,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IAEnB,wBAAwB;EAC1B;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IAGE,wBAAwB;EAC1B;AACF;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;AAC5C;;AAEA;EACE;IACE,eAAe;IACf,OAAO;IACP,QAAQ;IACR,MAAM;IACN,UAAU;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EAEjB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IAGE,aAAa;IAGb,yBAAyB;EAC3B;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EAGE,aAAa;EAIb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EAGE,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,OAAO;EACP,QAAQ;EACR,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EAGnB,oBAAoB;EACpB,kBAAkB;EAGlB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;EAGE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAElB,6CAA6C;AAC/C;;AAEA;EACE;;;;;IAKE,aAAa;EACf;;EAEA;;;;;;IAME,cAAc;EAChB;AACF;;AAEA;EACE,gBAAgB;EAGhB,aAAa;EAEb,eAAe;EAGf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAGlB,aAAa;EAEb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;AACd;;AAEA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EAGE,yBAAyB;AAC3B;;AAEA;EAGE,QAAQ;EACR,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EAGE,yBAAyB;AAC3B;;AAEA;EAGE,QAAQ;EACR,mCAAmC;EACnC,sBAAsB;EACtB,iBAAiB;EAEjB,gCAAgC;AAClC;;AAEA;;;;;;EAME,0CAA0C;EAC1C,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;;;;;;;EAOE,qCAAqC;AACvC;;AAEA;EAGE,yBAAyB;AAC3B;;AAEA;;;;;EAOE,QAAQ;AACV;;AAEA;EAGE,QAAQ;AACV;;AAEA;EAGE,QAAQ;AACV;;AAEA;EAGE,QAAQ;AACV;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EAGE,aAAa;AACf;;AAEA;EAEE,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EAET,2BAA2B;EAC3B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,4CAA4C;EAC5C,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;EAEhB,oBAAoB;AACtB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EAEE,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kDAAkD;EAClD,qDAAqD;AACvD;;AAEA;EACE,qCAAqC;EACrC,eAAe;AACjB;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,0CAA0C;EAE1C,oBAAoB;AACtB;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,YAAY;IACZ,eAAe;IACf,aAAa;IAEb,6CAA6C;IAE7C,4BAA4B;IAC5B,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,mBAAmB;IAEnB,eAAe;EACjB;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EAGE,aAAa;EAGb,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,0CAA0C;EAE1C,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EAET,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,UAAU;EACV,0CAA0C;EAE1C,2BAA2B;EAE3B,oBAAoB;EACpB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EAEE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,eAAe;EAEf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAE3B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,QAAQ;EACR,cAAc;EACd,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,QAAQ;EACR,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;EACR,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAGE,iCAAiC;EACjC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EAGE,aAAa;EACb,WAAW;EAGX,uBAAuB;EAGvB,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,MAAM;IACN,SAAS;IACT,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,aAAa;IAEb,6CAA6C;IAE7C,2BAA2B;EAC7B;;EAEA;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YAAY;EACZ,WAAW;EACX,UAAU;EACV,aAAa;AACf;;AAEA;EAEE,6CAA6C;AAC/C;;AAEA;EACE;IACE,UAAU;IACV,WAAW;EACb;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EAGE,aAAa;EACb,gBAAgB;EAGhB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,WAAW;EAEX,iBAAiB;EAEjB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,kBAAkB;EAClB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,eAAe;EAEf,yBAAyB;AAC3B;;AAEA;EACE;IACE,0CAA0C;IAE1C,kDAAkD;IAClD,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAEhB,oBAAoB;EACpB,8BAA8B;EAC9B,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAE1C,kDAAkD;AACpD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;;;GAMG;;AAEH;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EAEjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,cAAc;EAEd,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,2CAA2C;EAE3C,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iCAAiC;EAEjC,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;;EAEE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EAEb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,MAAM;EACN,SAAS;EACT,uCAAuC;EACvC,UAAU;EAEV,yBAAyB;AAC3B;;AAEA;EACE,QAAQ;EACR,kBAAkB;EAClB,SAAS;EAET,gCAAgC;AAClC;;AAEA;EACE,UAAU;EACV,aAAa;EAEb,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,0CAA0C;EAE1C,0BAA0B;EAC1B,YAAY;AACd;;AAEA;;;;;GAKG;;AAEH;EACE,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAEhB,yBAAyB;AAC3B;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;EACP,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,YAAY;IACZ,eAAe;IACf,aAAa;IAEb,6CAA6C;IAE7C,4BAA4B;IAC5B,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,mBAAmB;IAEnB,eAAe;EACjB;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,eAAe;EACf,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,eAAe;IACf,MAAM;IACN,SAAS;IACT,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,aAAa;IAEb,6CAA6C;IAE7C,2BAA2B;EAC7B;;EAEA;IAEE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EAGb,aAAa;EAGb,uBAAuB;EAGvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA,4BAA4B;;AAE5B;EACE,kCAAkC;EAClC,oCAAoC;EACpC,wBAAwB;EACxB,wDAAwD;AAC1D;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;GAEG;;AAEH;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;;;EAGE,wDAAwD;AAC1D;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH;EACE;0CACwC;AAC1C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,wEAAwE;EACxE,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,oCAAoC;EACpC,2BAA2B;EAC3B,kCAAkC;EAClC,mFAAmF;EACnF,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;;EAKE,WAAW;EACX,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,uCAAuC;EACvC,uCAAuC;AACzC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,eAAe;AACjB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,kDAAkD;EAClD,wCAAwC;EACxC,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,0CAA0C;AAC5C;;AAEA;EACE,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,6CAA6C;EAC7C,uDAAuD;AACzD;;AAEA,oBAAoB;AACpB;EACE,YAAY;AACd;;AAEA;EACE,+CAA+C;EAC/C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC;;;cAGY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;;;;EAIE,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kDAAkD;EAClD,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,kDAAkD;EAClD,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,QAAQ;AACR;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,sDAAsD;AACxD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,gBAAgB;IAChB,YAAY;IACZ,YAAY;EACd;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,yBAAyB;AAC3B","sourcesContent":["@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap);\n@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap);\n\n@font-face {\n  font-family: hkgrotesk;\n  src: url(../fonts/hkgrotesk-light.eot);\n  src: local(\"hkgrotesk light\"),\n    url(../fonts/hkgrotesk-light.woff) format(\"woff\");\n  font-weight: 300;\n}\n\n@font-face {\n  font-family: hkgrotesk;\n  src: url(../fonts/hkgrotesk-regular.eot);\n  src: local(\"hkgrotesk regular\"),\n    url(../fonts/hkgrotesk-regular.woff) format(\"woff\");\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: hkgrotesk;\n  src: url(../fonts/hkgrotesk-medium.eot);\n  src: local(\"hkgrotesk medium\"),\n    url(../fonts/hkgrotesk-medium.woff) format(\"woff\");\n  font-weight: 500;\n}\n\n@font-face {\n  font-family: hkgrotesk;\n  src: url(../fonts/hkgrotesk-semibold.eot);\n  src: local(\"hkgrotesk semibold\"),\n    url(../fonts/hkgrotesk-semibold.woff) format(\"woff\");\n  font-weight: 600;\n}\n\n@font-face {\n  font-family: hkgrotesk;\n  src: url(../fonts/hkgrotesk-semibold.eot);\n  src: local(\"hkgrotesk bold\"), url(../fonts/hkgrotesk-bold.woff) format(\"woff\");\n  font-weight: 700;\n}\n\n:root {\n  --bs-vertical-menu-bg: #fff;\n  --bs-vertical-menu-item-color: #6d7080;\n  --bs-vertical-menu-item-hover-color: #4b38b3;\n  --bs-vertical-menu-item-active-color: #4b38b3;\n  --bs-vertical-menu-sub-item-color: #7c7f90;\n  --bs-vertical-menu-sub-item-hover-color: #4b38b3;\n  --bs-vertical-menu-sub-item-active-color: #4b38b3;\n  --bs-vertical-menu-title-color: #919da9;\n  --bs-vertical-menu-bg-dark: #f3f3f9;\n  --bs-vertical-menu-item-color-dark: #a3a6b7;\n  --bs-vertical-menu-item-hover-color-dark: #fff;\n  --bs-vertical-menu-item-active-color-dark: #fff;\n  --bs-vertical-menu-sub-item-color-dark: #a3a6b7;\n  --bs-vertical-menu-sub-item-hover-color-dark: #fff;\n  --bs-vertical-menu-sub-item-active-color-dark: #fff;\n  --bs-vertical-menu-title-color-dark: #6d7080;\n  --bs-header-bg: #fff;\n  --bs-header-item-color: #e9ecef;\n  --bs-header-bg-dark: #1c1c36;\n  --bs-header-item-color-dark: var(--bs-vertical-menu-item-color-dark);\n  --bs-topbar-search-bg: #f3f3f9;\n  --bs-topbar-user-bg: #f3f3f9;\n  --bs-topbar-user-bg-dark: #2a2a50;\n  --bs-footer-bg: #fff;\n  --bs-footer-color: #98a6ad;\n  --bs-topnav-bg: #fff;\n  --bs-topnav-item-color: #6d7080;\n  --bs-topnav-item-color-active: #4b38b3;\n  --bs-twocolumn-menu-iconview-bg: #fff;\n  --bs-twocolumn-menu-bg: #fff;\n  --bs-twocolumn-menu-iconview-bg-dark: var(--bs-vertical-menu-bg-dark);\n  --bs-twocolumn-menu-bg-dark: #1c1c36;\n  --bs-twocolumn-menu-item-color-dark: var(--bs-vertical-menu-item-color-dark);\n  --bs-twocolumn-menu-item-active-color-dark: #fff;\n  --bs-twocolumn-menu-item-active-bg-dark: rgba(255, 255, 255, 0.15);\n  --bs-boxed-body-bg: #e5e5ef;\n  --bs-heading-color: #495057;\n  --bs-box-shadow: 0 3px 3px rgba(56, 65, 74, 0.1);\n  --bs-link-color: #4b38b3;\n  --bs-link-hover-color: #4b38b3;\n  --bs-border-color: #e9ebec;\n  --bs-card-bg-custom: #fff;\n  --bs-card-logo-dark: block;\n  --bs-card-logo-light: none;\n  --bs-list-group-hover-bg: #f3f6f9;\n  --bs-input-bg: #fff;\n  --bs-input-border: #ced4da;\n  --bs-input-focus-border: #a59cd9;\n  --bs-input-disabled-bg: #eff2f7;\n  --bs-input-group-addon-bg: #eff2f7;\n  --bs-input-check-border: var(--bs-input-border);\n  --bs-body-font-size: 0.8125rem !important;\n  --bs-dropdown-font-size: 0.8125rem !important;\n}\n\n.h2,\nh2 {\n  font-size: calc(1.2875rem + 0.45vw) !important;\n}\n\n.btn-group-sm > .btn,\n.btn-sm {\n  --bs-btn-font-size: 0.7109375rem;\n  --bs-btn-border-radius: 0.2rem;\n}\n\n.h6,\nh6 {\n  font-size: 0.8125rem;\n}\n\n.h5,\nh5 {\n  font-size: 1.015625rem;\n}\n\n.h4,\nh4 {\n  font-size: 1.21875rem;\n}\n\n.dropdown-menu {\n  font-size: var(--bs-body-font-size);\n}\n\n.form-select,\n.input-group-text,\n.form-control {\n  font-size: 0.8125rem !important;\n}\n\n:root .nav-tabs {\n  --bs-nav-tabs-link-active-bg: #f2f2f7;\n}\n\n:root .choices,\n:root .ck,\n:root .flatpickr-calendar,\n:root .menu-dropdown,\n:root .ql-toolbar,\n:root .select2-container {\n  --bs-choices-bg: #fff;\n  --bs-choices-link-color: #212529;\n  --bs-choices-link-hover-bg: #f3f6f9;\n  --bs-choices-link-active-color: #1e2125;\n}\n\n[data-layout-mode=\"dark\"] {\n  --bs-gray-100: #1a1d21;\n  --bs-gray-200: #212529;\n  --bs-gray-300: #2a2f34;\n  --bs-gray-400: #878a99;\n  --bs-gray-500: #adb5bd;\n  --bs-gray-600: #bfc8e2;\n  --bs-gray-700: #ced4da;\n  --bs-gray-800: #eff2f7;\n  --bs-gray-900: #f3f6f9;\n  --bs-body-bg: #1a1d21;\n  --bs-body-bg-rgb: 26, 29, 33;\n  --bs-body-color: #ced4da;\n  --bs-body-color-rgb: 206, 212, 218;\n  --bs-vertical-menu-bg: #fff;\n  --bs-vertical-menu-item-color: #5f6270;\n  --bs-vertical-menu-item-hover-color: #4b38b3;\n  --bs-vertical-menu-item-active-color: #4b38b3;\n  --bs-vertical-menu-sub-item-color: #686b7b;\n  --bs-vertical-menu-sub-item-hover-color: #4b38b3;\n  --bs-vertical-menu-sub-item-active-color: #4b38b3;\n  --bs-vertical-menu-title-color: #878a99;\n  --bs-vertical-menu-bg-dark: #212529;\n  --bs-vertical-menu-item-color-dark: #878a99;\n  --bs-vertical-menu-item-hover-color-dark: #fff;\n  --bs-vertical-menu-item-active-color-dark: #fff;\n  --bs-vertical-menu-sub-item-color-dark: #7c7f90;\n  --bs-vertical-menu-sub-item-hover-color-dark: #fff;\n  --bs-vertical-menu-sub-item-active-color-dark: #fff;\n  --bs-vertical-menu-title-color-dark: #5f6270;\n  --bs-header-bg: #262a2f;\n  --bs-header-item-color: #e9ecef;\n  --bs-header-bg-dark: var(--bs-header-bg);\n  --bs-header-item-color-dark: var(--bs-header-item-color);\n  --bs-topbar-search-bg: #1a1d21;\n  --bs-topbar-user-bg: #2f343a;\n  --bs-topbar-user-bg-dark: #2f343a;\n  --bs-footer-bg: #23282c;\n  --bs-footer-color: #878a99;\n  --bs-topnav-bg: #272b30;\n  --bs-topnav-item-color: #878a99;\n  --bs-topnav-item-color-active: #fff;\n  --bs-twocolumn-menu-iconview-bg: #fff;\n  --bs-twocolumn-menu-bg: #fff;\n  --bs-twocolumn-menu-iconview-bg-dark: #1b1f22;\n  --bs-twocolumn-menu-bg-dark: var(--bs-vertical-menu-bg-dark);\n  --bs-twocolumn-menu-item-color-dark: var(--bs-vertical-menu-item-color-dark);\n  --bs-twocolumn-menu-item-active-color-dark: #fff;\n  --bs-twocolumn-menu-item-active-bg-dark: rgba(255, 255, 255, 0.15);\n  --bs-boxed-body-bg: #111316;\n  --bs-heading-color: #ced4da;\n  --bs-box-shadow: 0 3px 5px rgba(29, 35, 40, 0.15);\n  --bs-light: #2a2f34;\n  --bs-light-rgb: 42, 47, 52;\n  --bs-dark: #eff2f7;\n  --bs-dark-rgb: 239, 242, 247;\n  --bs-link-color: #ced4da;\n  --bs-link-hover-color: #ced4da;\n  --bs-border-color: #32383e;\n  --bs-card-bg-custom: #212529;\n  --bs-card-logo-dark: none;\n  --bs-card-logo-light: block;\n  --bs-list-group-hover-bg: #272b30;\n  --bs-input-bg: #262a2f;\n  --bs-input-border: #2a2f34;\n  --bs-input-focus-border: #33393f;\n  --bs-input-disabled-bg: #212529;\n  --bs-input-group-addon-bg: #2a2f34;\n  --bs-input-check-border: #33393f;\n  --bs-body-bg: #1a1d21;\n  --bs-card-list-hover: blue;\n}\n\n[data-layout-mode=\"dark\"] .list-group {\n  --bs-list-group-color: #ced4da;\n  --bs-list-group-bg: #212529;\n  --bs-list-group-border-color: var(--bs-border-color);\n}\n\n[data-layout-mode=\"dark\"] .form-check-input {\n  background-color: var(--bs-input-bg);\n  border: 1px solid var(--bs-input-check-border);\n}\n\n[data-layout-mode=\"dark\"] .dropdown-menu {\n  --bs-dropdown-bg: #272b30;\n  --bs-dropdown-link-color: #eff2f7;\n  --bs-dropdown-link-hover-color: #d7dade;\n  --bs-dropdown-link-hover-bg: #2f343a;\n  --bs-dropdown-border-width: 1px;\n  --bs-dropdown-link-active-bg: #2f343a;\n  --bs-dropdown-link-active-color: #adb5bd;\n}\n\n[data-layout-mode=\"dark\"] .choices,\n[data-layout-mode=\"dark\"] .ck,\n[data-layout-mode=\"dark\"] .flatpickr-calendar,\n[data-layout-mode=\"dark\"] .menu-dropdown,\n[data-layout-mode=\"dark\"] .ql-toolbar,\n[data-layout-mode=\"dark\"] .select2-container {\n  --bs-choices-bg: #292e33;\n  --bs-choices-link-color: #adb5bd;\n  --bs-choices-link-hover-bg: #2f343a;\n  --bs-choices-link-active-color: #dbdde0;\n}\n\n[data-layout-mode=\"dark\"] .btn-light {\n  --bs-btn-color: var(--bs-dark);\n  --bs-btn-bg: var(--bs-light);\n  --bs-btn-border-color: var(--bs-light);\n}\n\n[data-layout-mode=\"dark\"] .btn-outline-light {\n  --bs-btn-color: var(--bs-dark);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: var(--bs-light);\n}\n\n[data-layout-mode=\"dark\"] .btn-light,\n[data-layout-mode=\"dark\"] .btn-outline-light {\n  --bs-btn-hover-color: var(--bs-dark);\n  --bs-btn-hover-bg: rgba(var(--bs-light-rgb), 0.75);\n  --bs-btn-hover-border-color: rgba(var(--bs-light-rgb), 0.75);\n}\n\n[data-layout-mode=\"dark\"] .btn-dark {\n  --bs-btn-color: var(--bs-light);\n  --bs-btn-bg: var(--bs-dark);\n  --bs-btn-border-color: var(--bs-dark);\n}\n\n[data-layout-mode=\"dark\"] .btn-outline-dark {\n  --bs-btn-color: var(--bs-dark);\n  --bs-btn-bg: transparent;\n  --bs-btn-border-color: var(--bs-dark);\n}\n\n[data-layout-mode=\"dark\"] .btn-dark,\n[data-layout-mode=\"dark\"] .btn-outline-dark {\n  --bs-btn-hover-color: var(--bs-light);\n  --bs-btn-hover-bg: rgba(var(--bs-dark-rgb), 0.75);\n  --bs-btn-hover-border-color: rgba(var(--bs-dark-rgb), 0.75);\n}\n\n[data-layout-mode=\"dark\"] .card {\n  --bs-card-bg: #212529;\n  --bs-card-cap-bg: #212529;\n  color: var(--bs-heading-color);\n}\n\n[data-layout-mode=\"dark\"] .modal {\n  --bs-modal-bg: #212529;\n}\n\n[data-layout-mode=\"dark\"] .nav-tabs {\n  --bs-nav-tabs-link-active-color: #f3f6f9;\n  --bs-nav-tabs-link-active-bg: #2a2f34;\n}\n\n[data-layout-mode=\"dark\"] .accordion {\n  --bs-accordion-button-active-color: #fff;\n  --bs-accordion-bg: #212529;\n  --bs-accordion-btn-bg: #212529;\n}\n\n[data-layout-mode=\"dark\"] .offcanvas,\n[data-layout-mode=\"dark\"] .offcanvas-lg,\n[data-layout-mode=\"dark\"] .offcanvas-md,\n[data-layout-mode=\"dark\"] .offcanvas-sm,\n[data-layout-mode=\"dark\"] .offcanvas-xl,\n[data-layout-mode=\"dark\"] .offcanvas-xxl {\n  --bs-offcanvas-bg: #212529;\n}\n\n[data-layout-mode=\"dark\"] .progress {\n  --bs-progress-bg: #2a2f34;\n}\n\n.table {\n  font-family: \"Inter\", sans-serif !important;\n  font-size: 12px !important;\n  line-height: 1.5 !important;\n}\n\n[data-layout-mode=\"dark\"] .table {\n  --bs-table-striped-bg: rgba(255, 255, 255, 0.03);\n  --bs-table-active-bg: rgba(255, 255, 255, 0.07);\n  --bs-table-hover-bg: rgba(255, 255, 255, 0.07);\n  --bs-table-color: #ced4da;\n}\n\n[data-layout-mode=\"dark\"] .table-light {\n  --bs-table-color: #fff;\n  --bs-table-bg: rgba(255, 255, 255, 0.05);\n  --bs-table-border-color: var(--bs-border-color);\n  --bs-table-striped-bg: rgba(255, 255, 255, 0.07);\n  --bs-table-striped-color: #fff;\n}\n\n[data-layout-mode=\"dark\"] .toast {\n  --bs-toast-bg: rgba(42, 47, 52, 0.85);\n  --bs-toast-header-bg: rgba(42, 47, 52, 0.85);\n  --bs-toast-border-color: rgba(255, 255, 255, 0.1);\n  --bs-toast-header-border-color: rgba(255, 255, 255, 0.05);\n}\n\n[data-layout-mode=\"dark\"] .popover {\n  --bs-popover-bg: #23282c;\n}\n\n[data-layout-mode=\"dark\"] .pagination {\n  --bs-pagination-hover-bg: #2a2f34;\n  --bs-pagination-focus-bg: #2a2f34;\n  --bs-pagination-color: var(--bs-link-color);\n  --bs-pagination-bg: var(--bs-card-bg-custom);\n}\n\n[data-layout-mode=\"dark\"] .page-link {\n  border: none;\n}\n\n[data-layout-mode=\"dark\"] .css-1g0ym13-control {\n  background-color: transparent;\n}\n\n[data-layout-mode=\"dark\"]\n  .flatpickr-calendar.inline\n  .flatpickr-rContainer\n  .flatpickr-days\n  .dayContainer {\n  background-color: #292e33;\n}\n\n/* [data-layout-mode=dark] .list-group-item-action:focus, .list-group-item-action:hover {\n    background-color: var(--bs-card-list-hover);\n}\n[data-layout-mode=light] .list-group-item-action:focus, .list-group-item-action:hover {\n    background-color: #eef2f5;\n} */\n\n[data-sidebar=\"gradient\"] {\n  --bs-vertical-menu-bg-gradient: linear-gradient(\n    to right,\n    var(--bs-primary),\n    var(--bs-success)\n  );\n  --bs-vertical-menu-border-gradient: var(--bs-success);\n  --bs-twocolumn-menu-bg-dark: var(--bs-success);\n}\n\n[data-sidebar=\"gradient-2\"] {\n  --bs-vertical-menu-bg-gradient: linear-gradient(\n    to right,\n    var(--bs-info),\n    var(--bs-secondary)\n  );\n  --bs-vertical-menu-border-gradient: var(--bs-secondary);\n  --bs-twocolumn-menu-bg-dark: var(--bs-secondary);\n}\n\n[data-sidebar=\"gradient-3\"] {\n  --bs-vertical-menu-bg-gradient: linear-gradient(\n    to right,\n    var(--bs-info),\n    var(--bs-success)\n  );\n  --bs-vertical-menu-border-gradient: var(--bs-success);\n  --bs-twocolumn-menu-bg-dark: var(--bs-success);\n}\n\n[data-sidebar=\"gradient-4\"] {\n  --bs-vertical-menu-bg-gradient: linear-gradient(\n    to right,\n    #212529,\n    var(--bs-primary)\n  );\n  --bs-vertical-menu-border-gradient: var(--bs-primary);\n  --bs-twocolumn-menu-bg-dark: var(--bs-primary);\n}\n\n#page-topbar {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1002;\n  background-color: var(--bs-header-bg);\n  -webkit-transition: all 0.1s ease-out;\n  transition: all 0.1s ease-out;\n}\n\n#page-topbar.topbar-shadow {\n  -webkit-box-shadow: var(--bs-box-shadow);\n  box-shadow: var(--bs-box-shadow);\n}\n\n@media (min-width: 768px) {\n  #page-topbar {\n    left: 250px;\n  }\n}\n\n@media (max-width: 767px) {\n  .navbar-menu {\n    margin-top: 70px !important;\n  }\n}\n\n.navbar-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n  -webkit-box-pack: justify;\n  justify-content: space-between;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin: 0 auto;\n  height: 70px;\n  padding: 0 1.5rem 0 calc(1.5rem / 2);\n}\n\n@media (max-width: 767.98px) {\n  .navbar-header {\n    padding: 0 calc(1.5rem / 2) 0 calc(1.5rem / 2);\n  }\n}\n\n.navbar-header .topbar-head-dropdown .dropdown-menu.show {\n  top: 13px !important;\n}\n\n.navbar-header .btn-topbar {\n  height: 42px;\n  width: 42px;\n}\n\n@media (max-width: 360px) {\n  .navbar-header .btn-topbar {\n    height: 36px;\n    width: 36px;\n  }\n}\n\n.navbar-header .user-name-text {\n  color: var(--bs-gray-700);\n}\n\n.app-search {\n  padding: calc(32px / 2) 0;\n}\n\n.app-search .form-control {\n  border: none;\n  height: 38px;\n  padding-left: 40px;\n  padding-right: 30px;\n  background-color: var(--bs-topbar-search-bg);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.app-search .form-control::placeholder {\n  color: #878a99;\n  font-size: 15px;\n  font-weight: 400;\n}\n\n.app-search span.search-widget-icon {\n  position: absolute;\n  z-index: 10;\n  font-size: 18px;\n  line-height: 38px;\n  left: 13px;\n  top: 0;\n  color: #878a99;\n}\n\n.app-search .search-widget-icon-close {\n  right: 7px;\n  left: auto !important;\n}\n\n@media (max-width: 1023.99px) {\n  .app-search {\n    padding-left: calc(1.5rem / 2);\n  }\n}\n\n.megamenu-list li {\n  position: relative;\n  padding: 5px 0;\n}\n\n.megamenu-list li a {\n  color: var(--bs-body-color);\n}\n\n@media (max-width: 767.98px) {\n  .logo span.logo-lg {\n    display: none;\n  }\n\n  .logo span.logo-sm {\n    display: inline-block;\n  }\n}\n\n.header-item {\n  height: 70px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.header-profile-user {\n  height: 32px;\n  width: 32px;\n}\n\n.topbar-badge-sm {\n  right: 0;\n  top: 7px !important;\n}\n\n.topbar-badge {\n  right: -9px;\n  top: 4px !important;\n}\n\n.topbar-user .dropdown-menu {\n  top: 6px !important;\n}\n\n.notification-item {\n  padding: 0.75rem 1rem;\n  white-space: inherit;\n  position: relative;\n}\n\n.notification-item .form-check-input {\n  position: relative;\n  z-index: 2;\n}\n\n.dropdown-icon-item {\n  display: block;\n  border-radius: 3px;\n  line-height: 34px;\n  text-align: center;\n  padding: 15px 0 9px;\n  border: 1px solid transparent;\n  color: var(--bs-dropdown-link-color);\n}\n\n.dropdown-icon-item img {\n  height: 24px;\n}\n\n.dropdown-icon-item span {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dropdown-icon-item:hover {\n  background-color: var(--bs-dropdown-link-hover-bg);\n}\n\n.fullscreen-enable [data-toggle=\"fullscreen\"] .bx-fullscreen::before {\n  content: \"\\eacb\";\n}\n\n[data-layout-mode=\"dark\"] .light-dark-mode .bx-moon::before {\n  content: \"\\ec34\";\n}\n\n[data-topbar=\"dark\"] #page-topbar {\n  background-color: var(--bs-header-bg-dark);\n  border-color: var(--bs-header-bg-dark);\n}\n\n[data-topbar=\"dark\"] .navbar-header .btn-topbar {\n  color: var(--bs-header-item-color-dark);\n}\n\n[data-topbar=\"dark\"] .navbar-header .btn-topbar:focus,\n[data-topbar=\"dark\"] .navbar-header .btn-topbar:hover {\n  background-color: rgba(255, 255, 255, 0.07);\n  color: #fff;\n}\n\n[data-topbar=\"dark\"] .logo-dark {\n  display: none;\n}\n\n[data-topbar=\"dark\"] .logo-light {\n  display: inline-block;\n}\n\n[data-topbar=\"dark\"] .app-search .form-control {\n  background-color: rgba(255, 255, 255, 0.05);\n  color: #fff;\n}\n\n[data-topbar=\"dark\"] .app-search input.form-control::-webkit-input-placeholder,\n[data-topbar=\"dark\"] .app-search span.search-widget-icon {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n[data-topbar=\"dark\"] .hamburger-icon span {\n  background-color: #e9ebec;\n}\n\n@media (max-width: 600px) {\n  .navbar-header .dropdown {\n    position: static;\n  }\n\n  .navbar-header .dropdown .dropdown-menu {\n    width: 100%;\n  }\n}\n\n@media (max-width: 767.98px) {\n  #search-dropdown-reponsive {\n    top: 54px !important;\n  }\n}\n\n@media (min-width: 1024.1px) {\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"] #page-topbar {\n    left: 0 !important;\n    -webkit-box-shadow: var(--bs-box-shadow);\n    box-shadow: var(--bs-box-shadow);\n  }\n\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"] .horizontal-logo {\n    display: inline-block;\n    padding-left: 0;\n  }\n\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"] .topnav-hamburger {\n    visibility: hidden;\n  }\n\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"] .layout-width {\n    max-width: 95%;\n    margin: 0 auto;\n  }\n\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar-size=\"sm-hover\"]\n    .navbar-brand-box,\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar-size=\"sm\"]\n    .navbar-brand-box {\n    background-color: transparent !important;\n    position: relative;\n    width: auto;\n    text-align: left;\n  }\n\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar-size=\"sm-hover\"]\n    .navbar-brand-box\n    .logo-sm,\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar-size=\"sm\"]\n    .navbar-brand-box\n    .logo-sm {\n    display: none;\n  }\n\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar-size=\"sm-hover\"]\n    .navbar-brand-box\n    .logo-lg,\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar-size=\"sm\"]\n    .navbar-brand-box\n    .logo-lg {\n    display: block;\n  }\n}\n\n[data-layout=\"vertical\"][data-layout-style=\"detached\"][data-topbar=\"dark\"]\n  .horizontal-logo\n  .logo-dark {\n  display: none;\n}\n\n[data-layout=\"vertical\"][data-layout-style=\"detached\"][data-topbar=\"dark\"]\n  .horizontal-logo\n  .logo-light {\n  display: block;\n}\n\n[data-layout=\"horizontal\"] #page-topbar {\n  left: 0;\n  border-bottom: 1px solid var(--bs-gray-300);\n}\n\n@media (min-width: 1024.1px) {\n  [data-layout=\"horizontal\"] #page-topbar.topbar-shadow {\n    -webkit-box-shadow: none;\n    box-shadow: none;\n  }\n}\n\n[data-layout=\"horizontal\"] .page-content {\n  padding: calc(45px + 1.5rem) calc(1.5rem / 2) 60px calc(1.5rem / 2);\n}\n\n@media (min-width: 1024.1px) {\n  [data-layout=\"horizontal\"] .page-content {\n    margin-top: 70px;\n  }\n}\n\n@media (min-width: 1024.1px) {\n  [data-layout=\"horizontal\"][data-layout-width=\"boxed\"] .page-content {\n    min-height: calc(100vh - 130px);\n  }\n}\n\n@media (min-width: 768px) {\n  [data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"] #page-topbar,\n  [data-layout=\"vertical\"][data-sidebar-size=\"sm\"] #page-topbar {\n    left: 70px;\n  }\n}\n\n@media (min-width: 768px) {\n  [data-layout=\"vertical\"][data-sidebar-size=\"md\"] #page-topbar {\n    left: 180px;\n  }\n}\n\n@media (min-width: 768px) {\n  [data-layout=\"twocolumn\"] #page-topbar {\n    left: calc(70px + 220px);\n  }\n}\n\n[data-layout=\"twocolumn\"] .horizontal-logo {\n  display: none;\n}\n\n.page-title-box {\n  padding: 10px 1.5rem;\n  background-color: var(--bs-card-bg-custom);\n  -webkit-box-shadow: var(--bs-box-shadow);\n  box-shadow: var(--bs-box-shadow);\n  border-bottom: 1px solid none;\n  border-top: 1px solid none;\n  margin: -23px -1.5rem 1.5rem -1.5rem;\n}\n\n.page-title-box .breadcrumb {\n  background-color: transparent;\n  padding: 0;\n}\n\n.page-title-box h4 {\n  font-weight: 700;\n  font-size: 15px !important;\n  text-transform: uppercase;\n}\n\n[data-layout=\"horizontal\"] .page-title-box {\n  padding: 1.2rem 0;\n  background-color: transparent !important;\n  border-bottom: none;\n  border-top: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  margin: 0;\n}\n\n@media (min-width: 1024.1px) {\n  [data-layout=\"horizontal\"] .page-title-box {\n    margin: -19px 0 0 0;\n  }\n}\n\n[data-layout=\"vertical\"][data-layout-style=\"detached\"] .page-title-box {\n  padding: 1.2rem 0;\n  background-color: transparent !important;\n  border-bottom: none;\n  border-top: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  margin: 0;\n}\n\n@media (min-width: 1024.1px) {\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"] .page-title-box {\n    margin: -19px 0 0 0;\n  }\n}\n\n.footer {\n  /* bottom: 0; */\n  padding: 20px calc(1.5rem * 0.5);\n  /* position: absolute; */\n  /* right: 0; */\n  color: var(--bs-footer-color);\n  /* left: 250px; */\n  height: 60px;\n  background-color: var(--bs-footer-bg);\n}\n\n@media (max-width: 991.98px) {\n  .footer {\n    left: 0;\n  }\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"] .footer,\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"] .footer {\n  left: 70px;\n}\n\n@media (max-width: 767.98px) {\n  [data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"] .footer,\n  [data-layout=\"vertical\"][data-sidebar-size=\"sm\"] .footer {\n    left: 0;\n  }\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"md\"] .footer {\n  left: 180px;\n}\n\n@media (max-width: 991.98px) {\n  [data-layout=\"vertical\"][data-sidebar-size=\"md\"] .footer {\n    left: 0;\n  }\n}\n\n[data-layout=\"horizontal\"] .footer {\n  left: 0 !important;\n}\n\n@media (min-width: 1024.1px) {\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"] .footer {\n    left: 0 !important;\n    background-color: transparent;\n  }\n}\n\n@media (min-width: 768.1px) {\n  [data-layout=\"twocolumn\"] .footer {\n    left: calc(70px + 220px);\n  }\n}\n\n.app-content {\n  margin-left: 250px;\n  overflow: hidden;\n}\n\n.app-content .content {\n  padding: 0 15px 10px 15px;\n  margin-top: 70px;\n}\n\n.main-content {\n  -webkit-transition: all 0.1s ease-out;\n  transition: all 0.1s ease-out;\n  /* background-color: #f3f3f9 !important; */\n}\n\n@media (min-width: 768px) {\n  .main-content {\n    margin-left: 250px;\n  }\n}\n\n.page-content {\n  padding: calc(70px + 1.5rem) calc(1.5rem * 0.5) 60px calc(1.5rem * 0.5);\n}\n\n.navbar-menu {\n  width: 250px;\n  z-index: 1002;\n  /* background: var(--bs-vertical-menu-bg); */\n  /* border-right: 1px solid #fff; */\n  bottom: 0;\n  margin-top: 0;\n  position: fixed;\n  top: 0;\n  -webkit-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);\n  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);\n  padding: 0 0 calc(70px + 25px) 0;\n  -webkit-transition: all 0.1s ease-out;\n  transition: all 0.1s ease-out;\n}\n\n.navbar-menu .navbar-nav .nav-link {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  padding: 6px 1.5rem;\n  color: var(--bs-vertical-menu-item-color);\n  font-size: 0.925rem;\n  font-family: Inter, sans-serif;\n}\n\n.navbar-menu .navbar-nav .nav-link.active {\n  color: var(--bs-vertical-menu-item-active-color);\n}\n\n.navbar-menu .navbar-nav .nav-link:hover {\n  color: var(--bs-vertical-menu-item-hover-color);\n}\n\n.navbar-menu .navbar-nav .nav-link i {\n  display: inline-block;\n  min-width: 1.75rem;\n  font-size: 18px;\n  line-height: inherit;\n}\n\n.navbar-menu .navbar-nav .nav-link svg {\n  width: 18px;\n  margin-right: 0.665rem;\n  color: var(--bs-vertical-menu-item-color);\n}\n\n.navbar-menu .navbar-nav .nav-link .badge {\n  margin-left: auto;\n  margin-right: -2px;\n  z-index: 1;\n}\n\n.navbar-menu .navbar-nav .nav-link:hover {\n  color: var(--bs-vertical-menu-item-hover-color);\n}\n\n.navbar-menu .navbar-nav .nav-link:hover .icon-dual {\n  color: var(--bs-vertical-menu-item-hover-color);\n  fill: rgba(75, 56, 179, 0.16);\n}\n\n.navbar-menu .navbar-nav .nav-link[data-bs-toggle=\"collapse\"]:after {\n  display: block;\n  content: \"\\f0142\";\n  font-family: \"Material Design Icons\";\n  margin-left: auto;\n  -webkit-transition: -webkit-transform 0.2s;\n  transition: -webkit-transform 0.2s;\n  transition: transform 0.2s;\n  transition: transform 0.2s, -webkit-transform 0.2s;\n  font-size: 1.05rem;\n  position: absolute;\n  right: 18px;\n  color: var(--bs-vertical-menu-title-color);\n}\n\n.navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"] {\n  color: var(--bs-vertical-menu-item-active-color);\n}\n\n.navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]\n  .icon-dual {\n  color: var(--bs-vertical-menu-item-hover-color);\n  fill: rgba(75, 56, 179, 0.16);\n}\n\n.navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]:after {\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n  color: var(--bs-vertical-menu-item-active-color);\n}\n\n.navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]:before {\n  opacity: 1;\n  background-color: var(--bs-vertical-menu-item-active-color);\n}\n\n.navbar-menu .navbar-nav .nav-link.collapsed.active::after {\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.navbar-menu .navbar-nav .nav-sm {\n  padding-left: 1.75rem;\n}\n\n.navbar-menu .navbar-nav .nav-sm .nav-link {\n  padding: 0.55rem 1.5rem !important;\n  color: var(--bs-vertical-menu-sub-item-color);\n  white-space: none;\n  position: relative;\n  font-size: 0.8125rem;\n  font-family: Inter, sans-serif;\n}\n\n.navbar-menu .navbar-nav .nav-sm .nav-link:before {\n  content: \"\";\n  width: 6px;\n  height: 1.5px;\n  background-color: var(--bs-vertical-menu-sub-item-color);\n  position: absolute;\n  left: 2px;\n  top: 16.5px;\n  -webkit-transition: all 0.4s ease-in-out;\n  transition: all 0.4s ease-in-out;\n  opacity: 0.5;\n}\n\n.navbar-menu .navbar-nav .nav-sm .nav-link:hover {\n  color: var(--bs-vertical-menu-sub-item-hover-color);\n}\n\n.navbar-menu .navbar-nav .nav-sm .nav-link:hover:before {\n  background-color: var(--bs-vertical-menu-sub-item-hover-color) !important;\n  opacity: 1;\n}\n\n.navbar-menu .navbar-nav .nav-sm .nav-link.active {\n  color: var(--bs-vertical-menu-item-active-color);\n}\n\n.navbar-menu .navbar-nav .nav-sm .nav-link.active:before {\n  background-color: var(--bs-vertical-menu-item-active-color);\n}\n\n.navbar-menu .navbar-nav .nav-sm .nav-sm {\n  padding-left: 15px;\n}\n\n.navbar-menu .navbar-nav .nav-sm .nav-sm .nav-link:before {\n  height: 5px;\n  width: 5px;\n  left: 5px;\n  border-radius: 50%;\n  background-color: transparent;\n  border: 1px solid;\n  top: 16px;\n}\n\n.navbar-menu .btn-vertical-sm-hover {\n  color: #878a99;\n  display: none;\n}\n\n.navbar-brand-box {\n  padding: 0 1.3rem;\n  text-align: center;\n  -webkit-transition: all 0.1s ease-out;\n  transition: all 0.1s ease-out;\n}\n\n@media (max-width: 767.98px) {\n  .navbar-brand-box {\n    display: none;\n  }\n}\n\n.hamburger-icon {\n  width: 20px;\n  height: 14px;\n  position: relative;\n  cursor: pointer;\n  display: inline-block;\n}\n\n.hamburger-icon span {\n  background-color: #878a99;\n  position: absolute;\n  border-radius: 2px;\n  -webkit-transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);\n  transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);\n  width: 100%;\n  height: 2px;\n  display: block;\n  left: 0;\n}\n\n.hamburger-icon span:nth-child(1) {\n  top: 0;\n  width: 80%;\n}\n\n.hamburger-icon span:nth-child(2) {\n  top: 6px;\n}\n\n.hamburger-icon span:nth-child(3) {\n  bottom: 0;\n  width: 60%;\n}\n\n.vertical-menu-btn:hover .hamburger-icon:not(.open) span:nth-child(1) {\n  top: -1px;\n}\n\n.vertical-menu-btn:hover .hamburger-icon:not(.open) span:nth-child(3) {\n  bottom: -1px;\n}\n\n.hamburger-icon.open {\n  -webkit-transform: rotate(-90deg);\n  transform: rotate(-90deg);\n}\n\n.hamburger-icon.open span:nth-child(1) {\n  left: 1px;\n  top: 5px;\n  width: 20px;\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n  -webkit-transition-delay: 150ms;\n  transition-delay: 150ms;\n}\n\n.hamburger-icon.open span:nth-child(2) {\n  left: 3px;\n  top: 13px;\n  width: 10px;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  -webkit-transition-delay: 50ms;\n  transition-delay: 50ms;\n}\n\n.hamburger-icon.open span:nth-child(3) {\n  left: 9px;\n  top: 13px;\n  width: 10px;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  -webkit-transition-delay: 0.1s;\n  transition-delay: 0.1s;\n}\n\n.logo {\n  line-height: 70px;\n}\n\n.logo .logo-sm {\n  display: none;\n}\n\n.logo-light {\n  display: none;\n}\n\n[data-layout=\"vertical\"] .app-menu .row {\n  margin: 0;\n}\n\n[data-layout=\"vertical\"] .app-menu .row > * {\n  width: 100%;\n  padding: 0;\n}\n\n@media (max-width: 767.98px) {\n  [data-layout=\"vertical\"] .app-menu {\n    margin-left: -100%;\n    padding: 10px 0 20px 0;\n  }\n}\n\n[data-layout=\"vertical\"] .navbar-menu .container-fluid {\n  padding: 0;\n}\n\n@media (max-width: 767.98px) {\n  [data-layout=\"vertical\"] .navbar-brand-box {\n    display: none;\n  }\n}\n\n[data-layout=\"vertical\"] .horizontal-logo {\n  display: none;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"] .main-content {\n  margin-left: 70px;\n}\n\n@media (max-width: 767.98px) {\n  [data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"] .main-content {\n    margin-left: 0;\n  }\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"] .logo span.logo-lg {\n  display: none;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"] .logo span.logo-sm {\n  display: inline-block;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"] .btn-vertical-sm-hover {\n  display: inline-block;\n}\n\n@media (min-width: 768px) {\n  [data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"] .topnav-hamburger {\n    display: none;\n  }\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"] .navbar-menu {\n  width: 70px;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu\n  .btn-vertical-sm-hover {\n  display: none;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu\n  .btn-vertical-sm-hover\n  i.ri-record-circle-line:before {\n  content: \"\\eb7d\";\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu\n  .navbar-nav\n  .badge {\n  display: none;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu\n  .navbar-nav\n  .menu-title {\n  text-align: center;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu\n  .navbar-nav\n  .menu-title\n  span {\n  display: none;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu\n  .navbar-nav\n  .menu-title\n  i {\n  display: block;\n  line-height: 36px;\n  font-size: 1rem;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link\n  span {\n  display: none;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link\n  i {\n  font-size: 22px;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link\n  i.lab,\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link\n  i.lar,\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link\n  i.las {\n  font-size: 24px;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link\n  svg {\n  margin-right: 0;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link:after,\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link:before {\n  display: none;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu\n  .navbar-nav\n  .menu-dropdown {\n  display: none;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"] .navbar-menu:hover {\n  width: 250px !important;\n}\n\n@media (min-width: 1024.99px) {\n  [data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n    .navbar-menu:hover\n    .btn-vertical-sm-hover {\n    display: inline-block;\n  }\n\n  [data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n    .navbar-menu:hover\n    .navbar-brand-box {\n    text-align: left;\n  }\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu:hover\n  .navbar-nav\n  .menu-dropdown.show {\n  display: block;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu:hover\n  .nav-link\n  i {\n  font-size: 18px;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu:hover\n  .nav-link\n  i.lab,\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu:hover\n  .nav-link\n  i.lar,\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu:hover\n  .nav-link\n  i.las {\n  font-size: 20px;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu:hover\n  .nav-link\n  svg {\n  margin-right: 0.665rem;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu:hover\n  .nav-link\n  span,\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu:hover\n  .nav-link:after,\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu:hover\n  .nav-link:before {\n  display: inline-block;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu:hover\n  .logo\n  span.logo-lg {\n  display: inline-block;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu:hover\n  .logo\n  span.logo-sm {\n  display: none;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu:hover\n  .menu-title {\n  text-align: left;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu:hover\n  .menu-title\n  span {\n  display: inline-block;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"]\n  .navbar-menu:hover\n  .menu-title\n  i {\n  display: none;\n}\n\n@media (min-width: 1025px) {\n  [data-layout=\"vertical\"][data-sidebar-size=\"sm-hover-active\"] .navbar-header,\n  [data-layout=\"vertical\"][data-sidebar-size=\"sm-hover\"] .navbar-header {\n    padding-left: 1.5rem;\n  }\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover-active\"]\n  .navbar-brand-box {\n  text-align: left;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover-active\"]\n  .topnav-hamburger {\n  display: none;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm-hover-active\"]\n  .btn-vertical-sm-hover {\n  display: inline-block;\n}\n\n@media (min-width: 768px) {\n  [data-layout=\"vertical\"][data-sidebar-size=\"sm\"] {\n    min-height: 1400px;\n  }\n\n  [data-layout=\"vertical\"][data-sidebar-size=\"sm\"] .main-content {\n    margin-left: 70px;\n  }\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"] #page-topbar {\n  z-index: calc(1002 + 1);\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"] .navbar-brand-box {\n  position: fixed;\n  padding: 0;\n  width: 70px;\n  z-index: 1;\n  top: 0;\n  /* background: var(--bs-vertical-menu-bg) */\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"] .logo span.logo-lg {\n  display: none;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"] .logo span.logo-sm {\n  display: inline-block;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"] .navbar-menu {\n  position: fixed;\n  width: 70px !important;\n  padding-top: 70px;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .simplebar-content-wrapper,\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"] .navbar-menu .simplebar-mask {\n  overflow: visible !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .simplebar-scrollbar,\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .vertical-menu-btn {\n  display: none !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .simplebar-offset {\n  bottom: 0 !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .badge {\n  display: none !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .menu-title {\n  text-align: center;\n  font-size: 1rem;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .menu-title\n  span {\n  display: none;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .menu-title\n  i {\n  display: block;\n  line-height: 36px;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link\n  span {\n  display: none;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link\n  i {\n  font-size: 22px;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link\n  svg {\n  margin-right: 0;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link:after,\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link:before {\n  display: none;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .menu-dropdown {\n  display: none;\n  height: auto !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item {\n  position: relative;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item:hover\n  > a.menu-link {\n  position: relative;\n  width: calc(200px + 70px);\n  color: #6d7080;\n  background-color: var(--bs-vertical-menu-bg-dark);\n  -webkit-transition: none;\n  transition: none;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item:hover\n  > a.menu-link\n  .icon-dual {\n  color: var(--bs-vertical-menu-item-hover-color-dark);\n  fill: rgba(255, 255, 255, 0.16);\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item:hover\n  > a.menu-link\n  span {\n  display: inline-block;\n  padding-left: 25px;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item:hover\n  > a.menu-link:after {\n  display: block;\n  -webkit-transform: rotate(90deg);\n  transform: rotate(90deg);\n  color: var(--bs-body-color);\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item:hover\n  > .menu-dropdown {\n  display: block;\n  left: 70px;\n  position: absolute;\n  width: 200px;\n  /* background: var(--bs-vertical-menu-bg); */\n  height: auto !important;\n  padding: 0.5rem 0;\n  border-radius: 0 0 3px 3px;\n  -webkit-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);\n  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);\n}\n\n[data-layout-mode=\"light\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item:hover\n  > .menu-dropdown {\n  background-color: #fff !important;\n}\n\n[data-layout-mode=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item:hover\n  > .menu-dropdown {\n  background-color: #262a2f !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm {\n  padding: 0;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-item:hover\n  > .nav-link {\n  color: var(--bs-vertical-menu-item-hover-color);\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-item:hover\n  > .nav-link:after {\n  color: inherit;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link:after {\n  display: block !important;\n  -webkit-transform: rotate(0) !important;\n  transform: rotate(0) !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .menu-dropdown {\n  left: 100% !important;\n  top: 0;\n  border-radius: 3px !important;\n}\n\n@media (min-width: 768px) {\n  [data-layout=\"vertical\"][data-sidebar-size=\"md\"] .main-content {\n    margin-left: 180px;\n  }\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"md\"] .navbar-brand-box {\n  width: 180px;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"md\"] .navbar-menu {\n  width: 180px !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"md\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link {\n  display: block;\n  text-align: center;\n  padding: 0.55rem 0.525rem;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"md\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link\n  i {\n  display: block;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"md\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link\n  svg {\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"md\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link:before {\n  display: none !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"md\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"]:after {\n  position: relative;\n  display: inline-block;\n  right: 0;\n  top: 3px;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"md\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link.menu-link[data-bs-toggle=\"collapse\"]:after {\n  display: none;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"md\"]\n  .navbar-menu\n  .navbar-nav\n  .badge {\n  display: none !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"md\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm {\n  padding-left: 0;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"md\"] .navbar-menu .menu-title {\n  text-align: center;\n}\n\n[data-layout=\"vertical\"][data-sidebar-size=\"md\"] .navbar-menu .menu-title span {\n  text-decoration: underline;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"] .navbar-menu {\n  background: var(--bs-vertical-menu-bg-dark);\n  border-right: 1px solid var(--bs-vertical-menu-bg-dark);\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .hamburger-icon\n  span {\n  background-color: var(--bs-vertical-menu-item-color-dark);\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .btn-vertical-sm-hover {\n  color: var(--bs-vertical-menu-item-color-dark);\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"] .navbar-nav .nav-link {\n  color: var(--bs-vertical-menu-item-color-dark);\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"] .navbar-nav .nav-link.active {\n  color: var(--bs-vertical-menu-item-active-color-dark);\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"]:after {\n  color: inherit;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"] {\n  color: var(--bs-vertical-menu-item-active-color-dark);\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]:after {\n  color: inherit;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]\n  .icon-dual {\n  color: var(--bs-vertical-menu-item-active-color-dark);\n  fill: rgba(255, 255, 255, 0.1);\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"] .navbar-nav .nav-link svg {\n  color: var(--bs-vertical-menu-item-color-dark);\n  fill: rgba(255, 255, 255, 0.1);\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"] .navbar-nav .nav-link:hover {\n  color: var(--bs-vertical-menu-item-hover-color-dark);\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-nav\n  .nav-link:hover\n  .icon-dual {\n  color: var(--bs-vertical-menu-item-hover-color-dark);\n  fill: rgba(255, 255, 255, 0.16);\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-nav\n  > .nav-item\n  .nav-link.active {\n  color: var(--bs-vertical-menu-item-active-color-dark);\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-nav\n  > .nav-item\n  .nav-link.active\n  .icon-dual {\n  color: var(--bs-vertical-menu-item-hover-color-dark);\n  fill: rgba(255, 255, 255, 0.16);\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"] .navbar-nav .nav-sm .nav-link {\n  color: var(--bs-vertical-menu-sub-item-color-dark);\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-nav\n  .nav-sm\n  .nav-link:before {\n  background-color: var(--bs-vertical-menu-sub-item-color-dark) !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-nav\n  .nav-sm\n  .nav-link:hover {\n  color: var(--bs-vertical-menu-item-hover-color-dark);\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-nav\n  .nav-sm\n  .nav-link:hover:before {\n  background-color: var(--bs-vertical-menu-item-hover-color-dark) !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-nav\n  .nav-sm\n  .nav-link.active {\n  color: var(--bs-vertical-menu-item-active-color-dark);\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-nav\n  .nav-sm\n  .nav-sm\n  .nav-link:before {\n  background-color: transparent !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-nav\n  .nav-sm\n  .nav-sm\n  .nav-link:hover:before {\n  background-color: var(--bs-vertical-menu-item-hover-color-dark) !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-nav\n  .nav-sm\n  .nav-sm\n  .nav-link.active {\n  color: var(--bs-vertical-menu-item-active-color-dark);\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"]\n  .navbar-nav\n  .nav-sm\n  .nav-sm\n  .nav-link.active:before {\n  background-color: var(--bs-vertical-menu-item-active-color-dark) !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"][data-sidebar-size=\"sm\"]\n  .navbar-brand-box {\n  background: var(--bs-vertical-menu-bg-dark);\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item:hover\n  > .menu-dropdown {\n  background: var(--bs-vertical-menu-bg-dark);\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm {\n  padding: 0;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link:after {\n  display: block !important;\n  -webkit-transform: rotate(0) !important;\n  transform: rotate(0) !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-item:hover\n  > .nav-link {\n  color: var(--bs-vertical-menu-item-active-color-dark);\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-item:hover\n  > .nav-link:after {\n  color: inherit;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .menu-dropdown {\n  left: 100% !important;\n  top: 0;\n  border-radius: 3px !important;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"] .menu-title {\n  color: var(--bs-vertical-menu-title-color-dark);\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"] .logo-dark {\n  display: none;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"dark\"] .logo-light {\n  display: inline-block;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"light\"] .logo-dark {\n  display: inline-block;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"light\"] .logo-light {\n  display: none;\n}\n\n[data-layout=\"vertical\"][data-layout-style=\"detached\"] #layout-wrapper,\n[data-layout=\"vertical\"][data-layout-style=\"detached\"] .main-content {\n  min-height: 100vh;\n}\n\n@media (min-width: 1024.1px) {\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"] .main-content {\n    position: relative;\n  }\n\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"] #layout-wrapper {\n    max-width: 95%;\n    margin: 0 auto;\n    padding-left: 1.5rem;\n  }\n\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"] .navbar-header {\n    padding-left: 1.5rem;\n  }\n\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"] .navbar-menu {\n    top: calc(70px + 1.5rem);\n    bottom: 1.5rem;\n    padding: 0;\n    border-right: var(--bs-vertical-menu-bg);\n    border-radius: 5px;\n    padding: 10px 0;\n    z-index: 1;\n  }\n\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"]\n    .navbar-menu\n    .navbar-brand-box {\n    display: none;\n  }\n\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar=\"dark\"]\n    .logo-dark,\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar=\"gradient-2\"]\n    .logo-dark,\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar=\"gradient-3\"]\n    .logo-dark,\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar=\"gradient-4\"]\n    .logo-dark,\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar=\"gradient\"]\n    .logo-dark {\n    display: inline-block;\n  }\n\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar=\"dark\"]\n    .logo-light,\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar=\"gradient-2\"]\n    .logo-light,\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar=\"gradient-3\"]\n    .logo-light,\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar=\"gradient-4\"]\n    .logo-light,\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar=\"gradient\"]\n    .logo-light {\n    display: none;\n  }\n}\n\n[data-layout=\"vertical\"][data-layout-style=\"detached\"] .footer {\n  border-top: 1px dashed var(--bs-border-color);\n}\n\n[data-layout=\"vertical\"][data-layout-style=\"detached\"]\n  .auth-page-wrapper\n  .footer {\n  border-top: none;\n}\n\n@media (min-width: 768px) {\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar-size=\"sm\"]\n    #layout-wrapper,\n  [data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar-size=\"sm\"]\n    .main-content {\n    min-height: 1400px;\n  }\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"gradient-2\"] .logo-dark,\n[data-layout=\"vertical\"][data-sidebar=\"gradient-3\"] .logo-dark,\n[data-layout=\"vertical\"][data-sidebar=\"gradient-4\"] .logo-dark,\n[data-layout=\"vertical\"][data-sidebar=\"gradient\"] .logo-dark {\n  display: none;\n}\n\n[data-layout=\"vertical\"][data-sidebar=\"gradient-2\"] .logo-light,\n[data-layout=\"vertical\"][data-sidebar=\"gradient-3\"] .logo-light,\n[data-layout=\"vertical\"][data-sidebar=\"gradient-4\"] .logo-light,\n[data-layout=\"vertical\"][data-sidebar=\"gradient\"] .logo-light {\n  display: inline-block;\n}\n\n.menu-title {\n  letter-spacing: 0.05em;\n  cursor: default;\n  font-size: 11px;\n  text-transform: uppercase;\n  color: var(--bs-vertical-menu-title-color);\n  font-weight: 600;\n}\n\n.menu-title span {\n  padding: 12px 20px;\n  display: inline-block;\n}\n\n.menu-title i {\n  display: none;\n}\n\n.vertical-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(33, 37, 41, 0.35);\n  z-index: 1003;\n  display: none;\n}\n\n.vertical-sidebar-enable .vertical-overlay {\n  display: block;\n}\n\n.vertical-sidebar-enable .app-menu {\n  margin-left: 0 !important;\n  z-index: 1004;\n}\n\n[dir=\"rtl\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"]:after {\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n[dir=\"rtl\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]:after {\n  -webkit-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n[data-sidebar=\"gradient-2\"] .navbar-menu,\n[data-sidebar=\"gradient-3\"] .navbar-menu,\n[data-sidebar=\"gradient-4\"] .navbar-menu,\n[data-sidebar=\"gradient\"] .navbar-menu {\n  background: var(--bs-vertical-menu-bg-gradient);\n  border-right: 1px solid var(--bs-vertical-menu-border-gradient);\n}\n\n[data-sidebar=\"gradient-2\"] .navbar-menu .hamburger-icon span,\n[data-sidebar=\"gradient-3\"] .navbar-menu .hamburger-icon span,\n[data-sidebar=\"gradient-4\"] .navbar-menu .hamburger-icon span,\n[data-sidebar=\"gradient\"] .navbar-menu .hamburger-icon span {\n  background-color: rgba(255, 255, 255, 0.5);\n}\n\n[data-sidebar=\"gradient-2\"] .navbar-menu .btn-vertical-sm-hover,\n[data-sidebar=\"gradient-3\"] .navbar-menu .btn-vertical-sm-hover,\n[data-sidebar=\"gradient-4\"] .navbar-menu .btn-vertical-sm-hover,\n[data-sidebar=\"gradient\"] .navbar-menu .btn-vertical-sm-hover {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n[data-sidebar=\"gradient-2\"] .navbar-nav .nav-link,\n[data-sidebar=\"gradient-3\"] .navbar-nav .nav-link,\n[data-sidebar=\"gradient-4\"] .navbar-nav .nav-link,\n[data-sidebar=\"gradient\"] .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n[data-sidebar=\"gradient-2\"] .navbar-nav .nav-link.active,\n[data-sidebar=\"gradient-3\"] .navbar-nav .nav-link.active,\n[data-sidebar=\"gradient-4\"] .navbar-nav .nav-link.active,\n[data-sidebar=\"gradient\"] .navbar-nav .nav-link.active {\n  color: var(--bs-vertical-menu-item-active-color-dark);\n}\n\n[data-sidebar=\"gradient-2\"]\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"]:after,\n[data-sidebar=\"gradient-3\"]\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"]:after,\n[data-sidebar=\"gradient-4\"]\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"]:after,\n[data-sidebar=\"gradient\"]\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"]:after {\n  color: inherit;\n}\n\n[data-sidebar=\"gradient-2\"]\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"],\n[data-sidebar=\"gradient-3\"]\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"],\n[data-sidebar=\"gradient-4\"]\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"],\n[data-sidebar=\"gradient\"]\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"] {\n  color: var(--bs-vertical-menu-item-active-color-dark);\n}\n\n[data-sidebar=\"gradient-2\"]\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]:after,\n[data-sidebar=\"gradient-3\"]\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]:after,\n[data-sidebar=\"gradient-4\"]\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]:after,\n[data-sidebar=\"gradient\"]\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]:after {\n  color: inherit;\n}\n\n[data-sidebar=\"gradient-2\"]\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]\n  .icon-dual,\n[data-sidebar=\"gradient-3\"]\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]\n  .icon-dual,\n[data-sidebar=\"gradient-4\"]\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]\n  .icon-dual,\n[data-sidebar=\"gradient\"]\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]\n  .icon-dual {\n  color: var(--bs-vertical-menu-item-active-color-dark);\n  fill: rgba(255, 255, 255, 0.1);\n}\n\n[data-sidebar=\"gradient-2\"] .navbar-nav .nav-link svg,\n[data-sidebar=\"gradient-3\"] .navbar-nav .nav-link svg,\n[data-sidebar=\"gradient-4\"] .navbar-nav .nav-link svg,\n[data-sidebar=\"gradient\"] .navbar-nav .nav-link svg {\n  color: rgba(255, 255, 255, 0.5);\n  fill: rgba(255, 255, 255, 0.1);\n}\n\n[data-sidebar=\"gradient-2\"] .navbar-nav .nav-link:hover,\n[data-sidebar=\"gradient-3\"] .navbar-nav .nav-link:hover,\n[data-sidebar=\"gradient-4\"] .navbar-nav .nav-link:hover,\n[data-sidebar=\"gradient\"] .navbar-nav .nav-link:hover {\n  color: var(--bs-vertical-menu-item-hover-color-dark);\n}\n\n[data-sidebar=\"gradient-2\"] .navbar-nav .nav-link:hover .icon-dual,\n[data-sidebar=\"gradient-3\"] .navbar-nav .nav-link:hover .icon-dual,\n[data-sidebar=\"gradient-4\"] .navbar-nav .nav-link:hover .icon-dual,\n[data-sidebar=\"gradient\"] .navbar-nav .nav-link:hover .icon-dual {\n  color: var(--bs-vertical-menu-item-hover-color-dark);\n  fill: rgba(255, 255, 255, 0.16);\n}\n\n[data-sidebar=\"gradient-2\"] .navbar-nav > .nav-item .nav-link.active,\n[data-sidebar=\"gradient-3\"] .navbar-nav > .nav-item .nav-link.active,\n[data-sidebar=\"gradient-4\"] .navbar-nav > .nav-item .nav-link.active,\n[data-sidebar=\"gradient\"] .navbar-nav > .nav-item .nav-link.active {\n  color: var(--bs-vertical-menu-item-active-color-dark);\n}\n\n[data-sidebar=\"gradient-2\"] .navbar-nav > .nav-item .nav-link.active .icon-dual,\n[data-sidebar=\"gradient-3\"] .navbar-nav > .nav-item .nav-link.active .icon-dual,\n[data-sidebar=\"gradient-4\"] .navbar-nav > .nav-item .nav-link.active .icon-dual,\n[data-sidebar=\"gradient\"] .navbar-nav > .nav-item .nav-link.active .icon-dual {\n  color: var(--bs-vertical-menu-item-hover-color-dark);\n  fill: rgba(255, 255, 255, 0.16);\n}\n\n[data-sidebar=\"gradient-2\"] .navbar-nav .nav-sm .nav-link,\n[data-sidebar=\"gradient-3\"] .navbar-nav .nav-sm .nav-link,\n[data-sidebar=\"gradient-4\"] .navbar-nav .nav-sm .nav-link,\n[data-sidebar=\"gradient\"] .navbar-nav .nav-sm .nav-link {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n[data-sidebar=\"gradient-2\"] .navbar-nav .nav-sm .nav-link:before,\n[data-sidebar=\"gradient-3\"] .navbar-nav .nav-sm .nav-link:before,\n[data-sidebar=\"gradient-4\"] .navbar-nav .nav-sm .nav-link:before,\n[data-sidebar=\"gradient\"] .navbar-nav .nav-sm .nav-link:before {\n  background-color: rgba(255, 255, 255, 0.5) !important;\n}\n\n[data-sidebar=\"gradient-2\"] .navbar-nav .nav-sm .nav-link:hover,\n[data-sidebar=\"gradient-3\"] .navbar-nav .nav-sm .nav-link:hover,\n[data-sidebar=\"gradient-4\"] .navbar-nav .nav-sm .nav-link:hover,\n[data-sidebar=\"gradient\"] .navbar-nav .nav-sm .nav-link:hover {\n  color: var(--bs-vertical-menu-item-hover-color-dark);\n}\n\n[data-sidebar=\"gradient-2\"] .navbar-nav .nav-sm .nav-link:hover:before,\n[data-sidebar=\"gradient-3\"] .navbar-nav .nav-sm .nav-link:hover:before,\n[data-sidebar=\"gradient-4\"] .navbar-nav .nav-sm .nav-link:hover:before,\n[data-sidebar=\"gradient\"] .navbar-nav .nav-sm .nav-link:hover:before {\n  background-color: var(--bs-vertical-menu-item-hover-color-dark) !important;\n}\n\n[data-sidebar=\"gradient-2\"] .navbar-nav .nav-sm .nav-link.active,\n[data-sidebar=\"gradient-3\"] .navbar-nav .nav-sm .nav-link.active,\n[data-sidebar=\"gradient-4\"] .navbar-nav .nav-sm .nav-link.active,\n[data-sidebar=\"gradient\"] .navbar-nav .nav-sm .nav-link.active {\n  color: var(--bs-vertical-menu-item-active-color-dark);\n}\n\n[data-sidebar=\"gradient-2\"] .navbar-nav .nav-sm .nav-sm .nav-link:before,\n[data-sidebar=\"gradient-3\"] .navbar-nav .nav-sm .nav-sm .nav-link:before,\n[data-sidebar=\"gradient-4\"] .navbar-nav .nav-sm .nav-sm .nav-link:before,\n[data-sidebar=\"gradient\"] .navbar-nav .nav-sm .nav-sm .nav-link:before {\n  background-color: transparent !important;\n}\n\n[data-sidebar=\"gradient-2\"] .navbar-nav .nav-sm .nav-sm .nav-link:hover:before,\n[data-sidebar=\"gradient-3\"] .navbar-nav .nav-sm .nav-sm .nav-link:hover:before,\n[data-sidebar=\"gradient-4\"] .navbar-nav .nav-sm .nav-sm .nav-link:hover:before,\n[data-sidebar=\"gradient\"] .navbar-nav .nav-sm .nav-sm .nav-link:hover:before {\n  background-color: var(--bs-vertical-menu-item-hover-color-dark) !important;\n}\n\n[data-sidebar=\"gradient-2\"] .navbar-nav .nav-sm .nav-sm .nav-link.active,\n[data-sidebar=\"gradient-3\"] .navbar-nav .nav-sm .nav-sm .nav-link.active,\n[data-sidebar=\"gradient-4\"] .navbar-nav .nav-sm .nav-sm .nav-link.active,\n[data-sidebar=\"gradient\"] .navbar-nav .nav-sm .nav-sm .nav-link.active {\n  color: var(--bs-vertical-menu-item-active-color-dark);\n}\n\n[data-sidebar=\"gradient-2\"] .navbar-nav .nav-sm .nav-sm .nav-link.active:before,\n[data-sidebar=\"gradient-3\"] .navbar-nav .nav-sm .nav-sm .nav-link.active:before,\n[data-sidebar=\"gradient-4\"] .navbar-nav .nav-sm .nav-sm .nav-link.active:before,\n[data-sidebar=\"gradient\"] .navbar-nav .nav-sm .nav-sm .nav-link.active:before {\n  background-color: var(--bs-vertical-menu-item-active-color-dark) !important;\n}\n\n[data-sidebar=\"gradient-2\"][data-sidebar-size=\"sm\"] .navbar-brand-box,\n[data-sidebar=\"gradient-3\"][data-sidebar-size=\"sm\"] .navbar-brand-box,\n[data-sidebar=\"gradient-4\"][data-sidebar-size=\"sm\"] .navbar-brand-box,\n[data-sidebar=\"gradient\"][data-sidebar-size=\"sm\"] .navbar-brand-box {\n  background: var(--bs-vertical-menu-bg-gradient);\n}\n\n[data-sidebar=\"gradient-2\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item:hover\n  > .menu-dropdown,\n[data-sidebar=\"gradient-3\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item:hover\n  > .menu-dropdown,\n[data-sidebar=\"gradient-4\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item:hover\n  > .menu-dropdown,\n[data-sidebar=\"gradient\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item:hover\n  > .menu-dropdown {\n  background: var(--bs-vertical-menu-bg-dark);\n}\n\n[data-sidebar=\"gradient-2\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm,\n[data-sidebar=\"gradient-3\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm,\n[data-sidebar=\"gradient-4\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm,\n[data-sidebar=\"gradient\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm {\n  padding: 0;\n}\n\n[data-sidebar=\"gradient-2\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link:after,\n[data-sidebar=\"gradient-3\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link:after,\n[data-sidebar=\"gradient-4\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link:after,\n[data-sidebar=\"gradient\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link:after {\n  display: block !important;\n  -webkit-transform: rotate(0) !important;\n  transform: rotate(0) !important;\n}\n\n[data-sidebar=\"gradient-2\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-item:hover\n  > .nav-link,\n[data-sidebar=\"gradient-3\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-item:hover\n  > .nav-link,\n[data-sidebar=\"gradient-4\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-item:hover\n  > .nav-link,\n[data-sidebar=\"gradient\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-item:hover\n  > .nav-link {\n  color: var(--bs-vertical-menu-item-active-color-dark);\n}\n\n[data-sidebar=\"gradient-2\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-item:hover\n  > .nav-link:after,\n[data-sidebar=\"gradient-3\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-item:hover\n  > .nav-link:after,\n[data-sidebar=\"gradient-4\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-item:hover\n  > .nav-link:after,\n[data-sidebar=\"gradient\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-item:hover\n  > .nav-link:after {\n  color: inherit;\n}\n\n[data-sidebar=\"gradient-2\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .menu-dropdown,\n[data-sidebar=\"gradient-3\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .menu-dropdown,\n[data-sidebar=\"gradient-4\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .menu-dropdown,\n[data-sidebar=\"gradient\"][data-sidebar-size=\"sm\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .menu-dropdown {\n  left: 100% !important;\n  top: 0;\n  border-radius: 3px !important;\n}\n\n[data-sidebar=\"gradient-2\"][data-sidebar-size=\"sm\"][data-layout=\"vertical\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item:hover\n  > a.menu-link,\n[data-sidebar=\"gradient-3\"][data-sidebar-size=\"sm\"][data-layout=\"vertical\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item:hover\n  > a.menu-link,\n[data-sidebar=\"gradient-4\"][data-sidebar-size=\"sm\"][data-layout=\"vertical\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item:hover\n  > a.menu-link,\n[data-sidebar=\"gradient\"][data-sidebar-size=\"sm\"][data-layout=\"vertical\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-item:hover\n  > a.menu-link {\n  background: var(--bs-vertical-menu-bg-gradient);\n}\n\n[data-sidebar=\"gradient-2\"] .menu-title,\n[data-sidebar=\"gradient-3\"] .menu-title,\n[data-sidebar=\"gradient-4\"] .menu-title,\n[data-sidebar=\"gradient\"] .menu-title {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.bg-vertical-gradient {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(var(--bs-primary)),\n    to(var(--bs-success))\n  );\n  background: linear-gradient(to right, var(--bs-primary), var(--bs-success));\n}\n\n.bg-vertical-gradient-2 {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(var(--bs-info)),\n    to(var(--bs-secondary))\n  );\n  background: linear-gradient(to right, var(--bs-info), var(--bs-secondary));\n}\n\n.bg-vertical-gradient-3 {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(var(--bs-info)),\n    to(var(--bs-success))\n  );\n  background: linear-gradient(to right, var(--bs-info), var(--bs-success));\n}\n\n.bg-vertical-gradient-4 {\n  background: -webkit-gradient(\n    linear,\n    left top,\n    right top,\n    from(var(--bs-dark)),\n    to(var(--bs-primary))\n  );\n  background: linear-gradient(to right, var(--bs-dark), var(--bs-primary));\n}\n\n.sidebar-background {\n  position: absolute;\n  z-index: -1;\n  height: 100%;\n  width: 100%;\n  display: block;\n  top: 0;\n  left: 0;\n  background-size: cover;\n  background-position: 50%;\n  opacity: 0.07;\n}\n\n[data-layout=\"horizontal\"] .main-content {\n  margin-left: 0;\n}\n\n@media (min-width: 1024.1px) {\n  [data-layout=\"horizontal\"] .container-fluid,\n  [data-layout=\"horizontal\"] .layout-width {\n    max-width: 90%;\n    margin: 0 auto;\n  }\n\n  [data-layout=\"horizontal\"] .topnav-hamburger {\n    visibility: hidden;\n  }\n}\n\n[data-layout=\"horizontal\"] .horizontal-logo {\n  padding-left: calc(1.5rem / 2);\n}\n\n@media (max-width: 1024.98px) {\n  [data-layout=\"horizontal\"] .horizontal-logo {\n    padding-left: 1.5rem;\n  }\n}\n\n[data-layout=\"horizontal\"] .navbar-menu {\n  background: var(--bs-topnav-bg);\n  border-right-color: transparent;\n  padding: 0 calc(1.5rem / 2);\n  -webkit-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);\n  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);\n  margin-top: 70px;\n  position: fixed;\n  left: 0;\n  right: 0;\n  z-index: 100;\n  width: 100%;\n  bottom: auto;\n}\n\n@media (max-width: 575.98px) {\n  [data-layout=\"horizontal\"] .navbar-menu .container-fluid {\n    padding: 0;\n  }\n}\n\n[data-layout=\"horizontal\"] .navbar-menu .navbar-nav {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n[data-layout=\"horizontal\"] .navbar-menu .navbar-nav .nav-sm {\n  padding-left: 0;\n}\n\n[data-layout=\"horizontal\"] .navbar-menu .navbar-nav .nav-sm .nav-link:before {\n  opacity: 0 !important;\n}\n\n[data-layout=\"horizontal\"] .navbar-menu .navbar-nav .nav-sm .nav-link.active,\n[data-layout=\"horizontal\"] .navbar-menu .navbar-nav .nav-sm .nav-link:hover {\n  color: var(--bs-topnav-item-color-active);\n}\n\n[data-layout=\"horizontal\"] .navbar-menu .navbar-nav .nav-link {\n  color: var(--bs-topnav-item-color);\n  padding: 0.75rem 1.5rem;\n}\n\n[data-layout=\"horizontal\"] .navbar-menu .navbar-nav .nav-link i {\n  line-height: 1;\n}\n\n[data-layout=\"horizontal\"] .navbar-menu .navbar-nav .nav-link.active {\n  color: var(--bs-topnav-item-color-active);\n}\n\n[data-layout=\"horizontal\"] .navbar-menu .navbar-nav .nav-link.active:after {\n  color: var(--bs-topnav-item-color-active);\n}\n\n[data-layout=\"horizontal\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link.active\n  .icon-dual {\n  color: var(--bs-topnav-item-color-active);\n  fill: rgba(75, 56, 179, 0.1);\n}\n\n[data-layout=\"horizontal\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"] {\n  color: var(--bs-topnav-item-color-active);\n}\n\n[data-layout=\"horizontal\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]\n  .icon-dual {\n  color: var(--bs-topnav-item-color-active);\n  fill: rgba(75, 56, 179, 0.1);\n}\n\n[data-layout=\"horizontal\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]:after {\n  color: var(--bs-topnav-item-color-active);\n}\n\n[data-layout=\"horizontal\"] .navbar-menu .navbar-nav .nav-link:hover .icon-dual {\n  color: var(--bs-topnav-item-color-active);\n  fill: rgba(75, 56, 179, 0.1);\n}\n\n[data-layout=\"horizontal\"]\n  .navbar-menu\n  .navbar-nav\n  > .nav-item\n  > .nav-link[data-bs-toggle=\"collapse\"]:after {\n  right: 0;\n  -webkit-transform: rotate(90deg) !important;\n  transform: rotate(90deg) !important;\n}\n\n[data-layout=\"horizontal\"]\n  .navbar-menu\n  .navbar-nav\n  > li:nth-of-type(2)\n  > .nav-link.menu-link {\n  padding-left: 0;\n}\n\n[data-layout=\"horizontal\"] .navbar-menu .navbar-brand-box {\n  display: none;\n}\n\n[data-layout=\"horizontal\"] .navbar-nav .nav-item {\n  position: relative;\n}\n\n[data-layout=\"horizontal\"]\n  .navbar-nav\n  .nav-item\n  .nav-link[data-bs-toggle=\"collapse\"]:after {\n  right: 10px;\n  -webkit-transform: rotate(0) !important;\n  transform: rotate(0) !important;\n}\n\n[data-layout=\"horizontal\"] .navbar-nav .nav-item > .nav-link > .badge {\n  display: none;\n}\n\n[data-layout=\"horizontal\"] .navbar-nav .nav-item:hover > .nav-link {\n  color: var(--bs-topnav-item-color-active);\n}\n\n[data-layout=\"horizontal\"] .navbar-nav .nav-item:hover > .nav-link .icon-dual {\n  color: var(--bs-topnav-item-color-active);\n  fill: rgba(75, 56, 179, 0.1);\n}\n\n[data-layout=\"horizontal\"] .navbar-nav .nav-item:hover > .nav-link:after {\n  color: var(--bs-topnav-item-color-active);\n}\n\n@media (min-width: 1024.1px) {\n  [data-layout=\"horizontal\"] .navbar-nav .nav-item:hover > .menu-dropdown {\n    display: block;\n    height: auto !important;\n  }\n}\n\n[data-layout=\"horizontal\"] .navbar-nav .nav-item.active {\n  color: var(--bs-topnav-item-color-active);\n}\n\n[data-layout=\"horizontal\"] .menu-dropdown {\n  position: absolute;\n  min-width: 12rem;\n  padding: 0.5rem 0;\n  -webkit-box-shadow: 0 0 5px rgba(15, 34, 58, 0.15);\n  box-shadow: 0 0 5px rgba(15, 34, 58, 0.15);\n  -webkit-animation-name: DropDownSlide;\n  animation-name: DropDownSlide;\n  -webkit-animation-duration: 0.3s;\n  animation-duration: 0.3s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  margin: 0;\n  z-index: 1000;\n  background-color: var(--bs-choices-bg);\n  background-clip: padding-box;\n  border: 0 solid var(--bs-border-color);\n  border-radius: 0.3rem;\n  display: none;\n}\n\n[data-layout=\"horizontal\"] .menu-dropdown .menu-dropdown {\n  top: 0;\n  left: 100%;\n}\n\n[data-layout=\"horizontal\"] .mega-dropdown-menu {\n  width: 40rem;\n}\n\n[data-layout=\"horizontal\"] .menu-title {\n  display: none;\n}\n\n[data-layout=\"horizontal\"] .dropdown-custom-right {\n  left: -100% !important;\n  right: 100%;\n}\n\n@media (max-width: 1024px) {\n  [data-layout=\"horizontal\"] .navbar-menu {\n    display: none;\n  }\n}\n\n@media (max-width: 1024px) {\n  [data-layout=\"horizontal\"] .menu .navbar-menu {\n    display: block;\n    max-height: 360px;\n    overflow-y: auto;\n    padding-left: 0;\n  }\n\n  [data-layout=\"horizontal\"] .menu .navbar-menu .navbar-nav {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n  }\n\n  [data-layout=\"horizontal\"]\n    .menu\n    .navbar-menu\n    .navbar-nav\n    > li:nth-of-type(2)\n    > .nav-link.menu-link {\n    padding-left: 1.5rem;\n  }\n\n  [data-layout=\"horizontal\"]\n    .menu\n    .navbar-menu\n    .navbar-nav\n    .nav-sm\n    .nav-link:before {\n    opacity: 1 !important;\n  }\n\n  [data-layout=\"horizontal\"] .menu .menu-dropdown {\n    position: relative;\n    min-width: 100%;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n    padding-left: 28px;\n    left: 0;\n    -webkit-animation: none;\n    animation: none;\n    padding-top: 0;\n  }\n\n  [data-layout=\"horizontal\"] .menu .menu-dropdown.show {\n    display: block;\n  }\n\n  [data-layout=\"horizontal\"] .menu .dropdown-custom-right {\n    left: 0 !important;\n  }\n\n  [data-layout=\"horizontal\"]\n    .menu\n    .nav-item\n    .nav-link[data-bs-toggle=\"collapse\"]:after {\n    right: 0;\n  }\n\n  [data-layout=\"horizontal\"] .menu .mega-dropdown-menu {\n    width: 100%;\n  }\n}\n\n[data-layout-mode=\"dark\"][data-topbar=\"light\"]\n  .navbar-header\n  .horizontal-logo\n  .logo-dark {\n  display: none;\n}\n\n[data-layout-mode=\"dark\"][data-topbar=\"light\"]\n  .navbar-header\n  .horizontal-logo\n  .logo-light {\n  display: block;\n}\n\n[dir=\"rtl\"][data-layout=\"horizontal\"]\n  .navbar-menu\n  .navbar-nav\n  > .nav-item\n  > .nav-link[data-bs-toggle=\"collapse\"]:after {\n  -webkit-transform: rotate(-90deg) !important;\n  transform: rotate(-90deg) !important;\n}\n\n[dir=\"rtl\"][data-layout=\"horizontal\"]\n  .navbar-nav\n  .nav-item\n  .nav-link[data-bs-toggle=\"collapse\"]:after {\n  -webkit-transform: rotate(-180deg) !important;\n  transform: rotate(-180deg) !important;\n}\n\n[data-layout=\"twocolumn\"] .app-menu {\n  padding-bottom: 0;\n  width: 220px;\n  left: 70px;\n}\n\n[data-layout=\"twocolumn\"] .app-menu .menu-link {\n  letter-spacing: 0.05em;\n  cursor: default;\n  font-size: 11px;\n  text-transform: uppercase;\n  color: var(--bs-vertical-menu-title-color) !important;\n  font-weight: 600;\n}\n\n[data-layout=\"twocolumn\"] .app-menu .menu-link:after {\n  display: none !important;\n}\n\n[data-layout=\"twocolumn\"] .app-menu .menu-link i {\n  display: none;\n}\n\n[data-layout=\"twocolumn\"] .app-menu .navbar-nav {\n  height: calc(100vh - 70px);\n}\n\n@media (max-width: 767.98px) {\n  [data-layout=\"twocolumn\"] .app-menu .navbar-nav {\n    padding-top: 16px;\n  }\n}\n\n[data-layout=\"twocolumn\"] .app-menu .navbar-nav > li:not(.twocolumn-item-show) {\n  display: none;\n}\n\n[data-layout=\"twocolumn\"] .app-menu .navbar-nav .twocolumn-item-show > div {\n  display: block !important;\n  height: auto !important;\n}\n\n[data-layout=\"twocolumn\"] .app-menu .navbar-nav > .nav-item > .menu-dropdown {\n  display: block !important;\n  height: auto !important;\n}\n\n[data-layout=\"twocolumn\"] .app-menu .navbar-nav .nav-item .menu-dropdown .row {\n  margin: 0;\n}\n\n[data-layout=\"twocolumn\"]\n  .app-menu\n  .navbar-nav\n  .nav-item\n  .menu-dropdown\n  .row\n  .col-lg-4 {\n  width: 100%;\n  padding: 0;\n}\n\n[data-layout=\"twocolumn\"] .app-menu .navbar-nav .nav-sm .nav-link {\n  color: var(--bs-vertical-menu-item-color);\n}\n\n[data-layout=\"twocolumn\"] .app-menu .navbar-nav .nav-sm .nav-link.active {\n  color: var(--bs-vertical-menu-item-active-color);\n}\n\n[data-layout=\"twocolumn\"] .app-menu .container-fluid {\n  padding: 0;\n}\n\n[data-layout=\"twocolumn\"] .main-content {\n  margin-left: calc(220px + 70px);\n}\n\n@media (max-width: 767.98px) {\n  [data-layout=\"twocolumn\"] .main-content {\n    margin-left: 70px;\n  }\n}\n\n[data-layout=\"twocolumn\"] .twocolumn-iconview {\n  width: 70px;\n  background-color: var(--bs-twocolumn-menu-iconview-bg);\n  height: 100%;\n  left: -70px;\n  -webkit-box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);\n  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);\n  top: 0;\n  position: absolute;\n  padding: 0;\n  text-align: center;\n}\n\n[data-layout=\"twocolumn\"] .twocolumn-iconview li {\n  position: relative;\n}\n\n[data-layout=\"twocolumn\"] .twocolumn-iconview li .nav-icon::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n[data-layout=\"twocolumn\"] .twocolumn-iconview .nav-icon {\n  width: 42px;\n  height: 42px;\n  line-height: 42px;\n  color: var(--bs-vertical-menu-item-color);\n  z-index: 1;\n  font-size: 22px;\n  text-align: center;\n  border-radius: 3px;\n  margin: 5px 0;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n[data-layout=\"twocolumn\"] .twocolumn-iconview .nav-icon .icon-dual {\n  width: 18px;\n  color: var(--bs-vertical-menu-item-color);\n}\n\n[data-layout=\"twocolumn\"] .twocolumn-iconview .nav-icon.active {\n  background-color: rgba(75, 56, 179, 0.15);\n  color: #4b38b3;\n}\n\n[data-layout=\"twocolumn\"] .twocolumn-iconview .nav-icon.active .icon-dual {\n  color: #4b38b3;\n  fill: rgba(75, 56, 179, 0.1);\n}\n\n[data-layout=\"twocolumn\"] .menu-title {\n  display: none;\n}\n\n@media (max-width: 991.98px) {\n  [data-layout=\"twocolumn\"] .logo span.logo-lg {\n    display: block;\n  }\n\n  [data-layout=\"twocolumn\"] .logo span.logo-sm {\n    display: none;\n  }\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"light\"]\n  .app-menu\n  .navbar-brand-box\n  .logo-light {\n  display: none;\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"light\"]\n  .app-menu\n  .navbar-brand-box\n  .logo-dark {\n  display: block;\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"dark\"] .twocolumn-iconview {\n  background-color: var(--bs-twocolumn-menu-iconview-bg-dark);\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"dark\"] .twocolumn-iconview .nav-icon {\n  color: var(--bs-twocolumn-menu-item-color-dark);\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"dark\"]\n  .twocolumn-iconview\n  .nav-icon.active {\n  color: var(--bs-twocolumn-menu-item-active-color-dark);\n  background-color: var(--bs-twocolumn-menu-item-active-bg-dark);\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"dark\"] .app-menu {\n  background-color: var(--bs-twocolumn-menu-bg-dark);\n  border-right-color: var(--bs-twocolumn-menu-bg-dark);\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"dark\"]\n  .app-menu\n  .navbar-brand-box\n  .logo-light {\n  display: block;\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"dark\"]\n  .app-menu\n  .navbar-brand-box\n  .logo-dark {\n  display: none;\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"dark\"]\n  .app-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link {\n  color: var(--bs-twocolumn-menu-item-color-dark);\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link.active,\n[data-layout=\"twocolumn\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link:hover {\n  color: var(--bs-twocolumn-menu-item-active-color-dark);\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link.active::before,\n[data-layout=\"twocolumn\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link:hover::before {\n  background-color: var(--bs-twocolumn-menu-item-active-color-dark) !important;\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"] {\n  color: var(--bs-twocolumn-menu-item-active-color-dark);\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]:before {\n  background-color: var(--bs-twocolumn-menu-item-active-color-dark);\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]::after {\n  color: var(--bs-twocolumn-menu-item-active-color-dark) !important;\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-2\"] .twocolumn-iconview,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-3\"] .twocolumn-iconview,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-4\"] .twocolumn-iconview,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient\"] .twocolumn-iconview {\n  background-color: var(--bs-twocolumn-menu-iconview-bg-dark);\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-2\"]\n  .twocolumn-iconview\n  .nav-icon,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-3\"]\n  .twocolumn-iconview\n  .nav-icon,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-4\"]\n  .twocolumn-iconview\n  .nav-icon,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient\"]\n  .twocolumn-iconview\n  .nav-icon {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-2\"]\n  .twocolumn-iconview\n  .nav-icon.active,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-3\"]\n  .twocolumn-iconview\n  .nav-icon.active,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-4\"]\n  .twocolumn-iconview\n  .nav-icon.active,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient\"]\n  .twocolumn-iconview\n  .nav-icon.active {\n  color: var(--bs-twocolumn-menu-item-active-color-dark);\n  background-color: var(--bs-twocolumn-menu-item-active-bg-dark);\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-2\"] .app-menu,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-3\"] .app-menu,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-4\"] .app-menu,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient\"] .app-menu {\n  background-color: var(--bs-twocolumn-menu-bg-dark);\n  border-right-color: var(--bs-twocolumn-menu-bg-dark);\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-2\"]\n  .app-menu\n  .navbar-brand-box\n  .logo-light,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-3\"]\n  .app-menu\n  .navbar-brand-box\n  .logo-light,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-4\"]\n  .app-menu\n  .navbar-brand-box\n  .logo-light,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient\"]\n  .app-menu\n  .navbar-brand-box\n  .logo-light {\n  display: block;\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-2\"]\n  .app-menu\n  .navbar-brand-box\n  .logo-dark,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-3\"]\n  .app-menu\n  .navbar-brand-box\n  .logo-dark,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-4\"]\n  .app-menu\n  .navbar-brand-box\n  .logo-dark,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient\"]\n  .app-menu\n  .navbar-brand-box\n  .logo-dark {\n  display: none;\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-2\"]\n  .app-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-3\"]\n  .app-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-4\"]\n  .app-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient\"]\n  .app-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-2\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link.active,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-2\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link:hover,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-3\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link.active,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-3\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link:hover,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-4\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link.active,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-4\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link:hover,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link.active,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link:hover {\n  color: var(--bs-twocolumn-menu-item-active-color-dark);\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-2\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link.active::before,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-2\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link:hover::before,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-3\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link.active::before,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-3\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link:hover::before,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-4\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link.active::before,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-4\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link:hover::before,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link.active::before,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-link:hover::before {\n  background-color: var(--bs-twocolumn-menu-item-active-color-dark) !important;\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-2\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"],\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-3\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"],\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-4\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"],\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"] {\n  color: var(--bs-twocolumn-menu-item-active-color-dark);\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-2\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]:before,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-3\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]:before,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-4\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]:before,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]:before {\n  background-color: var(--bs-twocolumn-menu-item-active-color-dark);\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-2\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]::after,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-3\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]::after,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-4\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]::after,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"]::after {\n  color: var(--bs-twocolumn-menu-item-active-color-dark) !important;\n}\n\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-2\"][data-layout-mode=\"dark\"]\n  .app-menu,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-3\"][data-layout-mode=\"dark\"]\n  .app-menu,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient-4\"][data-layout-mode=\"dark\"]\n  .app-menu,\n[data-layout=\"twocolumn\"][data-sidebar=\"gradient\"][data-layout-mode=\"dark\"]\n  .app-menu {\n  border-right-color: #495057;\n}\n\n[data-layout=\"twocolumn\"] .twocolumn-panel .app-menu {\n  width: 0;\n  border-right: 0;\n}\n\n@media (max-width: 575.98px) {\n  [data-layout=\"twocolumn\"] .twocolumn-panel .app-menu {\n    display: none;\n  }\n}\n\n[data-layout=\"twocolumn\"] .twocolumn-panel .navbar-brand-box,\n[data-layout=\"twocolumn\"] .twocolumn-panel .navbar-nav {\n  display: none;\n}\n\n[data-layout=\"twocolumn\"] .twocolumn-panel .main-content {\n  margin-left: 70px;\n}\n\n[data-layout=\"twocolumn\"] .twocolumn-panel #page-topbar,\n[data-layout=\"twocolumn\"] .twocolumn-panel .footer {\n  left: 70px;\n}\n\n@media (max-width: 575.98px) {\n  [data-layout=\"twocolumn\"] .twocolumn-panel .main-content {\n    margin-left: 0;\n  }\n\n  [data-layout=\"twocolumn\"] .twocolumn-panel #page-topbar,\n  [data-layout=\"twocolumn\"] .twocolumn-panel .footer {\n    left: 0;\n  }\n}\n\n@media (max-width: 767.98px) {\n  [data-layout=\"twocolumn\"] #page-topbar,\n  [data-layout=\"twocolumn\"] .footer {\n    left: 70px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  [data-layout=\"twocolumn\"] .main-content {\n    margin-left: 0;\n  }\n\n  [data-layout=\"twocolumn\"] #page-topbar,\n  [data-layout=\"twocolumn\"] .footer {\n    left: 0;\n  }\n}\n\n[data-layout-width=\"boxed\"] body {\n  background-color: var(--bs-boxed-body-bg);\n}\n\n[data-layout-width=\"boxed\"] #layout-wrapper {\n  max-width: 1300px;\n  margin: 0 auto;\n  -webkit-box-shadow: var(--bs-box-shadow);\n  box-shadow: var(--bs-box-shadow);\n  background-color: var(--bs-body-bg);\n}\n\n[data-layout-width=\"boxed\"][data-layout=\"vertical\"] #layout-wrapper {\n  min-height: 100vh;\n}\n\n[data-layout-width=\"boxed\"] #page-topbar,\n[data-layout-width=\"boxed\"] .footer {\n  max-width: 1300px;\n  margin: 0 auto;\n  left: 0 !important;\n}\n\n@media (min-width: 768px) {\n  [data-layout-width=\"boxed\"][data-sidebar-size=\"sm-hover\"][data-layout=\"vertical\"]\n    #layout-wrapper,\n  [data-layout-width=\"boxed\"][data-sidebar-size=\"sm\"][data-layout=\"vertical\"]\n    #layout-wrapper {\n    min-height: 1400px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  [data-layout-width=\"boxed\"][data-sidebar-size=\"sm-hover\"][data-layout=\"vertical\"]\n    .main-content,\n  [data-layout-width=\"boxed\"][data-sidebar-size=\"sm\"][data-layout=\"vertical\"]\n    .main-content {\n    margin-left: 0;\n  }\n}\n\n[data-layout-width=\"boxed\"][data-sidebar-size=\"sm-hover\"] #page-topbar,\n[data-layout-width=\"boxed\"][data-sidebar-size=\"sm-hover\"] .footer,\n[data-layout-width=\"boxed\"][data-sidebar-size=\"sm\"] #page-topbar,\n[data-layout-width=\"boxed\"][data-sidebar-size=\"sm\"] .footer {\n  left: 0 !important;\n  max-width: calc(1300px - 70px);\n}\n\n@media (min-width: 768px) {\n  [data-layout-width=\"boxed\"][data-sidebar-size=\"sm-hover\"] #page-topbar,\n  [data-layout-width=\"boxed\"][data-sidebar-size=\"sm-hover\"] .footer,\n  [data-layout-width=\"boxed\"][data-sidebar-size=\"sm\"] #page-topbar,\n  [data-layout-width=\"boxed\"][data-sidebar-size=\"sm\"] .footer {\n    left: 70px !important;\n  }\n}\n\n[data-layout-width=\"boxed\"][data-sidebar-size=\"lg\"] #page-topbar,\n[data-layout-width=\"boxed\"][data-sidebar-size=\"lg\"] .footer,\n[data-layout-width=\"boxed\"][data-sidebar-size=\"sm-hover-active\"] #page-topbar,\n[data-layout-width=\"boxed\"][data-sidebar-size=\"sm-hover-active\"] .footer {\n  max-width: calc(1300px - 250px);\n}\n\n@media (min-width: 768px) {\n  [data-layout-width=\"boxed\"][data-sidebar-size=\"lg\"] #page-topbar,\n  [data-layout-width=\"boxed\"][data-sidebar-size=\"lg\"] .footer,\n  [data-layout-width=\"boxed\"][data-sidebar-size=\"sm-hover-active\"] #page-topbar,\n  [data-layout-width=\"boxed\"][data-sidebar-size=\"sm-hover-active\"] .footer {\n    left: 250px !important;\n  }\n}\n\n[data-layout-width=\"boxed\"][data-sidebar-size=\"md\"] #page-topbar,\n[data-layout-width=\"boxed\"][data-sidebar-size=\"md\"] .footer {\n  max-width: calc(1300px - 180px);\n}\n\n@media (min-width: 768px) {\n  [data-layout-width=\"boxed\"][data-sidebar-size=\"md\"] #page-topbar,\n  [data-layout-width=\"boxed\"][data-sidebar-size=\"md\"] .footer {\n    left: 180px !important;\n  }\n}\n\n[data-layout-width=\"boxed\"][data-layout=\"vertical\"][data-layout-style=\"detached\"]\n  body {\n  background-color: var(--bs-body-bg);\n}\n\n@media (min-width: 1024.1px) {\n  [data-layout-width=\"boxed\"][data-layout=\"vertical\"][data-layout-style=\"detached\"]\n    #layout-wrapper {\n    max-width: 1300px;\n    -webkit-box-shadow: none;\n    box-shadow: none;\n  }\n\n  [data-layout-width=\"boxed\"][data-layout=\"vertical\"][data-layout-style=\"detached\"]\n    .layout-width {\n    max-width: 1300px;\n  }\n}\n\n[data-layout-width=\"boxed\"][data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar-size=\"lg\"]\n  #page-topbar,\n[data-layout-width=\"boxed\"][data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar-size=\"lg\"]\n  .footer,\n[data-layout-width=\"boxed\"][data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar-size=\"md\"]\n  #page-topbar,\n[data-layout-width=\"boxed\"][data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar-size=\"md\"]\n  .footer,\n[data-layout-width=\"boxed\"][data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar-size=\"sm-hover\"]\n  #page-topbar,\n[data-layout-width=\"boxed\"][data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar-size=\"sm-hover\"]\n  .footer,\n[data-layout-width=\"boxed\"][data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar-size=\"sm\"]\n  #page-topbar,\n[data-layout-width=\"boxed\"][data-layout=\"vertical\"][data-layout-style=\"detached\"][data-sidebar-size=\"sm\"]\n  .footer {\n  max-width: 100%;\n  left: 0 !important;\n}\n\n[data-layout=\"horizontal\"][data-layout-width=\"boxed\"] #layout-wrapper,\n[data-layout=\"horizontal\"][data-layout-width=\"boxed\"] #page-topbar,\n[data-layout=\"horizontal\"][data-layout-width=\"boxed\"] .footer {\n  max-width: 100%;\n}\n\n[data-layout=\"horizontal\"][data-layout-width=\"boxed\"] .container-fluid,\n[data-layout=\"horizontal\"][data-layout-width=\"boxed\"] .navbar-header {\n  max-width: 1300px;\n}\n\n[data-layout=\"horizontal\"][data-layout-width=\"boxed\"] .navbar-header {\n  padding: 0 calc(1.5rem / 2) 0 0;\n}\n\n[data-layout=\"horizontal\"][data-layout-width=\"boxed\"][data-sidebar-size=\"lg\"]\n  #page-topbar,\n[data-layout=\"horizontal\"][data-layout-width=\"boxed\"][data-sidebar-size=\"lg\"]\n  .footer,\n[data-layout=\"horizontal\"][data-layout-width=\"boxed\"][data-sidebar-size=\"sm-hover\"]\n  #page-topbar,\n[data-layout=\"horizontal\"][data-layout-width=\"boxed\"][data-sidebar-size=\"sm-hover\"]\n  .footer,\n[data-layout=\"horizontal\"][data-layout-width=\"boxed\"][data-sidebar-size=\"sm\"]\n  [data-layout=\"horizontal\"][data-layout-width=\"boxed\"][data-sidebar-size=\"sm-hover-active\"]\n  #page-topbar,\n[data-layout=\"horizontal\"][data-layout-width=\"boxed\"][data-sidebar-size=\"sm\"]\n  [data-layout=\"horizontal\"][data-layout-width=\"boxed\"][data-sidebar-size=\"sm-hover-active\"]\n  .footer {\n  left: 0 !important;\n}\n\n@media (min-width: 992px) {\n  [data-layout-position=\"scrollable\"] #page-topbar,\n  [data-layout-position=\"scrollable\"] .navbar-menu {\n    position: absolute;\n  }\n}\n\n@media (min-width: 992px) {\n  [data-layout-position=\"scrollable\"][data-layout=\"horizontal\"] #page-topbar,\n  [data-layout-position=\"scrollable\"][data-layout=\"horizontal\"] .topnav {\n    position: absolute;\n  }\n}\n\n/*!\n * Waves v0.7.6\n * http://fian.my.id/Waves \n * \n * Copyright 2014-2018 Alfiana E. Sibuea and other contributors \n * Released under the MIT license \n * https://github.com/fians/Waves/blob/master/LICENSE */\n\n.waves-effect {\n  position: relative;\n  cursor: pointer;\n  display: inline-block;\n  overflow: hidden;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.waves-effect .waves-ripple {\n  position: absolute;\n  border-radius: 50%;\n  width: 100px;\n  height: 100px;\n  margin-top: -50px;\n  margin-left: -50px;\n  opacity: 0;\n  background: rgba(0, 0, 0, 0.2);\n  background: radial-gradient(\n    rgba(0, 0, 0, 0.2) 0,\n    rgba(0, 0, 0, 0.3) 40%,\n    rgba(0, 0, 0, 0.4) 50%,\n    rgba(0, 0, 0, 0.5) 60%,\n    rgba(255, 255, 255, 0) 70%\n  );\n  -webkit-transition: all 0.5s ease-out;\n  transition: all 0.5s ease-out;\n  -webkit-transition-property: -webkit-transform, opacity;\n  -webkit-transition-property: opacity, -webkit-transform;\n  transition-property: opacity, -webkit-transform;\n  transition-property: transform, opacity;\n  transition-property: transform, opacity, -webkit-transform;\n  -webkit-transform: scale(0) translate(0, 0);\n  transform: scale(0) translate(0, 0);\n  pointer-events: none;\n}\n\n.waves-effect.waves-light .waves-ripple {\n  background: rgba(255, 255, 255, 0.4);\n  background: radial-gradient(\n    rgba(255, 255, 255, 0.2) 0,\n    rgba(255, 255, 255, 0.3) 40%,\n    rgba(255, 255, 255, 0.4) 50%,\n    rgba(255, 255, 255, 0.5) 60%,\n    rgba(255, 255, 255, 0) 70%\n  );\n}\n\n.waves-effect.waves-classic .waves-ripple {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.waves-effect.waves-classic.waves-light .waves-ripple {\n  background: rgba(255, 255, 255, 0.4);\n}\n\n.waves-notransition {\n  -webkit-transition: none !important;\n  transition: none !important;\n}\n\n.waves-button,\n.waves-circle {\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n  -webkit-mask-image: -webkit-radial-gradient(circle, #fff 100%, #000 100%);\n}\n\n.waves-button,\n.waves-button-input,\n.waves-button:hover,\n.waves-button:visited {\n  white-space: nowrap;\n  vertical-align: middle;\n  cursor: pointer;\n  border: none;\n  outline: 0;\n  color: inherit;\n  background-color: rgba(0, 0, 0, 0);\n  font-size: 1em;\n  line-height: 1em;\n  text-align: center;\n  text-decoration: none;\n  z-index: 1;\n}\n\n.waves-button {\n  padding: 0.85em 1.1em;\n  border-radius: 0.2em;\n}\n\n.waves-button-input {\n  margin: 0;\n  padding: 0.85em 1.1em;\n}\n\n.waves-input-wrapper {\n  border-radius: 0.2em;\n  vertical-align: bottom;\n}\n\n.waves-input-wrapper.waves-button {\n  padding: 0;\n}\n\n.waves-input-wrapper .waves-button-input {\n  position: relative;\n  top: 0;\n  left: 0;\n  z-index: 1;\n}\n\n.waves-circle {\n  text-align: center;\n  width: 2.5em;\n  height: 2.5em;\n  line-height: 2.5em;\n  border-radius: 50%;\n}\n\n.waves-float {\n  -webkit-mask-image: none;\n  -webkit-box-shadow: 0 1px 1.5px 1px rgba(0, 0, 0, 0.12);\n  box-shadow: 0 1px 1.5px 1px rgba(0, 0, 0, 0.12);\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n\n.waves-float:active {\n  -webkit-box-shadow: 0 8px 20px 1px rgba(0, 0, 0, 0.3);\n  box-shadow: 0 8px 20px 1px rgba(0, 0, 0, 0.3);\n}\n\n.waves-block {\n  display: block;\n}\n\n.waves-effect.waves-light .waves-ripple {\n  background-color: rgba(255, 255, 255, 0.4);\n}\n\n.waves-effect.waves-primary .waves-ripple {\n  background-color: rgba(75, 56, 179, 0.4);\n}\n\n.waves-effect.waves-success .waves-ripple {\n  background-color: rgba(69, 203, 133, 0.4);\n}\n\n.waves-effect.waves-info .waves-ripple {\n  background-color: rgba(41, 156, 219, 0.4);\n}\n\n.waves-effect.waves-warning .waves-ripple {\n  background-color: rgba(255, 190, 11, 0.4);\n}\n\n.waves-effect.waves-danger .waves-ripple {\n  background-color: rgba(240, 101, 72, 0.4);\n}\n\n.avatar-xxs {\n  height: 1.5rem;\n  width: 1.5rem;\n}\n\n.avatar-xs {\n  height: 2rem;\n  width: 2rem;\n}\n\n.avatar-sm {\n  height: 3rem;\n  width: 3rem;\n}\n\n.avatar-md {\n  height: 4.5rem;\n  width: 4.5rem;\n}\n\n.avatar-lg {\n  height: 6rem;\n  width: 6rem;\n}\n\n.avatar-xl {\n  height: 9.5rem;\n  width: 9.5rem;\n  border-radius: 0.375rem !important;\n  box-shadow: none !important;\n}\n\n.profile-img {\n  height: 50px;\n  width: 50px;\n}\n\n.avatar-title {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  background-color: #4b38b3;\n  color: #fff;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  font-weight: 500;\n  height: 100%;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.avatar-group {\n  padding-left: 12px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n}\n\n.avatar-group .avatar-group-item {\n  margin-left: -12px;\n  border: 2px solid var(--bs-card-bg-custom);\n  border-radius: 50%;\n  -webkit-transition: all 0.2s;\n  transition: all 0.2s;\n}\n\n.avatar-group .avatar-group-item:hover {\n  position: relative;\n  -webkit-transform: translateY(-2px);\n  transform: translateY(-2px);\n  z-index: 1;\n}\n\n.accordion .accordion-button {\n  font-weight: 500;\n}\n\n.accordion .accordion-body {\n  color: #878a99;\n}\n\n.accordion.accordion-icon-none .accordion-button::after {\n  content: \"\";\n  background-image: none !important;\n}\n\n.accordion.accordion-icon-none .accordion-button:not(.collapsed)::after {\n  content: \"\";\n}\n\n.custom-accordionwithicon .accordion-button::after {\n  background-image: none !important;\n  font-family: \"Material Design Icons\";\n  content: \"\\f0142\";\n  font-size: 1.1rem;\n  vertical-align: middle;\n  line-height: 0.8;\n}\n\n.custom-accordionwithicon .accordion-button:not(.collapsed)::after {\n  background-image: none !important;\n  content: \"\\f0140\";\n  margin-right: -3px;\n}\n\n.custom-accordionwithicon-plus .accordion-button::after {\n  background-image: none !important;\n  font-family: \"Material Design Icons\";\n  content: \"\\f0415\";\n  font-size: 1.1rem;\n  vertical-align: middle;\n  line-height: 0.8;\n}\n\n.custom-accordionwithicon-plus .accordion-button:not(.collapsed)::after {\n  background-image: none !important;\n  content: \"\\f0374\";\n  margin-right: -3px;\n}\n\n.lefticon-accordion .accordion-button {\n  padding-left: 2.75rem;\n}\n\n.lefticon-accordion .accordion-button::after {\n  position: absolute;\n  left: 1.25rem;\n  top: 14px;\n}\n\n.lefticon-accordion .accordion-button:not(.collapsed)::after {\n  top: 20px;\n}\n\n.accordion-border-box .accordion-item {\n  border-top: 1px solid var(--bs-border-color);\n  border-radius: 0.25rem;\n}\n\n.accordion-border-box .accordion-item:not(:first-of-type) {\n  margin-top: 8px;\n}\n\n.accordion-border-box .accordion-item .accordion-button {\n  border-radius: 0.25rem;\n}\n\n.accordion-border-box .accordion-item .accordion-button:not(.collapsed) {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.custom-accordion-border .accordion-item {\n  border-left: 3px solid var(--bs-border-color);\n}\n\n.accordion-primary .accordion-item {\n  border-color: rgba(75, 56, 179, 0.6);\n}\n\n.accordion-primary .accordion-item .accordion-button {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.accordion-primary .accordion-item .accordion-button:not(.collapsed) {\n  color: #4b38b3;\n  background-color: rgba(75, 56, 179, 0.1) !important;\n}\n\n.accordion-primary .accordion-item .accordion-button::after {\n  color: #4b38b3;\n}\n\n.accordion-fill-primary .accordion-item .accordion-button {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.accordion-fill-primary .accordion-item .accordion-button:not(.collapsed) {\n  color: #fff;\n  background-color: #4b38b3 !important;\n}\n\n.accordion-secondary .accordion-item {\n  border-color: rgba(53, 119, 241, 0.6);\n}\n\n.accordion-secondary .accordion-item .accordion-button {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.accordion-secondary .accordion-item .accordion-button:not(.collapsed) {\n  color: #3577f1;\n  background-color: rgba(53, 119, 241, 0.1) !important;\n}\n\n.accordion-secondary .accordion-item .accordion-button::after {\n  color: #3577f1;\n}\n\n.accordion-fill-secondary .accordion-item .accordion-button {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.accordion-fill-secondary .accordion-item .accordion-button:not(.collapsed) {\n  color: #fff;\n  background-color: #3577f1 !important;\n}\n\n.accordion-success .accordion-item {\n  border-color: rgba(69, 203, 133, 0.6);\n}\n\n.accordion-success .accordion-item .accordion-button {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.accordion-success .accordion-item .accordion-button:not(.collapsed) {\n  color: #45cb85;\n  background-color: rgba(69, 203, 133, 0.1) !important;\n}\n\n.accordion-success .accordion-item .accordion-button::after {\n  color: #45cb85;\n}\n\n.accordion-fill-success .accordion-item .accordion-button {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.accordion-fill-success .accordion-item .accordion-button:not(.collapsed) {\n  color: #fff;\n  background-color: #45cb85 !important;\n}\n\n.accordion-info .accordion-item {\n  border-color: rgba(41, 156, 219, 0.6);\n}\n\n.accordion-info .accordion-item .accordion-button {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.accordion-info .accordion-item .accordion-button:not(.collapsed) {\n  color: #299cdb;\n  background-color: rgba(41, 156, 219, 0.1) !important;\n}\n\n.accordion-info .accordion-item .accordion-button::after {\n  color: #299cdb;\n}\n\n.accordion-fill-info .accordion-item .accordion-button {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.accordion-fill-info .accordion-item .accordion-button:not(.collapsed) {\n  color: #fff;\n  background-color: #299cdb !important;\n}\n\n.accordion-warning .accordion-item {\n  border-color: rgba(255, 190, 11, 0.6);\n}\n\n.accordion-warning .accordion-item .accordion-button {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.accordion-warning .accordion-item .accordion-button:not(.collapsed) {\n  color: #ffbe0b;\n  background-color: rgba(255, 190, 11, 0.1) !important;\n}\n\n.accordion-warning .accordion-item .accordion-button::after {\n  color: #ffbe0b;\n}\n\n.accordion-fill-warning .accordion-item .accordion-button {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.accordion-fill-warning .accordion-item .accordion-button:not(.collapsed) {\n  color: #fff;\n  background-color: #ffbe0b !important;\n}\n\n.accordion-danger .accordion-item {\n  border-color: rgba(240, 101, 72, 0.6);\n}\n\n.accordion-danger .accordion-item .accordion-button {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.accordion-danger .accordion-item .accordion-button:not(.collapsed) {\n  color: #f06548;\n  background-color: rgba(240, 101, 72, 0.1) !important;\n}\n\n.accordion-danger .accordion-item .accordion-button::after {\n  color: #f06548;\n}\n\n.accordion-fill-danger .accordion-item .accordion-button {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.accordion-fill-danger .accordion-item .accordion-button:not(.collapsed) {\n  color: #fff;\n  background-color: #f06548 !important;\n}\n\n.accordion-light .accordion-item {\n  border-color: rgba(243, 246, 249, 0.6);\n}\n\n.accordion-light .accordion-item .accordion-button {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.accordion-light .accordion-item .accordion-button:not(.collapsed) {\n  color: #f3f6f9;\n  background-color: rgba(243, 246, 249, 0.1) !important;\n}\n\n.accordion-light .accordion-item .accordion-button::after {\n  color: #f3f6f9;\n}\n\n.accordion-fill-light .accordion-item .accordion-button {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.accordion-fill-light .accordion-item .accordion-button:not(.collapsed) {\n  color: #fff;\n  background-color: #f3f6f9 !important;\n}\n\n.accordion-dark .accordion-item {\n  border-color: rgba(33, 37, 41, 0.6);\n}\n\n.accordion-dark .accordion-item .accordion-button {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.accordion-dark .accordion-item .accordion-button:not(.collapsed) {\n  color: #212529;\n  background-color: rgba(33, 37, 41, 0.1) !important;\n}\n\n.accordion-dark .accordion-item .accordion-button::after {\n  color: #212529;\n}\n\n.accordion-fill-dark .accordion-item .accordion-button {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.accordion-fill-dark .accordion-item .accordion-button:not(.collapsed) {\n  color: #fff;\n  background-color: #212529 !important;\n}\n\n[data-layout-mode=\"dark\"] .accordion-button:not(.collapsed) {\n  color: var(--bs-accordion-button-active-color);\n}\n\n[data-layout-mode=\"dark\"] .accordion-button:not(.collapsed):after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23fff'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n[data-layout-mode=\"dark\"] .accordion-button:after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23adb5bd'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e\");\n}\n\n[dir=\"rtl\"] .custom-accordionwithicon .accordion-button::after {\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.fs-10 {\n  font-size: 10px !important;\n}\n\n.fs-11 {\n  font-size: 11px !important;\n}\n\n.fs-12 {\n  font-size: 12px !important;\n}\n\n.fs-13 {\n  font-size: 13px !important;\n}\n\n.fs-14 {\n  font-size: 14px !important;\n}\n\n.fs-15 {\n  font-size: 15px !important;\n}\n\n.fs-16 {\n  font-size: 16px !important;\n}\n\n.fs-17 {\n  font-size: 17px !important;\n}\n\n.fs-18 {\n  font-size: 18px !important;\n}\n\n.fs-19 {\n  font-size: 19px !important;\n}\n\n.fs-20 {\n  font-size: 20px !important;\n}\n\n.fs-21 {\n  font-size: 21px !important;\n}\n\n.fs-22 {\n  font-size: 22px !important;\n}\n\n.fs-23 {\n  font-size: 23px !important;\n}\n\n.fs-24 {\n  font-size: 24px !important;\n}\n\n.fs-36 {\n  font-size: 36px !important;\n}\n\n.fs-48 {\n  font-size: 48px !important;\n}\n\n.border-dark {\n  border-color: var(--bs-dark) !important;\n}\n\n.border-light {\n  border-color: var(--bs-light) !important;\n}\n\n.border-double {\n  border-style: double !important;\n}\n\n.border-top-double {\n  border-top-style: double !important;\n}\n\n.border-bottom-double {\n  border-bottom-style: double !important;\n}\n\n.border-end-double {\n  border-right-style: double !important;\n}\n\n.border-start-double {\n  border-left-style: double !important;\n}\n\n.list-group-flush.border-double {\n  border: none !important;\n}\n\n.list-group-flush.border-double .list-group-item {\n  border-style: double !important;\n}\n\n.border-dashed {\n  border-style: dashed !important;\n}\n\n.border-top-dashed {\n  border-top-style: dashed !important;\n}\n\n.border-bottom-dashed {\n  border-bottom-style: dashed !important;\n}\n\n.border-end-dashed {\n  border-right-style: dashed !important;\n}\n\n.border-start-dashed {\n  border-left-style: dashed !important;\n}\n\n.list-group-flush.border-dashed {\n  border: none !important;\n}\n\n.list-group-flush.border-dashed .list-group-item {\n  border-style: dashed !important;\n}\n\n.border-groove {\n  border-style: groove !important;\n}\n\n.border-top-groove {\n  border-top-style: groove !important;\n}\n\n.border-bottom-groove {\n  border-bottom-style: groove !important;\n}\n\n.border-end-groove {\n  border-right-style: groove !important;\n}\n\n.border-start-groove {\n  border-left-style: groove !important;\n}\n\n.list-group-flush.border-groove {\n  border: none !important;\n}\n\n.list-group-flush.border-groove .list-group-item {\n  border-style: groove !important;\n}\n\n.border-outset {\n  border-style: outset !important;\n}\n\n.border-top-outset {\n  border-top-style: outset !important;\n}\n\n.border-bottom-outset {\n  border-bottom-style: outset !important;\n}\n\n.border-end-outset {\n  border-right-style: outset !important;\n}\n\n.border-start-outset {\n  border-left-style: outset !important;\n}\n\n.list-group-flush.border-outset {\n  border: none !important;\n}\n\n.list-group-flush.border-outset .list-group-item {\n  border-style: outset !important;\n}\n\n.border-ridge {\n  border-style: ridge !important;\n}\n\n.border-top-ridge {\n  border-top-style: ridge !important;\n}\n\n.border-bottom-ridge {\n  border-bottom-style: ridge !important;\n}\n\n.border-end-ridge {\n  border-right-style: ridge !important;\n}\n\n.border-start-ridge {\n  border-left-style: ridge !important;\n}\n\n.list-group-flush.border-ridge {\n  border: none !important;\n}\n\n.list-group-flush.border-ridge .list-group-item {\n  border-style: ridge !important;\n}\n\n.border-dotted {\n  border-style: dotted !important;\n}\n\n.border-top-dotted {\n  border-top-style: dotted !important;\n}\n\n.border-bottom-dotted {\n  border-bottom-style: dotted !important;\n}\n\n.border-end-dotted {\n  border-right-style: dotted !important;\n}\n\n.border-start-dotted {\n  border-left-style: dotted !important;\n}\n\n.list-group-flush.border-dotted {\n  border: none !important;\n}\n\n.list-group-flush.border-dotted .list-group-item {\n  border-style: dotted !important;\n}\n\n.border-inset {\n  border-style: inset !important;\n}\n\n.border-top-inset {\n  border-top-style: inset !important;\n}\n\n.border-bottom-inset {\n  border-bottom-style: inset !important;\n}\n\n.border-end-inset {\n  border-right-style: inset !important;\n}\n\n.border-start-inset {\n  border-left-style: inset !important;\n}\n\n.list-group-flush.border-inset {\n  border: none !important;\n}\n\n.list-group-flush.border-inset .list-group-item {\n  border-style: inset !important;\n}\n\n[data-layout-mode=\"dark\"] .link-dark,\n[data-layout-mode=\"dark\"] .link-light {\n  color: var(--bs-dark) !important;\n}\n\n[data-layout-mode=\"dark\"] .link-dark:focus,\n[data-layout-mode=\"dark\"] .link-dark:hover,\n[data-layout-mode=\"dark\"] .link-light:focus,\n[data-layout-mode=\"dark\"] .link-light:hover {\n  color: rgba(var(--bs-dark-rgb), 0.75) !important;\n}\n\n.ff-base {\n  font-family: var(--bs-font-sans-serif);\n}\n\n.ff-secondary {\n  font-family: Inter, sans-serif;\n}\n\n.fw-medium {\n  font-weight: 500;\n}\n\n.flex-1 {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.social-list-item {\n  height: 2rem;\n  width: 2rem;\n  line-height: calc(2rem - 4px);\n  display: block;\n  border: 2px solid #adb5bd;\n  border-radius: 50%;\n  color: #adb5bd;\n  text-align: center;\n  -webkit-transition: all 0.4s;\n  transition: all 0.4s;\n}\n\n.social-list-item:hover {\n  color: #878a99;\n  background-color: #eff2f7;\n}\n\n/* .bg-pattern {\n    background: url(../images/modal-bg.png) #fff\n} */\n\n.w-xs {\n  min-width: 80px;\n}\n\n.w-sm {\n  min-width: 95px;\n}\n\n.w-md {\n  min-width: 110px;\n}\n\n.w-lg {\n  min-width: 140px;\n}\n\n.w-xl {\n  min-width: 160px;\n}\n\n.icon-xs {\n  height: 16px;\n  width: 16px;\n}\n\n.icon-sm {\n  height: 18px;\n  width: 18px;\n}\n\n.icon-md {\n  height: 22px;\n  width: 22px;\n}\n\n.icon-lg {\n  height: 24px;\n  width: 24px;\n}\n\n.icon-xl {\n  height: 28px;\n  width: 28px;\n}\n\n.icon-xxl {\n  height: 32px;\n  width: 32px;\n}\n\n.icon-dual {\n  color: #adb5bd;\n  fill: rgba(173, 181, 189, 0.16);\n}\n\n.icon-dual-primary {\n  color: #4b38b3;\n  fill: rgba(75, 56, 179, 0.16);\n}\n\n.icon-dual-secondary {\n  color: #3577f1;\n  fill: rgba(53, 119, 241, 0.16);\n}\n\n.icon-dual-success {\n  color: #45cb85;\n  fill: rgba(69, 203, 133, 0.16);\n}\n\n.icon-dual-info {\n  color: #299cdb;\n  fill: rgba(41, 156, 219, 0.16);\n}\n\n.icon-dual-warning {\n  color: #ffbe0b;\n  fill: rgba(255, 190, 11, 0.16);\n}\n\n.icon-dual-danger {\n  color: #f06548;\n  fill: rgba(240, 101, 72, 0.16);\n}\n\n.icon-dual-light {\n  color: #f3f6f9;\n  fill: rgba(243, 246, 249, 0.16);\n}\n\n.icon-dual-dark {\n  color: #212529;\n  fill: rgba(33, 37, 41, 0.16);\n}\n\n.search-box {\n  position: relative;\n}\n\n.search-box .form-control {\n  padding-left: 40px;\n}\n\n.search-box .search-icon {\n  font-size: 14px;\n  position: absolute;\n  left: 13px;\n  top: 0;\n  height: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  color: #878a99;\n}\n\n.bg-overlay {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  top: 0;\n  opacity: 0.7;\n  background-color: #000;\n}\n\n.customizer-setting {\n  position: fixed;\n  bottom: 40px;\n  right: 20px;\n  z-index: 1000;\n}\n\ncode {\n  -webkit-user-select: all;\n  -moz-user-select: all;\n  user-select: all;\n}\n\n.layout-rightside {\n  width: 280px;\n  margin-right: -1.5rem;\n  margin-top: calc(1px - 1.5rem * 1.1);\n  height: calc(100% + 1.5rem * 1.1);\n}\n\n@media (max-width: 1699.98px) {\n  .layout-rightside-col {\n    display: none;\n    position: fixed !important;\n    height: 100vh;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 1004;\n  }\n\n  .layout-rightside-col .overlay {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: rgba(33, 37, 41, 0.2);\n  }\n\n  .layout-rightside-col .layout-rightside {\n    margin-top: 0;\n    height: 100%;\n    margin-left: auto;\n  }\n\n  .layout-rightside-col .card-body {\n    overflow-y: auto;\n    padding-bottom: 1rem !important;\n  }\n}\n\n@media (min-width: 1700px) {\n  [data-layout-style=\"detached\"] .layout-rightside,\n  [data-layout=\"horizontal\"] .layout-rightside {\n    margin-top: calc(28px - 1.5rem);\n    margin-right: 0;\n    height: calc(100% - (1.5rem / 5));\n  }\n}\n\n.object-cover {\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n.text-truncate-two-lines {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  -webkit-line-clamp: 2;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  white-space: normal;\n}\n\n.favourite-btn {\n  border-color: transparent;\n}\n\n.favourite-btn .ri-star-fill {\n  color: #878a99;\n}\n\n.favourite-btn.active {\n  border-color: transparent;\n}\n\n.favourite-btn.active .ri-star-fill {\n  color: #ffbe0b;\n}\n\n.favourite-btn.active .ri-star-fill:before {\n  content: \"\\f186\";\n}\n\n.card-logo-light {\n  display: var(--bs-card-logo-light);\n}\n\n.card-logo-dark {\n  display: var(--bs-card-logo-dark);\n}\n\n[data-layout-mode=\"dark\"] .btn-close {\n  -webkit-filter: invert(1) grayscale(100%) brightness(200%);\n  filter: invert(1) grayscale(100%) brightness(200%);\n}\n\n#back-to-top {\n  position: fixed;\n  bottom: 100px;\n  right: 28px;\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n  display: none;\n  z-index: 1000;\n}\n\n#back-to-top:hover {\n  -webkit-animation: fade-up 1.5s infinite linear;\n  animation: fade-up 1.5s infinite linear;\n}\n\n@-webkit-keyframes fade-up {\n  0% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n\n  75% {\n    -webkit-transform: translateY(-20px);\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n}\n\n@keyframes fade-up {\n  0% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n    opacity: 1;\n  }\n\n  75% {\n    -webkit-transform: translateY(-20px);\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n#preloader {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--bs-card-bg-custom);\n  z-index: 9999;\n}\n\n[data-preloader=\"disable\"] #preloader {\n  opacity: 0;\n  visibility: hidden;\n}\n\n#status {\n  width: 40px;\n  height: 40px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  margin: -20px 0 0 -20px;\n}\n\n[type=\"email\"]::-webkit-input-placeholder,\n[type=\"number\"]::-webkit-input-placeholder,\n[type=\"tel\"]::-webkit-input-placeholder,\n[type=\"url\"]::-webkit-input-placeholder {\n  text-align: left;\n}\n\n[type=\"email\"]::-moz-placeholder,\n[type=\"number\"]::-moz-placeholder,\n[type=\"tel\"]::-moz-placeholder,\n[type=\"url\"]::-moz-placeholder {\n  text-align: left;\n}\n\n[type=\"email\"]:-ms-input-placeholder,\n[type=\"number\"]:-ms-input-placeholder,\n[type=\"tel\"]:-ms-input-placeholder,\n[type=\"url\"]:-ms-input-placeholder {\n  text-align: left;\n}\n\n[type=\"email\"]::-ms-input-placeholder,\n[type=\"number\"]::-ms-input-placeholder,\n[type=\"tel\"]::-ms-input-placeholder,\n[type=\"url\"]::-ms-input-placeholder {\n  text-align: left;\n}\n\n[type=\"email\"]::placeholder,\n[type=\"number\"]::placeholder,\n[type=\"tel\"]::placeholder,\n[type=\"url\"]::placeholder {\n  text-align: left;\n}\n\n.main-chart .chart-border-left {\n  border-left: 1.4px solid var(--bs-border-color);\n  padding: 2px 20px;\n}\n\n.main-chart .chart-border-left:last-child {\n  margin-right: 0;\n}\n\n.activity-feed {\n  list-style: none;\n}\n\n.activity-feed .feed-item {\n  position: relative;\n  padding-bottom: 27px;\n  padding-left: 16px;\n  border-left: 2px solid #f3f6f9;\n}\n\n.activity-feed .feed-item:after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  top: 4px;\n  left: -6px;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  border: 2px solid #4b38b3;\n  background-color: #fff;\n}\n\n.activity-feed .feed-item:last-child {\n  border-color: transparent;\n}\n\n.mini-stats-wid {\n  position: relative;\n}\n\n.mini-stats-wid .mini-stat-icon {\n  overflow: hidden;\n  position: relative;\n}\n\n.mini-stats-wid .mini-stat-icon:after,\n.mini-stats-wid .mini-stat-icon:before {\n  content: \"\";\n  position: absolute;\n  width: 8px;\n  height: 69px;\n  background-color: rgba(69, 203, 133, 0.1);\n  left: 3px;\n  -webkit-transform: rotate(32deg);\n  transform: rotate(32deg);\n  top: -8px;\n  -webkit-transition: all 0.4s;\n  transition: all 0.4s;\n}\n\n.mini-stats-wid .mini-stat-icon::after {\n  left: 27px;\n  width: 8px;\n  -webkit-transition: all 0.2s;\n  transition: all 0.2s;\n}\n\n.mini-stats-wid:hover .mini-stat-icon::after {\n  left: 60px;\n}\n\n.mini-stats-wid:hover .mini-stat-icon::before {\n  left: 50px;\n}\n\n.button-items {\n  margin-left: -8px;\n  margin-bottom: -12px;\n}\n\n.button-items .btn {\n  margin-bottom: 12px;\n  margin-left: 8px;\n}\n\n.bs-example-modal {\n  position: relative;\n  top: auto;\n  right: auto;\n  bottom: auto;\n  left: auto;\n  z-index: 1;\n  display: block;\n}\n\n[dir=\"rtl\"] .modal-open {\n  padding-left: 0 !important;\n}\n\n.icon-demo-content {\n  color: var(--bs-gray-500);\n}\n\n.icon-demo-content i {\n  font-size: 24px;\n  margin-right: 10px;\n  color: var(--bs-gray-600);\n  -webkit-transition: all 0.4s;\n  transition: all 0.4s;\n  vertical-align: middle;\n}\n\n.icon-demo-content svg {\n  margin-right: 10px;\n  -webkit-transition: all 0.4s;\n  transition: all 0.4s;\n  height: 20px;\n}\n\n.icon-demo-content .col-lg-4 {\n  margin-top: 24px;\n}\n\n.icon-demo-content .col-lg-4:hover i,\n.icon-demo-content .col-lg-4:hover svg {\n  color: #4b38b3;\n  -webkit-transform: scale(1.5);\n  transform: scale(1.5);\n}\n\n.grid-structure .grid-container {\n  background-color: #f3f6f9;\n  margin-top: 10px;\n  font-size: 0.8rem;\n  font-weight: 500;\n  padding: 10px 20px;\n}\n\n.img-switch .card-radio .form-check-input {\n  display: none;\n}\n\n.img-switch .card-radio .form-check-input:checked + .form-check-label::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(75, 56, 179, 0.5);\n}\n\n.img-switch .card-radio .form-check-input:checked + .form-check-label::after {\n  content: \"\\eb80\";\n  font-family: remixicon;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translateY(-50%) translateX(-50%);\n  transform: translateY(-50%) translateX(-50%);\n  font-size: 18px;\n  color: #fff;\n}\n\n[data-bs-target=\"#collapseBgGradient\"].active {\n  border-color: #4b38b3 !important;\n}\n\n[data-bs-target=\"#collapseBgGradient\"].active::before {\n  content: \"\\eb80\";\n  font-family: remixicon;\n  position: absolute;\n  top: 2px;\n  right: 6px;\n  font-size: 16px;\n  color: #4b38b3;\n}\n\n[data-layout-mode=\"dark\"] .colorscheme-cardradio .form-check-label {\n  background-color: var(--bs-dark);\n}\n\n[data-layout-mode=\"dark\"] .colorscheme-cardradio .bg-light {\n  background-color: rgb(120 123 137) !important;\n}\n\n[data-layout-mode=\"dark\"] .colorscheme-cardradio .bg-soft-light {\n  background-color: rgba(var(--bs-dark-rgb), 0.1) !important;\n}\n\n[data-layout-mode=\"dark\"] .colorscheme-cardradio .dark .bg-dark {\n  background-color: var(--bs-card-bg-custom) !important;\n}\n\n@media print {\n  #back-to-top,\n  .app-menu,\n  .footer,\n  .navbar-header,\n  .page-title-box,\n  .right-bar,\n  .vertical-menu {\n    display: none !important;\n  }\n\n  .card-body,\n  .main-content,\n  .page-content,\n  .right-bar,\n  body {\n    padding: 0;\n    margin: 0;\n  }\n\n  .card {\n    border: 0;\n    -webkit-box-shadow: none !important;\n    box-shadow: none !important;\n  }\n\n  .invoice-details .d-sm-flex {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n\n  .address.col-sm-6 {\n    -webkit-box-flex: 0 !important;\n    -ms-flex: 0 0 auto !important;\n    flex: 0 0 auto !important;\n    width: 50% !important;\n    max-width: 100% !important;\n  }\n}\n\n.ribbon-box {\n  position: relative;\n}\n\n.ribbon-box .ribbon {\n  padding: 5px 12px;\n  -webkit-box-shadow: 2px 5px 10px rgba(33, 37, 41, 0.15);\n  box-shadow: 2px 5px 10px rgba(33, 37, 41, 0.15);\n  color: #fff;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  position: absolute;\n  left: -1px;\n  top: 5px;\n}\n\n.ribbon-box .ribbon.round-shape {\n  border-radius: 0 30px 30px 0;\n}\n\n.ribbon-box .ribbon.ribbon-shape {\n  display: inline-block;\n}\n\n.ribbon-box .ribbon.ribbon-shape::before {\n  content: \"\";\n  position: absolute;\n  right: -17px;\n  top: 0;\n  border: 14px solid transparent;\n}\n\n.ribbon-box .ribbon.ribbon-shape::after {\n  content: \"\";\n  position: absolute;\n  right: -17px;\n  bottom: 0;\n  border: 14px solid transparent;\n}\n\n.ribbon-box.ribbon-circle .ribbon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  padding: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  left: 20px;\n  top: 20px;\n}\n\n.ribbon-box.ribbon-fill {\n  overflow: hidden;\n}\n\n.ribbon-box.ribbon-fill .ribbon {\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  width: 93px;\n  height: 52px;\n  left: -36px;\n  top: -16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n}\n\n.ribbon-box.ribbon-fill.ribbon-sm .ribbon {\n  padding: 2px 12px;\n  width: 78px;\n  height: 42px;\n  font-size: 12px;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.ribbon-box.right .ribbon {\n  position: absolute;\n  left: auto;\n  right: 0;\n}\n\n.ribbon-box.right .ribbon.round-shape {\n  border-radius: 30px 0 0 30px;\n}\n\n.ribbon-box.right .ribbon.ribbon-shape {\n  text-align: right;\n}\n\n.ribbon-box.right .ribbon.ribbon-shape::after,\n.ribbon-box.right .ribbon.ribbon-shape::before {\n  right: auto;\n  left: -17px;\n  border-left-color: transparent;\n}\n\n.ribbon-box.right.ribbon-circle .ribbon {\n  left: auto;\n  right: 20px;\n}\n\n.ribbon-box.right .icon-ribbon {\n  right: 24px;\n  left: auto;\n}\n\n.ribbon-box.right.ribbon-fill .ribbon {\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  right: -38px;\n  left: auto;\n}\n\n.ribbon-box.right.ribbon-box .ribbon-two {\n  left: auto;\n  right: -5px;\n}\n\n.ribbon-box.right.ribbon-box .ribbon-two span {\n  left: auto;\n  right: -21px;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.ribbon-box .ribbon-content {\n  clear: both;\n}\n\n.ribbon-box .ribbon-primary {\n  background: #4b38b3;\n}\n\n.ribbon-box .ribbon-primary:before {\n  border-color: #3b2c8c transparent transparent;\n}\n\n.ribbon-box .ribbon-primary.ribbon-shape::before {\n  border-left-color: #4b38b3;\n  border-top-color: #4b38b3;\n}\n\n.ribbon-box .ribbon-primary.ribbon-shape::after {\n  border-left-color: #4b38b3;\n  border-bottom-color: #4b38b3;\n}\n\n.ribbon-box.right .ribbon-primary {\n  background: #4b38b3;\n}\n\n.ribbon-box.right .ribbon-primary.ribbon-shape::before {\n  border-right-color: #4b38b3;\n  border-top-color: #4b38b3;\n}\n\n.ribbon-box.right .ribbon-primary.ribbon-shape::after {\n  border-right-color: #4b38b3;\n  border-bottom-color: #4b38b3;\n}\n\n.ribbon-box .ribbon-secondary {\n  background: #3577f1;\n}\n\n.ribbon-box .ribbon-secondary:before {\n  border-color: #105ae3 transparent transparent;\n}\n\n.ribbon-box .ribbon-secondary.ribbon-shape::before {\n  border-left-color: #3577f1;\n  border-top-color: #3577f1;\n}\n\n.ribbon-box .ribbon-secondary.ribbon-shape::after {\n  border-left-color: #3577f1;\n  border-bottom-color: #3577f1;\n}\n\n.ribbon-box.right .ribbon-secondary {\n  background: #3577f1;\n}\n\n.ribbon-box.right .ribbon-secondary.ribbon-shape::before {\n  border-right-color: #3577f1;\n  border-top-color: #3577f1;\n}\n\n.ribbon-box.right .ribbon-secondary.ribbon-shape::after {\n  border-right-color: #3577f1;\n  border-bottom-color: #3577f1;\n}\n\n.ribbon-box .ribbon-success {\n  background: #45cb85;\n}\n\n.ribbon-box .ribbon-success:before {\n  border-color: #30ad6c transparent transparent;\n}\n\n.ribbon-box .ribbon-success.ribbon-shape::before {\n  border-left-color: #45cb85;\n  border-top-color: #45cb85;\n}\n\n.ribbon-box .ribbon-success.ribbon-shape::after {\n  border-left-color: #45cb85;\n  border-bottom-color: #45cb85;\n}\n\n.ribbon-box.right .ribbon-success {\n  background: #45cb85;\n}\n\n.ribbon-box.right .ribbon-success.ribbon-shape::before {\n  border-right-color: #45cb85;\n  border-top-color: #45cb85;\n}\n\n.ribbon-box.right .ribbon-success.ribbon-shape::after {\n  border-right-color: #45cb85;\n  border-bottom-color: #45cb85;\n}\n\n.ribbon-box .ribbon-info {\n  background: #299cdb;\n}\n\n.ribbon-box .ribbon-info:before {\n  border-color: #1e7eb3 transparent transparent;\n}\n\n.ribbon-box .ribbon-info.ribbon-shape::before {\n  border-left-color: #299cdb;\n  border-top-color: #299cdb;\n}\n\n.ribbon-box .ribbon-info.ribbon-shape::after {\n  border-left-color: #299cdb;\n  border-bottom-color: #299cdb;\n}\n\n.ribbon-box.right .ribbon-info {\n  background: #299cdb;\n}\n\n.ribbon-box.right .ribbon-info.ribbon-shape::before {\n  border-right-color: #299cdb;\n  border-top-color: #299cdb;\n}\n\n.ribbon-box.right .ribbon-info.ribbon-shape::after {\n  border-right-color: #299cdb;\n  border-bottom-color: #299cdb;\n}\n\n.ribbon-box .ribbon-warning {\n  background: #ffbe0b;\n}\n\n.ribbon-box .ribbon-warning:before {\n  border-color: #d79e00 transparent transparent;\n}\n\n.ribbon-box .ribbon-warning.ribbon-shape::before {\n  border-left-color: #ffbe0b;\n  border-top-color: #ffbe0b;\n}\n\n.ribbon-box .ribbon-warning.ribbon-shape::after {\n  border-left-color: #ffbe0b;\n  border-bottom-color: #ffbe0b;\n}\n\n.ribbon-box.right .ribbon-warning {\n  background: #ffbe0b;\n}\n\n.ribbon-box.right .ribbon-warning.ribbon-shape::before {\n  border-right-color: #ffbe0b;\n  border-top-color: #ffbe0b;\n}\n\n.ribbon-box.right .ribbon-warning.ribbon-shape::after {\n  border-right-color: #ffbe0b;\n  border-bottom-color: #ffbe0b;\n}\n\n.ribbon-box .ribbon-danger {\n  background: #f06548;\n}\n\n.ribbon-box .ribbon-danger:before {\n  border-color: #ec3d19 transparent transparent;\n}\n\n.ribbon-box .ribbon-danger.ribbon-shape::before {\n  border-left-color: #f06548;\n  border-top-color: #f06548;\n}\n\n.ribbon-box .ribbon-danger.ribbon-shape::after {\n  border-left-color: #f06548;\n  border-bottom-color: #f06548;\n}\n\n.ribbon-box.right .ribbon-danger {\n  background: #f06548;\n}\n\n.ribbon-box.right .ribbon-danger.ribbon-shape::before {\n  border-right-color: #f06548;\n  border-top-color: #f06548;\n}\n\n.ribbon-box.right .ribbon-danger.ribbon-shape::after {\n  border-right-color: #f06548;\n  border-bottom-color: #f06548;\n}\n\n.ribbon-box .ribbon-light {\n  background: #f3f6f9;\n}\n\n.ribbon-box .ribbon-light:before {\n  border-color: #d1dde8 transparent transparent;\n}\n\n.ribbon-box .ribbon-light.ribbon-shape::before {\n  border-left-color: #f3f6f9;\n  border-top-color: #f3f6f9;\n}\n\n.ribbon-box .ribbon-light.ribbon-shape::after {\n  border-left-color: #f3f6f9;\n  border-bottom-color: #f3f6f9;\n}\n\n.ribbon-box.right .ribbon-light {\n  background: #f3f6f9;\n}\n\n.ribbon-box.right .ribbon-light.ribbon-shape::before {\n  border-right-color: #f3f6f9;\n  border-top-color: #f3f6f9;\n}\n\n.ribbon-box.right .ribbon-light.ribbon-shape::after {\n  border-right-color: #f3f6f9;\n  border-bottom-color: #f3f6f9;\n}\n\n.ribbon-box .ribbon-dark {\n  background: #212529;\n}\n\n.ribbon-box .ribbon-dark:before {\n  border-color: #0a0c0d transparent transparent;\n}\n\n.ribbon-box .ribbon-dark.ribbon-shape::before {\n  border-left-color: #212529;\n  border-top-color: #212529;\n}\n\n.ribbon-box .ribbon-dark.ribbon-shape::after {\n  border-left-color: #212529;\n  border-bottom-color: #212529;\n}\n\n.ribbon-box.right .ribbon-dark {\n  background: #212529;\n}\n\n.ribbon-box.right .ribbon-dark.ribbon-shape::before {\n  border-right-color: #212529;\n  border-top-color: #212529;\n}\n\n.ribbon-box.right .ribbon-dark.ribbon-shape::after {\n  border-right-color: #212529;\n  border-bottom-color: #212529;\n}\n\n.ribbon-box .icon-ribbon {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  left: 24px;\n  top: -12px;\n  font-size: 40px;\n  padding: 0;\n}\n\n.ribbon-box .ribbon-two {\n  position: absolute;\n  left: -5px;\n  top: -5px;\n  z-index: 1;\n  overflow: hidden;\n  width: 75px;\n  height: 75px;\n  text-align: right;\n}\n\n.ribbon-box .ribbon-two span {\n  font-size: 13px;\n  color: #fff;\n  text-align: center;\n  line-height: 20px;\n  -webkit-transform: rotate(-45deg);\n  transform: rotate(-45deg);\n  width: 100px;\n  display: block;\n  -webkit-box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.06),\n    0 1px 0 0 rgba(0, 0, 0, 0.02);\n  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);\n  position: absolute;\n  top: 19px;\n  left: -21px;\n  font-weight: 600;\n}\n\n.ribbon-box .ribbon-two span:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 100%;\n  z-index: -1;\n  border-right: 3px solid transparent;\n  border-bottom: 3px solid transparent;\n}\n\n.ribbon-box .ribbon-two span:after {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: 100%;\n  z-index: -1;\n  border-left: 3px solid transparent;\n  border-bottom: 3px solid transparent;\n}\n\n.ribbon-box .ribbon-two-primary span {\n  background: #4b38b3;\n}\n\n.ribbon-box .ribbon-two-primary span:before {\n  border-left: 3px solid #332679;\n  border-top: 3px solid #332679;\n}\n\n.ribbon-box .ribbon-two-primary span:after {\n  border-right: 3px solid #332679;\n  border-top: 3px solid #332679;\n}\n\n.ribbon-box .ribbon-two-secondary span {\n  background: #3577f1;\n}\n\n.ribbon-box .ribbon-two-secondary span:before {\n  border-left: 3px solid #0e51cb;\n  border-top: 3px solid #0e51cb;\n}\n\n.ribbon-box .ribbon-two-secondary span:after {\n  border-right: 3px solid #0e51cb;\n  border-top: 3px solid #0e51cb;\n}\n\n.ribbon-box .ribbon-two-success span {\n  background: #45cb85;\n}\n\n.ribbon-box .ribbon-two-success span:before {\n  border-left: 3px solid #2b995f;\n  border-top: 3px solid #2b995f;\n}\n\n.ribbon-box .ribbon-two-success span:after {\n  border-right: 3px solid #2b995f;\n  border-top: 3px solid #2b995f;\n}\n\n.ribbon-box .ribbon-two-info span {\n  background: #299cdb;\n}\n\n.ribbon-box .ribbon-two-info span:before {\n  border-left: 3px solid #1a6f9d;\n  border-top: 3px solid #1a6f9d;\n}\n\n.ribbon-box .ribbon-two-info span:after {\n  border-right: 3px solid #1a6f9d;\n  border-top: 3px solid #1a6f9d;\n}\n\n.ribbon-box .ribbon-two-warning span {\n  background: #ffbe0b;\n}\n\n.ribbon-box .ribbon-two-warning span:before {\n  border-left: 3px solid #be8b00;\n  border-top: 3px solid #be8b00;\n}\n\n.ribbon-box .ribbon-two-warning span:after {\n  border-right: 3px solid #be8b00;\n  border-top: 3px solid #be8b00;\n}\n\n.ribbon-box .ribbon-two-danger span {\n  background: #f06548;\n}\n\n.ribbon-box .ribbon-two-danger span:before {\n  border-left: 3px solid #da3412;\n  border-top: 3px solid #da3412;\n}\n\n.ribbon-box .ribbon-two-danger span:after {\n  border-right: 3px solid #da3412;\n  border-top: 3px solid #da3412;\n}\n\n.ribbon-box .ribbon-two-light span {\n  background: #f3f6f9;\n}\n\n.ribbon-box .ribbon-two-light span:before {\n  border-left: 3px solid #c0d0e0;\n  border-top: 3px solid #c0d0e0;\n}\n\n.ribbon-box .ribbon-two-light span:after {\n  border-right: 3px solid #c0d0e0;\n  border-top: 3px solid #c0d0e0;\n}\n\n.ribbon-box .ribbon-two-dark span {\n  background: #212529;\n}\n\n.ribbon-box .ribbon-two-dark span:before {\n  border-left: 3px solid #000;\n  border-top: 3px solid #000;\n}\n\n.ribbon-box .ribbon-two-dark span:after {\n  border-right: 3px solid #000;\n  border-top: 3px solid #000;\n}\n\n.ribbon-box.right .ribbon-three {\n  position: absolute;\n  top: -6.1px;\n  right: 10px;\n  left: auto;\n}\n\n.ribbon-three {\n  position: absolute;\n  top: -6.1px;\n  left: 10px;\n}\n\n.ribbon-three span {\n  position: relative;\n  display: block;\n  text-align: center;\n  color: #fff;\n  font-size: 14px;\n  line-height: 1;\n  padding: 12px 8px 10px;\n  border-top-right-radius: 8px;\n  width: 90px;\n}\n\n.ribbon-three span::after,\n.ribbon-three span::before {\n  position: absolute;\n  content: \"\";\n}\n\n.ribbon-three span::before {\n  height: 6px;\n  width: 6px;\n  left: -6px;\n  top: 0;\n}\n\n.ribbon-three span::after {\n  height: 6px;\n  width: 8px;\n  left: -8px;\n  top: 0;\n  border-radius: 8px 8px 0 0;\n}\n\n.ribbon-three::after {\n  position: absolute;\n  content: \"\";\n  width: 0;\n  height: 0;\n  border-left: 44px solid transparent;\n  border-right: 44px solid transparent;\n  border-top: 10px solid;\n}\n\n.ribbon-three-primary span {\n  background: #4b38b3;\n}\n\n.ribbon-three-primary span:before {\n  background: #4b38b3;\n}\n\n.ribbon-three-primary span:after {\n  background: #3b2c8c;\n}\n\n.ribbon-three-primary::after {\n  border-top-color: #4b38b3;\n}\n\n.ribbon-three-secondary span {\n  background: #3577f1;\n}\n\n.ribbon-three-secondary span:before {\n  background: #3577f1;\n}\n\n.ribbon-three-secondary span:after {\n  background: #105ae3;\n}\n\n.ribbon-three-secondary::after {\n  border-top-color: #3577f1;\n}\n\n.ribbon-three-success span {\n  background: #45cb85;\n}\n\n.ribbon-three-success span:before {\n  background: #45cb85;\n}\n\n.ribbon-three-success span:after {\n  background: #30ad6c;\n}\n\n.ribbon-three-success::after {\n  border-top-color: #45cb85;\n}\n\n.ribbon-three-info span {\n  background: #299cdb;\n}\n\n.ribbon-three-info span:before {\n  background: #299cdb;\n}\n\n.ribbon-three-info span:after {\n  background: #1e7eb3;\n}\n\n.ribbon-three-info::after {\n  border-top-color: #299cdb;\n}\n\n.ribbon-three-warning span {\n  background: #ffbe0b;\n}\n\n.ribbon-three-warning span:before {\n  background: #ffbe0b;\n}\n\n.ribbon-three-warning span:after {\n  background: #d79e00;\n}\n\n.ribbon-three-warning::after {\n  border-top-color: #ffbe0b;\n}\n\n.ribbon-three-danger span {\n  background: #f06548;\n}\n\n.ribbon-three-danger span:before {\n  background: #f06548;\n}\n\n.ribbon-three-danger span:after {\n  background: #ec3d19;\n}\n\n.ribbon-three-danger::after {\n  border-top-color: #f06548;\n}\n\n.ribbon-three-light span {\n  background: #f3f6f9;\n}\n\n.ribbon-three-light span:before {\n  background: #f3f6f9;\n}\n\n.ribbon-three-light span:after {\n  background: #d1dde8;\n}\n\n.ribbon-three-light::after {\n  border-top-color: #f3f6f9;\n}\n\n.ribbon-three-dark span {\n  background: #212529;\n}\n\n.ribbon-three-dark span:before {\n  background: #212529;\n}\n\n.ribbon-three-dark span:after {\n  background: #0a0c0d;\n}\n\n.ribbon-three-dark::after {\n  border-top-color: #212529;\n}\n\n.ribbon-box .trending-ribbon {\n  -webkit-transform: translateX(-50px);\n  transform: translateX(-50px);\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n}\n\n.ribbon-box .trending-ribbon .trending-ribbon-text {\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n  opacity: 0;\n}\n\n.ribbon-box:hover .trending-ribbon {\n  -webkit-transform: translateX(0);\n  transform: translateX(0);\n}\n\n.ribbon-box:hover .trending-ribbon .trending-ribbon-text {\n  opacity: 1;\n}\n\n.ribbon-box.right .trending-ribbon {\n  -webkit-transform: translateX(50px);\n  transform: translateX(50px);\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n}\n\n.ribbon-box.right .trending-ribbon .trending-ribbon-text {\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n  opacity: 0;\n}\n\n.ribbon-box.right:hover .trending-ribbon {\n  -webkit-transform: translateX(0);\n  transform: translateX(0);\n}\n\n.ribbon-box.right:hover .trending-ribbon .trending-ribbon-text {\n  opacity: 1;\n}\n\n.toast:not(:last-child) {\n  margin-bottom: 0.75rem;\n}\n\n.toast-border-primary .toast-body {\n  color: #4b38b3;\n  border-bottom: 3px solid #4b38b3;\n}\n\n.toast-border-secondary .toast-body {\n  color: #3577f1;\n  border-bottom: 3px solid #3577f1;\n}\n\n.toast-border-success .toast-body {\n  color: #45cb85;\n  border-bottom: 3px solid #45cb85;\n}\n\n.toast-border-info .toast-body {\n  color: #299cdb;\n  border-bottom: 3px solid #299cdb;\n}\n\n.toast-border-warning .toast-body {\n  color: #ffbe0b;\n  border-bottom: 3px solid #ffbe0b;\n}\n\n.toast-border-danger .toast-body {\n  color: #f06548;\n  border-bottom: 3px solid #f06548;\n}\n\n.toast-border-light .toast-body {\n  color: #f3f6f9;\n  border-bottom: 3px solid #f3f6f9;\n}\n\n.toast-border-dark .toast-body {\n  color: #212529;\n  border-bottom: 3px solid #212529;\n}\n\n.scrollspy-example {\n  position: relative;\n  height: 200px;\n  margin-top: 0.5rem;\n  overflow: auto;\n}\n\n.scrollspy-example-2 {\n  position: relative;\n  height: 370px;\n  overflow: auto;\n}\n\nhtml {\n  position: relative;\n  min-height: 100%;\n}\n\n.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  color: var(--bs-heading-color);\n  font-family: Inter, sans-serif;\n}\n\na {\n  text-decoration: none !important;\n}\n\nlabel {\n  font-weight: 500;\n  margin-bottom: 0.5rem;\n}\n\nb,\nstrong {\n  font-weight: 600;\n}\n\n.blockquote {\n  padding: 10px 20px;\n  border-left: 4px solid var(--bs-gray-300);\n}\n\n.blockquote-reverse {\n  border-left: 0;\n  border-right: 4px solid var(--bs-gray-300);\n  text-align: right;\n}\n\n@media (min-width: 1200px) {\n  .container,\n  .container-lg,\n  .container-md,\n  .container-sm,\n  .container-xl,\n  .container-xxl {\n    max-width: 1140px;\n  }\n}\n\n.row > * {\n  position: relative;\n}\n\n.alert-solid .alert-link {\n  color: #fff;\n}\n\n.alert-outline {\n  background-color: var(--bs-card-bg-custom);\n  border-width: 2px;\n}\n\n.alert-borderless {\n  border-width: 0;\n}\n\n.alert-label-icon {\n  position: relative;\n  padding-left: 60px;\n  border: 0;\n}\n\n.alert-label-icon .label-icon {\n  position: absolute;\n  width: 45px;\n  height: 100%;\n  left: 0;\n  top: 0;\n  background-color: rgba(255, 255, 255, 0.15);\n  font-size: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.alert-label-icon.label-arrow {\n  overflow: hidden;\n}\n\n.alert-label-icon.label-arrow .label-icon:after {\n  content: \"\";\n  position: absolute;\n  border: 6px solid transparent;\n  border-left-color: #4b38b3;\n  right: -12px;\n}\n\n.alert-border-left {\n  border-left: 3px solid;\n}\n\n.alert-top-border {\n  background-color: var(--bs-card-bg-custom);\n  border-color: var(--bs-border-color);\n  border-top: 2px solid;\n  color: var(--bs-body-color);\n}\n\n.alert-additional {\n  padding: 0;\n}\n\n.alert-additional .alert-body {\n  padding: 0.8rem 1rem;\n}\n\n.alert-additional .alert-content {\n  padding: 0.8rem 1rem;\n  border-bottom-left-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n  margin: 0 -1px -1px -1px;\n}\n\n.rounded-label .label-icon {\n  width: 45px;\n  height: 26px;\n  left: 0;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n  border-radius: 0 30px 30px 0;\n}\n\n.alert-solid.alert-primary {\n  background-color: #4b38b3;\n  border-color: #4b38b3;\n  color: #fff;\n}\n\n.alert-outline.alert-primary {\n  color: #4b38b3;\n}\n\n.alert-border-left.alert-primary {\n  border-left-color: #4b38b3;\n}\n\n.alert-top-border.alert-primary {\n  border-top-color: #4b38b3;\n}\n\n.rounded-label.alert-primary .label-icon {\n  background-color: #4b38b3;\n  color: #fff;\n}\n\n.label-arrow.alert-primary .label-icon {\n  color: #fff;\n  background-color: #4b38b3;\n}\n\n.label-arrow.alert-primary .label-icon:after {\n  border-left-color: #4b38b3 !important;\n}\n\n.alert.alert-primary .btn-close::after {\n  color: #4b38b3;\n}\n\n.alert-additional.alert-primary .alert-content {\n  background-color: #4b38b3;\n  color: #fff;\n}\n\n.alert-solid.alert-secondary {\n  background-color: #3577f1;\n  border-color: #3577f1;\n  color: #fff;\n}\n\n.alert-outline.alert-secondary {\n  color: #3577f1;\n}\n\n.alert-border-left.alert-secondary {\n  border-left-color: #3577f1;\n}\n\n.alert-top-border.alert-secondary {\n  border-top-color: #3577f1;\n}\n\n.rounded-label.alert-secondary .label-icon {\n  background-color: #3577f1;\n  color: #fff;\n}\n\n.label-arrow.alert-secondary .label-icon {\n  color: #fff;\n  background-color: #3577f1;\n}\n\n.label-arrow.alert-secondary .label-icon:after {\n  border-left-color: #3577f1 !important;\n}\n\n.alert.alert-secondary .btn-close::after {\n  color: #3577f1;\n}\n\n.alert-additional.alert-secondary .alert-content {\n  background-color: #3577f1;\n  color: #fff;\n}\n\n.alert-solid.alert-success {\n  background-color: #45cb85;\n  border-color: #45cb85;\n  color: #fff;\n}\n\n.alert-outline.alert-success {\n  color: #45cb85;\n}\n\n.alert-border-left.alert-success {\n  border-left-color: #45cb85;\n}\n\n.alert-top-border.alert-success {\n  border-top-color: #45cb85;\n}\n\n.rounded-label.alert-success .label-icon {\n  background-color: #45cb85;\n  color: #fff;\n}\n\n.label-arrow.alert-success .label-icon {\n  color: #fff;\n  background-color: #45cb85;\n}\n\n.label-arrow.alert-success .label-icon:after {\n  border-left-color: #45cb85 !important;\n}\n\n.alert.alert-success .btn-close::after {\n  color: #45cb85;\n}\n\n.alert-additional.alert-success .alert-content {\n  background-color: #45cb85;\n  color: #fff;\n}\n\n.alert-solid.alert-info {\n  background-color: #299cdb;\n  border-color: #299cdb;\n  color: #fff;\n}\n\n.alert-outline.alert-info {\n  color: #299cdb;\n}\n\n.alert-border-left.alert-info {\n  border-left-color: #299cdb;\n}\n\n.alert-top-border.alert-info {\n  border-top-color: #299cdb;\n}\n\n.rounded-label.alert-info .label-icon {\n  background-color: #299cdb;\n  color: #fff;\n}\n\n.label-arrow.alert-info .label-icon {\n  color: #fff;\n  background-color: #299cdb;\n}\n\n.label-arrow.alert-info .label-icon:after {\n  border-left-color: #299cdb !important;\n}\n\n.alert.alert-info .btn-close::after {\n  color: #299cdb;\n}\n\n.alert-additional.alert-info .alert-content {\n  background-color: #299cdb;\n  color: #fff;\n}\n\n.alert-solid.alert-warning {\n  background-color: #ffbe0b;\n  border-color: #ffbe0b;\n  color: #fff;\n}\n\n.alert-outline.alert-warning {\n  color: #ffbe0b;\n}\n\n.alert-border-left.alert-warning {\n  border-left-color: #ffbe0b;\n}\n\n.alert-top-border.alert-warning {\n  border-top-color: #ffbe0b;\n}\n\n.rounded-label.alert-warning .label-icon {\n  background-color: #ffbe0b;\n  color: #fff;\n}\n\n.label-arrow.alert-warning .label-icon {\n  color: #fff;\n  background-color: #ffbe0b;\n}\n\n.label-arrow.alert-warning .label-icon:after {\n  border-left-color: #ffbe0b !important;\n}\n\n.alert.alert-warning .btn-close::after {\n  color: #ffbe0b;\n}\n\n.alert-additional.alert-warning .alert-content {\n  background-color: #ffbe0b;\n  color: #fff;\n}\n\n.alert-solid.alert-danger {\n  background-color: #f06548;\n  border-color: #f06548;\n  color: #fff;\n}\n\n.alert-outline.alert-danger {\n  color: #f06548;\n}\n\n.alert-border-left.alert-danger {\n  border-left-color: #f06548;\n}\n\n.alert-top-border.alert-danger {\n  border-top-color: #f06548;\n}\n\n.rounded-label.alert-danger .label-icon {\n  background-color: #f06548;\n  color: #fff;\n}\n\n.label-arrow.alert-danger .label-icon {\n  color: #fff;\n  background-color: #f06548;\n}\n\n.label-arrow.alert-danger .label-icon:after {\n  border-left-color: #f06548 !important;\n}\n\n.alert.alert-danger .btn-close::after {\n  color: #f06548;\n}\n\n.alert-additional.alert-danger .alert-content {\n  background-color: #f06548;\n  color: #fff;\n}\n\n.alert-solid.alert-light {\n  background-color: #f3f6f9;\n  border-color: #f3f6f9;\n  color: #000;\n}\n\n.alert-outline.alert-light {\n  color: #f3f6f9;\n}\n\n.alert-border-left.alert-light {\n  border-left-color: #f3f6f9;\n}\n\n.alert-top-border.alert-light {\n  border-top-color: #f3f6f9;\n}\n\n.rounded-label.alert-light .label-icon {\n  background-color: #f3f6f9;\n  color: #000;\n}\n\n.label-arrow.alert-light .label-icon {\n  color: #000;\n  background-color: #f3f6f9;\n}\n\n.label-arrow.alert-light .label-icon:after {\n  border-left-color: #f3f6f9 !important;\n}\n\n.alert.alert-light .btn-close::after {\n  color: #f3f6f9;\n}\n\n.alert-additional.alert-light .alert-content {\n  background-color: #f3f6f9;\n  color: #000;\n}\n\n.alert-solid.alert-dark {\n  background-color: #212529;\n  border-color: #212529;\n  color: #fff;\n}\n\n.alert-outline.alert-dark {\n  color: #212529;\n}\n\n.alert-border-left.alert-dark {\n  border-left-color: #212529;\n}\n\n.alert-top-border.alert-dark {\n  border-top-color: #212529;\n}\n\n.rounded-label.alert-dark .label-icon {\n  background-color: #212529;\n  color: #fff;\n}\n\n.label-arrow.alert-dark .label-icon {\n  color: #fff;\n  background-color: #212529;\n}\n\n.label-arrow.alert-dark .label-icon:after {\n  border-left-color: #212529 !important;\n}\n\n.alert.alert-dark .btn-close::after {\n  color: #212529;\n}\n\n.alert-additional.alert-dark .alert-content {\n  background-color: #212529;\n  color: #fff;\n}\n\n.alert-dismissible .btn-close {\n  background: 0 0 !important;\n}\n\n.alert-dismissible .btn-close::after {\n  background: 0 0 !important;\n  content: \"\\f0156\" !important;\n  font-size: 18px;\n  line-height: 15px;\n  font-family: \"Material Design Icons\" !important;\n}\n\n.alert-outline.alert-dark {\n  color: var(--bs-dark);\n}\n\n.bg-soft-primary {\n  background-color: rgba(75, 56, 179, 0.18) !important;\n}\n\n.bg-soft-secondary {\n  background-color: rgba(53, 119, 241, 0.18) !important;\n}\n\n.bg-soft-success {\n  background-color: rgba(69, 203, 133, 0.18) !important;\n}\n\n.bg-soft-info {\n  background-color: rgba(41, 156, 219, 0.18) !important;\n}\n\n.bg-soft-warning {\n  background-color: rgba(255, 190, 11, 0.18) !important;\n}\n\n.bg-soft-danger {\n  background-color: rgba(240, 101, 72, 0.18) !important;\n}\n\n.bg-soft-light {\n  background-color: rgba(243, 246, 249, 0.18) !important;\n}\n\n.bg-soft-dark {\n  background-color: rgba(33, 37, 41, 0.18) !important;\n}\n\n.bg-soft-dark {\n  background-color: rgba(var(--bs-dark-rgb), 0.18) !important;\n}\n\n.bg-soft-light {\n  background-color: rgba(var(--bs-light-rgb), 0.18) !important;\n}\n\n.badge-outline-primary {\n  color: #4b38b3;\n  border: 1px solid #4b38b3;\n  background-color: transparent;\n}\n\n.badge-outline-secondary {\n  color: #3577f1;\n  border: 1px solid #3577f1;\n  background-color: transparent;\n}\n\n.badge-outline-success {\n  color: #45cb85;\n  border: 1px solid #45cb85;\n  background-color: transparent;\n}\n\n.badge-outline-info {\n  color: #299cdb;\n  border: 1px solid #299cdb;\n  background-color: transparent;\n}\n\n.badge-outline-warning {\n  color: #ffbe0b;\n  border: 1px solid #ffbe0b;\n  background-color: transparent;\n}\n\n.badge-outline-danger {\n  color: #f06548;\n  border: 1px solid #f06548;\n  background-color: transparent;\n}\n\n.badge-outline-light {\n  color: #f3f6f9;\n  border: 1px solid #f3f6f9;\n  background-color: transparent;\n}\n\n.badge-outline-dark {\n  color: #212529;\n  border: 1px solid #212529;\n  background-color: transparent;\n}\n\n.badge-outline {\n  background-color: var(--bs-card-bg-custom);\n  border: 1px solid;\n}\n\n.badge-soft-primary {\n  color: #4b38b3;\n  background-color: rgba(75, 56, 179, 0.1);\n}\n\n.badge-outline.badge-primary {\n  color: #4b38b3;\n  border: 1px solid #4b38b3;\n  background-color: transparent;\n}\n\n.badge-label.bg-primary:before {\n  border-right-color: #4b38b3;\n}\n\n.badge-soft-secondary {\n  color: #3577f1;\n  background-color: rgba(53, 119, 241, 0.1);\n}\n\n.badge-outline.badge-secondary {\n  color: #3577f1;\n  border: 1px solid #3577f1;\n  background-color: transparent;\n}\n\n.badge-label.bg-secondary:before {\n  border-right-color: #3577f1;\n}\n\n.badge-soft-success {\n  color: #45cb85;\n  background-color: rgba(69, 203, 133, 0.1);\n}\n\n.badge-outline.badge-success {\n  color: #45cb85;\n  border: 1px solid #45cb85;\n  background-color: transparent;\n}\n\n.badge-label.bg-success:before {\n  border-right-color: #45cb85;\n}\n\n.badge-soft-info {\n  color: #299cdb;\n  background-color: rgba(41, 156, 219, 0.1);\n}\n\n.badge-outline.badge-info {\n  color: #299cdb;\n  border: 1px solid #299cdb;\n  background-color: transparent;\n}\n\n.badge-label.bg-info:before {\n  border-right-color: #299cdb;\n}\n\n.badge-soft-warning {\n  color: #ffbe0b;\n  background-color: rgba(255, 190, 11, 0.1);\n}\n\n.badge-outline.badge-warning {\n  color: #ffbe0b;\n  border: 1px solid #ffbe0b;\n  background-color: transparent;\n}\n\n.badge-label.bg-warning:before {\n  border-right-color: #ffbe0b;\n}\n\n.badge-soft-danger {\n  color: #f06548;\n  background-color: rgba(240, 101, 72, 0.1);\n}\n\n.badge-outline.badge-danger {\n  color: #f06548;\n  border: 1px solid #f06548;\n  background-color: transparent;\n}\n\n.badge-label.bg-danger:before {\n  border-right-color: #f06548;\n}\n\n.badge-soft-light {\n  color: #f3f6f9;\n  background-color: rgba(243, 246, 249, 0.1);\n}\n\n.badge-outline.badge-light {\n  color: #f3f6f9;\n  border: 1px solid #f3f6f9;\n  background-color: transparent;\n}\n\n.badge-label.bg-light:before {\n  border-right-color: #f3f6f9;\n}\n\n.badge-soft-dark {\n  color: #212529;\n  background-color: rgba(33, 37, 41, 0.1);\n}\n\n.badge-outline.badge-dark {\n  color: #212529;\n  border: 1px solid #212529;\n  background-color: transparent;\n}\n\n.badge-label.bg-dark:before {\n  border-right-color: #212529;\n}\n\n.badge-border {\n  border-left: 2px solid;\n}\n\n.badge-label {\n  margin-left: 8px;\n  position: relative;\n}\n\n.badge-label:before {\n  content: \"\";\n  position: absolute;\n  border: 8px solid transparent;\n  border-right-color: #4b38b3;\n  left: -14px;\n  top: 0;\n}\n\n.badge-gradient-primary {\n  background: linear-gradient(135deg, #4b38b3 0, #45cb85 100%);\n}\n\n.badge-gradient-secondary {\n  background: linear-gradient(135deg, #3577f1 0, #299cdb 100%);\n}\n\n.badge-gradient-success {\n  background: linear-gradient(135deg, #45cb85 0, #ffbe0b 100%);\n}\n\n.badge-gradient-danger {\n  background: linear-gradient(135deg, #f06548 0, #3577f1 100%);\n}\n\n.badge-gradient-warning {\n  background: linear-gradient(135deg, #ffbe0b 0, #be8b00 100%);\n}\n\n.badge-gradient-info {\n  background: linear-gradient(135deg, #299cdb 0, #45cb85 100%);\n}\n\n.badge-gradient-dark {\n  background: linear-gradient(135deg, #212529 0, #4b38b3 100%);\n}\n\na,\nbutton {\n  outline: 0 !important;\n  position: relative;\n}\n\n.btn {\n  -webkit-box-shadow: var(--bs-box-shadow);\n  box-shadow: var(--bs-box-shadow);\n}\n\n.btn.active,\n.btn.show,\n.btn:active,\n.btn:first-child:active,\n.btn:focus,\n.btn:hover {\n  border-color: transparent;\n}\n\n:not(.btn-check) + .btn:active {\n  border-color: transparent;\n}\n\n.btn-rounded {\n  border-radius: 30px;\n}\n\n.btn-icon {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  height: calc(1rem + 1.5em + 2px);\n  width: calc(1rem + 1.5em + 2px);\n  padding: 0;\n}\n\n.btn-icon i,\n.btn-icon img,\n.btn-icon svg {\n  vertical-align: middle;\n}\n\n.btn-icon.btn-sm {\n  height: calc(0.5rem + 1.5em + 2px);\n  width: calc(0.5rem + 1.5em + 2px);\n}\n\n.btn-icon.btn-lg {\n  height: calc(1.4rem + 1.5em + 2px);\n  width: calc(1.4rem + 1.5em + 2px);\n}\n\n.btn-soft-primary {\n  color: #4b38b3;\n  background-color: rgba(75, 56, 179, 0.1);\n  border-color: transparent;\n}\n\n.btn-soft-primary:active,\n.btn-soft-primary:focus,\n.btn-soft-primary:hover {\n  color: #fff !important;\n  background-color: #4b38b3 !important;\n  border-color: transparent;\n}\n\n.btn-soft-secondary {\n  color: #3577f1;\n  background-color: rgba(53, 119, 241, 0.1);\n  border-color: transparent;\n  margin: 3px;\n}\n\n.btn-soft-secondary:active,\n.btn-soft-secondary:focus,\n.btn-soft-secondary:hover {\n  color: #fff !important;\n  background-color: #3577f1 !important;\n  border-color: transparent;\n}\n\n.btn-soft-success {\n  color: #45cb85;\n  background-color: rgba(69, 203, 133, 0.1);\n  border-color: transparent;\n}\n\n.btn-soft-success:active,\n.btn-soft-success:focus,\n.btn-soft-success:hover {\n  color: #fff !important;\n  background-color: #45cb85 !important;\n  border-color: transparent;\n}\n\n.btn-soft-info {\n  color: #299cdb;\n  background-color: rgba(41, 156, 219, 0.1);\n  border-color: transparent;\n  margin: 3px;\n}\n\n.btn-soft-info:active,\n.btn-soft-info:focus,\n.btn-soft-info:hover {\n  color: #fff !important;\n  background-color: #299cdb !important;\n  border-color: transparent;\n}\n\n.btn-soft-warning {\n  color: #ffbe0b;\n  background-color: rgba(255, 190, 11, 0.1);\n  border-color: transparent;\n}\n\n.btn-soft-warning:active,\n.btn-soft-warning:focus,\n.btn-soft-warning:hover {\n  color: #fff !important;\n  background-color: #ffbe0b !important;\n  border-color: transparent;\n}\n\n.btn-soft-danger {\n  color: #f06548;\n  background-color: rgba(240, 101, 72, 0.1);\n  border-color: transparent;\n}\n\n.btn-soft-danger:active,\n.btn-soft-danger:focus,\n.btn-soft-danger:hover {\n  color: #fff !important;\n  background-color: #f06548 !important;\n  border-color: transparent;\n}\n\n.btn-soft-light {\n  color: #f3f6f9;\n  background-color: rgba(243, 246, 249, 0.1);\n  border-color: transparent;\n}\n\n.btn-soft-light:active,\n.btn-soft-light:focus,\n.btn-soft-light:hover {\n  color: #fff !important;\n  background-color: #f3f6f9 !important;\n  border-color: transparent;\n}\n\n.btn-soft-dark {\n  color: #212529;\n  background-color: rgba(33, 37, 41, 0.1);\n  border-color: transparent;\n}\n\n.btn-soft-dark:active,\n.btn-soft-dark:focus,\n.btn-soft-dark:hover {\n  color: #fff !important;\n  background-color: #212529 !important;\n  border-color: transparent;\n}\n\n.btn-ghost-primary {\n  color: #4b38b3;\n  border-color: transparent;\n}\n\n.btn-ghost-primary:active,\n.btn-ghost-primary:focus,\n.btn-ghost-primary:hover {\n  color: #4b38b3 !important;\n  background-color: rgba(75, 56, 179, 0.1) !important;\n  border-color: transparent !important;\n}\n\n.btn-ghost-secondary {\n  color: #3577f1;\n  border-color: transparent;\n}\n\n.btn-ghost-secondary:active,\n.btn-ghost-secondary:focus,\n.btn-ghost-secondary:hover {\n  color: #3577f1 !important;\n  background-color: rgba(53, 119, 241, 0.1) !important;\n  border-color: transparent !important;\n}\n\n.btn-ghost-success {\n  color: #45cb85;\n  border-color: transparent;\n}\n\n.btn-ghost-success:active,\n.btn-ghost-success:focus,\n.btn-ghost-success:hover {\n  color: #45cb85 !important;\n  background-color: rgba(69, 203, 133, 0.1) !important;\n  border-color: transparent !important;\n}\n\n.btn-ghost-info {\n  color: #299cdb;\n  border-color: transparent;\n}\n\n.btn-ghost-info:active,\n.btn-ghost-info:focus,\n.btn-ghost-info:hover {\n  color: #299cdb !important;\n  background-color: rgba(41, 156, 219, 0.1) !important;\n  border-color: transparent !important;\n}\n\n.btn-ghost-warning {\n  color: #ffbe0b;\n  border-color: transparent;\n}\n\n.btn-ghost-warning:active,\n.btn-ghost-warning:focus,\n.btn-ghost-warning:hover {\n  color: #ffbe0b !important;\n  background-color: rgba(255, 190, 11, 0.1) !important;\n  border-color: transparent !important;\n}\n\n.btn-ghost-danger {\n  color: #f06548;\n  border-color: transparent;\n}\n\n.btn-ghost-danger:active,\n.btn-ghost-danger:focus,\n.btn-ghost-danger:hover {\n  color: #f06548 !important;\n  background-color: rgba(240, 101, 72, 0.1) !important;\n  border-color: transparent !important;\n}\n\n.btn-ghost-light {\n  color: #f3f6f9;\n  border-color: transparent;\n}\n\n.btn-ghost-light:active,\n.btn-ghost-light:focus,\n.btn-ghost-light:hover {\n  color: #f3f6f9 !important;\n  background-color: rgba(243, 246, 249, 0.1) !important;\n  border-color: transparent !important;\n}\n\n.btn-ghost-dark {\n  color: #212529;\n  border-color: transparent;\n}\n\n.btn-ghost-dark:active,\n.btn-ghost-dark:focus,\n.btn-ghost-dark:hover {\n  color: #212529 !important;\n  background-color: rgba(33, 37, 41, 0.1) !important;\n  border-color: transparent !important;\n}\n\n.btn-ghost-secondary {\n  color: var(--bs-gray-700);\n}\n\n.btn-label {\n  position: relative;\n  padding-left: 44px;\n}\n\n.btn-label .label-icon {\n  position: absolute;\n  width: 35.5px;\n  left: -1px;\n  top: -1px;\n  bottom: -1px;\n  background-color: rgba(255, 255, 255, 0.1);\n  font-size: 16px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.btn-label.btn-light .label-icon {\n  background-color: rgba(33, 37, 41, 0.05);\n}\n\n.btn-label.right {\n  padding-left: 0.9rem;\n  padding-right: 44px;\n}\n\n.btn-label.right .label-icon {\n  right: -1px;\n  left: auto;\n}\n\n.btn-animation {\n  overflow: hidden;\n  -webkit-transition: border-color 0.3s, background-color 0.3s;\n  transition: border-color 0.3s, background-color 0.3s;\n  -webkit-transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\n  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\n}\n\n.btn-animation::after {\n  content: attr(data-text);\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  -webkit-transform: translate3d(0, 25%, 0);\n  transform: translate3d(0, 25%, 0);\n  padding: 0.5rem 0.9rem;\n  -webkit-transition: opacity 0.3s, -webkit-transform 0.3s;\n  transition: opacity 0.3s, -webkit-transform 0.3s;\n  transition: transform 0.3s, opacity 0.3s;\n  transition: transform 0.3s, opacity 0.3s, -webkit-transform 0.3s;\n  -webkit-transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\n  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\n}\n\n.btn-animation > span {\n  display: block;\n  -webkit-transition: opacity 0.3s, -webkit-transform 0.3s;\n  transition: opacity 0.3s, -webkit-transform 0.3s;\n  transition: transform 0.3s, opacity 0.3s;\n  transition: transform 0.3s, opacity 0.3s, -webkit-transform 0.3s;\n  -webkit-transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\n  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\n}\n\n.btn-animation:hover::after {\n  opacity: 1;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n\n.btn-animation:hover > span {\n  opacity: 0;\n  -webkit-transform: translate3d(0, -25%, 0);\n  transform: translate3d(0, -25%, 0);\n}\n\n.btn-primary.btn-animation {\n  background-color: #4b38b3;\n  border-color: #4b38b3;\n}\n\n.btn-primary.btn-animation:active,\n.btn-primary.btn-animation:focus,\n.btn-primary.btn-animation:hover {\n  color: #4b38b3;\n  background-color: rgba(75, 56, 179, 0.1);\n}\n\n.btn-secondary.btn-animation {\n  background-color: #3577f1;\n  border-color: #3577f1;\n}\n\n.btn-secondary.btn-animation:active,\n.btn-secondary.btn-animation:focus,\n.btn-secondary.btn-animation:hover {\n  color: #3577f1;\n  background-color: rgba(53, 119, 241, 0.1);\n}\n\n.btn-success.btn-animation {\n  background-color: #45cb85;\n  border-color: #45cb85;\n}\n\n.btn-success.btn-animation:active,\n.btn-success.btn-animation:focus,\n.btn-success.btn-animation:hover {\n  color: #45cb85;\n  background-color: rgba(69, 203, 133, 0.1);\n}\n\n.btn-info.btn-animation {\n  background-color: #299cdb;\n  border-color: #299cdb;\n}\n\n.btn-info.btn-animation:active,\n.btn-info.btn-animation:focus,\n.btn-info.btn-animation:hover {\n  color: #299cdb;\n  background-color: rgba(41, 156, 219, 0.1);\n}\n\n.btn-warning.btn-animation {\n  background-color: #ffbe0b;\n  border-color: #ffbe0b;\n}\n\n.btn-warning.btn-animation:active,\n.btn-warning.btn-animation:focus,\n.btn-warning.btn-animation:hover {\n  color: #ffbe0b;\n  background-color: rgba(255, 190, 11, 0.1);\n}\n\n.btn-danger.btn-animation {\n  background-color: #f06548;\n  border-color: #f06548;\n}\n\n.btn-danger.btn-animation:active,\n.btn-danger.btn-animation:focus,\n.btn-danger.btn-animation:hover {\n  color: #f06548;\n  background-color: rgba(240, 101, 72, 0.1);\n}\n\n.btn-light.btn-animation {\n  background-color: #f3f6f9;\n  border-color: #f3f6f9;\n}\n\n.btn-light.btn-animation:active,\n.btn-light.btn-animation:focus,\n.btn-light.btn-animation:hover {\n  color: #f3f6f9;\n  background-color: rgba(243, 246, 249, 0.1);\n}\n\n.btn-dark.btn-animation {\n  background-color: #212529;\n  border-color: #212529;\n}\n\n.btn-dark.btn-animation:active,\n.btn-dark.btn-animation:focus,\n.btn-dark.btn-animation:hover {\n  color: #212529;\n  background-color: rgba(33, 37, 41, 0.1);\n}\n\n.btn-group-vertical label {\n  margin-bottom: 0;\n}\n\n.btn-group.radio .btn {\n  border: none;\n}\n\n.btn-group.radio .btn-check:active + .btn-light,\n.btn-group.radio .btn-check:checked + .btn-light,\n.btn-group.radio .btn-light.active,\n.btn-group.radio .btn-light.dropdown-toggle.show,\n.btn-group.radio .btn-light:active {\n  background-color: rgba(41, 156, 219, 0.2);\n  color: #299cdb;\n}\n\n[data-layout-mode=\"dark\"] .btn-check:focus + .btn-light,\n[data-layout-mode=\"dark\"] .btn-check:focus + .btn-outline-light,\n[data-layout-mode=\"dark\"] .btn-check:focus + .btn-soft-light,\n[data-layout-mode=\"dark\"] .btn-soft-light:focus {\n  color: var(--bs-dark);\n  background-color: rgba(var(--bs-light-rgb), 0.75);\n  border-color: rgba(var(--bs-light-rgb), 0.75);\n}\n\n[data-layout-mode=\"dark\"] .btn-check:active + .btn-light,\n[data-layout-mode=\"dark\"] .btn-check:active + .btn-outline-light,\n[data-layout-mode=\"dark\"] .btn-check:active + .btn-soft-light,\n[data-layout-mode=\"dark\"] .btn-check:checked + .btn-light,\n[data-layout-mode=\"dark\"] .btn-check:checked + .btn-outline-light,\n[data-layout-mode=\"dark\"] .btn-check:checked + .btn-soft-light,\n[data-layout-mode=\"dark\"] .btn-light.active,\n[data-layout-mode=\"dark\"] .btn-light:active,\n[data-layout-mode=\"dark\"] .btn-outline-light.active,\n[data-layout-mode=\"dark\"] .btn-outline-light:active,\n[data-layout-mode=\"dark\"] .btn-soft-light.active,\n[data-layout-mode=\"dark\"] .btn-soft-light:active,\n[data-layout-mode=\"dark\"] .show > .btn-light.dropdown-toggle,\n[data-layout-mode=\"dark\"] .show > .btn-outline-light.dropdown-toggle,\n[data-layout-mode=\"dark\"] .show > .btn-soft-light.dropdown-toggle {\n  color: var(--bs-dark);\n  background-color: rgba(var(--bs-light-rgb), 0.75);\n  border-color: rgba(var(--bs-light-rgb), 0.75);\n}\n\n[data-layout-mode=\"dark\"] .btn-check:focus + .btn-dark,\n[data-layout-mode=\"dark\"] .btn-check:focus + .btn-outline-dark,\n[data-layout-mode=\"dark\"] .btn-check:focus + .btn-soft-dark,\n[data-layout-mode=\"dark\"] .btn-soft-dark:focus {\n  color: var(--bs-light);\n  background-color: rgba(var(--bs-dark-rgb), 0.75);\n  border-color: rgba(var(--bs-dark-rgb), 0.75);\n}\n\n[data-layout-mode=\"dark\"] .btn-check:active + .btn-dark,\n[data-layout-mode=\"dark\"] .btn-check:active + .btn-outline-dark,\n[data-layout-mode=\"dark\"] .btn-check:active + .btn-soft-dark,\n[data-layout-mode=\"dark\"] .btn-check:checked + .btn-dark,\n[data-layout-mode=\"dark\"] .btn-check:checked + .btn-outline-dark,\n[data-layout-mode=\"dark\"] .btn-check:checked + .btn-soft-dark,\n[data-layout-mode=\"dark\"] .btn-dark.active,\n[data-layout-mode=\"dark\"] .btn-dark:active,\n[data-layout-mode=\"dark\"] .btn-outline-dark.active,\n[data-layout-mode=\"dark\"] .btn-outline-dark:active,\n[data-layout-mode=\"dark\"] .btn-soft-dark.active,\n[data-layout-mode=\"dark\"] .btn-soft-dark:active,\n[data-layout-mode=\"dark\"] .show > .btn-dark.dropdown-toggle,\n[data-layout-mode=\"dark\"] .show > .btn-outline-dark.dropdown-toggle,\n[data-layout-mode=\"dark\"] .show > .btn-soft-dark.dropdown-toggle {\n  color: var(--bs-light);\n  background-color: rgba(var(--bs-dark-rgb), 0.75);\n  border-color: rgba(var(--bs-dark-rgb), 0.75);\n}\n\n[data-layout-mode=\"dark\"] .btn-soft-light {\n  color: var(--bs-dark);\n  background-color: rgba(var(--bs-light-rgb), 0.1);\n}\n\n[data-layout-mode=\"dark\"] .btn-soft-light:hover {\n  color: var(--bs-dark);\n  background-color: var(--bs-light);\n}\n\n[data-layout-mode=\"dark\"] .btn-soft-dark {\n  color: var(--bs-dark);\n  background-color: rgba(var(--bs-dark-rgb), 0.1);\n}\n\n[data-layout-mode=\"dark\"] .btn-soft-dark:hover {\n  color: var(--bs-light);\n  background-color: var(--bs-dark);\n}\n\n[data-layout-mode=\"dark\"] .btn-ghost-light {\n  color: var(--bs-dark);\n}\n\n[data-layout-mode=\"dark\"] .btn-ghost-light:active,\n[data-layout-mode=\"dark\"] .btn-ghost-light:focus,\n[data-layout-mode=\"dark\"] .btn-ghost-light:hover {\n  color: var(--bs-dark);\n  background-color: rgba(var(--bs-light-rgb), 0.5);\n}\n\n[data-layout-mode=\"dark\"] .btn-ghost-dark {\n  color: var(--bs-dark);\n}\n\n[data-layout-mode=\"dark\"] .btn-ghost-dark:active,\n[data-layout-mode=\"dark\"] .btn-ghost-dark:focus,\n[data-layout-mode=\"dark\"] .btn-ghost-dark:hover {\n  color: var(--bs-dark);\n  background-color: rgba(var(--bs-dark-rgb), 0.1);\n}\n\n.btn-load .spinner-border,\n.btn-load .spinner-grow {\n  height: 19px;\n  width: 19px;\n}\n\n.btn-outline-primary.btn-border,\n.btn-primary.btn-border,\n.btn-soft-primary.btn-border {\n  border-bottom: 2px solid #3e2e94;\n}\n\n.btn-outline-secondary.btn-border,\n.btn-secondary.btn-border,\n.btn-soft-secondary.btn-border {\n  border-bottom: 2px solid #105eed;\n}\n\n.btn-outline-success.btn-border,\n.btn-soft-success.btn-border,\n.btn-success.btn-border {\n  border-bottom: 2px solid #33b571;\n}\n\n.btn-info.btn-border,\n.btn-outline-info.btn-border,\n.btn-soft-info.btn-border {\n  border-bottom: 2px solid #2084bc;\n}\n\n.btn-outline-warning.btn-border,\n.btn-soft-warning.btn-border,\n.btn-warning.btn-border {\n  border-bottom: 2px solid #e1a500;\n}\n\n.btn-danger.btn-border,\n.btn-outline-danger.btn-border,\n.btn-soft-danger.btn-border {\n  border-bottom: 2px solid #ed4522;\n}\n\n.btn-light.btn-border,\n.btn-outline-light.btn-border,\n.btn-soft-light.btn-border {\n  border-bottom: 2px solid #d8e2eb;\n}\n\n.btn-dark.btn-border,\n.btn-outline-dark.btn-border,\n.btn-soft-dark.btn-border {\n  border-bottom: 2px solid #0f1112;\n}\n\n.custom-toggle .icon-off {\n  display: none;\n}\n\n.custom-toggle.active .icon-on {\n  display: none;\n}\n\n.custom-toggle.active .icon-off {\n  display: block;\n}\n\n.breadcrumb-item > a {\n  color: var(--bs-gray-700);\n}\n\n.breadcrumb-item + .breadcrumb-item::before {\n  font-family: \"Material Design Icons\";\n  font-size: 15px;\n  line-height: 20px;\n}\n\n.card {\n  margin-bottom: 1.5rem;\n  -webkit-box-shadow: var(--bs-box-shadow);\n  box-shadow: var(--bs-box-shadow);\n}\n\n.card-header {\n  border-bottom: 1px solid var(--bs-border-color);\n}\n\n.card-header-dropdown .dropdown-btn {\n  padding: 1rem 0;\n}\n\n.card-footer {\n  border-top: 1px solid var(--bs-border-color);\n}\n\n.card-drop {\n  color: #212529;\n}\n\n.card-title {\n  font-size: 16px;\n  margin: 0 0 7px 0;\n}\n\n.card-title-desc {\n  margin-bottom: 24px;\n}\n\n.card-height-100 {\n  height: calc(100% - 1.5rem);\n}\n\n.card-animate {\n  -webkit-transition: all 0.4s;\n  transition: all 0.4s;\n}\n\n.card-animate:hover {\n  -webkit-transform: translateY(calc(-1.5rem / 5));\n  transform: translateY(calc(-1.5rem / 5));\n  -webkit-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n}\n\n.card-primary {\n  color: #fff;\n  background-color: #4b38b3;\n}\n\n.card-primary .card-footer,\n.card-primary .card-header {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  border-color: transparent;\n}\n\n.card-primary .card-title {\n  color: #fff;\n}\n\n.card-secondary {\n  color: #fff;\n  background-color: #3577f1;\n}\n\n.card-secondary .card-footer,\n.card-secondary .card-header {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  border-color: transparent;\n}\n\n.card-secondary .card-title {\n  color: #fff;\n}\n\n.card-success {\n  color: #fff;\n  background-color: #45cb85;\n}\n\n.card-success .card-footer,\n.card-success .card-header {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  border-color: transparent;\n}\n\n.card-success .card-title {\n  color: #fff;\n}\n\n.card-info {\n  color: #fff;\n  background-color: #299cdb;\n}\n\n.card-info .card-footer,\n.card-info .card-header {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  border-color: transparent;\n}\n\n.card-info .card-title {\n  color: #fff;\n}\n\n.card-warning {\n  color: #fff;\n  background-color: #ffbe0b;\n}\n\n.card-warning .card-footer,\n.card-warning .card-header {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  border-color: transparent;\n}\n\n.card-warning .card-title {\n  color: #fff;\n}\n\n.card-danger {\n  color: #fff;\n  background-color: #f06548;\n}\n\n.card-danger .card-footer,\n.card-danger .card-header {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  border-color: transparent;\n}\n\n.card-danger .card-title {\n  color: #fff;\n}\n\n.card-light {\n  color: #fff;\n  background-color: #f3f6f9;\n}\n\n.card-light .card-footer,\n.card-light .card-header {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  border-color: transparent;\n}\n\n.card-light .card-title {\n  color: #fff;\n}\n\n.card-dark {\n  color: #fff;\n  background-color: #212529;\n}\n\n.card-dark .card-footer,\n.card-dark .card-header {\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  border-color: transparent;\n}\n\n.card-dark .card-title {\n  color: #fff;\n}\n\n.card-border-primary {\n  border-color: #4b38b3 !important;\n}\n\n.card-border-primary .card-footer,\n.card-border-primary .card-header {\n  border-color: #4b38b3;\n}\n\n.card-border-secondary {\n  border-color: #3577f1 !important;\n}\n\n.card-border-secondary .card-footer,\n.card-border-secondary .card-header {\n  border-color: #3577f1;\n}\n\n.card-border-success {\n  border-color: #45cb85 !important;\n}\n\n.card-border-success .card-footer,\n.card-border-success .card-header {\n  border-color: #45cb85;\n}\n\n.card-border-info {\n  border-color: #299cdb !important;\n}\n\n.card-border-info .card-footer,\n.card-border-info .card-header {\n  border-color: #299cdb;\n}\n\n.card-border-warning {\n  border-color: #ffbe0b !important;\n}\n\n.card-border-warning .card-footer,\n.card-border-warning .card-header {\n  border-color: #ffbe0b;\n}\n\n.card-border-danger {\n  border-color: #f06548 !important;\n}\n\n.card-border-danger .card-footer,\n.card-border-danger .card-header {\n  border-color: #f06548;\n}\n\n.card-border-light {\n  border-color: #f3f6f9 !important;\n}\n\n.card-border-light .card-footer,\n.card-border-light .card-header {\n  border-color: #f3f6f9;\n}\n\n.card-border-dark {\n  border-color: #212529 !important;\n}\n\n.card-border-dark .card-footer,\n.card-border-dark .card-header {\n  border-color: #212529;\n}\n\n.card-light {\n  background-color: var(--bs-light);\n}\n\n.card-light .card-footer,\n.card-light .card-header {\n  color: var(--bs-body-color) !important;\n  background-color: rgba(var(--bs-dark-rgb), 0.1);\n}\n\n.card-light .card-text,\n.card-light .card-title {\n  color: var(--bs-body-color) !important;\n}\n\n.stretched-link {\n  position: static;\n}\n\n.card-preloader {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(var(--bs-light-rgb), 0.6);\n  z-index: 9999;\n}\n\n.card-status {\n  width: 40px;\n  height: 40px;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%) !important;\n  transform: translate(-50%, -50%) !important;\n}\n\n.custom-loader {\n  -webkit-animation: spin 2s linear infinite;\n  animation: spin 2s linear infinite;\n}\n\n@-webkit-keyframes spin {\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes spin {\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n.card-overlay {\n  position: relative;\n  overflow: hidden;\n}\n\n.card-overlay:before {\n  content: \"\";\n  background-color: rgba(75, 56, 179, 0.2);\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  bottom: 0;\n}\n\n.card-overlay .card-footer,\n.card-overlay .card-header {\n  border-color: rgba(255, 255, 255, 0.15) !important;\n}\n\n.card-toolbar-menu {\n  line-height: 0.8;\n}\n\n.card-toolbar-menu a {\n  font-size: 17px;\n}\n\n.card-toolbar-menu .minimize-card .plus {\n  display: none;\n}\n\n.card-toolbar-menu .minimize-card .minus {\n  display: block;\n}\n\n.card-toolbar-menu .minimize-card.collapsed .plus {\n  display: block;\n}\n\n.card-toolbar-menu .minimize-card.collapsed .minus {\n  display: none;\n}\n\n.dropdown-toggle::after {\n  display: inline-block;\n  margin-left: 0.255em;\n  font-size: 15px;\n  line-height: 15px;\n  content: \"\\f0140\";\n  font-family: \"Material Design Icons\";\n}\n\n.dropdown-menu {\n  -webkit-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n  -webkit-animation-name: DropDownSlide;\n  animation-name: DropDownSlide;\n  -webkit-animation-duration: 0.3s;\n  animation-duration: 0.3s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  position: absolute;\n  z-index: 1000;\n}\n\n.dropdown-menu.dropdown-megamenu {\n  padding: 20px;\n  left: 0 !important;\n  right: 0 !important;\n}\n\n.dropdown-menu[data-popper-placement=\"top-start\"] {\n  -webkit-animation-name: DropDownSlideDown;\n  animation-name: DropDownSlideDown;\n}\n\n@-webkit-keyframes DropDownSlide {\n  100% {\n    margin-top: -1px;\n  }\n\n  0% {\n    margin-top: 8px;\n  }\n}\n\n@keyframes DropDownSlide {\n  100% {\n    margin-top: -1px;\n  }\n\n  0% {\n    margin-top: 8px;\n  }\n}\n\n@-webkit-keyframes DropDownSlideDown {\n  100% {\n    margin-bottom: 0;\n  }\n\n  0% {\n    margin-bottom: 8px;\n  }\n}\n\n@keyframes DropDownSlideDown {\n  100% {\n    margin-bottom: 0;\n  }\n\n  0% {\n    margin-bottom: 8px;\n  }\n}\n\n@media (min-width: 600px) {\n  .dropdown-menu-xl {\n    width: 420px;\n  }\n\n  .dropdown-menu-lg {\n    width: 320px;\n  }\n\n  .dropdown-menu-md {\n    width: 240px;\n  }\n}\n\n.dropdown-toggle-split {\n  border-left: none;\n}\n\n.dropdown-toggle-split::after {\n  margin-left: 0;\n}\n\n.dropdown-toggle-split:before {\n  content: \"\";\n  position: absolute;\n  background-color: rgba(255, 255, 255, 0.12);\n  top: -1px;\n  bottom: -1px;\n  right: -1px;\n  left: 0;\n  border-radius: 0 0.25rem 0.25rem 0;\n}\n\n.dropdown-mega {\n  position: static !important;\n}\n\n.dropdown-mega-menu-xl {\n  width: 38rem;\n}\n\n.dropdown-mega-menu-lg {\n  width: 26rem;\n}\n\n[dir=\"ltr\"] .dropdown-menu-start {\n  --bs-position: end;\n}\n\n[dir=\"ltr\"] .dropdown-menu-end {\n  --bs-position: start;\n}\n\n.dropdown-head .nav-tabs-custom {\n  border: 0;\n}\n\n.dropdown-head .nav-tabs-custom .nav-link {\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.dropdown-head .nav-tabs-custom .nav-link.active {\n  background-color: var(--bs-dropdown-bg);\n}\n\n.dropdown-head .nav-tabs-custom .nav-link:hover {\n  color: #fff;\n}\n\n.dropdownmenu-primary .dropdown-item.active,\n.dropdownmenu-primary .dropdown-item:focus,\n.dropdownmenu-primary .dropdown-item:hover {\n  background-color: rgba(75, 56, 179, 0.07);\n  color: #4b38b3;\n}\n\n.dropdownmenu-secondary .dropdown-item.active,\n.dropdownmenu-secondary .dropdown-item:focus,\n.dropdownmenu-secondary .dropdown-item:hover {\n  background-color: rgba(53, 119, 241, 0.07);\n  color: #3577f1;\n}\n\n.dropdownmenu-success .dropdown-item.active,\n.dropdownmenu-success .dropdown-item:focus,\n.dropdownmenu-success .dropdown-item:hover {\n  background-color: rgba(69, 203, 133, 0.07);\n  color: #45cb85;\n}\n\n.dropdownmenu-info .dropdown-item.active,\n.dropdownmenu-info .dropdown-item:focus,\n.dropdownmenu-info .dropdown-item:hover {\n  background-color: rgba(41, 156, 219, 0.07);\n  color: #299cdb;\n}\n\n.dropdownmenu-warning .dropdown-item.active,\n.dropdownmenu-warning .dropdown-item:focus,\n.dropdownmenu-warning .dropdown-item:hover {\n  background-color: rgba(255, 190, 11, 0.07);\n  color: #ffbe0b;\n}\n\n.dropdownmenu-danger .dropdown-item.active,\n.dropdownmenu-danger .dropdown-item:focus,\n.dropdownmenu-danger .dropdown-item:hover {\n  background-color: rgba(240, 101, 72, 0.07);\n  color: #f06548;\n}\n\n.dropdownmenu-light .dropdown-item.active,\n.dropdownmenu-light .dropdown-item:focus,\n.dropdownmenu-light .dropdown-item:hover {\n  background-color: rgba(243, 246, 249, 0.07);\n  color: #f3f6f9;\n}\n\n.dropdownmenu-dark .dropdown-item.active,\n.dropdownmenu-dark .dropdown-item:focus,\n.dropdownmenu-dark .dropdown-item:hover {\n  background-color: rgba(33, 37, 41, 0.07);\n  color: #212529;\n}\n\n.nav-pills > li > a,\n.nav-tabs > li > a {\n  color: var(--bs-gray-700);\n  font-weight: 500;\n}\n\n.nav-pills > a {\n  color: var(--bs-gray-700);\n  font-weight: 500;\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  -webkit-box-shadow: var(--bs-box-shadow);\n  box-shadow: var(--bs-box-shadow);\n}\n\n.nav-tabs-custom {\n  border-bottom: 1px solid var(--bs-gray-300);\n}\n\n.nav-tabs-custom .nav-item {\n  position: relative;\n}\n\n.nav-tabs-custom .nav-item .nav-link {\n  border: none;\n  font-weight: 500;\n}\n\n.nav-tabs-custom .nav-item .nav-link::after {\n  content: \"\";\n  background: #4b38b3;\n  height: 1px;\n  position: absolute;\n  width: 100%;\n  left: 0;\n  bottom: 0;\n  -webkit-transition: all 250ms ease 0s;\n  transition: all 250ms ease 0s;\n  -webkit-transform: scale(0);\n  transform: scale(0);\n}\n\n.nav-tabs-custom .nav-item .nav-link.active {\n  color: #4b38b3;\n}\n\n.nav-tabs-custom .nav-item .nav-link.active:after {\n  -webkit-transform: scale(1);\n  transform: scale(1);\n}\n\n.nav-tabs-custom.card-header-tabs {\n  margin-top: -1rem;\n}\n\n.nav-tabs-custom.card-header-tabs .nav-link {\n  padding: 1rem 1rem;\n}\n\n.vertical-nav .nav .nav-link {\n  padding: 24px 16px;\n  text-align: center;\n  margin-bottom: 8px;\n}\n\n.vertical-nav .nav .nav-link .nav-icon {\n  font-size: 24px;\n}\n\n.navtab-bg li > a {\n  background-color: #e9ebec;\n  margin: 0 5px;\n}\n\n.arrow-navtabs .nav-item .nav-link {\n  position: relative;\n  text-align: center;\n}\n\n.arrow-navtabs .nav-item .nav-link:before {\n  content: \"\";\n  position: absolute;\n  border: 6px solid transparent;\n  bottom: -12px;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  -webkit-transition: color 0.15s ease-in-out,\n    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .arrow-navtabs .nav-item .nav-link:before {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.arrow-navtabs .nav-item .nav-link.active:before {\n  border-top-color: #4b38b3;\n}\n\n.custom-hover-nav-tabs .nav-item {\n  text-align: center;\n  overflow: hidden;\n}\n\n.custom-hover-nav-tabs .nav-item .nav-link {\n  width: 120px;\n  height: 45px;\n  position: relative;\n  border-radius: 0;\n}\n\n.custom-hover-nav-tabs .nav-item .nav-link .nav-icon {\n  font-size: 22px;\n}\n\n.custom-hover-nav-tabs .nav-item .nav-link .nav-titl {\n  font-size: 14px;\n}\n\n.custom-hover-nav-tabs .nav-item .nav-link.active .nav-tab-position {\n  color: #fff;\n}\n\n.custom-hover-nav-tabs .nav-item .nav-link .nav-tab-position {\n  position: absolute;\n  left: 0;\n  right: 0;\n  -webkit-transition: all 0.4s;\n  transition: all 0.4s;\n}\n\n.custom-hover-nav-tabs .nav-item .nav-link .nav-tab-position.nav-icon {\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n.custom-hover-nav-tabs .nav-item .nav-link .nav-tab-position.nav-titl {\n  bottom: -20px;\n}\n\n.custom-hover-nav-tabs .nav-item .nav-link:hover .nav-titl {\n  bottom: 50%;\n  -webkit-transform: translateY(50%);\n  transform: translateY(50%);\n}\n\n.custom-hover-nav-tabs .nav-item .nav-link:hover .nav-icon {\n  top: -20px;\n}\n\n.custom-verti-nav-pills .nav-link {\n  background-color: var(--bs-light);\n  margin-top: 7px;\n  position: relative;\n}\n\n@media (min-width: 992px) {\n  .custom-verti-nav-pills .nav-link::before {\n    content: \"\";\n    position: absolute;\n    right: -20px;\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n    border: 12px solid transparent;\n    border-left-color: transparent;\n    -webkit-transition: border-left-color 0.04 ease;\n    transition: border-left-color 0.04 ease;\n  }\n\n  .custom-verti-nav-pills .nav-link.active::before {\n    border-left-color: #4b38b3;\n  }\n}\n\n.animation-nav li {\n  position: relative;\n}\n\n.animation-nav li a {\n  color: var(--bs-body-color);\n  border-radius: 4px;\n  position: relative;\n  overflow: hidden;\n  -webkit-transition: all 0.4s;\n  transition: all 0.4s;\n  z-index: 1;\n}\n\n.animation-nav li a span {\n  position: relative;\n}\n\n.animation-nav li a::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  width: 0;\n  right: 0;\n  height: 100%;\n  -webkit-transition: width 0.4s cubic-bezier(0.51, 0.18, 0, 0.88) 0.1s;\n  transition: width 0.4s cubic-bezier(0.51, 0.18, 0, 0.88) 0.1s;\n  background-color: #4b38b3;\n  z-index: -1;\n}\n\n.animation-nav li a.active,\n.animation-nav li a:hover {\n  color: #fff;\n  background-color: transparent !important;\n}\n\n.animation-nav li a.active::before,\n.animation-nav li a:hover::before {\n  width: 100%;\n  left: 0;\n}\n\n.nav-border-top .nav-link {\n  border-top: 3px solid transparent;\n}\n\n.nav-border-top .nav-link.active {\n  border-top-color: #4b38b3;\n}\n\n.nav-border-top-primary .nav-link.active {\n  color: #4b38b3;\n  border-top-color: #4b38b3;\n}\n\n.nav-border-top-secondary .nav-link.active {\n  color: #3577f1;\n  border-top-color: #3577f1;\n}\n\n.nav-border-top-success .nav-link.active {\n  color: #45cb85;\n  border-top-color: #45cb85;\n}\n\n.nav-border-top-info .nav-link.active {\n  color: #299cdb;\n  border-top-color: #299cdb;\n}\n\n.nav-border-top-warning .nav-link.active {\n  color: #ffbe0b;\n  border-top-color: #ffbe0b;\n}\n\n.nav-border-top-danger .nav-link.active {\n  color: #f06548;\n  border-top-color: #f06548;\n}\n\n.nav-border-top-light .nav-link.active {\n  color: #f3f6f9;\n  border-top-color: #f3f6f9;\n}\n\n.nav-border-top-dark .nav-link.active {\n  color: #212529;\n  border-top-color: #212529;\n}\n\n.nav-custom {\n  background-color: #4b38b3;\n  border-radius: 0.25rem;\n}\n\n.nav-custom .nav-item .nav-link {\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.nav-custom .nav-item .nav-link.active {\n  color: #fff;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.nav-custom.nav-custom-light .nav-item .nav-link {\n  color: rgba(var(--bs-dark-rgb), 0.75);\n}\n\n.nav-custom.nav-custom-light .nav-item .nav-link.active {\n  color: #f3f6f9;\n  background-color: #4b38b3;\n}\n\n.nav-custom-primary {\n  background-color: #4b38b3;\n}\n\n.nav-custom-secondary {\n  background-color: #3577f1;\n}\n\n.nav-custom-success {\n  background-color: #45cb85;\n}\n\n.nav-custom-info {\n  background-color: #299cdb;\n}\n\n.nav-custom-warning {\n  background-color: #ffbe0b;\n}\n\n.nav-custom-danger {\n  background-color: #f06548;\n}\n\n.nav-custom-light {\n  background-color: #f3f6f9;\n}\n\n.nav-custom-dark {\n  background-color: #212529;\n}\n\n.nav-custom-light {\n  background-color: var(--bs-light);\n}\n\n.nav-primary .nav-link.active {\n  color: #fff;\n  background-color: #4b38b3;\n}\n\n.nav-primary.nav-tabs .nav-link.active {\n  color: #4b38b3;\n  background-color: var(--bs-card-bg-custom);\n}\n\n.nav-primary.nav-tabs-custom .nav-link.active {\n  color: #4b38b3;\n  background-color: var(--bs-card-bg-custom);\n}\n\n.nav-primary.nav-tabs-custom .nav-link.active::after {\n  background-color: #4b38b3;\n}\n\n.nav-primary.arrow-navtabs .nav-link.active::before {\n  border-top-color: #4b38b3;\n}\n\n.nav-primary.custom-verti-nav-pills .nav-link.active::before {\n  border-left-color: #4b38b3;\n}\n\n.nav-secondary .nav-link.active {\n  color: #fff;\n  background-color: #3577f1;\n}\n\n.nav-secondary.nav-tabs .nav-link.active {\n  color: #3577f1;\n  background-color: var(--bs-card-bg-custom);\n}\n\n.nav-secondary.nav-tabs-custom .nav-link.active {\n  color: #3577f1;\n  background-color: var(--bs-card-bg-custom);\n}\n\n.nav-secondary.nav-tabs-custom .nav-link.active::after {\n  background-color: #3577f1;\n}\n\n.nav-secondary.arrow-navtabs .nav-link.active::before {\n  border-top-color: #3577f1;\n}\n\n.nav-secondary.custom-verti-nav-pills .nav-link.active::before {\n  border-left-color: #3577f1;\n}\n\n.nav-success .nav-link.active {\n  color: #fff;\n  background-color: #45cb85;\n}\n\n.nav-success.nav-tabs .nav-link.active {\n  color: #45cb85;\n  background-color: var(--bs-card-bg-custom);\n}\n\n.nav-success.nav-tabs-custom .nav-link.active {\n  color: #45cb85;\n  background-color: var(--bs-card-bg-custom);\n}\n\n.nav-success.nav-tabs-custom .nav-link.active::after {\n  background-color: #45cb85;\n}\n\n.nav-success.arrow-navtabs .nav-link.active::before {\n  border-top-color: #45cb85;\n}\n\n.nav-success.custom-verti-nav-pills .nav-link.active::before {\n  border-left-color: #45cb85;\n}\n\n.nav-info .nav-link.active {\n  color: #fff;\n  background-color: #299cdb;\n}\n\n.nav-info.nav-tabs .nav-link.active {\n  color: #299cdb;\n  background-color: var(--bs-card-bg-custom);\n}\n\n.nav-info.nav-tabs-custom .nav-link.active {\n  color: #299cdb;\n  background-color: var(--bs-card-bg-custom);\n}\n\n.nav-info.nav-tabs-custom .nav-link.active::after {\n  background-color: #299cdb;\n}\n\n.nav-info.arrow-navtabs .nav-link.active::before {\n  border-top-color: #299cdb;\n}\n\n.nav-info.custom-verti-nav-pills .nav-link.active::before {\n  border-left-color: #299cdb;\n}\n\n.nav-warning .nav-link.active {\n  color: #fff;\n  background-color: #ffbe0b;\n}\n\n.nav-warning.nav-tabs .nav-link.active {\n  color: #ffbe0b;\n  background-color: var(--bs-card-bg-custom);\n}\n\n.nav-warning.nav-tabs-custom .nav-link.active {\n  color: #ffbe0b;\n  background-color: var(--bs-card-bg-custom);\n}\n\n.nav-warning.nav-tabs-custom .nav-link.active::after {\n  background-color: #ffbe0b;\n}\n\n.nav-warning.arrow-navtabs .nav-link.active::before {\n  border-top-color: #ffbe0b;\n}\n\n.nav-warning.custom-verti-nav-pills .nav-link.active::before {\n  border-left-color: #ffbe0b;\n}\n\n.nav-danger .nav-link.active {\n  color: #fff;\n  background-color: #f06548;\n}\n\n.nav-danger.nav-tabs .nav-link.active {\n  color: #f06548;\n  background-color: var(--bs-card-bg-custom);\n}\n\n.nav-danger.nav-tabs-custom .nav-link.active {\n  color: #f06548;\n  background-color: var(--bs-card-bg-custom);\n}\n\n.nav-danger.nav-tabs-custom .nav-link.active::after {\n  background-color: #f06548;\n}\n\n.nav-danger.arrow-navtabs .nav-link.active::before {\n  border-top-color: #f06548;\n}\n\n.nav-danger.custom-verti-nav-pills .nav-link.active::before {\n  border-left-color: #f06548;\n}\n\n.nav-light .nav-link.active {\n  color: #fff;\n  background-color: #f3f6f9;\n}\n\n.nav-light.nav-tabs .nav-link.active {\n  color: #f3f6f9;\n  background-color: var(--bs-card-bg-custom);\n}\n\n.nav-light.nav-tabs-custom .nav-link.active {\n  color: #f3f6f9;\n  background-color: var(--bs-card-bg-custom);\n}\n\n.nav-light.nav-tabs-custom .nav-link.active::after {\n  background-color: #f3f6f9;\n}\n\n.nav-light.arrow-navtabs .nav-link.active::before {\n  border-top-color: #f3f6f9;\n}\n\n.nav-light.custom-verti-nav-pills .nav-link.active::before {\n  border-left-color: #f3f6f9;\n}\n\n.nav-dark .nav-link.active {\n  color: #fff;\n  background-color: #212529;\n}\n\n.nav-dark.nav-tabs .nav-link.active {\n  color: #212529;\n  background-color: var(--bs-card-bg-custom);\n}\n\n.nav-dark.nav-tabs-custom .nav-link.active {\n  color: #212529;\n  background-color: var(--bs-card-bg-custom);\n}\n\n.nav-dark.nav-tabs-custom .nav-link.active::after {\n  background-color: #212529;\n}\n\n.nav-dark.arrow-navtabs .nav-link.active::before {\n  border-top-color: #212529;\n}\n\n.nav-dark.custom-verti-nav-pills .nav-link.active::before {\n  border-left-color: #212529;\n}\n\n.progress-nav {\n  position: relative;\n  margin-right: 1rem;\n  margin-left: 1rem;\n}\n\n.progress-nav .progress {\n  position: absolute;\n  left: 0;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n  width: 100%;\n}\n\n.progress-nav .nav {\n  margin-right: -1rem;\n  margin-left: -1rem;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.progress-nav .nav .nav-link {\n  width: 2rem;\n  height: 2rem;\n  background-color: var(--bs-light);\n  padding: 0;\n  color: var(--bs-dark);\n  font-weight: 500;\n}\n\n.progress-nav .nav .nav-link.active,\n.progress-nav .nav .nav-link.done {\n  background-color: #4b38b3;\n  color: #fff;\n}\n\n.step-arrow-nav .nav {\n  background-color: var(--bs-light);\n}\n\n.step-arrow-nav .nav .nav-link {\n  border-radius: 0;\n  position: relative;\n  font-weight: 500;\n  color: var(--bs-dark);\n}\n\n.step-arrow-nav .nav .nav-link::before {\n  content: \"\";\n  position: absolute;\n  border: 7px solid transparent;\n  right: -14px;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n.step-arrow-nav .nav .nav-link.done {\n  background-color: rgba(75, 56, 179, 0.05);\n  color: #4b38b3;\n}\n\n.step-arrow-nav .nav .nav-link.done::before {\n  border-left-color: transparent;\n}\n\n.step-arrow-nav .nav .nav-link.active {\n  background-color: rgba(75, 56, 179, 0.1);\n  color: #4b38b3;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.step-arrow-nav .nav .nav-link.active::before {\n  border-left-color: rgba(75, 56, 179, 0.1);\n}\n\n.step-arrow-nav .nav .nav-item:last-child .nav-link:before {\n  display: none;\n}\n\n.vertical-navs-step .nav {\n  gap: 16px;\n}\n\n.vertical-navs-step .nav .nav-link {\n  text-align: left;\n  background-color: rgba(var(--bs-light-rgb), 0.4);\n  border: 1px solid var(--bs-border-color);\n  color: var(--bs-dark);\n}\n\n.vertical-navs-step .nav .nav-link .step-title {\n  font-weight: 600;\n}\n\n.vertical-navs-step .nav .nav-link .step-icon {\n  color: #f06548;\n  vertical-align: middle;\n  font-weight: 500;\n  float: left;\n}\n\n.vertical-navs-step .nav .nav-link.active .step-icon,\n.vertical-navs-step .nav .nav-link.done .step-icon {\n  color: #45cb85;\n}\n\n.vertical-navs-step .nav .nav-link.active .step-icon:before,\n.vertical-navs-step .nav .nav-link.done .step-icon:before {\n  content: \"\\eb80\";\n}\n\n.vertical-navs-step .nav .nav-link.active {\n  border-color: #4b38b3;\n}\n\n.vertical-navs-step .nav .nav-link.done {\n  border-color: #45cb85;\n}\n\n.nav-custom-outline.nav .nav-link {\n  border: 1px solid transparent;\n  border-bottom: 2px solid transparent;\n}\n\n.nav-custom-outline.nav .nav-link.active {\n  border-color: #4b38b3;\n  background-color: transparent;\n  color: #4b38b3;\n}\n\n.nav-primary.nav-custom-outline .nav-link.active {\n  color: #4b38b3;\n  border-color: #4b38b3;\n}\n\n.nav-secondary.nav-custom-outline .nav-link.active {\n  color: #3577f1;\n  border-color: #3577f1;\n}\n\n.nav-success.nav-custom-outline .nav-link.active {\n  color: #45cb85;\n  border-color: #45cb85;\n}\n\n.nav-info.nav-custom-outline .nav-link.active {\n  color: #299cdb;\n  border-color: #299cdb;\n}\n\n.nav-warning.nav-custom-outline .nav-link.active {\n  color: #ffbe0b;\n  border-color: #ffbe0b;\n}\n\n.nav-danger.nav-custom-outline .nav-link.active {\n  color: #f06548;\n  border-color: #f06548;\n}\n\n.nav-light.nav-custom-outline .nav-link.active {\n  color: #f3f6f9;\n  border-color: #f3f6f9;\n}\n\n.nav-dark.nav-custom-outline .nav-link.active {\n  color: #212529;\n  border-color: #212529;\n}\n\n.nav-customs.nav {\n  padding-left: 34px;\n  overflow: hidden;\n}\n\n.nav-customs.nav .nav-link {\n  position: relative;\n  display: block;\n  float: right;\n  background-color: var(--bs-body-bg);\n  margin-right: 46px;\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n}\n\n.nav-customs.nav .nav-link::after,\n.nav-customs.nav .nav-link::before {\n  display: block;\n  content: \" \";\n  position: absolute;\n  top: -1px;\n  bottom: -1px;\n  width: 37px;\n  background-color: var(--bs-body-bg);\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n}\n\n.nav-customs.nav .nav-link::before {\n  border-radius: 0 8px 0 0;\n  right: -24px;\n  -webkit-transform: skew(30deg, 0deg);\n  transform: skew(30deg, 0deg);\n}\n\n.nav-customs.nav .nav-link::after {\n  border-radius: 8px 0 0 0;\n  left: -24px;\n  -webkit-transform: skew(-30deg, 0deg);\n  transform: skew(-30deg, 0deg);\n}\n\n.nav-customs.nav .nav-link.active,\n.nav-customs.nav .nav-link.active:after,\n.nav-customs.nav .nav-link.active:before {\n  background-color: #4b38b3;\n  color: #fff;\n}\n\n.nav-customs.nav .nav-link.active {\n  z-index: 1;\n}\n\n.table th {\n  font-weight: 600;\n}\n\n.table > thead {\n  border-color: var(--bs-border-color);\n}\n\n.table > :not(:first-child) {\n  border-top-width: 1px;\n}\n\n.table-nowrap td,\n.table-nowrap th {\n  white-space: nowrap;\n}\n\n.table-card {\n  margin: -1rem -1rem;\n}\n\n.table-card td:first-child,\n.table-card th:first-child {\n  padding-left: 16px;\n}\n\n.table-card td:last-child,\n.table-card th:last-child {\n  padding-right: 16px;\n}\n\n.table-card .table > :not(:first-child) {\n  border-top-width: 1px;\n}\n\n.border-primary.table > thead {\n  border-color: #4b38b3 !important;\n}\n\n.table-primary.table > thead {\n  border-bottom-color: #6654ca !important;\n}\n\n.border-secondary.table > thead {\n  border-color: #3577f1 !important;\n}\n\n.table-secondary.table > thead {\n  border-bottom-color: #6597f4 !important;\n}\n\n.border-success.table > thead {\n  border-color: #45cb85 !important;\n}\n\n.table-success.table > thead {\n  border-bottom-color: #6dd69f !important;\n}\n\n.border-info.table > thead {\n  border-color: #299cdb !important;\n}\n\n.table-info.table > thead {\n  border-bottom-color: #55b0e2 !important;\n}\n\n.border-warning.table > thead {\n  border-color: #ffbe0b !important;\n}\n\n.table-warning.table > thead {\n  border-bottom-color: #ffcc3e !important;\n}\n\n.border-danger.table > thead {\n  border-color: #f06548 !important;\n}\n\n.table-danger.table > thead {\n  border-bottom-color: #f48d77 !important;\n}\n\n.border-light.table > thead {\n  border-color: #f3f6f9 !important;\n}\n\n.table-light.table > thead {\n  border-bottom-color: #fff !important;\n}\n\n.border-dark.table > thead {\n  border-color: #212529 !important;\n}\n\n.table-dark.table > thead {\n  border-bottom-color: #383f45 !important;\n}\n\n.table .form-check {\n  padding-left: 0;\n  margin-bottom: 0;\n}\n\n.table .form-check .form-check-input {\n  margin-left: 0;\n  margin-top: 0;\n  float: none;\n  vertical-align: middle;\n}\n\n.table .sort {\n  position: relative;\n}\n\n.table .sort::before {\n  content: \"\\f035d\";\n  position: absolute;\n  right: 0.5rem;\n  top: 18px;\n  font-size: 0.8rem;\n  font-family: \"Material Design Icons\";\n}\n\n.table .sort::after {\n  position: absolute;\n  right: 0.5rem;\n  content: \"\\f0360\";\n  font-family: \"Material Design Icons\";\n  font-size: 0.8rem;\n  top: 12px;\n}\n\n.modal-title {\n  font-weight: 600;\n}\n\n.modal-dialog:not(.modal-dialog-scrollable) .modal-header {\n  padding-bottom: 0;\n}\n\n.modal-dialog:not(.modal-dialog-scrollable) .modal-header .btn-close {\n  margin-top: -1.25rem 1.25rem;\n}\n\n.modal-dialog:not(.modal-dialog-scrollable) .modal-footer {\n  padding-top: 0;\n}\n\n.modal.fadeInRight .modal-dialog {\n  opacity: 0;\n  -webkit-transform: translateX(20%);\n  transform: translateX(20%);\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n\n.modal.fadeInRight.show .modal-dialog {\n  opacity: 1;\n  -webkit-transform: translateX(0);\n  transform: translateX(0);\n}\n\n.modal.fadeInLeft .modal-dialog {\n  -webkit-animation: fadeInLeft 0.3s ease-in-out;\n  animation: fadeInLeft 0.3s ease-in-out;\n  -webkit-transform: translate(-50%, 0);\n  transform: translate(-50%, 0);\n}\n\n.modal.fadeInLeft.show .modal-dialog {\n  -webkit-transform: none;\n  transform: none;\n}\n\n.modal.fadeInUp .modal-dialog {\n  -webkit-animation: fadeInUp 0.3s ease-in-out;\n  animation: fadeInUp 0.3s ease-in-out;\n  -webkit-transform: translate(0, 30%);\n  transform: translate(0, 30%);\n}\n\n.modal.fadeInUp.show .modal-dialog {\n  -webkit-transform: none;\n  transform: none;\n}\n\n.modal.flip {\n  -webkit-perspective: 1300px;\n  perspective: 1300px;\n}\n\n.modal.flip .modal-dialog {\n  opacity: 0;\n  -webkit-transform: rotateY(-70deg);\n  transform: rotateY(-70deg);\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n\n.modal.flip.show .modal-dialog {\n  opacity: 1;\n  -webkit-transform: rotateY(0);\n  transform: rotateY(0);\n}\n\n.modal.zoomIn .modal-dialog {\n  opacity: 0;\n  -webkit-transform: scale(0.7);\n  transform: scale(0.7);\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.modal.zoomIn.show .modal-dialog {\n  opacity: 1;\n  -webkit-transform: scale(1);\n  transform: scale(1);\n}\n\n.modal-dialog-right {\n  margin-right: 1.75rem;\n}\n\n.modal-dialog-bottom {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n  min-height: calc(100% - 1.75rem);\n}\n\n@media (min-width: 576px) {\n  .modal-dialog-bottom {\n    min-height: calc(100% - 3.5rem);\n  }\n}\n\n.modal-dialog-bottom-right {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n  min-height: calc(100% - 1.75rem);\n  margin-right: 1.75rem;\n}\n\n@media (min-width: 576px) {\n  .modal-dialog-bottom-right {\n    min-height: calc(100% - 3.5rem);\n  }\n}\n\n@-webkit-keyframes fadeInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-30%, 0, 0);\n    transform: translate3d(-30%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@keyframes fadeInLeft {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(-30%, 0, 0);\n    transform: translate3d(-30%, 0, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@-webkit-keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 30%, 0);\n    transform: translate3d(0, 30%, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@keyframes fadeInUp {\n  0% {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 30%, 0);\n    transform: translate3d(0, 30%, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translateZ(0);\n    transform: translateZ(0);\n  }\n}\n\n@-webkit-keyframes zoomIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  50% {\n    opacity: 1;\n  }\n}\n\n@keyframes zoomIn {\n  0% {\n    opacity: 0;\n    -webkit-transform: scale3d(0.3, 0.3, 0.3);\n    transform: scale3d(0.3, 0.3, 0.3);\n  }\n\n  50% {\n    opacity: 1;\n  }\n}\n\n.login-modal {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1016%26quot%3b)' fill='none'%3e%3crect width='1440' height='560' x='0' y='0' fill='rgba(64%2c 81%2c 137%2c 1)'%3e%3c/rect%3e%3cpath d='M0%2c650.704C122.328%2c648.746%2c159.175%2c473.043%2c255.674%2c397.837C339.724%2c332.333%2c461.529%2c324.924%2c526.449%2c240.421C598.428%2c146.73%2c655.546%2c24.847%2c631.015%2c-90.726C606.666%2c-205.444%2c482.926%2c-263.497%2c401.565%2c-347.958C325.215%2c-427.217%2c275.543%2c-549.012%2c167.826%2c-571.563C60.344%2c-594.065%2c-27.703%2c-482.932%2c-135.163%2c-460.325C-256.336%2c-434.833%2c-401.929%2c-509.651%2c-497.972%2c-431.495C-592.807%2c-354.321%2c-579.865%2c-206.886%2c-595.603%2c-85.635C-611.133%2c34.016%2c-656.761%2c169.183%2c-588.884%2c268.934C-520.854%2c368.909%2c-362.458%2c340.324%2c-260.989%2c406.106C-158.875%2c472.306%2c-121.679%2c652.651%2c0%2c650.704' fill='%2333416e'%3e%3c/path%3e%3cpath d='M1440 995.672C1519.728 984.741 1563.12 899.779 1626.466 850.1469999999999 1682.6390000000001 806.135 1756.261 782.602 1791.2939999999999 720.431 1827.571 656.052 1835.537 577.6610000000001 1820.814 505.247 1806.518 434.933 1753.2640000000001 383.16999999999996 1710.941 325.228 1664.475 261.614 1634.992 175.16000000000003 1560.657 149.07999999999998 1485.96 122.87299999999999 1402.146 155.543 1332.03 192.289 1269.541 225.038 1232.754 287.251 1189.969 343.347 1149.925 395.849 1115.781 448.9 1089.96 509.672 1056 589.599 988.9680000000001 671.1659999999999 1015.557 753.837 1041.91 835.774 1142.714 863.61 1217.498 906.22 1288.388 946.611 1359.167 1006.755 1440 995.672' fill='%234d61a4'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1016'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e\");\n  background-size: cover;\n  background-position: center;\n}\n\n.pagination-separated .page-item .page-link {\n  margin-left: 0.35rem;\n  border-radius: 0.25rem;\n}\n\n.pagination-rounded .page-link {\n  border-radius: 30px !important;\n  margin: 0 3px !important;\n  border: none;\n  min-width: 32px;\n  min-height: 32px;\n  text-align: center;\n}\n\n.pagination-rounded.pagination-sm .page-link {\n  min-width: 25px;\n  min-height: 25px;\n}\n\n.page-item.active .page-link {\n  -webkit-box-shadow: var(--bs-box-shadow);\n  box-shadow: var(--bs-box-shadow);\n}\n\n.progress-sm {\n  height: 5px;\n}\n\n.progress-lg {\n  height: 12px;\n}\n\n.progress-xl {\n  height: 16px;\n}\n\n.custom-progess {\n  position: relative;\n}\n\n.custom-progess .progress-icon {\n  position: absolute;\n  top: -12px;\n}\n\n.custom-progess .progress-icon .avatar-title {\n  background: var(--bs-card-bg-custom);\n}\n\n.animated-progress {\n  position: relative;\n}\n\n.animated-progress .progress-bar {\n  position: relative;\n  border-radius: 6px;\n  -webkit-animation: animate-positive 2s;\n  animation: animate-positive 2s;\n}\n\n@-webkit-keyframes animate-positive {\n  0% {\n    width: 0;\n  }\n}\n\n@keyframes animate-positive {\n  0% {\n    width: 0;\n  }\n}\n\n.custom-progress {\n  height: 15px;\n  padding: 4px;\n  border-radius: 30px;\n}\n\n.custom-progress .progress-bar {\n  position: relative;\n  border-radius: 30px;\n}\n\n.custom-progress .progress-bar::before {\n  content: \"\";\n  position: absolute;\n  width: 4px;\n  height: 4px;\n  background-color: #fff;\n  border-radius: 7px;\n  right: 2px;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n.progress-label {\n  overflow: visible;\n}\n\n.progress-label .progress-bar {\n  position: relative;\n  overflow: visible;\n}\n\n.progress-label .progress-bar .label {\n  position: absolute;\n  top: -25px;\n  right: -9px;\n  background-color: #4b38b3;\n  color: #fff;\n  display: inline-block;\n  line-height: 18px;\n  padding: 0 4px;\n  border-radius: 4px;\n}\n\n.progress-label .progress-bar .label:after {\n  content: \"\";\n  position: absolute;\n  border: 4px solid transparent;\n  border-top-color: #4b38b3;\n  bottom: -7px;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n}\n\n.progress-step-arrow {\n  height: 3.25rem;\n}\n\n.progress-step-arrow .progress-bar {\n  position: relative;\n  overflow: initial;\n  font-size: 0.875rem;\n  color: #fff;\n}\n\n.progress-step-arrow .progress-bar::after {\n  content: \"\";\n  position: absolute;\n  border: 10px solid transparent;\n  bottom: 15px;\n  right: -20px;\n  z-index: 1;\n}\n\n.progress-primary .progress-bar {\n  background-color: #4b38b3;\n}\n\n.progress-primary .progress-bar::after {\n  border-left-color: #4b38b3;\n}\n\n.progress-primary .progress-bar:nth-child(2) {\n  background-color: rgba(75, 56, 179, 0.1) !important;\n  color: #4b38b3 !important;\n}\n\n.progress-primary .progress-bar:nth-child(2)::after {\n  border-left-color: rgba(75, 56, 179, 0.1);\n}\n\n.progress-secondary .progress-bar {\n  background-color: #3577f1;\n}\n\n.progress-secondary .progress-bar::after {\n  border-left-color: #3577f1;\n}\n\n.progress-secondary .progress-bar:nth-child(2) {\n  background-color: rgba(53, 119, 241, 0.1) !important;\n  color: #3577f1 !important;\n}\n\n.progress-secondary .progress-bar:nth-child(2)::after {\n  border-left-color: rgba(53, 119, 241, 0.1);\n}\n\n.progress-success .progress-bar {\n  background-color: #45cb85;\n}\n\n.progress-success .progress-bar::after {\n  border-left-color: #45cb85;\n}\n\n.progress-success .progress-bar:nth-child(2) {\n  background-color: rgba(69, 203, 133, 0.1) !important;\n  color: #45cb85 !important;\n}\n\n.progress-success .progress-bar:nth-child(2)::after {\n  border-left-color: rgba(69, 203, 133, 0.1);\n}\n\n.progress-info .progress-bar {\n  background-color: #299cdb;\n}\n\n.progress-info .progress-bar::after {\n  border-left-color: #299cdb;\n}\n\n.progress-info .progress-bar:nth-child(2) {\n  background-color: rgba(41, 156, 219, 0.1) !important;\n  color: #299cdb !important;\n}\n\n.progress-info .progress-bar:nth-child(2)::after {\n  border-left-color: rgba(41, 156, 219, 0.1);\n}\n\n.progress-warning .progress-bar {\n  background-color: #ffbe0b;\n}\n\n.progress-warning .progress-bar::after {\n  border-left-color: #ffbe0b;\n}\n\n.progress-warning .progress-bar:nth-child(2) {\n  background-color: rgba(255, 190, 11, 0.1) !important;\n  color: #ffbe0b !important;\n}\n\n.progress-warning .progress-bar:nth-child(2)::after {\n  border-left-color: rgba(255, 190, 11, 0.1);\n}\n\n.progress-danger .progress-bar {\n  background-color: #f06548;\n}\n\n.progress-danger .progress-bar::after {\n  border-left-color: #f06548;\n}\n\n.progress-danger .progress-bar:nth-child(2) {\n  background-color: rgba(240, 101, 72, 0.1) !important;\n  color: #f06548 !important;\n}\n\n.progress-danger .progress-bar:nth-child(2)::after {\n  border-left-color: rgba(240, 101, 72, 0.1);\n}\n\n.progress-light .progress-bar {\n  background-color: #f3f6f9;\n}\n\n.progress-light .progress-bar::after {\n  border-left-color: #f3f6f9;\n}\n\n.progress-light .progress-bar:nth-child(2) {\n  background-color: rgba(243, 246, 249, 0.1) !important;\n  color: #f3f6f9 !important;\n}\n\n.progress-light .progress-bar:nth-child(2)::after {\n  border-left-color: rgba(243, 246, 249, 0.1);\n}\n\n.progress-dark .progress-bar {\n  background-color: #212529;\n}\n\n.progress-dark .progress-bar::after {\n  border-left-color: #212529;\n}\n\n.progress-dark .progress-bar:nth-child(2) {\n  background-color: rgba(33, 37, 41, 0.1) !important;\n  color: #212529 !important;\n}\n\n.progress-dark .progress-bar:nth-child(2)::after {\n  border-left-color: rgba(33, 37, 41, 0.1);\n}\n\n.popover {\n  -webkit-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n}\n\n.text-white-75 {\n  color: rgba(255, 255, 255, 0.75) !important;\n}\n\n.custom-blockquote.blockquote {\n  padding: 16px;\n  border-left: 3px solid;\n}\n\n.custom-blockquote.blockquote.blockquote-outline {\n  background-color: var(--bs-card-bg-custom) !important;\n  border: 1px solid;\n  border-left: 3px solid;\n}\n\n.custom-blockquote.blockquote.blockquote-primary {\n  color: #4b38b3;\n  border-color: #4b38b3;\n  background-color: rgba(75, 56, 179, 0.15);\n}\n\n.custom-blockquote.blockquote.blockquote-primary .blockquote-footer {\n  color: #4b38b3;\n}\n\n.custom-blockquote.blockquote.blockquote-outline.blockquote-primary {\n  border-color: #4b38b3;\n}\n\n.custom-blockquote.blockquote.blockquote-outline.blockquote-primary\n  .blockquote-footer {\n  color: #4b38b3;\n}\n\n.custom-blockquote.blockquote.blockquote-secondary {\n  color: #3577f1;\n  border-color: #3577f1;\n  background-color: rgba(53, 119, 241, 0.15);\n}\n\n.custom-blockquote.blockquote.blockquote-secondary .blockquote-footer {\n  color: #3577f1;\n}\n\n.custom-blockquote.blockquote.blockquote-outline.blockquote-secondary {\n  border-color: #3577f1;\n}\n\n.custom-blockquote.blockquote.blockquote-outline.blockquote-secondary\n  .blockquote-footer {\n  color: #3577f1;\n}\n\n.custom-blockquote.blockquote.blockquote-success {\n  color: #45cb85;\n  border-color: #45cb85;\n  background-color: rgba(69, 203, 133, 0.15);\n}\n\n.custom-blockquote.blockquote.blockquote-success .blockquote-footer {\n  color: #45cb85;\n}\n\n.custom-blockquote.blockquote.blockquote-outline.blockquote-success {\n  border-color: #45cb85;\n}\n\n.custom-blockquote.blockquote.blockquote-outline.blockquote-success\n  .blockquote-footer {\n  color: #45cb85;\n}\n\n.custom-blockquote.blockquote.blockquote-info {\n  color: #299cdb;\n  border-color: #299cdb;\n  background-color: rgba(41, 156, 219, 0.15);\n}\n\n.custom-blockquote.blockquote.blockquote-info .blockquote-footer {\n  color: #299cdb;\n}\n\n.custom-blockquote.blockquote.blockquote-outline.blockquote-info {\n  border-color: #299cdb;\n}\n\n.custom-blockquote.blockquote.blockquote-outline.blockquote-info\n  .blockquote-footer {\n  color: #299cdb;\n}\n\n.custom-blockquote.blockquote.blockquote-warning {\n  color: #ffbe0b;\n  border-color: #ffbe0b;\n  background-color: rgba(255, 190, 11, 0.15);\n}\n\n.custom-blockquote.blockquote.blockquote-warning .blockquote-footer {\n  color: #ffbe0b;\n}\n\n.custom-blockquote.blockquote.blockquote-outline.blockquote-warning {\n  border-color: #ffbe0b;\n}\n\n.custom-blockquote.blockquote.blockquote-outline.blockquote-warning\n  .blockquote-footer {\n  color: #ffbe0b;\n}\n\n.custom-blockquote.blockquote.blockquote-danger {\n  color: #f06548;\n  border-color: #f06548;\n  background-color: rgba(240, 101, 72, 0.15);\n}\n\n.custom-blockquote.blockquote.blockquote-danger .blockquote-footer {\n  color: #f06548;\n}\n\n.custom-blockquote.blockquote.blockquote-outline.blockquote-danger {\n  border-color: #f06548;\n}\n\n.custom-blockquote.blockquote.blockquote-outline.blockquote-danger\n  .blockquote-footer {\n  color: #f06548;\n}\n\n.custom-blockquote.blockquote.blockquote-light {\n  color: #f3f6f9;\n  border-color: #f3f6f9;\n  background-color: rgba(243, 246, 249, 0.15);\n}\n\n.custom-blockquote.blockquote.blockquote-light .blockquote-footer {\n  color: #f3f6f9;\n}\n\n.custom-blockquote.blockquote.blockquote-outline.blockquote-light {\n  border-color: #f3f6f9;\n}\n\n.custom-blockquote.blockquote.blockquote-outline.blockquote-light\n  .blockquote-footer {\n  color: #f3f6f9;\n}\n\n.custom-blockquote.blockquote.blockquote-dark {\n  color: #212529;\n  border-color: #212529;\n  background-color: rgba(33, 37, 41, 0.15);\n}\n\n.custom-blockquote.blockquote.blockquote-dark .blockquote-footer {\n  color: #212529;\n}\n\n.custom-blockquote.blockquote.blockquote-outline.blockquote-dark {\n  border-color: #212529;\n}\n\n.custom-blockquote.blockquote.blockquote-outline.blockquote-dark\n  .blockquote-footer {\n  color: #212529;\n}\n\n.custom-blockquote.blockquote.blockquote-dark {\n  color: var(--bs-dark);\n  border-color: var(--bs-dark);\n  background-color: rgba(var(--bs-dark-rgb), 0.15);\n}\n\n.custom-blockquote.blockquote.blockquote-dark .blockquote-footer {\n  color: var(--bs-dark);\n}\n\n.custom-blockquote.blockquote.blockquote-outline.blockquote-dark {\n  border-color: var(--bs-dark);\n}\n\n.custom-blockquote.blockquote.blockquote-outline.blockquote-dark\n  .blockquote-footer {\n  color: var(--bs-dark);\n}\n\n.form-check {\n  position: relative;\n  text-align: left;\n}\n\n.form-check .form-check-input {\n  cursor: pointer;\n}\n\n.form-check label {\n  cursor: pointer;\n}\n\n.form-check-primary .form-check-input:checked {\n  background-color: #4b38b3;\n  border-color: #4b38b3;\n}\n\n.form-radio-primary .form-check-input:checked {\n  border-color: #4b38b3;\n  background-color: #4b38b3;\n}\n\n.form-radio-primary .form-check-input:checked:after {\n  background-color: #4b38b3;\n}\n\n.form-check-secondary .form-check-input:checked {\n  background-color: #3577f1;\n  border-color: #3577f1;\n}\n\n.form-radio-secondary .form-check-input:checked {\n  border-color: #3577f1;\n  background-color: #3577f1;\n}\n\n.form-radio-secondary .form-check-input:checked:after {\n  background-color: #3577f1;\n}\n\n.form-check-success .form-check-input:checked {\n  background-color: #45cb85;\n  border-color: #45cb85;\n}\n\n.form-radio-success .form-check-input:checked {\n  border-color: #45cb85;\n  background-color: #45cb85;\n}\n\n.form-radio-success .form-check-input:checked:after {\n  background-color: #45cb85;\n}\n\n.form-check-info .form-check-input:checked {\n  background-color: #299cdb;\n  border-color: #299cdb;\n}\n\n.form-radio-info .form-check-input:checked {\n  border-color: #299cdb;\n  background-color: #299cdb;\n}\n\n.form-radio-info .form-check-input:checked:after {\n  background-color: #299cdb;\n}\n\n.form-check-warning .form-check-input:checked {\n  background-color: #ffbe0b;\n  border-color: #ffbe0b;\n}\n\n.form-radio-warning .form-check-input:checked {\n  border-color: #ffbe0b;\n  background-color: #ffbe0b;\n}\n\n.form-radio-warning .form-check-input:checked:after {\n  background-color: #ffbe0b;\n}\n\n.form-check-danger .form-check-input:checked {\n  background-color: #f06548;\n  border-color: #f06548;\n}\n\n.form-radio-danger .form-check-input:checked {\n  border-color: #f06548;\n  background-color: #f06548;\n}\n\n.form-radio-danger .form-check-input:checked:after {\n  background-color: #f06548;\n}\n\n.form-check-light .form-check-input:checked {\n  background-color: #f3f6f9;\n  border-color: #f3f6f9;\n}\n\n.form-radio-light .form-check-input:checked {\n  border-color: #f3f6f9;\n  background-color: #f3f6f9;\n}\n\n.form-radio-light .form-check-input:checked:after {\n  background-color: #f3f6f9;\n}\n\n.form-check-dark .form-check-input:checked {\n  background-color: #212529;\n  border-color: #212529;\n}\n\n.form-radio-dark .form-check-input:checked {\n  border-color: #212529;\n  background-color: #212529;\n}\n\n.form-radio-dark .form-check-input:checked:after {\n  background-color: #212529;\n}\n\n.form-check-label {\n  cursor: pointer;\n  margin-bottom: 0;\n}\n\n.form-check-right {\n  padding-left: 0;\n  display: inline-block;\n}\n\n.form-check-right .form-check-input {\n  float: right;\n  margin-left: 0;\n  margin-right: -1.6em;\n}\n\n.form-check-right .form-check-label {\n  display: block;\n}\n\n.form-check-right.form-switch .form-check-input {\n  margin-right: -2.56em;\n}\n\n.form-check-outline.form-check-primary\n  .form-check-input:checked[type=\"checkbox\"] {\n  color: #4b38b3;\n  background-color: transparent;\n  border-color: #4b38b3;\n}\n\n.form-check-outline.form-check-secondary\n  .form-check-input:checked[type=\"checkbox\"] {\n  color: #3577f1;\n  background-color: transparent;\n  border-color: #3577f1;\n}\n\n.form-check-outline.form-check-success\n  .form-check-input:checked[type=\"checkbox\"] {\n  color: #45cb85;\n  background-color: transparent;\n  border-color: #45cb85;\n}\n\n.form-check-outline.form-check-info .form-check-input:checked[type=\"checkbox\"] {\n  color: #299cdb;\n  background-color: transparent;\n  border-color: #299cdb;\n}\n\n.form-check-outline.form-check-warning\n  .form-check-input:checked[type=\"checkbox\"] {\n  color: #ffbe0b;\n  background-color: transparent;\n  border-color: #ffbe0b;\n}\n\n.form-check-outline.form-check-danger\n  .form-check-input:checked[type=\"checkbox\"] {\n  color: #f06548;\n  background-color: transparent;\n  border-color: #f06548;\n}\n\n.form-check-outline.form-check-light\n  .form-check-input:checked[type=\"checkbox\"] {\n  color: #f3f6f9;\n  background-color: transparent;\n  border-color: #f3f6f9;\n}\n\n.form-check-outline.form-check-dark .form-check-input:checked[type=\"checkbox\"] {\n  color: #212529;\n  background-color: transparent;\n  border-color: #212529;\n}\n\n.form-check-outline .form-check-input {\n  position: relative;\n}\n\n.form-check-outline .form-check-input:checked[type=\"checkbox\"] {\n  background-image: none;\n}\n\n.form-check-outline .form-check-input:checked[type=\"checkbox\"]::before {\n  content: \"\\f012c\";\n  font-family: \"Material Design Icons\";\n  top: -2px;\n  position: absolute;\n  font-weight: 700;\n  font-size: 11px;\n  left: 1px;\n}\n\n.form-radio-outline.form-radio-primary .form-check-input:checked[type=\"radio\"] {\n  color: #4b38b3;\n  background-color: transparent;\n  border-color: #4b38b3;\n}\n\n.form-radio-outline.form-radio-secondary\n  .form-check-input:checked[type=\"radio\"] {\n  color: #3577f1;\n  background-color: transparent;\n  border-color: #3577f1;\n}\n\n.form-radio-outline.form-radio-success .form-check-input:checked[type=\"radio\"] {\n  color: #45cb85;\n  background-color: transparent;\n  border-color: #45cb85;\n}\n\n.form-radio-outline.form-radio-info .form-check-input:checked[type=\"radio\"] {\n  color: #299cdb;\n  background-color: transparent;\n  border-color: #299cdb;\n}\n\n.form-radio-outline.form-radio-warning .form-check-input:checked[type=\"radio\"] {\n  color: #ffbe0b;\n  background-color: transparent;\n  border-color: #ffbe0b;\n}\n\n.form-radio-outline.form-radio-danger .form-check-input:checked[type=\"radio\"] {\n  color: #f06548;\n  background-color: transparent;\n  border-color: #f06548;\n}\n\n.form-radio-outline.form-radio-light .form-check-input:checked[type=\"radio\"] {\n  color: #f3f6f9;\n  background-color: transparent;\n  border-color: #f3f6f9;\n}\n\n.form-radio-outline.form-radio-dark .form-check-input:checked[type=\"radio\"] {\n  color: #212529;\n  background-color: transparent;\n  border-color: #212529;\n}\n\n.form-radio-outline .form-check-input {\n  position: relative;\n}\n\n.form-radio-outline .form-check-input:checked[type=\"radio\"] {\n  background-image: none;\n}\n\n.form-radio-outline .form-check-input:checked[type=\"radio\"]::before {\n  content: \"\\f0765\";\n  font-family: \"Material Design Icons\";\n  top: 0;\n  position: absolute;\n  font-size: 8px;\n  left: 2.2px;\n}\n\n.form-switch-md {\n  padding-left: 2.5rem;\n  min-height: 22px;\n  line-height: 22px;\n}\n\n.form-switch-md .form-check-input {\n  width: 40px;\n  height: 20px;\n  left: -0.5rem;\n  position: relative;\n}\n\n.form-switch-md .form-check-label {\n  vertical-align: middle;\n}\n\n.form-switch-lg {\n  padding-left: 2.75rem;\n  min-height: 28px;\n  line-height: 28px;\n}\n\n.form-switch-lg .form-check-input {\n  width: 48px;\n  height: 24px;\n  left: -0.75rem;\n  position: relative;\n}\n\n.input-group-text {\n  margin-bottom: 0;\n}\n\n.form-switch-primary .form-check-input:checked {\n  background-color: #4b38b3;\n  border-color: #4b38b3;\n}\n\n.form-switch-custom.form-switch-primary .form-check-input:checked::before {\n  color: #180f5a;\n}\n\n.form-switch-secondary .form-check-input:checked {\n  background-color: #3577f1;\n  border-color: #3577f1;\n}\n\n.form-switch-custom.form-switch-secondary .form-check-input:checked::before {\n  color: #3577f1;\n}\n\n.form-switch-success .form-check-input:checked {\n  background-color: #45cb85;\n  border-color: #45cb85;\n}\n\n.form-switch-custom.form-switch-success .form-check-input:checked::before {\n  color: #45cb85;\n}\n\n.form-switch-info .form-check-input:checked {\n  background-color: #299cdb;\n  border-color: #299cdb;\n}\n\n.form-switch-custom.form-switch-info .form-check-input:checked::before {\n  color: #299cdb;\n}\n\n.form-switch-warning .form-check-input:checked {\n  background-color: #ffbe0b;\n  border-color: #ffbe0b;\n}\n\n.form-switch-custom.form-switch-warning .form-check-input:checked::before {\n  color: #ffbe0b;\n}\n\n.form-switch-danger .form-check-input:checked {\n  background-color: #f06548;\n  border-color: #f06548;\n}\n\n.form-switch-custom.form-switch-danger .form-check-input:checked::before {\n  color: #f06548;\n}\n\n.form-switch-light .form-check-input:checked {\n  background-color: #f3f6f9;\n  border-color: #f3f6f9;\n}\n\n.form-switch-custom.form-switch-light .form-check-input:checked::before {\n  color: #f3f6f9;\n}\n\n.form-switch-dark .form-check-input:checked {\n  background-color: #212529;\n  border-color: #212529;\n}\n\n.form-switch-custom.form-switch-dark .form-check-input:checked::before {\n  color: #212529;\n}\n\n.form-switch-custom .form-check-input {\n  position: relative;\n  background-image: none;\n}\n\n.form-switch-custom .form-check-input::before {\n  content: \"\\f0765\";\n  font-family: \"Material Design Icons\";\n  top: -9px;\n  position: absolute;\n  font-size: 20px;\n  left: -3px;\n  color: #878a99;\n  -webkit-transition: background-position 0.15s ease-in-out;\n  transition: background-position 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .form-switch-custom .form-check-input::before {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.form-switch-custom .form-check-input:checked {\n  background-image: none;\n  background-color: var(--bs-input-bg);\n  -webkit-transition: background-position 0.15s ease-in-out;\n  transition: background-position 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .form-switch-custom .form-check-input:checked {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.form-switch-custom .form-check-input:checked::before {\n  right: -3px;\n  left: auto;\n}\n\n.form-switch-custom .form-check-input:focus {\n  background-image: none;\n}\n\n.form-switch-right {\n  display: inline-block;\n  padding-right: 0.8em;\n  margin-bottom: 0;\n  padding-left: 0 !important;\n}\n\n.form-switch-right .form-check-input {\n  float: right;\n  margin-left: 0;\n  margin-right: -1.6em;\n  margin-top: 0.1em !important;\n}\n\n.form-switch-right label {\n  margin-bottom: 0;\n  margin-right: 1rem;\n}\n\n.card-radio {\n  padding: 0;\n}\n\n.card-radio .form-check-label {\n  background-color: var(--bs-card-bg-custom);\n  border: 1px solid var(--bs-input-check-border) !important;\n  border-radius: 0.25rem;\n  padding: 1rem;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: block;\n  position: relative;\n  padding-right: 32px;\n}\n\n.card-radio .form-check-label:hover {\n  cursor: pointer;\n}\n\n.card-radio .form-check-input {\n  display: none;\n}\n\n.card-radio .form-check-input:checked + .form-check-label {\n  border-color: #4b38b3 !important;\n}\n\n.card-radio .form-check-input:checked + .form-check-label:before {\n  content: \"\\eb80\";\n  font-family: remixicon;\n  position: absolute;\n  top: 2px;\n  right: 6px;\n  font-size: 16px;\n  color: #4b38b3;\n}\n\n.card-radio.dark .form-check-input:checked + .form-check-label:before {\n  color: #fff;\n}\n\n[data-layout-mode=\"dark\"] .form-switch .form-check-input,\n[data-layout-mode=\"dark\"] .form-switch .form-check-input:focus {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23ced4da'/%3e%3c/svg%3e\");\n}\n\n.form-icon {\n  position: relative;\n}\n\n.form-icon .form-control-icon {\n  padding-left: 2.7rem;\n  position: relative;\n}\n\n.form-icon i {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 18px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.form-icon.right .form-control-icon {\n  padding-right: 2.7rem;\n  padding-left: 0.9rem;\n  position: relative;\n}\n\n.form-icon.right i {\n  left: auto;\n  right: 18px;\n}\n\n[data-layout-mode=\"dark\"] .form-select {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%23ced4da' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/%3e%3c/svg%3e\");\n  color: var(--bs-body-color);\n  background-color: var(--bs-input-bg);\n  border: 1px solid var(--bs-input-border);\n}\n\n[data-layout-mode=\"dark\"] .form-control {\n  color: white !important;\n  background-color: var(--bs-input-bg);\n  border: 1px solid var(--bs-input-border);\n}\n\n[data-layout-mode=\"dark\"] .input-group-text {\n  background-color: var(--bs-input-group-addon-bg);\n  border: 1px solid var(--bs-input-border);\n  color: var(--bs-body-color);\n}\n\n.list-group-fill-primary .list-group-item.active {\n  background-color: #4b38b3 !important;\n  border-color: #4b38b3;\n}\n\n.list-group-fill-secondary .list-group-item.active {\n  background-color: #3577f1 !important;\n  border-color: #3577f1;\n}\n\n.list-group-fill-success .list-group-item.active {\n  background-color: #45cb85 !important;\n  border-color: #45cb85;\n}\n\n.list-group-fill-info .list-group-item.active {\n  background-color: #299cdb !important;\n  border-color: #299cdb;\n}\n\n.list-group-fill-warning .list-group-item.active {\n  background-color: #ffbe0b !important;\n  border-color: #ffbe0b;\n}\n\n.list-group-fill-danger .list-group-item.active {\n  background-color: #f06548 !important;\n  border-color: #f06548;\n}\n\n.list-group-fill-light .list-group-item.active {\n  background-color: #f3f6f9 !important;\n  border-color: #f3f6f9;\n}\n\n.list-group-fill-dark .list-group-item.active {\n  background-color: #212529 !important;\n  border-color: #212529;\n}\n\n.list-group-fill-light {\n  color: #212529 !important;\n}\n\n.list-group-item {\n  margin-bottom: 0;\n}\n\n.list-group-item .list-text {\n  color: #878a99;\n}\n\n.list-group-item.active {\n  -webkit-box-shadow: var(--bs-box-shadow);\n  box-shadow: var(--bs-box-shadow);\n}\n\n.list-group-item.active .list-title {\n  color: #fff;\n}\n\n.list-group-item.active .list-text {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n[data-simplebar] {\n  position: relative;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-pack: start;\n  -ms-flex-pack: start;\n  justify-content: flex-start;\n  -ms-flex-line-pack: start;\n  align-content: flex-start;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n}\n\n.simplebar-wrapper {\n  overflow: hidden;\n  width: inherit;\n  height: inherit;\n  max-width: inherit;\n  max-height: inherit;\n}\n\n.simplebar-mask {\n  direction: inherit;\n  position: absolute;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: auto !important;\n  height: auto !important;\n  z-index: 0;\n}\n\n.simplebar-offset {\n  direction: inherit !important;\n  -webkit-box-sizing: inherit !important;\n  box-sizing: inherit !important;\n  resize: none !important;\n  position: absolute;\n  top: 0;\n  left: 0 !important;\n  bottom: 0;\n  right: 0 !important;\n  padding: 0;\n  margin: 0;\n  -webkit-overflow-scrolling: touch;\n}\n\n.simplebar-content-wrapper {\n  direction: inherit;\n  -webkit-box-sizing: border-box !important;\n  box-sizing: border-box !important;\n  position: relative;\n  display: block;\n  height: 100%;\n  width: auto;\n  visibility: visible;\n  overflow: auto;\n  max-width: 100%;\n  max-height: 100%;\n  scrollbar-width: none;\n  padding: 0 !important;\n}\n\n.simplebar-content-wrapper::-webkit-scrollbar,\n.simplebar-hide-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n.simplebar-content:after,\n.simplebar-content:before {\n  content: \" \";\n  display: table;\n}\n\n.simplebar-placeholder {\n  max-height: 100%;\n  max-width: 100%;\n  width: 100%;\n  pointer-events: none;\n}\n\n.simplebar-height-auto-observer-wrapper {\n  -webkit-box-sizing: inherit !important;\n  box-sizing: inherit !important;\n  height: 100%;\n  width: 100%;\n  max-width: 1px;\n  position: relative;\n  float: left;\n  max-height: 1px;\n  overflow: hidden;\n  z-index: -1;\n  padding: 0;\n  margin: 0;\n  pointer-events: none;\n  -webkit-box-flex: inherit;\n  -ms-flex-positive: inherit;\n  flex-grow: inherit;\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n  -ms-flex-preferred-size: 0;\n  flex-basis: 0;\n}\n\n.simplebar-height-auto-observer {\n  -webkit-box-sizing: inherit;\n  box-sizing: inherit;\n  display: block;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 1000%;\n  width: 1000%;\n  min-height: 1px;\n  min-width: 1px;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: -1;\n}\n\n.simplebar-track {\n  z-index: 1;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-content {\n  pointer-events: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-track {\n  pointer-events: all;\n}\n\n.simplebar-scrollbar {\n  position: absolute;\n  right: 2px;\n  width: 6px;\n  min-height: 10px;\n}\n\n.simplebar-scrollbar:before {\n  position: absolute;\n  content: \"\";\n  background: #a2adb7;\n  border-radius: 7px;\n  left: 0;\n  right: 0;\n  opacity: 0;\n  -webkit-transition: opacity 0.2s linear;\n  transition: opacity 0.2s linear;\n}\n\n.simplebar-scrollbar.simplebar-visible:before {\n  opacity: 0.5;\n  -webkit-transition: opacity 0s linear;\n  transition: opacity 0s linear;\n}\n\n.simplebar-track.simplebar-vertical {\n  top: 0;\n  width: 11px;\n}\n\n.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {\n  top: 2px;\n  bottom: 2px;\n}\n\n.simplebar-track.simplebar-horizontal {\n  left: 0;\n  height: 11px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {\n  height: 100%;\n  left: 2px;\n  right: 2px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar {\n  right: auto;\n  left: 0;\n  top: 2px;\n  height: 7px;\n  min-height: 0;\n  min-width: 10px;\n  width: auto;\n}\n\n[data-simplebar-direction=\"rtl\"] .simplebar-track.simplebar-vertical {\n  right: auto;\n  left: 0;\n}\n\n.hs-dummy-scrollbar-size {\n  direction: rtl;\n  position: fixed;\n  opacity: 0;\n  visibility: hidden;\n  height: 500px;\n  width: 500px;\n  overflow-y: hidden;\n  overflow-x: scroll;\n}\n\n.simplebar-hide-scrollbar {\n  position: fixed;\n  left: 0;\n  visibility: hidden;\n  overflow-y: scroll;\n  scrollbar-width: none;\n}\n\n.custom-scroll {\n  height: 100%;\n}\n\n[data-simplebar-track=\"primary\"] .simplebar-scrollbar:before {\n  background: #4b38b3;\n}\n\n[data-simplebar-track=\"secondary\"] .simplebar-scrollbar:before {\n  background: #3577f1;\n}\n\n[data-simplebar-track=\"success\"] .simplebar-scrollbar:before {\n  background: #45cb85;\n}\n\n[data-simplebar-track=\"info\"] .simplebar-scrollbar:before {\n  background: #299cdb;\n}\n\n[data-simplebar-track=\"warning\"] .simplebar-scrollbar:before {\n  background: #ffbe0b;\n}\n\n[data-simplebar-track=\"danger\"] .simplebar-scrollbar:before {\n  background: #f06548;\n}\n\n[data-simplebar-track=\"light\"] .simplebar-scrollbar:before {\n  background: #f3f6f9;\n}\n\n[data-simplebar-track=\"dark\"] .simplebar-scrollbar:before {\n  background: #212529;\n}\n\ncode[class*=\"language-\"],\npre[class*=\"language-\"] {\n  color: #000;\n  background: 0 0;\n  text-shadow: 0 1px #fff;\n  font-family: Consolas, Monaco, \"Andale Mono\", \"Ubuntu Mono\", monospace;\n  font-size: 1em;\n  text-align: left;\n  white-space: pre;\n  word-spacing: normal;\n  word-break: normal;\n  word-wrap: normal;\n  line-height: 1.5;\n  -moz-tab-size: 4;\n  -o-tab-size: 4;\n  tab-size: 4;\n  -webkit-hyphens: none;\n  -ms-hyphens: none;\n  hyphens: none;\n}\n\ncode[class*=\"language-\"] ::-moz-selection,\ncode[class*=\"language-\"]::-moz-selection,\npre[class*=\"language-\"] ::-moz-selection,\npre[class*=\"language-\"]::-moz-selection {\n  text-shadow: none;\n  background: #b3d4fc;\n}\n\ncode[class*=\"language-\"] ::-moz-selection,\ncode[class*=\"language-\"]::-moz-selection,\npre[class*=\"language-\"] ::-moz-selection,\npre[class*=\"language-\"]::-moz-selection {\n  text-shadow: none;\n  background: #b3d4fc;\n}\n\ncode[class*=\"language-\"] ::selection,\ncode[class*=\"language-\"]::selection,\npre[class*=\"language-\"] ::selection,\npre[class*=\"language-\"]::selection {\n  text-shadow: none;\n  background: #b3d4fc;\n}\n\n@media print {\n  code[class*=\"language-\"],\n  pre[class*=\"language-\"] {\n    text-shadow: none;\n  }\n}\n\npre[class*=\"language-\"] {\n  padding: 1em;\n  margin: 0;\n  overflow: auto;\n}\n\n:not(pre) > code[class*=\"language-\"],\npre[class*=\"language-\"] {\n  background: var(--bs-light) !important;\n}\n\n:not(pre) > code[class*=\"language-\"] {\n  padding: 0.1em;\n  border-radius: 0.3em;\n  white-space: normal;\n}\n\n.token.cdata,\n.token.comment,\n.token.doctype,\n.token.prolog {\n  color: #708090;\n}\n\n.token.punctuation {\n  color: #999;\n}\n\n.token.namespace {\n  opacity: 0.7;\n}\n\n.token.boolean,\n.token.constant,\n.token.deleted,\n.token.number,\n.token.property,\n.token.symbol,\n.token.tag {\n  color: #f06548;\n}\n\n.token.attr-name,\n.token.builtin,\n.token.char,\n.token.inserted,\n.token.selector,\n.token.string {\n  color: #690;\n}\n\n.language-css .token.string,\n.style .token.string,\n.token.entity,\n.token.operator,\n.token.url {\n  color: #9a6e3a;\n  background: hsla(0deg, 0%, 100%, 0.5);\n}\n\n.token.atrule,\n.token.attr-value,\n.token.keyword {\n  color: #07a;\n}\n\n.token.class-name,\n.token.function {\n  color: #dd4a68;\n}\n\n.token.important,\n.token.regex,\n.token.variable {\n  color: #e90;\n}\n\n.token.bold,\n.token.important {\n  font-weight: 700;\n}\n\n.token.italic {\n  font-style: italic;\n}\n\n.token.entity {\n  cursor: help;\n}\n\n:not(pre) > code[class*=\"language-\"],\npre[class*=\"language-\"] {\n  background: #eff2f7;\n}\n\ncode[class*=\"language-\"],\npre[class*=\"language-\"] {\n  color: #878a99;\n  text-shadow: none;\n}\n\n.language-markup::-webkit-scrollbar {\n  -webkit-appearance: none;\n}\n\n.language-markup::-webkit-scrollbar:vertical {\n  width: 10px;\n}\n\n.language-markup::-webkit-scrollbar:horizontal {\n  height: 10px;\n}\n\n.language-markup::-webkit-scrollbar-thumb {\n  background-color: rgba(var(--bs-dark-rgb), 0.1);\n  border-radius: 10px;\n  border: 2px solid var(--bs-light);\n}\n\n.language-markup::-webkit-scrollbar-track {\n  border-radius: 10px;\n  background-color: var(--bs-light);\n}\n\n#scroll-top {\n  width: 30px;\n  height: 30px;\n  position: fixed;\n  bottom: 65px;\n  right: 30px;\n  background: #343a40;\n  border-color: transparent;\n  border-radius: 3px;\n  color: #fff;\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n}\n\n.btn-clipboard {\n  position: absolute !important;\n  right: 15px !important;\n  z-index: 1 !important;\n}\n\ndiv.code-toolbar > .toolbar {\n  opacity: 1 !important;\n}\n\ndiv.code-toolbar > .toolbar button {\n  display: inline-block !important;\n  margin: 0.375rem 0.5rem !important;\n  padding: 0.25rem 0.75rem !important;\n  -webkit-transition: color 0.15s ease-in-out,\n    background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,\n    -webkit-box-shadow 0.15s ease-in-out !important;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out !important;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;\n  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,\n    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out,\n    -webkit-box-shadow 0.15s ease-in-out !important;\n  border-radius: 0.2rem !important;\n  border: 1px solid rgba(75, 56, 179, 0.35) !important;\n  background-color: transparent;\n  color: #4b38b3 !important;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\ndiv.code-toolbar > .toolbar button:focus {\n  outline: 0 !important;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\ndiv.code-toolbar > .toolbar button:hover {\n  background-color: #4b38b3 !important;\n  color: #fff !important;\n}\n\n.swal2-container .swal2-title {\n  padding: 24px 24px 0;\n  font-size: 20px;\n  font-weight: 500;\n}\n\n.swal2-popup {\n  padding-bottom: 24px;\n  border-radius: 0.3rem;\n  background-color: var(--bs-card-bg-custom);\n  color: var(--bs-body-color);\n}\n\n.swal2-popup .swal2-title {\n  color: var(--bs-heading-color);\n}\n\n.swal2-popup .swal2-html-container {\n  color: var(--bs-body-color);\n}\n\n.swal2-footer {\n  border-top: 1px solid var(--bs-border-color);\n  color: var(--bs-body-color);\n}\n\n.swal2-html-container {\n  font-size: 16px;\n}\n\n.swal2-icon.swal2-question {\n  border-color: #299cdb;\n  color: #299cdb;\n}\n\n.swal2-icon.swal2-success [class^=\"swal2-success-line\"] {\n  background-color: #45cb85;\n}\n\n.swal2-icon.swal2-success .swal2-success-ring {\n  border-color: rgba(69, 203, 133, 0.3);\n}\n\n.swal2-icon.swal2-warning {\n  border-color: #ffbe0b;\n  color: #ffbe0b;\n}\n\n.swal2-styled:focus {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.swal2-loader {\n  border-color: #4b38b3 transparent #4b38b3 transparent;\n}\n\n.swal2-timer-progress-bar {\n  background-color: rgba(69, 203, 133, 0.4);\n}\n\n.swal2-progress-steps .swal2-progress-step {\n  background: #4b38b3;\n}\n\n.swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {\n  background: #4b38b3;\n}\n\n.swal2-progress-steps\n  .swal2-progress-step.swal2-active-progress-step\n  ~ .swal2-progress-step,\n.swal2-progress-steps\n  .swal2-progress-step.swal2-active-progress-step\n  ~ .swal2-progress-step-line {\n  background: rgba(75, 56, 179, 0.3);\n}\n\n.swal2-progress-steps .swal2-progress-step-line {\n  background: #4b38b3;\n}\n\n.swal2-actions.swal2-loading .swal2-styled.swal2-confirm {\n  border-left-color: #4b38b3 !important;\n  border-right-color: #4b38b3 !important;\n}\n\n.swal2-file,\n.swal2-input,\n.swal2-textarea {\n  border: 1px solid var(--bs-input-border);\n}\n\n.swal2-file:focus,\n.swal2-input:focus,\n.swal2-textarea:focus {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  border-color: var(--bs-input-focus-border);\n}\n\n.swal2-input {\n  height: auto;\n  display: block;\n  padding: 0.5rem 0.9rem;\n  font-size: 0.8125rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  background-color: var(--bs-input-bg);\n  background-clip: padding-box;\n  border: 1px solid var(--bs-input-border);\n}\n\n.swal2-close {\n  font-family: var(--bs-font-sans-serif);\n  font-weight: 300;\n  font-size: 28px;\n}\n\n.swal2-close:focus {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.swal2-close:hover {\n  color: #4b38b3;\n}\n\n.swal2-validation-message {\n  background-color: transparent;\n}\n\n.dropzone {\n  min-height: 230px;\n  border: 2px dashed var(--bs-border-color);\n  background: var(--bs-card-bg-custom);\n  border-radius: 6px;\n}\n\n.dropzone .dz-message {\n  font-size: 24px;\n  width: 100%;\n  margin: 1em 0;\n}\n\n.noUi-connect {\n  background: #45cb85;\n}\n\n.noUi-handle {\n  background: #45cb85;\n  border: 2px solid var(--bs-card-bg);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.noUi-horizontal {\n  height: 4px;\n}\n\n.noUi-horizontal .noUi-handle {\n  height: 16px;\n  width: 16px;\n  border-radius: 50%;\n  right: -10px !important;\n  top: -7px;\n}\n\n.noUi-horizontal .noUi-handle::after,\n.noUi-horizontal .noUi-handle::before {\n  display: none;\n}\n\n.noUi-horizontal .noUi-handle:focus {\n  outline: 0;\n}\n\n.noUi-pips-horizontal {\n  height: 50px;\n}\n\n.noUi-tooltip {\n  padding: 0.4rem 0.7rem;\n  border-color: var(--bs-border-color);\n  border-radius: 0.2rem;\n  background-color: var(--bs-card-bg-custom);\n  color: var(--bs-body-color);\n}\n\n.noUi-vertical {\n  width: 4px;\n}\n\n.noUi-vertical .noUi-handle {\n  height: 16px;\n  width: 16px;\n  right: -8px;\n  top: -12px;\n  left: auto;\n  border-radius: 50%;\n}\n\n.noUi-vertical .noUi-handle::after,\n.noUi-vertical .noUi-handle::before {\n  display: none;\n}\n\n.noUi-vertical .noUi-handle:focus {\n  outline: 0;\n}\n\n.noUi-vertical .noUi-origin {\n  top: 0;\n}\n\n.noUi-value {\n  font-size: 12px;\n}\n\n.noUi-marker-horizontal.noUi-marker-large {\n  height: 12px;\n}\n\n.noUi-value-horizontal {\n  padding-top: 4px;\n}\n\n.noUi-target {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  background-color: var(--bs-light);\n  border-color: var(--bs-light);\n}\n\n.noUi-touch-area:focus {\n  outline: 0;\n}\n\n#blue,\n#green,\n#red {\n  margin: 10px;\n  display: inline-block;\n  height: 200px;\n}\n\n#colorpicker {\n  height: 240px;\n  width: 310px;\n  margin: 0 auto;\n  padding: 10px;\n  border: 1px solid var(--bs-border-color);\n}\n\n#result {\n  margin: 60px 26px;\n  height: 100px;\n  width: 100px;\n  display: inline-block;\n  vertical-align: top;\n  border: 1px solid var(--bs-border-color);\n  -webkit-box-shadow: 0 0 3px;\n  box-shadow: 0 0 3px;\n  border-radius: 7px;\n}\n\n#red .noUi-connect {\n  background: #f06548;\n}\n\n#green .noUi-connect {\n  background: #45cb85;\n}\n\n#blue .noUi-connect {\n  background: #4b38b3;\n}\n\n.form-control.keyboard {\n  max-width: 340px !important;\n}\n\n.example-val {\n  font-size: 12px;\n  color: #878a99;\n  display: block;\n  margin: 15px 0;\n}\n\n.example-val:before {\n  content: \"Value: \";\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.noUi-tooltip {\n  display: none;\n}\n\n.noUi-active .noUi-tooltip {\n  display: block;\n}\n\n.c-1-color {\n  background: #f06548;\n}\n\n.c-2-color {\n  background: #ffbe0b;\n}\n\n.c-3-color {\n  background: #45cb85;\n}\n\n.c-4-color {\n  background: #4b38b3;\n}\n\n.c-5-color {\n  background: #6559cc;\n}\n\n#slider-toggle {\n  height: 50px;\n}\n\n#slider-toggle.off .noUi-handle {\n  border-color: #f06548;\n}\n\n[data-slider-color=\"primary\"] .noUi-connect {\n  background: #4b38b3;\n}\n\n[data-slider-color=\"primary\"] .noUi-handle {\n  background: #4b38b3;\n}\n\n[data-slider-color=\"primary\"][data-slider-style=\"border\"] .noUi-handle,\n[data-slider-color=\"primary\"][data-slider-style=\"square\"] .noUi-handle {\n  border-color: #4b38b3;\n}\n\n[data-slider-color=\"secondary\"] .noUi-connect {\n  background: #3577f1;\n}\n\n[data-slider-color=\"secondary\"] .noUi-handle {\n  background: #3577f1;\n}\n\n[data-slider-color=\"secondary\"][data-slider-style=\"border\"] .noUi-handle,\n[data-slider-color=\"secondary\"][data-slider-style=\"square\"] .noUi-handle {\n  border-color: #3577f1;\n}\n\n[data-slider-color=\"success\"] .noUi-connect {\n  background: #45cb85;\n}\n\n[data-slider-color=\"success\"] .noUi-handle {\n  background: #45cb85;\n}\n\n[data-slider-color=\"success\"][data-slider-style=\"border\"] .noUi-handle,\n[data-slider-color=\"success\"][data-slider-style=\"square\"] .noUi-handle {\n  border-color: #45cb85;\n}\n\n[data-slider-color=\"info\"] .noUi-connect {\n  background: #299cdb;\n}\n\n[data-slider-color=\"info\"] .noUi-handle {\n  background: #299cdb;\n}\n\n[data-slider-color=\"info\"][data-slider-style=\"border\"] .noUi-handle,\n[data-slider-color=\"info\"][data-slider-style=\"square\"] .noUi-handle {\n  border-color: #299cdb;\n}\n\n[data-slider-color=\"warning\"] .noUi-connect {\n  background: #ffbe0b;\n}\n\n[data-slider-color=\"warning\"] .noUi-handle {\n  background: #ffbe0b;\n}\n\n[data-slider-color=\"warning\"][data-slider-style=\"border\"] .noUi-handle,\n[data-slider-color=\"warning\"][data-slider-style=\"square\"] .noUi-handle {\n  border-color: #ffbe0b;\n}\n\n[data-slider-color=\"danger\"] .noUi-connect {\n  background: #f06548;\n}\n\n[data-slider-color=\"danger\"] .noUi-handle {\n  background: #f06548;\n}\n\n[data-slider-color=\"danger\"][data-slider-style=\"border\"] .noUi-handle,\n[data-slider-color=\"danger\"][data-slider-style=\"square\"] .noUi-handle {\n  border-color: #f06548;\n}\n\n[data-slider-color=\"light\"] .noUi-connect {\n  background: #f3f6f9;\n}\n\n[data-slider-color=\"light\"] .noUi-handle {\n  background: #f3f6f9;\n}\n\n[data-slider-color=\"light\"][data-slider-style=\"border\"] .noUi-handle,\n[data-slider-color=\"light\"][data-slider-style=\"square\"] .noUi-handle {\n  border-color: #f3f6f9;\n}\n\n[data-slider-color=\"dark\"] .noUi-connect {\n  background: #212529;\n}\n\n[data-slider-color=\"dark\"] .noUi-handle {\n  background: #212529;\n}\n\n[data-slider-color=\"dark\"][data-slider-style=\"border\"] .noUi-handle,\n[data-slider-color=\"dark\"][data-slider-style=\"square\"] .noUi-handle {\n  border-color: #212529;\n}\n\n[data-slider-size=\"lg\"].noUi-horizontal {\n  height: 12px;\n}\n\n[data-slider-size=\"lg\"].noUi-horizontal .noUi-handle {\n  width: 24px;\n  height: 24px;\n}\n\n[data-slider-size=\"md\"].noUi-horizontal {\n  height: 8px;\n}\n\n[data-slider-size=\"md\"].noUi-horizontal .noUi-handle {\n  width: 20px;\n  height: 20px;\n}\n\n[data-slider-size=\"sm\"].noUi-horizontal {\n  height: 4px;\n}\n\n[data-slider-size=\"sm\"].noUi-horizontal .noUi-handle {\n  width: 16px;\n  height: 16px;\n}\n\n[data-slider-style=\"line\"].noUi-horizontal .noUi-handle {\n  width: 8px;\n  border-radius: 4px;\n  right: -8px;\n}\n\n[data-slider-style=\"line\"].noUi-vertical .noUi-handle {\n  height: 8px;\n  border-radius: 4px;\n  top: -3px;\n}\n\n[data-slider-style=\"border\"] .noUi-handle {\n  border-color: #45cb85;\n  background-color: #fff;\n}\n\n[data-slider-style=\"square\"] .noUi-handle {\n  border-radius: 0;\n  -webkit-transform: rotate(45deg);\n  transform: rotate(45deg);\n  height: 10px;\n  width: 10px;\n  top: -4px;\n  border-color: #45cb85;\n  background-color: #fff;\n}\n\n.nested-list .list-group-item {\n  background-color: rgba(75, 56, 179, 0.05);\n  border-color: rgba(75, 56, 179, 0.05);\n}\n\n.nested-1,\n.nested-2,\n.nested-3,\n.nested-list {\n  margin-top: 5px;\n}\n\n.nested-sortable-handle .handle {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 42px;\n  height: 42px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  cursor: -webkit-grab;\n  cursor: grab;\n}\n\n.nested-sortable-handle .list-group-item {\n  padding-left: 42px;\n}\n\n.shepherd-element {\n  background: var(--bs-card-bg-custom);\n  -webkit-box-shadow: var(--bs-box-shadow);\n  box-shadow: var(--bs-box-shadow);\n}\n\n.shepherd-has-title .shepherd-content .shepherd-header {\n  background-color: var(--bs-light);\n  padding: 0.5rem 0.75rem;\n}\n\n.shepherd-has-title .shepherd-content .shepherd-cancel-icon {\n  color: rgba(var(--bs-dark-rgb), 0.75);\n}\n\n.shepherd-has-title .shepherd-content .shepherd-cancel-icon:hover {\n  color: rgba(var(--bs-dark-rgb), 0.75);\n}\n\n.shepherd-element.shepherd-has-title[data-popper-placement^=\"bottom\"]\n  > .shepherd-arrow:before {\n  background-color: var(--bs-light);\n}\n\n.shepherd-title {\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--bs-body-color);\n}\n\n.shepherd-text {\n  padding: 0.75rem;\n  font-size: 0.8125rem;\n  color: var(--bs-body-color);\n}\n\n.shepherd-button.btn-success:not(:disabled):hover {\n  background: #3bc87e;\n  color: #fff;\n}\n\n.shepherd-button.btn-light:not(:disabled):hover {\n  background: rgba(var(--bs-light-rgb), 0.75);\n  color: var(--bs-dark);\n}\n\n.shepherd-button.btn-primary:not(:disabled):hover {\n  background: #4735a9;\n  color: #fff;\n}\n\n.shepherd-footer {\n  padding: 0 0.75rem 0.75rem;\n}\n\n.shepherd-arrow,\n.shepherd-arrow:before {\n  content: \"\\ea75\";\n  font-family: remixicon;\n  font-size: 24px;\n  z-index: 1;\n  background-color: transparent !important;\n  -webkit-transform: rotate(0);\n  transform: rotate(0);\n  color: #4b38b3;\n}\n\n.shepherd-element[data-popper-placement^=\"bottom\"] > .shepherd-arrow {\n  top: -18px;\n}\n\n.shepherd-button {\n  margin-right: 0.5rem;\n}\n\n.swiper-button-next,\n.swiper-button-prev {\n  height: 32px;\n  width: 32px;\n  background-color: rgba(75, 56, 179, 0.2);\n  -webkit-backdrop-filter: blur(2px);\n  backdrop-filter: blur(2px);\n  border-radius: 8px;\n}\n\n.swiper-button-next::after,\n.swiper-button-prev::after {\n  font-family: remixicon;\n  font-size: 28px;\n  color: #4b38b3;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.swiper-button-prev::after {\n  content: \"\\ea64\" !important;\n}\n\n.swiper-button-next::after {\n  content: \"\\ea6e\" !important;\n}\n\n.swiper-pagination-bullet {\n  width: 22px;\n  height: 5px;\n  background-color: #fff;\n  border-radius: 50px;\n  -webkit-box-shadow: var(--bs-box-shadow);\n  box-shadow: var(--bs-box-shadow);\n}\n\n.swiper-pagination-bullet .swiper-pagination-bullet-active {\n  opacity: 1;\n}\n\n.dynamic-pagination .swiper-pagination-bullet {\n  width: 8px;\n  height: 8px;\n  background-color: #fff;\n  opacity: 0.5;\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n}\n\n.dynamic-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  opacity: 1;\n  width: 20px;\n}\n\n.swiper-pagination-fraction {\n  color: #fff;\n  font-size: 16px;\n  background-color: rgba(0, 0, 0, 0.3);\n  -webkit-backdrop-filter: blur(2px);\n  backdrop-filter: blur(2px);\n}\n\n.pagination-custom .swiper-pagination-bullet {\n  height: 25px;\n  width: 25px;\n  line-height: 25px;\n  border-radius: 8px;\n  background-color: #fff;\n  opacity: 0.5;\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n}\n\n.pagination-custom .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  color: #3577f1;\n  opacity: 1;\n}\n\n.swiper-pagination-progressbar {\n  height: 6px !important;\n  background-color: rgba(69, 203, 133, 0.25);\n}\n\n.swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  background-color: #45cb85;\n}\n\n.swiper-scrollbar {\n  background-color: rgba(255, 255, 255, 0.35);\n  -webkit-backdrop-filter: blur(2px);\n  backdrop-filter: blur(2px);\n  padding: 1.2px;\n  height: 6px !important;\n}\n\n.swiper-scrollbar .swiper-scrollbar-drag {\n  background-color: #fff;\n}\n\n.swiper-pagination-dark .swiper-pagination-bullet {\n  background-color: #3577f1;\n}\n\n.swiper-pagination-dark .dynamic-pagination .swiper-pagination-bullet {\n  background-color: #3577f1;\n}\n\n.swiper-pagination-dark.pagination-custom .swiper-pagination-bullet {\n  color: #fff;\n}\n\n.swiper-pagination-dark.pagination-custom\n  .swiper-pagination-bullet.swiper-pagination-bullet-active {\n  opacity: 1;\n}\n\n.swiper-pagination-dark.swiper-scrollbar {\n  background-color: rgba(33, 37, 41, 0.35);\n}\n\n.multi-wrapper {\n  border: none;\n  position: relative;\n}\n\n.multi-wrapper::before {\n  content: \"\\ea61\";\n  position: absolute;\n  font-family: remixicon;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  bottom: 86px;\n  width: 32px;\n  height: 32px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  font-size: 16px;\n  border-radius: 50%;\n  color: #878a99;\n  background-color: var(--bs-light);\n  z-index: 1;\n}\n\n.multi-wrapper .non-selected-wrapper {\n  border: 1px solid var(--bs-input-border);\n  background-color: var(--bs-input-bg);\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.multi-wrapper .non-selected-wrapper::-webkit-scrollbar,\n.multi-wrapper .selected-wrapper::-webkit-scrollbar {\n  -webkit-appearance: none;\n}\n\n.multi-wrapper .non-selected-wrapper::-webkit-scrollbar:vertical,\n.multi-wrapper .selected-wrapper::-webkit-scrollbar:vertical {\n  width: 10px;\n}\n\n.multi-wrapper .non-selected-wrapper::-webkit-scrollbar:horizontal,\n.multi-wrapper .selected-wrapper::-webkit-scrollbar:horizontal {\n  height: 9px;\n}\n\n.multi-wrapper .non-selected-wrapper::-webkit-scrollbar-thumb,\n.multi-wrapper .selected-wrapper::-webkit-scrollbar-thumb {\n  background-color: rgba(var(--bs-dark-rgb), 0.2);\n  border-radius: 10px;\n  border: 2px solid var(--bs-input-bg);\n}\n\n.multi-wrapper .non-selected-wrapper::-webkit-scrollbar-track,\n.multi-wrapper .selected-wrapper::-webkit-scrollbar-track {\n  border-radius: 10px;\n  background-color: var(--bs-input-bg);\n}\n\n.multi-wrapper .item-group .group-label {\n  font-size: 12px;\n}\n\n.multi-wrapper .item {\n  color: var(--bs-body-color);\n}\n\n.multi-wrapper .item:hover {\n  background-color: rgba(75, 56, 179, 0.1);\n}\n\n.multi-wrapper .selected-wrapper {\n  border: 1px solid var(--bs-input-border);\n  background: var(--bs-input-bg);\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.multi-wrapper .search-input {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  padding: 0.5rem 0.9rem;\n  font-size: 0.8125rem;\n  color: var(--bs-body-color);\n  background-color: var(--bs-input-bg);\n  border: 1px solid var(--bs-input-border);\n  border-radius: 0.25rem;\n  margin-bottom: 16px;\n}\n\n.multi-wrapper .search-input::-webkit-input-placeholder {\n  color: #878a99;\n}\n\n.multi-wrapper .search-input::-moz-placeholder {\n  color: #878a99;\n}\n\n.multi-wrapper .search-input:-ms-input-placeholder {\n  color: #878a99;\n}\n\n.multi-wrapper .search-input::-ms-input-placeholder {\n  color: #878a99;\n}\n\n.multi-wrapper .search-input::placeholder {\n  color: #878a99;\n}\n\n.multi-wrapper .header {\n  font-weight: 600;\n  color: var(--bs-gray-600);\n}\n\n.pcr-app {\n  background: var(--bs-card-bg-custom);\n  -webkit-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n  border-radius: 4px;\n  border: 1px solid var(--bs-border-color);\n}\n\n.pickr .pcr-button {\n  border: 4px solid var(--bs-card-bg-custom);\n  -webkit-box-shadow: 0 0 0 2px var(--bs-border-color);\n  box-shadow: 0 0 0 2px var(--bs-border-color);\n  border-radius: 50%;\n  -webkit-box-shadow: var(--bs-box-shadow);\n  box-shadow: var(--bs-box-shadow);\n}\n\n.pickr .pcr-button::after,\n.pickr .pcr-button::before {\n  border-radius: 50%;\n}\n\n.pcr-app[data-theme=\"classic\"] .pcr-selection .pcr-color-preview {\n  margin-right: 0.75em;\n  margin-left: 0;\n}\n\n.pcr-app[data-theme=\"classic\"] .pcr-selection .pcr-color-chooser,\n.pcr-app[data-theme=\"classic\"] .pcr-selection .pcr-color-opacity {\n  margin-left: 0.75em;\n  margin-right: 0;\n}\n\n.pcr-app[data-theme=\"monolith\"] .pcr-result {\n  min-width: 100%;\n}\n\n.pcr-app .pcr-interaction .pcr-type.active {\n  background: #4b38b3;\n}\n\n.pcr-app .pcr-interaction .pcr-result {\n  background-color: var(--bs-input-bg);\n  color: var(--bs-body-color);\n  border: 1px solid var(--bs-input-border);\n  border-radius: 0.25rem;\n}\n\n.pcr-app .pcr-interaction input {\n  border-radius: 0.25rem !important;\n}\n\n.pcr-app .pcr-interaction input:focus {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  background-color: var(--bs-input-bg);\n  border-color: var(--bs-input-focus-border);\n}\n\n.pcr-app .pcr-interaction .pcr-save {\n  background: #45cb85 !important;\n}\n\n.pcr-app .pcr-interaction .pcr-cancel,\n.pcr-app .pcr-interaction .pcr-clear {\n  background: #f06548 !important;\n}\n\n.filepond--root {\n  margin-bottom: 0;\n}\n\n.filepond--root[data-style-panel-layout~=\"circle\"] .filepond--drop-label label {\n  font-size: 14px;\n}\n\n.filepond--panel-root {\n  border: 2px dashed var(--bs-border-color);\n  background: var(--bs-card-bg-custom);\n}\n\n.filepond--drop-label {\n  color: var(--bs-body-color);\n}\n\n.filepond--drop-label label {\n  font-weight: 500;\n}\n\n.filepond--credits {\n  display: none;\n}\n\n.filepond--item-panel {\n  background-color: #4b38b3 !important;\n}\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  height: auto;\n}\n\n.input-step {\n  border: 1px solid var(--bs-input-border);\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  overflow: visible;\n  height: 37.5px;\n  border-radius: 0.25rem;\n  background: var(--bs-input-bg);\n  padding: 4px;\n  max-width: 115px;\n}\n\n.input-step input {\n  width: 4em;\n  height: 100%;\n  text-align: center;\n  border: 0;\n  background: 0 0;\n  color: var(--bs-body-color);\n  border-radius: 0.25rem;\n}\n\n.input-step input:focus-visible {\n  outline: 0;\n}\n\n.input-step button {\n  width: 1.4em;\n  font-weight: 300;\n  height: 100%;\n  line-height: 0.1em;\n  font-size: 1.4em;\n  padding: 0.2em !important;\n  background: var(--bs-light);\n  color: var(--bs-body-color);\n  border: none;\n  border-radius: 0.25rem;\n}\n\n.input-step.light {\n  background: var(--bs-light);\n}\n\n.input-step.light button {\n  background-color: var(--bs-input-bg);\n}\n\n.input-step.light-input {\n  background: var(--bs-light);\n}\n\n.input-step.light-input input {\n  background-color: var(--bs-input-bg);\n}\n\n.input-step.full-width {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n\n.input-step.full-width button {\n  -ms-flex-negative: 0;\n  flex-shrink: 0;\n}\n\n.input-step.full-width input {\n  -webkit-box-flex: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n}\n\n.input-step.step-primary button {\n  background-color: #4b38b3;\n  color: #fff;\n}\n\n.input-step.step-secondary button {\n  background-color: #3577f1;\n  color: #fff;\n}\n\n.input-step.step-success button {\n  background-color: #45cb85;\n  color: #fff;\n}\n\n.input-step.step-info button {\n  background-color: #299cdb;\n  color: #fff;\n}\n\n.input-step.step-warning button {\n  background-color: #ffbe0b;\n  color: #fff;\n}\n\n.input-step.step-danger button {\n  background-color: #f06548;\n  color: #fff;\n}\n\n.input-step.step-light button {\n  background-color: #f3f6f9;\n  color: #fff;\n}\n\n.input-step.step-dark button {\n  background-color: #212529;\n  color: #fff;\n}\n\n.ck {\n  font-family: var(--bs-font-sans-serif) !important;\n}\n\n.ck.ck-reset_all,\n.ck.ck-reset_all * {\n  color: var(--bs-body-color) !important;\n}\n\n.ck.ck-toolbar {\n  background: rgba(var(--bs-light-rgb), 0.75) !important;\n}\n\n.ck p {\n  margin-bottom: 0;\n}\n\n.ck.ck-toolbar {\n  border: 1px solid var(--bs-input-border) !important;\n}\n\n.ck.ck-toolbar.ck-toolbar_grouping > .ck-toolbar__items {\n  -ms-flex-wrap: wrap !important;\n  flex-wrap: wrap !important;\n}\n\n.ck.ck-toolbar .ck.ck-toolbar__separator {\n  background: 0 0 !important;\n}\n\n.ck.ck-editor__main > .ck-editor__editable {\n  border-top: 0 !important;\n  background-color: var(--bs-card-bg-custom) !important;\n  border-color: var(--bs-input-border) !important;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.ck.ck-dropdown__panel {\n  background: var(--bs-choices-bg) !important;\n  -webkit-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n  -webkit-animation-name: DropDownSlide;\n  animation-name: DropDownSlide;\n  -webkit-animation-duration: 0.3s;\n  animation-duration: 0.3s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  border-radius: 0.3rem;\n}\n\n.ck.ck-list {\n  background: var(--bs-choices-bg) !important;\n}\n\n.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,\n.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se {\n  left: 0;\n  right: auto !important;\n}\n\n.ck.ck-editor__editable_inline[dir=\"ltr\"] {\n  text-align: left !important;\n}\n\n.ck.ck-dropdown__panel {\n  -webkit-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12) !important;\n  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12) !important;\n  border-radius: 0.3rem !important;\n  border: 1px solid var(--bs-border-color) !important;\n}\n\n.ck.ck-button:active,\n.ck.ck-button:focus,\na.ck.ck-button:active,\na.ck.ck-button:focus {\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n  border: 1px solid var(--bs-light) !important;\n}\n\n.ck.ck-button:not(.ck-disabled):hover,\na.ck.ck-button:not(.ck-disabled):hover {\n  background: var(--bs-light) !important;\n}\n\n.ck.ck-button.ck-on,\na.ck.ck-button.ck-on {\n  background: var(--bs-light) !important;\n}\n\n.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,\n.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {\n  border-radius: 0.25rem !important;\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,\n.ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {\n  border-radius: 0.25rem !important;\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n.ck-editor__editable {\n  min-height: 245px !important;\n}\n\n.ck[class*=\"ck-heading_heading\"] {\n  font-weight: 500 !important;\n}\n\n.ck.ck-button.ck-on:not(.ck-disabled):active,\n.ck.ck-button.ck-on:not(.ck-disabled):hover,\na.ck.ck-button.ck-on:not(.ck-disabled):active,\na.ck.ck-button.ck-on:not(.ck-disabled):hover {\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.ck.ck-tooltip .ck-tooltip__text {\n  background: #212529 !important;\n  color: #f3f6f9 !important;\n}\n\n.ck.ck-input-text {\n  background: var(--bs-input-bg) !important;\n  border: 1px solid var(--bs-input-border) !important;\n}\n\n.ck.ck-input-text:focus {\n  border: 1px solid var(--bs-input-focus-border) !important;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.ck.ck-balloon-panel {\n  background: #fff !important;\n  border: 1px solid var(--bs-border-color) !important;\n}\n\n.ck.ck-balloon-panel[class*=\"arrow_n\"]:after {\n  border-bottom-color: #fff !important;\n}\n\n.ck.ck-balloon-panel[class*=\"arrow_n\"]::before {\n  border-bottom-color: var(--bs-border-color) !important;\n}\n\n.ck.ck-labeled-field-view\n  > .ck.ck-labeled-field-view__input-wrapper\n  > .ck.ck-label {\n  background: #fff !important;\n}\n\n.ck-editor-reverse .ck-editor {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: reverse;\n  -ms-flex-direction: column-reverse;\n  flex-direction: column-reverse;\n}\n\n.ck-editor-reverse .ck.ck-editor__main > .ck-editor__editable {\n  border: 1px solid var(--bs-input-border) !important;\n  border-bottom: 0 !important;\n}\n\n.ck-editor-reverse\n  .ck-rounded-corners\n  .ck.ck-editor__main\n  > .ck-editor__editable,\n.ck-editor-reverse\n  .ck.ck-editor__main\n  > .ck-editor__editable.ck-rounded-corners {\n  border-radius: 0.25rem !important;\n  border-bottom-left-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n}\n\n.ck-editor-reverse\n  .ck-rounded-corners\n  .ck.ck-editor__top\n  .ck-sticky-panel\n  .ck-toolbar,\n.ck-editor-reverse\n  .ck.ck-editor__top\n  .ck-sticky-panel\n  .ck-toolbar.ck-rounded-corners {\n  border-radius: 0.25rem !important;\n  border-top-left-radius: 0 !important;\n  border-top-right-radius: 0 !important;\n}\n\n[dir=\"rtl\"] .ck.ck-toolbar > .ck-toolbar__items {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: reverse;\n  -ms-flex-direction: row-reverse;\n  flex-direction: row-reverse;\n}\n\n.ql-editor {\n  text-align: left;\n}\n\n.ql-editor ol,\n.ql-editor ul {\n  padding-left: 1.5em;\n  padding-right: 0;\n}\n\n.ql-editor li:not(.ql-direction-rtl)::before {\n  margin-left: -1.5em;\n  margin-right: 0.3em;\n  text-align: right;\n}\n\n.ql-container {\n  font-family: var(--bs-font-sans-serif);\n}\n\n.ql-container.ql-snow {\n  border-color: var(--bs-input-border);\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.ql-bubble {\n  border: 1px solid var(--bs-input-border);\n  border-radius: 0.25rem;\n}\n\n.ql-toolbar {\n  font-family: var(--bs-font-sans-serif) !important;\n}\n\n.ql-toolbar span {\n  outline: 0 !important;\n  color: var(--bs-choices-link-color);\n}\n\n.ql-toolbar span:hover {\n  color: #4b38b3 !important;\n}\n\n.ql-toolbar.ql-snow {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border-color: var(--bs-input-border);\n}\n\n.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n  border-color: transparent;\n}\n\n.ql-toolbar.ql-snow .ql-picker-options {\n  -webkit-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n  border-radius: 0.3rem;\n}\n\n.ql-snow .ql-script,\n.ql-snow .ql-strike svg,\n.ql-snow .ql-stroke {\n  stroke: var(--bs-choices-link-color);\n}\n\n.ql-snow .ql-fill {\n  fill: var(--bs-choices-link-color);\n}\n\n.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {\n  right: 0;\n  left: auto;\n}\n\n.ql-snow .ql-picker.ql-expanded .ql-picker-label {\n  color: var(--bs-choices-link-color);\n}\n\n.ql-snow .ql-picker-options {\n  background-color: var(--bs-choices-bg);\n  border-color: var(--bs-border-color) !important;\n}\n\n.gridjs-container {\n  color: var(--bs-body-color);\n  padding: 0;\n  display: block;\n}\n\n.gridjs-wrapper {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  border: 1px solid var(--bs-border-color);\n  border-radius: 0;\n}\n\n.gridjs-wrapper::-webkit-scrollbar {\n  -webkit-appearance: none;\n}\n\n.gridjs-wrapper::-webkit-scrollbar:vertical {\n  width: 12px;\n}\n\n.gridjs-wrapper::-webkit-scrollbar:horizontal {\n  height: 12px;\n}\n\n.gridjs-wrapper::-webkit-scrollbar-thumb {\n  background-color: rgba(var(--bs-dark-rgb), 0.075);\n  border-radius: 10px;\n  border: 2px solid var(--bs-card-bg-custom);\n}\n\n.gridjs-wrapper::-webkit-scrollbar-track {\n  border-radius: 10px;\n  background-color: var(--bs-card-bg-custom);\n}\n\n.gridjs-footer {\n  border: none !important;\n  padding: 12px 0 0;\n}\n\n.gridjs-table {\n  width: 100%;\n}\n\n.gridjs-tbody,\ntd.gridjs-td {\n  background-color: transparent;\n}\n\ntd.gridjs-td,\nth.gridjs-th {\n  border: 1px solid var(--bs-border-color);\n  padding: 0.75rem 0.6rem;\n}\n\nth.gridjs-th {\n  border-top: 0;\n  color: var(--bs-body-color);\n  background-color: rgba(var(--bs-light-rgb), 0.75);\n}\n\nth.gridjs-th-sort:focus,\nth.gridjs-th-sort:hover {\n  background-color: rgba(var(--bs-light-rgb), 0.85);\n}\n\n.gridjs-head {\n  padding-top: 0;\n}\n\n.gridjs-footer {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  border: 1px solid var(--bs-border-color);\n  border-top: 0;\n  background-color: transparent;\n}\n\n.gridjs-summary {\n  color: #878a99;\n  margin-top: 8px !important;\n}\n\n.gridjs-pagination .gridjs-pages button {\n  margin-left: 0.3rem;\n  border-radius: 0.25rem !important;\n  border: 1px solid transparent;\n  background-color: var(--bs-card-bg-custom);\n  color: var(--bs-link-color);\n}\n\n.gridjs-pagination .gridjs-pages button:last-child {\n  border-right: 1px solid transparent;\n}\n\n.gridjs-pagination .gridjs-pages button:disabled,\n.gridjs-pagination .gridjs-pages button:hover:disabled,\n.gridjs-pagination .gridjs-pages button[disabled] {\n  color: #878a99;\n  background-color: var(--bs-card-bg-custom);\n}\n\n.gridjs-pagination .gridjs-pages button:hover {\n  background-color: #eff2f7;\n  color: var(--bs-link-hover-color);\n}\n\n.gridjs-pagination .gridjs-pages button:focus {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.gridjs-pagination .gridjs-pages button:first-child:hover,\n.gridjs-pagination .gridjs-pages button:last-child:hover {\n  background-color: transparent;\n}\n\n.gridjs-pagination .gridjs-pages button.gridjs-currentPage {\n  background-color: #4b38b3;\n  color: #fff;\n  border-color: #4b38b3;\n  font-weight: 500;\n}\n\n.gridjs-search {\n  position: relative;\n  float: left;\n}\n\n.gridjs-search::before {\n  content: \"\\f0d1\";\n  font-family: remixicon;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n  left: 10px;\n  font-size: 14px;\n  color: #878a99;\n}\n\ninput.gridjs-input {\n  border-color: var(--bs-input-border);\n  background-color: var(--bs-input-bg);\n  color: var(--bs-body-color);\n  line-height: 1.5;\n  padding: 0.5rem 0.9rem 0.5rem 2.025rem;\n  border-radius: 0.25rem;\n  font-size: 0.8125rem;\n}\n\ninput.gridjs-input:focus {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  border-color: var(--bs-input-focus-border);\n  background-color: var(--bs-input-bg);\n}\n\ninput.gridjs-input::-webkit-input-placeholder {\n  color: #878a99;\n}\n\ninput.gridjs-input::-moz-placeholder {\n  color: #878a99;\n}\n\ninput.gridjs-input:-ms-input-placeholder {\n  color: #878a99;\n}\n\ninput.gridjs-input::-ms-input-placeholder {\n  color: #878a99;\n}\n\ninput.gridjs-input::placeholder {\n  color: #878a99;\n}\n\nth.gridjs-th .gridjs-th-content {\n  float: none;\n  display: inline-block;\n  vertical-align: middle;\n  font-weight: 600;\n}\n\nbutton.gridjs-sort {\n  float: none;\n  display: inline-block;\n  vertical-align: middle;\n  width: 10px;\n  height: 20px;\n}\n\nth.gridjs-th-sort .gridjs-th-content {\n  width: calc(100% - 10px);\n}\n\nbutton.gridjs-sort-asc,\nbutton.gridjs-sort-desc {\n  background-size: 7px;\n}\n\n.table-card .gridjs-head {\n  padding: 16px 16px 5px;\n}\n\n.table-card .gridjs-wrapper {\n  border-top: 0;\n  border-radius: 0;\n  border-width: 1px 0;\n}\n\n.table-card .gridjs-footer {\n  padding: 8px 16px;\n}\n\n.gridjs-tr-selected td {\n  background-color: rgba(var(--bs-light-rgb), 1);\n}\n\n.gridjs-tr-selected .gridjs-td .gridjs-checkbox[type=\"checkbox\"] {\n  background-color: #4b38b3;\n  border-color: #4b38b3;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e\");\n}\n\n.gridjs-td .gridjs-checkbox {\n  width: 1.1em;\n  height: 1.1em;\n  vertical-align: top;\n  background-color: var(--bs-input-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: 1px solid var(--bs-input-check-border);\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  -webkit-print-color-adjust: exact;\n  print-color-adjust: exact;\n}\n\n.gridjs-td .gridjs-checkbox[type=\"checkbox\"] {\n  border-radius: 0.25em;\n}\n\n.gridjs-border-none td.gridjs-td,\n.gridjs-border-none th.gridjs-th {\n  border-right-width: 0;\n  border-left-width: 0;\n}\n\n.gridjs-loading-bar {\n  background-color: var(--bs-card-bg-custom);\n}\n\n[data-layout-mode=\"dark\"] button.gridjs-sort-asc,\n[data-layout-mode=\"dark\"] button.gridjs-sort-desc,\n[data-layout-mode=\"dark\"] button.gridjs-sort-neutral {\n  -webkit-filter: invert(1) grayscale(100%) brightness(200%);\n  filter: invert(1) grayscale(100%) brightness(200%);\n}\n\n.listjs-pagination {\n  margin-bottom: 0;\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.listjs-pagination li .page {\n  display: block;\n  padding: 0.375rem 0.75rem;\n  color: var(--bs-link-color);\n  background-color: var(--bs-card-bg-custom);\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n}\n\n.listjs-pagination li.active .page {\n  color: #fff;\n  background-color: #4b38b3;\n  border-color: #4b38b3;\n}\n\n.pagination-wrap {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.pagination-wrap a {\n  text-decoration: none;\n  display: inline-block;\n}\n\n.pagination-next,\n.pagination-prev {\n  color: #4b38b3;\n  font-weight: 500;\n  padding: 0.375rem 0.75rem;\n  background-color: var(--bs-card-bg-custom);\n  border: 1px solid transparent;\n  border-radius: 0.25rem;\n}\n\n.pagination-next:hover,\n.pagination-prev:hover {\n  color: #897bd6;\n}\n\n.pagination-next.disabled,\n.pagination-prev.disabled {\n  color: #878a99;\n  cursor: default;\n}\n\n.pagination-next.disabled:hover,\n.pagination-prev.disabled:hover {\n  color: #878a99;\n}\n\n.apex-charts {\n  min-height: 10px !important;\n}\n\n.apex-charts text {\n  font-family: var(--bs-font-sans-serif) !important;\n}\n\n.apex-charts .apexcharts-canvas {\n  margin: 0 auto;\n}\n\n.apexcharts-tooltip-text,\n.apexcharts-tooltip-title {\n  font-family: var(--bs-font-sans-serif) !important;\n}\n\n.apexcharts-tooltip {\n  border: 1px solid var(--bs-border-color) !important;\n  background-color: var(--bs-card-bg-custom) !important;\n  -webkit-box-shadow: var(--bs-box-shadow) !important;\n  box-shadow: var(--bs-box-shadow) !important;\n}\n\n.apexcharts-tooltip * {\n  font-family: var(--bs-font-sans-serif) !important;\n  color: #878a99 !important;\n}\n\n.apexcharts-tooltip .apexcharts-tooltip-title {\n  background-color: rgba(var(--bs-light-rgb), 0.75) !important;\n  border-bottom: 1px solid var(--bs-border-color) !important;\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark * {\n  color: #fff !important;\n}\n\n.apexcharts-legend-series {\n  font-weight: 500;\n}\n\n.apexcharts-gridline {\n  pointer-events: none;\n  stroke: rgba(var(--bs-light-rgb), 0.75);\n}\n\n.apexcharts-legend-text {\n  color: #878a99 !important;\n  font-family: var(--bs-font-sans-serif) !important;\n  font-size: 13px !important;\n}\n\n.apexcharts-pie-label {\n  fill: #fff !important;\n}\n\n.apexcharts-subtitle-text,\n.apexcharts-title-text {\n  fill: #adb5bd;\n}\n\n.apexcharts-xaxis text,\n.apexcharts-yaxis text {\n  font-family: var(--bs-font-sans-serif) !important;\n  fill: #adb5bd;\n}\n\n.apexcharts-yaxis-title {\n  font-weight: 500;\n}\n\n#dynamicloadedchart-wrap {\n  margin: 0 auto;\n  max-width: 800px;\n  position: relative;\n}\n\n.chart-box {\n  padding-left: 0;\n}\n\n#chart-quarter,\n#chart-year {\n  width: 96%;\n  max-width: 48%;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  padding-left: 0;\n  padding-top: 20px;\n  background: var(--bs-card-bg-custom);\n  border: 1px solid var(--bs-border-color);\n}\n\n#chart-year {\n  float: left;\n  position: relative;\n  -webkit-transition: 1s ease transform;\n  transition: 1s ease transform;\n  z-index: 3;\n}\n\n#chart-year.chart-quarter-activated {\n  -webkit-transform: translateX(0);\n  transform: translateX(0);\n  -webkit-transition: 1s ease transform;\n  transition: 1s ease transform;\n}\n\n#chart-quarter {\n  float: left;\n  position: relative;\n  z-index: -2;\n  -webkit-transition: 1s ease transform;\n  transition: 1s ease transform;\n}\n\n#chart-quarter.active {\n  -webkit-transition: 1.1s ease-in-out transform;\n  transition: 1.1s ease-in-out transform;\n  -webkit-transform: translateX(0);\n  transform: translateX(0);\n  z-index: 1;\n}\n\n@media screen and (min-width: 480px) {\n  #chart-year {\n    -webkit-transform: translateX(50%);\n    transform: translateX(50%);\n  }\n\n  #chart-quarter {\n    -webkit-transform: translateX(-50%);\n    transform: translateX(-50%);\n  }\n}\n\n.apexcharts-radar-series line,\n.apexcharts-radar-series polygon {\n  stroke: var(--bs-border-color);\n}\n\n.apexcharts-pie circle,\n.apexcharts-pie line {\n  stroke: var(--bs-border-color);\n}\n\n.apexcharts-pie text {\n  fill: var(--bs-body-color);\n}\n\n.apex-charts .apexcharts-xaxis line,\n.apex-charts .apexcharts-yaxis line {\n  stroke: var(--bs-border-color);\n}\n\n.apex-charts .apexcharts-xaxis-tick {\n  stroke: var(--bs-border-color);\n}\n\n.apex-charts .apexcharts-bar-series path,\n.apex-charts .apexcharts-pie-series path {\n  stroke: var(--bs-card-bg-custom);\n}\n\n.apex-charts .apexcharts-radialbar-track path {\n  stroke: var(--bs-light);\n}\n\n.apex-charts .apexcharts-marker {\n  stroke: var(--bs-card-bg-custom);\n}\n\n.apex-charts .apexcharts-boxPlot-series path {\n  stroke: var(--bs-border-color);\n}\n\n.apex-charts .apexcharts-heatmap-series rect,\n.apex-charts .apexcharts-treemap rect {\n  stroke: var(--bs-card-bg-custom);\n}\n\n.chartjs-chart {\n  max-height: 320px;\n}\n\n.e-charts {\n  height: 350px;\n}\n\n.e-charts-height {\n  height: 300px;\n}\n\n.gmaps,\n.gmaps-panaroma {\n  height: 300px;\n  background: #f3f6f9;\n  border-radius: 3px;\n}\n\n.gmaps-overlay {\n  display: block;\n  text-align: center;\n  color: #fff;\n  font-size: 16px;\n  line-height: 40px;\n  background: #4b38b3;\n  border-radius: 4px;\n  padding: 10px 20px;\n}\n\n.gmaps-overlay_arrow {\n  left: 50%;\n  margin-left: -16px;\n  width: 0;\n  height: 0;\n  position: absolute;\n}\n\n.gmaps-overlay_arrow.above {\n  bottom: -15px;\n  border-left: 16px solid transparent;\n  border-right: 16px solid transparent;\n  border-top: 16px solid #4b38b3;\n}\n\n.gmaps-overlay_arrow.below {\n  top: -15px;\n  border-left: 16px solid transparent;\n  border-right: 16px solid transparent;\n  border-bottom: 16px solid #4b38b3;\n}\n\n.autoComplete_wrapper {\n  display: block;\n}\n\n.autoComplete_wrapper > input {\n  display: block;\n  width: 100%;\n  height: auto;\n  padding: 0.5rem 0.9rem;\n  font-size: 0.8125rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: var(--bs-body-color);\n  background-color: var(--bs-input-bg);\n  background-clip: padding-box;\n  border: 1px solid var(--bs-input-border);\n  border-radius: 0.25rem;\n  background-image: none;\n}\n\n.autoComplete_wrapper > input::-webkit-input-placeholder {\n  padding: 0 !important;\n  color: #878a99 !important;\n  font-size: 0.8125rem !important;\n}\n\n.autoComplete_wrapper > input::-moz-placeholder {\n  padding: 0 !important;\n  color: #878a99 !important;\n  font-size: 0.8125rem !important;\n}\n\n.autoComplete_wrapper > input:-ms-input-placeholder {\n  padding: 0 !important;\n  color: #878a99 !important;\n  font-size: 0.8125rem !important;\n}\n\n.autoComplete_wrapper > input::-ms-input-placeholder {\n  padding: 0 !important;\n  color: #878a99 !important;\n  font-size: 0.8125rem !important;\n}\n\n.autoComplete_wrapper > input::placeholder {\n  padding: 0 !important;\n  color: #878a99 !important;\n  font-size: 0.8125rem !important;\n}\n\n.autoComplete_wrapper > input:focus {\n  border: 1px solid var(--bs-input-focus-border);\n  color: var(--bs-body-color);\n}\n\n.autoComplete_wrapper > input:hover {\n  color: var(--bs-body-color);\n}\n\n.autoComplete_wrapper > ul {\n  border-radius: 0.25rem;\n  border-color: var(--bs-border-color);\n  background-color: #fff;\n  -webkit-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n  padding: 0;\n  overflow: auto;\n  max-height: 160px;\n  margin: 0;\n  -webkit-animation-name: DropDownSlide;\n  animation-name: DropDownSlide;\n  -webkit-animation-duration: 0.3s;\n  animation-duration: 0.3s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n.autoComplete_wrapper > ul > li {\n  font-size: 0.8125rem;\n  margin: 0;\n  padding: 0.35rem 1.2rem;\n  border-radius: 0;\n  background-color: #fff;\n  color: var(--bs-body-color);\n}\n\n.autoComplete_wrapper > ul > li mark {\n  color: #f06548;\n  font-weight: 600;\n  padding: 1px;\n}\n\n.autoComplete_wrapper > ul > li:hover,\n.autoComplete_wrapper > ul > li[aria-selected=\"true\"] {\n  color: #1e2125;\n  background-color: #f3f6f9;\n}\n\n.autoComplete_wrapper > ul .no_result {\n  padding: 0.7rem 1.2rem;\n  font-style: italic;\n  font-weight: 500;\n}\n\n.jvm-tooltip {\n  border-radius: 3px;\n  background-color: #4b38b3;\n  font-family: var(--bs-font-sans-serif);\n  -webkit-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n  padding: 5px 9px;\n}\n\n.jvm-container text {\n  font-family: var(--bs-font-sans-serif);\n  font-size: 0.8125rem;\n  fill: var(--bs-gray-700);\n}\n\n.jvm-zoom-btn {\n  background-color: #4b38b3;\n}\n\n.leaflet-map {\n  height: 300px;\n}\n\n.leaflet-map.leaflet-container {\n  z-index: 0;\n  font-family: Inter, sans-serif;\n}\n\n.fc td,\n.fc th {\n  border: 1px solid var(--bs-border-color);\n}\n\n.fc .fc-toolbar h2 {\n  font-size: 16px;\n  line-height: 30px;\n  text-transform: uppercase;\n}\n\n@media (max-width: 767.98px) {\n  .fc .fc-toolbar .fc-center,\n  .fc .fc-toolbar .fc-left,\n  .fc .fc-toolbar .fc-right {\n    float: none;\n    display: block;\n    text-align: center;\n    clear: both;\n    margin: 10px 0;\n  }\n\n  .fc .fc-toolbar > * > * {\n    float: none;\n  }\n\n  .fc .fc-toolbar .fc-today-button {\n    display: none;\n  }\n}\n\n.fc .fc-toolbar .btn {\n  text-transform: capitalize;\n}\n\n.fc .fc-col-header-cell {\n  background-color: var(--bs-light);\n}\n\n.fc .fc-col-header-cell-cushion {\n  display: block;\n  padding: 8px 4px;\n}\n\n.fc .fc-daygrid-day-number {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  padding: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 500;\n  margin: 2px;\n}\n\n.fc .fc-daygrid-day.fc-day-today {\n  background-color: rgba(75, 56, 179, 0.1);\n}\n\n.fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-number {\n  background-color: #4b38b3;\n  color: #fff;\n}\n\n.fc .fc-daygrid-day.fc-day-today {\n  background-color: rgba(75, 56, 179, 0.1);\n}\n\n.fc .fc-timegrid-col.fc-day-today {\n  background-color: rgba(75, 56, 179, 0.1);\n}\n\n.fc .fc-list-event:hover td {\n  background: 0 0;\n}\n\n.fc .fc-list-event-title a {\n  color: #fff !important;\n}\n\n.fc .fc-col-header,\n.fc .fc-daygrid-body,\n.fc .fc-scrollgrid-sync-table {\n  width: 100% !important;\n}\n\n.fc .fc-scrollgrid-section > * {\n  border-left: 1px solid var(--bs-border-color);\n  border-top: 1px solid var(--bs-border-color);\n}\n\n.fc .fc-scrollgrid-section-liquid > td {\n  border-top: 0;\n}\n\n.fc-theme-bootstrap a:not([href]) {\n  color: var(--bs-body-color);\n}\n\n.fc-event {\n  color: #fff;\n}\n\n.fc th.fc-widget-header {\n  background: #e9ebec;\n  line-height: 20px;\n  padding: 10px 0;\n  text-transform: uppercase;\n  font-weight: 700;\n}\n\n.fc-unthemed .fc-content,\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-list-heading td,\n.fc-unthemed .fc-list-view,\n.fc-unthemed .fc-popover,\n.fc-unthemed .fc-row,\n.fc-unthemed tbody,\n.fc-unthemed td,\n.fc-unthemed th,\n.fc-unthemed thead {\n  border-color: #e9ebec;\n}\n\n.fc-unthemed td.fc-today {\n  background: #f6f8fa;\n}\n\n.fc-button {\n  background: var(--bs-card-bg-custom);\n  border-color: var(--bs-border-color);\n  color: #495057;\n  text-transform: capitalize;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  padding: 6px 12px !important;\n  height: auto !important;\n}\n\n.fc-state-active,\n.fc-state-disabled,\n.fc-state-down {\n  background-color: #4b38b3;\n  color: #fff;\n  text-shadow: none;\n}\n\n.fc-event {\n  border-radius: 2px;\n  border: none;\n  cursor: move;\n  font-size: 0.8125rem;\n  margin: 5px 7px;\n  padding: 5px 5px;\n  text-align: center;\n}\n\n.fc-event,\n.fc-event-dot {\n  background-color: #4b38b3;\n}\n\n.fc-daygrid-dot-event.fc-event-mirror,\n.fc-daygrid-dot-event:hover {\n  background-color: #4b38b3;\n}\n\n.fc-event-title,\n.fc-sticky {\n  font-weight: 600 !important;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.fc-daygrid-event-dot {\n  border-color: #fff !important;\n  display: none;\n}\n\n.fc-event-time {\n  display: none;\n}\n\n.fc-event .fc-content {\n  color: #fff;\n}\n\n#external-events .external-event {\n  text-align: left;\n  padding: 8px 16px;\n  margin: 6px 0;\n}\n\n.fc-day-grid-event.fc-h-event.fc-event.fc-start.fc-end.bg-dark .fc-content {\n  color: #f3f6f9;\n}\n\n.fc-next-button,\n.fc-prev-button {\n  position: relative;\n  height: 37.5px;\n  width: 37.5px;\n}\n\n.fc-next-button::before,\n.fc-prev-button::before {\n  position: absolute;\n  font-family: remixicon !important;\n  font-size: 20px;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n}\n\n.fc-prev-button::before {\n  content: \"\\ea64\";\n}\n\n.fc-next-button::before {\n  content: \"\\ea6e\";\n}\n\n.fc-toolbar-chunk .btn-group {\n  -webkit-box-shadow: var(--bs-box-shadow);\n  box-shadow: var(--bs-box-shadow);\n}\n\n.fc-toolbar-chunk .btn-group .btn {\n  color: #3577f1;\n  background-color: rgba(53, 119, 241, 0.15);\n  border: none;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.fc-toolbar-chunk .btn-group .btn.active,\n.fc-toolbar-chunk .btn-group .btn:hover {\n  color: #fff;\n  background-color: #3577f1;\n}\n\n.fc-toolbar-chunk .fc-today-button {\n  background-color: #3577f1 !important;\n  border: #3577f1;\n}\n\n@media (max-width: 575.98px) {\n  .fc-toolbar {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    gap: 16px;\n  }\n}\n\n#upcoming-event-list .card:last-child {\n  margin-bottom: 6px !important;\n}\n\n#event-modal .event-details {\n  display: none;\n}\n\n#event-modal .view-event .event-form {\n  display: none;\n}\n\n#event-modal .view-event #event-category-tag {\n  display: none;\n}\n\n#event-modal .view-event .event-details {\n  display: block;\n}\n\n.fc-daygrid-event-harness .fc-daygrid-event {\n  -webkit-backdrop-filter: blur(4px);\n  backdrop-filter: blur(4px);\n}\n\n.fc-timegrid-event-harness .fc-timegrid-event {\n  -webkit-backdrop-filter: blur(4px);\n  backdrop-filter: blur(4px);\n}\n\n.fc-timegrid-slots table tr {\n  border-color: var(--bs-border-color) !important;\n}\n\n.fc-list-table {\n  border-color: var(--bs-border-color);\n}\n\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-primary .fc-event-main,\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-primary .fc-event-title {\n  color: #4b38b3 !important;\n}\n\n.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-primary .fc-event-title {\n  color: #4b38b3 !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-primary {\n  color: #4b38b3 !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-primary .fc-list-event-title > a {\n  color: #4b38b3 !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-primary .fc-list-event-dot {\n  border-color: #4b38b3;\n}\n\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-secondary .fc-event-main,\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-secondary .fc-event-title {\n  color: #3577f1 !important;\n}\n\n.fc-timegrid-event-harness\n  .fc-timegrid-event.bg-soft-secondary\n  .fc-event-title {\n  color: #3577f1 !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-secondary {\n  color: #3577f1 !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-secondary .fc-list-event-title > a {\n  color: #3577f1 !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-secondary .fc-list-event-dot {\n  border-color: #3577f1;\n}\n\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-success .fc-event-main,\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-success .fc-event-title {\n  color: #45cb85 !important;\n}\n\n.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-success .fc-event-title {\n  color: #45cb85 !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-success {\n  color: #45cb85 !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-success .fc-list-event-title > a {\n  color: #45cb85 !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-success .fc-list-event-dot {\n  border-color: #45cb85;\n}\n\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-info .fc-event-main,\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-info .fc-event-title {\n  color: #299cdb !important;\n}\n\n.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-info .fc-event-title {\n  color: #299cdb !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-info {\n  color: #299cdb !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-info .fc-list-event-title > a {\n  color: #299cdb !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-info .fc-list-event-dot {\n  border-color: #299cdb;\n}\n\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-warning .fc-event-main,\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-warning .fc-event-title {\n  color: #ffbe0b !important;\n}\n\n.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-warning .fc-event-title {\n  color: #ffbe0b !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-warning {\n  color: #ffbe0b !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-warning .fc-list-event-title > a {\n  color: #ffbe0b !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-warning .fc-list-event-dot {\n  border-color: #ffbe0b;\n}\n\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-danger .fc-event-main,\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-danger .fc-event-title {\n  color: #f06548 !important;\n}\n\n.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-danger .fc-event-title {\n  color: #f06548 !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-danger {\n  color: #f06548 !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-danger .fc-list-event-title > a {\n  color: #f06548 !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-danger .fc-list-event-dot {\n  border-color: #f06548;\n}\n\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-light .fc-event-main,\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-light .fc-event-title {\n  color: #f3f6f9 !important;\n}\n\n.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-light .fc-event-title {\n  color: #f3f6f9 !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-light {\n  color: #f3f6f9 !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-light .fc-list-event-title > a {\n  color: #f3f6f9 !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-light .fc-list-event-dot {\n  border-color: #f3f6f9;\n}\n\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-main,\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-title {\n  color: #212529 !important;\n}\n\n.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-dark .fc-event-title {\n  color: #212529 !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-dark {\n  color: #212529 !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-dark .fc-list-event-title > a {\n  color: #212529 !important;\n}\n\n.fc-list-table .fc-list-event.bg-soft-dark .fc-list-event-dot {\n  border-color: #212529;\n}\n\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-main,\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-title {\n  color: var(--bs-dark) !important;\n}\n\n.fc-direction-ltr {\n  direction: ltr;\n}\n\n.fc-direction-ltr .fc-toolbar > * > :not(:first-child) {\n  margin-left: 0.75em;\n}\n\n.fg-emoji-picker {\n  width: 250px !important;\n  -webkit-box-shadow: var(--bs-box-shadow) !important;\n  box-shadow: var(--bs-box-shadow) !important;\n  top: auto !important;\n  bottom: 130px;\n}\n\n.fg-emoji-picker * {\n  font-family: var(--bs-font-sans-serif) !important;\n  color: var(--bs-body-color) !important;\n}\n\n@media (max-width: 991.98px) {\n  .fg-emoji-picker {\n    left: 14px !important;\n    top: auto !important;\n    bottom: 118px;\n  }\n}\n\n.fg-emoji-picker .fg-emoji-picker-container-title {\n  color: #212529 !important;\n}\n\n.fg-emoji-picker .fg-emoji-picker-search {\n  height: 40px !important;\n}\n\n.fg-emoji-picker .fg-emoji-picker-search input {\n  background-color: var(--bs-input-bg) !important;\n  color: var(--bs-body-color) !important;\n  padding: 0.5rem 0.9rem !important;\n  font-size: 0.8125rem !important;\n}\n\n.fg-emoji-picker .fg-emoji-picker-search input::-webkit-input-placeholder {\n  color: #878a99 !important;\n}\n\n.fg-emoji-picker .fg-emoji-picker-search input::-moz-placeholder {\n  color: #878a99 !important;\n}\n\n.fg-emoji-picker .fg-emoji-picker-search input:-ms-input-placeholder {\n  color: #878a99 !important;\n}\n\n.fg-emoji-picker .fg-emoji-picker-search input::-ms-input-placeholder {\n  color: #878a99 !important;\n}\n\n.fg-emoji-picker .fg-emoji-picker-search input::placeholder {\n  color: #878a99 !important;\n}\n\n.fg-emoji-picker .fg-emoji-picker-search svg {\n  fill: var(--bs-body-color) !important;\n  right: 11px;\n  top: 12px;\n}\n\n.fg-emoji-picker .fg-emoji-picker-categories {\n  background-color: #f3f6f9 !important;\n}\n\n.fg-emoji-picker .fg-emoji-picker-categories li.active {\n  background-color: rgba(var(--bs-primary-rgb), 0.2);\n}\n\n.fg-emoji-picker .fg-emoji-picker-categories a:hover {\n  background-color: rgba(var(--bs-primary-rgb), 0.2);\n}\n\n.fg-emoji-picker-grid > li:hover {\n  background-color: rgba(var(--bs-primary-rgb), 0.2) !important;\n}\n\na.fg-emoji-picker-close-button {\n  background-color: #e5ecf2 !important;\n}\n\ntable.dataTable td.dataTables_empty,\ntable.dataTable th.dataTables_empty {\n  text-align: center;\n  padding: 50px;\n  font-weight: 600;\n  --bs-table-accent-bg: var(--bs-card-bg-custom);\n}\n\ntable.dataTable > thead .sorting:before,\ntable.dataTable > thead .sorting_asc:before,\ntable.dataTable > thead .sorting_asc_disabled:before,\ntable.dataTable > thead .sorting_desc:before,\ntable.dataTable > thead .sorting_desc_disabled:before {\n  content: \"\\f0360\";\n  position: absolute;\n  right: 0.5rem;\n  top: 12px;\n  font-size: 0.8rem;\n  font-family: \"Material Design Icons\";\n}\n\ntable.dataTable > thead .sorting:after,\ntable.dataTable > thead .sorting_asc:after,\ntable.dataTable > thead .sorting_asc_disabled:after,\ntable.dataTable > thead .sorting_desc:after,\ntable.dataTable > thead .sorting_desc_disabled:after {\n  content: \"\\f035d\";\n  position: absolute;\n  right: 0.5rem;\n  top: 18px;\n  font-size: 0.8rem;\n  font-family: \"Material Design Icons\";\n}\n\ntable.dataTable > tbody > tr.child span.dtr-title {\n  font-weight: 600;\n  min-width: 150px;\n}\n\ntable.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control::before,\ntable.dataTable.dtr-inline.collapsed > tbody > tr > th.dtr-control::before {\n  background-color: #4b38b3;\n  border-color: var(--bs-card-bg-custom);\n}\n\ntable.dataTable.dtr-inline.collapsed\n  > tbody\n  > tr.parent.parent\n  > th.dtr-control::before {\n  background-color: #f06548;\n}\n\ntable.dataTable.dtr-inline.collapsed\n  > tbody\n  > tr.parent\n  > td.dtr-control::before {\n  background-color: #f06548;\n}\n\ntable.dataTable > tbody > tr.child span.dtr-title {\n  min-width: 135px;\n}\n\n.table-card .dataTables_filter,\n.table-card .dataTables_length {\n  padding: 1rem 1rem;\n  padding-bottom: 0;\n}\n\n.table-card .dataTables_info,\n.table-card .dataTables_paginate {\n  padding: 1rem 1rem;\n}\n\n.table-card div.dataTables_wrapper .col-md-6 {\n  width: 100%;\n}\n\n.table-card div.dataTables_wrapper div.dataTables_filter input {\n  width: calc(100% - 52px);\n}\n\n.table-card div.dataTables_wrapper div.dataTables_filter label {\n  display: block;\n}\n\ndiv.dtr-modal div.dtr-modal-display {\n  background-color: #fff;\n  border-color: var(--bs-border-color);\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  height: 70%;\n}\n\ndiv.dtr-modal div.dtr-modal-content {\n  padding: 1.25rem;\n}\n\ndiv.dtr-modal div.dtr-modal-content h2 {\n  font-size: 1.015625rem;\n  font-weight: 600;\n  margin-bottom: 15px;\n}\n\ndiv.dtr-modal div.dtr-modal-content .dtr-details tr td {\n  padding: 0.75rem 0.6rem;\n}\n\ndiv.dtr-modal div.dtr-modal-close {\n  font-size: 24px;\n  top: 9px;\n  right: 11px;\n  width: 30px;\n  height: 30px;\n  line-height: 30px;\n  background-color: var(--bs-card-bg-custom);\n  border-color: var(--bs-border-color);\n}\n\ndiv.dtr-modal div.dtr-modal-close:hover {\n  background-color: var(--bs-light);\n}\n\n.dt-buttons a.dt-button,\n.dt-buttons button.dt-button,\n.dt-buttons div.dt-button,\n.dt-buttons input.dt-button {\n  border-color: var(--bs-border-color);\n  background: var(--bs-light);\n  color: var(--bs-gray-800);\n}\n\n.select2.select2-container {\n  width: 100% !important;\n}\n\n.select2-container .select2-selection--single {\n  border: 1px solid var(--bs-input-border);\n  height: calc(1.5em + 1rem + 2px);\n  background-color: var(--bs-input-bg);\n  outline: 0;\n}\n\n.select2-container .select2-selection--single .select2-selection__rendered {\n  line-height: 36px;\n  padding-left: 12px;\n  color: var(--bs-body-color);\n}\n\n.select2-container .select2-selection--single .select2-selection__arrow {\n  height: 34px;\n  width: 34px;\n  right: 3px;\n}\n\n.select2-container .select2-selection--single .select2-selection__arrow b {\n  border-color: var(--bs-input-border) transparent transparent transparent;\n  border-width: 6px 6px 0 6px;\n}\n\n.select2-container--open\n  .select2-selection--single\n  .select2-selection__arrow\n  b {\n  border-color: transparent transparent var(--bs-input-border) transparent !important;\n  border-width: 0 6px 6px 6px !important;\n}\n\n.select2-results__option {\n  padding: 6px 12px;\n}\n\n.select2-dropdown {\n  border: 0 solid var(--bs-border-color);\n  -webkit-box-shadow: var(--bs-box-shadow);\n  box-shadow: var(--bs-box-shadow);\n  background-color: var(--bs-choices-bg);\n  z-index: 1056;\n}\n\n.select2-container--default .select2-results__option--selected {\n  background-color: var(--bs-input-disabled-bg);\n}\n\n.select2-container--default .select2-search--dropdown {\n  padding: 10px;\n  background-color: var(--bs-choices-bg);\n}\n\n.select2-container--default .select2-search--dropdown .select2-search__field {\n  outline: 0;\n  border: 1px solid var(--bs-input-border);\n  background-color: var(--bs-input-bg);\n  color: var(--bs-body-color);\n  border-radius: 0.25rem;\n}\n\n.select2-container--default\n  .select2-results__option--highlighted[aria-selected] {\n  background-color: #4b38b3;\n}\n\n.select2-container--default .select2-results__option[aria-selected=\"true\"] {\n  background-color: var(--bs-choices-bg);\n  color: var(--bs-choices-link-active-color);\n}\n\n.select2-container--default\n  .select2-results__option[aria-selected=\"true\"]:hover {\n  background-color: #4b38b3;\n  color: #fff;\n}\n\n.select2-container--default\n  .select2-selection--multiple\n  .select2-selection__choice__display {\n  padding-left: 36px;\n  padding-right: 5px;\n}\n\n.select2-container--default\n  .select2-selection--single\n  .select2-selection__arrow {\n  right: 1px;\n  left: auto;\n}\n\n.select2-container .select2-selection--multiple {\n  min-height: calc(1.5em + 1rem + 2px);\n  border: 1px solid var(--bs-input-border) !important;\n  background-color: var(--bs-input-bg);\n}\n\n.select2-container .select2-selection--multiple .select2-selection__rendered {\n  padding: 1px 4px;\n}\n\n.select2-container .select2-selection--multiple .select2-search__field {\n  border: 0;\n  color: var(--bs-body-color);\n}\n\n.select2-container .select2-selection--multiple .select2-selection__choice {\n  background-color: #4b38b3;\n  border: none;\n  color: #fff;\n  border-radius: 3px;\n  padding: 3px;\n  margin-top: 6px;\n}\n\n.select2-container\n  .select2-selection--multiple\n  .select2-selection__choice__remove {\n  color: #fff;\n  margin-right: 7px;\n  border-color: #5d4cbb;\n  padding: 0 8px;\n  top: 3px;\n}\n\n.select2-container\n  .select2-selection--multiple\n  .select2-selection__choice__remove:hover {\n  color: #fff;\n  background-color: #4b38b3;\n}\n\n.select2-container .select2-search--inline .select2-search__field {\n  margin-top: 7px;\n  font-family: var(--bs-font-sans-serif);\n}\n\n.select2-container .select2-search textarea::-webkit-input-placeholder {\n  color: #878a99;\n}\n\n.select2-container .select2-search textarea::-moz-placeholder {\n  color: #878a99;\n}\n\n.select2-container .select2-search textarea:-ms-input-placeholder {\n  color: #878a99;\n}\n\n.select2-container .select2-search textarea::-ms-input-placeholder {\n  color: #878a99;\n}\n\n.select2-container .select2-search textarea::placeholder {\n  color: #878a99;\n}\n\n.select2-container--default.select2-container--disabled\n  .select2-selection--multiple,\n.select2-container--default.select2-container--disabled\n  .select2-selection--single {\n  background-color: var(--bs-input-disabled-bg);\n  cursor: default;\n}\n\n.toastify {\n  padding: 12px 16px;\n  color: #fff;\n  display: inline-block;\n  -webkit-box-shadow: 0 3px 6px -1px rgba(0, 0, 0, 0.12),\n    0 10px 36px -4px rgba(77, 96, 232, 0.3);\n  box-shadow: 0 3px 6px -1px rgba(0, 0, 0, 0.12),\n    0 10px 36px -4px rgba(77, 96, 232, 0.3);\n  background: #45cb85;\n  position: fixed;\n  opacity: 0;\n  -webkit-transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);\n  transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);\n  border-radius: 2px;\n  cursor: pointer;\n  text-decoration: none;\n  max-width: calc(50% - 20px);\n  z-index: 2147483647;\n}\n\n.toastify.on {\n  opacity: 1;\n}\n\n.toast-close {\n  opacity: 0.4;\n  padding: 0 5px;\n  position: relative;\n  left: 4px;\n  margin-left: 4px;\n  border: none;\n  background: 0 0;\n}\n\n.toastify-right {\n  right: 15px;\n}\n\n.toastify-left {\n  left: 15px;\n}\n\n.toastify-left .toast-close {\n  left: -4px;\n  margin-left: 0;\n  margin-right: 4px;\n}\n\n.toastify-top {\n  top: -150px;\n}\n\n.toastify-bottom {\n  bottom: -150px;\n}\n\n.toastify-rounded {\n  border-radius: 25px;\n}\n\n.toastify-avatar {\n  width: 1.5em;\n  height: 1.5em;\n  margin: -7px 5px;\n  border-radius: 2px;\n}\n\n.toastify-center {\n  margin-left: auto;\n  margin-right: auto;\n  left: 0;\n  right: 0;\n  max-width: -webkit-fit-content;\n  max-width: fit-content;\n  max-width: -moz-fit-content;\n}\n\n@media only screen and (max-width: 360px) {\n  .toastify-left,\n  .toastify-right {\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: 0;\n    max-width: -webkit-fit-content;\n    max-width: -moz-fit-content;\n    max-width: fit-content;\n  }\n}\n\n.choices {\n  position: relative;\n  margin-bottom: 24px;\n  font-size: 16px;\n}\n\n.choices:focus {\n  outline: 0;\n}\n\n.choices:last-child {\n  margin-bottom: 0;\n}\n\n.choices.is-disabled .choices__inner,\n.choices.is-disabled .choices__input {\n  background-color: rgba(var(--bs-light-rgb), 0.75);\n  cursor: not-allowed;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.choices.is-disabled .choices__item {\n  cursor: not-allowed;\n}\n\n.choices [hidden] {\n  display: none !important;\n}\n\n.choices[data-type*=\"select-one\"] {\n  cursor: pointer;\n}\n\n.choices[data-type*=\"select-one\"] .choices__inner {\n  padding-bottom: 0.25rem;\n}\n\n.choices[data-type*=\"select-one\"] .choices__input {\n  display: block;\n  width: 100%;\n  padding: 0.5rem 0.9rem;\n  background-color: var(--bs-input-bg);\n  border: 1px solid var(--bs-input-border);\n  font-size: 0.8125rem;\n  border-radius: 0.25rem;\n  color: var(--bs-body-color);\n  margin-bottom: 10px;\n}\n\n.choices[data-type*=\"select-one\"] .choices__button {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5bsGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==);\n  padding: 0;\n  background-size: 8px;\n  position: absolute;\n  top: 50%;\n  right: 0;\n  left: auto;\n  margin-top: -10px;\n  margin-right: 25px;\n  margin-left: 0;\n  height: 20px;\n  width: 20px;\n  border-radius: 10em;\n  opacity: 0.5;\n}\n\n.choices[data-type*=\"select-one\"] .choices__button:focus,\n.choices[data-type*=\"select-one\"] .choices__button:hover {\n  opacity: 1;\n}\n\n.choices[data-type*=\"select-one\"] .choices__button:focus {\n  -webkit-box-shadow: 0 0 0 2px #00bcd4;\n  box-shadow: 0 0 0 2px #00bcd4;\n}\n\n.choices[data-type*=\"select-one\"]\n  .choices__item[data-value=\"\"]\n  .choices__button {\n  display: none;\n}\n\n.choices[data-type*=\"select-one\"]:after {\n  content: \"\\f0140\";\n  position: absolute;\n  border: 0;\n  border-color: #212529 transparent transparent;\n  right: 11.5px;\n  left: auto;\n  font-family: \"Material Design Icons\";\n  width: auto;\n  height: auto;\n  margin-top: 0;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n.choices[data-type*=\"select-one\"].is-open:after {\n  margin-top: 0;\n  -webkit-transform: translateY(-50%) rotate(-180deg);\n  transform: translateY(-50%) rotate(-180deg);\n}\n\n.choices[data-type*=\"select-multiple\"] .choices__inner,\n.choices[data-type*=\"text\"] .choices__inner {\n  cursor: text;\n  padding-right: 0.9rem;\n}\n\n.choices[data-type*=\"select-multiple\"] .choices__button,\n.choices[data-type*=\"text\"] .choices__button {\n  position: relative;\n  display: inline-block;\n  margin-top: 0;\n  margin-right: -4px;\n  margin-bottom: 0;\n  margin-left: 8px;\n  padding-left: 16px;\n  border-left: 1px solid rgba(255, 255, 255, 0.5);\n  border-right: 0;\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5bsGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==);\n  background-size: 8px;\n  width: 8px;\n  line-height: 1;\n  opacity: 0.75;\n  border-radius: 0;\n}\n\n.choices[data-type*=\"select-multiple\"] .choices__button:focus,\n.choices[data-type*=\"select-multiple\"] .choices__button:hover,\n.choices[data-type*=\"text\"] .choices__button:focus,\n.choices[data-type*=\"text\"] .choices__button:hover {\n  opacity: 1;\n}\n\n.choices[data-type*=\"select-multiple\"] .choices__list--dropdown,\n.choices[data-type*=\"text\"] .choices__list--dropdown {\n  padding-bottom: 10px;\n}\n\n.choices[data-type*=\"select-multiple\"] .choices__list--dropdown .choices__list,\n.choices[data-type*=\"text\"] .choices__list--dropdown .choices__list {\n  margin-bottom: 0;\n}\n\n.choices[data-type*=\"select-multiple\"] .choices__input {\n  padding-top: 3px;\n}\n\n.input-light .choices__inner {\n  background-color: var(--bs-light);\n  border: none;\n}\n\n.choices__inner {\n  display: inline-block;\n  vertical-align: middle;\n  width: 100%;\n  background-color: var(--bs-input-bg);\n  padding: 0.25rem 3.6rem 0.1rem 0.5rem;\n  border: 1px solid var(--bs-input-border);\n  border-radius: 0.25rem !important;\n  font-size: 0.8125rem;\n  min-height: 37.5px;\n  overflow: hidden;\n}\n\n.is-focused .choices__inner,\n.is-open .choices__inner {\n  border-color: var(--bs-input-focus-border);\n}\n\n.choices__list {\n  margin: 0;\n  padding-left: 0;\n  list-style: none;\n}\n\n.choices__list--single {\n  display: inline-block;\n  padding: 4px 16px 4px 4px;\n  width: 100%;\n}\n\n.choices__list--single .choices__item {\n  width: 100%;\n}\n\n.choices__list--multiple {\n  display: inline;\n}\n\n.choices__list--multiple .choices__item {\n  display: inline-block;\n  vertical-align: initial;\n  border-radius: 7px;\n  padding: 2px 7px;\n  font-size: 11px;\n  font-weight: 400;\n  margin-right: 3.75px;\n  margin-bottom: 3.75px;\n  margin-top: 2px;\n  background-color: #4b38b3;\n  border: 1px solid #4b38b3;\n  word-break: break-all;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  color: #fff;\n  -webkit-box-shadow: var(--bs-box-shadow);\n  box-shadow: var(--bs-box-shadow);\n}\n\n.choices__list--multiple .choices__item[data-deletable] {\n  padding-right: 5px;\n}\n\n.choices__list--multiple .choices__item.is-highlighted {\n  background-color: #4b38b3;\n  border: 1px solid #4b38b3;\n}\n\n.is-disabled .choices__list--multiple .choices__item {\n  background-color: #3577f1;\n  border: 1px solid #3577f1;\n}\n\n.choices__list--dropdown {\n  visibility: hidden;\n  z-index: 1;\n  position: absolute;\n  width: 100%;\n  background-color: var(--bs-choices-bg);\n  border: 1px solid var(--bs-border-color);\n  -webkit-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n  top: 100%;\n  margin-top: 0;\n  padding: 10px 10px 20px 10px;\n  border-bottom-left-radius: 2.5px;\n  border-bottom-right-radius: 2.5px;\n  overflow: hidden;\n  word-break: break-all;\n  will-change: visibility;\n  -webkit-animation-duration: 0.3s;\n  animation-duration: 0.3s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n  -webkit-transform: translateY(1px);\n  transform: translateY(1px);\n}\n\n.choices__list--dropdown.is-active {\n  visibility: visible;\n  -webkit-animation-name: DropDownSlide;\n  animation-name: DropDownSlide;\n}\n\n.choices__list--dropdown .choices__item--selectable.is-highlighted {\n  background-color: var(--bs-choices-link-hover-bg);\n}\n\n.choices__list--dropdown .choices__list {\n  margin: 0 -16px -16px;\n}\n\n.choices__list--dropdown .has-no-results {\n  font-style: italic;\n  font-weight: 500;\n}\n\n.choices__list--dropdown .choices__item--selectable:after {\n  display: none;\n}\n\n.is-open .choices__list--dropdown {\n  border-color: var(--bs-border-color);\n}\n\n.is-flipped .choices__list--dropdown {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: -1px;\n  border-radius: 0.25rem 0.25rem 0 0;\n}\n\n.is-flipped .choices__list--dropdown.is-active {\n  -webkit-animation-name: DropDownSlideDown;\n  animation-name: DropDownSlideDown;\n  -webkit-transform: translateY(-1px);\n  transform: translateY(-1px);\n}\n\n.choices__list--dropdown .choices__list {\n  position: relative;\n  max-height: 300px;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  will-change: scroll-position;\n}\n\n.choices__list--dropdown .choices__item {\n  position: relative;\n  font-size: 0.8125rem;\n  padding: 0.35rem 1.2rem 0.35rem 16px;\n}\n\n@media (min-width: 640px) {\n  .choices__list--dropdown .choices__item--selectable:after {\n    content: attr(data-select-text);\n    font-size: 12px;\n    opacity: 0;\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n  }\n\n  .choices__list--dropdown .choices__item--selectable.is-highlighted:after {\n    opacity: 0.5;\n  }\n}\n\n.choices__item {\n  cursor: default;\n}\n\n.choices__item--selectable {\n  cursor: pointer;\n}\n\n.choices__item--disabled {\n  cursor: not-allowed;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  opacity: 0.5;\n}\n\n.choices__heading {\n  font-weight: 600;\n  font-size: 12px;\n  padding: 10px 16px;\n  border-bottom: 1px solid var(--bs-border-color);\n  color: #878a99;\n}\n\n.choices__button {\n  text-indent: -9999px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  border: 0;\n  background-color: transparent;\n  background-repeat: no-repeat;\n  background-position: center;\n  cursor: pointer;\n}\n\n.choices__button:focus {\n  outline: 0;\n}\n\n.choices__input {\n  display: inline-block;\n  vertical-align: baseline;\n  background-color: var(--bs-input-bg);\n  color: var(--bs-body-color);\n  font-size: 0.8125rem;\n  margin-bottom: 0;\n  border: 0;\n  border-radius: 0;\n  max-width: 100%;\n  padding: 2px 0 2px 2px;\n}\n\n.choices__input:focus {\n  outline: 0;\n}\n\n.choices__input::-webkit-input-placeholder {\n  color: #878a99;\n}\n\n.choices__input::-moz-placeholder {\n  color: #878a99;\n}\n\n.choices__input:-ms-input-placeholder {\n  color: #878a99;\n}\n\n.choices__input::-ms-input-placeholder {\n  color: #878a99;\n}\n\n.choices__input::placeholder {\n  color: #878a99;\n}\n\n.choices__placeholder {\n  color: #878a99;\n  opacity: 1;\n}\n\n[data-layout-mode=\"dark\"] .choices[data-type*=\"select-one\"] .choices__button {\n  -webkit-filter: invert(1) grayscale(100%) brightness(200%);\n  filter: invert(1) grayscale(100%) brightness(200%);\n}\n\n.flatpickr-calendar {\n  background: 0 0;\n  opacity: 0;\n  display: none;\n  text-align: center;\n  visibility: hidden;\n  padding: 0;\n  -webkit-animation: none;\n  animation: none;\n  direction: ltr;\n  border: 0;\n  font-size: 14px;\n  line-height: 24px;\n  border-radius: 5px;\n  position: absolute;\n  width: 307.875px;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  -ms-touch-action: manipulation;\n  touch-action: manipulation;\n  background: var(--bs-choices-bg);\n  -webkit-box-shadow: 1px 0 0 var(--bs-border-color),\n    -1px 0 0 var(--bs-border-color), 0 1px 0 var(--bs-border-color),\n    0 -1px 0 var(--bs-border-color), 0 3px 13px rgba(0, 0, 0, 0.08);\n  box-shadow: 1px 0 0 var(--bs-border-color), -1px 0 0 var(--bs-border-color),\n    0 1px 0 var(--bs-border-color), 0 -1px 0 var(--bs-border-color),\n    0 3px 13px rgba(0, 0, 0, 0.08);\n}\n\n.flatpickr-calendar.inline,\n.flatpickr-calendar.open {\n  opacity: 1;\n  max-height: 640px;\n  visibility: visible;\n}\n\n.flatpickr-calendar.open {\n  display: inline-block;\n  z-index: 1056;\n}\n\n.flatpickr-calendar.animate.open {\n  -webkit-animation: fpFadeInDown 0.3s cubic-bezier(0.23, 1, 0.32, 1);\n  animation: fpFadeInDown 0.3s cubic-bezier(0.23, 1, 0.32, 1);\n}\n\n.flatpickr-calendar.inline {\n  display: block;\n  position: relative;\n  top: 2px;\n  width: 100%;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.flatpickr-calendar.inline .flatpickr-rContainer {\n  display: block;\n  width: 100%;\n}\n\n.flatpickr-calendar.inline .flatpickr-rContainer .flatpickr-days {\n  width: 100%;\n  border: 1px solid var(--bs-input-border);\n  border-top: none;\n  border-radius: 0 0 5px 5px;\n}\n\n.flatpickr-calendar.inline .flatpickr-rContainer .flatpickr-days .dayContainer {\n  width: 100%;\n  min-width: 100%;\n  max-width: 100%;\n}\n\n.flatpickr-calendar.inline\n  .flatpickr-rContainer\n  .flatpickr-days\n  .dayContainer\n  .flatpickr-day {\n  max-width: 100%;\n  border-radius: 4px;\n}\n\n.flatpickr-calendar.inline .flatpickr-time {\n  border: 1px solid var(--bs-input-border) !important;\n  border-radius: 0.25rem;\n}\n\n.flatpickr-calendar.static {\n  position: absolute;\n  top: calc(100% + 2px);\n}\n\n.flatpickr-calendar.static.open {\n  z-index: 999;\n  display: block;\n}\n\n.flatpickr-calendar.multiMonth\n  .flatpickr-days\n  .dayContainer:nth-child(n + 1)\n  .flatpickr-day.inRange:nth-child(7n + 7) {\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.flatpickr-calendar.multiMonth\n  .flatpickr-days\n  .dayContainer:nth-child(n + 2)\n  .flatpickr-day.inRange:nth-child(7n + 1) {\n  -webkit-box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n  box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n}\n\n.flatpickr-calendar .hasTime .dayContainer,\n.flatpickr-calendar .hasWeeks .dayContainer {\n  border-bottom: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.flatpickr-calendar .hasWeeks .dayContainer {\n  border-left: 0;\n}\n\n.flatpickr-calendar.hasTime .flatpickr-time {\n  height: 40px;\n  border-top: 1px solid var(--bs-border-color);\n}\n\n.flatpickr-calendar.noCalendar.hasTime .flatpickr-time {\n  height: auto;\n}\n\n.flatpickr-calendar::after,\n.flatpickr-calendar::before {\n  position: absolute;\n  display: block;\n  pointer-events: none;\n  border: solid transparent;\n  content: \"\";\n  height: 0;\n  width: 0;\n  left: 22px;\n}\n\n.flatpickr-calendar.arrowRight::after,\n.flatpickr-calendar.arrowRight::before,\n.flatpickr-calendar.rightMost::after,\n.flatpickr-calendar.rightMost::before {\n  left: auto;\n  right: 22px;\n}\n\n.flatpickr-calendar.arrowCenter::after,\n.flatpickr-calendar.arrowCenter::before {\n  left: 50%;\n  right: 50%;\n}\n\n.flatpickr-calendar::before {\n  border-width: 5px;\n  margin: 0 -5px;\n}\n\n.flatpickr-calendar::after {\n  border-width: 4px;\n  margin: 0 -4px;\n}\n\n.flatpickr-calendar.arrowTop::after,\n.flatpickr-calendar.arrowTop::before {\n  bottom: 100%;\n}\n\n.flatpickr-calendar.arrowTop::before {\n  border-bottom-color: #4b38b3;\n}\n\n.flatpickr-calendar.arrowTop::after {\n  border-bottom-color: #4b38b3;\n}\n\n.flatpickr-calendar.arrowBottom::after,\n.flatpickr-calendar.arrowBottom::before {\n  top: 100%;\n}\n\n.flatpickr-calendar.arrowBottom::before {\n  border-top-color: #4b38b3;\n}\n\n.flatpickr-calendar.arrowBottom::after {\n  border-top-color: #4b38b3;\n}\n\n.flatpickr-calendar:focus {\n  outline: 0;\n}\n\n.flatpickr-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.flatpickr-months {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  background-color: #4b38b3;\n  border-radius: 5px 5px 0 0;\n}\n\n.flatpickr-months .flatpickr-month {\n  background: 0 0;\n  color: rgba(255, 255, 255, 0.9);\n  fill: rgba(255, 255, 255, 0.9);\n  height: 34px;\n  line-height: 1;\n  text-align: center;\n  position: relative;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  overflow: hidden;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\n.flatpickr-months .flatpickr-next-month,\n.flatpickr-months .flatpickr-prev-month {\n  text-decoration: none;\n  cursor: pointer;\n  position: absolute;\n  top: 0;\n  height: 34px;\n  padding: 10px;\n  z-index: 3;\n  color: rgba(255, 255, 255, 0.9);\n  fill: rgba(255, 255, 255, 0.9);\n}\n\n.flatpickr-months .flatpickr-next-month.flatpickr-disabled,\n.flatpickr-months .flatpickr-prev-month.flatpickr-disabled {\n  display: none;\n}\n\n.flatpickr-months .flatpickr-next-month i,\n.flatpickr-months .flatpickr-prev-month i {\n  position: relative;\n}\n\n.flatpickr-months .flatpickr-next-month.flatpickr-prev-month,\n.flatpickr-months .flatpickr-prev-month.flatpickr-prev-month {\n  left: 0;\n}\n\n.flatpickr-months .flatpickr-next-month.flatpickr-next-month,\n.flatpickr-months .flatpickr-prev-month.flatpickr-next-month {\n  right: 0;\n}\n\n.flatpickr-months .flatpickr-next-month:hover,\n.flatpickr-months .flatpickr-prev-month:hover {\n  color: #959ea9;\n}\n\n.flatpickr-months .flatpickr-next-month:hover svg,\n.flatpickr-months .flatpickr-prev-month:hover svg {\n  fill: rgba(255, 255, 255, 0.9);\n}\n\n.flatpickr-months .flatpickr-next-month svg,\n.flatpickr-months .flatpickr-prev-month svg {\n  width: 14px;\n  height: 14px;\n}\n\n.flatpickr-months .flatpickr-next-month svg path,\n.flatpickr-months .flatpickr-prev-month svg path {\n  -webkit-transition: fill 0.1s;\n  transition: fill 0.1s;\n  fill: inherit;\n}\n\n.numInputWrapper {\n  position: relative;\n  height: auto;\n}\n\n.numInputWrapper input,\n.numInputWrapper span {\n  display: inline-block;\n}\n\n.numInputWrapper input {\n  width: 100%;\n}\n\n.numInputWrapper input::-ms-clear {\n  display: none;\n}\n\n.numInputWrapper input::-webkit-inner-spin-button,\n.numInputWrapper input::-webkit-outer-spin-button {\n  margin: 0;\n  -webkit-appearance: none;\n}\n\n.numInputWrapper span {\n  position: absolute;\n  right: 0;\n  width: 14px;\n  padding: 0 4px 0 2px;\n  height: 50%;\n  line-height: 50%;\n  opacity: 0;\n  cursor: pointer;\n  border: 1px solid rgba(var(--bs-dark-rgb), 0.15);\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.numInputWrapper span:hover {\n  background: rgba(0, 0, 0, 0.1);\n}\n\n.numInputWrapper span:active {\n  background: rgba(0, 0, 0, 0.2);\n}\n\n.numInputWrapper span:after {\n  display: block;\n  content: \"\";\n  position: absolute;\n}\n\n.numInputWrapper span.arrowUp {\n  top: 0;\n  border-bottom: 0;\n}\n\n.numInputWrapper span.arrowUp:after {\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-bottom: 4px solid rgba(57, 57, 57, 0.6);\n  top: 26%;\n}\n\n.numInputWrapper span.arrowDown {\n  top: 50%;\n}\n\n.numInputWrapper span.arrowDown:after {\n  border-left: 4px solid transparent;\n  border-right: 4px solid transparent;\n  border-top: 4px solid rgba(57, 57, 57, 0.6);\n  top: 40%;\n}\n\n.numInputWrapper span svg {\n  width: inherit;\n  height: auto;\n}\n\n.numInputWrapper span svg path {\n  fill: rgba(0, 0, 0, 0.5);\n}\n\n.numInputWrapper:hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.numInputWrapper:hover span {\n  opacity: 1;\n}\n\n.flatpickr-current-month {\n  font-size: 100%;\n  line-height: inherit;\n  font-weight: 300;\n  color: inherit;\n  position: absolute;\n  width: 75%;\n  left: 12.5%;\n  padding: 7.48px 0 0 0;\n  line-height: 1;\n  height: 34px;\n  display: inline-block;\n  text-align: center;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n}\n\n.flatpickr-current-month span.cur-month {\n  font-family: inherit;\n  font-weight: 700;\n  color: inherit;\n  display: inline-block;\n  margin-left: 0.5ch;\n  padding: 0;\n}\n\n.flatpickr-current-month span.cur-month:hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.flatpickr-current-month .numInputWrapper {\n  width: 6ch;\n  display: inline-block;\n}\n\n.flatpickr-current-month span.arrowUp::after {\n  border-bottom-color: rgba(0, 0, 0, 0.9);\n}\n\n.flatpickr-current-month span.arrowDown:after {\n  border-top-color: rgba(0, 0, 0, 0.9);\n}\n\n.flatpickr-current-month input.cur-year {\n  background: 0 0;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  color: inherit;\n  cursor: text;\n  padding: 0 0 0 0.5ch;\n  margin: 0;\n  display: inline-block;\n  font-size: inherit;\n  font-family: inherit;\n  font-weight: 600;\n  line-height: inherit;\n  height: auto;\n  border: 0;\n  border-radius: 0;\n  vertical-align: initial;\n  -webkit-appearance: textfield;\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n\n.flatpickr-current-month input.cur-year:focus {\n  outline: 0;\n}\n\n.flatpickr-current-month input.cur-year[disabled],\n.flatpickr-current-month input.cur-year[disabled]:hover {\n  font-size: 100%;\n  color: rgba(255, 255, 255, 0.9);\n  background: 0 0;\n  pointer-events: none;\n}\n\n.flatpickr-current-month .flatpickr-monthDropdown-months {\n  -webkit-appearance: menulist;\n  -moz-appearance: menulist;\n  appearance: menulist;\n  background: 0 0;\n  border: none;\n  border-radius: 0;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  color: inherit;\n  cursor: pointer;\n  font-size: inherit;\n  font-family: inherit;\n  font-weight: 600;\n  height: auto;\n  line-height: inherit;\n  margin: -1px 0 0 0;\n  outline: 0;\n  padding: 0 0 0 0.5ch;\n  position: relative;\n  vertical-align: initial;\n  width: auto;\n}\n\n.flatpickr-current-month .flatpickr-monthDropdown-months:active,\n.flatpickr-current-month .flatpickr-monthDropdown-months:focus {\n  outline: 0;\n}\n\n.flatpickr-current-month .flatpickr-monthDropdown-months:hover {\n  background-color: transparent;\n}\n\n.flatpickr-current-month\n  .flatpickr-monthDropdown-months\n  .flatpickr-monthDropdown-month {\n  background-color: transparent;\n  outline: 0;\n  padding: 0;\n  color: rgba(0, 0, 0, 0.8);\n}\n\n.flatpickr-weekdays {\n  background-color: #4b38b3;\n  text-align: center;\n  overflow: hidden;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  height: 36px;\n  border-bottom: 1px solid var(--bs-border-color);\n}\n\n.flatpickr-weekdays .flatpickr-weekdaycontainer {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n\nspan.flatpickr-weekday {\n  cursor: default;\n  font-size: 90%;\n  background: #4b38b3;\n  color: #fff;\n  line-height: 1;\n  margin: 0;\n  text-align: center;\n  display: block;\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  font-weight: 500;\n}\n\n.dayContainer,\n.flatpickr-weeks {\n  padding: 1px 0 0 0;\n}\n\n.flatpickr-days {\n  position: relative;\n  overflow: hidden;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  width: 307.875px;\n}\n\n.flatpickr-days:focus {\n  outline: 0;\n}\n\n.dayContainer {\n  padding: 0;\n  outline: 0;\n  text-align: left;\n  width: 307.875px;\n  min-width: 307.875px;\n  max-width: 307.875px;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  display: inline-block;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -ms-flex-pack: distribute;\n  justify-content: space-around;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  opacity: 1;\n}\n\n.dayContainer + .dayContainer {\n  -webkit-box-shadow: -1px 0 0 #e6e6e6;\n  box-shadow: -1px 0 0 #e6e6e6;\n}\n\n.flatpickr-day {\n  background: 0 0;\n  border: 1px solid transparent;\n  border-radius: 150px;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  color: var(--bs-body-color);\n  cursor: pointer;\n  font-weight: 400;\n  width: 14.2857143%;\n  -ms-flex-preferred-size: 14.2857143%;\n  flex-basis: 14.2857143%;\n  max-width: 39px;\n  height: 39px;\n  line-height: 39px;\n  margin: 0;\n  display: inline-block;\n  position: relative;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.flatpickr-day:focus,\n.flatpickr-day:hover {\n  background-color: rgba(var(--bs-light-rgb), 0.7);\n}\n\n.flatpickr-day.inRange,\n.flatpickr-day.nextMonthDay.inRange,\n.flatpickr-day.nextMonthDay.today.inRange,\n.flatpickr-day.nextMonthDay:focus,\n.flatpickr-day.nextMonthDay:hover,\n.flatpickr-day.prevMonthDay.inRange,\n.flatpickr-day.prevMonthDay.today.inRange,\n.flatpickr-day.prevMonthDay:focus,\n.flatpickr-day.prevMonthDay:hover,\n.flatpickr-day.today.inRange,\n.flatpickr-day:focus,\n.flatpickr-day:hover {\n  cursor: pointer;\n  outline: 0;\n  background-color: var(--bs-light);\n  border-color: var(--bs-light);\n}\n\n.flatpickr-day.today {\n  border-color: #4b38b3;\n  background-color: rgba(75, 56, 179, 0.1);\n  -webkit-box-shadow: var(--bs-box-shadow);\n  box-shadow: var(--bs-box-shadow);\n}\n\n.flatpickr-day.today:focus,\n.flatpickr-day.today:hover {\n  border-color: #4b38b3;\n  background-color: rgba(75, 56, 179, 0.15);\n  color: var(--bs-dark);\n}\n\n.flatpickr-day.endRange,\n.flatpickr-day.endRange.inRange,\n.flatpickr-day.endRange.nextMonthDay,\n.flatpickr-day.endRange.prevMonthDay,\n.flatpickr-day.endRange:focus,\n.flatpickr-day.endRange:hover,\n.flatpickr-day.selected,\n.flatpickr-day.selected.inRange,\n.flatpickr-day.selected.nextMonthDay,\n.flatpickr-day.selected.prevMonthDay,\n.flatpickr-day.selected:focus,\n.flatpickr-day.selected:hover,\n.flatpickr-day.startRange,\n.flatpickr-day.startRange.inRange,\n.flatpickr-day.startRange.nextMonthDay,\n.flatpickr-day.startRange.prevMonthDay,\n.flatpickr-day.startRange:focus,\n.flatpickr-day.startRange:hover {\n  background: #4b38b3;\n  -webkit-box-shadow: var(--bs-box-shadow);\n  box-shadow: var(--bs-box-shadow);\n  color: #fff;\n  border-color: #4b38b3;\n}\n\n.flatpickr-day.endRange.startRange,\n.flatpickr-day.selected.startRange,\n.flatpickr-day.startRange.startRange {\n  border-radius: 50px 0 0 50px;\n}\n\n.flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n + 1)),\n.flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n + 1)),\n.flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n + 1)) {\n  -webkit-box-shadow: -10px 0 0 #4b38b3;\n  box-shadow: -10px 0 0 #4b38b3;\n}\n\n.flatpickr-day.endRange.startRange .endRange,\n.flatpickr-day.selected.startRange .endRange,\n.flatpickr-day.startRange.startRange .endRange {\n  border-radius: 50px;\n}\n\n.flatpickr-day.endRange.endRange,\n.flatpickr-day.selected.endRange,\n.flatpickr-day.startRange.endRange {\n  border-radius: 0 50px 50px 0;\n}\n\n.flatpickr-day.inRange {\n  border-radius: 0;\n  -webkit-box-shadow: -5px 0 0 var(--bs-light), 5px 0 0 var(--bs-light);\n  box-shadow: -5px 0 0 var(--bs-light), 5px 0 0 var(--bs-light);\n}\n\n.flatpickr-day.flatpickr-disabled,\n.flatpickr-day.flatpickr-disabled:hover,\n.flatpickr-day.nextMonthDay,\n.flatpickr-day.notAllowed,\n.flatpickr-day.notAllowed.nextMonthDay,\n.flatpickr-day.notAllowed.prevMonthDay,\n.flatpickr-day.prevMonthDay {\n  color: rgba(var(--bs-body-color-rgb), 0.3);\n  background: 0 0;\n  border-color: transparent;\n  cursor: default;\n}\n\n.flatpickr-day.flatpickr-disabled,\n.flatpickr-day.flatpickr-disabled:hover {\n  cursor: not-allowed;\n  color: rgba(var(--bs-body-color-rgb), 0.3);\n}\n\n.flatpickr-day.week.selected {\n  border-radius: 0;\n  -webkit-box-shadow: -5px 0 0 #4b38b3, 5px 0 0 #4b38b3;\n  box-shadow: -5px 0 0 #4b38b3, 5px 0 0 #4b38b3;\n}\n\n.flatpickr-day.hidden {\n  visibility: hidden;\n}\n\n.rangeMode .flatpickr-day {\n  margin-top: 1px;\n}\n\n.flatpickr-weekwrapper {\n  float: left;\n}\n\n.flatpickr-weekwrapper .flatpickr-weeks {\n  padding: 0 12px;\n  -webkit-box-shadow: 1px 0 0 #e6e6e6;\n  box-shadow: 1px 0 0 #e6e6e6;\n}\n\n.flatpickr-weekwrapper .flatpickr-weekday {\n  float: none;\n  width: 100%;\n  line-height: 35px;\n}\n\n.flatpickr-weekwrapper span.flatpickr-day,\n.flatpickr-weekwrapper span.flatpickr-day:hover {\n  display: block;\n  width: 100%;\n  max-width: none;\n  color: rgba(var(--bs-dark-rgb), 0.3);\n  background: 0 0;\n  cursor: default;\n  border: none;\n}\n\n.flatpickr-innerContainer {\n  display: block;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  overflow: hidden;\n}\n\n.flatpickr-rContainer {\n  display: inline-block;\n  padding: 0;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.flatpickr-time {\n  text-align: center;\n  outline: 0;\n  display: block;\n  height: 0;\n  line-height: 40px;\n  max-height: 40px;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  overflow: hidden;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.flatpickr-time:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n.flatpickr-time .numInputWrapper {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  width: 40%;\n  height: 40px;\n  float: left;\n}\n\n.flatpickr-time .numInputWrapper span.arrowDown:after,\n.flatpickr-time .numInputWrapper span.arrowUp:after {\n  border-bottom-color: var(--bs-border-color);\n}\n\n.flatpickr-time.hasSeconds .numInputWrapper {\n  width: 26%;\n}\n\n.flatpickr-time.time24hr .numInputWrapper {\n  width: 49%;\n}\n\n.flatpickr-time input {\n  background: 0 0;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  border: 0;\n  border-radius: 0;\n  text-align: center;\n  margin: 0;\n  padding: 0;\n  height: inherit;\n  line-height: inherit;\n  color: var(--bs-body-color);\n  font-size: 14px;\n  position: relative;\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  -webkit-appearance: textfield;\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n\n.flatpickr-time input.flatpickr-hour {\n  font-weight: 700;\n}\n\n.flatpickr-time input.flatpickr-minute,\n.flatpickr-time input.flatpickr-second {\n  font-weight: 400;\n}\n\n.flatpickr-time input:focus {\n  outline: 0;\n  border: 0;\n}\n\n.flatpickr-time .flatpickr-am-pm,\n.flatpickr-time .flatpickr-time-separator {\n  height: inherit;\n  float: left;\n  line-height: inherit;\n  color: var(--bs-body-color);\n  font-weight: 700;\n  width: 2%;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -ms-flex-item-align: center;\n  align-self: center;\n}\n\n.flatpickr-time .flatpickr-am-pm {\n  outline: 0;\n  width: 18%;\n  cursor: pointer;\n  text-align: center;\n  font-weight: 400;\n}\n\n.flatpickr-time .flatpickr-am-pm:focus,\n.flatpickr-time .flatpickr-am-pm:hover,\n.flatpickr-time input:focus,\n.flatpickr-time input:hover {\n  background: rgba(75, 56, 179, 0.04);\n}\n\n.flatpickr-am-pm:focus,\n.flatpickr-am-pm:hover,\n.numInput:focus,\n.numInput:hover,\n.numInputWrapper:focus,\n.numInputWrapper:hover {\n  background-color: transparent;\n}\n\n.flatpickr-input[readonly] {\n  cursor: pointer;\n  background-color: var(--bs-input-bg);\n}\n\n[data-inline-date=\"true\"],\n[data-time-inline] {\n  display: none;\n}\n\n@-webkit-keyframes fpFadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes fpFadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -20px, 0);\n    transform: translate3d(0, -20px, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n[datepicker-inline],\n[timepicker-inline] {\n  display: none;\n}\n\n[data-input-flag] {\n  position: relative;\n}\n\n[data-input-flag] .dropdown-menu .dropdown-menu-list {\n  max-height: 158px;\n  overflow-y: auto;\n}\n\n[data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar {\n  -webkit-appearance: none;\n}\n\n[data-input-flag]\n  .dropdown-menu\n  .dropdown-menu-list::-webkit-scrollbar:vertical {\n  width: 8px;\n}\n\n[data-input-flag]\n  .dropdown-menu\n  .dropdown-menu-list::-webkit-scrollbar:horizontal {\n  height: 10px;\n}\n\n[data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar-thumb {\n  background-color: rgba(var(--bs-dark-rgb), 0.075);\n  border-radius: 8px;\n}\n\n[data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar-track {\n  border-radius: 8px;\n}\n\n/* [data-option-flag-img-name] .flag-input {\n    padding-left: 45px;\n    background-image: url(../images/flags/us.svg);\n    background-repeat: no-repeat;\n    background-position: 14px 8px;\n    background-size: 18px\n} */\n\n[data-option-flag-img-name]::before,\n[data-option-flag-name]::before {\n  content: \"\\f0140\";\n  font-family: \"Material Design Icons\";\n  position: absolute;\n  right: 0.9rem;\n  top: 0.5rem;\n  font-size: 16px;\n}\n\n[data-option-countrycode=\"false\"] .country-codeno {\n  display: none;\n}\n\n[data-search-input=\"false\"] .searchlist-input {\n  display: none;\n}\n\n.auth-page-wrapper .auth-page-content {\n  padding-bottom: 60px;\n  position: relative;\n  z-index: 2;\n  width: 100%;\n}\n\n.auth-page-wrapper .footer {\n  left: 0;\n  background-color: transparent;\n  color: var(--bs-body-color);\n}\n\n.auth-one-bg-position {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  width: 100%;\n  height: 380px;\n}\n\n@media (max-width: 575.98px) {\n  .auth-one-bg-position {\n    height: 280px;\n  }\n}\n\n.auth-one-bg .shape {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.auth-one-bg .shape > svg {\n  width: 100%;\n  height: auto;\n  fill: var(--bs-body-bg);\n}\n\n.auth-pass-inputgroup input[type=\"text\"] + .btn .ri-eye-fill:before {\n  content: \"\\ecb6\";\n}\n\n.particles-js-canvas-el {\n  position: relative;\n}\n\n.signin-other-title {\n  position: relative;\n}\n\n.signin-other-title:after {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 1px;\n  left: 0;\n  right: 0;\n  border-top: 1px dashed var(--bs-border-color);\n  top: 10px;\n}\n\n.signin-other-title .title {\n  display: inline-block;\n  position: relative;\n  z-index: 9;\n  background-color: var(--bs-card-bg-custom);\n  padding: 2px 16px;\n}\n\n.auth-bg-cover {\n  background: #f5f5f5;\n}\n\n/* .auth-bg-cover>.bg-overlay {\n    background-image: url(../images/cover-pattern.png);\n    background-position: center;\n    background-size: cover;\n    opacity: 1;\n    background-color: transparent\n} */\n\n.auth-bg-cover .footer {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n#password-contain {\n  display: none;\n}\n\n#password-contain p {\n  padding-left: 13px;\n}\n\n#password-contain p.valid {\n  color: #45cb85;\n}\n\n#password-contain p.valid::before {\n  position: relative;\n  left: -8px;\n  content: \"✔\";\n}\n\n#password-contain p.invalid {\n  color: #f06548;\n}\n\n#password-contain p.invalid::before {\n  position: relative;\n  left: -8px;\n  content: \"✖\";\n}\n\n.dash-filter-picker {\n  min-width: 210px !important;\n}\n\n.upcoming-scheduled {\n  position: relative;\n}\n\n.upcoming-scheduled .flatpickr-months {\n  position: absolute !important;\n  top: -45px !important;\n  left: auto !important;\n  right: 0 !important;\n  width: 200px;\n  background-color: transparent;\n}\n\n.upcoming-scheduled .flatpickr-months .flatpickr-month {\n  color: #878a99 !important;\n  fill: #878a99 !important;\n}\n\n.upcoming-scheduled .flatpickr-months .flatpickr-next-month,\n.upcoming-scheduled .flatpickr-months .flatpickr-prev-month {\n  display: none;\n}\n\n.upcoming-scheduled .flatpickr-calendar {\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.upcoming-scheduled .flatpickr-calendar .flatpickr-current-month {\n  font-size: 13px;\n  width: 100%;\n  left: 0;\n}\n\n.upcoming-scheduled .flatpickr-calendar .flatpickr-monthDropdown-months {\n  border: 1px solid var(--bs-border-color);\n  border-radius: 4px;\n  height: 26px;\n}\n\n.upcoming-scheduled .flatpickr-calendar .flatpickr-weekdays {\n  background-color: var(--bs-light);\n  border: none;\n}\n\n.upcoming-scheduled\n  .flatpickr-calendar\n  .flatpickr-weekdays\n  span.flatpickr-weekday {\n  color: var(--bs-dark);\n  background-color: var(--bs-light);\n}\n\n.upcoming-scheduled .flatpickr-calendar .flatpickr-day.today {\n  color: #fff !important;\n  background-color: #45cb85;\n  border-color: #45cb85 !important;\n}\n\n.upcoming-scheduled .flatpickr-calendar .flatpickr-day.today:hover {\n  color: #45cb85 !important;\n  background-color: rgba(69, 203, 133, 0.2) !important;\n}\n\n.upcoming-scheduled .flatpickr-calendar .flatpickr-day.selected {\n  background-color: #45cb85 !important;\n  border-color: #45cb85 !important;\n  color: #fff;\n}\n\n.upcoming-scheduled .flatpickr-calendar .numInputWrapper {\n  width: 7.5ch;\n  margin-left: 10px;\n}\n\n.upcoming-scheduled .flatpickr-days {\n  border: none !important;\n}\n\n.crm-widget .col {\n  border-right: 1px solid var(--bs-border-color);\n}\n\n.crm-widget .col:last-child {\n  border: 0;\n}\n\n@media (min-width: 768px) and (max-width: 1399.98px) {\n  .crm-widget .col:nth-child(3) {\n    border-right: 0;\n  }\n\n  .crm-widget .col:last-child {\n    border-right: 1px solid var(--bs-border-color);\n  }\n}\n\n@media (max-width: 767.98px) {\n  .crm-widget .col {\n    border-right: 0;\n    border-bottom: 1px solid var(--bs-border-color);\n  }\n}\n\n@media (min-width: 1400px) and (max-width: 1599.98px) {\n  .project-wrapper .col-xxl-4,\n  .project-wrapper > .col-xxl-8 {\n    width: 100%;\n  }\n}\n\n.crypto-widget {\n  max-width: 130px !important;\n}\n\n/* .bg-marketplace {\n    background-image: url(../images/nft/marketplace.png);\n    background-size: cover\n} */\n\n.dash-countdown .countdownlist .count-num {\n  background-color: var(--bs-card-bg-custom);\n  padding: 16px 8px;\n  font-size: 22px;\n}\n\n@media (max-width: 575.98px) {\n  .dash-countdown .countdownlist .count-num {\n    font-size: 16px;\n    padding: 8px 6px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .dash-countdown .countdownlist .count-title {\n    font-size: 10px;\n  }\n}\n\n.marketplace-icon {\n  position: absolute;\n  float: right;\n  top: 30px;\n  left: 30px;\n}\n\n.marketplace-swiper .swiper-button-next,\n.marketplace-swiper .swiper-button-prev {\n  top: 34px;\n  width: 28px;\n  height: 28px;\n  background-color: rgba(75, 56, 179, 0.1);\n  color: #4b38b3;\n  border-radius: 0.3rem;\n  right: 16px !important;\n}\n\n.marketplace-swiper .swiper-button-prev {\n  right: 58px !important;\n  left: auto !important;\n}\n\n.dash-collection .content {\n  background-color: rgba(255, 255, 255, 0.25);\n  -webkit-backdrop-filter: blur(5px);\n  backdrop-filter: blur(5px);\n}\n\n@media (max-width: 1441.98px) {\n  .dash-nft .col-xxl-3,\n  .dash-nft .col-xxl-9 {\n    width: 100% !important;\n    max-width: 100% !important;\n  }\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {\n  width: 32px;\n  height: 32px;\n  display: inline-block;\n  vertical-align: middle;\n}\n\n.timeline {\n  position: relative;\n  width: 100%;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.timeline::after {\n  content: \"\";\n  position: absolute;\n  width: 2px;\n  background: var(--bs-card-bg-custom);\n  top: 57px;\n  bottom: 166px;\n  left: 50%;\n  margin-left: -1.5px;\n}\n\n.timeline-item {\n  padding: 30px 60px;\n  position: relative;\n  background: inherit;\n  width: 50%;\n}\n\n.timeline-item .icon {\n  position: absolute;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  width: 60px;\n  height: 60px;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  font-size: 25px;\n  top: 30px;\n  right: -30px;\n  padding: 9px 0;\n  background: var(--bs-card-bg-custom);\n  border: 1px solid var(--bs-border-color);\n  border-radius: 50px;\n  color: #45cb85;\n  z-index: 1;\n}\n\n.timeline-item .date {\n  position: absolute;\n  display: inline-block;\n  width: calc(100% - 48px);\n  top: 50px;\n  font-size: 14px;\n  font-weight: 500;\n  font-style: italic;\n}\n\n.timeline-item .content {\n  padding: 20px;\n  background: var(--bs-card-bg-custom);\n  position: relative;\n  border: 1px solid var(--bs-border-color);\n  border-radius: 0.25rem;\n  -webkit-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);\n}\n\n.timeline-item.left {\n  left: 0;\n}\n\n.timeline-item.left .date {\n  left: calc(100% + 48px);\n  text-align: start;\n}\n\n.timeline-item.right {\n  left: 50%;\n}\n\n.timeline-item.right .icon {\n  left: -30px;\n}\n\n.timeline-item.right .date {\n  right: calc(100% + 48px);\n  text-align: end;\n}\n\n.timeline-item.right::before {\n  left: 28px;\n  border-color: transparent transparent transparent #fff;\n}\n\n@media (max-width: 991.98px) {\n  .timeline::after {\n    left: 112px;\n    bottom: 180px;\n  }\n\n  .timeline-item {\n    width: 100%;\n    padding-left: 165px;\n    padding-right: 0;\n  }\n\n  .timeline-item.left,\n  .timeline-item.right {\n    left: 0;\n  }\n\n  .timeline-item.left .icon,\n  .timeline-item.right .icon {\n    width: 45px;\n    height: 45px;\n    top: 37.5px;\n    font-size: 18px;\n    left: 90px;\n  }\n\n  .timeline-item.left::before,\n  .timeline-item.right::before {\n    left: 110px;\n    border-color: transparent transparent transparent var(--bs-border-color);\n  }\n\n  .timeline-item.left .date,\n  .timeline-item.right .date {\n    right: auto;\n    left: 0;\n    width: 79px;\n  }\n}\n\n.timeline-2 {\n  position: relative;\n}\n\n.timeline-2::after {\n  position: absolute;\n  content: \"\";\n  width: 2px;\n  height: 83%;\n  top: 50px;\n  left: 40px;\n  margin-left: -1px;\n  background: var(--bs-card-bg-custom);\n}\n\n.timeline-2 .timeline-year {\n  position: relative;\n  width: 100%;\n  text-align: left;\n  z-index: 1;\n}\n\n.timeline-2 .timeline-year p {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  width: 80px;\n  height: 80px;\n  margin: 0;\n  padding: 23px 10px;\n  background: var(--bs-card-bg-custom);\n  border-radius: 50px;\n  text-transform: uppercase;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.timeline-2 .timeline-year p span {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.timeline-2 .timeline-date {\n  font-size: 14px;\n  font-weight: 500;\n  margin: 24px 0 0 0;\n  margin-left: 55px;\n}\n\n.timeline-2 .timeline-date::after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  top: 26px;\n  left: 45px;\n  -webkit-box-align: left;\n  -ms-flex-align: left;\n  align-items: left;\n  background: #45cb85;\n  border: 3px solid var(--bs-card-bg-custom);\n  border-radius: 50px;\n  z-index: 1;\n}\n\n.timeline-2 .timeline-box {\n  position: relative;\n  display: inline-block;\n  margin: 23px 62px;\n  padding: 20px;\n  border: 1px solid var(--bs-border-color);\n  border-radius: 6px;\n  background: var(--bs-card-bg-custom);\n  max-width: 695px;\n}\n\n.timeline-2 .timeline-box::after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  top: 26px;\n  right: 100%;\n  border-color: transparent var(--bs-card-bg-custom) transparent transparent;\n  border-width: 10px;\n}\n\n.timeline-2 .timeline-box::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  right: 100%;\n  top: 24px;\n  border-color: transparent var(--bs-border-color) transparent transparent;\n  border-width: 12px;\n}\n\n.timeline-2 .timeline-box .timeline-text {\n  position: relative;\n  float: left;\n}\n\n.timeline-2 .timeline-launch {\n  position: relative;\n  display: inline-block;\n  border: 1px solid var(--bs-border-color);\n  border-radius: 6px;\n  background: #fff;\n  width: 100%;\n  margin-top: 15px;\n  padding: 0;\n  border: none;\n  text-align: left;\n  background: 0 0;\n}\n\n.timeline-2 .timeline-launch .timeline-box {\n  margin-left: 0;\n}\n\n.timeline-2 .timeline-launch .timeline-box::after {\n  left: 30px;\n  margin-left: 0;\n  top: -20px;\n  border-color: transparent transparent var(--bs-border-color) transparent;\n}\n\n.timeline-2 .timeline-launch .timeline-box::before {\n  left: 30px;\n  margin-left: 0;\n  top: -19px;\n  border-color: transparent transparent var(--bs-card-bg-custom) transparent;\n  border-width: 10px;\n  z-index: 1;\n}\n\n.horizontal-timeline {\n  position: relative;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.horizontal-timeline::before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  top: 174px;\n  left: 0;\n  height: 2px;\n  background-color: var(--bs-card-bg-custom);\n}\n\n.horizontal-timeline .swiper-slide .item-box {\n  margin: 227px 0 0;\n  background-color: transparent;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n}\n\n.horizontal-timeline .swiper-slide .item-box::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  background: #4b38b3;\n  width: 13px;\n  height: 13px;\n  top: -59px;\n  border-radius: 50px;\n  border: 3px solid var(--bs-card-bg-custom);\n}\n\n.horizontal-timeline .swiper-slide .timeline-content {\n  min-height: 110px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  position: relative;\n  background-color: var(--bs-card-bg-custom);\n}\n\n.horizontal-timeline .swiper-slide .timeline-content::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  width: 0;\n  height: 0;\n  border-style: solid;\n  left: 0;\n  top: -23px;\n  border-color: transparent transparent var(--bs-card-bg-custom) transparent;\n  border-width: 12px;\n  right: 0;\n  margin: 0 auto;\n}\n\n.horizontal-timeline .swiper-slide .time {\n  position: absolute;\n  top: -86px;\n  right: 0;\n  left: 0;\n  margin: 0 auto;\n}\n\n.horizontal-timeline .swiper-slide:nth-child(even) {\n  margin-top: 5px;\n  -webkit-transform: rotate(-180deg);\n  transform: rotate(-180deg);\n}\n\n.horizontal-timeline .swiper-slide:nth-child(even) .timeline-content {\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.horizontal-timeline .swiper-slide:nth-child(even) .timeline-content::before {\n  bottom: -23px;\n  top: auto;\n  border-color: var(--bs-card-bg-custom) transparent transparent transparent;\n}\n\n.horizontal-timeline .swiper-slide:nth-child(even) .time {\n  -webkit-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.horizontal-timeline .swiper-button-next,\n.horizontal-timeline .swiper-button-prev {\n  height: 40px;\n  width: 40px;\n  line-height: 40px;\n  border-radius: 50%;\n  background-color: #4f3bbd;\n}\n\n.horizontal-timeline .swiper-button-next::after,\n.horizontal-timeline .swiper-button-prev::after {\n  font-size: 24px;\n  color: #fff;\n}\n\n.horizontal-timeline .swiper-button-next.swiper-button-disabled,\n.horizontal-timeline .swiper-button-prev.swiper-button-disabled {\n  background-color: rgba(75, 56, 179, 0.5);\n  opacity: 1;\n  cursor: auto;\n  -webkit-backdrop-filter: blur(25px);\n  backdrop-filter: blur(25px);\n  pointer-events: none;\n}\n\n.horizontal-timeline .swiper-button-next {\n  right: 0;\n}\n\n.horizontal-timeline .swiper-button-next::after {\n  content: \"\\ea6e\";\n  font-family: remixicon;\n}\n\n.horizontal-timeline .swiper-button-prev {\n  left: 0;\n}\n\n.horizontal-timeline .swiper-button-prev::after {\n  content: \"\\ea64\";\n  font-family: remixicon;\n}\n\n.acitivity-timeline {\n  position: relative;\n  overflow: hidden;\n}\n\n.acitivity-timeline .acitivity-item {\n  position: relative;\n}\n\n.acitivity-timeline .acitivity-item .flex-shrink-0 {\n  z-index: 2;\n}\n\n.acitivity-timeline .acitivity-item .acitivity-avatar {\n  background-color: var(--bs-card-bg-custom);\n  border: 3px solid var(--bs-card-bg-custom);\n  height: 32px;\n  width: 32px;\n}\n\n.acitivity-timeline .acitivity-item:before {\n  content: \"\";\n  position: absolute;\n  border-left: 1px dashed var(--bs-border-color);\n  left: 16px;\n  height: 100%;\n  top: 5px;\n  z-index: 0;\n}\n\n.acitivity-timeline .acitivity-item:last-child::before {\n  border-color: transparent;\n}\n\n.categories-filter .list-inline-item {\n  position: relative;\n  margin-right: 0;\n}\n\n.categories-filter .list-inline-item a {\n  display: block;\n  color: var(--bs-body-color);\n  font-weight: 600;\n  padding: 8px 15px;\n  margin: 5px;\n  cursor: pointer;\n}\n\n.gallery-box {\n  position: relative;\n  overflow: hidden;\n  border: 1px solid transparent;\n  margin-bottom: 10px;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  background-color: transparent;\n  padding: 8px;\n}\n\n.gallery-box::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  width: 100%;\n  height: 0;\n  background-color: var(--bs-card-bg-custom);\n  -webkit-transition: all 0.4s;\n  transition: all 0.4s;\n}\n\n.gallery-box .gallery-container {\n  position: relative;\n  overflow: hidden;\n  border-radius: 4px;\n}\n\n.gallery-box .gallery-container a {\n  display: block;\n}\n\n.gallery-box .gallery-container .gallery-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n  opacity: 0;\n  background: -webkit-gradient(\n    linear,\n    left top,\n    left bottom,\n    color-stop(10%, rgba(0, 0, 0, 0)),\n    color-stop(60%, rgba(0, 0, 0, 0)),\n    to(rgba(0, 0, 0, 0.5))\n  );\n  background: linear-gradient(\n    180deg,\n    rgba(0, 0, 0, 0) 10%,\n    rgba(0, 0, 0, 0) 60%,\n    rgba(0, 0, 0, 0.5) 100%\n  );\n  visibility: hidden;\n  overflow: hidden;\n  -webkit-transition: all 0.4s ease-in-out 0s;\n  transition: all 0.4s ease-in-out 0s;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n  padding: 16px;\n}\n\n.gallery-box .gallery-container .gallery-overlay .overlay-caption {\n  color: #fff;\n  margin: 0;\n  font-size: 16px;\n}\n\n.gallery-box .gallery-img {\n  -webkit-transition: all 0.2s ease-in-out;\n  transition: all 0.2s ease-in-out;\n}\n\n.gallery-box .box-content {\n  position: relative;\n}\n\n.gallery-box .box-content .title {\n  font-size: 14px;\n  margin-bottom: 4px;\n  display: none;\n}\n\n.gallery-box .box-content .post {\n  margin: 0;\n  -webkit-transition: all 0.2s;\n  transition: all 0.2s;\n  color: #878a99;\n}\n\n.gallery-box:hover::before {\n  height: 100%;\n}\n\n.gallery-box:hover .box-content {\n  bottom: 0;\n}\n\n.gallery-box:hover .box-content .post {\n  opacity: 1;\n}\n\n.gallery-box:hover .gallery-overlay {\n  opacity: 1;\n  visibility: visible;\n}\n\n.gallery-light .gallery-box::before {\n  background-color: var(--bs-light);\n}\n\n.error-basic-img {\n  max-width: 450px;\n}\n\n.error-500 .title {\n  font-size: 250px;\n}\n\n.error-500 .error-500-img {\n  position: absolute;\n  top: 57px;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n}\n\n@media (min-width: 768px) and (max-width: 991.98px) {\n  .error-500 .title {\n    font-size: 150px;\n  }\n\n  .error-500 .error-500-img {\n    width: 20% !important;\n    top: 43px;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .error-500 .title {\n    font-size: 68px;\n    margin-top: 35px;\n  }\n\n  .error-500 .error-500-img {\n    position: relative;\n    top: 0;\n  }\n}\n\n@-webkit-keyframes errorAnimation {\n  0% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n\n  15% {\n    -webkit-transform: translateX(-25%) rotate(-5deg);\n    transform: translateX(-25%) rotate(-5deg);\n  }\n\n  30% {\n    -webkit-transform: translateX(20%) rotate(3deg);\n    transform: translateX(20%) rotate(3deg);\n  }\n\n  45% {\n    -webkit-transform: translateX(-15%) rotate(-3deg);\n    transform: translateX(-15%) rotate(-3deg);\n  }\n\n  60% {\n    -webkit-transform: translateX(10%) rotate(2deg);\n    transform: translateX(10%) rotate(2deg);\n  }\n\n  75% {\n    -webkit-transform: translateX(-5%) rotate(-1deg);\n    transform: translateX(-5%) rotate(-1deg);\n  }\n\n  100% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n}\n\n@keyframes errorAnimation {\n  0% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n\n  15% {\n    -webkit-transform: translateX(-25%) rotate(-5deg);\n    transform: translateX(-25%) rotate(-5deg);\n  }\n\n  30% {\n    -webkit-transform: translateX(20%) rotate(3deg);\n    transform: translateX(20%) rotate(3deg);\n  }\n\n  45% {\n    -webkit-transform: translateX(-15%) rotate(-3deg);\n    transform: translateX(-15%) rotate(-3deg);\n  }\n\n  60% {\n    -webkit-transform: translateX(10%) rotate(2deg);\n    transform: translateX(10%) rotate(2deg);\n  }\n\n  75% {\n    -webkit-transform: translateX(-5%) rotate(-1deg);\n    transform: translateX(-5%) rotate(-1deg);\n  }\n\n  100% {\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n}\n\n.error-img {\n  -webkit-animation: errorAnimation 20s infinite;\n  animation: errorAnimation 20s infinite;\n}\n\n.error-text {\n  text-shadow: 4px 4px rgba(69, 203, 133, 0.4);\n}\n\n@media (min-width: 1200px) {\n  .error-text {\n    font-size: 10rem;\n  }\n}\n\n.profile-wid-bg {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  height: 320px;\n}\n\n@media (max-width: 575.98px) {\n  .profile-wid-bg {\n    height: 445px;\n  }\n}\n\n.profile-wid-bg::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  opacity: 0.9;\n  background: #4b38b3;\n  background: -webkit-gradient(\n    linear,\n    left bottom,\n    left top,\n    from(#221a52),\n    to(#4b38b3)\n  );\n  background: linear-gradient(to top, #221a52, #4b38b3);\n}\n\n.profile-wid-bg .profile-wid-img {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n.profile-nav.nav-pills .nav-link {\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.profile-nav.nav-pills .nav-link::before {\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.profile-project-card {\n  border: 1px solid var(--bs-border-color);\n  border-left: 3px solid var(--bs-border-color);\n}\n\n.profile-project-card.profile-project-primary {\n  border-left-color: #4b38b3;\n}\n\n.profile-project-card.profile-project-secondary {\n  border-left-color: #3577f1;\n}\n\n.profile-project-card.profile-project-success {\n  border-left-color: #45cb85;\n}\n\n.profile-project-card.profile-project-info {\n  border-left-color: #299cdb;\n}\n\n.profile-project-card.profile-project-warning {\n  border-left-color: #ffbe0b;\n}\n\n.profile-project-card.profile-project-danger {\n  border-left-color: #f06548;\n}\n\n.profile-project-card.profile-project-light {\n  border-left-color: #f3f6f9;\n}\n\n.profile-project-card.profile-project-dark {\n  border-left-color: #212529;\n}\n\n.user-profile-img {\n  position: relative;\n}\n\n.user-profile-img .profile-img {\n  width: 100%;\n  height: 250px;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n@media (max-width: 991px) {\n  .user-profile-img .profile-img {\n    height: 160px;\n  }\n}\n\n.user-profile-img .profile-foreground-img-file-input {\n  display: none;\n}\n\n.user-profile-img .profile-photo-edit {\n  cursor: pointer;\n}\n\n.profile-user {\n  position: relative;\n  display: inline-block;\n}\n\n.profile-user .profile-photo-edit {\n  position: absolute;\n  right: 0;\n  left: auto;\n  bottom: 0;\n  cursor: pointer;\n}\n\n.profile-user .user-profile-image {\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n.profile-user .profile-img-file-input {\n  display: none;\n}\n\n.profile-timeline .accordion-item {\n  position: relative;\n}\n\n.profile-timeline .accordion-item .accordion-button {\n  background-color: transparent;\n}\n\n.profile-timeline .accordion-item .accordion-button::after {\n  background: 0 0;\n}\n\n.profile-timeline .accordion-item::before {\n  content: \"\";\n  border-left: 2px dashed var(--bs-border-color);\n  position: absolute;\n  height: 100%;\n  left: 23px;\n}\n\n.profile-timeline .accordion-item:first-child::before {\n  top: 8px;\n}\n\n.profile-timeline .accordion-item:last-child::before {\n  height: 20px;\n  top: 3px;\n}\n\n.profile-setting-img {\n  position: relative;\n  height: 260px;\n}\n\n.profile-setting-img .overlay-content {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n}\n\n.profile-setting-img .profile-img {\n  width: 100%;\n  height: 250px;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n@media (max-width: 991.98px) {\n  .profile-setting-img .profile-img {\n    height: 160px;\n  }\n}\n\n.profile-setting-img .profile-foreground-img-file-input {\n  display: none;\n}\n\n.profile-setting-img .profile-photo-edit {\n  cursor: pointer;\n}\n\n@media (max-width: 575.98px) {\n  [data-layout=\"horizontal\"] .profile-foreground {\n    margin-top: 0 !important;\n  }\n}\n\n.sitemap-content {\n  width: 100%;\n  max-width: 1142px;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.sitemap-content * {\n  position: relative;\n}\n\n.sitemap-horizontal {\n  position: relative;\n}\n\n.sitemap-horizontal ul {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.sitemap-horizontal ul a {\n  display: block;\n  background: var(--bs-light);\n  border: 2px solid var(--bs-card-bg-custom);\n  -webkit-box-shadow: var(--bs-box-shadow);\n  box-shadow: var(--bs-box-shadow);\n  font-size: 0.8125rem;\n  height: 60px;\n  padding: 8px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.sitemap-horizontal ul a span {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.administration .director > li > a {\n  width: 50%;\n  margin: 0 auto 0 auto;\n  border-radius: 4px;\n}\n\n.administration .subdirector {\n  position: absolute;\n  width: 100%;\n}\n\n.administration .subdirector::after {\n  content: \"\";\n  display: block;\n  width: 0;\n  height: 130px;\n  border-left: 2px dashed var(--bs-border-color);\n  left: 45.45%;\n  position: relative;\n}\n\n.administration .subdirector > li:first-child {\n  width: 18.59%;\n  height: 64px;\n  margin: 0 auto 92px auto;\n  padding-top: 25px;\n  border-bottom: 2px dashed var(--bs-border-color);\n  z-index: 1;\n  float: right;\n  right: 27.2%;\n  border-left: 2px dashed var(--bs-border-color);\n}\n\n.administration .subdirector > li:first-child a {\n  width: 100%;\n  left: 25px;\n}\n\n@media screen and (max-width: 767px) {\n  .administration .subdirector > li:first-child {\n    width: 40%;\n    right: 10%;\n    margin-right: 2px;\n  }\n\n  .administration .subdirector::after {\n    left: 49.8%;\n  }\n}\n\n.departments {\n  width: 100%;\n}\n\n.departments > li:first-child {\n  width: 18.59%;\n  height: 64px;\n  margin: 0 auto 92px auto;\n  padding-top: 25px;\n  border-bottom: 2px dashed var(--bs-border-color);\n  z-index: 1;\n  float: left;\n  left: 27%;\n}\n\n.departments > li:first-child a {\n  width: 100%;\n  right: 25px;\n}\n\n.departments > li:nth-child(2) {\n  margin-left: 0;\n  clear: left;\n}\n\n.departments > li:nth-child(2).department:before {\n  border: none;\n}\n\n.departments::after {\n  content: \"\";\n  display: block;\n  position: absolute;\n  width: 81.1%;\n  height: 22px;\n  border-top: 2px dashed var(--bs-border-color);\n  border-right: 2px dashed var(--bs-border-color);\n  border-left: 2px dashed var(--bs-border-color);\n  margin: 0 auto;\n  top: 130px;\n  left: 9.1%;\n}\n\n@media screen and (max-width: 767px) {\n  .departments > li:first-child {\n    width: 40%;\n    left: 10%;\n    margin-left: 2px;\n  }\n\n  .departments::after {\n    border-right: none;\n    left: 0;\n    width: 50%;\n  }\n}\n\n.department {\n  border-left: 2px dashed var(--bs-border-color);\n  float: left;\n  margin-left: 1.75%;\n  margin-bottom: 60px;\n  width: 18.25%;\n}\n\n.department::before {\n  content: \"\";\n  display: block;\n  position: absolute;\n  width: 0;\n  height: 22px;\n  border-left: 2px dashed var(--bs-border-color);\n  z-index: 1;\n  top: -22px;\n  left: 50%;\n  margin-left: -4px;\n}\n\n.department > a {\n  margin: 0 0 -26px -4px;\n  z-index: 1;\n}\n\n.department ul {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.department ul li {\n  padding-left: 25px;\n  border-bottom: 2px dashed var(--bs-border-color);\n  height: 80px;\n}\n\n.department ul li a {\n  background: var(--bs-card-bg-custom);\n  margin-top: 48px;\n  position: absolute;\n  z-index: 1;\n  width: 90%;\n  height: 60px;\n  vertical-align: middle;\n  right: -1px;\n  text-align: center;\n}\n\n.department:first-child {\n  margin-left: 0;\n  clear: left;\n}\n\n@media screen and (min-width: 768px) {\n  .department:last-child:before {\n    border: none;\n  }\n}\n\n@media screen and (max-width: 767px) {\n  .department {\n    float: none;\n    width: 100%;\n    margin-left: 0;\n  }\n\n  .department::before {\n    content: \"\";\n    display: block;\n    position: absolute;\n    width: 0;\n    height: 60px;\n    border-left: 2px dashed #fff;\n    z-index: 1;\n    top: -60px;\n    left: 0;\n    margin-left: -4px;\n  }\n\n  .department:nth-child(2)::before {\n    display: none;\n  }\n}\n\n.hori-sitemap ul {\n  padding: 0;\n  padding-top: 10px;\n  text-align: center;\n}\n\n.hori-sitemap ul li {\n  position: relative;\n}\n\n@media (max-width: 575.98px) {\n  .hori-sitemap ul {\n    text-align: left;\n  }\n\n  .hori-sitemap ul .parent-title a {\n    padding-left: 0;\n  }\n\n  .hori-sitemap ul .parent-title a:after {\n    display: none;\n  }\n\n  .hori-sitemap ul .parent-title:before {\n    display: none;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .hori-sitemap > ul {\n    position: relative;\n  }\n\n  .hori-sitemap > ul li {\n    padding-top: 10px;\n  }\n\n  .hori-sitemap > ul li .second-list,\n  .hori-sitemap > ul li .sub-list {\n    position: relative;\n  }\n\n  .hori-sitemap > ul li .second-list:before,\n  .hori-sitemap > ul li .sub-list:before {\n    content: \"\";\n    height: calc(100% - 14px);\n    border-right: 2px dashed var(--bs-border-color);\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n\n  .hori-sitemap > ul li .sub-list:before {\n    height: 38%;\n  }\n\n  .hori-sitemap > ul li a {\n    position: relative;\n    padding: 4px 16px 4px 36px;\n  }\n\n  .hori-sitemap > ul li a:after {\n    content: \"\";\n    width: 24px;\n    border-top: 2px dashed var(--bs-border-color);\n    position: absolute;\n    top: 50%;\n    -webkit-transform: translateY(-50%);\n    transform: translateY(-50%);\n    left: 0;\n  }\n\n  .hori-sitemap > ul li ul {\n    margin-left: 36px;\n  }\n}\n\n@media (min-width: 576px) {\n  .hori-sitemap ul {\n    padding-top: 20px;\n  }\n\n  .hori-sitemap ul li {\n    padding-top: 30px;\n  }\n\n  .hori-sitemap ul li:before {\n    content: \"\";\n    height: 24px;\n    width: 0;\n    border-right: 2px dashed var(--bs-border-color);\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n  }\n\n  .hori-sitemap ul li:after {\n    content: \"\";\n    width: 100%;\n    border-top: 2px dashed var(--bs-border-color);\n    position: absolute;\n    top: 0;\n    left: 50%;\n  }\n\n  .hori-sitemap ul li:last-of-type:after {\n    display: none;\n  }\n\n  .hori-sitemap ul li.parent-title::before {\n    content: \"\";\n    height: 23px;\n    border-right: 2px dashed var(--bs-border-color);\n    position: absolute;\n    top: 28px;\n    left: 0;\n  }\n\n  .hori-sitemap ul li.parent-title::after {\n    border: none;\n  }\n\n  .hori-sitemap ul li .sub-title {\n    position: relative;\n  }\n\n  .hori-sitemap ul li .sub-title::before {\n    content: \"\";\n    height: 21px;\n    border-right: 2px dashed var(--bs-border-color);\n    position: absolute;\n    top: 27px;\n    left: 49%;\n    margin: 0 auto;\n  }\n}\n\n.hori-sitemap a {\n  color: var(--bs-body-color);\n  padding: 4px 0;\n  display: block;\n}\n\n.verti-sitemap a {\n  color: var(--bs-body-color);\n  display: block;\n}\n\n.verti-sitemap .parent-title a {\n  padding-left: 0;\n}\n\n.verti-sitemap .parent-title a:before {\n  display: none;\n}\n\n.verti-sitemap .parent-title:before {\n  display: none;\n}\n\n.verti-sitemap .first-list {\n  position: relative;\n  padding-top: 10px;\n}\n\n.verti-sitemap .first-list:before {\n  content: \"\";\n  border-left: 2px dashed var(--bs-border-color);\n  position: absolute;\n  top: 0;\n  height: 100%;\n  bottom: 0;\n  left: 0;\n}\n\n.verti-sitemap .first-list .list-wrap a,\n.verti-sitemap .first-list li a {\n  position: relative;\n  padding: 10px 16px 4px 36px;\n}\n\n.verti-sitemap .first-list .list-wrap a::before,\n.verti-sitemap .first-list li a::before {\n  content: \"\";\n  width: 24px;\n  border-top: 2px dashed var(--bs-border-color);\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n  left: 0;\n}\n\n.verti-sitemap .first-list .second-list,\n.verti-sitemap .first-list .third-list {\n  margin-left: 42px;\n}\n\n.verti-sitemap .first-list .second-list,\n.verti-sitemap .first-list .third-list {\n  position: relative;\n}\n\n.verti-sitemap .first-list .second-list li,\n.verti-sitemap .first-list .third-list li {\n  position: relative;\n}\n\n.verti-sitemap .first-list .second-list li:before,\n.verti-sitemap .first-list .third-list li:before {\n  content: \"\";\n  height: 100%;\n  border-left: 2px dashed var(--bs-border-color);\n  position: absolute;\n  top: 0;\n  left: 0;\n  margin: 0 auto;\n}\n\n.verti-sitemap .first-list .second-list li:last-child::before,\n.verti-sitemap .first-list .third-list li:last-child::before {\n  height: 13px;\n}\n\n.verti-sitemap .first-list:last-child::before {\n  height: 25px;\n}\n\n.modal-team-cover,\n.profile-offcanvas .team-cover,\n.team-box .team-cover {\n  display: none;\n  position: relative;\n  margin-bottom: -140px;\n}\n\n.modal-team-cover img,\n.profile-offcanvas .team-cover img,\n.team-box .team-cover img {\n  height: 140px;\n  width: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n.modal-team-cover::before,\n.profile-offcanvas .team-cover::before,\n.team-box .team-cover::before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  background: -webkit-gradient(\n    linear,\n    left bottom,\n    left top,\n    from(#221a52),\n    to(#4b38b3)\n  );\n  background: linear-gradient(to top, #221a52, #4b38b3);\n  opacity: 0.6;\n}\n\n.team-list.grid-view-filter {\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-flow: row wrap;\n  flex-flow: row wrap;\n}\n\n.team-list.grid-view-filter .col {\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  width: 25%;\n}\n\n.team-list.grid-view-filter .team-box {\n  overflow: hidden;\n}\n\n.team-list.grid-view-filter .team-box .team-row {\n  -webkit-box-align: start;\n  -ms-flex-align: start;\n  align-items: start;\n}\n\n.team-list.grid-view-filter .team-box .team-row .col {\n  width: 100%;\n}\n\n.team-list.grid-view-filter .team-box .team-cover {\n  display: block;\n}\n\n.team-list.grid-view-filter .team-box .team-settings .col {\n  width: 50% !important;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n}\n\n.team-list.grid-view-filter .team-box .team-settings .btn-star {\n  color: #fff;\n}\n\n.team-list.grid-view-filter .team-box .team-settings .dropdown > a {\n  color: #fff;\n}\n\n.team-list.grid-view-filter .team-box .team-profile-img {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-bottom: 25px;\n  margin-top: 36px;\n}\n\n.team-list.grid-view-filter .team-box .team-profile-img .avatar-lg {\n  font-size: 22px;\n}\n\n.team-list.grid-view-filter .team-box .team-profile-img .team-content {\n  margin-left: 0;\n  margin-top: 25px;\n  text-align: center;\n}\n\n.team-list.grid-view-filter .team-box .view-btn {\n  width: 100%;\n  margin-top: 25px;\n}\n\n@media (min-width: 1200px) and (max-width: 1399.98px) {\n  .team-list.grid-view-filter .col {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 33.33%;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .team-list.grid-view-filter .col {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 50%;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .team-list.grid-view-filter .col {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 100%;\n  }\n}\n\n.team-list.list-view-filter {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n.team-list.list-view-filter .team-box {\n  margin-bottom: 10px;\n}\n\n.team-list.list-view-filter .team-box .team-row {\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n}\n\n.team-list.list-view-filter .team-box .team-profile-img {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.team-list.list-view-filter .team-box .team-profile-img .avatar-lg {\n  height: 4rem;\n  width: 4rem;\n  font-size: 16px;\n}\n\n.team-list.list-view-filter .team-box .team-profile-img .team-content {\n  margin-left: 15px;\n}\n\n.team-list.list-view-filter .team-box .team-settings {\n  width: auto;\n  -webkit-box-flex: 0;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  -webkit-box-ordinal-group: 7;\n  -ms-flex-order: 6;\n  order: 6;\n}\n\n.team-list.list-view-filter .team-box .btn-star {\n  color: #4b38b3;\n}\n\n@media (max-width: 767.98px) {\n  .team-list.list-view-filter {\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -ms-flex-direction: row;\n    flex-direction: row;\n  }\n\n  .team-list.list-view-filter .col {\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    width: 100%;\n  }\n\n  .team-list.list-view-filter .team-box .team-settings {\n    width: 100%;\n    -webkit-box-flex: 0;\n    -ms-flex: 0 0 auto;\n    flex: 0 0 auto;\n    -webkit-box-ordinal-group: 0;\n    -ms-flex-order: -1;\n    order: -1;\n    margin-bottom: 10px;\n  }\n\n  .team-list.list-view-filter .team-box .team-settings .col {\n    width: 50%;\n  }\n\n  .team-list.list-view-filter .team-box .team-profile-img {\n    margin-bottom: 25px;\n  }\n\n  .team-list.list-view-filter .team-box .view-btn {\n    width: 100%;\n    margin-top: 25px;\n  }\n}\n\n.modal-team-cover {\n  display: block;\n}\n\n.list-grid-nav .nav-link.active {\n  background-color: #299cdb;\n  color: #fff;\n}\n\n.profile-offcanvas .team-cover {\n  margin-bottom: -132px;\n  display: block;\n  z-index: -1;\n}\n\n.profile-offcanvas .btn-star {\n  color: #fff;\n}\n\n.profile-offcanvas .dropdown > a {\n  color: #fff;\n}\n\n.countdownlist {\n  text-align: center;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 24px;\n}\n\n.countdownlist .countdownlist-item {\n  width: 25%;\n}\n\n.countdownlist .countdownlist-item:last-of-type .count-num::after {\n  display: none;\n}\n\n.countdownlist .count-title {\n  font-size: 13px;\n  font-weight: 500;\n  display: block;\n  margin-bottom: 8px;\n  color: rgba(var(--bs-dark-rgb), 0.5);\n  text-transform: uppercase;\n}\n\n.countdownlist .count-num {\n  background-color: var(--bs-card-bg-custom);\n  padding: 16px 8px;\n  position: relative;\n  border-radius: 0.25rem;\n  -webkit-box-shadow: var(--bs-box-shadow);\n  box-shadow: var(--bs-box-shadow);\n  font-weight: 600;\n  font-size: 32px;\n}\n\n@media (max-width: 575.98px) {\n  .countdownlist .count-num {\n    font-size: 18px;\n  }\n}\n\n.countdownlist .count-num::after {\n  content: \":\";\n  font-size: 20px;\n  position: absolute;\n  right: -16px;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n  color: var(--bs-dark);\n}\n\n.move-animation {\n  -webkit-animation: mover 1s infinite alternate;\n  animation: mover 1s infinite alternate;\n}\n\n@-webkit-keyframes mover {\n  0% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n  }\n\n  100% {\n    -webkit-transform: translateY(-16px);\n    transform: translateY(-16px);\n  }\n}\n\n@keyframes mover {\n  0% {\n    -webkit-transform: translateY(0);\n    transform: translateY(0);\n  }\n\n  100% {\n    -webkit-transform: translateY(-16px);\n    transform: translateY(-16px);\n  }\n}\n\n.coming-soon-text {\n  font-weight: 600;\n  text-transform: uppercase;\n  color: #fff;\n  text-shadow: 3px 4px #45cb85;\n}\n\n.countdown-input-group {\n  max-width: 400px;\n}\n\n.search-more-results {\n  position: relative;\n  overflow: hidden;\n}\n\n.search-more-results .nav-icon {\n  font-size: 14px;\n  color: #fff;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n  text-align: center;\n  left: 0;\n  right: 0;\n}\n\n.search-more-results .nav-icon i {\n  font-size: 20px;\n}\n\n@media (max-width: 767.98px) {\n  .search-more-results .nav-icon {\n    font-size: 14px;\n  }\n\n  .search-more-results .nav-icon i {\n    font-size: 18px;\n  }\n}\n\n.video-list .list-element {\n  display: none;\n}\n\n.video-list .list-element:nth-child(1) {\n  display: block;\n}\n\n.video-list .list-element:nth-child(2) {\n  display: block;\n}\n\n.video-list .list-element:nth-child(3) {\n  display: block;\n}\n\n.search-voice {\n  height: 120px;\n  width: 120px;\n  line-height: 120px;\n  margin: 0 auto;\n  text-align: center;\n  border-radius: 50%;\n  z-index: 1;\n  position: relative;\n}\n\n.search-voice i {\n  line-height: 56px;\n  font-size: 30px;\n}\n\n.search-voice .voice-wave {\n  position: absolute;\n  width: 120px;\n  height: 120px;\n  z-index: -1;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  opacity: 0;\n  border-radius: 100px;\n  -webkit-animation: voice-wave 1.8s infinite;\n  animation: voice-wave 1.8s infinite;\n  background-color: var(--bs-light);\n}\n\n.search-voice .voice-wave:nth-child(2) {\n  -webkit-animation-delay: 0.3s;\n  animation-delay: 0.3s;\n}\n\n.search-voice .voice-wave:nth-child(3) {\n  -webkit-animation-delay: 0.6s;\n  animation-delay: 0.6s;\n}\n\n@-webkit-keyframes voice-wave {\n  0% {\n    opacity: 1;\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n@keyframes voice-wave {\n  0% {\n    opacity: 1;\n    -webkit-transform: scale(0);\n    transform: scale(0);\n  }\n\n  100% {\n    opacity: 0;\n    -webkit-transform: scale(1);\n    transform: scale(1);\n  }\n}\n\n.images-menu .swiper-slide {\n  width: auto;\n  display: inline-block;\n}\n\n#selection-element {\n  display: none;\n}\n\n.filter-choices-input .choices__inner {\n  padding: 0;\n  border: none;\n  background-color: var(--bs-card-bg-custom);\n}\n\n.filter-choices-input .choices__input {\n  background-color: var(--bs-card-bg-custom);\n}\n\n@media (min-width: 992px) {\n  .sticky-side-div {\n    position: sticky;\n    top: calc(70px + 1.5rem);\n  }\n}\n\n.product-img-slider .product-nav-slider .nav-slide-item {\n  border: 1px solid var(--bs-border-color);\n  border-radius: 0.25rem;\n  padding: 0.5rem;\n  cursor: pointer;\n}\n\n.product-img-slider\n  .product-nav-slider\n  .swiper-slide-thumb-active\n  .nav-slide-item {\n  background-color: var(--bs-light);\n}\n\n.filter-list a.active .listname {\n  color: #45cb85;\n}\n\n.invoice-table tbody:last-child {\n  border: none;\n}\n\n.currency-select .choices__inner {\n  padding: 0;\n  padding-right: 15px;\n  min-height: 0;\n}\n\n.currency-select .choices__list--single {\n  padding: 0 16px 0 4px;\n}\n\n.currency-select .choices[data-type*=\"select-one\"] {\n  bottom: 0;\n}\n\n.currency-select .choices[data-type*=\"select-one\"] :after {\n  top: 4px;\n}\n\n.currency-select .choices[data-type*=\"select-one\"] .choices__inner {\n  padding-bottom: 0;\n}\n\n.chat-wrapper {\n  position: relative;\n  overflow-x: hidden;\n}\n\n.chat-leftsidebar {\n  height: calc(100vh - 137px);\n  position: relative;\n  background-color: var(--bs-card-bg-custom);\n}\n\n@media (min-width: 992px) {\n  .chat-leftsidebar {\n    min-width: 300px;\n    max-width: 300px;\n    height: calc(100vh - 70px - 60px - 8px);\n  }\n}\n\n.chat-list {\n  margin: 0;\n}\n\n.chat-list > li.active a {\n  background-color: var(--bs-primary);\n  color: var(--bs-white);\n}\n\n.chat-list > li.active a .badge {\n  background-color: rgba(var(--bs-success-rgb), 0.15) !important;\n  color: #45cb85 !important;\n}\n\n.chat-list > li a {\n  display: block;\n  padding: 7px 24px;\n  color: var(--bs-body-color);\n  -webkit-transition: all 0.4s;\n  transition: all 0.4s;\n  font-family: Inter, sans-serif;\n  font-weight: 500;\n  font-size: 0.8125rem;\n}\n\n.chat-list > li .chat-user-message {\n  font-size: 14px;\n}\n\n.chat-list > li .unread-msg-user {\n  font-weight: 600;\n}\n\n.chat-list > li .unread-message {\n  position: absolute;\n  display: inline-block;\n  right: 24px;\n  left: auto;\n  top: 33px;\n}\n\n.chat-list > li .unread-message .badge {\n  line-height: 16px;\n  font-weight: 600;\n  font-size: 10px;\n}\n\n.chat-user-img {\n  position: relative;\n}\n\n.chat-user-img .user-status {\n  width: 10px;\n  height: 10px;\n  background-color: #adb5bd;\n  border-radius: 50%;\n  border: 2px solid var(--bs-card-bg-custom);\n  position: absolute;\n  right: 0;\n  left: auto;\n  bottom: 0;\n}\n\n.chat-user-img.online .user-status {\n  background-color: #45cb85;\n}\n\n.chat-user-img.away .user-status {\n  background-color: #ffbe0b;\n}\n\n.chat-room-list {\n  max-height: calc(100vh - 296px);\n}\n\n@media (max-width: 991.98px) {\n  .chat-room-list {\n    height: calc(100vh - 296px);\n  }\n}\n\n.contact-list li {\n  cursor: pointer;\n  padding: 8px 24px;\n  -webkit-transition: all 0.4s;\n  transition: all 0.4s;\n  color: var(--bs-body-color);\n  font-family: Inter, sans-serif;\n  font-weight: 500;\n  font-size: 0.8125rem;\n}\n\n.contact-list-title {\n  padding: 6px 24px;\n  color: #4b38b3;\n  font-weight: 500;\n  position: relative;\n  font-size: 12px;\n}\n\n.contact-list-title:after {\n  content: \"\";\n  height: 1px;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  transform: translateY(-50%);\n  left: 50px;\n  right: 0;\n  background-color: #f3f6f9;\n}\n\n/* .user-chat {\n    background: url(../images/chat-bg-pattern.png);\n    -webkit-transition: all .4s;\n    transition: all .4s;\n    position: relative;\n    background-color: var(--bs-body-bg)\n} */\n\n@media (max-width: 991.98px) {\n  .user-chat {\n    position: absolute;\n    left: 0;\n    top: 3px;\n    width: 100%;\n    height: calc(100% - 3px);\n    visibility: hidden;\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n    z-index: 99;\n    padding-top: 70px;\n  }\n\n  .user-chat.user-chat-show {\n    visibility: visible;\n    -webkit-transform: translateX(0);\n    transform: translateX(0);\n  }\n}\n\n.user-chat .chat-content {\n  position: relative;\n}\n\n.user-chat.user-chat-show .chat-welcome-section {\n  display: none;\n}\n\n@media (min-width: 992px) {\n  .user-chat.user-chat-show .chat-content {\n    display: -webkit-box !important;\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n}\n\n.user-chat-topbar {\n  border-bottom: 1px solid transparent;\n  background-color: var(--bs-card-bg-custom);\n}\n\n@media (max-width: 991.98px) {\n  .user-chat-topbar {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    z-index: 1;\n  }\n}\n\n.user-chat-nav .nav-btn {\n  height: 40px;\n  width: 40px;\n  line-height: 40px;\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  padding: 0;\n  font-size: 20px;\n  color: #343a40;\n}\n\n@media (max-width: 575.98px) {\n  .user-chat-nav {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: end;\n    -ms-flex-pack: end;\n    justify-content: flex-end;\n  }\n}\n\n.chat-conversation {\n  height: calc(100vh - 299px);\n}\n\n@media (max-width: 991.98px) {\n  .chat-conversation {\n    height: calc(100vh - 275px);\n  }\n}\n\n.chat-conversation .simplebar-content-wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n.chat-conversation .simplebar-content-wrapper .simplebar-content {\n  margin-top: auto;\n}\n\n.chat-conversation .chat-conversation-list {\n  padding-top: 10px;\n  margin-bottom: 0;\n}\n\n.chat-conversation .chat-conversation-list > li {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.chat-conversation li:last-of-type .conversation-list {\n  margin-bottom: 0;\n}\n\n.chat-conversation .chat-list.left .check-message-icon {\n  display: none;\n}\n\n.chat-conversation .chat-list .message-box-drop {\n  visibility: hidden;\n}\n\n.chat-conversation .chat-list:hover .message-box-drop {\n  visibility: visible;\n}\n\n.chat-conversation .chat-avatar {\n  margin: 0 16px 0 0;\n}\n\n.chat-conversation .chat-avatar img {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n}\n\n.chat-conversation .chat-day-title {\n  position: relative;\n  text-align: center;\n  margin-bottom: 24px;\n  margin-top: 12px;\n  width: 100%;\n}\n\n.chat-conversation .chat-day-title .title {\n  background-color: #fff;\n  position: relative;\n  font-size: 13px;\n  z-index: 1;\n  padding: 6px 12px;\n  border-radius: 5px;\n}\n\n.chat-conversation .chat-day-title:before {\n  content: \"\";\n  position: absolute;\n  width: 100%;\n  height: 1px;\n  left: 0;\n  right: 0;\n  background-color: rgba(75, 56, 179, 0.2);\n  top: 10px;\n}\n\n.chat-conversation .chat-day-title .badge {\n  font-size: 12px;\n}\n\n.chat-conversation .conversation-list {\n  margin-bottom: 24px;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  position: relative;\n  -webkit-box-align: end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n  max-width: 80%;\n}\n\n@media (max-width: 575.98px) {\n  .chat-conversation .conversation-list {\n    max-width: 90%;\n  }\n}\n\n.chat-conversation .conversation-list .ctext-wrap {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 10px;\n}\n\n.chat-conversation .conversation-list .ctext-content {\n  word-wrap: break-word;\n  word-break: break-word;\n}\n\n.chat-conversation .conversation-list .ctext-wrap-content {\n  padding: 12px 20px;\n  background-color: var(--bs-light);\n  position: relative;\n  border-radius: 3px;\n  -webkit-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n}\n\n@media (max-width: 575.98px) {\n  .chat-conversation\n    .conversation-list\n    .ctext-wrap-content\n    .attached-file\n    .attached-file-avatar {\n    display: none;\n  }\n\n  .chat-conversation\n    .conversation-list\n    .ctext-wrap-content\n    .attached-file\n    .dropdown\n    .dropdown-toggle {\n    display: block;\n  }\n}\n\n.chat-conversation .conversation-list .conversation-name {\n  font-weight: 500;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  gap: 8px;\n}\n\n.chat-conversation .conversation-list .dropdown .dropdown-toggle {\n  font-size: 18px;\n  padding: 4px;\n  color: #878a99;\n}\n\n.chat-conversation .conversation-list .dropdown .dropdown-toggle::after {\n  display: none;\n}\n\n@media (max-width: 575.98px) {\n  .chat-conversation .conversation-list .dropdown .dropdown-toggle {\n    display: none;\n  }\n}\n\n.chat-conversation .conversation-list .chat-time {\n  font-size: 12px;\n  margin-top: 4px;\n  text-align: right;\n}\n\n.chat-conversation .conversation-list .message-img {\n  border-radius: 0.2rem;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.chat-conversation .conversation-list .message-img .message-img-list {\n  position: relative;\n}\n\n.chat-conversation .conversation-list .message-img img {\n  max-width: 150px;\n}\n\n.chat-conversation .conversation-list .message-img .message-img-link {\n  position: absolute;\n  right: 10px;\n  left: auto;\n  bottom: 10px;\n}\n\n.chat-conversation .conversation-list .message-img .message-img-link li > a {\n  font-size: 18px;\n  color: #fff;\n  display: inline-block;\n  line-height: 20px;\n  width: 26px;\n  height: 24px;\n  border-radius: 3px;\n  background-color: rgba(33, 37, 41, 0.7);\n  text-align: center;\n}\n\n.chat-conversation .right {\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n\n.chat-conversation .right .chat-avatar {\n  -webkit-box-ordinal-group: 4;\n  -ms-flex-order: 3;\n  order: 3;\n  margin-right: 0;\n  margin-left: 16px;\n}\n\n.chat-conversation .right .chat-time {\n  text-align: left;\n  color: #878a99;\n}\n\n.chat-conversation .right .conversation-list {\n  text-align: right;\n}\n\n.chat-conversation .right .conversation-list .ctext-wrap {\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n\n.chat-conversation .right .conversation-list .ctext-wrap .ctext-wrap-content {\n  -webkit-box-ordinal-group: 3;\n  -ms-flex-order: 2;\n  order: 2;\n  background-color: var(--bs-primary);\n  color: var(--bs-white);\n  text-align: right;\n  -webkit-box-shadow: var(--bs-box-shadow);\n  box-shadow: var(--bs-box-shadow);\n}\n\n.chat-conversation\n  .right\n  .conversation-list\n  .ctext-wrap\n  .ctext-wrap-content\n  .replymessage-block {\n  background-color: rgba(255, 255, 255, 0.5);\n  border-color: rgba(var(--bs-success-rgb), 1);\n  color: #212529;\n}\n\n.chat-conversation\n  .right\n  .conversation-list\n  .ctext-wrap\n  .ctext-wrap-content\n  .replymessage-block\n  .conversation-name {\n  color: rgba(var(--bs-success-rgb), 1);\n}\n\n.chat-conversation .right .conversation-list .conversation-name {\n  -webkit-box-pack: end;\n  -ms-flex-pack: end;\n  justify-content: flex-end;\n}\n\n.chat-conversation\n  .right\n  .conversation-list\n  .conversation-name\n  .check-message-icon {\n  -webkit-box-ordinal-group: 2;\n  -ms-flex-order: 1;\n  order: 1;\n}\n\n.chat-conversation .right .conversation-list .conversation-name .time {\n  -webkit-box-ordinal-group: 3;\n  -ms-flex-order: 2;\n  order: 2;\n}\n\n.chat-conversation .right .conversation-list .conversation-name .name {\n  -webkit-box-ordinal-group: 4;\n  -ms-flex-order: 3;\n  order: 3;\n}\n\n.chat-conversation .right .conversation-list .dropdown {\n  -webkit-box-ordinal-group: 2;\n  -ms-flex-order: 1;\n  order: 1;\n}\n\n.chat-conversation .right .dot {\n  background-color: #212529;\n}\n\n.chat-input-section {\n  border-top: 1px solid transparent;\n  background-color: var(--bs-card-bg-custom);\n  position: relative;\n  z-index: 1;\n}\n\n.chat-input-section .chat-input-feedback {\n  display: none;\n  position: absolute;\n  top: -20px;\n  left: 4px;\n  font-size: 12px;\n  color: #f06548;\n}\n\n.chat-input-section .show {\n  display: block;\n}\n\n.chat-input-links {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.chat-input-links .links-list-item > .btn {\n  -webkit-box-shadow: none;\n  box-shadow: none;\n  padding: 0;\n  font-size: 20px;\n  width: 37.5px;\n  height: 37.5px;\n}\n\n.chat-input-links .links-list-item > .btn.btn-link {\n  color: #878a99;\n}\n\n.copyclipboard-alert {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  display: none;\n}\n\n.replyCard {\n  position: absolute;\n  left: 0;\n  right: 0;\n  border-top: 1px solid var(--bs-border-color);\n  overflow: hidden;\n  opacity: 0;\n  bottom: 0;\n  border-radius: 0;\n  -webkit-transition: all 0.4s;\n  transition: all 0.4s;\n}\n\n@media (max-width: 991.98px) {\n  .replyCard {\n    bottom: -12px;\n  }\n}\n\n.replyCard.show {\n  -webkit-transform: translateY(-88px);\n  transform: translateY(-88px);\n  opacity: 1;\n}\n\n@media (max-width: 991.98px) {\n  .replyCard.show {\n    -webkit-transform: translateY(-83px);\n    transform: translateY(-83px);\n  }\n}\n\n.replymessage-block {\n  padding: 12px 20px;\n  margin-bottom: 8px;\n  text-align: left;\n  border-radius: 4px;\n  background-color: rgba(var(--bs-success-rgb), 0.1);\n  border-left: 2px solid rgba(var(--bs-success-rgb), 1);\n}\n\n.replymessage-block .conversation-name {\n  color: rgba(var(--bs-success-rgb), 1);\n  font-size: 14px;\n}\n\n.chat-sm .ctext-wrap-content {\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.chat-sm .message-img img {\n  max-width: 90px !important;\n}\n\n.chat-sm .message-img-link {\n  bottom: 0 !important;\n  right: 5px !important;\n}\n\n@media (min-width: 1025px) {\n  [data-layout=\"horizontal\"] .chat-wrapper {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n}\n\n@media (max-width: 991.98px) {\n  [data-layout=\"horizontal\"] .chat-wrapper {\n    margin-top: 0 !important;\n  }\n}\n\n[data-layout=\"horizontal\"] .chat-leftsidebar {\n  height: calc(100vh - 70px - 60px - 54px);\n}\n\n@media (max-width: 991.98px) {\n  [data-layout=\"horizontal\"] .chat-leftsidebar {\n    height: calc(100vh - 70px - 60px - 8px);\n  }\n}\n\n[data-layout=\"horizontal\"] .chat-room-list {\n  height: calc(100vh - 352px);\n}\n\n@media (max-width: 991.98px) {\n  [data-layout=\"horizontal\"] .chat-room-list {\n    height: calc(100vh - 265px);\n  }\n}\n\n[data-layout=\"horizontal\"] .chat-conversation {\n  height: calc(100vh - 343px);\n}\n\n@media (max-width: 991.98px) {\n  [data-layout=\"horizontal\"] .chat-conversation {\n    height: calc(100vh - 275px);\n  }\n}\n\n.email-wrapper {\n  position: relative;\n  overflow-x: hidden;\n}\n\n.email-menu-sidebar {\n  height: calc(100vh - 137px);\n  position: relative;\n  background-color: var(--bs-card-bg-custom);\n  -webkit-transition: all 0.2s;\n  transition: all 0.2s;\n}\n\n@media (min-width: 992px) {\n  .email-menu-sidebar {\n    min-width: 250px;\n    max-width: 250px;\n    height: calc(100vh - 70px - 60px - 8px);\n  }\n}\n\n@media (max-width: 991.98px) {\n  .email-menu-sidebar {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 200px;\n    max-width: 100%;\n    z-index: 1003;\n    -webkit-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n    -webkit-transform: translateX(-100%);\n    transform: translateX(-100%);\n    visibility: hidden;\n    height: 100vh;\n  }\n\n  .email-menu-sidebar.menubar-show {\n    visibility: visible;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n.email-menu-sidebar .email-menu-sidebar-scroll {\n  height: calc(100vh - 295px);\n}\n\n@media (max-width: 991.98px) {\n  .email-menu-sidebar .email-menu-sidebar-scroll {\n    height: calc(100vh - 150px);\n  }\n}\n\n.mail-list a {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  color: #878a99;\n  padding: 5px 0;\n  font-weight: 500;\n}\n\n.mail-list a:hover {\n  color: #4b38b3;\n}\n\n.mail-list a i {\n  font-size: 14px;\n}\n\n.mail-list a.active {\n  color: #45cb85;\n  font-weight: 600;\n}\n\n.mail-list a.active i {\n  color: #45cb85;\n}\n\n.email-topbar-link .btn-ghost-secondary {\n  color: #878a99;\n}\n\n.email-topbar-link .btn-ghost-secondary:hover {\n  color: #3577f1;\n}\n\n.email-content {\n  width: 100%;\n  background-color: var(--bs-card-bg-custom);\n  -webkit-transition: all 0.2s;\n  transition: all 0.2s;\n}\n\n.unreadConversations-alert {\n  position: fixed;\n  bottom: 60px;\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n  transform: translateX(-50%);\n  z-index: 1;\n}\n\n.email-detail-content {\n  position: absolute;\n  top: 4px;\n  bottom: 4px;\n  left: 68%;\n  width: 32%;\n  background-color: var(--bs-card-bg-custom);\n  -webkit-transform: translateX(200%);\n  transform: translateX(200%);\n  -webkit-transition: all 0.2s;\n  transition: all 0.2s;\n  visibility: hidden;\n  border-left: 2px solid var(--bs-body-bg);\n}\n\n.email-detail-show .email-detail-content {\n  -webkit-transform: none;\n  transform: none;\n  visibility: visible;\n}\n\n.email-detail-show .email-content {\n  margin-right: 32%;\n}\n\n@media (max-width: 1349.98px) {\n  .email-detail-show .email-content {\n    margin-right: 0;\n  }\n}\n\n.email-detail-content-scroll {\n  height: calc(100vh - 390px);\n}\n\n@media (max-width: 1349.98px) {\n  .email-detail-content-scroll {\n    height: calc(100vh - 252px);\n  }\n}\n\n.message-list-content {\n  height: calc(100vh - 242px);\n}\n\n@media (max-width: 575.98px) {\n  .message-list-content {\n    height: calc(100vh - 230px);\n  }\n}\n\n.message-list {\n  display: block;\n  padding-left: 0;\n  margin: 0;\n}\n\n.message-list li {\n  position: relative;\n  display: block;\n  height: 50px;\n  line-height: 50px;\n  cursor: default;\n  -webkit-transition-duration: 0.3s;\n  transition-duration: 0.3s;\n  clear: both;\n}\n\n.message-list li a {\n  color: var(--bs-gray-700);\n}\n\n.message-list li:hover {\n  background: var(--bs-light);\n  -webkit-transition-duration: 50ms;\n  transition-duration: 50ms;\n}\n\n.message-list li .col-mail {\n  float: left;\n  position: relative;\n}\n\n.message-list li .col-mail-1 {\n  width: 280px;\n}\n\n.message-list li .col-mail-1 .checkbox-wrapper-mail,\n.message-list li .col-mail-1 .dot,\n.message-list li .col-mail-1 .star-toggle {\n  display: block;\n  float: left;\n}\n\n.message-list li .col-mail-1 .dot {\n  border: 4px solid transparent;\n  border-radius: 100px;\n  margin: 22px 26px 0;\n  height: 0;\n  width: 0;\n  line-height: 0;\n  font-size: 0;\n}\n\n.message-list li .col-mail-1 .checkbox-wrapper-mail {\n  margin: 15px 0 0 20px;\n  line-height: normal;\n}\n\n.message-list li .col-mail-1 .star-toggle {\n  margin-top: 18px;\n  margin-left: 5px;\n}\n\n.message-list li .col-mail-1 .title {\n  position: absolute;\n  top: 0;\n  left: 95px;\n  right: 0;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  margin-bottom: 0;\n}\n\n@media (max-width: 575.98px) {\n  .message-list li .col-mail-1 .title {\n    left: 95px;\n  }\n}\n\n.message-list li .col-mail-2 {\n  position: absolute;\n  top: 0;\n  left: 280px;\n  right: 0;\n  bottom: 0;\n}\n\n.message-list li .col-mail-2 .date,\n.message-list li .col-mail-2 .subject {\n  position: absolute;\n  top: 0;\n}\n\n.message-list li .col-mail-2 .subject {\n  left: 0;\n  right: 110px;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.message-list li .col-mail-2 .subject .teaser {\n  color: var(--bs-gray-600);\n}\n\n.message-list li .col-mail-2 .date {\n  right: 0;\n  width: 100px;\n  padding-left: 20px;\n}\n\n.message-list li.active,\n.message-list li.active:hover {\n  -webkit-box-shadow: inset 3px 0 0 #4b38b3;\n  box-shadow: inset 3px 0 0 #4b38b3;\n  background-color: var(--bs-light);\n}\n\n.message-list li.unread {\n  color: var(--bs-gray-800);\n}\n\n.message-list li.unread a {\n  color: var(--bs-gray-800);\n  font-weight: 600;\n}\n\n#email-topbar-actions,\n#unreadConversations {\n  display: none;\n}\n\n#elmLoader {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n}\n\n.email-compose-input {\n  padding-right: 80px;\n}\n\n@media (max-width: 1349.98px) {\n  .email-detail-content {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: auto;\n    right: 0;\n    width: 400px;\n    max-width: 100%;\n    z-index: 1003;\n    -webkit-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n  }\n\n  .email-detail-show .email-detail-content {\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .message-list li .col-mail-1 {\n    width: 180px;\n  }\n}\n\n.email-editor .ck-editor__editable_inline {\n  min-height: 200px !important;\n}\n\n.email-chat-detail {\n  width: 350px;\n  position: fixed;\n  max-width: 100%;\n  bottom: 60px;\n  right: 60px;\n  z-index: 9;\n  display: none;\n}\n\n.email-chat-detail .card {\n  -webkit-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n}\n\n@media (max-width: 515.98px) {\n  .email-chat-detail {\n    left: 16px;\n    right: 16px;\n  }\n}\n\n@media (min-width: 1025px) {\n  [data-layout=\"horizontal\"] .email-wrapper {\n    margin-left: 0 !important;\n    margin-right: 0 !important;\n  }\n}\n\n@media (max-width: 991.98px) {\n  [data-layout=\"horizontal\"] .email-wrapper {\n    margin-top: 0 !important;\n  }\n}\n\n[data-layout=\"horizontal\"] .email-menu-sidebar {\n  height: calc(100vh - 70px - 60px - 54px);\n}\n\n@media (max-width: 991.98px) {\n  [data-layout=\"horizontal\"] .email-menu-sidebar {\n    height: 100vh;\n  }\n}\n\n[data-layout=\"horizontal\"] .email-menu-sidebar .email-menu-sidebar-scroll {\n  height: calc(100vh - 330px);\n}\n\n@media (max-width: 991.98px) {\n  [data-layout=\"horizontal\"] .email-menu-sidebar .email-menu-sidebar-scroll {\n    height: calc(100vh - 150px);\n  }\n}\n\n[data-layout=\"horizontal\"] .message-list-content {\n  height: calc(100vh - 289px);\n}\n\n[data-layout=\"horizontal\"] .email-detail-content-scroll {\n  height: calc(100vh - 435px);\n}\n\n@media (max-width: 1349.98px) {\n  [data-layout=\"horizontal\"] .email-detail-content-scroll {\n    height: calc(100vh - 252px);\n  }\n}\n\n.tasks-board {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  overflow-x: auto;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n\n.tasks-board .tasks-list {\n  min-width: 300px;\n  margin-right: 24px;\n}\n\n.tasks-board::-webkit-scrollbar {\n  -webkit-appearance: none;\n}\n\n.tasks-board::-webkit-scrollbar:vertical {\n  width: 10px;\n}\n\n.tasks-board::-webkit-scrollbar:horizontal {\n  height: 8px;\n}\n\n.tasks-board::-webkit-scrollbar-thumb {\n  background-color: rgba(var(--bs-dark-rgb), 0.075);\n  border-radius: 8px;\n}\n\n.tasks-board::-webkit-scrollbar-track {\n  border-radius: 8px;\n}\n\n.tasks-box .progress {\n  border-radius: 0 0 0.25rem 0.25rem;\n}\n\n.tasks-box .tasks-img {\n  height: 135px;\n  width: 100%;\n  -o-object-fit: cover;\n  object-fit: cover;\n  -o-object-position: center;\n  object-position: center;\n  margin: 12px 0;\n}\n\n.tasks-box:last-child {\n  margin-bottom: 0;\n}\n\n.tasks-wrapper {\n  max-height: calc(100vh - 418px);\n}\n\n.tasks {\n  min-height: 180px;\n  position: relative;\n}\n\n/* .tasks.noTask::before {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    height: 180px;\n    width: 270px;\n    margin: 0 auto;\n    background-image: url(../images/file.png);\n    background-size: cover;\n    background-position: center\n} */\n\n#tasksList tr .tasks-list-menu {\n  opacity: 0;\n}\n\n#tasksList tr:hover .tasks-list-menu {\n  opacity: 1;\n}\n\n.layout-wrapper.landing {\n  background-color: var(--bs-card-bg-custom);\n  font-size: 15px;\n}\n\n.section {\n  padding: 90px 0;\n  position: relative;\n}\n\n@media (max-width: 767.98px) {\n  .section {\n    padding: 50px 0;\n  }\n}\n\n.icon-effect {\n  position: relative;\n}\n\n.icon-effect::before {\n  content: \"\";\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  background-color: rgba(69, 203, 133, 0.2);\n  border-radius: 50%;\n  bottom: 0;\n  left: 0;\n}\n\n.navbar-landing {\n  padding: 10px 0;\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n}\n\n@media (max-width: 991.98px) {\n  .navbar-landing {\n    background-color: var(--bs-card-bg-custom);\n    -webkit-box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);\n    box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);\n    padding: 10px 8px;\n  }\n}\n\n.navbar-landing .navbar-nav .nav-item .nav-link {\n  font-size: 16px;\n  font-weight: 500;\n  -webkit-transition: all 0.4s;\n  transition: all 0.4s;\n  font-family: Inter, sans-serif;\n  color: var(--bs-dark);\n  padding: 14px;\n}\n\n@media (max-width: 991.98px) {\n  .navbar-landing .navbar-nav .nav-item .nav-link {\n    padding: 8px 0;\n  }\n}\n\n.navbar-landing .navbar-nav .nav-item .nav-link.active,\n.navbar-landing .navbar-nav .nav-item .nav-link:focus,\n.navbar-landing .navbar-nav .nav-item .nav-link:hover {\n  color: #45cb85 !important;\n}\n\n.navbar-landing.is-sticky {\n  background-color: var(--bs-card-bg-custom);\n  -webkit-box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);\n  box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);\n}\n\n.navbar-light .navbar-brand .card-logo-dark {\n  display: none;\n}\n\n.navbar-light .navbar-brand .card-logo-light {\n  display: block;\n}\n\n.navbar-light .navbar-nav .nav-item .nav-link {\n  color: rgba(var(--bs-white-rgb), 0.75);\n}\n\n.navbar-light.is-sticky .navbar-nav .nav-item .nav-link {\n  color: var(--bs-dark);\n}\n\n.navbar-light.is-sticky .navbar-brand .card-logo-dark {\n  display: block;\n}\n\n.navbar-light.is-sticky .navbar-brand .card-logo-light {\n  display: none;\n}\n\n.hero-section {\n  background-color: rgba(var(--bs-light-rgb), 0.5);\n}\n\n.hero-section .hero-shape-svg svg path {\n  fill: var(--bs-card-bg-custom);\n}\n\n/* .bg-overlay-pattern {\n    background-image: url(../images/landing/bg-pattern.png);\n    background-color: transparent;\n    background-position: center;\n    background-size: cover;\n    opacity: .2\n} */\n\n.demo-carousel {\n  position: relative;\n  z-index: 1;\n}\n\n.demo-carousel .carousel-item .demo-item {\n  background-color: var(--bs-card-bg-custom);\n  padding: 8px;\n  border-radius: 7px;\n}\n\n.demo-carousel .demo-img-patten-top {\n  position: absolute;\n  right: -50px;\n  top: -16px;\n  max-width: 230px;\n}\n\n.demo-carousel .demo-img-patten-bottom {\n  position: absolute;\n  left: -70px;\n  bottom: -50px;\n  max-width: 230px;\n}\n\n.client-images img {\n  max-height: 45px;\n  width: auto;\n  margin: 12px auto;\n  -webkit-transition: all 0.4s;\n  transition: all 0.4s;\n}\n\n.plan-box {\n  max-width: 356px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.process-card {\n  position: relative;\n}\n\n.process-card .process-arrow-img {\n  position: absolute;\n  left: 75%;\n  top: 7%;\n  width: 50%;\n  opacity: 0.1;\n}\n\n.custom-footer {\n  color: #9ba7b3;\n}\n\n.footer-list li a {\n  color: #9ba7b3;\n  padding: 7px 0;\n  display: block;\n  -webkit-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n}\n\n.footer-list li a:hover {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.footer-social-link .avatar-title {\n  color: #778089;\n  background-color: rgba(255, 255, 255, 0.05);\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\n.footer-social-link .avatar-title:hover {\n  color: #fff;\n  background-color: #4b38b3;\n}\n\n#back-to-top.landing-back-top {\n  bottom: 35px;\n}\n\n[data-layout-mode=\"dark\"] .layout-wrapper.landing .demo-img-patten-bottom,\n[data-layout-mode=\"dark\"] .layout-wrapper.landing .demo-img-patten-top {\n  opacity: 0.2;\n}\n\n[data-layout-mode=\"dark\"] .layout-wrapper.landing footer.bg-dark {\n  background-color: var(--bs-card-bg-custom) !important;\n}\n\n[data-layout-mode=\"dark\"]\n  .navbar-light.is-sticky\n  .navbar-brand\n  .card-logo-dark {\n  display: none;\n}\n\n[data-layout-mode=\"dark\"]\n  .navbar-light.is-sticky\n  .navbar-brand\n  .card-logo-light {\n  display: block;\n}\n\n.bookmark-icon .btn {\n  color: #878a99;\n  background-color: var(--bs-light);\n  -webkit-box-shadow: var(--bs-box-shadow);\n  box-shadow: var(--bs-box-shadow);\n  font-size: 0.8125rem;\n}\n\n.bookmark-icon .btn.active,\n.bookmark-icon .btn:hover {\n  border-color: transparent;\n  color: #f06548;\n}\n\n.explore-box {\n  border-radius: 9px;\n  overflow: hidden;\n}\n\n.explore-box .explore-img {\n  height: 280px;\n  -o-object-fit: cover;\n  object-fit: cover;\n}\n\n.explore-box .explore-place-bid-img {\n  position: relative;\n  overflow: hidden;\n  z-index: 0;\n}\n\n.explore-box .explore-place-bid-img .bg-overlay {\n  position: absolute;\n  right: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  background-color: rgba(33, 37, 41, 0.4);\n  opacity: 0;\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n}\n\n.explore-box .explore-place-bid-img .place-bid-btn {\n  top: 50%;\n  position: absolute;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n}\n\n.explore-box .explore-place-bid-img .place-bid-btn .btn {\n  opacity: 0;\n  bottom: -25px;\n  -webkit-transition: 0.5s ease;\n  transition: 0.5s ease;\n}\n\n.explore-box:hover .explore-place-bid-img .place-bid-btn .btn {\n  opacity: 1;\n  bottom: 0;\n}\n\n.explore-box:hover .explore-place-bid-img .bg-overlay {\n  opacity: 1;\n}\n\n.explore-box .discount-time {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  text-align: center;\n  background-color: rgba(255, 255, 255, 0.4);\n  -webkit-backdrop-filter: blur(5px);\n  backdrop-filter: blur(5px);\n  padding: 8px;\n}\n\n/* .nft-hero {\n    background-image: url(../images/nft/bg-home.jpg);\n    background-size: cover;\n    background-position: bottom;\n    padding: 222px 0 150px 0\n} */\n\n.nft-hero .bg-overlay {\n  background-color: #05175f;\n  opacity: 0.85;\n}\n\n#explorecard-list .list-element {\n  display: none;\n}\n\n#explorecard-list .list-element:nth-child(-n + 10) {\n  display: block;\n}\n\n.file-manager-menu {\n  max-height: calc(100vh - 296px);\n}\n\n@media (max-width: 991.98px) {\n  .file-manager-menu {\n    height: calc(100vh - 296px);\n  }\n}\n\n.file-manager-menu li {\n  padding: 5px 0;\n}\n\n.file-manager-menu li a {\n  color: var(--bs-dark);\n  font-weight: 500;\n  -webkit-transition: all 0.5s ease;\n  transition: all 0.5s ease;\n}\n\n.file-manager-menu li a.active,\n.file-manager-menu li a:hover,\n.file-manager-menu li a[aria-expanded=\"true\"] {\n  color: #45cb85;\n}\n\n.file-manager-menu li .sub-menu li {\n  padding-left: 25px;\n  position: relative;\n}\n\n.file-manager-menu li .sub-menu li::before {\n  content: \"\\f0374\";\n  position: absolute;\n  left: 0;\n  font-family: Material Design Icons;\n  color: rgba(var(--bs-dark-rgb), 0.4);\n}\n\n.file-manager-sidebar {\n  position: relative;\n  background-color: var(--bs-card-bg-custom);\n}\n\n@media (min-width: 992px) {\n  .file-manager-sidebar {\n    min-width: 300px;\n    max-width: 300px;\n    height: calc(100vh - 70px - 60px - 8px);\n  }\n}\n\n@media (max-width: 991.98px) {\n  .file-manager-sidebar {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 200px;\n    max-width: 100%;\n    z-index: 1003;\n    -webkit-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n    -webkit-transform: translateX(-100%);\n    transform: translateX(-100%);\n    visibility: hidden;\n    height: 100vh;\n  }\n\n  .file-manager-sidebar.menubar-show {\n    visibility: visible;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n.file-menu-sidebar-scroll {\n  height: calc(100vh - 375px);\n}\n\n@media (max-width: 991.98px) {\n  .file-menu-sidebar-scroll {\n    height: calc(100vh - 190px);\n  }\n}\n\n.file-manager-content {\n  background-color: var(--bs-card-bg-custom);\n}\n\n.file-manager-content-scroll {\n  height: calc(100vh - 185px);\n}\n\n@media (max-width: 991.98px) {\n  .file-manager-content-scroll {\n    height: calc(100vh - 144px);\n  }\n}\n\n.file-manager-content-scroll .simplebar-content {\n  height: 100%;\n}\n\n.file-detail-content-scroll {\n  height: calc(100vh - 180px);\n}\n\n@media (max-width: 991.98px) {\n  .file-detail-content-scroll {\n    height: 100vh;\n  }\n}\n\n.file-detail-content-scroll .simplebar-content {\n  height: 100%;\n}\n\n.file-manager-detail-content {\n  width: 32%;\n  max-width: 100%;\n  background-color: var(--bs-card-bg-custom);\n  display: none;\n}\n\n.file-detail-show .file-manager-detail-content {\n  display: block;\n}\n\n#file-overview {\n  display: none;\n}\n\n@media (max-width: 1399.98px) {\n  .file-manager-detail-content {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: auto;\n    right: 0;\n    width: 400px;\n    max-width: 100%;\n    z-index: 1003;\n    -webkit-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);\n    -webkit-transform: translateX(100%);\n    transform: translateX(100%);\n  }\n\n  .file-detail-show .file-manager-detail-content {\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n.file-details-box {\n  height: 195px;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n}\n\n.to-do-menu li .nav-link {\n  color: var(--bs-body-color);\n  padding-left: 0;\n  font-weight: 500;\n  background-color: var(--bs-light);\n  padding: 10px 12px;\n  border-radius: 4px;\n  display: block;\n  margin-bottom: 8px;\n}\n\n.to-do-menu li .nav-link.active,\n.to-do-menu li .nav-link:hover {\n  color: #45cb85;\n}\n\n.todo-content {\n  height: calc(100vh - 362px);\n  overflow-y: auto;\n}\n\n.todo-content::-webkit-scrollbar {\n  -webkit-appearance: none;\n}\n\n.todo-content::-webkit-scrollbar:vertical {\n  width: 8px;\n}\n\n.todo-content::-webkit-scrollbar:horizontal {\n  height: 10px;\n}\n\n.todo-content::-webkit-scrollbar-thumb {\n  background-color: rgba(var(--bs-dark-rgb), 0.075);\n  border-radius: 8px;\n}\n\n.todo-content::-webkit-scrollbar-track {\n  border-radius: 8px;\n}\n\n.todo-task table .form-check .form-check-input:checked + .form-check-label {\n  text-decoration: line-through;\n}\n\n.task-handle {\n  cursor: move;\n}\n\n#task-error-msg {\n  display: none;\n}\n\n\n.color-icon-open:before {\n  content: \"\\eaeb\";\n}\n\n.color-icon-close::before {\n  content: \"\\eacb\";\n}\n\n.flatpickr-monthDropdown-months {\n  display: none !important;\n}\n\n.remove-child-scroll {\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.dropdown-item-cart {\n  white-space: nowrap;\n}\n\n.remove-child-scroll {\n  max-height: 270px;\n  overflow-y: scroll;\n}\n\n.remove-child-scroll::-webkit-scrollbar {\n  width: 0;\n  background: transparent;\n}\n\n.remove-child-scroll::-webkit-scrollbar-thumb {\n  background: transparent;\n}\n\n.remove-child-scroll h5 {\n  font-size: 1.1rem;\n}\n\n.dropdown-item-cart {\n  white-space: nowrap;\n}\n\n.empty-cart {\n  display: none;\n}\n\n.dropdown-container {\n  position: relative;\n  display: inline-block;\n}\n\n.dropdown-toggle {\n  padding: 10px 20px;\n  color: #fff;\n  border: none;\n  cursor: pointer;\n}\n\n.unread-msg-scroll {\n  overflow-y: auto;\n  min-height: 430px;\n}\n\n.unread-msg-scroll::-webkit-scrollbar {\n  width: 0;\n  background: transparent;\n}\n\n.unread-msg-scroll::-webkit-scrollbar-thumb {\n  background: transparent;\n}\n\n.dropdown-item {\n  padding: 10px 20px;\n  cursor: pointer;\n}\n\n.dropdown-item.active {\n  background-color: #f1f1f1;\n}\n\n.sub-menu {\n  padding-left: 20px;\n  margin-top: 10px;\n  background-color: #f9f9f9;\n}\n\n.sub-menu-item {\n  padding: 8px 20px;\n  cursor: pointer;\n}\n\n.sub-menu-item:hover {\n  background-color: #ececec;\n}\n\n.blurred-background {\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.apexcharts-toolbar {\n  display: none !important;\n}\n\n.chat-conversation {\n  height: 500px !important;\n  overflow-y: scroll;\n}\n\n.chat-conversation::-webkit-scrollbar {\n  width: 0;\n  background: transparent;\n}\n\n.chat-conversation::-webkit-scrollbar-thumb {\n  background: transparent;\n}\n\n.myTasksElementStyle {\n  height: 219px;\n  overflow-y: scroll;\n}\n\n.myTasksElementStyle::-webkit-scrollbar {\n  width: 0;\n  background: transparent;\n}\n\n.myTasksElementStyle::-webkit-scrollbar-thumb {\n  background: transparent;\n}\n\n.table-responsive::-webkit-scrollbar {\n  width: 0;\n  background: transparent;\n}\n\n.table-responsive::-webkit-scrollbar-thumb {\n  background: transparent;\n}\n\n.fullscreen.fullscreen-enabled {\n  background-color: white !important;\n}\n\n.text-muted {\n  --bs-text-opacity: 1;\n  color: #878a99 !important;\n  font-size: 14px !important;\n}\n\n/* page group page styling */\n\n.table > :not(caption) > * > * {\n  padding: 0.75rem 1.6rem !important;\n  background-color: var(--bs-table-bg);\n  border-bottom-width: 1px;\n  box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg);\n}\n\n.manage-page-group {\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.manage-page-group i {\n  font-size: 20px;\n  padding-right: 5px;\n}\n\n.manage-page-group i.ri-delete-bin-6-line {\n  color: #dc3545;\n}\n\n.manage-page-group i.ri-pencil-fill {\n  color: #13096a;\n}\n\n.btn.disabled,\n.btn:disabled,\nfieldset:disabled .btn {\n  opacity: 0.1;\n}\n\n.card {\n  --bs-card-border-color: transparent !important;\n}\n\n.card-header {\n  background-color: transparent !important;\n}\n\n/* .table {\n    --bs-table-striped-bg: #fbfbfb !important;\n} */\n\n[data-layout-mode=\"light\"] .main-content {\n  background-color: #f3f3f9;\n}\n\n[data-layout-mode=\"dark\"] .main-content {\n  background-color: #1a1d21;\n}\n\n[data-layout-mode=\"light\"] .navbar-menu {\n  background-color: #ffffff;\n}\n\n[data-layout-mode=\"dark\"] .navbar-menu {\n  background-color: #262a2f;\n}\n\n[data-layout-mode=\"light\"] .manage-page-group-select {\n  color: #000;\n  border: 1px solid #e5e5e5;\n}\n\n[data-layout-mode=\"dark\"] .manage-page-group-select {\n  color: #fff;\n  border: 1px solid #1a1d21;\n}\n\n.manage-page-group-card-body {\n  padding: 0px !important;\n}\n\n.manage-page-group th:first-child {\n  padding-left: 26px !important;\n}\n\n.manage-page-group td:first-child {\n  padding-left: 26px !important;\n}\n\n.manage-page-group-table-values td {\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.manage-page-group-entries-displayed {\n  font-size: 14px;\n  font-weight: 400;\n}\n\n.card-header h5 {\n  font-weight: 600;\n}\n\n.form-select-entry-count {\n  display: flex !important;\n  align-items: center !important;\n}\n\nul.dropdown-menu.show {\n  min-width: 100px !important;\n}\n\n.btn-secondary {\n  --bs-btn-bg: #1f156d !important;\n}\n\n[data-layout-mode=\"light\"] .manage-page-group-table-header {\n  background-color: #f3f6f9;\n}\n\n[data-layout-mode=\"dark\"] .manage-page-group-table-header {\n  background-color: #262a2f;\n}\n\n[data-layout-mode=\"light\"] .manage-page-group-table-header th {\n  font-size: 14px;\n  color: #000;\n  font-weight: 600;\n}\n\n[data-layout-mode=\"dark\"] .manage-page-group-table-header th {\n  font-size: 14px;\n  color: #fff;\n  font-weight: 600;\n}\n\n[data-layout-mode=\"light\"] .manage-page-group-table-values td {\n  color: #000;\n}\n\n[data-layout-mode=\"dark\"] .manage-page-group-table-values td {\n  color: #fff;\n}\n\n[data-layout-mode=\"light\"] .manage-page-group-entries-displayed {\n  color: #000;\n}\n\n[data-layout-mode=\"dark\"] .manage-page-group-entries-displayed {\n  color: #fff;\n}\n\n[data-layout-mode=\"light\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-item.active\n  .nav-link {\n  color: #4b38b3 !important;\n}\n\n[data-layout-mode=\"dark\"]\n  .navbar-menu\n  .navbar-nav\n  .nav-sm\n  .nav-item.active\n  .nav-link {\n  color: #fff !important;\n}\n\n.navbar-menu\n  .navbar-nav\n  .nav-link[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"] {\n  color: var(--bs-vertical-menu-sub-item-color) !important;\n}\n\n[data-layout-mode=\"light\"] button.btn.btn-sm.manage-page-group-select {\n  color: #000;\n}\n\n[data-layout-mode=\"dark\"] button.btn.btn-sm.manage-page-group-select {\n  color: #fff;\n}\n\nbutton.btn.btn-sm.manage-page-group-select {\n  font-size: 2rem;\n  background-color: transparent;\n  border: none;\n  box-shadow: none;\n}\n\n/* div#sidebarAdminSettings {\n    background-color: var(--bs-vertical-menu-bg-dark);\n} */\n\n.border-shadow-login-card {\n  box-shadow: rgba(60, 64, 67, 0.3) 0px 1px 2px 0px,\n    rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;\n}\n\n.text-body i.ri-camera-fill {\n  color: black;\n}\n\nspan.avatar-title.rounded-circle.bg-light.text-body.shadow {\n  background-color: #737685 !important;\n}\n\n.loading-spinner-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100vh;\n  background-color: #f4f4f4;\n}\n\n[data-layout-mode=\"dark\"] .loading-spinner-container {\n  background-color: #262a2f;\n}\n\n.loading-spinner {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.spinner-circle {\n  border: 6px solid #f3f3f3;\n  border-radius: 50%;\n  border-top: 6px solid #3498db;\n  width: 50px;\n  height: 50px;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.loading-spinner p {\n  margin-top: 15px;\n  font-size: 1.2rem;\n  color: #333;\n}\n\n.select-dropdown-swr-property {\n  box-shadow: none;\n  background-color: #fff;\n  border: 1px solid #ced4da;\n  appearance: none;\n  border-radius: 0.375rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  height: 34px;\n  color: #000;\n  padding: 2px;\n}\n\n.select-dropdown-swr-property:hover {\n  box-shadow: none !important;\n  background-color: #fff !important;\n  border: 1px solid #ced4da !important;\n  appearance: none !important;\n  border-radius: 0.375rem !important;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;\n  height: 34px !important;\n  color: #000 !important;\n  padding: 2px !important;\n}\n\n.dropdown-toggle::after {\n  content: none !important;\n}\n\n.btn-check:checked + .btn,\n.btn.active,\n.btn.show,\n.btn:first-child:active,\n:not(.btn-check) + .btn:active {\n  color: #000;\n  background-color: #fff;\n  border-color: #ced4da;\n}\n\n.badge {\n  --bs-badge-padding-x: 0.85em !important;\n  --bs-badge-padding-y: 0.55em !important;\n}\n\n.heading-tab-section {\n  font-size: 1.2rem;\n  font-weight: 600;\n}\n\nspan.badge.text-bg-warning.ms-2 {\n  color: #fff !important;\n}\n\n.tab-dates {\n  font-weight: 600;\n}\n\n.nav-success.nav-tabs-custom .nav-link.active {\n  color: #2913dd;\n  background-color: transparent !important;\n  font-size: 1rem;\n}\n\n.nav-tabs-custom {\n  border-bottom: 1px solid transparent !important;\n}\n\n.property-detail-tab {\n  background-color: #eaf2fd;\n}\n\n.nav-success.nav-tabs-custom .nav-link.active::after {\n  background-color: #2913dd !important;\n}\n\nul.nav.nav-tabs.nav-tabs-custom.nav-success.nav-justified.mb-3.pt-3 {\n  font-size: 1rem;\n  color: #fff;\n  width: 480px;\n}\n\n.tab-property-detail-address {\n  white-space: normal;\n  word-wrap: break-word;\n  word-break: break-word;\n}\n\ntable.table.table-nowrap {\n  font-size: 0.9rem;\n}\n\ntable.table.table-nowrap td {\n  font-weight: 400;\n}\n\n.ri-edit-2-fill:before {\n  font-size: 1.1rem;\n  color: #170b75;\n}\n\n.flat-detail-table {\n  padding: 0 !important;\n}\n\n.image-container {\n  position: relative;\n  display: inline-block;\n  margin: 10px;\n  transition: transform 0.3s ease, opacity 0.3s ease;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  /* Add slight box-shadow */\n  border-radius: 8px;\n}\n\n.image-container:hover {\n  transform: scale(1.05);\n  /* Slight zoom on hover */\n}\n\n.uploaded-image {\n  width: 100px;\n  height: 100px;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.remove-image-btn {\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  background-color: #ff4d4f;\n  color: white;\n  border: none;\n  border-radius: 50%;\n  width: 24px;\n  height: 24px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  transition: background-color 0.2s ease;\n}\n\n.remove-image-btn:hover {\n  background-color: #ff7875;\n}\n\n.image-preview {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n.image-container.fade-in {\n  animation: fadeIn 0.3s ease;\n}\n\n.image-container.fade-out {\n  animation: fadeOut 0.3s ease;\n}\n\n.gallery-modal-heading {\n  color: #1f156d;\n}\n\n.mt-n4 {\n  margin-top: -1.5rem !important;\n  /* background-color: #d8edf9 !important; */\n}\n\n.mx-n4 {\n  margin-right: -1.5rem !important;\n  margin-left: -1.5rem !important;\n}\n\n.css-s4lgu-MuiFormControl-root {\n  margin: 0px !important;\n}\n\n.css-w76bbz-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {\n  padding: 0px !important;\n}\n\n.css-lohd6h-MuiSvgIcon-root-MuiSelect-icon {\n  display: none !important;\n}\n\n.css-w1u3ce > span {\n  display: none !important;\n}\n\n.css-lohd6h-MuiSvgIcon-root-MuiSelect-icon {\n  visibility: hidden !important;\n}\n\n.form-select svg {\n  display: none !important;\n}\n\nbutton#page-header-user-dropdown {\n  color: unset !important;\n  background-color: unset !important;\n  border-color: transparent !important;\n}\n\n.pagination {\n  --bs-pagination-active-bg: #211959 !important;\n  --bs-pagination-active-border-color: #2b2178 !important;\n}\n\n/* blogs page css  */\n.profile-user {\n  width: 130px;\n}\n\n.card-header-wrapper {\n  border-bottom: 1px solid var(--bs-border-color);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.tox-statusbar__branding {\n  display: none !important;\n}\n\n.blog-name-wrapper {\n  display: flex;\n  align-items: center;\n  column-gap: 5px;\n}\n\n[data-layout-mode=\"dark\"] .tox .tox-statusbar {\n  background-color: #1a1d21 !important;\n  border-top: 1px solid #20252a !important;\n}\n\n[data-layout-mode=\"dark\"] .tox .tox-edit-area__iframe {\n  background-color: #1a1d21 !important;\n}\n\n[data-layout-mode=\"dark\"] .tox:not(.tox-tinymce-inline) .tox-editor-header {\n  background-color: #1a1d21 !important;\n}\n\n[data-layout-mode=\"dark\"] .tox .tox-toolbar__primary {\n  background-color: #1a1d21 !important;\n  background-image: repeating-linear-gradient(\n    #20252a 0 1px,\n    transparent 1px 39px\n  ) !important;\n}\n\n[data-layout-mode=\"dark\"] .tox-tinymce {\n  border: 2px solid #20252a !important;\n}\n\n[data-layout-mode=\"dark\"] .tox .tox-statusbar__path-item {\n  color: #fff !important;\n}\n\n[data-layout-mode=\"dark\"] .tox .tox-statusbar__wordcount {\n  color: #fff !important;\n}\n\n[data-layout-mode=\"dark\"] .tox .tox-tbtn svg {\n  fill: #ffffff !important;\n}\n\n[data-layout-mode=\"dark\"] .tox .tox-tbtn--bespoke {\n  background: #262a2f !important;\n  color: #fff !important;\n}\n\n.mce-content-body {\n  color: #000 !important;\n}\n\n[data-layout-mode=\"dark\"] .tox.tox-tinymce-aux .tox-toolbar__overflow {\n  background-color: #262a2f !important;\n}\n\n[data-layout-mode=\"dark\"] .tox .tox-menu {\n  background-color: #262a2f !important;\n}\n\n[data-layout-mode=\"dark\"] .tox .tox-menu .tox-collection__item-label {\n  color: #fff !important;\n}\n\n[data-layout-mode=\"dark\"].tox\n  .tox-collection--list\n  .tox-collection__item--active {\n  background-color: #1a1d21 !important;\n}\n\n[data-layout-mode=\"dark\"] .tox .tox-tbtn--enabled {\n  background: #1a1d21 !important;\n}\n\n[data-layout-mode=\"dark\"] .tox .tox-tbtn:hover {\n  background: #1a1d21 !important;\n}\n\n[data-layout-mode=\"dark\"]\n  .tox\n  .tox-collection--list\n  .tox-collection__item--active {\n  background: #1a1d21 !important;\n}\n\nbody#tinymce {\n  color: #fff !important;\n}\n\n[data-layout-mode=\"dark\"] .tox .tox-collection__item-icon svg {\n  fill: #fff !important;\n}\n\n.css-13cymwt-control {\n  min-height: 36px !important;\n  height: 32px !important;\n}\n\n[data-layout-mode=\"dark\"] .css-13cymwt-control {\n  background-color: #262a2f !important;\n  border-color: hsl(210deg 10.64% 18.43%) !important;\n  color: #acb1b8 !important;\n}\n\n[data-layout-mode=\"dark\"] .css-t3ipsp-control {\n  background-color: #262a2f !important;\n  border-color: hsl(210deg 10.64% 18.43%) !important;\n  color: #acb1b8 !important;\n}\n\n[data-layout-mode=\"dark\"] .css-1nmdiq5-menu {\n  background-color: #262a2f !important;\n  color: #acb1b8 !important;\n}\n\n.modal-dialog:not(.modal-dialog-scrollable) .modal-header {\n  padding-bottom: 9px !important;\n}\n\n.btn-properties-search {\n  margin-top: 18px !important;\n  padding: 6px 20px !important;\n}\n\n.PhoneInput {\n  font-size: 0.8125rem;\n  background: transparent;\n  border: 1px solid #ced4da;\n  border-radius: 5px;\n  color: #0e0e46;\n  min-height: 34px;\n  margin: 0;\n  padding: 9px 15px;\n  max-height: 37px;\n}\n\n.PhoneInput input {\n  margin: 0;\n  padding: 0;\n  border: none;\n  height: 30px;\n  width: calc(100% - 30px);\n  outline: none;\n  background-color: transparent !important;\n}\n\n.PhoneInput--focus {\n  border-color: var(--secondary-theme-color);\n}\n\n.verified-details {\n  font-size: 17px;\n  margin-left: 5px;\n  line-height: 0;\n  position: relative;\n  top: 4px;\n}\n\n.ri-mail-fill:before {\n  content: \"\\eef3\";\n  line-height: 0;\n  position: relative;\n  top: 3px;\n  color: #13086a;\n}\n\n.ri-phone-fill:before {\n  line-height: 0;\n  position: relative;\n  top: 2px;\n  color: #13086a;\n}\n\n.form-select {\n  padding: 0.5rem 0.9rem;\n  font-weight: 400;\n  line-height: 1.5;\n}\n\n.form-control {\n  padding: 0.5rem 0.9rem;\n  font-weight: 400;\n  line-height: 1.5;\n}\n\n.form-select {\n  padding: 0.5rem 0.9rem;\n  font-weight: 400;\n  line-height: 1.5;\n}\n\n/* --- */\n.css-mp9f0v {\n  padding: 0px 0px !important;\n}\n\n.MuiFormControl-root.MuiFormControl-marginNormal.MuiFormControl-fullWidth {\n  margin: 0px !important;\n}\n\n.entried-dropdown-style {\n  min-width: 80px;\n  text-align: justify;\n}\n\n.btn-secondary {\n  min-width: 100px !important;\n}\n\n.no-border {\n  border: none !important;\n}\n\n.viewhidePassword {\n  position: absolute;\n  right: 10px;\n  top: 70%;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.view-hide-password-invalid {\n  position: absolute;\n  right: 22px;\n  top: 48px;\n  transform: translateY(-50%);\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.img-thumbnail {\n  background-color: transparent !important;\n}\n\ninput::placeholder {\n  font-family: \"Inter\", sans-serif !important;\n  font-size: 0.8125rem;\n  font-weight: 400;\n}\n\n[data-sidebar-size=\"lg\"] .navbar-menu div#scrollbar {\n  overflow-y: auto;\n  height: calc(100dvh - 70px);\n}\n\nselect.PhoneInputCountrySelect:disabled {\n  display: contents !important;\n}\n\n.pac-container {\n  z-index: 9999 !important;\n  box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px !important;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.manage-page-group:hover {\n  background-color: #f6f6f6;\n}\n\n[data-layout-mode=\"dark\"] .manage-page-group:hover {\n  background-color: #1a1d21;\n}\n\n.auth-one-bg img {\n  filter: grayscale(100) brightness(100);\n}\n\n.text-primary {\n  font-size: 30px;\n}\n\n.aligning-item {\n  align-items: center !important;\n}\n\n.aligning-sigin-form {\n  height: 100%;\n}\n\n[data-layout-mode=\"dark\"] .disabled > .page-link,\n.page-link.disabled {\n  background-color: #333232 !important;\n}\n\n.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.form-select.css-quhxjy-MuiInputBase-root-MuiOutlinedInput-root {\n  border: 1px !important;\n}\n\n.profile-info-fields {\n  position: relative;\n  z-index: 1;\n}\n\n.profile-info-fields:before {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: 12px;\n  width: 89%;\n  height: 1px;\n  background: #c7c7c7;\n  z-index: -1;\n}\n\n.profile-info-fields h5 {\n  background: var(--white);\n  margin-bottom: 20px;\n  display: inline-flex;\n  padding-right: 10px;\n}\n\n@media (max-width: 1600px) {\n  .profile-info-fields:before {\n    width: 88%;\n  }\n}\n\n@media (max-width: 1400px) {\n  .profile-info-fields:before {\n    width: 86%;\n  }\n}\n\n@media (max-width: 1200px) {\n  .profile-info-fields:before {\n    width: 84%;\n  }\n}\n\n@media (max-width: 992px) {\n  .profile-info-fields:before {\n    width: 79%;\n  }\n}\n\n@media (max-width: 768px) {\n  .profile-info-fields:before {\n    width: 67%;\n  }\n}\n\n@media (max-width: 576px) {\n  .profile-info-fields:before {\n    display: none !important;\n  }\n}\n\n.line-separator {\n  font-size: 16px;\n  font-weight: 700;\n}\n\n.order-info-details {\n  display: flex;\n  justify-content: space-between;\n}\n\n.responsive-filter {\n  display: flex;\n  justify-content: start;\n}\n\n.responsive-filter-type {\n  display: flex;\n  column-gap: 20px;\n}\n\n@media (max-width: 1092px) {\n  .responsive-filter {\n    display: block !important;\n  }\n\n  .responsive-filter-type {\n    display: block !important;\n  }\n}\n\n@media (max-width: 576px) {\n  .timeline-item .content {\n    background: transparent;\n    box-shadow: none;\n    border: none;\n    padding: 0px;\n  }\n}\n\n.required-field {\n  color: red;\n}\n\n.timeline-background {\n  background-color: #edf2fa;\n}\n\n[data-layout-mode=\"dark\"] .timeline-background {\n  background-color: #1b1c1e;\n}\n\n.fw-semibold {\n  color: #150b6d;\n}\n\n[data-layout-mode=\"dark\"] .fw-semibold {\n  color: #6c757d;\n}\n\n.sub-title-detail {\n  font-weight: 600;\n  color: #000;\n}\n\n[data-layout-mode=\"dark\"] .sub-title-detail {\n  color: #fff;\n}\n\n.MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-colorPrimary.MuiInputBase-formControl.form-select.css-iz33ar {\n  border: 1px !important;\n}\n\n.wrapper-entries-dropdownx {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.css-28116y-MuiAutocomplete-root .MuiOutlinedInput-root {\n  padding: 0px !important;\n}\n\n.css-28116y-MuiAutocomplete-root .MuiOutlinedInput-root .MuiAutocomplete-input {\n  padding: 6px 4px 7.5px 5px !important;\n}\n\n.css-qjqmwp .MuiOutlinedInput-root .MuiAutocomplete-input {\n  padding: 6px 4px 7.5px 5px !important;\n}\n\n.css-qjqmwp .MuiOutlinedInput-root {\n  padding: 0px !important;\n}\n\n.css-28116y-MuiAutocomplete-root {\n  width: 270px !important;\n}\n\n.css-qjqmwp {\n  width: 270px !important;\n}\n\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: thin;\n  scrollbar-color: #c4c4c4 #f3f3f9;\n}\n\n.show-hide-sub-table {\n  font-size: 25px;\n  cursor: pointer;\n}\n\n.show-hide-sub-row {\n  font-size: 30px;\n  cursor: pointer;\n}\n\n.pagination-details-responsive {\n  display: flex !important;\n}\n\n.flat-details-filter {\n  margin: 0px 0px;\n}\n\n@media (max-width: 520px) {\n  .pagination-details-responsive {\n    display: contents !important;\n  }\n\n  .flat-details-filter {\n    margin: 10px 0px;\n  }\n}\n\n.btn-download {\n  border: 2px solid #1f156d !important;\n  background-color: #ffffff !important;\n  color: #1f156d !important;\n}\n\n.btn-download:hover {\n  background-color: #1f156d !important;\n  color: #ffffff !important;\n}\n\n[data-layout-mode=\"dark\"] .table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: thin;\n  scrollbar-color: #868990 #1a1d21;\n}\n\n.set-upload-button {\n  margin-top: 10px;\n  margin-left: 10px;\n}\n\n.set-upload-button-sample {\n  margin-top: 10px;\n}\n\n[data-layout-mode=\"dark\"] .btn-download {\n  background-color: #262a2f !important;\n  border: 2px solid #ffffff !important;\n  color: #ffffff !important;\n}\n","\n/*!\n * Waves v0.7.6\n * http://fian.my.id/Waves \n * \n * Copyright 2014-2018 Alfiana E. Sibuea and other contributors \n * Released under the MIT license \n * https://github.com/fians/Waves/blob/master/LICENSE */\n .waves-effect {\n    position: relative;\n    cursor: pointer;\n    display: inline-block;\n    overflow: hidden;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n  }\n  .waves-effect .waves-ripple {\n    position: absolute;\n    border-radius: 50%;\n    width: 100px;\n    height: 100px;\n    margin-top: -50px;\n    margin-left: -50px;\n    opacity: 0;\n    background: rgba(0, 0, 0, 0.2);\n    background: -webkit-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -o-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -moz-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    -webkit-transition: all 0.5s ease-out;\n    -moz-transition: all 0.5s ease-out;\n    -o-transition: all 0.5s ease-out;\n    transition: all 0.5s ease-out;\n    -webkit-transition-property: -webkit-transform, opacity;\n    -moz-transition-property: -moz-transform, opacity;\n    -o-transition-property: -o-transform, opacity;\n    transition-property: transform, opacity;\n    -webkit-transform: scale(0) translate(0, 0);\n    -moz-transform: scale(0) translate(0, 0);\n    -ms-transform: scale(0) translate(0, 0);\n    -o-transform: scale(0) translate(0, 0);\n    transform: scale(0) translate(0, 0);\n    pointer-events: none;\n  }\n  .waves-effect.waves-light .waves-ripple {\n    background: rgba(255, 255, 255, 0.4);\n    background: -webkit-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -o-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -moz-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n  }\n  .waves-effect.waves-classic .waves-ripple {\n    background: rgba(0, 0, 0, 0.2);\n  }\n  .waves-effect.waves-classic.waves-light .waves-ripple {\n    background: rgba(255, 255, 255, 0.4);\n  }\n  .waves-notransition {\n    -webkit-transition: none !important;\n    -moz-transition: none !important;\n    -o-transition: none !important;\n    transition: none !important;\n  }\n  .waves-button,\n  .waves-circle {\n    -webkit-transform: translateZ(0);\n    -moz-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    -o-transform: translateZ(0);\n    transform: translateZ(0);\n    -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);\n  }\n  .waves-button,\n  .waves-button:hover,\n  .waves-button:visited,\n  .waves-button-input {\n    white-space: nowrap;\n    vertical-align: middle;\n    cursor: pointer;\n    border: none;\n    outline: none;\n    color: inherit;\n    background-color: rgba(0, 0, 0, 0);\n    font-size: 1em;\n    line-height: 1em;\n    text-align: center;\n    text-decoration: none;\n    z-index: 1;\n  }\n  .waves-button {\n    padding: 0.85em 1.1em;\n    border-radius: 0.2em;\n  }\n  .waves-button-input {\n    margin: 0;\n    padding: 0.85em 1.1em;\n  }\n  .waves-input-wrapper {\n    border-radius: 0.2em;\n    vertical-align: bottom;\n  }\n  .waves-input-wrapper.waves-button {\n    padding: 0;\n  }\n  .waves-input-wrapper .waves-button-input {\n    position: relative;\n    top: 0;\n    left: 0;\n    z-index: 1;\n  }\n  .waves-circle {\n    text-align: center;\n    width: 2.5em;\n    height: 2.5em;\n    line-height: 2.5em;\n    border-radius: 50%;\n  }\n  .waves-float {\n    -webkit-mask-image: none;\n    -webkit-box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\n    box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\n    -webkit-transition: all 300ms;\n    -moz-transition: all 300ms;\n    -o-transition: all 300ms;\n    transition: all 300ms;\n  }\n  .waves-float:active {\n    -webkit-box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\n    box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\n  }\n  .waves-block {\n    display: block;\n  }\n\n.waves-effect.waves-light {\n    .waves-ripple {\n        background-color: rgba($white, 0.4);\n    }\n}\n\n.waves-effect.waves-primary {\n    .waves-ripple {\n        background-color: rgba($primary, 0.4);\n    }\n}\n.waves-effect.waves-success {\n    .waves-ripple {\n        background-color: rgba($success, 0.4);\n    }\n}\n.waves-effect.waves-info {\n    .waves-ripple {\n        background-color: rgba($info, 0.4);\n    }\n}\n.waves-effect.waves-warning {\n    .waves-ripple {\n        background-color: rgba($warning, 0.4);\n    }\n}\n.waves-effect.waves-danger {\n    .waves-ripple {\n        background-color: rgba($danger, 0.4);\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
